import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  Color: { input: string; output: string; }
  CompanyProfessionCode: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  Email: { input: string; output: string; }
  EmailAddress: { input: any; output: any; }
  INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_discounts_items_discount_code: { input: any; output: any; }
  INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_discounts_items_discount_label: { input: any; output: any; }
  INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_price_tiers_items_tier_label: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_articles_items_company_article_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_articles_items_group_article_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_articles_items_gtin_13_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_articles_items_supplier_article_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_articles_items_upc_12_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_company_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_customer_account_code: { input: any; output: any; }
  INTL_STOCK_queryInput_postStockLevel_input_organisational_unit_codes_items: { input: any; output: any; }
  INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_company_article_code: { input: any; output: any; }
  INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_gtin_13_code: { input: any; output: any; }
  INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_inventory_details_items_stock_location_details_items_batch_details_items_batch_number: { input: any; output: any; }
  INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_inventory_details_items_stock_location_details_items_serial_number_list_items_serial_number: { input: any; output: any; }
  INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_upc_12_code: { input: any; output: any; }
  IsoCountryCode2: { input: any; output: any; }
  IsoCountryCode3: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  ObjMap: { input: any; output: any; }
  Phone: { input: string; output: string; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  SequelizeJSON: { input: any; output: any; }
  URL: { input: string; output: string; }
  UUID: { input: any; output: any; }
  UserEmail: { input: any; output: any; }
  Void: { input: any; output: any; }
  orderReferenceM2: { input: any; output: any; }
};

export enum AccountNumberCharset {
  Numeric = 'NUMERIC'
}

export type AddProductsToCartResponse = {
  __typename?: 'AddProductsToCartResponse';
  /** number of reference added or changed by the mutation, used by front for succes message */
  addedReferences: Scalars['Int']['output'];
  cart: Cart;
};

export type AddressActionResponse = {
  __typename?: 'AddressActionResponse';
  address?: Maybe<UserCompanyAddress>;
  isActionDeferred: Scalars['Boolean']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  isoCountryCode: Scalars['IsoCountryCode2']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode: Scalars['String']['input'];
};

/** Approval flow type */
export type ApprovalFlow = {
  __typename?: 'ApprovalFlow';
  approvees: Array<User>;
  approvers: Array<User>;
  id: Scalars['ID']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

/**
 * Source : front
 * Approval flow input to create an approval flow
 */
export type ApprovalFlowCreateInput = {
  approvees: Array<Scalars['ID']['input']>;
  approvers: Array<Scalars['ID']['input']>;
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/**
 * Represents the paginated result of approval flows
 * Contains total pages, total size and the list of approval flow
 */
export type ApprovalFlowPagination = {
  __typename?: 'ApprovalFlowPagination';
  items: Array<ApprovalFlow>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * Source : front
 * Approval flow input to create an approval flow
 */
export type ApprovalFlowUpdateInput = {
  approvees: Array<Scalars['ID']['input']>;
  approvers: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Specifies the value for attribute. */
export type AttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars['String']['input'];
  /** The value assigned to the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Different availability values for a product :
 * - ONLINE : available online
 * - STOPPED_INSTORE : stopped in store
 * - STOPPED_ONLINE : stopped online
 * - STORE : available in store
 * - STORE_ONLY : available only in store
 * Those values are cumulative, for instance a product can be available online and in store
 */
export enum Availability {
  Online = 'ONLINE',
  StoppedInstore = 'STOPPED_INSTORE',
  StoppedOnline = 'STOPPED_ONLINE',
  Store = 'STORE',
  StoreOnly = 'STORE_ONLY'
}

export type BestPriceInfo = {
  __typename?: 'BestPriceInfo';
  bestArticlePrice?: Maybe<Scalars['Float']['output']>;
  packaging?: Maybe<Packaging>;
  reference: Scalars['String']['output'];
};

export type Billtrust = {
  __typename?: 'Billtrust';
  urlredirect?: Maybe<Scalars['String']['output']>;
};

/**
 * Page data for serving a brand content
 * Source: M2 + MS-Catalog
 */
export type Brand = {
  __typename?: 'Brand';
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  /** primary key */
  code?: Maybe<Scalars['String']['output']>;
  /** MS-Catalog */
  description?: Maybe<Scalars['String']['output']>;
  /** MS-Catalog */
  logo?: Maybe<Image>;
  /** M2 */
  name: Scalars['String']['output'];
  /** Resolve the sold brand's products pageable collection, along with available filters for sub selection */
  productList?: Maybe<ProductList>;
  /** M2 */
  urlKey?: Maybe<Scalars['String']['output']>;
};


/**
 * Page data for serving a brand content
 * Source: M2 + MS-Catalog
 */
export type BrandProductListArgs = {
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
};

export type BrandInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Source : M2 + MS
 * Context : Clickable entry in a page breadcrumb, that redirects to the associated page
 */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  entity: Entity;
  name: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

/**
 * Defines the browsing parameters used for filtering, pagination, and sorting.
 * See here for more details about the browsing :  https://descours-cabaud.atlassian.net/wiki/x/BQAa1QQ
 */
export type Browsing = {
  /** List of filters to apply to the search. */
  filter?: InputMaybe<Array<Filter>>;
  /** Pagination parameters (size and page index). */
  pagination?: InputMaybe<Pagination>;
  /** Sorting criteria for the results. */
  sort?: InputMaybe<Sort>;
};

export type Cms_Access = {
  __typename?: 'CMS_Access';
  canAccessAdmin: Scalars['Boolean']['output'];
  comments?: Maybe<Cms_CommentsAccess>;
  form_submissions?: Maybe<Cms_Form_SubmissionsAccess>;
  forms?: Maybe<Cms_FormsAccess>;
  media?: Maybe<Cms_MediaAccess>;
  pages?: Maybe<Cms_PagesAccess>;
  payload_folders?: Maybe<Cms_Payload_FoldersAccess>;
  payload_jobs?: Maybe<Cms_Payload_JobsAccess>;
  payload_kv?: Maybe<Cms_Payload_KvAccess>;
  payload_locked_documents?: Maybe<Cms_Payload_Locked_DocumentsAccess>;
  payload_preferences?: Maybe<Cms_Payload_PreferencesAccess>;
  reassurance_cards?: Maybe<Cms_Reassurance_CardsAccess>;
  seo_categories?: Maybe<Cms_Seo_CategoriesAccess>;
  tenants?: Maybe<Cms_TenantsAccess>;
  users?: Maybe<Cms_UsersAccess>;
};

export type Cms_BrandsSliderBlock = {
  __typename?: 'CMS_BrandsSliderBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_ButtonLinkBlock = {
  __typename?: 'CMS_ButtonLinkBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Cms_Media>;
  plainLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_CalloutBlock = {
  __typename?: 'CMS_CalloutBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  calloutDescriptionRichText?: Maybe<Scalars['JSON']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tint?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type Cms_CalloutBlockCalloutDescriptionRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_CardBlock = {
  __typename?: 'CMS_CardBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  cardRichText?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isTitleBold?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Array<Cms_CardBlock_Link>>;
  picture?: Maybe<Cms_Media>;
  pictureHeight?: Maybe<Cms_CardBlock_PictureHeight>;
  pictureLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSize?: Maybe<Scalars['String']['output']>;
  titleTag?: Maybe<Cms_CardBlock_TitleTag>;
};


export type Cms_CardBlockCardRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_CardBlock_Link = {
  __typename?: 'CMS_CardBlock_Link';
  iconLeft?: Maybe<Scalars['String']['output']>;
  iconRight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export enum Cms_CardBlock_PictureHeight {
  Full = 'full',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs'
}

export enum Cms_CardBlock_TitleTag {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6'
}

export type Cms_CardIconBlock = {
  __typename?: 'CMS_CardIconBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_CatalogCardBlock = {
  __typename?: 'CMS_CatalogCardBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  catalogCardPicture?: Maybe<Cms_Media>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Cms_CatalogCardBlock_Label>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum Cms_CatalogCardBlock_Label {
  Read = 'read',
  SeeCatalog = 'seeCatalog'
}

export type Cms_CatalogListBlock = {
  __typename?: 'CMS_CatalogListBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  buttonLabelSeeLess?: Maybe<Scalars['String']['output']>;
  buttonLabelSeeMore?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  layout: Array<Cms_CatalogListBlock_Layout>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_CatalogListBlock_Layout = Cms_CatalogCardBlock;

export type Cms_CategoryLinkListBlock = {
  __typename?: 'CMS_CategoryLinkListBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  links: Array<Cms_CategoryLinkListBlock_Links>;
};

export type Cms_CategoryLinkListBlock_Links = Cms_ButtonLinkBlock;

export type Cms_Checkbox = {
  __typename?: 'CMS_Checkbox';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Cms_ColumnsBlock = {
  __typename?: 'CMS_ColumnsBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  columns?: Maybe<Array<Cms_ColumnsBlock_Columns>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_ColumnsBlock_Columns = Cms_CardBlock | Cms_CardIconBlock | Cms_InnerHtmlBlock | Cms_KeyInformationBlock | Cms_StepBlock;

export type Cms_Comment = {
  __typename?: 'CMS_Comment';
  author: Scalars['EmailAddress']['output'];
  blockId: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  replyCollection?: Maybe<Scalars['String']['output']>;
  replyDoc?: Maybe<Cms_Comment_ReplyDoc_Relationship>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type Cms_CommentReplyDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_CommentUpdate_ReplyDocRelationshipInput = {
  relationTo?: InputMaybe<Cms_CommentUpdate_ReplyDocRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_CommentUpdate_ReplyDocRelationshipInputRelationTo {
  Pages = 'pages',
  ReassuranceCards = 'reassurance_cards'
}

export type Cms_Comment_ReplyDoc = Cms_Page | Cms_ReassuranceCard;

export type Cms_Comment_ReplyDocRelationshipInput = {
  relationTo?: InputMaybe<Cms_Comment_ReplyDocRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_Comment_ReplyDocRelationshipInputRelationTo {
  Pages = 'pages',
  ReassuranceCards = 'reassurance_cards'
}

export enum Cms_Comment_ReplyDoc_RelationTo {
  Pages = 'pages',
  ReassuranceCards = 'reassurance_cards'
}

export type Cms_Comment_ReplyDoc_Relationship = {
  __typename?: 'CMS_Comment_ReplyDoc_Relationship';
  relationTo?: Maybe<Cms_Comment_ReplyDoc_RelationTo>;
  value?: Maybe<Cms_Comment_ReplyDoc>;
};

export type Cms_Comment_Author_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  contains?: InputMaybe<Scalars['EmailAddress']['input']>;
  equals?: InputMaybe<Scalars['EmailAddress']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  like?: InputMaybe<Scalars['EmailAddress']['input']>;
  not_equals?: InputMaybe<Scalars['EmailAddress']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
};

export type Cms_Comment_BlockId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Comment_Content_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_Comment_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Comment_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Comment_IsApproved_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_Comment_ReplyCollection_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Comment_ReplyDoc_Relation = {
  relationTo?: InputMaybe<Cms_Comment_ReplyDoc_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_Comment_ReplyDoc_Relation_RelationTo {
  Pages = 'pages',
  ReassuranceCards = 'reassurance_cards'
}

export type Cms_Comment_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Comment_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Comment_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_Or>>>;
  author?: InputMaybe<Cms_Comment_Author_Operator>;
  blockId?: InputMaybe<Cms_Comment_BlockId_Operator>;
  content?: InputMaybe<Cms_Comment_Content_Operator>;
  createdAt?: InputMaybe<Cms_Comment_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Comment_Id_Operator>;
  isApproved?: InputMaybe<Cms_Comment_IsApproved_Operator>;
  replyCollection?: InputMaybe<Cms_Comment_ReplyCollection_Operator>;
  replyDoc?: InputMaybe<Cms_Comment_ReplyDoc_Relation>;
  title?: InputMaybe<Cms_Comment_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Comment_UpdatedAt_Operator>;
};

export type Cms_Comment_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_Or>>>;
  author?: InputMaybe<Cms_Comment_Author_Operator>;
  blockId?: InputMaybe<Cms_Comment_BlockId_Operator>;
  content?: InputMaybe<Cms_Comment_Content_Operator>;
  createdAt?: InputMaybe<Cms_Comment_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Comment_Id_Operator>;
  isApproved?: InputMaybe<Cms_Comment_IsApproved_Operator>;
  replyCollection?: InputMaybe<Cms_Comment_ReplyCollection_Operator>;
  replyDoc?: InputMaybe<Cms_Comment_ReplyDoc_Relation>;
  title?: InputMaybe<Cms_Comment_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Comment_UpdatedAt_Operator>;
};

export type Cms_Comment_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Comment_Where_Or>>>;
  author?: InputMaybe<Cms_Comment_Author_Operator>;
  blockId?: InputMaybe<Cms_Comment_BlockId_Operator>;
  content?: InputMaybe<Cms_Comment_Content_Operator>;
  createdAt?: InputMaybe<Cms_Comment_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Comment_Id_Operator>;
  isApproved?: InputMaybe<Cms_Comment_IsApproved_Operator>;
  replyCollection?: InputMaybe<Cms_Comment_ReplyCollection_Operator>;
  replyDoc?: InputMaybe<Cms_Comment_ReplyDoc_Relation>;
  title?: InputMaybe<Cms_Comment_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Comment_UpdatedAt_Operator>;
};

export type Cms_Comments = {
  __typename?: 'CMS_Comments';
  docs: Array<Cms_Comment>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_CommentsCreateAccess = {
  __typename?: 'CMS_CommentsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsCreateDocAccess = {
  __typename?: 'CMS_CommentsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsDeleteAccess = {
  __typename?: 'CMS_CommentsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsDeleteDocAccess = {
  __typename?: 'CMS_CommentsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsDocAccessFields = {
  __typename?: 'CMS_CommentsDocAccessFields';
  author?: Maybe<Cms_CommentsDocAccessFields_Author>;
  blockId?: Maybe<Cms_CommentsDocAccessFields_BlockId>;
  content?: Maybe<Cms_CommentsDocAccessFields_Content>;
  createdAt?: Maybe<Cms_CommentsDocAccessFields_CreatedAt>;
  isApproved?: Maybe<Cms_CommentsDocAccessFields_IsApproved>;
  replyCollection?: Maybe<Cms_CommentsDocAccessFields_ReplyCollection>;
  replyDoc?: Maybe<Cms_CommentsDocAccessFields_ReplyDoc>;
  title?: Maybe<Cms_CommentsDocAccessFields_Title>;
  updatedAt?: Maybe<Cms_CommentsDocAccessFields_UpdatedAt>;
};

export type Cms_CommentsDocAccessFields_Author = {
  __typename?: 'CMS_CommentsDocAccessFields_author';
  create?: Maybe<Cms_CommentsDocAccessFields_Author_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_Author_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_Author_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_Author_Update>;
};

export type Cms_CommentsDocAccessFields_Author_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_author_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Author_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_author_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Author_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_author_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Author_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_author_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_BlockId = {
  __typename?: 'CMS_CommentsDocAccessFields_blockId';
  create?: Maybe<Cms_CommentsDocAccessFields_BlockId_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_BlockId_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_BlockId_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_BlockId_Update>;
};

export type Cms_CommentsDocAccessFields_BlockId_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_blockId_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_BlockId_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_blockId_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_BlockId_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_blockId_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_BlockId_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_blockId_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Content = {
  __typename?: 'CMS_CommentsDocAccessFields_content';
  create?: Maybe<Cms_CommentsDocAccessFields_Content_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_Content_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_Content_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_Content_Update>;
};

export type Cms_CommentsDocAccessFields_Content_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_content_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Content_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_content_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Content_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_content_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Content_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_content_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_CommentsDocAccessFields_createdAt';
  create?: Maybe<Cms_CommentsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_CreatedAt_Update>;
};

export type Cms_CommentsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_IsApproved = {
  __typename?: 'CMS_CommentsDocAccessFields_isApproved';
  create?: Maybe<Cms_CommentsDocAccessFields_IsApproved_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_IsApproved_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_IsApproved_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_IsApproved_Update>;
};

export type Cms_CommentsDocAccessFields_IsApproved_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_isApproved_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_IsApproved_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_isApproved_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_IsApproved_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_isApproved_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_IsApproved_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_isApproved_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyCollection = {
  __typename?: 'CMS_CommentsDocAccessFields_replyCollection';
  create?: Maybe<Cms_CommentsDocAccessFields_ReplyCollection_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_ReplyCollection_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_ReplyCollection_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_ReplyCollection_Update>;
};

export type Cms_CommentsDocAccessFields_ReplyCollection_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_replyCollection_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyCollection_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_replyCollection_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyCollection_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_replyCollection_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyCollection_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_replyCollection_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyDoc = {
  __typename?: 'CMS_CommentsDocAccessFields_replyDoc';
  create?: Maybe<Cms_CommentsDocAccessFields_ReplyDoc_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_ReplyDoc_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_ReplyDoc_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_ReplyDoc_Update>;
};

export type Cms_CommentsDocAccessFields_ReplyDoc_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_replyDoc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyDoc_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_replyDoc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyDoc_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_replyDoc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_ReplyDoc_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_replyDoc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Title = {
  __typename?: 'CMS_CommentsDocAccessFields_title';
  create?: Maybe<Cms_CommentsDocAccessFields_Title_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_Title_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_Title_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_Title_Update>;
};

export type Cms_CommentsDocAccessFields_Title_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Title_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Title_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_Title_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_CommentsDocAccessFields_updatedAt';
  create?: Maybe<Cms_CommentsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_CommentsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_CommentsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_CommentsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_CommentsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_CommentsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_CommentsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_CommentsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_CommentsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields = {
  __typename?: 'CMS_CommentsFields';
  author?: Maybe<Cms_CommentsFields_Author>;
  blockId?: Maybe<Cms_CommentsFields_BlockId>;
  content?: Maybe<Cms_CommentsFields_Content>;
  createdAt?: Maybe<Cms_CommentsFields_CreatedAt>;
  isApproved?: Maybe<Cms_CommentsFields_IsApproved>;
  replyCollection?: Maybe<Cms_CommentsFields_ReplyCollection>;
  replyDoc?: Maybe<Cms_CommentsFields_ReplyDoc>;
  title?: Maybe<Cms_CommentsFields_Title>;
  updatedAt?: Maybe<Cms_CommentsFields_UpdatedAt>;
};

export type Cms_CommentsFields_Author = {
  __typename?: 'CMS_CommentsFields_author';
  create?: Maybe<Cms_CommentsFields_Author_Create>;
  delete?: Maybe<Cms_CommentsFields_Author_Delete>;
  read?: Maybe<Cms_CommentsFields_Author_Read>;
  update?: Maybe<Cms_CommentsFields_Author_Update>;
};

export type Cms_CommentsFields_Author_Create = {
  __typename?: 'CMS_CommentsFields_author_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Author_Delete = {
  __typename?: 'CMS_CommentsFields_author_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Author_Read = {
  __typename?: 'CMS_CommentsFields_author_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Author_Update = {
  __typename?: 'CMS_CommentsFields_author_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_BlockId = {
  __typename?: 'CMS_CommentsFields_blockId';
  create?: Maybe<Cms_CommentsFields_BlockId_Create>;
  delete?: Maybe<Cms_CommentsFields_BlockId_Delete>;
  read?: Maybe<Cms_CommentsFields_BlockId_Read>;
  update?: Maybe<Cms_CommentsFields_BlockId_Update>;
};

export type Cms_CommentsFields_BlockId_Create = {
  __typename?: 'CMS_CommentsFields_blockId_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_BlockId_Delete = {
  __typename?: 'CMS_CommentsFields_blockId_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_BlockId_Read = {
  __typename?: 'CMS_CommentsFields_blockId_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_BlockId_Update = {
  __typename?: 'CMS_CommentsFields_blockId_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Content = {
  __typename?: 'CMS_CommentsFields_content';
  create?: Maybe<Cms_CommentsFields_Content_Create>;
  delete?: Maybe<Cms_CommentsFields_Content_Delete>;
  read?: Maybe<Cms_CommentsFields_Content_Read>;
  update?: Maybe<Cms_CommentsFields_Content_Update>;
};

export type Cms_CommentsFields_Content_Create = {
  __typename?: 'CMS_CommentsFields_content_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Content_Delete = {
  __typename?: 'CMS_CommentsFields_content_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Content_Read = {
  __typename?: 'CMS_CommentsFields_content_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Content_Update = {
  __typename?: 'CMS_CommentsFields_content_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_CreatedAt = {
  __typename?: 'CMS_CommentsFields_createdAt';
  create?: Maybe<Cms_CommentsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_CommentsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_CommentsFields_CreatedAt_Read>;
  update?: Maybe<Cms_CommentsFields_CreatedAt_Update>;
};

export type Cms_CommentsFields_CreatedAt_Create = {
  __typename?: 'CMS_CommentsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_CreatedAt_Delete = {
  __typename?: 'CMS_CommentsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_CreatedAt_Read = {
  __typename?: 'CMS_CommentsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_CreatedAt_Update = {
  __typename?: 'CMS_CommentsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_IsApproved = {
  __typename?: 'CMS_CommentsFields_isApproved';
  create?: Maybe<Cms_CommentsFields_IsApproved_Create>;
  delete?: Maybe<Cms_CommentsFields_IsApproved_Delete>;
  read?: Maybe<Cms_CommentsFields_IsApproved_Read>;
  update?: Maybe<Cms_CommentsFields_IsApproved_Update>;
};

export type Cms_CommentsFields_IsApproved_Create = {
  __typename?: 'CMS_CommentsFields_isApproved_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_IsApproved_Delete = {
  __typename?: 'CMS_CommentsFields_isApproved_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_IsApproved_Read = {
  __typename?: 'CMS_CommentsFields_isApproved_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_IsApproved_Update = {
  __typename?: 'CMS_CommentsFields_isApproved_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyCollection = {
  __typename?: 'CMS_CommentsFields_replyCollection';
  create?: Maybe<Cms_CommentsFields_ReplyCollection_Create>;
  delete?: Maybe<Cms_CommentsFields_ReplyCollection_Delete>;
  read?: Maybe<Cms_CommentsFields_ReplyCollection_Read>;
  update?: Maybe<Cms_CommentsFields_ReplyCollection_Update>;
};

export type Cms_CommentsFields_ReplyCollection_Create = {
  __typename?: 'CMS_CommentsFields_replyCollection_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyCollection_Delete = {
  __typename?: 'CMS_CommentsFields_replyCollection_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyCollection_Read = {
  __typename?: 'CMS_CommentsFields_replyCollection_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyCollection_Update = {
  __typename?: 'CMS_CommentsFields_replyCollection_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyDoc = {
  __typename?: 'CMS_CommentsFields_replyDoc';
  create?: Maybe<Cms_CommentsFields_ReplyDoc_Create>;
  delete?: Maybe<Cms_CommentsFields_ReplyDoc_Delete>;
  read?: Maybe<Cms_CommentsFields_ReplyDoc_Read>;
  update?: Maybe<Cms_CommentsFields_ReplyDoc_Update>;
};

export type Cms_CommentsFields_ReplyDoc_Create = {
  __typename?: 'CMS_CommentsFields_replyDoc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyDoc_Delete = {
  __typename?: 'CMS_CommentsFields_replyDoc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyDoc_Read = {
  __typename?: 'CMS_CommentsFields_replyDoc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_ReplyDoc_Update = {
  __typename?: 'CMS_CommentsFields_replyDoc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Title = {
  __typename?: 'CMS_CommentsFields_title';
  create?: Maybe<Cms_CommentsFields_Title_Create>;
  delete?: Maybe<Cms_CommentsFields_Title_Delete>;
  read?: Maybe<Cms_CommentsFields_Title_Read>;
  update?: Maybe<Cms_CommentsFields_Title_Update>;
};

export type Cms_CommentsFields_Title_Create = {
  __typename?: 'CMS_CommentsFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Title_Delete = {
  __typename?: 'CMS_CommentsFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Title_Read = {
  __typename?: 'CMS_CommentsFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_Title_Update = {
  __typename?: 'CMS_CommentsFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_UpdatedAt = {
  __typename?: 'CMS_CommentsFields_updatedAt';
  create?: Maybe<Cms_CommentsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_CommentsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_CommentsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_CommentsFields_UpdatedAt_Update>;
};

export type Cms_CommentsFields_UpdatedAt_Create = {
  __typename?: 'CMS_CommentsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_CommentsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_UpdatedAt_Read = {
  __typename?: 'CMS_CommentsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsFields_UpdatedAt_Update = {
  __typename?: 'CMS_CommentsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_CommentsReadAccess = {
  __typename?: 'CMS_CommentsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsReadDocAccess = {
  __typename?: 'CMS_CommentsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsUpdateAccess = {
  __typename?: 'CMS_CommentsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_CommentsUpdateDocAccess = {
  __typename?: 'CMS_CommentsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_Email = {
  __typename?: 'CMS_Email';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Cms_Form = {
  __typename?: 'CMS_Form';
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  confirmationType?: Maybe<Cms_Form_ConfirmationType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emails?: Maybe<Array<Cms_Form_Emails>>;
  fields?: Maybe<Array<Cms_Form_Fields>>;
  id: Scalars['Int']['output'];
  redirect?: Maybe<Cms_Form_Redirect>;
  submitButtonLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Cms_FormBlock = {
  __typename?: 'CMS_FormBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Cms_Form>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_FormSubmission = {
  __typename?: 'CMS_FormSubmission';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  form?: Maybe<Cms_Form>;
  id: Scalars['Int']['output'];
  submissionData?: Maybe<Array<Cms_FormSubmission_SubmissionData>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Cms_FormSubmission_SubmissionData = {
  __typename?: 'CMS_FormSubmission_SubmissionData';
  field?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Cms_FormSubmission_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_FormSubmission_Form_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_FormSubmission_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_FormSubmission_SubmissionData__Field_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_FormSubmission_SubmissionData__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_FormSubmission_SubmissionData__Value_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_FormSubmission_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_FormSubmission_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<Cms_FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<Cms_FormSubmission_Form_Operator>;
  id?: InputMaybe<Cms_FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<Cms_FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<Cms_FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<Cms_FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<Cms_FormSubmission_UpdatedAt_Operator>;
};

export type Cms_FormSubmission_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<Cms_FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<Cms_FormSubmission_Form_Operator>;
  id?: InputMaybe<Cms_FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<Cms_FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<Cms_FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<Cms_FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<Cms_FormSubmission_UpdatedAt_Operator>;
};

export type Cms_FormSubmission_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<Cms_FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<Cms_FormSubmission_Form_Operator>;
  id?: InputMaybe<Cms_FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<Cms_FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<Cms_FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<Cms_FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<Cms_FormSubmission_UpdatedAt_Operator>;
};

export type Cms_FormSubmissions = {
  __typename?: 'CMS_FormSubmissions';
  docs: Array<Cms_FormSubmission>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_FormSubmissionsCreateAccess = {
  __typename?: 'CMS_FormSubmissionsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsCreateDocAccess = {
  __typename?: 'CMS_FormSubmissionsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsDeleteAccess = {
  __typename?: 'CMS_FormSubmissionsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsDeleteDocAccess = {
  __typename?: 'CMS_FormSubmissionsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsDocAccessFields = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields';
  createdAt?: Maybe<Cms_FormSubmissionsDocAccessFields_CreatedAt>;
  form?: Maybe<Cms_FormSubmissionsDocAccessFields_Form>;
  submissionData?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData>;
  updatedAt?: Maybe<Cms_FormSubmissionsDocAccessFields_UpdatedAt>;
};

export type Cms_FormSubmissionsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_createdAt';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_CreatedAt_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_Form = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_form';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_Form_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_Form_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_Form_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_Form_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_Form_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_form_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_Form_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_form_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_Form_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_form_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_Form_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_form_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Delete>;
  fields?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Fields>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Fields = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_Fields';
  field?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Field>;
  id?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Id>;
  value?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Value>;
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Field = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_field';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_field_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_field_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_field_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Field_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_field_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Id = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_id';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Id_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Value = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_value';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_value_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_value_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_value_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_SubmissionData_Value_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_submissionData_value_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_updatedAt';
  create?: Maybe<Cms_FormSubmissionsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_FormSubmissionsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_FormSubmissionsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_FormSubmissionsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_FormSubmissionsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_FormSubmissionsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields = {
  __typename?: 'CMS_FormSubmissionsFields';
  createdAt?: Maybe<Cms_FormSubmissionsFields_CreatedAt>;
  form?: Maybe<Cms_FormSubmissionsFields_Form>;
  submissionData?: Maybe<Cms_FormSubmissionsFields_SubmissionData>;
  updatedAt?: Maybe<Cms_FormSubmissionsFields_UpdatedAt>;
};

export type Cms_FormSubmissionsFields_CreatedAt = {
  __typename?: 'CMS_FormSubmissionsFields_createdAt';
  create?: Maybe<Cms_FormSubmissionsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_CreatedAt_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_CreatedAt_Update>;
};

export type Cms_FormSubmissionsFields_CreatedAt_Create = {
  __typename?: 'CMS_FormSubmissionsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_CreatedAt_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_CreatedAt_Read = {
  __typename?: 'CMS_FormSubmissionsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_CreatedAt_Update = {
  __typename?: 'CMS_FormSubmissionsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_Form = {
  __typename?: 'CMS_FormSubmissionsFields_form';
  create?: Maybe<Cms_FormSubmissionsFields_Form_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_Form_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_Form_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_Form_Update>;
};

export type Cms_FormSubmissionsFields_Form_Create = {
  __typename?: 'CMS_FormSubmissionsFields_form_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_Form_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_form_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_Form_Read = {
  __typename?: 'CMS_FormSubmissionsFields_form_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_Form_Update = {
  __typename?: 'CMS_FormSubmissionsFields_form_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData';
  create?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Delete>;
  fields?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Fields>;
  read?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Update>;
};

export type Cms_FormSubmissionsFields_SubmissionData_Create = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Fields = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_Fields';
  field?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Field>;
  id?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Id>;
  value?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Value>;
};

export type Cms_FormSubmissionsFields_SubmissionData_Read = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Update = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Field = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_field';
  create?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Field_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Field_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Field_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Field_Update>;
};

export type Cms_FormSubmissionsFields_SubmissionData_Field_Create = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_field_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Field_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_field_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Field_Read = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_field_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Field_Update = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_field_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Id = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_id';
  create?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Id_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Id_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Id_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Id_Update>;
};

export type Cms_FormSubmissionsFields_SubmissionData_Id_Create = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Id_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Id_Read = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Id_Update = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Value = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_value';
  create?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Value_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Value_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Value_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_SubmissionData_Value_Update>;
};

export type Cms_FormSubmissionsFields_SubmissionData_Value_Create = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_value_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Value_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_value_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Value_Read = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_value_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_SubmissionData_Value_Update = {
  __typename?: 'CMS_FormSubmissionsFields_submissionData_value_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_UpdatedAt = {
  __typename?: 'CMS_FormSubmissionsFields_updatedAt';
  create?: Maybe<Cms_FormSubmissionsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_FormSubmissionsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_FormSubmissionsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_FormSubmissionsFields_UpdatedAt_Update>;
};

export type Cms_FormSubmissionsFields_UpdatedAt_Create = {
  __typename?: 'CMS_FormSubmissionsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_FormSubmissionsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_UpdatedAt_Read = {
  __typename?: 'CMS_FormSubmissionsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsFields_UpdatedAt_Update = {
  __typename?: 'CMS_FormSubmissionsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormSubmissionsReadAccess = {
  __typename?: 'CMS_FormSubmissionsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsReadDocAccess = {
  __typename?: 'CMS_FormSubmissionsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsUpdateAccess = {
  __typename?: 'CMS_FormSubmissionsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormSubmissionsUpdateDocAccess = {
  __typename?: 'CMS_FormSubmissionsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_Form_Emails = {
  __typename?: 'CMS_Form_Emails';
  bcc?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  emailFrom?: Maybe<Scalars['String']['output']>;
  emailTo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['JSON']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};


export type Cms_Form_EmailsMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Form_Fields = Cms_Checkbox | Cms_Email | Cms_Text;

export type Cms_Form_Redirect = {
  __typename?: 'CMS_Form_Redirect';
  url?: Maybe<Scalars['String']['output']>;
};

export type Cms_Form_ConfirmationMessage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Cms_Form_ConfirmationType {
  Message = 'message',
  Redirect = 'redirect'
}

export enum Cms_Form_ConfirmationType_Input {
  Message = 'message',
  Redirect = 'redirect'
}

export type Cms_Form_ConfirmationType_Operator = {
  contains?: InputMaybe<Cms_Form_ConfirmationType_Input>;
  equals?: InputMaybe<Cms_Form_ConfirmationType_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Cms_Form_ConfirmationType_Input>;
  not_equals?: InputMaybe<Cms_Form_ConfirmationType_Input>;
};

export type Cms_Form_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Form_Emails__Bcc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__Cc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__EmailFrom_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__EmailTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__Message_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_Form_Emails__ReplyTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Emails__Subject_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Form_Redirect__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_SubmitButtonLabel_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Form_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Form_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Cms_Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Cms_Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Cms_Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Cms_Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Cms_Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Cms_Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Cms_Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Cms_Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Cms_Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Cms_Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Cms_Form_Emails__Subject_Operator>;
  id?: InputMaybe<Cms_Form_Id_Operator>;
  redirect__url?: InputMaybe<Cms_Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Cms_Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Cms_Form_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Form_UpdatedAt_Operator>;
};

export type Cms_Form_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Cms_Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Cms_Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Cms_Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Cms_Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Cms_Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Cms_Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Cms_Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Cms_Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Cms_Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Cms_Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Cms_Form_Emails__Subject_Operator>;
  id?: InputMaybe<Cms_Form_Id_Operator>;
  redirect__url?: InputMaybe<Cms_Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Cms_Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Cms_Form_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Form_UpdatedAt_Operator>;
};

export type Cms_Form_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Cms_Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Cms_Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Cms_Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Cms_Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Cms_Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Cms_Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Cms_Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Cms_Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Cms_Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Cms_Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Cms_Form_Emails__Subject_Operator>;
  id?: InputMaybe<Cms_Form_Id_Operator>;
  redirect__url?: InputMaybe<Cms_Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Cms_Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Cms_Form_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Form_UpdatedAt_Operator>;
};

export type Cms_Forms = {
  __typename?: 'CMS_Forms';
  docs: Array<Cms_Form>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_FormsCreateAccess = {
  __typename?: 'CMS_FormsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsCreateDocAccess = {
  __typename?: 'CMS_FormsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsDeleteAccess = {
  __typename?: 'CMS_FormsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsDeleteDocAccess = {
  __typename?: 'CMS_FormsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsDocAccessFields = {
  __typename?: 'CMS_FormsDocAccessFields';
  confirmationMessage?: Maybe<Cms_FormsDocAccessFields_ConfirmationMessage>;
  confirmationType?: Maybe<Cms_FormsDocAccessFields_ConfirmationType>;
  createdAt?: Maybe<Cms_FormsDocAccessFields_CreatedAt>;
  emails?: Maybe<Cms_FormsDocAccessFields_Emails>;
  fields?: Maybe<Cms_FormsDocAccessFields_Fields>;
  redirect?: Maybe<Cms_FormsDocAccessFields_Redirect>;
  submitButtonLabel?: Maybe<Cms_FormsDocAccessFields_SubmitButtonLabel>;
  title?: Maybe<Cms_FormsDocAccessFields_Title>;
  updatedAt?: Maybe<Cms_FormsDocAccessFields_UpdatedAt>;
};

export type Cms_FormsDocAccessFields_ConfirmationMessage = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationMessage';
  create?: Maybe<Cms_FormsDocAccessFields_ConfirmationMessage_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_ConfirmationMessage_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_ConfirmationMessage_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_ConfirmationMessage_Update>;
};

export type Cms_FormsDocAccessFields_ConfirmationMessage_Create = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationMessage_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationMessage_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationMessage_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationMessage_Read = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationMessage_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationMessage_Update = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationMessage_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationType = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationType';
  create?: Maybe<Cms_FormsDocAccessFields_ConfirmationType_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_ConfirmationType_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_ConfirmationType_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_ConfirmationType_Update>;
};

export type Cms_FormsDocAccessFields_ConfirmationType_Create = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationType_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationType_Read = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_ConfirmationType_Update = {
  __typename?: 'CMS_FormsDocAccessFields_confirmationType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_FormsDocAccessFields_createdAt';
  create?: Maybe<Cms_FormsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_CreatedAt_Update>;
};

export type Cms_FormsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_FormsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_FormsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_FormsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails = {
  __typename?: 'CMS_FormsDocAccessFields_emails';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Delete>;
  fields?: Maybe<Cms_FormsDocAccessFields_Emails_Fields>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Fields = {
  __typename?: 'CMS_FormsDocAccessFields_emails_Fields';
  bcc?: Maybe<Cms_FormsDocAccessFields_Emails_Bcc>;
  cc?: Maybe<Cms_FormsDocAccessFields_Emails_Cc>;
  emailFrom?: Maybe<Cms_FormsDocAccessFields_Emails_EmailFrom>;
  emailTo?: Maybe<Cms_FormsDocAccessFields_Emails_EmailTo>;
  id?: Maybe<Cms_FormsDocAccessFields_Emails_Id>;
  message?: Maybe<Cms_FormsDocAccessFields_Emails_Message>;
  replyTo?: Maybe<Cms_FormsDocAccessFields_Emails_ReplyTo>;
  subject?: Maybe<Cms_FormsDocAccessFields_Emails_Subject>;
};

export type Cms_FormsDocAccessFields_Emails_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Bcc = {
  __typename?: 'CMS_FormsDocAccessFields_emails_bcc';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Bcc_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Bcc_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Bcc_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Bcc_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Bcc_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_bcc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Bcc_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_bcc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Bcc_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_bcc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Bcc_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_bcc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Cc = {
  __typename?: 'CMS_FormsDocAccessFields_emails_cc';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Cc_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Cc_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Cc_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Cc_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Cc_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_cc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Cc_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_cc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Cc_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_cc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Cc_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_cc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailFrom = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailFrom';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_EmailFrom_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_EmailFrom_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_EmailFrom_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_EmailFrom_Update>;
};

export type Cms_FormsDocAccessFields_Emails_EmailFrom_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailFrom_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailFrom_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailFrom_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailFrom_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailFrom_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailFrom_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailFrom_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailTo = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailTo';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_EmailTo_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_EmailTo_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_EmailTo_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_EmailTo_Update>;
};

export type Cms_FormsDocAccessFields_Emails_EmailTo_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailTo_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailTo_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailTo_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailTo_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailTo_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_EmailTo_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_emailTo_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Id = {
  __typename?: 'CMS_FormsDocAccessFields_emails_id';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Id_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Id_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Id_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Id_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Id_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Id_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Id_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Id_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Message = {
  __typename?: 'CMS_FormsDocAccessFields_emails_message';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Message_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Message_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Message_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Message_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Message_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_message_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Message_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_message_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Message_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_message_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Message_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_message_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_ReplyTo = {
  __typename?: 'CMS_FormsDocAccessFields_emails_replyTo';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_ReplyTo_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_ReplyTo_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_ReplyTo_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_ReplyTo_Update>;
};

export type Cms_FormsDocAccessFields_Emails_ReplyTo_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_replyTo_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_ReplyTo_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_replyTo_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_ReplyTo_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_replyTo_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_ReplyTo_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_replyTo_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Subject = {
  __typename?: 'CMS_FormsDocAccessFields_emails_subject';
  create?: Maybe<Cms_FormsDocAccessFields_Emails_Subject_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Emails_Subject_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Emails_Subject_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Emails_Subject_Update>;
};

export type Cms_FormsDocAccessFields_Emails_Subject_Create = {
  __typename?: 'CMS_FormsDocAccessFields_emails_subject_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Subject_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_emails_subject_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Subject_Read = {
  __typename?: 'CMS_FormsDocAccessFields_emails_subject_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Emails_Subject_Update = {
  __typename?: 'CMS_FormsDocAccessFields_emails_subject_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Fields = {
  __typename?: 'CMS_FormsDocAccessFields_fields';
  create?: Maybe<Cms_FormsDocAccessFields_Fields_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Fields_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Fields_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Fields_Update>;
};

export type Cms_FormsDocAccessFields_Fields_Create = {
  __typename?: 'CMS_FormsDocAccessFields_fields_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Fields_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_fields_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Fields_Read = {
  __typename?: 'CMS_FormsDocAccessFields_fields_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Fields_Update = {
  __typename?: 'CMS_FormsDocAccessFields_fields_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect = {
  __typename?: 'CMS_FormsDocAccessFields_redirect';
  create?: Maybe<Cms_FormsDocAccessFields_Redirect_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Redirect_Delete>;
  fields?: Maybe<Cms_FormsDocAccessFields_Redirect_Fields>;
  read?: Maybe<Cms_FormsDocAccessFields_Redirect_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Redirect_Update>;
};

export type Cms_FormsDocAccessFields_Redirect_Create = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Fields = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_Fields';
  url?: Maybe<Cms_FormsDocAccessFields_Redirect_Url>;
};

export type Cms_FormsDocAccessFields_Redirect_Read = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Update = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Url = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_url';
  create?: Maybe<Cms_FormsDocAccessFields_Redirect_Url_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Redirect_Url_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Redirect_Url_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Redirect_Url_Update>;
};

export type Cms_FormsDocAccessFields_Redirect_Url_Create = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Url_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Url_Read = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Redirect_Url_Update = {
  __typename?: 'CMS_FormsDocAccessFields_redirect_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_SubmitButtonLabel = {
  __typename?: 'CMS_FormsDocAccessFields_submitButtonLabel';
  create?: Maybe<Cms_FormsDocAccessFields_SubmitButtonLabel_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_SubmitButtonLabel_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_SubmitButtonLabel_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_SubmitButtonLabel_Update>;
};

export type Cms_FormsDocAccessFields_SubmitButtonLabel_Create = {
  __typename?: 'CMS_FormsDocAccessFields_submitButtonLabel_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_SubmitButtonLabel_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_submitButtonLabel_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_SubmitButtonLabel_Read = {
  __typename?: 'CMS_FormsDocAccessFields_submitButtonLabel_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_SubmitButtonLabel_Update = {
  __typename?: 'CMS_FormsDocAccessFields_submitButtonLabel_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Title = {
  __typename?: 'CMS_FormsDocAccessFields_title';
  create?: Maybe<Cms_FormsDocAccessFields_Title_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_Title_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_Title_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_Title_Update>;
};

export type Cms_FormsDocAccessFields_Title_Create = {
  __typename?: 'CMS_FormsDocAccessFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Title_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Title_Read = {
  __typename?: 'CMS_FormsDocAccessFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_Title_Update = {
  __typename?: 'CMS_FormsDocAccessFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_FormsDocAccessFields_updatedAt';
  create?: Maybe<Cms_FormsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_FormsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_FormsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_FormsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_FormsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_FormsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_FormsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_FormsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_FormsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields = {
  __typename?: 'CMS_FormsFields';
  confirmationMessage?: Maybe<Cms_FormsFields_ConfirmationMessage>;
  confirmationType?: Maybe<Cms_FormsFields_ConfirmationType>;
  createdAt?: Maybe<Cms_FormsFields_CreatedAt>;
  emails?: Maybe<Cms_FormsFields_Emails>;
  fields?: Maybe<Cms_FormsFields_Fields>;
  redirect?: Maybe<Cms_FormsFields_Redirect>;
  submitButtonLabel?: Maybe<Cms_FormsFields_SubmitButtonLabel>;
  title?: Maybe<Cms_FormsFields_Title>;
  updatedAt?: Maybe<Cms_FormsFields_UpdatedAt>;
};

export type Cms_FormsFields_ConfirmationMessage = {
  __typename?: 'CMS_FormsFields_confirmationMessage';
  create?: Maybe<Cms_FormsFields_ConfirmationMessage_Create>;
  delete?: Maybe<Cms_FormsFields_ConfirmationMessage_Delete>;
  read?: Maybe<Cms_FormsFields_ConfirmationMessage_Read>;
  update?: Maybe<Cms_FormsFields_ConfirmationMessage_Update>;
};

export type Cms_FormsFields_ConfirmationMessage_Create = {
  __typename?: 'CMS_FormsFields_confirmationMessage_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationMessage_Delete = {
  __typename?: 'CMS_FormsFields_confirmationMessage_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationMessage_Read = {
  __typename?: 'CMS_FormsFields_confirmationMessage_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationMessage_Update = {
  __typename?: 'CMS_FormsFields_confirmationMessage_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationType = {
  __typename?: 'CMS_FormsFields_confirmationType';
  create?: Maybe<Cms_FormsFields_ConfirmationType_Create>;
  delete?: Maybe<Cms_FormsFields_ConfirmationType_Delete>;
  read?: Maybe<Cms_FormsFields_ConfirmationType_Read>;
  update?: Maybe<Cms_FormsFields_ConfirmationType_Update>;
};

export type Cms_FormsFields_ConfirmationType_Create = {
  __typename?: 'CMS_FormsFields_confirmationType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationType_Delete = {
  __typename?: 'CMS_FormsFields_confirmationType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationType_Read = {
  __typename?: 'CMS_FormsFields_confirmationType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_ConfirmationType_Update = {
  __typename?: 'CMS_FormsFields_confirmationType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_CreatedAt = {
  __typename?: 'CMS_FormsFields_createdAt';
  create?: Maybe<Cms_FormsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_FormsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_FormsFields_CreatedAt_Read>;
  update?: Maybe<Cms_FormsFields_CreatedAt_Update>;
};

export type Cms_FormsFields_CreatedAt_Create = {
  __typename?: 'CMS_FormsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_CreatedAt_Delete = {
  __typename?: 'CMS_FormsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_CreatedAt_Read = {
  __typename?: 'CMS_FormsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_CreatedAt_Update = {
  __typename?: 'CMS_FormsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails = {
  __typename?: 'CMS_FormsFields_emails';
  create?: Maybe<Cms_FormsFields_Emails_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Delete>;
  fields?: Maybe<Cms_FormsFields_Emails_Fields>;
  read?: Maybe<Cms_FormsFields_Emails_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Update>;
};

export type Cms_FormsFields_Emails_Create = {
  __typename?: 'CMS_FormsFields_emails_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Delete = {
  __typename?: 'CMS_FormsFields_emails_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Fields = {
  __typename?: 'CMS_FormsFields_emails_Fields';
  bcc?: Maybe<Cms_FormsFields_Emails_Bcc>;
  cc?: Maybe<Cms_FormsFields_Emails_Cc>;
  emailFrom?: Maybe<Cms_FormsFields_Emails_EmailFrom>;
  emailTo?: Maybe<Cms_FormsFields_Emails_EmailTo>;
  id?: Maybe<Cms_FormsFields_Emails_Id>;
  message?: Maybe<Cms_FormsFields_Emails_Message>;
  replyTo?: Maybe<Cms_FormsFields_Emails_ReplyTo>;
  subject?: Maybe<Cms_FormsFields_Emails_Subject>;
};

export type Cms_FormsFields_Emails_Read = {
  __typename?: 'CMS_FormsFields_emails_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Update = {
  __typename?: 'CMS_FormsFields_emails_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Bcc = {
  __typename?: 'CMS_FormsFields_emails_bcc';
  create?: Maybe<Cms_FormsFields_Emails_Bcc_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Bcc_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_Bcc_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Bcc_Update>;
};

export type Cms_FormsFields_Emails_Bcc_Create = {
  __typename?: 'CMS_FormsFields_emails_bcc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Bcc_Delete = {
  __typename?: 'CMS_FormsFields_emails_bcc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Bcc_Read = {
  __typename?: 'CMS_FormsFields_emails_bcc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Bcc_Update = {
  __typename?: 'CMS_FormsFields_emails_bcc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Cc = {
  __typename?: 'CMS_FormsFields_emails_cc';
  create?: Maybe<Cms_FormsFields_Emails_Cc_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Cc_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_Cc_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Cc_Update>;
};

export type Cms_FormsFields_Emails_Cc_Create = {
  __typename?: 'CMS_FormsFields_emails_cc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Cc_Delete = {
  __typename?: 'CMS_FormsFields_emails_cc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Cc_Read = {
  __typename?: 'CMS_FormsFields_emails_cc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Cc_Update = {
  __typename?: 'CMS_FormsFields_emails_cc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailFrom = {
  __typename?: 'CMS_FormsFields_emails_emailFrom';
  create?: Maybe<Cms_FormsFields_Emails_EmailFrom_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_EmailFrom_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_EmailFrom_Read>;
  update?: Maybe<Cms_FormsFields_Emails_EmailFrom_Update>;
};

export type Cms_FormsFields_Emails_EmailFrom_Create = {
  __typename?: 'CMS_FormsFields_emails_emailFrom_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailFrom_Delete = {
  __typename?: 'CMS_FormsFields_emails_emailFrom_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailFrom_Read = {
  __typename?: 'CMS_FormsFields_emails_emailFrom_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailFrom_Update = {
  __typename?: 'CMS_FormsFields_emails_emailFrom_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailTo = {
  __typename?: 'CMS_FormsFields_emails_emailTo';
  create?: Maybe<Cms_FormsFields_Emails_EmailTo_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_EmailTo_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_EmailTo_Read>;
  update?: Maybe<Cms_FormsFields_Emails_EmailTo_Update>;
};

export type Cms_FormsFields_Emails_EmailTo_Create = {
  __typename?: 'CMS_FormsFields_emails_emailTo_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailTo_Delete = {
  __typename?: 'CMS_FormsFields_emails_emailTo_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailTo_Read = {
  __typename?: 'CMS_FormsFields_emails_emailTo_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_EmailTo_Update = {
  __typename?: 'CMS_FormsFields_emails_emailTo_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Id = {
  __typename?: 'CMS_FormsFields_emails_id';
  create?: Maybe<Cms_FormsFields_Emails_Id_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Id_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_Id_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Id_Update>;
};

export type Cms_FormsFields_Emails_Id_Create = {
  __typename?: 'CMS_FormsFields_emails_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Id_Delete = {
  __typename?: 'CMS_FormsFields_emails_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Id_Read = {
  __typename?: 'CMS_FormsFields_emails_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Id_Update = {
  __typename?: 'CMS_FormsFields_emails_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Message = {
  __typename?: 'CMS_FormsFields_emails_message';
  create?: Maybe<Cms_FormsFields_Emails_Message_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Message_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_Message_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Message_Update>;
};

export type Cms_FormsFields_Emails_Message_Create = {
  __typename?: 'CMS_FormsFields_emails_message_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Message_Delete = {
  __typename?: 'CMS_FormsFields_emails_message_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Message_Read = {
  __typename?: 'CMS_FormsFields_emails_message_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Message_Update = {
  __typename?: 'CMS_FormsFields_emails_message_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_ReplyTo = {
  __typename?: 'CMS_FormsFields_emails_replyTo';
  create?: Maybe<Cms_FormsFields_Emails_ReplyTo_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_ReplyTo_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_ReplyTo_Read>;
  update?: Maybe<Cms_FormsFields_Emails_ReplyTo_Update>;
};

export type Cms_FormsFields_Emails_ReplyTo_Create = {
  __typename?: 'CMS_FormsFields_emails_replyTo_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_ReplyTo_Delete = {
  __typename?: 'CMS_FormsFields_emails_replyTo_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_ReplyTo_Read = {
  __typename?: 'CMS_FormsFields_emails_replyTo_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_ReplyTo_Update = {
  __typename?: 'CMS_FormsFields_emails_replyTo_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Subject = {
  __typename?: 'CMS_FormsFields_emails_subject';
  create?: Maybe<Cms_FormsFields_Emails_Subject_Create>;
  delete?: Maybe<Cms_FormsFields_Emails_Subject_Delete>;
  read?: Maybe<Cms_FormsFields_Emails_Subject_Read>;
  update?: Maybe<Cms_FormsFields_Emails_Subject_Update>;
};

export type Cms_FormsFields_Emails_Subject_Create = {
  __typename?: 'CMS_FormsFields_emails_subject_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Subject_Delete = {
  __typename?: 'CMS_FormsFields_emails_subject_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Subject_Read = {
  __typename?: 'CMS_FormsFields_emails_subject_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Emails_Subject_Update = {
  __typename?: 'CMS_FormsFields_emails_subject_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Fields = {
  __typename?: 'CMS_FormsFields_fields';
  create?: Maybe<Cms_FormsFields_Fields_Create>;
  delete?: Maybe<Cms_FormsFields_Fields_Delete>;
  read?: Maybe<Cms_FormsFields_Fields_Read>;
  update?: Maybe<Cms_FormsFields_Fields_Update>;
};

export type Cms_FormsFields_Fields_Create = {
  __typename?: 'CMS_FormsFields_fields_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Fields_Delete = {
  __typename?: 'CMS_FormsFields_fields_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Fields_Read = {
  __typename?: 'CMS_FormsFields_fields_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Fields_Update = {
  __typename?: 'CMS_FormsFields_fields_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect = {
  __typename?: 'CMS_FormsFields_redirect';
  create?: Maybe<Cms_FormsFields_Redirect_Create>;
  delete?: Maybe<Cms_FormsFields_Redirect_Delete>;
  fields?: Maybe<Cms_FormsFields_Redirect_Fields>;
  read?: Maybe<Cms_FormsFields_Redirect_Read>;
  update?: Maybe<Cms_FormsFields_Redirect_Update>;
};

export type Cms_FormsFields_Redirect_Create = {
  __typename?: 'CMS_FormsFields_redirect_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Delete = {
  __typename?: 'CMS_FormsFields_redirect_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Fields = {
  __typename?: 'CMS_FormsFields_redirect_Fields';
  url?: Maybe<Cms_FormsFields_Redirect_Url>;
};

export type Cms_FormsFields_Redirect_Read = {
  __typename?: 'CMS_FormsFields_redirect_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Update = {
  __typename?: 'CMS_FormsFields_redirect_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Url = {
  __typename?: 'CMS_FormsFields_redirect_url';
  create?: Maybe<Cms_FormsFields_Redirect_Url_Create>;
  delete?: Maybe<Cms_FormsFields_Redirect_Url_Delete>;
  read?: Maybe<Cms_FormsFields_Redirect_Url_Read>;
  update?: Maybe<Cms_FormsFields_Redirect_Url_Update>;
};

export type Cms_FormsFields_Redirect_Url_Create = {
  __typename?: 'CMS_FormsFields_redirect_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Url_Delete = {
  __typename?: 'CMS_FormsFields_redirect_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Url_Read = {
  __typename?: 'CMS_FormsFields_redirect_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Redirect_Url_Update = {
  __typename?: 'CMS_FormsFields_redirect_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_SubmitButtonLabel = {
  __typename?: 'CMS_FormsFields_submitButtonLabel';
  create?: Maybe<Cms_FormsFields_SubmitButtonLabel_Create>;
  delete?: Maybe<Cms_FormsFields_SubmitButtonLabel_Delete>;
  read?: Maybe<Cms_FormsFields_SubmitButtonLabel_Read>;
  update?: Maybe<Cms_FormsFields_SubmitButtonLabel_Update>;
};

export type Cms_FormsFields_SubmitButtonLabel_Create = {
  __typename?: 'CMS_FormsFields_submitButtonLabel_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_SubmitButtonLabel_Delete = {
  __typename?: 'CMS_FormsFields_submitButtonLabel_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_SubmitButtonLabel_Read = {
  __typename?: 'CMS_FormsFields_submitButtonLabel_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_SubmitButtonLabel_Update = {
  __typename?: 'CMS_FormsFields_submitButtonLabel_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Title = {
  __typename?: 'CMS_FormsFields_title';
  create?: Maybe<Cms_FormsFields_Title_Create>;
  delete?: Maybe<Cms_FormsFields_Title_Delete>;
  read?: Maybe<Cms_FormsFields_Title_Read>;
  update?: Maybe<Cms_FormsFields_Title_Update>;
};

export type Cms_FormsFields_Title_Create = {
  __typename?: 'CMS_FormsFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Title_Delete = {
  __typename?: 'CMS_FormsFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Title_Read = {
  __typename?: 'CMS_FormsFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_Title_Update = {
  __typename?: 'CMS_FormsFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_UpdatedAt = {
  __typename?: 'CMS_FormsFields_updatedAt';
  create?: Maybe<Cms_FormsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_FormsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_FormsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_FormsFields_UpdatedAt_Update>;
};

export type Cms_FormsFields_UpdatedAt_Create = {
  __typename?: 'CMS_FormsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_FormsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_UpdatedAt_Read = {
  __typename?: 'CMS_FormsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsFields_UpdatedAt_Update = {
  __typename?: 'CMS_FormsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_FormsReadAccess = {
  __typename?: 'CMS_FormsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsReadDocAccess = {
  __typename?: 'CMS_FormsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsUpdateAccess = {
  __typename?: 'CMS_FormsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FormsUpdateDocAccess = {
  __typename?: 'CMS_FormsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_FullImageCardBlock = {
  __typename?: 'CMS_FullImageCardBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageFullImageCard?: Maybe<Cms_Media>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_HeroBannerBlock = {
  __typename?: 'CMS_HeroBannerBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  contentBottom?: Maybe<Scalars['JSON']['output']>;
  contentTop?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type Cms_HeroBannerBlockContentBottomArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_InnerHtmlBlock = {
  __typename?: 'CMS_InnerHtmlBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};


export type Cms_InnerHtmlBlockHtmlContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_KeyInformationBlock = {
  __typename?: 'CMS_KeyInformationBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  illustration?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_Media = {
  __typename?: 'CMS_Media';
  alt: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  focalX?: Maybe<Scalars['Float']['output']>;
  focalY?: Maybe<Scalars['Float']['output']>;
  folder?: Maybe<Cms_PayloadFolder>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Cms_MediaCreateAccess = {
  __typename?: 'CMS_MediaCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaCreateDocAccess = {
  __typename?: 'CMS_MediaCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaDeleteAccess = {
  __typename?: 'CMS_MediaDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaDeleteDocAccess = {
  __typename?: 'CMS_MediaDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaDocAccessFields = {
  __typename?: 'CMS_MediaDocAccessFields';
  alt?: Maybe<Cms_MediaDocAccessFields_Alt>;
  createdAt?: Maybe<Cms_MediaDocAccessFields_CreatedAt>;
  filename?: Maybe<Cms_MediaDocAccessFields_Filename>;
  filesize?: Maybe<Cms_MediaDocAccessFields_Filesize>;
  focalX?: Maybe<Cms_MediaDocAccessFields_FocalX>;
  focalY?: Maybe<Cms_MediaDocAccessFields_FocalY>;
  folder?: Maybe<Cms_MediaDocAccessFields_Folder>;
  height?: Maybe<Cms_MediaDocAccessFields_Height>;
  mimeType?: Maybe<Cms_MediaDocAccessFields_MimeType>;
  thumbnailURL?: Maybe<Cms_MediaDocAccessFields_ThumbnailUrl>;
  updatedAt?: Maybe<Cms_MediaDocAccessFields_UpdatedAt>;
  url?: Maybe<Cms_MediaDocAccessFields_Url>;
  width?: Maybe<Cms_MediaDocAccessFields_Width>;
};

export type Cms_MediaDocAccessFields_Alt = {
  __typename?: 'CMS_MediaDocAccessFields_alt';
  create?: Maybe<Cms_MediaDocAccessFields_Alt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Alt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Alt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Alt_Update>;
};

export type Cms_MediaDocAccessFields_Alt_Create = {
  __typename?: 'CMS_MediaDocAccessFields_alt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Alt_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_alt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Alt_Read = {
  __typename?: 'CMS_MediaDocAccessFields_alt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Alt_Update = {
  __typename?: 'CMS_MediaDocAccessFields_alt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_CreatedAt = {
  __typename?: 'CMS_MediaDocAccessFields_createdAt';
  create?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Update>;
};

export type Cms_MediaDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_MediaDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_MediaDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_MediaDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filename = {
  __typename?: 'CMS_MediaDocAccessFields_filename';
  create?: Maybe<Cms_MediaDocAccessFields_Filename_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Filename_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Filename_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Filename_Update>;
};

export type Cms_MediaDocAccessFields_Filename_Create = {
  __typename?: 'CMS_MediaDocAccessFields_filename_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filename_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_filename_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filename_Read = {
  __typename?: 'CMS_MediaDocAccessFields_filename_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filename_Update = {
  __typename?: 'CMS_MediaDocAccessFields_filename_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filesize = {
  __typename?: 'CMS_MediaDocAccessFields_filesize';
  create?: Maybe<Cms_MediaDocAccessFields_Filesize_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Filesize_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Filesize_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Filesize_Update>;
};

export type Cms_MediaDocAccessFields_Filesize_Create = {
  __typename?: 'CMS_MediaDocAccessFields_filesize_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filesize_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_filesize_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filesize_Read = {
  __typename?: 'CMS_MediaDocAccessFields_filesize_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Filesize_Update = {
  __typename?: 'CMS_MediaDocAccessFields_filesize_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalX = {
  __typename?: 'CMS_MediaDocAccessFields_focalX';
  create?: Maybe<Cms_MediaDocAccessFields_FocalX_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_FocalX_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_FocalX_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_FocalX_Update>;
};

export type Cms_MediaDocAccessFields_FocalX_Create = {
  __typename?: 'CMS_MediaDocAccessFields_focalX_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalX_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_focalX_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalX_Read = {
  __typename?: 'CMS_MediaDocAccessFields_focalX_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalX_Update = {
  __typename?: 'CMS_MediaDocAccessFields_focalX_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalY = {
  __typename?: 'CMS_MediaDocAccessFields_focalY';
  create?: Maybe<Cms_MediaDocAccessFields_FocalY_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_FocalY_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_FocalY_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_FocalY_Update>;
};

export type Cms_MediaDocAccessFields_FocalY_Create = {
  __typename?: 'CMS_MediaDocAccessFields_focalY_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalY_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_focalY_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalY_Read = {
  __typename?: 'CMS_MediaDocAccessFields_focalY_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_FocalY_Update = {
  __typename?: 'CMS_MediaDocAccessFields_focalY_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Folder = {
  __typename?: 'CMS_MediaDocAccessFields_folder';
  create?: Maybe<Cms_MediaDocAccessFields_Folder_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Folder_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Folder_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Folder_Update>;
};

export type Cms_MediaDocAccessFields_Folder_Create = {
  __typename?: 'CMS_MediaDocAccessFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Folder_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Folder_Read = {
  __typename?: 'CMS_MediaDocAccessFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Folder_Update = {
  __typename?: 'CMS_MediaDocAccessFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Height = {
  __typename?: 'CMS_MediaDocAccessFields_height';
  create?: Maybe<Cms_MediaDocAccessFields_Height_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Height_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Height_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Height_Update>;
};

export type Cms_MediaDocAccessFields_Height_Create = {
  __typename?: 'CMS_MediaDocAccessFields_height_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Height_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_height_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Height_Read = {
  __typename?: 'CMS_MediaDocAccessFields_height_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Height_Update = {
  __typename?: 'CMS_MediaDocAccessFields_height_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_MimeType = {
  __typename?: 'CMS_MediaDocAccessFields_mimeType';
  create?: Maybe<Cms_MediaDocAccessFields_MimeType_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_MimeType_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_MimeType_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_MimeType_Update>;
};

export type Cms_MediaDocAccessFields_MimeType_Create = {
  __typename?: 'CMS_MediaDocAccessFields_mimeType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_MimeType_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_mimeType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_MimeType_Read = {
  __typename?: 'CMS_MediaDocAccessFields_mimeType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_MimeType_Update = {
  __typename?: 'CMS_MediaDocAccessFields_mimeType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_ThumbnailUrl = {
  __typename?: 'CMS_MediaDocAccessFields_thumbnailURL';
  create?: Maybe<Cms_MediaDocAccessFields_ThumbnailUrl_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_ThumbnailUrl_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_ThumbnailUrl_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_ThumbnailUrl_Update>;
};

export type Cms_MediaDocAccessFields_ThumbnailUrl_Create = {
  __typename?: 'CMS_MediaDocAccessFields_thumbnailURL_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_ThumbnailUrl_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_thumbnailURL_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_ThumbnailUrl_Read = {
  __typename?: 'CMS_MediaDocAccessFields_thumbnailURL_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_ThumbnailUrl_Update = {
  __typename?: 'CMS_MediaDocAccessFields_thumbnailURL_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_MediaDocAccessFields_updatedAt';
  create?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Update>;
};

export type Cms_MediaDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_MediaDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_MediaDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_MediaDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Url = {
  __typename?: 'CMS_MediaDocAccessFields_url';
  create?: Maybe<Cms_MediaDocAccessFields_Url_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Url_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Url_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Url_Update>;
};

export type Cms_MediaDocAccessFields_Url_Create = {
  __typename?: 'CMS_MediaDocAccessFields_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Url_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Url_Read = {
  __typename?: 'CMS_MediaDocAccessFields_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Url_Update = {
  __typename?: 'CMS_MediaDocAccessFields_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Width = {
  __typename?: 'CMS_MediaDocAccessFields_width';
  create?: Maybe<Cms_MediaDocAccessFields_Width_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Width_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Width_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Width_Update>;
};

export type Cms_MediaDocAccessFields_Width_Create = {
  __typename?: 'CMS_MediaDocAccessFields_width_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Width_Delete = {
  __typename?: 'CMS_MediaDocAccessFields_width_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Width_Read = {
  __typename?: 'CMS_MediaDocAccessFields_width_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaDocAccessFields_Width_Update = {
  __typename?: 'CMS_MediaDocAccessFields_width_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields = {
  __typename?: 'CMS_MediaFields';
  alt?: Maybe<Cms_MediaFields_Alt>;
  createdAt?: Maybe<Cms_MediaFields_CreatedAt>;
  filename?: Maybe<Cms_MediaFields_Filename>;
  filesize?: Maybe<Cms_MediaFields_Filesize>;
  focalX?: Maybe<Cms_MediaFields_FocalX>;
  focalY?: Maybe<Cms_MediaFields_FocalY>;
  folder?: Maybe<Cms_MediaFields_Folder>;
  height?: Maybe<Cms_MediaFields_Height>;
  mimeType?: Maybe<Cms_MediaFields_MimeType>;
  thumbnailURL?: Maybe<Cms_MediaFields_ThumbnailUrl>;
  updatedAt?: Maybe<Cms_MediaFields_UpdatedAt>;
  url?: Maybe<Cms_MediaFields_Url>;
  width?: Maybe<Cms_MediaFields_Width>;
};

export type Cms_MediaFields_Alt = {
  __typename?: 'CMS_MediaFields_alt';
  create?: Maybe<Cms_MediaFields_Alt_Create>;
  delete?: Maybe<Cms_MediaFields_Alt_Delete>;
  read?: Maybe<Cms_MediaFields_Alt_Read>;
  update?: Maybe<Cms_MediaFields_Alt_Update>;
};

export type Cms_MediaFields_Alt_Create = {
  __typename?: 'CMS_MediaFields_alt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Alt_Delete = {
  __typename?: 'CMS_MediaFields_alt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Alt_Read = {
  __typename?: 'CMS_MediaFields_alt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Alt_Update = {
  __typename?: 'CMS_MediaFields_alt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_CreatedAt = {
  __typename?: 'CMS_MediaFields_createdAt';
  create?: Maybe<Cms_MediaFields_CreatedAt_Create>;
  delete?: Maybe<Cms_MediaFields_CreatedAt_Delete>;
  read?: Maybe<Cms_MediaFields_CreatedAt_Read>;
  update?: Maybe<Cms_MediaFields_CreatedAt_Update>;
};

export type Cms_MediaFields_CreatedAt_Create = {
  __typename?: 'CMS_MediaFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_CreatedAt_Delete = {
  __typename?: 'CMS_MediaFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_CreatedAt_Read = {
  __typename?: 'CMS_MediaFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_CreatedAt_Update = {
  __typename?: 'CMS_MediaFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filename = {
  __typename?: 'CMS_MediaFields_filename';
  create?: Maybe<Cms_MediaFields_Filename_Create>;
  delete?: Maybe<Cms_MediaFields_Filename_Delete>;
  read?: Maybe<Cms_MediaFields_Filename_Read>;
  update?: Maybe<Cms_MediaFields_Filename_Update>;
};

export type Cms_MediaFields_Filename_Create = {
  __typename?: 'CMS_MediaFields_filename_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filename_Delete = {
  __typename?: 'CMS_MediaFields_filename_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filename_Read = {
  __typename?: 'CMS_MediaFields_filename_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filename_Update = {
  __typename?: 'CMS_MediaFields_filename_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filesize = {
  __typename?: 'CMS_MediaFields_filesize';
  create?: Maybe<Cms_MediaFields_Filesize_Create>;
  delete?: Maybe<Cms_MediaFields_Filesize_Delete>;
  read?: Maybe<Cms_MediaFields_Filesize_Read>;
  update?: Maybe<Cms_MediaFields_Filesize_Update>;
};

export type Cms_MediaFields_Filesize_Create = {
  __typename?: 'CMS_MediaFields_filesize_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filesize_Delete = {
  __typename?: 'CMS_MediaFields_filesize_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filesize_Read = {
  __typename?: 'CMS_MediaFields_filesize_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Filesize_Update = {
  __typename?: 'CMS_MediaFields_filesize_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalX = {
  __typename?: 'CMS_MediaFields_focalX';
  create?: Maybe<Cms_MediaFields_FocalX_Create>;
  delete?: Maybe<Cms_MediaFields_FocalX_Delete>;
  read?: Maybe<Cms_MediaFields_FocalX_Read>;
  update?: Maybe<Cms_MediaFields_FocalX_Update>;
};

export type Cms_MediaFields_FocalX_Create = {
  __typename?: 'CMS_MediaFields_focalX_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalX_Delete = {
  __typename?: 'CMS_MediaFields_focalX_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalX_Read = {
  __typename?: 'CMS_MediaFields_focalX_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalX_Update = {
  __typename?: 'CMS_MediaFields_focalX_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalY = {
  __typename?: 'CMS_MediaFields_focalY';
  create?: Maybe<Cms_MediaFields_FocalY_Create>;
  delete?: Maybe<Cms_MediaFields_FocalY_Delete>;
  read?: Maybe<Cms_MediaFields_FocalY_Read>;
  update?: Maybe<Cms_MediaFields_FocalY_Update>;
};

export type Cms_MediaFields_FocalY_Create = {
  __typename?: 'CMS_MediaFields_focalY_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalY_Delete = {
  __typename?: 'CMS_MediaFields_focalY_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalY_Read = {
  __typename?: 'CMS_MediaFields_focalY_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_FocalY_Update = {
  __typename?: 'CMS_MediaFields_focalY_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Folder = {
  __typename?: 'CMS_MediaFields_folder';
  create?: Maybe<Cms_MediaFields_Folder_Create>;
  delete?: Maybe<Cms_MediaFields_Folder_Delete>;
  read?: Maybe<Cms_MediaFields_Folder_Read>;
  update?: Maybe<Cms_MediaFields_Folder_Update>;
};

export type Cms_MediaFields_Folder_Create = {
  __typename?: 'CMS_MediaFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Folder_Delete = {
  __typename?: 'CMS_MediaFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Folder_Read = {
  __typename?: 'CMS_MediaFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Folder_Update = {
  __typename?: 'CMS_MediaFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Height = {
  __typename?: 'CMS_MediaFields_height';
  create?: Maybe<Cms_MediaFields_Height_Create>;
  delete?: Maybe<Cms_MediaFields_Height_Delete>;
  read?: Maybe<Cms_MediaFields_Height_Read>;
  update?: Maybe<Cms_MediaFields_Height_Update>;
};

export type Cms_MediaFields_Height_Create = {
  __typename?: 'CMS_MediaFields_height_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Height_Delete = {
  __typename?: 'CMS_MediaFields_height_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Height_Read = {
  __typename?: 'CMS_MediaFields_height_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Height_Update = {
  __typename?: 'CMS_MediaFields_height_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_MimeType = {
  __typename?: 'CMS_MediaFields_mimeType';
  create?: Maybe<Cms_MediaFields_MimeType_Create>;
  delete?: Maybe<Cms_MediaFields_MimeType_Delete>;
  read?: Maybe<Cms_MediaFields_MimeType_Read>;
  update?: Maybe<Cms_MediaFields_MimeType_Update>;
};

export type Cms_MediaFields_MimeType_Create = {
  __typename?: 'CMS_MediaFields_mimeType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_MimeType_Delete = {
  __typename?: 'CMS_MediaFields_mimeType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_MimeType_Read = {
  __typename?: 'CMS_MediaFields_mimeType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_MimeType_Update = {
  __typename?: 'CMS_MediaFields_mimeType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_ThumbnailUrl = {
  __typename?: 'CMS_MediaFields_thumbnailURL';
  create?: Maybe<Cms_MediaFields_ThumbnailUrl_Create>;
  delete?: Maybe<Cms_MediaFields_ThumbnailUrl_Delete>;
  read?: Maybe<Cms_MediaFields_ThumbnailUrl_Read>;
  update?: Maybe<Cms_MediaFields_ThumbnailUrl_Update>;
};

export type Cms_MediaFields_ThumbnailUrl_Create = {
  __typename?: 'CMS_MediaFields_thumbnailURL_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_ThumbnailUrl_Delete = {
  __typename?: 'CMS_MediaFields_thumbnailURL_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_ThumbnailUrl_Read = {
  __typename?: 'CMS_MediaFields_thumbnailURL_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_ThumbnailUrl_Update = {
  __typename?: 'CMS_MediaFields_thumbnailURL_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_UpdatedAt = {
  __typename?: 'CMS_MediaFields_updatedAt';
  create?: Maybe<Cms_MediaFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_MediaFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_MediaFields_UpdatedAt_Read>;
  update?: Maybe<Cms_MediaFields_UpdatedAt_Update>;
};

export type Cms_MediaFields_UpdatedAt_Create = {
  __typename?: 'CMS_MediaFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_UpdatedAt_Delete = {
  __typename?: 'CMS_MediaFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_UpdatedAt_Read = {
  __typename?: 'CMS_MediaFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_UpdatedAt_Update = {
  __typename?: 'CMS_MediaFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Url = {
  __typename?: 'CMS_MediaFields_url';
  create?: Maybe<Cms_MediaFields_Url_Create>;
  delete?: Maybe<Cms_MediaFields_Url_Delete>;
  read?: Maybe<Cms_MediaFields_Url_Read>;
  update?: Maybe<Cms_MediaFields_Url_Update>;
};

export type Cms_MediaFields_Url_Create = {
  __typename?: 'CMS_MediaFields_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Url_Delete = {
  __typename?: 'CMS_MediaFields_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Url_Read = {
  __typename?: 'CMS_MediaFields_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Url_Update = {
  __typename?: 'CMS_MediaFields_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Width = {
  __typename?: 'CMS_MediaFields_width';
  create?: Maybe<Cms_MediaFields_Width_Create>;
  delete?: Maybe<Cms_MediaFields_Width_Delete>;
  read?: Maybe<Cms_MediaFields_Width_Read>;
  update?: Maybe<Cms_MediaFields_Width_Update>;
};

export type Cms_MediaFields_Width_Create = {
  __typename?: 'CMS_MediaFields_width_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Width_Delete = {
  __typename?: 'CMS_MediaFields_width_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Width_Read = {
  __typename?: 'CMS_MediaFields_width_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaFields_Width_Update = {
  __typename?: 'CMS_MediaFields_width_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_MediaReadAccess = {
  __typename?: 'CMS_MediaReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaReadDocAccess = {
  __typename?: 'CMS_MediaReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaUpdateAccess = {
  __typename?: 'CMS_MediaUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_MediaUpdateDocAccess = {
  __typename?: 'CMS_MediaUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_Media_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Media_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Media_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Media_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_Media_FocalX_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_Media_FocalY_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_Media_Folder_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Media_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_Media_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Media_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Media_ThumbnailUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Media_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Media_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Media_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  focalX?: InputMaybe<Cms_Media_FocalX_Operator>;
  focalY?: InputMaybe<Cms_Media_FocalY_Operator>;
  folder?: InputMaybe<Cms_Media_Folder_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  thumbnailURL?: InputMaybe<Cms_Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  focalX?: InputMaybe<Cms_Media_FocalX_Operator>;
  focalY?: InputMaybe<Cms_Media_FocalY_Operator>;
  folder?: InputMaybe<Cms_Media_Folder_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  thumbnailURL?: InputMaybe<Cms_Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  focalX?: InputMaybe<Cms_Media_FocalX_Operator>;
  focalY?: InputMaybe<Cms_Media_FocalY_Operator>;
  folder?: InputMaybe<Cms_Media_Folder_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  thumbnailURL?: InputMaybe<Cms_Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_Page = {
  __typename?: 'CMS_Page';
  _status?: Maybe<Cms_Page__Status>;
  breadcrumbs?: Maybe<Array<Cms_Page_Breadcrumbs>>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Cms_User>;
  folder?: Maybe<Cms_PayloadFolder>;
  generateSlug?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  layout: Array<Cms_Page_Layout>;
  meta?: Maybe<Cms_Page_Meta>;
  parent?: Maybe<Cms_Page>;
  path?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Cms_Tenant>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Cms_User>;
};


export type Cms_PageParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PageVersion = {
  __typename?: 'CMS_PageVersion';
  autosave?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latest?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Cms_Page>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Cms_PageVersion_Version>;
};


export type Cms_PageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PageVersion_Version = {
  __typename?: 'CMS_PageVersion_Version';
  _status?: Maybe<Cms_PageVersion_Version__Status>;
  breadcrumbs?: Maybe<Array<Cms_PageVersion_Version_Breadcrumbs>>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Cms_User>;
  folder?: Maybe<Cms_PayloadFolder>;
  generateSlug?: Maybe<Scalars['Boolean']['output']>;
  layout: Array<Cms_PageVersion_Version_Layout>;
  meta?: Maybe<Cms_PageVersion_Version_Meta>;
  parent?: Maybe<Cms_Page>;
  path?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Cms_Tenant>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Cms_User>;
};


export type Cms_PageVersion_VersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PageVersion_Version_Breadcrumbs = {
  __typename?: 'CMS_PageVersion_Version_Breadcrumbs';
  doc?: Maybe<Cms_Page>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type Cms_PageVersion_Version_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PageVersion_Version_Layout = Cms_BrandsSliderBlock | Cms_CalloutBlock | Cms_CatalogListBlock | Cms_CategoryLinkListBlock | Cms_ColumnsBlock | Cms_FormBlock | Cms_FullImageCardBlock | Cms_HeroBannerBlock | Cms_InnerHtmlBlock | Cms_PhoneCallbackBannerBlock | Cms_PictureBlock | Cms_QuoteBlock | Cms_SectionHeaderBlock | Cms_SimpleTableBlock | Cms_SkinBlock | Cms_TwoColumnsImageBlock | Cms_VideoPlayerBlock;

export type Cms_PageVersion_Version_Meta = {
  __typename?: 'CMS_PageVersion_Version_Meta';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum Cms_PageVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_Page_Breadcrumbs = {
  __typename?: 'CMS_Page_Breadcrumbs';
  doc?: Maybe<Cms_Page>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type Cms_Page_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_Page_Layout = Cms_BrandsSliderBlock | Cms_CalloutBlock | Cms_CatalogListBlock | Cms_CategoryLinkListBlock | Cms_ColumnsBlock | Cms_FormBlock | Cms_FullImageCardBlock | Cms_HeroBannerBlock | Cms_InnerHtmlBlock | Cms_PhoneCallbackBannerBlock | Cms_PictureBlock | Cms_QuoteBlock | Cms_SectionHeaderBlock | Cms_SimpleTableBlock | Cms_SkinBlock | Cms_TwoColumnsImageBlock | Cms_VideoPlayerBlock;

export type Cms_Page_Meta = {
  __typename?: 'CMS_Page_Meta';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum Cms_Page__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_Page__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_Page__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
  equals?: InputMaybe<Cms_Page__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
  not_equals?: InputMaybe<Cms_Page__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
};

export type Cms_Page_Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_CanonicalUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Page_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Folder_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_GenerateSlug_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_Page_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Page_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_Page_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Path_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Page_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_Subtitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Page_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Page_UpdatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_Page_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  canonicalUrl?: InputMaybe<Cms_Page_CanonicalUrl_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  createdBy?: InputMaybe<Cms_Page_CreatedBy_Operator>;
  folder?: InputMaybe<Cms_Page_Folder_Operator>;
  generateSlug?: InputMaybe<Cms_Page_GenerateSlug_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Cms_Page_Meta__Image_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  path?: InputMaybe<Cms_Page_Path_Operator>;
  publishedAt?: InputMaybe<Cms_Page_PublishedAt_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  subtitle?: InputMaybe<Cms_Page_Subtitle_Operator>;
  tenant?: InputMaybe<Cms_Page_Tenant_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
  updatedBy?: InputMaybe<Cms_Page_UpdatedBy_Operator>;
};

export type Cms_Page_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  canonicalUrl?: InputMaybe<Cms_Page_CanonicalUrl_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  createdBy?: InputMaybe<Cms_Page_CreatedBy_Operator>;
  folder?: InputMaybe<Cms_Page_Folder_Operator>;
  generateSlug?: InputMaybe<Cms_Page_GenerateSlug_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Cms_Page_Meta__Image_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  path?: InputMaybe<Cms_Page_Path_Operator>;
  publishedAt?: InputMaybe<Cms_Page_PublishedAt_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  subtitle?: InputMaybe<Cms_Page_Subtitle_Operator>;
  tenant?: InputMaybe<Cms_Page_Tenant_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
  updatedBy?: InputMaybe<Cms_Page_UpdatedBy_Operator>;
};

export type Cms_Page_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  canonicalUrl?: InputMaybe<Cms_Page_CanonicalUrl_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  createdBy?: InputMaybe<Cms_Page_CreatedBy_Operator>;
  folder?: InputMaybe<Cms_Page_Folder_Operator>;
  generateSlug?: InputMaybe<Cms_Page_GenerateSlug_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Cms_Page_Meta__Image_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  path?: InputMaybe<Cms_Page_Path_Operator>;
  publishedAt?: InputMaybe<Cms_Page_PublishedAt_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  subtitle?: InputMaybe<Cms_Page_Subtitle_Operator>;
  tenant?: InputMaybe<Cms_Page_Tenant_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
  updatedBy?: InputMaybe<Cms_Page_UpdatedBy_Operator>;
};

export type Cms_Pages = {
  __typename?: 'CMS_Pages';
  docs: Array<Cms_Page>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PagesCreateAccess = {
  __typename?: 'CMS_PagesCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesCreateDocAccess = {
  __typename?: 'CMS_PagesCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesDeleteAccess = {
  __typename?: 'CMS_PagesDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesDeleteDocAccess = {
  __typename?: 'CMS_PagesDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesDocAccessFields = {
  __typename?: 'CMS_PagesDocAccessFields';
  _status?: Maybe<Cms_PagesDocAccessFields__Status>;
  breadcrumbs?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs>;
  canonicalUrl?: Maybe<Cms_PagesDocAccessFields_CanonicalUrl>;
  createdAt?: Maybe<Cms_PagesDocAccessFields_CreatedAt>;
  createdBy?: Maybe<Cms_PagesDocAccessFields_CreatedBy>;
  folder?: Maybe<Cms_PagesDocAccessFields_Folder>;
  generateSlug?: Maybe<Cms_PagesDocAccessFields_GenerateSlug>;
  layout?: Maybe<Cms_PagesDocAccessFields_Layout>;
  meta?: Maybe<Cms_PagesDocAccessFields_Meta>;
  parent?: Maybe<Cms_PagesDocAccessFields_Parent>;
  path?: Maybe<Cms_PagesDocAccessFields_Path>;
  publishedAt?: Maybe<Cms_PagesDocAccessFields_PublishedAt>;
  slug?: Maybe<Cms_PagesDocAccessFields_Slug>;
  subtitle?: Maybe<Cms_PagesDocAccessFields_Subtitle>;
  tenant?: Maybe<Cms_PagesDocAccessFields_Tenant>;
  title?: Maybe<Cms_PagesDocAccessFields_Title>;
  updatedAt?: Maybe<Cms_PagesDocAccessFields_UpdatedAt>;
  updatedBy?: Maybe<Cms_PagesDocAccessFields_UpdatedBy>;
};

export type Cms_PagesDocAccessFields__Status = {
  __typename?: 'CMS_PagesDocAccessFields__status';
  create?: Maybe<Cms_PagesDocAccessFields__Status_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields__Status_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields__Status_Read>;
  update?: Maybe<Cms_PagesDocAccessFields__Status_Update>;
};

export type Cms_PagesDocAccessFields__Status_Create = {
  __typename?: 'CMS_PagesDocAccessFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields__Status_Delete = {
  __typename?: 'CMS_PagesDocAccessFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields__Status_Read = {
  __typename?: 'CMS_PagesDocAccessFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields__Status_Update = {
  __typename?: 'CMS_PagesDocAccessFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs';
  create?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Delete>;
  fields?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Fields>;
  read?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Update>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Create = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Fields = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_Fields';
  doc?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Doc>;
  id?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Id>;
  label?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Label>;
  url?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Url>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Read = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Update = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Doc = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_doc';
  create?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Doc_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Doc_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Doc_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Doc_Update>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Doc_Create = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_doc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_doc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Doc_Read = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_doc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Doc_Update = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_doc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Id = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_id';
  create?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Id_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Id_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Id_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Id_Update>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Id_Create = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Id_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Id_Read = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Id_Update = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Label = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_label';
  create?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Label_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Label_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Label_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Label_Update>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Label_Create = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_label_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Label_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_label_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Label_Read = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_label_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Label_Update = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_label_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Url = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_url';
  create?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Url_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Url_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Url_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Breadcrumbs_Url_Update>;
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Url_Create = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Url_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Url_Read = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Breadcrumbs_Url_Update = {
  __typename?: 'CMS_PagesDocAccessFields_breadcrumbs_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CanonicalUrl = {
  __typename?: 'CMS_PagesDocAccessFields_canonicalUrl';
  create?: Maybe<Cms_PagesDocAccessFields_CanonicalUrl_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_CanonicalUrl_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_CanonicalUrl_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_CanonicalUrl_Update>;
};

export type Cms_PagesDocAccessFields_CanonicalUrl_Create = {
  __typename?: 'CMS_PagesDocAccessFields_canonicalUrl_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CanonicalUrl_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_canonicalUrl_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CanonicalUrl_Read = {
  __typename?: 'CMS_PagesDocAccessFields_canonicalUrl_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CanonicalUrl_Update = {
  __typename?: 'CMS_PagesDocAccessFields_canonicalUrl_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedAt = {
  __typename?: 'CMS_PagesDocAccessFields_createdAt';
  create?: Maybe<Cms_PagesDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_CreatedAt_Update>;
};

export type Cms_PagesDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_PagesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_PagesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_PagesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedBy = {
  __typename?: 'CMS_PagesDocAccessFields_createdBy';
  create?: Maybe<Cms_PagesDocAccessFields_CreatedBy_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_CreatedBy_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_CreatedBy_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_CreatedBy_Update>;
};

export type Cms_PagesDocAccessFields_CreatedBy_Create = {
  __typename?: 'CMS_PagesDocAccessFields_createdBy_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedBy_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_createdBy_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedBy_Read = {
  __typename?: 'CMS_PagesDocAccessFields_createdBy_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_CreatedBy_Update = {
  __typename?: 'CMS_PagesDocAccessFields_createdBy_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Folder = {
  __typename?: 'CMS_PagesDocAccessFields_folder';
  create?: Maybe<Cms_PagesDocAccessFields_Folder_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Folder_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Folder_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Folder_Update>;
};

export type Cms_PagesDocAccessFields_Folder_Create = {
  __typename?: 'CMS_PagesDocAccessFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Folder_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Folder_Read = {
  __typename?: 'CMS_PagesDocAccessFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Folder_Update = {
  __typename?: 'CMS_PagesDocAccessFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_GenerateSlug = {
  __typename?: 'CMS_PagesDocAccessFields_generateSlug';
  create?: Maybe<Cms_PagesDocAccessFields_GenerateSlug_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_GenerateSlug_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_GenerateSlug_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_GenerateSlug_Update>;
};

export type Cms_PagesDocAccessFields_GenerateSlug_Create = {
  __typename?: 'CMS_PagesDocAccessFields_generateSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_GenerateSlug_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_generateSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_GenerateSlug_Read = {
  __typename?: 'CMS_PagesDocAccessFields_generateSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_GenerateSlug_Update = {
  __typename?: 'CMS_PagesDocAccessFields_generateSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Layout = {
  __typename?: 'CMS_PagesDocAccessFields_layout';
  create?: Maybe<Cms_PagesDocAccessFields_Layout_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Layout_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Layout_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Layout_Update>;
};

export type Cms_PagesDocAccessFields_Layout_Create = {
  __typename?: 'CMS_PagesDocAccessFields_layout_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Layout_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_layout_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Layout_Read = {
  __typename?: 'CMS_PagesDocAccessFields_layout_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Layout_Update = {
  __typename?: 'CMS_PagesDocAccessFields_layout_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta = {
  __typename?: 'CMS_PagesDocAccessFields_meta';
  create?: Maybe<Cms_PagesDocAccessFields_Meta_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Meta_Delete>;
  fields?: Maybe<Cms_PagesDocAccessFields_Meta_Fields>;
  read?: Maybe<Cms_PagesDocAccessFields_Meta_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Meta_Update>;
};

export type Cms_PagesDocAccessFields_Meta_Create = {
  __typename?: 'CMS_PagesDocAccessFields_meta_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_meta_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Fields = {
  __typename?: 'CMS_PagesDocAccessFields_meta_Fields';
  description?: Maybe<Cms_PagesDocAccessFields_Meta_Description>;
  image?: Maybe<Cms_PagesDocAccessFields_Meta_Image>;
  title?: Maybe<Cms_PagesDocAccessFields_Meta_Title>;
};

export type Cms_PagesDocAccessFields_Meta_Read = {
  __typename?: 'CMS_PagesDocAccessFields_meta_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Update = {
  __typename?: 'CMS_PagesDocAccessFields_meta_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Description = {
  __typename?: 'CMS_PagesDocAccessFields_meta_description';
  create?: Maybe<Cms_PagesDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Meta_Description_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Meta_Description_Update>;
};

export type Cms_PagesDocAccessFields_Meta_Description_Create = {
  __typename?: 'CMS_PagesDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Description_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Description_Read = {
  __typename?: 'CMS_PagesDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Description_Update = {
  __typename?: 'CMS_PagesDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Image = {
  __typename?: 'CMS_PagesDocAccessFields_meta_image';
  create?: Maybe<Cms_PagesDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Meta_Image_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Meta_Image_Update>;
};

export type Cms_PagesDocAccessFields_Meta_Image_Create = {
  __typename?: 'CMS_PagesDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Image_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Image_Read = {
  __typename?: 'CMS_PagesDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Image_Update = {
  __typename?: 'CMS_PagesDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Title = {
  __typename?: 'CMS_PagesDocAccessFields_meta_title';
  create?: Maybe<Cms_PagesDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Meta_Title_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Meta_Title_Update>;
};

export type Cms_PagesDocAccessFields_Meta_Title_Create = {
  __typename?: 'CMS_PagesDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Title_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Title_Read = {
  __typename?: 'CMS_PagesDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Meta_Title_Update = {
  __typename?: 'CMS_PagesDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Parent = {
  __typename?: 'CMS_PagesDocAccessFields_parent';
  create?: Maybe<Cms_PagesDocAccessFields_Parent_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Parent_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Parent_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Parent_Update>;
};

export type Cms_PagesDocAccessFields_Parent_Create = {
  __typename?: 'CMS_PagesDocAccessFields_parent_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Parent_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_parent_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Parent_Read = {
  __typename?: 'CMS_PagesDocAccessFields_parent_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Parent_Update = {
  __typename?: 'CMS_PagesDocAccessFields_parent_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Path = {
  __typename?: 'CMS_PagesDocAccessFields_path';
  create?: Maybe<Cms_PagesDocAccessFields_Path_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Path_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Path_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Path_Update>;
};

export type Cms_PagesDocAccessFields_Path_Create = {
  __typename?: 'CMS_PagesDocAccessFields_path_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Path_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_path_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Path_Read = {
  __typename?: 'CMS_PagesDocAccessFields_path_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Path_Update = {
  __typename?: 'CMS_PagesDocAccessFields_path_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_PublishedAt = {
  __typename?: 'CMS_PagesDocAccessFields_publishedAt';
  create?: Maybe<Cms_PagesDocAccessFields_PublishedAt_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_PublishedAt_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_PublishedAt_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_PublishedAt_Update>;
};

export type Cms_PagesDocAccessFields_PublishedAt_Create = {
  __typename?: 'CMS_PagesDocAccessFields_publishedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_PublishedAt_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_publishedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_PublishedAt_Read = {
  __typename?: 'CMS_PagesDocAccessFields_publishedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_PublishedAt_Update = {
  __typename?: 'CMS_PagesDocAccessFields_publishedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Slug = {
  __typename?: 'CMS_PagesDocAccessFields_slug';
  create?: Maybe<Cms_PagesDocAccessFields_Slug_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Slug_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Slug_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Slug_Update>;
};

export type Cms_PagesDocAccessFields_Slug_Create = {
  __typename?: 'CMS_PagesDocAccessFields_slug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Slug_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_slug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Slug_Read = {
  __typename?: 'CMS_PagesDocAccessFields_slug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Slug_Update = {
  __typename?: 'CMS_PagesDocAccessFields_slug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Subtitle = {
  __typename?: 'CMS_PagesDocAccessFields_subtitle';
  create?: Maybe<Cms_PagesDocAccessFields_Subtitle_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Subtitle_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Subtitle_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Subtitle_Update>;
};

export type Cms_PagesDocAccessFields_Subtitle_Create = {
  __typename?: 'CMS_PagesDocAccessFields_subtitle_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Subtitle_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_subtitle_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Subtitle_Read = {
  __typename?: 'CMS_PagesDocAccessFields_subtitle_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Subtitle_Update = {
  __typename?: 'CMS_PagesDocAccessFields_subtitle_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Tenant = {
  __typename?: 'CMS_PagesDocAccessFields_tenant';
  create?: Maybe<Cms_PagesDocAccessFields_Tenant_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Tenant_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Tenant_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Tenant_Update>;
};

export type Cms_PagesDocAccessFields_Tenant_Create = {
  __typename?: 'CMS_PagesDocAccessFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Tenant_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Tenant_Read = {
  __typename?: 'CMS_PagesDocAccessFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Tenant_Update = {
  __typename?: 'CMS_PagesDocAccessFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Title = {
  __typename?: 'CMS_PagesDocAccessFields_title';
  create?: Maybe<Cms_PagesDocAccessFields_Title_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_Title_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_Title_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_Title_Update>;
};

export type Cms_PagesDocAccessFields_Title_Create = {
  __typename?: 'CMS_PagesDocAccessFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Title_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Title_Read = {
  __typename?: 'CMS_PagesDocAccessFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_Title_Update = {
  __typename?: 'CMS_PagesDocAccessFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_PagesDocAccessFields_updatedAt';
  create?: Maybe<Cms_PagesDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PagesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_PagesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_PagesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_PagesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedBy = {
  __typename?: 'CMS_PagesDocAccessFields_updatedBy';
  create?: Maybe<Cms_PagesDocAccessFields_UpdatedBy_Create>;
  delete?: Maybe<Cms_PagesDocAccessFields_UpdatedBy_Delete>;
  read?: Maybe<Cms_PagesDocAccessFields_UpdatedBy_Read>;
  update?: Maybe<Cms_PagesDocAccessFields_UpdatedBy_Update>;
};

export type Cms_PagesDocAccessFields_UpdatedBy_Create = {
  __typename?: 'CMS_PagesDocAccessFields_updatedBy_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedBy_Delete = {
  __typename?: 'CMS_PagesDocAccessFields_updatedBy_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedBy_Read = {
  __typename?: 'CMS_PagesDocAccessFields_updatedBy_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesDocAccessFields_UpdatedBy_Update = {
  __typename?: 'CMS_PagesDocAccessFields_updatedBy_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields = {
  __typename?: 'CMS_PagesFields';
  _status?: Maybe<Cms_PagesFields__Status>;
  breadcrumbs?: Maybe<Cms_PagesFields_Breadcrumbs>;
  canonicalUrl?: Maybe<Cms_PagesFields_CanonicalUrl>;
  createdAt?: Maybe<Cms_PagesFields_CreatedAt>;
  createdBy?: Maybe<Cms_PagesFields_CreatedBy>;
  folder?: Maybe<Cms_PagesFields_Folder>;
  generateSlug?: Maybe<Cms_PagesFields_GenerateSlug>;
  layout?: Maybe<Cms_PagesFields_Layout>;
  meta?: Maybe<Cms_PagesFields_Meta>;
  parent?: Maybe<Cms_PagesFields_Parent>;
  path?: Maybe<Cms_PagesFields_Path>;
  publishedAt?: Maybe<Cms_PagesFields_PublishedAt>;
  slug?: Maybe<Cms_PagesFields_Slug>;
  subtitle?: Maybe<Cms_PagesFields_Subtitle>;
  tenant?: Maybe<Cms_PagesFields_Tenant>;
  title?: Maybe<Cms_PagesFields_Title>;
  updatedAt?: Maybe<Cms_PagesFields_UpdatedAt>;
  updatedBy?: Maybe<Cms_PagesFields_UpdatedBy>;
};

export type Cms_PagesFields__Status = {
  __typename?: 'CMS_PagesFields__status';
  create?: Maybe<Cms_PagesFields__Status_Create>;
  delete?: Maybe<Cms_PagesFields__Status_Delete>;
  read?: Maybe<Cms_PagesFields__Status_Read>;
  update?: Maybe<Cms_PagesFields__Status_Update>;
};

export type Cms_PagesFields__Status_Create = {
  __typename?: 'CMS_PagesFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields__Status_Delete = {
  __typename?: 'CMS_PagesFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields__Status_Read = {
  __typename?: 'CMS_PagesFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields__Status_Update = {
  __typename?: 'CMS_PagesFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs = {
  __typename?: 'CMS_PagesFields_breadcrumbs';
  create?: Maybe<Cms_PagesFields_Breadcrumbs_Create>;
  delete?: Maybe<Cms_PagesFields_Breadcrumbs_Delete>;
  fields?: Maybe<Cms_PagesFields_Breadcrumbs_Fields>;
  read?: Maybe<Cms_PagesFields_Breadcrumbs_Read>;
  update?: Maybe<Cms_PagesFields_Breadcrumbs_Update>;
};

export type Cms_PagesFields_Breadcrumbs_Create = {
  __typename?: 'CMS_PagesFields_breadcrumbs_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Delete = {
  __typename?: 'CMS_PagesFields_breadcrumbs_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Fields = {
  __typename?: 'CMS_PagesFields_breadcrumbs_Fields';
  doc?: Maybe<Cms_PagesFields_Breadcrumbs_Doc>;
  id?: Maybe<Cms_PagesFields_Breadcrumbs_Id>;
  label?: Maybe<Cms_PagesFields_Breadcrumbs_Label>;
  url?: Maybe<Cms_PagesFields_Breadcrumbs_Url>;
};

export type Cms_PagesFields_Breadcrumbs_Read = {
  __typename?: 'CMS_PagesFields_breadcrumbs_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Update = {
  __typename?: 'CMS_PagesFields_breadcrumbs_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Doc = {
  __typename?: 'CMS_PagesFields_breadcrumbs_doc';
  create?: Maybe<Cms_PagesFields_Breadcrumbs_Doc_Create>;
  delete?: Maybe<Cms_PagesFields_Breadcrumbs_Doc_Delete>;
  read?: Maybe<Cms_PagesFields_Breadcrumbs_Doc_Read>;
  update?: Maybe<Cms_PagesFields_Breadcrumbs_Doc_Update>;
};

export type Cms_PagesFields_Breadcrumbs_Doc_Create = {
  __typename?: 'CMS_PagesFields_breadcrumbs_doc_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'CMS_PagesFields_breadcrumbs_doc_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Doc_Read = {
  __typename?: 'CMS_PagesFields_breadcrumbs_doc_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Doc_Update = {
  __typename?: 'CMS_PagesFields_breadcrumbs_doc_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Id = {
  __typename?: 'CMS_PagesFields_breadcrumbs_id';
  create?: Maybe<Cms_PagesFields_Breadcrumbs_Id_Create>;
  delete?: Maybe<Cms_PagesFields_Breadcrumbs_Id_Delete>;
  read?: Maybe<Cms_PagesFields_Breadcrumbs_Id_Read>;
  update?: Maybe<Cms_PagesFields_Breadcrumbs_Id_Update>;
};

export type Cms_PagesFields_Breadcrumbs_Id_Create = {
  __typename?: 'CMS_PagesFields_breadcrumbs_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Id_Delete = {
  __typename?: 'CMS_PagesFields_breadcrumbs_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Id_Read = {
  __typename?: 'CMS_PagesFields_breadcrumbs_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Id_Update = {
  __typename?: 'CMS_PagesFields_breadcrumbs_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Label = {
  __typename?: 'CMS_PagesFields_breadcrumbs_label';
  create?: Maybe<Cms_PagesFields_Breadcrumbs_Label_Create>;
  delete?: Maybe<Cms_PagesFields_Breadcrumbs_Label_Delete>;
  read?: Maybe<Cms_PagesFields_Breadcrumbs_Label_Read>;
  update?: Maybe<Cms_PagesFields_Breadcrumbs_Label_Update>;
};

export type Cms_PagesFields_Breadcrumbs_Label_Create = {
  __typename?: 'CMS_PagesFields_breadcrumbs_label_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Label_Delete = {
  __typename?: 'CMS_PagesFields_breadcrumbs_label_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Label_Read = {
  __typename?: 'CMS_PagesFields_breadcrumbs_label_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Label_Update = {
  __typename?: 'CMS_PagesFields_breadcrumbs_label_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Url = {
  __typename?: 'CMS_PagesFields_breadcrumbs_url';
  create?: Maybe<Cms_PagesFields_Breadcrumbs_Url_Create>;
  delete?: Maybe<Cms_PagesFields_Breadcrumbs_Url_Delete>;
  read?: Maybe<Cms_PagesFields_Breadcrumbs_Url_Read>;
  update?: Maybe<Cms_PagesFields_Breadcrumbs_Url_Update>;
};

export type Cms_PagesFields_Breadcrumbs_Url_Create = {
  __typename?: 'CMS_PagesFields_breadcrumbs_url_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Url_Delete = {
  __typename?: 'CMS_PagesFields_breadcrumbs_url_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Url_Read = {
  __typename?: 'CMS_PagesFields_breadcrumbs_url_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Breadcrumbs_Url_Update = {
  __typename?: 'CMS_PagesFields_breadcrumbs_url_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CanonicalUrl = {
  __typename?: 'CMS_PagesFields_canonicalUrl';
  create?: Maybe<Cms_PagesFields_CanonicalUrl_Create>;
  delete?: Maybe<Cms_PagesFields_CanonicalUrl_Delete>;
  read?: Maybe<Cms_PagesFields_CanonicalUrl_Read>;
  update?: Maybe<Cms_PagesFields_CanonicalUrl_Update>;
};

export type Cms_PagesFields_CanonicalUrl_Create = {
  __typename?: 'CMS_PagesFields_canonicalUrl_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CanonicalUrl_Delete = {
  __typename?: 'CMS_PagesFields_canonicalUrl_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CanonicalUrl_Read = {
  __typename?: 'CMS_PagesFields_canonicalUrl_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CanonicalUrl_Update = {
  __typename?: 'CMS_PagesFields_canonicalUrl_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedAt = {
  __typename?: 'CMS_PagesFields_createdAt';
  create?: Maybe<Cms_PagesFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PagesFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PagesFields_CreatedAt_Read>;
  update?: Maybe<Cms_PagesFields_CreatedAt_Update>;
};

export type Cms_PagesFields_CreatedAt_Create = {
  __typename?: 'CMS_PagesFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedAt_Delete = {
  __typename?: 'CMS_PagesFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedAt_Read = {
  __typename?: 'CMS_PagesFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedAt_Update = {
  __typename?: 'CMS_PagesFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedBy = {
  __typename?: 'CMS_PagesFields_createdBy';
  create?: Maybe<Cms_PagesFields_CreatedBy_Create>;
  delete?: Maybe<Cms_PagesFields_CreatedBy_Delete>;
  read?: Maybe<Cms_PagesFields_CreatedBy_Read>;
  update?: Maybe<Cms_PagesFields_CreatedBy_Update>;
};

export type Cms_PagesFields_CreatedBy_Create = {
  __typename?: 'CMS_PagesFields_createdBy_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedBy_Delete = {
  __typename?: 'CMS_PagesFields_createdBy_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedBy_Read = {
  __typename?: 'CMS_PagesFields_createdBy_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_CreatedBy_Update = {
  __typename?: 'CMS_PagesFields_createdBy_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Folder = {
  __typename?: 'CMS_PagesFields_folder';
  create?: Maybe<Cms_PagesFields_Folder_Create>;
  delete?: Maybe<Cms_PagesFields_Folder_Delete>;
  read?: Maybe<Cms_PagesFields_Folder_Read>;
  update?: Maybe<Cms_PagesFields_Folder_Update>;
};

export type Cms_PagesFields_Folder_Create = {
  __typename?: 'CMS_PagesFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Folder_Delete = {
  __typename?: 'CMS_PagesFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Folder_Read = {
  __typename?: 'CMS_PagesFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Folder_Update = {
  __typename?: 'CMS_PagesFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_GenerateSlug = {
  __typename?: 'CMS_PagesFields_generateSlug';
  create?: Maybe<Cms_PagesFields_GenerateSlug_Create>;
  delete?: Maybe<Cms_PagesFields_GenerateSlug_Delete>;
  read?: Maybe<Cms_PagesFields_GenerateSlug_Read>;
  update?: Maybe<Cms_PagesFields_GenerateSlug_Update>;
};

export type Cms_PagesFields_GenerateSlug_Create = {
  __typename?: 'CMS_PagesFields_generateSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_GenerateSlug_Delete = {
  __typename?: 'CMS_PagesFields_generateSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_GenerateSlug_Read = {
  __typename?: 'CMS_PagesFields_generateSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_GenerateSlug_Update = {
  __typename?: 'CMS_PagesFields_generateSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Layout = {
  __typename?: 'CMS_PagesFields_layout';
  create?: Maybe<Cms_PagesFields_Layout_Create>;
  delete?: Maybe<Cms_PagesFields_Layout_Delete>;
  read?: Maybe<Cms_PagesFields_Layout_Read>;
  update?: Maybe<Cms_PagesFields_Layout_Update>;
};

export type Cms_PagesFields_Layout_Create = {
  __typename?: 'CMS_PagesFields_layout_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Layout_Delete = {
  __typename?: 'CMS_PagesFields_layout_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Layout_Read = {
  __typename?: 'CMS_PagesFields_layout_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Layout_Update = {
  __typename?: 'CMS_PagesFields_layout_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta = {
  __typename?: 'CMS_PagesFields_meta';
  create?: Maybe<Cms_PagesFields_Meta_Create>;
  delete?: Maybe<Cms_PagesFields_Meta_Delete>;
  fields?: Maybe<Cms_PagesFields_Meta_Fields>;
  read?: Maybe<Cms_PagesFields_Meta_Read>;
  update?: Maybe<Cms_PagesFields_Meta_Update>;
};

export type Cms_PagesFields_Meta_Create = {
  __typename?: 'CMS_PagesFields_meta_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Delete = {
  __typename?: 'CMS_PagesFields_meta_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Fields = {
  __typename?: 'CMS_PagesFields_meta_Fields';
  description?: Maybe<Cms_PagesFields_Meta_Description>;
  image?: Maybe<Cms_PagesFields_Meta_Image>;
  title?: Maybe<Cms_PagesFields_Meta_Title>;
};

export type Cms_PagesFields_Meta_Read = {
  __typename?: 'CMS_PagesFields_meta_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Update = {
  __typename?: 'CMS_PagesFields_meta_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Description = {
  __typename?: 'CMS_PagesFields_meta_description';
  create?: Maybe<Cms_PagesFields_Meta_Description_Create>;
  delete?: Maybe<Cms_PagesFields_Meta_Description_Delete>;
  read?: Maybe<Cms_PagesFields_Meta_Description_Read>;
  update?: Maybe<Cms_PagesFields_Meta_Description_Update>;
};

export type Cms_PagesFields_Meta_Description_Create = {
  __typename?: 'CMS_PagesFields_meta_description_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Description_Delete = {
  __typename?: 'CMS_PagesFields_meta_description_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Description_Read = {
  __typename?: 'CMS_PagesFields_meta_description_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Description_Update = {
  __typename?: 'CMS_PagesFields_meta_description_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Image = {
  __typename?: 'CMS_PagesFields_meta_image';
  create?: Maybe<Cms_PagesFields_Meta_Image_Create>;
  delete?: Maybe<Cms_PagesFields_Meta_Image_Delete>;
  read?: Maybe<Cms_PagesFields_Meta_Image_Read>;
  update?: Maybe<Cms_PagesFields_Meta_Image_Update>;
};

export type Cms_PagesFields_Meta_Image_Create = {
  __typename?: 'CMS_PagesFields_meta_image_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Image_Delete = {
  __typename?: 'CMS_PagesFields_meta_image_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Image_Read = {
  __typename?: 'CMS_PagesFields_meta_image_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Image_Update = {
  __typename?: 'CMS_PagesFields_meta_image_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Title = {
  __typename?: 'CMS_PagesFields_meta_title';
  create?: Maybe<Cms_PagesFields_Meta_Title_Create>;
  delete?: Maybe<Cms_PagesFields_Meta_Title_Delete>;
  read?: Maybe<Cms_PagesFields_Meta_Title_Read>;
  update?: Maybe<Cms_PagesFields_Meta_Title_Update>;
};

export type Cms_PagesFields_Meta_Title_Create = {
  __typename?: 'CMS_PagesFields_meta_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Title_Delete = {
  __typename?: 'CMS_PagesFields_meta_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Title_Read = {
  __typename?: 'CMS_PagesFields_meta_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Meta_Title_Update = {
  __typename?: 'CMS_PagesFields_meta_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Parent = {
  __typename?: 'CMS_PagesFields_parent';
  create?: Maybe<Cms_PagesFields_Parent_Create>;
  delete?: Maybe<Cms_PagesFields_Parent_Delete>;
  read?: Maybe<Cms_PagesFields_Parent_Read>;
  update?: Maybe<Cms_PagesFields_Parent_Update>;
};

export type Cms_PagesFields_Parent_Create = {
  __typename?: 'CMS_PagesFields_parent_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Parent_Delete = {
  __typename?: 'CMS_PagesFields_parent_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Parent_Read = {
  __typename?: 'CMS_PagesFields_parent_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Parent_Update = {
  __typename?: 'CMS_PagesFields_parent_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Path = {
  __typename?: 'CMS_PagesFields_path';
  create?: Maybe<Cms_PagesFields_Path_Create>;
  delete?: Maybe<Cms_PagesFields_Path_Delete>;
  read?: Maybe<Cms_PagesFields_Path_Read>;
  update?: Maybe<Cms_PagesFields_Path_Update>;
};

export type Cms_PagesFields_Path_Create = {
  __typename?: 'CMS_PagesFields_path_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Path_Delete = {
  __typename?: 'CMS_PagesFields_path_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Path_Read = {
  __typename?: 'CMS_PagesFields_path_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Path_Update = {
  __typename?: 'CMS_PagesFields_path_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_PublishedAt = {
  __typename?: 'CMS_PagesFields_publishedAt';
  create?: Maybe<Cms_PagesFields_PublishedAt_Create>;
  delete?: Maybe<Cms_PagesFields_PublishedAt_Delete>;
  read?: Maybe<Cms_PagesFields_PublishedAt_Read>;
  update?: Maybe<Cms_PagesFields_PublishedAt_Update>;
};

export type Cms_PagesFields_PublishedAt_Create = {
  __typename?: 'CMS_PagesFields_publishedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_PublishedAt_Delete = {
  __typename?: 'CMS_PagesFields_publishedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_PublishedAt_Read = {
  __typename?: 'CMS_PagesFields_publishedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_PublishedAt_Update = {
  __typename?: 'CMS_PagesFields_publishedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Slug = {
  __typename?: 'CMS_PagesFields_slug';
  create?: Maybe<Cms_PagesFields_Slug_Create>;
  delete?: Maybe<Cms_PagesFields_Slug_Delete>;
  read?: Maybe<Cms_PagesFields_Slug_Read>;
  update?: Maybe<Cms_PagesFields_Slug_Update>;
};

export type Cms_PagesFields_Slug_Create = {
  __typename?: 'CMS_PagesFields_slug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Slug_Delete = {
  __typename?: 'CMS_PagesFields_slug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Slug_Read = {
  __typename?: 'CMS_PagesFields_slug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Slug_Update = {
  __typename?: 'CMS_PagesFields_slug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Subtitle = {
  __typename?: 'CMS_PagesFields_subtitle';
  create?: Maybe<Cms_PagesFields_Subtitle_Create>;
  delete?: Maybe<Cms_PagesFields_Subtitle_Delete>;
  read?: Maybe<Cms_PagesFields_Subtitle_Read>;
  update?: Maybe<Cms_PagesFields_Subtitle_Update>;
};

export type Cms_PagesFields_Subtitle_Create = {
  __typename?: 'CMS_PagesFields_subtitle_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Subtitle_Delete = {
  __typename?: 'CMS_PagesFields_subtitle_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Subtitle_Read = {
  __typename?: 'CMS_PagesFields_subtitle_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Subtitle_Update = {
  __typename?: 'CMS_PagesFields_subtitle_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Tenant = {
  __typename?: 'CMS_PagesFields_tenant';
  create?: Maybe<Cms_PagesFields_Tenant_Create>;
  delete?: Maybe<Cms_PagesFields_Tenant_Delete>;
  read?: Maybe<Cms_PagesFields_Tenant_Read>;
  update?: Maybe<Cms_PagesFields_Tenant_Update>;
};

export type Cms_PagesFields_Tenant_Create = {
  __typename?: 'CMS_PagesFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Tenant_Delete = {
  __typename?: 'CMS_PagesFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Tenant_Read = {
  __typename?: 'CMS_PagesFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Tenant_Update = {
  __typename?: 'CMS_PagesFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Title = {
  __typename?: 'CMS_PagesFields_title';
  create?: Maybe<Cms_PagesFields_Title_Create>;
  delete?: Maybe<Cms_PagesFields_Title_Delete>;
  read?: Maybe<Cms_PagesFields_Title_Read>;
  update?: Maybe<Cms_PagesFields_Title_Update>;
};

export type Cms_PagesFields_Title_Create = {
  __typename?: 'CMS_PagesFields_title_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Title_Delete = {
  __typename?: 'CMS_PagesFields_title_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Title_Read = {
  __typename?: 'CMS_PagesFields_title_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_Title_Update = {
  __typename?: 'CMS_PagesFields_title_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedAt = {
  __typename?: 'CMS_PagesFields_updatedAt';
  create?: Maybe<Cms_PagesFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PagesFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PagesFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PagesFields_UpdatedAt_Update>;
};

export type Cms_PagesFields_UpdatedAt_Create = {
  __typename?: 'CMS_PagesFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PagesFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedAt_Read = {
  __typename?: 'CMS_PagesFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedAt_Update = {
  __typename?: 'CMS_PagesFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedBy = {
  __typename?: 'CMS_PagesFields_updatedBy';
  create?: Maybe<Cms_PagesFields_UpdatedBy_Create>;
  delete?: Maybe<Cms_PagesFields_UpdatedBy_Delete>;
  read?: Maybe<Cms_PagesFields_UpdatedBy_Read>;
  update?: Maybe<Cms_PagesFields_UpdatedBy_Update>;
};

export type Cms_PagesFields_UpdatedBy_Create = {
  __typename?: 'CMS_PagesFields_updatedBy_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedBy_Delete = {
  __typename?: 'CMS_PagesFields_updatedBy_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedBy_Read = {
  __typename?: 'CMS_PagesFields_updatedBy_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesFields_UpdatedBy_Update = {
  __typename?: 'CMS_PagesFields_updatedBy_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PagesReadAccess = {
  __typename?: 'CMS_PagesReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesReadDocAccess = {
  __typename?: 'CMS_PagesReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesReadVersionsAccess = {
  __typename?: 'CMS_PagesReadVersionsAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesReadVersionsDocAccess = {
  __typename?: 'CMS_PagesReadVersionsDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesUpdateAccess = {
  __typename?: 'CMS_PagesUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PagesUpdateDocAccess = {
  __typename?: 'CMS_PagesUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFolder = {
  __typename?: 'CMS_PayloadFolder';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentsAndFolders?: Maybe<Cms_PayloadFolder_DocumentsAndFolders>;
  folder?: Maybe<Cms_PayloadFolder>;
  folderType?: Maybe<Array<Cms_PayloadFolder_FolderType>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tenant?: Maybe<Cms_Tenant>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type Cms_PayloadFolderDocumentsAndFoldersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadFolderUpdate_FolderType_MutationInput {
  Media = 'media',
  Pages = 'pages'
}

export type Cms_PayloadFolder_DocumentsAndFolders = {
  __typename?: 'CMS_PayloadFolder_DocumentsAndFolders';
  docs: Scalars['JSON']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_PayloadFolder_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Cms_PayloadFolder_FolderType {
  Media = 'media',
  Pages = 'pages'
}

export enum Cms_PayloadFolder_FolderType_Input {
  Media = 'media',
  Pages = 'pages'
}

export enum Cms_PayloadFolder_FolderType_MutationInput {
  Media = 'media',
  Pages = 'pages'
}

export type Cms_PayloadFolder_FolderType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_FolderType_Input>>>;
  equals?: InputMaybe<Cms_PayloadFolder_FolderType_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_FolderType_Input>>>;
  not_equals?: InputMaybe<Cms_PayloadFolder_FolderType_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_FolderType_Input>>>;
};

export type Cms_PayloadFolder_Folder_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_PayloadFolder_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PayloadFolder_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_PayloadFolder_Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_PayloadFolder_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadFolder_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadFolder_CreatedAt_Operator>;
  folder?: InputMaybe<Cms_PayloadFolder_Folder_Operator>;
  folderType?: InputMaybe<Cms_PayloadFolder_FolderType_Operator>;
  id?: InputMaybe<Cms_PayloadFolder_Id_Operator>;
  name?: InputMaybe<Cms_PayloadFolder_Name_Operator>;
  tenant?: InputMaybe<Cms_PayloadFolder_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadFolder_UpdatedAt_Operator>;
};

export type Cms_PayloadFolder_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadFolder_CreatedAt_Operator>;
  folder?: InputMaybe<Cms_PayloadFolder_Folder_Operator>;
  folderType?: InputMaybe<Cms_PayloadFolder_FolderType_Operator>;
  id?: InputMaybe<Cms_PayloadFolder_Id_Operator>;
  name?: InputMaybe<Cms_PayloadFolder_Name_Operator>;
  tenant?: InputMaybe<Cms_PayloadFolder_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadFolder_UpdatedAt_Operator>;
};

export type Cms_PayloadFolder_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadFolder_CreatedAt_Operator>;
  folder?: InputMaybe<Cms_PayloadFolder_Folder_Operator>;
  folderType?: InputMaybe<Cms_PayloadFolder_FolderType_Operator>;
  id?: InputMaybe<Cms_PayloadFolder_Id_Operator>;
  name?: InputMaybe<Cms_PayloadFolder_Name_Operator>;
  tenant?: InputMaybe<Cms_PayloadFolder_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadFolder_UpdatedAt_Operator>;
};

export type Cms_PayloadFolders = {
  __typename?: 'CMS_PayloadFolders';
  docs: Array<Cms_PayloadFolder>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PayloadFoldersCreateAccess = {
  __typename?: 'CMS_PayloadFoldersCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersCreateDocAccess = {
  __typename?: 'CMS_PayloadFoldersCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersDeleteAccess = {
  __typename?: 'CMS_PayloadFoldersDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersDeleteDocAccess = {
  __typename?: 'CMS_PayloadFoldersDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersDocAccessFields = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields';
  createdAt?: Maybe<Cms_PayloadFoldersDocAccessFields_CreatedAt>;
  documentsAndFolders?: Maybe<Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders>;
  folder?: Maybe<Cms_PayloadFoldersDocAccessFields_Folder>;
  folderType?: Maybe<Cms_PayloadFoldersDocAccessFields_FolderType>;
  name?: Maybe<Cms_PayloadFoldersDocAccessFields_Name>;
  tenant?: Maybe<Cms_PayloadFoldersDocAccessFields_Tenant>;
  updatedAt?: Maybe<Cms_PayloadFoldersDocAccessFields_UpdatedAt>;
};

export type Cms_PayloadFoldersDocAccessFields_CreatedAt = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_createdAt';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_CreatedAt_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_documentsAndFolders';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_documentsAndFolders_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_documentsAndFolders_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_documentsAndFolders_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_DocumentsAndFolders_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_documentsAndFolders_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Folder = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folder';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_Folder_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_Folder_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_Folder_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_Folder_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_FolderType = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folderType';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_FolderType_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_FolderType_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_FolderType_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_FolderType_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_FolderType_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folderType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_FolderType_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folderType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_FolderType_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folderType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_FolderType_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folderType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Folder_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Folder_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Folder_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Folder_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Name = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_name';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_Name_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_Name_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_Name_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_Name_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_Name_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_name_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Name_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_name_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Name_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_name_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Name_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_name_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Tenant = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_tenant';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_Tenant_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_Tenant_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_Tenant_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_Tenant_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_Tenant_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Tenant_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Tenant_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_Tenant_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_updatedAt';
  create?: Maybe<Cms_PayloadFoldersDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadFoldersDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadFoldersDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadFoldersDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PayloadFoldersDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadFoldersDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields = {
  __typename?: 'CMS_PayloadFoldersFields';
  createdAt?: Maybe<Cms_PayloadFoldersFields_CreatedAt>;
  documentsAndFolders?: Maybe<Cms_PayloadFoldersFields_DocumentsAndFolders>;
  folder?: Maybe<Cms_PayloadFoldersFields_Folder>;
  folderType?: Maybe<Cms_PayloadFoldersFields_FolderType>;
  name?: Maybe<Cms_PayloadFoldersFields_Name>;
  tenant?: Maybe<Cms_PayloadFoldersFields_Tenant>;
  updatedAt?: Maybe<Cms_PayloadFoldersFields_UpdatedAt>;
};

export type Cms_PayloadFoldersFields_CreatedAt = {
  __typename?: 'CMS_PayloadFoldersFields_createdAt';
  create?: Maybe<Cms_PayloadFoldersFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_CreatedAt_Update>;
};

export type Cms_PayloadFoldersFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadFoldersFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadFoldersFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadFoldersFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_DocumentsAndFolders = {
  __typename?: 'CMS_PayloadFoldersFields_documentsAndFolders';
  create?: Maybe<Cms_PayloadFoldersFields_DocumentsAndFolders_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_DocumentsAndFolders_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_DocumentsAndFolders_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_DocumentsAndFolders_Update>;
};

export type Cms_PayloadFoldersFields_DocumentsAndFolders_Create = {
  __typename?: 'CMS_PayloadFoldersFields_documentsAndFolders_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_DocumentsAndFolders_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_documentsAndFolders_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_DocumentsAndFolders_Read = {
  __typename?: 'CMS_PayloadFoldersFields_documentsAndFolders_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_DocumentsAndFolders_Update = {
  __typename?: 'CMS_PayloadFoldersFields_documentsAndFolders_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Folder = {
  __typename?: 'CMS_PayloadFoldersFields_folder';
  create?: Maybe<Cms_PayloadFoldersFields_Folder_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_Folder_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_Folder_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_Folder_Update>;
};

export type Cms_PayloadFoldersFields_FolderType = {
  __typename?: 'CMS_PayloadFoldersFields_folderType';
  create?: Maybe<Cms_PayloadFoldersFields_FolderType_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_FolderType_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_FolderType_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_FolderType_Update>;
};

export type Cms_PayloadFoldersFields_FolderType_Create = {
  __typename?: 'CMS_PayloadFoldersFields_folderType_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_FolderType_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_folderType_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_FolderType_Read = {
  __typename?: 'CMS_PayloadFoldersFields_folderType_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_FolderType_Update = {
  __typename?: 'CMS_PayloadFoldersFields_folderType_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Folder_Create = {
  __typename?: 'CMS_PayloadFoldersFields_folder_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Folder_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_folder_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Folder_Read = {
  __typename?: 'CMS_PayloadFoldersFields_folder_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Folder_Update = {
  __typename?: 'CMS_PayloadFoldersFields_folder_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Name = {
  __typename?: 'CMS_PayloadFoldersFields_name';
  create?: Maybe<Cms_PayloadFoldersFields_Name_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_Name_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_Name_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_Name_Update>;
};

export type Cms_PayloadFoldersFields_Name_Create = {
  __typename?: 'CMS_PayloadFoldersFields_name_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Name_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_name_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Name_Read = {
  __typename?: 'CMS_PayloadFoldersFields_name_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Name_Update = {
  __typename?: 'CMS_PayloadFoldersFields_name_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Tenant = {
  __typename?: 'CMS_PayloadFoldersFields_tenant';
  create?: Maybe<Cms_PayloadFoldersFields_Tenant_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_Tenant_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_Tenant_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_Tenant_Update>;
};

export type Cms_PayloadFoldersFields_Tenant_Create = {
  __typename?: 'CMS_PayloadFoldersFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Tenant_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Tenant_Read = {
  __typename?: 'CMS_PayloadFoldersFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_Tenant_Update = {
  __typename?: 'CMS_PayloadFoldersFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_UpdatedAt = {
  __typename?: 'CMS_PayloadFoldersFields_updatedAt';
  create?: Maybe<Cms_PayloadFoldersFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadFoldersFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadFoldersFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadFoldersFields_UpdatedAt_Update>;
};

export type Cms_PayloadFoldersFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadFoldersFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadFoldersFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadFoldersFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadFoldersFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadFoldersReadAccess = {
  __typename?: 'CMS_PayloadFoldersReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersReadDocAccess = {
  __typename?: 'CMS_PayloadFoldersReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersUpdateAccess = {
  __typename?: 'CMS_PayloadFoldersUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadFoldersUpdateDocAccess = {
  __typename?: 'CMS_PayloadFoldersUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJob = {
  __typename?: 'CMS_PayloadJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  hasError?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  input?: Maybe<Scalars['JSON']['output']>;
  log?: Maybe<Array<Cms_PayloadJob_Log>>;
  processing?: Maybe<Scalars['Boolean']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  taskSlug?: Maybe<Cms_PayloadJob_TaskSlug>;
  taskStatus?: Maybe<Scalars['JSON']['output']>;
  totalTried?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  waitUntil?: Maybe<Scalars['DateTime']['output']>;
};

export enum Cms_PayloadJobUpdate_Log_TaskSlug_MutationInput {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export enum Cms_PayloadJobUpdate_TaskSlug_MutationInput {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export type Cms_PayloadJob_Log = {
  __typename?: 'CMS_PayloadJob_Log';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  output?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<Cms_PayloadJob_Log_State>;
  taskID?: Maybe<Scalars['String']['output']>;
  taskSlug?: Maybe<Cms_PayloadJob_Log_TaskSlug>;
};

export enum Cms_PayloadJob_Log_State {
  Failed = 'failed',
  Succeeded = 'succeeded'
}

export enum Cms_PayloadJob_Log_TaskSlug {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export enum Cms_PayloadJob_Log_TaskSlug_MutationInput {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export type Cms_PayloadJob_CompletedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_Error_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadJob_HasError_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PayloadJob_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PayloadJob_Input_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadJob_Log__CompletedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_Log__Error_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadJob_Log__ExecutedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_Log__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_PayloadJob_Log__Input_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadJob_Log__Output_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadJob_Log__State_Input {
  Failed = 'failed',
  Succeeded = 'succeeded'
}

export type Cms_PayloadJob_Log__State_Operator = {
  contains?: InputMaybe<Cms_PayloadJob_Log__State_Input>;
  equals?: InputMaybe<Cms_PayloadJob_Log__State_Input>;
  like?: InputMaybe<Cms_PayloadJob_Log__State_Input>;
  not_equals?: InputMaybe<Cms_PayloadJob_Log__State_Input>;
};

export type Cms_PayloadJob_Log__TaskId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Cms_PayloadJob_Log__TaskSlug_Input {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export type Cms_PayloadJob_Log__TaskSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Log__TaskSlug_Input>>>;
  equals?: InputMaybe<Cms_PayloadJob_Log__TaskSlug_Input>;
  in?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Log__TaskSlug_Input>>>;
  not_equals?: InputMaybe<Cms_PayloadJob_Log__TaskSlug_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Log__TaskSlug_Input>>>;
};

export type Cms_PayloadJob_Processing_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PayloadJob_Queue_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Cms_PayloadJob_TaskSlug {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export enum Cms_PayloadJob_TaskSlug_Input {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export enum Cms_PayloadJob_TaskSlug_MutationInput {
  Inline = 'inline',
  SchedulePublish = 'schedulePublish'
}

export type Cms_PayloadJob_TaskSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_TaskSlug_Input>>>;
  equals?: InputMaybe<Cms_PayloadJob_TaskSlug_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_TaskSlug_Input>>>;
  not_equals?: InputMaybe<Cms_PayloadJob_TaskSlug_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_TaskSlug_Input>>>;
};

export type Cms_PayloadJob_TaskStatus_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadJob_TotalTried_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_PayloadJob_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_WaitUntil_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadJob_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_Or>>>;
  completedAt?: InputMaybe<Cms_PayloadJob_CompletedAt_Operator>;
  createdAt?: InputMaybe<Cms_PayloadJob_CreatedAt_Operator>;
  error?: InputMaybe<Cms_PayloadJob_Error_Operator>;
  hasError?: InputMaybe<Cms_PayloadJob_HasError_Operator>;
  id?: InputMaybe<Cms_PayloadJob_Id_Operator>;
  input?: InputMaybe<Cms_PayloadJob_Input_Operator>;
  log__completedAt?: InputMaybe<Cms_PayloadJob_Log__CompletedAt_Operator>;
  log__error?: InputMaybe<Cms_PayloadJob_Log__Error_Operator>;
  log__executedAt?: InputMaybe<Cms_PayloadJob_Log__ExecutedAt_Operator>;
  log__id?: InputMaybe<Cms_PayloadJob_Log__Id_Operator>;
  log__input?: InputMaybe<Cms_PayloadJob_Log__Input_Operator>;
  log__output?: InputMaybe<Cms_PayloadJob_Log__Output_Operator>;
  log__state?: InputMaybe<Cms_PayloadJob_Log__State_Operator>;
  log__taskID?: InputMaybe<Cms_PayloadJob_Log__TaskId_Operator>;
  log__taskSlug?: InputMaybe<Cms_PayloadJob_Log__TaskSlug_Operator>;
  processing?: InputMaybe<Cms_PayloadJob_Processing_Operator>;
  queue?: InputMaybe<Cms_PayloadJob_Queue_Operator>;
  taskSlug?: InputMaybe<Cms_PayloadJob_TaskSlug_Operator>;
  taskStatus?: InputMaybe<Cms_PayloadJob_TaskStatus_Operator>;
  totalTried?: InputMaybe<Cms_PayloadJob_TotalTried_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadJob_UpdatedAt_Operator>;
  waitUntil?: InputMaybe<Cms_PayloadJob_WaitUntil_Operator>;
};

export type Cms_PayloadJob_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_Or>>>;
  completedAt?: InputMaybe<Cms_PayloadJob_CompletedAt_Operator>;
  createdAt?: InputMaybe<Cms_PayloadJob_CreatedAt_Operator>;
  error?: InputMaybe<Cms_PayloadJob_Error_Operator>;
  hasError?: InputMaybe<Cms_PayloadJob_HasError_Operator>;
  id?: InputMaybe<Cms_PayloadJob_Id_Operator>;
  input?: InputMaybe<Cms_PayloadJob_Input_Operator>;
  log__completedAt?: InputMaybe<Cms_PayloadJob_Log__CompletedAt_Operator>;
  log__error?: InputMaybe<Cms_PayloadJob_Log__Error_Operator>;
  log__executedAt?: InputMaybe<Cms_PayloadJob_Log__ExecutedAt_Operator>;
  log__id?: InputMaybe<Cms_PayloadJob_Log__Id_Operator>;
  log__input?: InputMaybe<Cms_PayloadJob_Log__Input_Operator>;
  log__output?: InputMaybe<Cms_PayloadJob_Log__Output_Operator>;
  log__state?: InputMaybe<Cms_PayloadJob_Log__State_Operator>;
  log__taskID?: InputMaybe<Cms_PayloadJob_Log__TaskId_Operator>;
  log__taskSlug?: InputMaybe<Cms_PayloadJob_Log__TaskSlug_Operator>;
  processing?: InputMaybe<Cms_PayloadJob_Processing_Operator>;
  queue?: InputMaybe<Cms_PayloadJob_Queue_Operator>;
  taskSlug?: InputMaybe<Cms_PayloadJob_TaskSlug_Operator>;
  taskStatus?: InputMaybe<Cms_PayloadJob_TaskStatus_Operator>;
  totalTried?: InputMaybe<Cms_PayloadJob_TotalTried_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadJob_UpdatedAt_Operator>;
  waitUntil?: InputMaybe<Cms_PayloadJob_WaitUntil_Operator>;
};

export type Cms_PayloadJob_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadJob_Where_Or>>>;
  completedAt?: InputMaybe<Cms_PayloadJob_CompletedAt_Operator>;
  createdAt?: InputMaybe<Cms_PayloadJob_CreatedAt_Operator>;
  error?: InputMaybe<Cms_PayloadJob_Error_Operator>;
  hasError?: InputMaybe<Cms_PayloadJob_HasError_Operator>;
  id?: InputMaybe<Cms_PayloadJob_Id_Operator>;
  input?: InputMaybe<Cms_PayloadJob_Input_Operator>;
  log__completedAt?: InputMaybe<Cms_PayloadJob_Log__CompletedAt_Operator>;
  log__error?: InputMaybe<Cms_PayloadJob_Log__Error_Operator>;
  log__executedAt?: InputMaybe<Cms_PayloadJob_Log__ExecutedAt_Operator>;
  log__id?: InputMaybe<Cms_PayloadJob_Log__Id_Operator>;
  log__input?: InputMaybe<Cms_PayloadJob_Log__Input_Operator>;
  log__output?: InputMaybe<Cms_PayloadJob_Log__Output_Operator>;
  log__state?: InputMaybe<Cms_PayloadJob_Log__State_Operator>;
  log__taskID?: InputMaybe<Cms_PayloadJob_Log__TaskId_Operator>;
  log__taskSlug?: InputMaybe<Cms_PayloadJob_Log__TaskSlug_Operator>;
  processing?: InputMaybe<Cms_PayloadJob_Processing_Operator>;
  queue?: InputMaybe<Cms_PayloadJob_Queue_Operator>;
  taskSlug?: InputMaybe<Cms_PayloadJob_TaskSlug_Operator>;
  taskStatus?: InputMaybe<Cms_PayloadJob_TaskStatus_Operator>;
  totalTried?: InputMaybe<Cms_PayloadJob_TotalTried_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadJob_UpdatedAt_Operator>;
  waitUntil?: InputMaybe<Cms_PayloadJob_WaitUntil_Operator>;
};

export type Cms_PayloadJobs = {
  __typename?: 'CMS_PayloadJobs';
  docs: Array<Cms_PayloadJob>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PayloadJobsCreateAccess = {
  __typename?: 'CMS_PayloadJobsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsCreateDocAccess = {
  __typename?: 'CMS_PayloadJobsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsDeleteAccess = {
  __typename?: 'CMS_PayloadJobsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsDeleteDocAccess = {
  __typename?: 'CMS_PayloadJobsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsDocAccessFields = {
  __typename?: 'CMS_PayloadJobsDocAccessFields';
  completedAt?: Maybe<Cms_PayloadJobsDocAccessFields_CompletedAt>;
  createdAt?: Maybe<Cms_PayloadJobsDocAccessFields_CreatedAt>;
  error?: Maybe<Cms_PayloadJobsDocAccessFields_Error>;
  hasError?: Maybe<Cms_PayloadJobsDocAccessFields_HasError>;
  input?: Maybe<Cms_PayloadJobsDocAccessFields_Input>;
  log?: Maybe<Cms_PayloadJobsDocAccessFields_Log>;
  processing?: Maybe<Cms_PayloadJobsDocAccessFields_Processing>;
  queue?: Maybe<Cms_PayloadJobsDocAccessFields_Queue>;
  taskSlug?: Maybe<Cms_PayloadJobsDocAccessFields_TaskSlug>;
  taskStatus?: Maybe<Cms_PayloadJobsDocAccessFields_TaskStatus>;
  totalTried?: Maybe<Cms_PayloadJobsDocAccessFields_TotalTried>;
  updatedAt?: Maybe<Cms_PayloadJobsDocAccessFields_UpdatedAt>;
  waitUntil?: Maybe<Cms_PayloadJobsDocAccessFields_WaitUntil>;
};

export type Cms_PayloadJobsDocAccessFields_CompletedAt = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_completedAt';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_CompletedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_CompletedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_CompletedAt_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_CompletedAt_Update>;
};

export type Cms_PayloadJobsDocAccessFields_CompletedAt_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_completedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CompletedAt_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_completedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CompletedAt_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_completedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CompletedAt_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_completedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_createdAt';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_CreatedAt_Update>;
};

export type Cms_PayloadJobsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Error = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_error';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Error_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Error_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Error_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Error_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Error_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_error_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Error_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_error_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Error_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_error_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Error_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_error_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_HasError = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_hasError';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_HasError_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_HasError_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_HasError_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_HasError_Update>;
};

export type Cms_PayloadJobsDocAccessFields_HasError_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_hasError_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_HasError_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_hasError_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_HasError_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_hasError_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_HasError_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_hasError_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Input = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_input';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Input_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Input_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Input_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Input_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Input_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_input_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Input_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_input_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Input_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_input_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Input_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_input_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Delete>;
  fields?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Fields>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Fields = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_Fields';
  completedAt?: Maybe<Cms_PayloadJobsDocAccessFields_Log_CompletedAt>;
  error?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Error>;
  executedAt?: Maybe<Cms_PayloadJobsDocAccessFields_Log_ExecutedAt>;
  id?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Id>;
  input?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Input>;
  output?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Output>;
  state?: Maybe<Cms_PayloadJobsDocAccessFields_Log_State>;
  taskID?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskId>;
  taskSlug?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskSlug>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_CompletedAt = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_completedAt';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_completedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_completedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_completedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_CompletedAt_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_completedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Error = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_error';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Error_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Error_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Error_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Error_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Error_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_error_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Error_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_error_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Error_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_error_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Error_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_error_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_ExecutedAt = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_executedAt';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_executedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_executedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_executedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_ExecutedAt_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_executedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Id = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_id';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Id_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Id_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Id_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Id_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Id_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Id_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Id_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Id_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Input = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_input';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Input_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Input_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Input_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Input_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Input_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_input_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Input_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_input_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Input_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_input_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Input_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_input_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Output = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_output';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Output_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Output_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Output_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_Output_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_Output_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_output_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Output_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_output_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Output_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_output_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_Output_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_output_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_State = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_state';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_State_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_State_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_State_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_State_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_State_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_state_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_State_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_state_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_State_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_state_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_State_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_state_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskId = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskID';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskId_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskId_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskId_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskId_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskId_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskID_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskId_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskID_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskId_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskID_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskId_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskID_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskSlug = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskSlug';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Log_TaskSlug_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_log_taskSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Processing = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_processing';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Processing_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Processing_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Processing_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Processing_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Processing_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_processing_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Processing_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_processing_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Processing_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_processing_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Processing_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_processing_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Queue = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_queue';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_Queue_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_Queue_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_Queue_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_Queue_Update>;
};

export type Cms_PayloadJobsDocAccessFields_Queue_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_queue_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Queue_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_queue_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Queue_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_queue_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_Queue_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_queue_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskSlug = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskSlug';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_TaskSlug_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_TaskSlug_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_TaskSlug_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_TaskSlug_Update>;
};

export type Cms_PayloadJobsDocAccessFields_TaskSlug_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskSlug_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskSlug_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskSlug_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskStatus = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskStatus';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_TaskStatus_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_TaskStatus_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_TaskStatus_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_TaskStatus_Update>;
};

export type Cms_PayloadJobsDocAccessFields_TaskStatus_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskStatus_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskStatus_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskStatus_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskStatus_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskStatus_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TaskStatus_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_taskStatus_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TotalTried = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_totalTried';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_TotalTried_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_TotalTried_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_TotalTried_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_TotalTried_Update>;
};

export type Cms_PayloadJobsDocAccessFields_TotalTried_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_totalTried_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TotalTried_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_totalTried_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TotalTried_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_totalTried_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_TotalTried_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_totalTried_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_updatedAt';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PayloadJobsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_WaitUntil = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_waitUntil';
  create?: Maybe<Cms_PayloadJobsDocAccessFields_WaitUntil_Create>;
  delete?: Maybe<Cms_PayloadJobsDocAccessFields_WaitUntil_Delete>;
  read?: Maybe<Cms_PayloadJobsDocAccessFields_WaitUntil_Read>;
  update?: Maybe<Cms_PayloadJobsDocAccessFields_WaitUntil_Update>;
};

export type Cms_PayloadJobsDocAccessFields_WaitUntil_Create = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_waitUntil_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_WaitUntil_Delete = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_waitUntil_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_WaitUntil_Read = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_waitUntil_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsDocAccessFields_WaitUntil_Update = {
  __typename?: 'CMS_PayloadJobsDocAccessFields_waitUntil_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields = {
  __typename?: 'CMS_PayloadJobsFields';
  completedAt?: Maybe<Cms_PayloadJobsFields_CompletedAt>;
  createdAt?: Maybe<Cms_PayloadJobsFields_CreatedAt>;
  error?: Maybe<Cms_PayloadJobsFields_Error>;
  hasError?: Maybe<Cms_PayloadJobsFields_HasError>;
  input?: Maybe<Cms_PayloadJobsFields_Input>;
  log?: Maybe<Cms_PayloadJobsFields_Log>;
  processing?: Maybe<Cms_PayloadJobsFields_Processing>;
  queue?: Maybe<Cms_PayloadJobsFields_Queue>;
  taskSlug?: Maybe<Cms_PayloadJobsFields_TaskSlug>;
  taskStatus?: Maybe<Cms_PayloadJobsFields_TaskStatus>;
  totalTried?: Maybe<Cms_PayloadJobsFields_TotalTried>;
  updatedAt?: Maybe<Cms_PayloadJobsFields_UpdatedAt>;
  waitUntil?: Maybe<Cms_PayloadJobsFields_WaitUntil>;
};

export type Cms_PayloadJobsFields_CompletedAt = {
  __typename?: 'CMS_PayloadJobsFields_completedAt';
  create?: Maybe<Cms_PayloadJobsFields_CompletedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_CompletedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_CompletedAt_Read>;
  update?: Maybe<Cms_PayloadJobsFields_CompletedAt_Update>;
};

export type Cms_PayloadJobsFields_CompletedAt_Create = {
  __typename?: 'CMS_PayloadJobsFields_completedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CompletedAt_Delete = {
  __typename?: 'CMS_PayloadJobsFields_completedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CompletedAt_Read = {
  __typename?: 'CMS_PayloadJobsFields_completedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CompletedAt_Update = {
  __typename?: 'CMS_PayloadJobsFields_completedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CreatedAt = {
  __typename?: 'CMS_PayloadJobsFields_createdAt';
  create?: Maybe<Cms_PayloadJobsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadJobsFields_CreatedAt_Update>;
};

export type Cms_PayloadJobsFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadJobsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadJobsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadJobsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadJobsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Error = {
  __typename?: 'CMS_PayloadJobsFields_error';
  create?: Maybe<Cms_PayloadJobsFields_Error_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Error_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Error_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Error_Update>;
};

export type Cms_PayloadJobsFields_Error_Create = {
  __typename?: 'CMS_PayloadJobsFields_error_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Error_Delete = {
  __typename?: 'CMS_PayloadJobsFields_error_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Error_Read = {
  __typename?: 'CMS_PayloadJobsFields_error_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Error_Update = {
  __typename?: 'CMS_PayloadJobsFields_error_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_HasError = {
  __typename?: 'CMS_PayloadJobsFields_hasError';
  create?: Maybe<Cms_PayloadJobsFields_HasError_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_HasError_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_HasError_Read>;
  update?: Maybe<Cms_PayloadJobsFields_HasError_Update>;
};

export type Cms_PayloadJobsFields_HasError_Create = {
  __typename?: 'CMS_PayloadJobsFields_hasError_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_HasError_Delete = {
  __typename?: 'CMS_PayloadJobsFields_hasError_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_HasError_Read = {
  __typename?: 'CMS_PayloadJobsFields_hasError_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_HasError_Update = {
  __typename?: 'CMS_PayloadJobsFields_hasError_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Input = {
  __typename?: 'CMS_PayloadJobsFields_input';
  create?: Maybe<Cms_PayloadJobsFields_Input_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Input_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Input_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Input_Update>;
};

export type Cms_PayloadJobsFields_Input_Create = {
  __typename?: 'CMS_PayloadJobsFields_input_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Input_Delete = {
  __typename?: 'CMS_PayloadJobsFields_input_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Input_Read = {
  __typename?: 'CMS_PayloadJobsFields_input_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Input_Update = {
  __typename?: 'CMS_PayloadJobsFields_input_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log = {
  __typename?: 'CMS_PayloadJobsFields_log';
  create?: Maybe<Cms_PayloadJobsFields_Log_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_Delete>;
  fields?: Maybe<Cms_PayloadJobsFields_Log_Fields>;
  read?: Maybe<Cms_PayloadJobsFields_Log_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_Update>;
};

export type Cms_PayloadJobsFields_Log_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Fields = {
  __typename?: 'CMS_PayloadJobsFields_log_Fields';
  completedAt?: Maybe<Cms_PayloadJobsFields_Log_CompletedAt>;
  error?: Maybe<Cms_PayloadJobsFields_Log_Error>;
  executedAt?: Maybe<Cms_PayloadJobsFields_Log_ExecutedAt>;
  id?: Maybe<Cms_PayloadJobsFields_Log_Id>;
  input?: Maybe<Cms_PayloadJobsFields_Log_Input>;
  output?: Maybe<Cms_PayloadJobsFields_Log_Output>;
  state?: Maybe<Cms_PayloadJobsFields_Log_State>;
  taskID?: Maybe<Cms_PayloadJobsFields_Log_TaskId>;
  taskSlug?: Maybe<Cms_PayloadJobsFields_Log_TaskSlug>;
};

export type Cms_PayloadJobsFields_Log_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_CompletedAt = {
  __typename?: 'CMS_PayloadJobsFields_log_completedAt';
  create?: Maybe<Cms_PayloadJobsFields_Log_CompletedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_CompletedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_CompletedAt_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_CompletedAt_Update>;
};

export type Cms_PayloadJobsFields_Log_CompletedAt_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_completedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_CompletedAt_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_completedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_CompletedAt_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_completedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_CompletedAt_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_completedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Error = {
  __typename?: 'CMS_PayloadJobsFields_log_error';
  create?: Maybe<Cms_PayloadJobsFields_Log_Error_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_Error_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_Error_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_Error_Update>;
};

export type Cms_PayloadJobsFields_Log_Error_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_error_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Error_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_error_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Error_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_error_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Error_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_error_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_ExecutedAt = {
  __typename?: 'CMS_PayloadJobsFields_log_executedAt';
  create?: Maybe<Cms_PayloadJobsFields_Log_ExecutedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_ExecutedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_ExecutedAt_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_ExecutedAt_Update>;
};

export type Cms_PayloadJobsFields_Log_ExecutedAt_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_executedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_ExecutedAt_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_executedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_ExecutedAt_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_executedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_ExecutedAt_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_executedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Id = {
  __typename?: 'CMS_PayloadJobsFields_log_id';
  create?: Maybe<Cms_PayloadJobsFields_Log_Id_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_Id_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_Id_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_Id_Update>;
};

export type Cms_PayloadJobsFields_Log_Id_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Id_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Id_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Id_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Input = {
  __typename?: 'CMS_PayloadJobsFields_log_input';
  create?: Maybe<Cms_PayloadJobsFields_Log_Input_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_Input_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_Input_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_Input_Update>;
};

export type Cms_PayloadJobsFields_Log_Input_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_input_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Input_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_input_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Input_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_input_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Input_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_input_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Output = {
  __typename?: 'CMS_PayloadJobsFields_log_output';
  create?: Maybe<Cms_PayloadJobsFields_Log_Output_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_Output_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_Output_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_Output_Update>;
};

export type Cms_PayloadJobsFields_Log_Output_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_output_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Output_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_output_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Output_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_output_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_Output_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_output_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_State = {
  __typename?: 'CMS_PayloadJobsFields_log_state';
  create?: Maybe<Cms_PayloadJobsFields_Log_State_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_State_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_State_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_State_Update>;
};

export type Cms_PayloadJobsFields_Log_State_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_state_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_State_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_state_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_State_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_state_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_State_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_state_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskId = {
  __typename?: 'CMS_PayloadJobsFields_log_taskID';
  create?: Maybe<Cms_PayloadJobsFields_Log_TaskId_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_TaskId_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_TaskId_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_TaskId_Update>;
};

export type Cms_PayloadJobsFields_Log_TaskId_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_taskID_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskId_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_taskID_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskId_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_taskID_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskId_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_taskID_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskSlug = {
  __typename?: 'CMS_PayloadJobsFields_log_taskSlug';
  create?: Maybe<Cms_PayloadJobsFields_Log_TaskSlug_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Log_TaskSlug_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Log_TaskSlug_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Log_TaskSlug_Update>;
};

export type Cms_PayloadJobsFields_Log_TaskSlug_Create = {
  __typename?: 'CMS_PayloadJobsFields_log_taskSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskSlug_Delete = {
  __typename?: 'CMS_PayloadJobsFields_log_taskSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskSlug_Read = {
  __typename?: 'CMS_PayloadJobsFields_log_taskSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Log_TaskSlug_Update = {
  __typename?: 'CMS_PayloadJobsFields_log_taskSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Processing = {
  __typename?: 'CMS_PayloadJobsFields_processing';
  create?: Maybe<Cms_PayloadJobsFields_Processing_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Processing_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Processing_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Processing_Update>;
};

export type Cms_PayloadJobsFields_Processing_Create = {
  __typename?: 'CMS_PayloadJobsFields_processing_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Processing_Delete = {
  __typename?: 'CMS_PayloadJobsFields_processing_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Processing_Read = {
  __typename?: 'CMS_PayloadJobsFields_processing_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Processing_Update = {
  __typename?: 'CMS_PayloadJobsFields_processing_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Queue = {
  __typename?: 'CMS_PayloadJobsFields_queue';
  create?: Maybe<Cms_PayloadJobsFields_Queue_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_Queue_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_Queue_Read>;
  update?: Maybe<Cms_PayloadJobsFields_Queue_Update>;
};

export type Cms_PayloadJobsFields_Queue_Create = {
  __typename?: 'CMS_PayloadJobsFields_queue_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Queue_Delete = {
  __typename?: 'CMS_PayloadJobsFields_queue_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Queue_Read = {
  __typename?: 'CMS_PayloadJobsFields_queue_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_Queue_Update = {
  __typename?: 'CMS_PayloadJobsFields_queue_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskSlug = {
  __typename?: 'CMS_PayloadJobsFields_taskSlug';
  create?: Maybe<Cms_PayloadJobsFields_TaskSlug_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_TaskSlug_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_TaskSlug_Read>;
  update?: Maybe<Cms_PayloadJobsFields_TaskSlug_Update>;
};

export type Cms_PayloadJobsFields_TaskSlug_Create = {
  __typename?: 'CMS_PayloadJobsFields_taskSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskSlug_Delete = {
  __typename?: 'CMS_PayloadJobsFields_taskSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskSlug_Read = {
  __typename?: 'CMS_PayloadJobsFields_taskSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskSlug_Update = {
  __typename?: 'CMS_PayloadJobsFields_taskSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskStatus = {
  __typename?: 'CMS_PayloadJobsFields_taskStatus';
  create?: Maybe<Cms_PayloadJobsFields_TaskStatus_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_TaskStatus_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_TaskStatus_Read>;
  update?: Maybe<Cms_PayloadJobsFields_TaskStatus_Update>;
};

export type Cms_PayloadJobsFields_TaskStatus_Create = {
  __typename?: 'CMS_PayloadJobsFields_taskStatus_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskStatus_Delete = {
  __typename?: 'CMS_PayloadJobsFields_taskStatus_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskStatus_Read = {
  __typename?: 'CMS_PayloadJobsFields_taskStatus_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TaskStatus_Update = {
  __typename?: 'CMS_PayloadJobsFields_taskStatus_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TotalTried = {
  __typename?: 'CMS_PayloadJobsFields_totalTried';
  create?: Maybe<Cms_PayloadJobsFields_TotalTried_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_TotalTried_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_TotalTried_Read>;
  update?: Maybe<Cms_PayloadJobsFields_TotalTried_Update>;
};

export type Cms_PayloadJobsFields_TotalTried_Create = {
  __typename?: 'CMS_PayloadJobsFields_totalTried_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TotalTried_Delete = {
  __typename?: 'CMS_PayloadJobsFields_totalTried_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TotalTried_Read = {
  __typename?: 'CMS_PayloadJobsFields_totalTried_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_TotalTried_Update = {
  __typename?: 'CMS_PayloadJobsFields_totalTried_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_UpdatedAt = {
  __typename?: 'CMS_PayloadJobsFields_updatedAt';
  create?: Maybe<Cms_PayloadJobsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadJobsFields_UpdatedAt_Update>;
};

export type Cms_PayloadJobsFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadJobsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadJobsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadJobsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadJobsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_WaitUntil = {
  __typename?: 'CMS_PayloadJobsFields_waitUntil';
  create?: Maybe<Cms_PayloadJobsFields_WaitUntil_Create>;
  delete?: Maybe<Cms_PayloadJobsFields_WaitUntil_Delete>;
  read?: Maybe<Cms_PayloadJobsFields_WaitUntil_Read>;
  update?: Maybe<Cms_PayloadJobsFields_WaitUntil_Update>;
};

export type Cms_PayloadJobsFields_WaitUntil_Create = {
  __typename?: 'CMS_PayloadJobsFields_waitUntil_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_WaitUntil_Delete = {
  __typename?: 'CMS_PayloadJobsFields_waitUntil_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_WaitUntil_Read = {
  __typename?: 'CMS_PayloadJobsFields_waitUntil_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsFields_WaitUntil_Update = {
  __typename?: 'CMS_PayloadJobsFields_waitUntil_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadJobsReadAccess = {
  __typename?: 'CMS_PayloadJobsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsReadDocAccess = {
  __typename?: 'CMS_PayloadJobsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsUpdateAccess = {
  __typename?: 'CMS_PayloadJobsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadJobsUpdateDocAccess = {
  __typename?: 'CMS_PayloadJobsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKv = {
  __typename?: 'CMS_PayloadKv';
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type Cms_PayloadKvCreateAccess = {
  __typename?: 'CMS_PayloadKvCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvCreateDocAccess = {
  __typename?: 'CMS_PayloadKvCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvDeleteAccess = {
  __typename?: 'CMS_PayloadKvDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvDeleteDocAccess = {
  __typename?: 'CMS_PayloadKvDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvDocAccessFields = {
  __typename?: 'CMS_PayloadKvDocAccessFields';
  data?: Maybe<Cms_PayloadKvDocAccessFields_Data>;
  key?: Maybe<Cms_PayloadKvDocAccessFields_Key>;
};

export type Cms_PayloadKvDocAccessFields_Data = {
  __typename?: 'CMS_PayloadKvDocAccessFields_data';
  create?: Maybe<Cms_PayloadKvDocAccessFields_Data_Create>;
  delete?: Maybe<Cms_PayloadKvDocAccessFields_Data_Delete>;
  read?: Maybe<Cms_PayloadKvDocAccessFields_Data_Read>;
  update?: Maybe<Cms_PayloadKvDocAccessFields_Data_Update>;
};

export type Cms_PayloadKvDocAccessFields_Data_Create = {
  __typename?: 'CMS_PayloadKvDocAccessFields_data_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Data_Delete = {
  __typename?: 'CMS_PayloadKvDocAccessFields_data_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Data_Read = {
  __typename?: 'CMS_PayloadKvDocAccessFields_data_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Data_Update = {
  __typename?: 'CMS_PayloadKvDocAccessFields_data_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Key = {
  __typename?: 'CMS_PayloadKvDocAccessFields_key';
  create?: Maybe<Cms_PayloadKvDocAccessFields_Key_Create>;
  delete?: Maybe<Cms_PayloadKvDocAccessFields_Key_Delete>;
  read?: Maybe<Cms_PayloadKvDocAccessFields_Key_Read>;
  update?: Maybe<Cms_PayloadKvDocAccessFields_Key_Update>;
};

export type Cms_PayloadKvDocAccessFields_Key_Create = {
  __typename?: 'CMS_PayloadKvDocAccessFields_key_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Key_Delete = {
  __typename?: 'CMS_PayloadKvDocAccessFields_key_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Key_Read = {
  __typename?: 'CMS_PayloadKvDocAccessFields_key_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvDocAccessFields_Key_Update = {
  __typename?: 'CMS_PayloadKvDocAccessFields_key_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields = {
  __typename?: 'CMS_PayloadKvFields';
  data?: Maybe<Cms_PayloadKvFields_Data>;
  key?: Maybe<Cms_PayloadKvFields_Key>;
};

export type Cms_PayloadKvFields_Data = {
  __typename?: 'CMS_PayloadKvFields_data';
  create?: Maybe<Cms_PayloadKvFields_Data_Create>;
  delete?: Maybe<Cms_PayloadKvFields_Data_Delete>;
  read?: Maybe<Cms_PayloadKvFields_Data_Read>;
  update?: Maybe<Cms_PayloadKvFields_Data_Update>;
};

export type Cms_PayloadKvFields_Data_Create = {
  __typename?: 'CMS_PayloadKvFields_data_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Data_Delete = {
  __typename?: 'CMS_PayloadKvFields_data_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Data_Read = {
  __typename?: 'CMS_PayloadKvFields_data_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Data_Update = {
  __typename?: 'CMS_PayloadKvFields_data_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Key = {
  __typename?: 'CMS_PayloadKvFields_key';
  create?: Maybe<Cms_PayloadKvFields_Key_Create>;
  delete?: Maybe<Cms_PayloadKvFields_Key_Delete>;
  read?: Maybe<Cms_PayloadKvFields_Key_Read>;
  update?: Maybe<Cms_PayloadKvFields_Key_Update>;
};

export type Cms_PayloadKvFields_Key_Create = {
  __typename?: 'CMS_PayloadKvFields_key_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Key_Delete = {
  __typename?: 'CMS_PayloadKvFields_key_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Key_Read = {
  __typename?: 'CMS_PayloadKvFields_key_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvFields_Key_Update = {
  __typename?: 'CMS_PayloadKvFields_key_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadKvReadAccess = {
  __typename?: 'CMS_PayloadKvReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvReadDocAccess = {
  __typename?: 'CMS_PayloadKvReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvUpdateAccess = {
  __typename?: 'CMS_PayloadKvUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKvUpdateDocAccess = {
  __typename?: 'CMS_PayloadKvUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadKv_Data_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadKv_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PayloadKv_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_PayloadKv_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_Or>>>;
  data?: InputMaybe<Cms_PayloadKv_Data_Operator>;
  id?: InputMaybe<Cms_PayloadKv_Id_Operator>;
  key?: InputMaybe<Cms_PayloadKv_Key_Operator>;
};

export type Cms_PayloadKv_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_Or>>>;
  data?: InputMaybe<Cms_PayloadKv_Data_Operator>;
  id?: InputMaybe<Cms_PayloadKv_Id_Operator>;
  key?: InputMaybe<Cms_PayloadKv_Key_Operator>;
};

export type Cms_PayloadKv_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadKv_Where_Or>>>;
  data?: InputMaybe<Cms_PayloadKv_Data_Operator>;
  id?: InputMaybe<Cms_PayloadKv_Id_Operator>;
  key?: InputMaybe<Cms_PayloadKv_Key_Operator>;
};

export type Cms_PayloadKvs = {
  __typename?: 'CMS_PayloadKvs';
  docs: Array<Cms_PayloadKv>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PayloadLockedDocument = {
  __typename?: 'CMS_PayloadLockedDocument';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<Cms_PayloadLockedDocument_Document_Relationship>;
  globalSlug?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<Cms_PayloadLockedDocument_User_Relationship>;
};


export type Cms_PayloadLockedDocumentDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_PayloadLockedDocumentUpdate_DocumentRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo {
  Comments = 'comments',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  Media = 'media',
  Pages = 'pages',
  PayloadFolders = 'payload_folders',
  ReassuranceCards = 'reassurance_cards',
  SeoCategories = 'seo_categories',
  Tenants = 'tenants',
  Users = 'users'
}

export type Cms_PayloadLockedDocumentUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo {
  Users = 'users'
}

export type Cms_PayloadLockedDocument_Document = Cms_Comment | Cms_Form | Cms_FormSubmission | Cms_Media | Cms_Page | Cms_PayloadFolder | Cms_ReassuranceCard | Cms_SeoCategory | Cms_Tenant | Cms_User;

export type Cms_PayloadLockedDocument_DocumentRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocument_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocument_DocumentRelationshipInputRelationTo {
  Comments = 'comments',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  Media = 'media',
  Pages = 'pages',
  PayloadFolders = 'payload_folders',
  ReassuranceCards = 'reassurance_cards',
  SeoCategories = 'seo_categories',
  Tenants = 'tenants',
  Users = 'users'
}

export enum Cms_PayloadLockedDocument_Document_RelationTo {
  Comments = 'comments',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  Media = 'media',
  Pages = 'pages',
  PayloadFolders = 'payload_folders',
  ReassuranceCards = 'reassurance_cards',
  SeoCategories = 'seo_categories',
  Tenants = 'tenants',
  Users = 'users'
}

export type Cms_PayloadLockedDocument_Document_Relationship = {
  __typename?: 'CMS_PayloadLockedDocument_Document_Relationship';
  relationTo?: Maybe<Cms_PayloadLockedDocument_Document_RelationTo>;
  value?: Maybe<Cms_PayloadLockedDocument_Document>;
};

export type Cms_PayloadLockedDocument_User = Cms_User;

export type Cms_PayloadLockedDocument_UserRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocument_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocument_UserRelationshipInputRelationTo {
  Users = 'users'
}

export enum Cms_PayloadLockedDocument_User_RelationTo {
  Users = 'users'
}

export type Cms_PayloadLockedDocument_User_Relationship = {
  __typename?: 'CMS_PayloadLockedDocument_User_Relationship';
  relationTo?: Maybe<Cms_PayloadLockedDocument_User_RelationTo>;
  value?: Maybe<Cms_PayloadLockedDocument_User>;
};

export type Cms_PayloadLockedDocument_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadLockedDocument_Document_Relation = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocument_Document_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocument_Document_Relation_RelationTo {
  Comments = 'comments',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  Media = 'media',
  Pages = 'pages',
  PayloadFolders = 'payload_folders',
  ReassuranceCards = 'reassurance_cards',
  SeoCategories = 'seo_categories',
  Tenants = 'tenants',
  Users = 'users'
}

export type Cms_PayloadLockedDocument_GlobalSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_PayloadLockedDocument_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PayloadLockedDocument_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadLockedDocument_User_Relation = {
  relationTo?: InputMaybe<Cms_PayloadLockedDocument_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadLockedDocument_User_Relation_RelationTo {
  Users = 'users'
}

export type Cms_PayloadLockedDocument_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<Cms_PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<Cms_PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<Cms_PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadLockedDocument_User_Relation>;
};

export type Cms_PayloadLockedDocument_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<Cms_PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<Cms_PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<Cms_PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadLockedDocument_User_Relation>;
};

export type Cms_PayloadLockedDocument_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<Cms_PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<Cms_PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<Cms_PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadLockedDocument_User_Relation>;
};

export type Cms_PayloadLockedDocuments = {
  __typename?: 'CMS_PayloadLockedDocuments';
  docs: Array<Cms_PayloadLockedDocument>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PayloadLockedDocumentsCreateAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsCreateDocAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsDeleteAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsDeleteDocAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields';
  createdAt?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt>;
  document?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_Document>;
  globalSlug?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug>;
  updatedAt?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt>;
  user?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_User>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_createdAt';
  create?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Update>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_Document = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_document';
  create?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_Document_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_Document_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_Document_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_Document_Update>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_Document_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_document_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_Document_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_document_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_Document_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_document_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_Document_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_document_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_globalSlug';
  create?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_globalSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_globalSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_globalSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_globalSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_updatedAt';
  create?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_User = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_user';
  create?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_User_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_User_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_User_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields_User_Update>;
};

export type Cms_PayloadLockedDocumentsDocAccessFields_User_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_user_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_User_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_user_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_User_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_user_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsDocAccessFields_User_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsDocAccessFields_user_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields = {
  __typename?: 'CMS_PayloadLockedDocumentsFields';
  createdAt?: Maybe<Cms_PayloadLockedDocumentsFields_CreatedAt>;
  document?: Maybe<Cms_PayloadLockedDocumentsFields_Document>;
  globalSlug?: Maybe<Cms_PayloadLockedDocumentsFields_GlobalSlug>;
  updatedAt?: Maybe<Cms_PayloadLockedDocumentsFields_UpdatedAt>;
  user?: Maybe<Cms_PayloadLockedDocumentsFields_User>;
};

export type Cms_PayloadLockedDocumentsFields_CreatedAt = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_createdAt';
  create?: Maybe<Cms_PayloadLockedDocumentsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsFields_CreatedAt_Update>;
};

export type Cms_PayloadLockedDocumentsFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_Document = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_document';
  create?: Maybe<Cms_PayloadLockedDocumentsFields_Document_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsFields_Document_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsFields_Document_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsFields_Document_Update>;
};

export type Cms_PayloadLockedDocumentsFields_Document_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_document_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_Document_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_document_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_Document_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_document_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_Document_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_document_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_GlobalSlug = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_globalSlug';
  create?: Maybe<Cms_PayloadLockedDocumentsFields_GlobalSlug_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsFields_GlobalSlug_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsFields_GlobalSlug_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsFields_GlobalSlug_Update>;
};

export type Cms_PayloadLockedDocumentsFields_GlobalSlug_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_globalSlug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_GlobalSlug_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_globalSlug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_GlobalSlug_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_globalSlug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_GlobalSlug_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_globalSlug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_UpdatedAt = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_updatedAt';
  create?: Maybe<Cms_PayloadLockedDocumentsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsFields_UpdatedAt_Update>;
};

export type Cms_PayloadLockedDocumentsFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_User = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_user';
  create?: Maybe<Cms_PayloadLockedDocumentsFields_User_Create>;
  delete?: Maybe<Cms_PayloadLockedDocumentsFields_User_Delete>;
  read?: Maybe<Cms_PayloadLockedDocumentsFields_User_Read>;
  update?: Maybe<Cms_PayloadLockedDocumentsFields_User_Update>;
};

export type Cms_PayloadLockedDocumentsFields_User_Create = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_user_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_User_Delete = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_user_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_User_Read = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_user_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsFields_User_Update = {
  __typename?: 'CMS_PayloadLockedDocumentsFields_user_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadLockedDocumentsReadAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsReadDocAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsUpdateAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadLockedDocumentsUpdateDocAccess = {
  __typename?: 'CMS_PayloadLockedDocumentsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreference = {
  __typename?: 'CMS_PayloadPreference';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<Cms_PayloadPreference_User_Relationship>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Cms_PayloadPreferenceUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadPreferenceUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadPreferenceUpdate_UserRelationshipInputRelationTo {
  Users = 'users'
}

export type Cms_PayloadPreference_User = Cms_User;

export type Cms_PayloadPreference_UserRelationshipInput = {
  relationTo?: InputMaybe<Cms_PayloadPreference_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadPreference_UserRelationshipInputRelationTo {
  Users = 'users'
}

export enum Cms_PayloadPreference_User_RelationTo {
  Users = 'users'
}

export type Cms_PayloadPreference_User_Relationship = {
  __typename?: 'CMS_PayloadPreference_User_Relationship';
  relationTo?: Maybe<Cms_PayloadPreference_User_RelationTo>;
  value?: Maybe<Cms_PayloadPreference_User>;
};

export type Cms_PayloadPreference_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadPreference_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PayloadPreference_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_PayloadPreference_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_PayloadPreference_User_Relation = {
  relationTo?: InputMaybe<Cms_PayloadPreference_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum Cms_PayloadPreference_User_Relation_RelationTo {
  Users = 'users'
}

export type Cms_PayloadPreference_Value_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  intersects?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  within?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_PayloadPreference_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<Cms_PayloadPreference_Id_Operator>;
  key?: InputMaybe<Cms_PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadPreference_User_Relation>;
  value?: InputMaybe<Cms_PayloadPreference_Value_Operator>;
};

export type Cms_PayloadPreference_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<Cms_PayloadPreference_Id_Operator>;
  key?: InputMaybe<Cms_PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadPreference_User_Relation>;
  value?: InputMaybe<Cms_PayloadPreference_Value_Operator>;
};

export type Cms_PayloadPreference_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<Cms_PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<Cms_PayloadPreference_Id_Operator>;
  key?: InputMaybe<Cms_PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<Cms_PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<Cms_PayloadPreference_User_Relation>;
  value?: InputMaybe<Cms_PayloadPreference_Value_Operator>;
};

export type Cms_PayloadPreferences = {
  __typename?: 'CMS_PayloadPreferences';
  docs: Array<Cms_PayloadPreference>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_PayloadPreferencesCreateAccess = {
  __typename?: 'CMS_PayloadPreferencesCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesCreateDocAccess = {
  __typename?: 'CMS_PayloadPreferencesCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesDeleteAccess = {
  __typename?: 'CMS_PayloadPreferencesDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesDeleteDocAccess = {
  __typename?: 'CMS_PayloadPreferencesDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesDocAccessFields = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields';
  createdAt?: Maybe<Cms_PayloadPreferencesDocAccessFields_CreatedAt>;
  key?: Maybe<Cms_PayloadPreferencesDocAccessFields_Key>;
  updatedAt?: Maybe<Cms_PayloadPreferencesDocAccessFields_UpdatedAt>;
  user?: Maybe<Cms_PayloadPreferencesDocAccessFields_User>;
  value?: Maybe<Cms_PayloadPreferencesDocAccessFields_Value>;
};

export type Cms_PayloadPreferencesDocAccessFields_CreatedAt = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_createdAt';
  create?: Maybe<Cms_PayloadPreferencesDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadPreferencesDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadPreferencesDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadPreferencesDocAccessFields_CreatedAt_Update>;
};

export type Cms_PayloadPreferencesDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Key = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_key';
  create?: Maybe<Cms_PayloadPreferencesDocAccessFields_Key_Create>;
  delete?: Maybe<Cms_PayloadPreferencesDocAccessFields_Key_Delete>;
  read?: Maybe<Cms_PayloadPreferencesDocAccessFields_Key_Read>;
  update?: Maybe<Cms_PayloadPreferencesDocAccessFields_Key_Update>;
};

export type Cms_PayloadPreferencesDocAccessFields_Key_Create = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_key_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Key_Delete = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_key_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Key_Read = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_key_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Key_Update = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_key_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_updatedAt';
  create?: Maybe<Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_User = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_user';
  create?: Maybe<Cms_PayloadPreferencesDocAccessFields_User_Create>;
  delete?: Maybe<Cms_PayloadPreferencesDocAccessFields_User_Delete>;
  read?: Maybe<Cms_PayloadPreferencesDocAccessFields_User_Read>;
  update?: Maybe<Cms_PayloadPreferencesDocAccessFields_User_Update>;
};

export type Cms_PayloadPreferencesDocAccessFields_User_Create = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_user_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_User_Delete = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_user_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_User_Read = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_user_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_User_Update = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_user_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Value = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_value';
  create?: Maybe<Cms_PayloadPreferencesDocAccessFields_Value_Create>;
  delete?: Maybe<Cms_PayloadPreferencesDocAccessFields_Value_Delete>;
  read?: Maybe<Cms_PayloadPreferencesDocAccessFields_Value_Read>;
  update?: Maybe<Cms_PayloadPreferencesDocAccessFields_Value_Update>;
};

export type Cms_PayloadPreferencesDocAccessFields_Value_Create = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_value_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Value_Delete = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_value_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Value_Read = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_value_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesDocAccessFields_Value_Update = {
  __typename?: 'CMS_PayloadPreferencesDocAccessFields_value_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields = {
  __typename?: 'CMS_PayloadPreferencesFields';
  createdAt?: Maybe<Cms_PayloadPreferencesFields_CreatedAt>;
  key?: Maybe<Cms_PayloadPreferencesFields_Key>;
  updatedAt?: Maybe<Cms_PayloadPreferencesFields_UpdatedAt>;
  user?: Maybe<Cms_PayloadPreferencesFields_User>;
  value?: Maybe<Cms_PayloadPreferencesFields_Value>;
};

export type Cms_PayloadPreferencesFields_CreatedAt = {
  __typename?: 'CMS_PayloadPreferencesFields_createdAt';
  create?: Maybe<Cms_PayloadPreferencesFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PayloadPreferencesFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PayloadPreferencesFields_CreatedAt_Read>;
  update?: Maybe<Cms_PayloadPreferencesFields_CreatedAt_Update>;
};

export type Cms_PayloadPreferencesFields_CreatedAt_Create = {
  __typename?: 'CMS_PayloadPreferencesFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_CreatedAt_Delete = {
  __typename?: 'CMS_PayloadPreferencesFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_CreatedAt_Read = {
  __typename?: 'CMS_PayloadPreferencesFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_CreatedAt_Update = {
  __typename?: 'CMS_PayloadPreferencesFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Key = {
  __typename?: 'CMS_PayloadPreferencesFields_key';
  create?: Maybe<Cms_PayloadPreferencesFields_Key_Create>;
  delete?: Maybe<Cms_PayloadPreferencesFields_Key_Delete>;
  read?: Maybe<Cms_PayloadPreferencesFields_Key_Read>;
  update?: Maybe<Cms_PayloadPreferencesFields_Key_Update>;
};

export type Cms_PayloadPreferencesFields_Key_Create = {
  __typename?: 'CMS_PayloadPreferencesFields_key_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Key_Delete = {
  __typename?: 'CMS_PayloadPreferencesFields_key_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Key_Read = {
  __typename?: 'CMS_PayloadPreferencesFields_key_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Key_Update = {
  __typename?: 'CMS_PayloadPreferencesFields_key_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_UpdatedAt = {
  __typename?: 'CMS_PayloadPreferencesFields_updatedAt';
  create?: Maybe<Cms_PayloadPreferencesFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PayloadPreferencesFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PayloadPreferencesFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PayloadPreferencesFields_UpdatedAt_Update>;
};

export type Cms_PayloadPreferencesFields_UpdatedAt_Create = {
  __typename?: 'CMS_PayloadPreferencesFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_UpdatedAt_Delete = {
  __typename?: 'CMS_PayloadPreferencesFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_UpdatedAt_Read = {
  __typename?: 'CMS_PayloadPreferencesFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_UpdatedAt_Update = {
  __typename?: 'CMS_PayloadPreferencesFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_User = {
  __typename?: 'CMS_PayloadPreferencesFields_user';
  create?: Maybe<Cms_PayloadPreferencesFields_User_Create>;
  delete?: Maybe<Cms_PayloadPreferencesFields_User_Delete>;
  read?: Maybe<Cms_PayloadPreferencesFields_User_Read>;
  update?: Maybe<Cms_PayloadPreferencesFields_User_Update>;
};

export type Cms_PayloadPreferencesFields_User_Create = {
  __typename?: 'CMS_PayloadPreferencesFields_user_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_User_Delete = {
  __typename?: 'CMS_PayloadPreferencesFields_user_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_User_Read = {
  __typename?: 'CMS_PayloadPreferencesFields_user_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_User_Update = {
  __typename?: 'CMS_PayloadPreferencesFields_user_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Value = {
  __typename?: 'CMS_PayloadPreferencesFields_value';
  create?: Maybe<Cms_PayloadPreferencesFields_Value_Create>;
  delete?: Maybe<Cms_PayloadPreferencesFields_Value_Delete>;
  read?: Maybe<Cms_PayloadPreferencesFields_Value_Read>;
  update?: Maybe<Cms_PayloadPreferencesFields_Value_Update>;
};

export type Cms_PayloadPreferencesFields_Value_Create = {
  __typename?: 'CMS_PayloadPreferencesFields_value_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Value_Delete = {
  __typename?: 'CMS_PayloadPreferencesFields_value_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Value_Read = {
  __typename?: 'CMS_PayloadPreferencesFields_value_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesFields_Value_Update = {
  __typename?: 'CMS_PayloadPreferencesFields_value_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_PayloadPreferencesReadAccess = {
  __typename?: 'CMS_PayloadPreferencesReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesReadDocAccess = {
  __typename?: 'CMS_PayloadPreferencesReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesUpdateAccess = {
  __typename?: 'CMS_PayloadPreferencesUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PayloadPreferencesUpdateDocAccess = {
  __typename?: 'CMS_PayloadPreferencesUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_PhoneCallbackBannerBlock = {
  __typename?: 'CMS_PhoneCallbackBannerBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_PictureBlock = {
  __typename?: 'CMS_PictureBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isScrollable?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Cms_PictureBlock_Mode>;
  pictureDesktop?: Maybe<Cms_Media>;
  pictureHeight?: Maybe<Cms_PictureBlock_PictureHeight>;
  pictureMobile?: Maybe<Cms_Media>;
};

export enum Cms_PictureBlock_Mode {
  Contain = 'contain',
  Cover = 'cover'
}

export enum Cms_PictureBlock_PictureHeight {
  Full = 'full',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs'
}

export type Cms_QuoteBlock = {
  __typename?: 'CMS_QuoteBlock';
  align?: Maybe<Cms_QuoteBlock_Align>;
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum Cms_QuoteBlock_Align {
  Center = 'center',
  Left = 'left'
}

export type Cms_ReassuranceCard = {
  __typename?: 'CMS_ReassuranceCard';
  _status?: Maybe<Cms_ReassuranceCard__Status>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  layout: Array<Cms_ReassuranceCard_Layout>;
  tenant?: Maybe<Cms_Tenant>;
  tenantName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Cms_ReassuranceCardBlock = {
  __typename?: 'CMS_ReassuranceCardBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  illustration?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
};

export type Cms_ReassuranceCardVersion = {
  __typename?: 'CMS_ReassuranceCardVersion';
  autosave?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latest?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Cms_ReassuranceCard>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Cms_ReassuranceCardVersion_Version>;
};


export type Cms_ReassuranceCardVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_ReassuranceCardVersion_Version = {
  __typename?: 'CMS_ReassuranceCardVersion_Version';
  _status?: Maybe<Cms_ReassuranceCardVersion_Version__Status>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  layout: Array<Cms_ReassuranceCardVersion_Version_Layout>;
  tenant?: Maybe<Cms_Tenant>;
  tenantName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Cms_ReassuranceCardVersion_Version_Layout = Cms_ReassuranceCardBlock;

export enum Cms_ReassuranceCardVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_ReassuranceCard_Layout = Cms_ReassuranceCardBlock;

export enum Cms_ReassuranceCard__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_ReassuranceCard__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_ReassuranceCard__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard__Status_Input>>>;
  equals?: InputMaybe<Cms_ReassuranceCard__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard__Status_Input>>>;
  not_equals?: InputMaybe<Cms_ReassuranceCard__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard__Status_Input>>>;
};

export type Cms_ReassuranceCard_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_ReassuranceCard_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_ReassuranceCard_TenantName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_ReassuranceCard_Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_ReassuranceCard_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_ReassuranceCard_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_Or>>>;
  _status?: InputMaybe<Cms_ReassuranceCard__Status_Operator>;
  createdAt?: InputMaybe<Cms_ReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_ReassuranceCard_Id_Operator>;
  tenant?: InputMaybe<Cms_ReassuranceCard_Tenant_Operator>;
  tenantName?: InputMaybe<Cms_ReassuranceCard_TenantName_Operator>;
  updatedAt?: InputMaybe<Cms_ReassuranceCard_UpdatedAt_Operator>;
};

export type Cms_ReassuranceCard_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_Or>>>;
  _status?: InputMaybe<Cms_ReassuranceCard__Status_Operator>;
  createdAt?: InputMaybe<Cms_ReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_ReassuranceCard_Id_Operator>;
  tenant?: InputMaybe<Cms_ReassuranceCard_Tenant_Operator>;
  tenantName?: InputMaybe<Cms_ReassuranceCard_TenantName_Operator>;
  updatedAt?: InputMaybe<Cms_ReassuranceCard_UpdatedAt_Operator>;
};

export type Cms_ReassuranceCard_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_ReassuranceCard_Where_Or>>>;
  _status?: InputMaybe<Cms_ReassuranceCard__Status_Operator>;
  createdAt?: InputMaybe<Cms_ReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_ReassuranceCard_Id_Operator>;
  tenant?: InputMaybe<Cms_ReassuranceCard_Tenant_Operator>;
  tenantName?: InputMaybe<Cms_ReassuranceCard_TenantName_Operator>;
  updatedAt?: InputMaybe<Cms_ReassuranceCard_UpdatedAt_Operator>;
};

export type Cms_ReassuranceCards = {
  __typename?: 'CMS_ReassuranceCards';
  docs: Array<Cms_ReassuranceCard>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_ReassuranceCardsCreateAccess = {
  __typename?: 'CMS_ReassuranceCardsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsCreateDocAccess = {
  __typename?: 'CMS_ReassuranceCardsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsDeleteAccess = {
  __typename?: 'CMS_ReassuranceCardsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsDeleteDocAccess = {
  __typename?: 'CMS_ReassuranceCardsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsDocAccessFields = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields';
  _status?: Maybe<Cms_ReassuranceCardsDocAccessFields__Status>;
  createdAt?: Maybe<Cms_ReassuranceCardsDocAccessFields_CreatedAt>;
  layout?: Maybe<Cms_ReassuranceCardsDocAccessFields_Layout>;
  tenant?: Maybe<Cms_ReassuranceCardsDocAccessFields_Tenant>;
  tenantName?: Maybe<Cms_ReassuranceCardsDocAccessFields_TenantName>;
  updatedAt?: Maybe<Cms_ReassuranceCardsDocAccessFields_UpdatedAt>;
};

export type Cms_ReassuranceCardsDocAccessFields__Status = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields__status';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields__Status_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields__Status_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields__Status_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields__Status_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields__Status_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields__Status_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields__Status_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields__Status_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_createdAt';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields_CreatedAt_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Layout = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_layout';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields_Layout_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields_Layout_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields_Layout_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields_Layout_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields_Layout_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_layout_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Layout_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_layout_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Layout_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_layout_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Layout_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_layout_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Tenant = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenant';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields_Tenant_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields_Tenant_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields_Tenant_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields_Tenant_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields_TenantName = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenantName';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields_TenantName_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields_TenantName_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields_TenantName_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields_TenantName_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields_TenantName_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenantName_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_TenantName_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenantName_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_TenantName_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenantName_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_TenantName_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenantName_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Tenant_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Tenant_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Tenant_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_Tenant_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_updatedAt';
  create?: Maybe<Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_ReassuranceCardsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields = {
  __typename?: 'CMS_ReassuranceCardsFields';
  _status?: Maybe<Cms_ReassuranceCardsFields__Status>;
  createdAt?: Maybe<Cms_ReassuranceCardsFields_CreatedAt>;
  layout?: Maybe<Cms_ReassuranceCardsFields_Layout>;
  tenant?: Maybe<Cms_ReassuranceCardsFields_Tenant>;
  tenantName?: Maybe<Cms_ReassuranceCardsFields_TenantName>;
  updatedAt?: Maybe<Cms_ReassuranceCardsFields_UpdatedAt>;
};

export type Cms_ReassuranceCardsFields__Status = {
  __typename?: 'CMS_ReassuranceCardsFields__status';
  create?: Maybe<Cms_ReassuranceCardsFields__Status_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields__Status_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields__Status_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields__Status_Update>;
};

export type Cms_ReassuranceCardsFields__Status_Create = {
  __typename?: 'CMS_ReassuranceCardsFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields__Status_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields__Status_Read = {
  __typename?: 'CMS_ReassuranceCardsFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields__Status_Update = {
  __typename?: 'CMS_ReassuranceCardsFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_CreatedAt = {
  __typename?: 'CMS_ReassuranceCardsFields_createdAt';
  create?: Maybe<Cms_ReassuranceCardsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields_CreatedAt_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields_CreatedAt_Update>;
};

export type Cms_ReassuranceCardsFields_CreatedAt_Create = {
  __typename?: 'CMS_ReassuranceCardsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_CreatedAt_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_CreatedAt_Read = {
  __typename?: 'CMS_ReassuranceCardsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_CreatedAt_Update = {
  __typename?: 'CMS_ReassuranceCardsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Layout = {
  __typename?: 'CMS_ReassuranceCardsFields_layout';
  create?: Maybe<Cms_ReassuranceCardsFields_Layout_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields_Layout_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields_Layout_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields_Layout_Update>;
};

export type Cms_ReassuranceCardsFields_Layout_Create = {
  __typename?: 'CMS_ReassuranceCardsFields_layout_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Layout_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields_layout_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Layout_Read = {
  __typename?: 'CMS_ReassuranceCardsFields_layout_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Layout_Update = {
  __typename?: 'CMS_ReassuranceCardsFields_layout_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Tenant = {
  __typename?: 'CMS_ReassuranceCardsFields_tenant';
  create?: Maybe<Cms_ReassuranceCardsFields_Tenant_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields_Tenant_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields_Tenant_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields_Tenant_Update>;
};

export type Cms_ReassuranceCardsFields_TenantName = {
  __typename?: 'CMS_ReassuranceCardsFields_tenantName';
  create?: Maybe<Cms_ReassuranceCardsFields_TenantName_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields_TenantName_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields_TenantName_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields_TenantName_Update>;
};

export type Cms_ReassuranceCardsFields_TenantName_Create = {
  __typename?: 'CMS_ReassuranceCardsFields_tenantName_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_TenantName_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields_tenantName_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_TenantName_Read = {
  __typename?: 'CMS_ReassuranceCardsFields_tenantName_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_TenantName_Update = {
  __typename?: 'CMS_ReassuranceCardsFields_tenantName_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Tenant_Create = {
  __typename?: 'CMS_ReassuranceCardsFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Tenant_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Tenant_Read = {
  __typename?: 'CMS_ReassuranceCardsFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_Tenant_Update = {
  __typename?: 'CMS_ReassuranceCardsFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_UpdatedAt = {
  __typename?: 'CMS_ReassuranceCardsFields_updatedAt';
  create?: Maybe<Cms_ReassuranceCardsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_ReassuranceCardsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_ReassuranceCardsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_ReassuranceCardsFields_UpdatedAt_Update>;
};

export type Cms_ReassuranceCardsFields_UpdatedAt_Create = {
  __typename?: 'CMS_ReassuranceCardsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_ReassuranceCardsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_UpdatedAt_Read = {
  __typename?: 'CMS_ReassuranceCardsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsFields_UpdatedAt_Update = {
  __typename?: 'CMS_ReassuranceCardsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_ReassuranceCardsReadAccess = {
  __typename?: 'CMS_ReassuranceCardsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsReadDocAccess = {
  __typename?: 'CMS_ReassuranceCardsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsReadVersionsAccess = {
  __typename?: 'CMS_ReassuranceCardsReadVersionsAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsReadVersionsDocAccess = {
  __typename?: 'CMS_ReassuranceCardsReadVersionsDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsUpdateAccess = {
  __typename?: 'CMS_ReassuranceCardsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_ReassuranceCardsUpdateDocAccess = {
  __typename?: 'CMS_ReassuranceCardsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SectionHeaderBlock = {
  __typename?: 'CMS_SectionHeaderBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionSize?: Maybe<Cms_SectionHeaderBlock_DescriptionSize>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Array<Cms_SectionHeaderBlock_Link>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAs?: Maybe<Cms_SectionHeaderBlock_TitleAs>;
};

export type Cms_SectionHeaderBlock_Link = {
  __typename?: 'CMS_SectionHeaderBlock_Link';
  iconLeft?: Maybe<Scalars['String']['output']>;
  iconRight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export enum Cms_SectionHeaderBlock_DescriptionSize {
  '3xl' = '_3xl',
  Lg = 'lg'
}

export enum Cms_SectionHeaderBlock_TitleAs {
  H2 = 'h2',
  H3 = 'h3'
}

export type Cms_SeoCategories = {
  __typename?: 'CMS_SeoCategories';
  docs: Array<Cms_SeoCategory>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_SeoCategoriesCreateAccess = {
  __typename?: 'CMS_SeoCategoriesCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesCreateDocAccess = {
  __typename?: 'CMS_SeoCategoriesCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesDeleteAccess = {
  __typename?: 'CMS_SeoCategoriesDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesDeleteDocAccess = {
  __typename?: 'CMS_SeoCategoriesDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesDocAccessFields = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields';
  _status?: Maybe<Cms_SeoCategoriesDocAccessFields__Status>;
  categoryCode?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryCode>;
  categoryName?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryName>;
  createdAt?: Maybe<Cms_SeoCategoriesDocAccessFields_CreatedAt>;
  seoContent?: Maybe<Cms_SeoCategoriesDocAccessFields_SeoContent>;
  tenant?: Maybe<Cms_SeoCategoriesDocAccessFields_Tenant>;
  updatedAt?: Maybe<Cms_SeoCategoriesDocAccessFields_UpdatedAt>;
};

export type Cms_SeoCategoriesDocAccessFields__Status = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields__status';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields__Status_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields__Status_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields__Status_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields__Status_Update>;
};

export type Cms_SeoCategoriesDocAccessFields__Status_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields__Status_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields__Status_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields__Status_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryCode = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryCode';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryCode_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryCode_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryCode_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryCode_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_CategoryCode_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryCode_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryCode_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryCode_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryCode_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryCode_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryCode_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryCode_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryName = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryName';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryName_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryName_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryName_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_CategoryName_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_CategoryName_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryName_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryName_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryName_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryName_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryName_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CategoryName_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_categoryName_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CreatedAt = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_createdAt';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_CreatedAt_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_SeoContent = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_seoContent';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_SeoContent_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_SeoContent_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_SeoContent_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_SeoContent_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_SeoContent_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_seoContent_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_SeoContent_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_seoContent_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_SeoContent_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_seoContent_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_SeoContent_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_seoContent_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_Tenant = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_tenant';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_Tenant_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_Tenant_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_Tenant_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_Tenant_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_Tenant_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_Tenant_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_Tenant_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_Tenant_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_updatedAt';
  create?: Maybe<Cms_SeoCategoriesDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_SeoCategoriesDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_SeoCategoriesDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_SeoCategoriesDocAccessFields_UpdatedAt_Update>;
};

export type Cms_SeoCategoriesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_SeoCategoriesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields = {
  __typename?: 'CMS_SeoCategoriesFields';
  _status?: Maybe<Cms_SeoCategoriesFields__Status>;
  categoryCode?: Maybe<Cms_SeoCategoriesFields_CategoryCode>;
  categoryName?: Maybe<Cms_SeoCategoriesFields_CategoryName>;
  createdAt?: Maybe<Cms_SeoCategoriesFields_CreatedAt>;
  seoContent?: Maybe<Cms_SeoCategoriesFields_SeoContent>;
  tenant?: Maybe<Cms_SeoCategoriesFields_Tenant>;
  updatedAt?: Maybe<Cms_SeoCategoriesFields_UpdatedAt>;
};

export type Cms_SeoCategoriesFields__Status = {
  __typename?: 'CMS_SeoCategoriesFields__status';
  create?: Maybe<Cms_SeoCategoriesFields__Status_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields__Status_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields__Status_Read>;
  update?: Maybe<Cms_SeoCategoriesFields__Status_Update>;
};

export type Cms_SeoCategoriesFields__Status_Create = {
  __typename?: 'CMS_SeoCategoriesFields__status_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields__Status_Delete = {
  __typename?: 'CMS_SeoCategoriesFields__status_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields__Status_Read = {
  __typename?: 'CMS_SeoCategoriesFields__status_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields__Status_Update = {
  __typename?: 'CMS_SeoCategoriesFields__status_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryCode = {
  __typename?: 'CMS_SeoCategoriesFields_categoryCode';
  create?: Maybe<Cms_SeoCategoriesFields_CategoryCode_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_CategoryCode_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_CategoryCode_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_CategoryCode_Update>;
};

export type Cms_SeoCategoriesFields_CategoryCode_Create = {
  __typename?: 'CMS_SeoCategoriesFields_categoryCode_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryCode_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_categoryCode_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryCode_Read = {
  __typename?: 'CMS_SeoCategoriesFields_categoryCode_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryCode_Update = {
  __typename?: 'CMS_SeoCategoriesFields_categoryCode_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryName = {
  __typename?: 'CMS_SeoCategoriesFields_categoryName';
  create?: Maybe<Cms_SeoCategoriesFields_CategoryName_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_CategoryName_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_CategoryName_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_CategoryName_Update>;
};

export type Cms_SeoCategoriesFields_CategoryName_Create = {
  __typename?: 'CMS_SeoCategoriesFields_categoryName_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryName_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_categoryName_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryName_Read = {
  __typename?: 'CMS_SeoCategoriesFields_categoryName_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CategoryName_Update = {
  __typename?: 'CMS_SeoCategoriesFields_categoryName_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CreatedAt = {
  __typename?: 'CMS_SeoCategoriesFields_createdAt';
  create?: Maybe<Cms_SeoCategoriesFields_CreatedAt_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_CreatedAt_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_CreatedAt_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_CreatedAt_Update>;
};

export type Cms_SeoCategoriesFields_CreatedAt_Create = {
  __typename?: 'CMS_SeoCategoriesFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CreatedAt_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CreatedAt_Read = {
  __typename?: 'CMS_SeoCategoriesFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_CreatedAt_Update = {
  __typename?: 'CMS_SeoCategoriesFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_SeoContent = {
  __typename?: 'CMS_SeoCategoriesFields_seoContent';
  create?: Maybe<Cms_SeoCategoriesFields_SeoContent_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_SeoContent_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_SeoContent_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_SeoContent_Update>;
};

export type Cms_SeoCategoriesFields_SeoContent_Create = {
  __typename?: 'CMS_SeoCategoriesFields_seoContent_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_SeoContent_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_seoContent_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_SeoContent_Read = {
  __typename?: 'CMS_SeoCategoriesFields_seoContent_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_SeoContent_Update = {
  __typename?: 'CMS_SeoCategoriesFields_seoContent_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_Tenant = {
  __typename?: 'CMS_SeoCategoriesFields_tenant';
  create?: Maybe<Cms_SeoCategoriesFields_Tenant_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_Tenant_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_Tenant_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_Tenant_Update>;
};

export type Cms_SeoCategoriesFields_Tenant_Create = {
  __typename?: 'CMS_SeoCategoriesFields_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_Tenant_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_Tenant_Read = {
  __typename?: 'CMS_SeoCategoriesFields_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_Tenant_Update = {
  __typename?: 'CMS_SeoCategoriesFields_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_UpdatedAt = {
  __typename?: 'CMS_SeoCategoriesFields_updatedAt';
  create?: Maybe<Cms_SeoCategoriesFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_SeoCategoriesFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_SeoCategoriesFields_UpdatedAt_Read>;
  update?: Maybe<Cms_SeoCategoriesFields_UpdatedAt_Update>;
};

export type Cms_SeoCategoriesFields_UpdatedAt_Create = {
  __typename?: 'CMS_SeoCategoriesFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_UpdatedAt_Delete = {
  __typename?: 'CMS_SeoCategoriesFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_UpdatedAt_Read = {
  __typename?: 'CMS_SeoCategoriesFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesFields_UpdatedAt_Update = {
  __typename?: 'CMS_SeoCategoriesFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_SeoCategoriesReadAccess = {
  __typename?: 'CMS_SeoCategoriesReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesReadDocAccess = {
  __typename?: 'CMS_SeoCategoriesReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesReadVersionsAccess = {
  __typename?: 'CMS_SeoCategoriesReadVersionsAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesReadVersionsDocAccess = {
  __typename?: 'CMS_SeoCategoriesReadVersionsDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesUpdateAccess = {
  __typename?: 'CMS_SeoCategoriesUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategoriesUpdateDocAccess = {
  __typename?: 'CMS_SeoCategoriesUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_SeoCategory = {
  __typename?: 'CMS_SeoCategory';
  _status?: Maybe<Cms_SeoCategory__Status>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  seoContent?: Maybe<Scalars['JSON']['output']>;
  tenant?: Maybe<Cms_Tenant>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type Cms_SeoCategorySeoContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_SeoCategoryVersion = {
  __typename?: 'CMS_SeoCategoryVersion';
  autosave?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latest?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Cms_SeoCategory>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Cms_SeoCategoryVersion_Version>;
};


export type Cms_SeoCategoryVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_SeoCategoryVersion_Version = {
  __typename?: 'CMS_SeoCategoryVersion_Version';
  _status?: Maybe<Cms_SeoCategoryVersion_Version__Status>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  seoContent?: Maybe<Scalars['JSON']['output']>;
  tenant?: Maybe<Cms_Tenant>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type Cms_SeoCategoryVersion_VersionSeoContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export enum Cms_SeoCategoryVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_SeoCategory__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_SeoCategory__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_SeoCategory__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_SeoCategory__Status_Input>>>;
  equals?: InputMaybe<Cms_SeoCategory__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_SeoCategory__Status_Input>>>;
  not_equals?: InputMaybe<Cms_SeoCategory__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_SeoCategory__Status_Input>>>;
};

export type Cms_SeoCategory_CategoryCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_SeoCategory_CategoryName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_SeoCategory_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_SeoCategory_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_SeoCategory_SeoContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_SeoCategory_Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_SeoCategory_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_SeoCategory_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_Or>>>;
  _status?: InputMaybe<Cms_SeoCategory__Status_Operator>;
  categoryCode?: InputMaybe<Cms_SeoCategory_CategoryCode_Operator>;
  categoryName?: InputMaybe<Cms_SeoCategory_CategoryName_Operator>;
  createdAt?: InputMaybe<Cms_SeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_SeoCategory_Id_Operator>;
  seoContent?: InputMaybe<Cms_SeoCategory_SeoContent_Operator>;
  tenant?: InputMaybe<Cms_SeoCategory_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_SeoCategory_UpdatedAt_Operator>;
};

export type Cms_SeoCategory_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_Or>>>;
  _status?: InputMaybe<Cms_SeoCategory__Status_Operator>;
  categoryCode?: InputMaybe<Cms_SeoCategory_CategoryCode_Operator>;
  categoryName?: InputMaybe<Cms_SeoCategory_CategoryName_Operator>;
  createdAt?: InputMaybe<Cms_SeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_SeoCategory_Id_Operator>;
  seoContent?: InputMaybe<Cms_SeoCategory_SeoContent_Operator>;
  tenant?: InputMaybe<Cms_SeoCategory_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_SeoCategory_UpdatedAt_Operator>;
};

export type Cms_SeoCategory_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_SeoCategory_Where_Or>>>;
  _status?: InputMaybe<Cms_SeoCategory__Status_Operator>;
  categoryCode?: InputMaybe<Cms_SeoCategory_CategoryCode_Operator>;
  categoryName?: InputMaybe<Cms_SeoCategory_CategoryName_Operator>;
  createdAt?: InputMaybe<Cms_SeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_SeoCategory_Id_Operator>;
  seoContent?: InputMaybe<Cms_SeoCategory_SeoContent_Operator>;
  tenant?: InputMaybe<Cms_SeoCategory_Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_SeoCategory_UpdatedAt_Operator>;
};

export type Cms_SimpleTableBlock = {
  __typename?: 'CMS_SimpleTableBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  overflowing?: Maybe<Scalars['Boolean']['output']>;
  rows: Array<Cms_SimpleTableBlock_Rows>;
};

export type Cms_SimpleTableBlock_Rows = {
  __typename?: 'CMS_SimpleTableBlock_Rows';
  columns: Array<Cms_SimpleTableBlock_Rows_Columns>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_SimpleTableBlock_Rows_Columns = {
  __typename?: 'CMS_SimpleTableBlock_Rows_Columns';
  align?: Maybe<Scalars['String']['output']>;
  contentRichText?: Maybe<Scalars['JSON']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tint?: Maybe<Scalars['String']['output']>;
  verticalAlign?: Maybe<Scalars['String']['output']>;
};


export type Cms_SimpleTableBlock_Rows_ColumnsContentRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_SkinBlock = {
  __typename?: 'CMS_SkinBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  layout: Array<Cms_SkinBlock_Layout>;
  tint?: Maybe<Scalars['String']['output']>;
};

export type Cms_SkinBlock_Layout = Cms_BrandsSliderBlock | Cms_CalloutBlock | Cms_CatalogListBlock | Cms_ColumnsBlock | Cms_InnerHtmlBlock | Cms_PhoneCallbackBannerBlock | Cms_PictureBlock | Cms_SectionHeaderBlock | Cms_TwoColumnsImageBlock | Cms_VideoPlayerBlock;

export type Cms_StepBlock = {
  __typename?: 'CMS_StepBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  illustration?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cms_Tenant = {
  __typename?: 'CMS_Tenant';
  allowPublicRead?: Maybe<Scalars['Boolean']['output']>;
  apiEndpoint?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Cms_Tenant_AllowPublicRead_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_Tenant_ApiEndpoint_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Tenant_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Tenant_Domain_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Tenant_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_Tenant_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Tenant_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_Tenant_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_Tenant_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_Or>>>;
  allowPublicRead?: InputMaybe<Cms_Tenant_AllowPublicRead_Operator>;
  apiEndpoint?: InputMaybe<Cms_Tenant_ApiEndpoint_Operator>;
  createdAt?: InputMaybe<Cms_Tenant_CreatedAt_Operator>;
  domain?: InputMaybe<Cms_Tenant_Domain_Operator>;
  id?: InputMaybe<Cms_Tenant_Id_Operator>;
  name?: InputMaybe<Cms_Tenant_Name_Operator>;
  slug?: InputMaybe<Cms_Tenant_Slug_Operator>;
  updatedAt?: InputMaybe<Cms_Tenant_UpdatedAt_Operator>;
};

export type Cms_Tenant_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_Or>>>;
  allowPublicRead?: InputMaybe<Cms_Tenant_AllowPublicRead_Operator>;
  apiEndpoint?: InputMaybe<Cms_Tenant_ApiEndpoint_Operator>;
  createdAt?: InputMaybe<Cms_Tenant_CreatedAt_Operator>;
  domain?: InputMaybe<Cms_Tenant_Domain_Operator>;
  id?: InputMaybe<Cms_Tenant_Id_Operator>;
  name?: InputMaybe<Cms_Tenant_Name_Operator>;
  slug?: InputMaybe<Cms_Tenant_Slug_Operator>;
  updatedAt?: InputMaybe<Cms_Tenant_UpdatedAt_Operator>;
};

export type Cms_Tenant_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Tenant_Where_Or>>>;
  allowPublicRead?: InputMaybe<Cms_Tenant_AllowPublicRead_Operator>;
  apiEndpoint?: InputMaybe<Cms_Tenant_ApiEndpoint_Operator>;
  createdAt?: InputMaybe<Cms_Tenant_CreatedAt_Operator>;
  domain?: InputMaybe<Cms_Tenant_Domain_Operator>;
  id?: InputMaybe<Cms_Tenant_Id_Operator>;
  name?: InputMaybe<Cms_Tenant_Name_Operator>;
  slug?: InputMaybe<Cms_Tenant_Slug_Operator>;
  updatedAt?: InputMaybe<Cms_Tenant_UpdatedAt_Operator>;
};

export type Cms_Tenants = {
  __typename?: 'CMS_Tenants';
  docs: Array<Cms_Tenant>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_TenantsCreateAccess = {
  __typename?: 'CMS_TenantsCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsCreateDocAccess = {
  __typename?: 'CMS_TenantsCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsDeleteAccess = {
  __typename?: 'CMS_TenantsDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsDeleteDocAccess = {
  __typename?: 'CMS_TenantsDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsDocAccessFields = {
  __typename?: 'CMS_TenantsDocAccessFields';
  allowPublicRead?: Maybe<Cms_TenantsDocAccessFields_AllowPublicRead>;
  apiEndpoint?: Maybe<Cms_TenantsDocAccessFields_ApiEndpoint>;
  createdAt?: Maybe<Cms_TenantsDocAccessFields_CreatedAt>;
  domain?: Maybe<Cms_TenantsDocAccessFields_Domain>;
  name?: Maybe<Cms_TenantsDocAccessFields_Name>;
  slug?: Maybe<Cms_TenantsDocAccessFields_Slug>;
  updatedAt?: Maybe<Cms_TenantsDocAccessFields_UpdatedAt>;
};

export type Cms_TenantsDocAccessFields_AllowPublicRead = {
  __typename?: 'CMS_TenantsDocAccessFields_allowPublicRead';
  create?: Maybe<Cms_TenantsDocAccessFields_AllowPublicRead_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_AllowPublicRead_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_AllowPublicRead_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_AllowPublicRead_Update>;
};

export type Cms_TenantsDocAccessFields_AllowPublicRead_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_allowPublicRead_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_AllowPublicRead_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_allowPublicRead_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_AllowPublicRead_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_allowPublicRead_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_AllowPublicRead_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_allowPublicRead_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_ApiEndpoint = {
  __typename?: 'CMS_TenantsDocAccessFields_apiEndpoint';
  create?: Maybe<Cms_TenantsDocAccessFields_ApiEndpoint_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_ApiEndpoint_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_ApiEndpoint_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_ApiEndpoint_Update>;
};

export type Cms_TenantsDocAccessFields_ApiEndpoint_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_apiEndpoint_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_ApiEndpoint_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_apiEndpoint_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_ApiEndpoint_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_apiEndpoint_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_ApiEndpoint_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_apiEndpoint_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_CreatedAt = {
  __typename?: 'CMS_TenantsDocAccessFields_createdAt';
  create?: Maybe<Cms_TenantsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_CreatedAt_Update>;
};

export type Cms_TenantsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Domain = {
  __typename?: 'CMS_TenantsDocAccessFields_domain';
  create?: Maybe<Cms_TenantsDocAccessFields_Domain_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_Domain_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_Domain_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_Domain_Update>;
};

export type Cms_TenantsDocAccessFields_Domain_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_domain_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Domain_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_domain_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Domain_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_domain_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Domain_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_domain_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Name = {
  __typename?: 'CMS_TenantsDocAccessFields_name';
  create?: Maybe<Cms_TenantsDocAccessFields_Name_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_Name_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_Name_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_Name_Update>;
};

export type Cms_TenantsDocAccessFields_Name_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_name_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Name_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_name_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Name_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_name_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Name_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_name_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Slug = {
  __typename?: 'CMS_TenantsDocAccessFields_slug';
  create?: Maybe<Cms_TenantsDocAccessFields_Slug_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_Slug_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_Slug_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_Slug_Update>;
};

export type Cms_TenantsDocAccessFields_Slug_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_slug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Slug_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_slug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Slug_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_slug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_Slug_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_slug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_TenantsDocAccessFields_updatedAt';
  create?: Maybe<Cms_TenantsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_TenantsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_TenantsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_TenantsDocAccessFields_UpdatedAt_Update>;
};

export type Cms_TenantsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_TenantsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_TenantsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_TenantsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_TenantsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields = {
  __typename?: 'CMS_TenantsFields';
  allowPublicRead?: Maybe<Cms_TenantsFields_AllowPublicRead>;
  apiEndpoint?: Maybe<Cms_TenantsFields_ApiEndpoint>;
  createdAt?: Maybe<Cms_TenantsFields_CreatedAt>;
  domain?: Maybe<Cms_TenantsFields_Domain>;
  name?: Maybe<Cms_TenantsFields_Name>;
  slug?: Maybe<Cms_TenantsFields_Slug>;
  updatedAt?: Maybe<Cms_TenantsFields_UpdatedAt>;
};

export type Cms_TenantsFields_AllowPublicRead = {
  __typename?: 'CMS_TenantsFields_allowPublicRead';
  create?: Maybe<Cms_TenantsFields_AllowPublicRead_Create>;
  delete?: Maybe<Cms_TenantsFields_AllowPublicRead_Delete>;
  read?: Maybe<Cms_TenantsFields_AllowPublicRead_Read>;
  update?: Maybe<Cms_TenantsFields_AllowPublicRead_Update>;
};

export type Cms_TenantsFields_AllowPublicRead_Create = {
  __typename?: 'CMS_TenantsFields_allowPublicRead_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_AllowPublicRead_Delete = {
  __typename?: 'CMS_TenantsFields_allowPublicRead_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_AllowPublicRead_Read = {
  __typename?: 'CMS_TenantsFields_allowPublicRead_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_AllowPublicRead_Update = {
  __typename?: 'CMS_TenantsFields_allowPublicRead_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_ApiEndpoint = {
  __typename?: 'CMS_TenantsFields_apiEndpoint';
  create?: Maybe<Cms_TenantsFields_ApiEndpoint_Create>;
  delete?: Maybe<Cms_TenantsFields_ApiEndpoint_Delete>;
  read?: Maybe<Cms_TenantsFields_ApiEndpoint_Read>;
  update?: Maybe<Cms_TenantsFields_ApiEndpoint_Update>;
};

export type Cms_TenantsFields_ApiEndpoint_Create = {
  __typename?: 'CMS_TenantsFields_apiEndpoint_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_ApiEndpoint_Delete = {
  __typename?: 'CMS_TenantsFields_apiEndpoint_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_ApiEndpoint_Read = {
  __typename?: 'CMS_TenantsFields_apiEndpoint_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_ApiEndpoint_Update = {
  __typename?: 'CMS_TenantsFields_apiEndpoint_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_CreatedAt = {
  __typename?: 'CMS_TenantsFields_createdAt';
  create?: Maybe<Cms_TenantsFields_CreatedAt_Create>;
  delete?: Maybe<Cms_TenantsFields_CreatedAt_Delete>;
  read?: Maybe<Cms_TenantsFields_CreatedAt_Read>;
  update?: Maybe<Cms_TenantsFields_CreatedAt_Update>;
};

export type Cms_TenantsFields_CreatedAt_Create = {
  __typename?: 'CMS_TenantsFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_CreatedAt_Delete = {
  __typename?: 'CMS_TenantsFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_CreatedAt_Read = {
  __typename?: 'CMS_TenantsFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_CreatedAt_Update = {
  __typename?: 'CMS_TenantsFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Domain = {
  __typename?: 'CMS_TenantsFields_domain';
  create?: Maybe<Cms_TenantsFields_Domain_Create>;
  delete?: Maybe<Cms_TenantsFields_Domain_Delete>;
  read?: Maybe<Cms_TenantsFields_Domain_Read>;
  update?: Maybe<Cms_TenantsFields_Domain_Update>;
};

export type Cms_TenantsFields_Domain_Create = {
  __typename?: 'CMS_TenantsFields_domain_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Domain_Delete = {
  __typename?: 'CMS_TenantsFields_domain_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Domain_Read = {
  __typename?: 'CMS_TenantsFields_domain_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Domain_Update = {
  __typename?: 'CMS_TenantsFields_domain_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Name = {
  __typename?: 'CMS_TenantsFields_name';
  create?: Maybe<Cms_TenantsFields_Name_Create>;
  delete?: Maybe<Cms_TenantsFields_Name_Delete>;
  read?: Maybe<Cms_TenantsFields_Name_Read>;
  update?: Maybe<Cms_TenantsFields_Name_Update>;
};

export type Cms_TenantsFields_Name_Create = {
  __typename?: 'CMS_TenantsFields_name_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Name_Delete = {
  __typename?: 'CMS_TenantsFields_name_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Name_Read = {
  __typename?: 'CMS_TenantsFields_name_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Name_Update = {
  __typename?: 'CMS_TenantsFields_name_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Slug = {
  __typename?: 'CMS_TenantsFields_slug';
  create?: Maybe<Cms_TenantsFields_Slug_Create>;
  delete?: Maybe<Cms_TenantsFields_Slug_Delete>;
  read?: Maybe<Cms_TenantsFields_Slug_Read>;
  update?: Maybe<Cms_TenantsFields_Slug_Update>;
};

export type Cms_TenantsFields_Slug_Create = {
  __typename?: 'CMS_TenantsFields_slug_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Slug_Delete = {
  __typename?: 'CMS_TenantsFields_slug_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Slug_Read = {
  __typename?: 'CMS_TenantsFields_slug_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_Slug_Update = {
  __typename?: 'CMS_TenantsFields_slug_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_UpdatedAt = {
  __typename?: 'CMS_TenantsFields_updatedAt';
  create?: Maybe<Cms_TenantsFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_TenantsFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_TenantsFields_UpdatedAt_Read>;
  update?: Maybe<Cms_TenantsFields_UpdatedAt_Update>;
};

export type Cms_TenantsFields_UpdatedAt_Create = {
  __typename?: 'CMS_TenantsFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_UpdatedAt_Delete = {
  __typename?: 'CMS_TenantsFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_UpdatedAt_Read = {
  __typename?: 'CMS_TenantsFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsFields_UpdatedAt_Update = {
  __typename?: 'CMS_TenantsFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_TenantsReadAccess = {
  __typename?: 'CMS_TenantsReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsReadDocAccess = {
  __typename?: 'CMS_TenantsReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsUpdateAccess = {
  __typename?: 'CMS_TenantsUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_TenantsUpdateDocAccess = {
  __typename?: 'CMS_TenantsUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_Text = {
  __typename?: 'CMS_Text';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Cms_TwoColumnsImageBlock = {
  __typename?: 'CMS_TwoColumnsImageBlock';
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Array<Cms_TwoColumnsImageBlock_Link>>;
  picture?: Maybe<Cms_Media>;
  pictureLinkTarget?: Maybe<Cms_TwoColumnsImageBlock_PictureLinkTarget>;
  pictureLinkUrl?: Maybe<Scalars['String']['output']>;
  picturePosition?: Maybe<Cms_TwoColumnsImageBlock_PicturePosition>;
  tint?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type Cms_TwoColumnsImageBlockContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_TwoColumnsImageBlock_Link = {
  __typename?: 'CMS_TwoColumnsImageBlock_Link';
  iconLeft?: Maybe<Scalars['String']['output']>;
  iconRight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export enum Cms_TwoColumnsImageBlock_PictureLinkTarget {
  Blank = '_blank',
  Self = '_self'
}

export enum Cms_TwoColumnsImageBlock_PicturePosition {
  Left = 'left',
  Right = 'right'
}

export type Cms_User = {
  __typename?: 'CMS_User';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['EmailAddress']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lockUntil?: Maybe<Scalars['DateTime']['output']>;
  loginAttempts?: Maybe<Scalars['Float']['output']>;
  resetPasswordExpiration?: Maybe<Scalars['DateTime']['output']>;
  resetPasswordToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Cms_User_Role>;
  salt?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Cms_User_Sessions>>;
  tenants?: Maybe<Array<Cms_User_Tenants>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum Cms_UserUpdate_Role_MutationInput {
  Admin = 'admin',
  AdminEditor = 'admin_editor',
  Contributor = 'contributor',
  Editor = 'editor',
  Reviewer = 'reviewer'
}

export type Cms_User_Sessions = {
  __typename?: 'CMS_User_Sessions';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Cms_User_Tenants = {
  __typename?: 'CMS_User_Tenants';
  id?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Cms_Tenant>;
};

export type Cms_User_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_User_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  contains?: InputMaybe<Scalars['EmailAddress']['input']>;
  equals?: InputMaybe<Scalars['EmailAddress']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  like?: InputMaybe<Scalars['EmailAddress']['input']>;
  not_equals?: InputMaybe<Scalars['EmailAddress']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
};

export type Cms_User_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export enum Cms_User_Role {
  Admin = 'admin',
  AdminEditor = 'admin_editor',
  Contributor = 'contributor',
  Editor = 'editor',
  Reviewer = 'reviewer'
}

export enum Cms_User_Role_Input {
  Admin = 'admin',
  AdminEditor = 'admin_editor',
  Contributor = 'contributor',
  Editor = 'editor',
  Reviewer = 'reviewer'
}

export enum Cms_User_Role_MutationInput {
  Admin = 'admin',
  AdminEditor = 'admin_editor',
  Contributor = 'contributor',
  Editor = 'editor',
  Reviewer = 'reviewer'
}

export type Cms_User_Role_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_User_Role_Input>>>;
  equals?: InputMaybe<Cms_User_Role_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_User_Role_Input>>>;
  not_equals?: InputMaybe<Cms_User_Role_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_User_Role_Input>>>;
};

export type Cms_User_Sessions__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_User_Sessions__ExpiresAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_User_Sessions__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_User_Tenants__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_User_Tenants__Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_User_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_User_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_User_Where_Or>>>;
  createdAt?: InputMaybe<Cms_User_CreatedAt_Operator>;
  email?: InputMaybe<Cms_User_Email_Operator>;
  id?: InputMaybe<Cms_User_Id_Operator>;
  role?: InputMaybe<Cms_User_Role_Operator>;
  sessions__createdAt?: InputMaybe<Cms_User_Sessions__CreatedAt_Operator>;
  sessions__expiresAt?: InputMaybe<Cms_User_Sessions__ExpiresAt_Operator>;
  sessions__id?: InputMaybe<Cms_User_Sessions__Id_Operator>;
  tenants__id?: InputMaybe<Cms_User_Tenants__Id_Operator>;
  tenants__tenant?: InputMaybe<Cms_User_Tenants__Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_User_UpdatedAt_Operator>;
};

export type Cms_User_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_User_Where_Or>>>;
  createdAt?: InputMaybe<Cms_User_CreatedAt_Operator>;
  email?: InputMaybe<Cms_User_Email_Operator>;
  id?: InputMaybe<Cms_User_Id_Operator>;
  role?: InputMaybe<Cms_User_Role_Operator>;
  sessions__createdAt?: InputMaybe<Cms_User_Sessions__CreatedAt_Operator>;
  sessions__expiresAt?: InputMaybe<Cms_User_Sessions__ExpiresAt_Operator>;
  sessions__id?: InputMaybe<Cms_User_Sessions__Id_Operator>;
  tenants__id?: InputMaybe<Cms_User_Tenants__Id_Operator>;
  tenants__tenant?: InputMaybe<Cms_User_Tenants__Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_User_UpdatedAt_Operator>;
};

export type Cms_User_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_User_Where_Or>>>;
  createdAt?: InputMaybe<Cms_User_CreatedAt_Operator>;
  email?: InputMaybe<Cms_User_Email_Operator>;
  id?: InputMaybe<Cms_User_Id_Operator>;
  role?: InputMaybe<Cms_User_Role_Operator>;
  sessions__createdAt?: InputMaybe<Cms_User_Sessions__CreatedAt_Operator>;
  sessions__expiresAt?: InputMaybe<Cms_User_Sessions__ExpiresAt_Operator>;
  sessions__id?: InputMaybe<Cms_User_Sessions__Id_Operator>;
  tenants__id?: InputMaybe<Cms_User_Tenants__Id_Operator>;
  tenants__tenant?: InputMaybe<Cms_User_Tenants__Tenant_Operator>;
  updatedAt?: InputMaybe<Cms_User_UpdatedAt_Operator>;
};

export type Cms_Users = {
  __typename?: 'CMS_Users';
  docs: Array<Cms_User>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_UsersCreateAccess = {
  __typename?: 'CMS_UsersCreateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersCreateDocAccess = {
  __typename?: 'CMS_UsersCreateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersDeleteAccess = {
  __typename?: 'CMS_UsersDeleteAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersDeleteDocAccess = {
  __typename?: 'CMS_UsersDeleteDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersDocAccessFields = {
  __typename?: 'CMS_UsersDocAccessFields';
  createdAt?: Maybe<Cms_UsersDocAccessFields_CreatedAt>;
  email?: Maybe<Cms_UsersDocAccessFields_Email>;
  role?: Maybe<Cms_UsersDocAccessFields_Role>;
  sessions?: Maybe<Cms_UsersDocAccessFields_Sessions>;
  tenants?: Maybe<Cms_UsersDocAccessFields_Tenants>;
  updatedAt?: Maybe<Cms_UsersDocAccessFields_UpdatedAt>;
};

export type Cms_UsersDocAccessFields_CreatedAt = {
  __typename?: 'CMS_UsersDocAccessFields_createdAt';
  create?: Maybe<Cms_UsersDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_CreatedAt_Update>;
};

export type Cms_UsersDocAccessFields_CreatedAt_Create = {
  __typename?: 'CMS_UsersDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_CreatedAt_Read = {
  __typename?: 'CMS_UsersDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_CreatedAt_Update = {
  __typename?: 'CMS_UsersDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Email = {
  __typename?: 'CMS_UsersDocAccessFields_email';
  create?: Maybe<Cms_UsersDocAccessFields_Email_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Email_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Email_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Email_Update>;
};

export type Cms_UsersDocAccessFields_Email_Create = {
  __typename?: 'CMS_UsersDocAccessFields_email_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Email_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_email_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Email_Read = {
  __typename?: 'CMS_UsersDocAccessFields_email_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Email_Update = {
  __typename?: 'CMS_UsersDocAccessFields_email_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Role = {
  __typename?: 'CMS_UsersDocAccessFields_role';
  create?: Maybe<Cms_UsersDocAccessFields_Role_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Role_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Role_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Role_Update>;
};

export type Cms_UsersDocAccessFields_Role_Create = {
  __typename?: 'CMS_UsersDocAccessFields_role_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Role_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_role_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Role_Read = {
  __typename?: 'CMS_UsersDocAccessFields_role_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Role_Update = {
  __typename?: 'CMS_UsersDocAccessFields_role_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions = {
  __typename?: 'CMS_UsersDocAccessFields_sessions';
  create?: Maybe<Cms_UsersDocAccessFields_Sessions_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Sessions_Delete>;
  fields?: Maybe<Cms_UsersDocAccessFields_Sessions_Fields>;
  read?: Maybe<Cms_UsersDocAccessFields_Sessions_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Sessions_Update>;
};

export type Cms_UsersDocAccessFields_Sessions_Create = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Fields = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_Fields';
  createdAt?: Maybe<Cms_UsersDocAccessFields_Sessions_CreatedAt>;
  expiresAt?: Maybe<Cms_UsersDocAccessFields_Sessions_ExpiresAt>;
  id?: Maybe<Cms_UsersDocAccessFields_Sessions_Id>;
};

export type Cms_UsersDocAccessFields_Sessions_Read = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Update = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_CreatedAt = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_createdAt';
  create?: Maybe<Cms_UsersDocAccessFields_Sessions_CreatedAt_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Sessions_CreatedAt_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Sessions_CreatedAt_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Sessions_CreatedAt_Update>;
};

export type Cms_UsersDocAccessFields_Sessions_CreatedAt_Create = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_CreatedAt_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_CreatedAt_Read = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_CreatedAt_Update = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_ExpiresAt = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_expiresAt';
  create?: Maybe<Cms_UsersDocAccessFields_Sessions_ExpiresAt_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Sessions_ExpiresAt_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Sessions_ExpiresAt_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Sessions_ExpiresAt_Update>;
};

export type Cms_UsersDocAccessFields_Sessions_ExpiresAt_Create = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_expiresAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_ExpiresAt_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_expiresAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_ExpiresAt_Read = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_expiresAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_ExpiresAt_Update = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_expiresAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Id = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_id';
  create?: Maybe<Cms_UsersDocAccessFields_Sessions_Id_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Sessions_Id_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Sessions_Id_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Sessions_Id_Update>;
};

export type Cms_UsersDocAccessFields_Sessions_Id_Create = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Id_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Id_Read = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Sessions_Id_Update = {
  __typename?: 'CMS_UsersDocAccessFields_sessions_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants = {
  __typename?: 'CMS_UsersDocAccessFields_tenants';
  create?: Maybe<Cms_UsersDocAccessFields_Tenants_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Tenants_Delete>;
  fields?: Maybe<Cms_UsersDocAccessFields_Tenants_Fields>;
  read?: Maybe<Cms_UsersDocAccessFields_Tenants_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Tenants_Update>;
};

export type Cms_UsersDocAccessFields_Tenants_Create = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Fields = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_Fields';
  id?: Maybe<Cms_UsersDocAccessFields_Tenants_Id>;
  tenant?: Maybe<Cms_UsersDocAccessFields_Tenants_Tenant>;
};

export type Cms_UsersDocAccessFields_Tenants_Read = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Update = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Id = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_id';
  create?: Maybe<Cms_UsersDocAccessFields_Tenants_Id_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Tenants_Id_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Tenants_Id_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Tenants_Id_Update>;
};

export type Cms_UsersDocAccessFields_Tenants_Id_Create = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Id_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Id_Read = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Id_Update = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Tenant = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_tenant';
  create?: Maybe<Cms_UsersDocAccessFields_Tenants_Tenant_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_Tenants_Tenant_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_Tenants_Tenant_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_Tenants_Tenant_Update>;
};

export type Cms_UsersDocAccessFields_Tenants_Tenant_Create = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Tenant_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Tenant_Read = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_Tenants_Tenant_Update = {
  __typename?: 'CMS_UsersDocAccessFields_tenants_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_UpdatedAt = {
  __typename?: 'CMS_UsersDocAccessFields_updatedAt';
  create?: Maybe<Cms_UsersDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_UsersDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_UsersDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_UsersDocAccessFields_UpdatedAt_Update>;
};

export type Cms_UsersDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CMS_UsersDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CMS_UsersDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CMS_UsersDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CMS_UsersDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields = {
  __typename?: 'CMS_UsersFields';
  createdAt?: Maybe<Cms_UsersFields_CreatedAt>;
  email?: Maybe<Cms_UsersFields_Email>;
  role?: Maybe<Cms_UsersFields_Role>;
  sessions?: Maybe<Cms_UsersFields_Sessions>;
  tenants?: Maybe<Cms_UsersFields_Tenants>;
  updatedAt?: Maybe<Cms_UsersFields_UpdatedAt>;
};

export type Cms_UsersFields_CreatedAt = {
  __typename?: 'CMS_UsersFields_createdAt';
  create?: Maybe<Cms_UsersFields_CreatedAt_Create>;
  delete?: Maybe<Cms_UsersFields_CreatedAt_Delete>;
  read?: Maybe<Cms_UsersFields_CreatedAt_Read>;
  update?: Maybe<Cms_UsersFields_CreatedAt_Update>;
};

export type Cms_UsersFields_CreatedAt_Create = {
  __typename?: 'CMS_UsersFields_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_CreatedAt_Delete = {
  __typename?: 'CMS_UsersFields_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_CreatedAt_Read = {
  __typename?: 'CMS_UsersFields_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_CreatedAt_Update = {
  __typename?: 'CMS_UsersFields_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Email = {
  __typename?: 'CMS_UsersFields_email';
  create?: Maybe<Cms_UsersFields_Email_Create>;
  delete?: Maybe<Cms_UsersFields_Email_Delete>;
  read?: Maybe<Cms_UsersFields_Email_Read>;
  update?: Maybe<Cms_UsersFields_Email_Update>;
};

export type Cms_UsersFields_Email_Create = {
  __typename?: 'CMS_UsersFields_email_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Email_Delete = {
  __typename?: 'CMS_UsersFields_email_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Email_Read = {
  __typename?: 'CMS_UsersFields_email_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Email_Update = {
  __typename?: 'CMS_UsersFields_email_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Role = {
  __typename?: 'CMS_UsersFields_role';
  create?: Maybe<Cms_UsersFields_Role_Create>;
  delete?: Maybe<Cms_UsersFields_Role_Delete>;
  read?: Maybe<Cms_UsersFields_Role_Read>;
  update?: Maybe<Cms_UsersFields_Role_Update>;
};

export type Cms_UsersFields_Role_Create = {
  __typename?: 'CMS_UsersFields_role_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Role_Delete = {
  __typename?: 'CMS_UsersFields_role_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Role_Read = {
  __typename?: 'CMS_UsersFields_role_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Role_Update = {
  __typename?: 'CMS_UsersFields_role_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions = {
  __typename?: 'CMS_UsersFields_sessions';
  create?: Maybe<Cms_UsersFields_Sessions_Create>;
  delete?: Maybe<Cms_UsersFields_Sessions_Delete>;
  fields?: Maybe<Cms_UsersFields_Sessions_Fields>;
  read?: Maybe<Cms_UsersFields_Sessions_Read>;
  update?: Maybe<Cms_UsersFields_Sessions_Update>;
};

export type Cms_UsersFields_Sessions_Create = {
  __typename?: 'CMS_UsersFields_sessions_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Delete = {
  __typename?: 'CMS_UsersFields_sessions_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Fields = {
  __typename?: 'CMS_UsersFields_sessions_Fields';
  createdAt?: Maybe<Cms_UsersFields_Sessions_CreatedAt>;
  expiresAt?: Maybe<Cms_UsersFields_Sessions_ExpiresAt>;
  id?: Maybe<Cms_UsersFields_Sessions_Id>;
};

export type Cms_UsersFields_Sessions_Read = {
  __typename?: 'CMS_UsersFields_sessions_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Update = {
  __typename?: 'CMS_UsersFields_sessions_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_CreatedAt = {
  __typename?: 'CMS_UsersFields_sessions_createdAt';
  create?: Maybe<Cms_UsersFields_Sessions_CreatedAt_Create>;
  delete?: Maybe<Cms_UsersFields_Sessions_CreatedAt_Delete>;
  read?: Maybe<Cms_UsersFields_Sessions_CreatedAt_Read>;
  update?: Maybe<Cms_UsersFields_Sessions_CreatedAt_Update>;
};

export type Cms_UsersFields_Sessions_CreatedAt_Create = {
  __typename?: 'CMS_UsersFields_sessions_createdAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_CreatedAt_Delete = {
  __typename?: 'CMS_UsersFields_sessions_createdAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_CreatedAt_Read = {
  __typename?: 'CMS_UsersFields_sessions_createdAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_CreatedAt_Update = {
  __typename?: 'CMS_UsersFields_sessions_createdAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_ExpiresAt = {
  __typename?: 'CMS_UsersFields_sessions_expiresAt';
  create?: Maybe<Cms_UsersFields_Sessions_ExpiresAt_Create>;
  delete?: Maybe<Cms_UsersFields_Sessions_ExpiresAt_Delete>;
  read?: Maybe<Cms_UsersFields_Sessions_ExpiresAt_Read>;
  update?: Maybe<Cms_UsersFields_Sessions_ExpiresAt_Update>;
};

export type Cms_UsersFields_Sessions_ExpiresAt_Create = {
  __typename?: 'CMS_UsersFields_sessions_expiresAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_ExpiresAt_Delete = {
  __typename?: 'CMS_UsersFields_sessions_expiresAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_ExpiresAt_Read = {
  __typename?: 'CMS_UsersFields_sessions_expiresAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_ExpiresAt_Update = {
  __typename?: 'CMS_UsersFields_sessions_expiresAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Id = {
  __typename?: 'CMS_UsersFields_sessions_id';
  create?: Maybe<Cms_UsersFields_Sessions_Id_Create>;
  delete?: Maybe<Cms_UsersFields_Sessions_Id_Delete>;
  read?: Maybe<Cms_UsersFields_Sessions_Id_Read>;
  update?: Maybe<Cms_UsersFields_Sessions_Id_Update>;
};

export type Cms_UsersFields_Sessions_Id_Create = {
  __typename?: 'CMS_UsersFields_sessions_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Id_Delete = {
  __typename?: 'CMS_UsersFields_sessions_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Id_Read = {
  __typename?: 'CMS_UsersFields_sessions_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Sessions_Id_Update = {
  __typename?: 'CMS_UsersFields_sessions_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants = {
  __typename?: 'CMS_UsersFields_tenants';
  create?: Maybe<Cms_UsersFields_Tenants_Create>;
  delete?: Maybe<Cms_UsersFields_Tenants_Delete>;
  fields?: Maybe<Cms_UsersFields_Tenants_Fields>;
  read?: Maybe<Cms_UsersFields_Tenants_Read>;
  update?: Maybe<Cms_UsersFields_Tenants_Update>;
};

export type Cms_UsersFields_Tenants_Create = {
  __typename?: 'CMS_UsersFields_tenants_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Delete = {
  __typename?: 'CMS_UsersFields_tenants_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Fields = {
  __typename?: 'CMS_UsersFields_tenants_Fields';
  id?: Maybe<Cms_UsersFields_Tenants_Id>;
  tenant?: Maybe<Cms_UsersFields_Tenants_Tenant>;
};

export type Cms_UsersFields_Tenants_Read = {
  __typename?: 'CMS_UsersFields_tenants_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Update = {
  __typename?: 'CMS_UsersFields_tenants_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Id = {
  __typename?: 'CMS_UsersFields_tenants_id';
  create?: Maybe<Cms_UsersFields_Tenants_Id_Create>;
  delete?: Maybe<Cms_UsersFields_Tenants_Id_Delete>;
  read?: Maybe<Cms_UsersFields_Tenants_Id_Read>;
  update?: Maybe<Cms_UsersFields_Tenants_Id_Update>;
};

export type Cms_UsersFields_Tenants_Id_Create = {
  __typename?: 'CMS_UsersFields_tenants_id_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Id_Delete = {
  __typename?: 'CMS_UsersFields_tenants_id_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Id_Read = {
  __typename?: 'CMS_UsersFields_tenants_id_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Id_Update = {
  __typename?: 'CMS_UsersFields_tenants_id_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Tenant = {
  __typename?: 'CMS_UsersFields_tenants_tenant';
  create?: Maybe<Cms_UsersFields_Tenants_Tenant_Create>;
  delete?: Maybe<Cms_UsersFields_Tenants_Tenant_Delete>;
  read?: Maybe<Cms_UsersFields_Tenants_Tenant_Read>;
  update?: Maybe<Cms_UsersFields_Tenants_Tenant_Update>;
};

export type Cms_UsersFields_Tenants_Tenant_Create = {
  __typename?: 'CMS_UsersFields_tenants_tenant_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Tenant_Delete = {
  __typename?: 'CMS_UsersFields_tenants_tenant_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Tenant_Read = {
  __typename?: 'CMS_UsersFields_tenants_tenant_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_Tenants_Tenant_Update = {
  __typename?: 'CMS_UsersFields_tenants_tenant_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_UpdatedAt = {
  __typename?: 'CMS_UsersFields_updatedAt';
  create?: Maybe<Cms_UsersFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_UsersFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_UsersFields_UpdatedAt_Read>;
  update?: Maybe<Cms_UsersFields_UpdatedAt_Update>;
};

export type Cms_UsersFields_UpdatedAt_Create = {
  __typename?: 'CMS_UsersFields_updatedAt_Create';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_UpdatedAt_Delete = {
  __typename?: 'CMS_UsersFields_updatedAt_Delete';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_UpdatedAt_Read = {
  __typename?: 'CMS_UsersFields_updatedAt_Read';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersFields_UpdatedAt_Update = {
  __typename?: 'CMS_UsersFields_updatedAt_Update';
  permission: Scalars['Boolean']['output'];
};

export type Cms_UsersReadAccess = {
  __typename?: 'CMS_UsersReadAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersReadDocAccess = {
  __typename?: 'CMS_UsersReadDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersUnlockAccess = {
  __typename?: 'CMS_UsersUnlockAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersUnlockDocAccess = {
  __typename?: 'CMS_UsersUnlockDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersUpdateAccess = {
  __typename?: 'CMS_UsersUpdateAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_UsersUpdateDocAccess = {
  __typename?: 'CMS_UsersUpdateDocAccess';
  permission: Scalars['Boolean']['output'];
  where?: Maybe<Scalars['JSONObject']['output']>;
};

export type Cms_VideoPlayerBlock = {
  __typename?: 'CMS_VideoPlayerBlock';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  blockName?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Cms_VideoPlayerBlock_Platform>;
  thumbnail?: Maybe<Cms_Media>;
  videoId?: Maybe<Scalars['String']['output']>;
  vimeoAutoplay?: Maybe<Scalars['Boolean']['output']>;
  vimeoControls?: Maybe<Scalars['Boolean']['output']>;
  vimeoLoop?: Maybe<Scalars['Boolean']['output']>;
  vimeoMute?: Maybe<Scalars['Boolean']['output']>;
  youtubeAutoplay?: Maybe<Scalars['Boolean']['output']>;
  youtubeControls?: Maybe<Scalars['Boolean']['output']>;
  youtubeMute?: Maybe<Scalars['Boolean']['output']>;
  youtubePlaysInline?: Maybe<Scalars['Boolean']['output']>;
};

export enum Cms_VideoPlayerBlock_Platform {
  Vimeo = 'vimeo',
  Youtube = 'youtube'
}

export type Cms_AllMedia = {
  __typename?: 'CMS_allMedia';
  docs: Array<Cms_Media>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_CommentsAccess = {
  __typename?: 'CMS_commentsAccess';
  create?: Maybe<Cms_CommentsCreateAccess>;
  delete?: Maybe<Cms_CommentsDeleteAccess>;
  fields?: Maybe<Cms_CommentsFields>;
  read?: Maybe<Cms_CommentsReadAccess>;
  update?: Maybe<Cms_CommentsUpdateAccess>;
};

export type Cms_CommentsDocAccess = {
  __typename?: 'CMS_commentsDocAccess';
  create?: Maybe<Cms_CommentsCreateDocAccess>;
  delete?: Maybe<Cms_CommentsDeleteDocAccess>;
  fields?: Maybe<Cms_CommentsDocAccessFields>;
  read?: Maybe<Cms_CommentsReadDocAccess>;
  update?: Maybe<Cms_CommentsUpdateDocAccess>;
};

export type Cms_CountComments = {
  __typename?: 'CMS_countComments';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountFormSubmissions = {
  __typename?: 'CMS_countFormSubmissions';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountForms = {
  __typename?: 'CMS_countForms';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPages = {
  __typename?: 'CMS_countPages';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPayloadFolders = {
  __typename?: 'CMS_countPayloadFolders';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPayloadJobs = {
  __typename?: 'CMS_countPayloadJobs';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPayloadKvs = {
  __typename?: 'CMS_countPayloadKvs';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPayloadLockedDocuments = {
  __typename?: 'CMS_countPayloadLockedDocuments';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountPayloadPreferences = {
  __typename?: 'CMS_countPayloadPreferences';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountReassuranceCards = {
  __typename?: 'CMS_countReassuranceCards';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountSeoCategories = {
  __typename?: 'CMS_countSeoCategories';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountTenants = {
  __typename?: 'CMS_countTenants';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountUsers = {
  __typename?: 'CMS_countUsers';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_CountallMedia = {
  __typename?: 'CMS_countallMedia';
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type Cms_Form_SubmissionsAccess = {
  __typename?: 'CMS_form_submissionsAccess';
  create?: Maybe<Cms_FormSubmissionsCreateAccess>;
  delete?: Maybe<Cms_FormSubmissionsDeleteAccess>;
  fields?: Maybe<Cms_FormSubmissionsFields>;
  read?: Maybe<Cms_FormSubmissionsReadAccess>;
  update?: Maybe<Cms_FormSubmissionsUpdateAccess>;
};

export type Cms_Form_SubmissionsDocAccess = {
  __typename?: 'CMS_form_submissionsDocAccess';
  create?: Maybe<Cms_FormSubmissionsCreateDocAccess>;
  delete?: Maybe<Cms_FormSubmissionsDeleteDocAccess>;
  fields?: Maybe<Cms_FormSubmissionsDocAccessFields>;
  read?: Maybe<Cms_FormSubmissionsReadDocAccess>;
  update?: Maybe<Cms_FormSubmissionsUpdateDocAccess>;
};

export type Cms_FormsAccess = {
  __typename?: 'CMS_formsAccess';
  create?: Maybe<Cms_FormsCreateAccess>;
  delete?: Maybe<Cms_FormsDeleteAccess>;
  fields?: Maybe<Cms_FormsFields>;
  read?: Maybe<Cms_FormsReadAccess>;
  update?: Maybe<Cms_FormsUpdateAccess>;
};

export type Cms_FormsDocAccess = {
  __typename?: 'CMS_formsDocAccess';
  create?: Maybe<Cms_FormsCreateDocAccess>;
  delete?: Maybe<Cms_FormsDeleteDocAccess>;
  fields?: Maybe<Cms_FormsDocAccessFields>;
  read?: Maybe<Cms_FormsReadDocAccess>;
  update?: Maybe<Cms_FormsUpdateDocAccess>;
};

export type Cms_MediaAccess = {
  __typename?: 'CMS_mediaAccess';
  create?: Maybe<Cms_MediaCreateAccess>;
  delete?: Maybe<Cms_MediaDeleteAccess>;
  fields?: Maybe<Cms_MediaFields>;
  read?: Maybe<Cms_MediaReadAccess>;
  update?: Maybe<Cms_MediaUpdateAccess>;
};

export type Cms_MediaDocAccess = {
  __typename?: 'CMS_mediaDocAccess';
  create?: Maybe<Cms_MediaCreateDocAccess>;
  delete?: Maybe<Cms_MediaDeleteDocAccess>;
  fields?: Maybe<Cms_MediaDocAccessFields>;
  read?: Maybe<Cms_MediaReadDocAccess>;
  update?: Maybe<Cms_MediaUpdateDocAccess>;
};

export type Cms_MutationCommentInput = {
  author: Scalars['String']['input'];
  blockId: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  replyCollection?: InputMaybe<Scalars['String']['input']>;
  replyDoc?: InputMaybe<Cms_Comment_ReplyDocRelationshipInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationCommentUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  blockId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  replyCollection?: InputMaybe<Scalars['String']['input']>;
  replyDoc?: InputMaybe<Cms_CommentUpdate_ReplyDocRelationshipInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationFormInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  confirmationType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Cms_MutationForm_EmailsInput>>>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  redirect: Cms_MutationForm_RedirectInput;
  submitButtonLabel?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationFormSubmissionInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['Int']['input']>;
  submissionData?: InputMaybe<Array<InputMaybe<Cms_MutationFormSubmission_SubmissionDataInput>>>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationFormSubmissionUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['Int']['input']>;
  submissionData?: InputMaybe<Array<InputMaybe<Cms_MutationFormSubmissionUpdate_SubmissionDataInput>>>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationFormSubmissionUpdate_SubmissionDataInput = {
  field: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type Cms_MutationFormSubmission_SubmissionDataInput = {
  field: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type Cms_MutationFormUpdateInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  confirmationType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Cms_MutationFormUpdate_EmailsInput>>>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  redirect: Cms_MutationFormUpdate_RedirectInput;
  submitButtonLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationFormUpdate_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['JSON']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type Cms_MutationFormUpdate_RedirectInput = {
  url: Scalars['String']['input'];
};

export type Cms_MutationForm_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['JSON']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type Cms_MutationForm_RedirectInput = {
  url: Scalars['String']['input'];
};

export type Cms_MutationMediaInput = {
  alt: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filesize?: InputMaybe<Scalars['Float']['input']>;
  focalX?: InputMaybe<Scalars['Float']['input']>;
  focalY?: InputMaybe<Scalars['Float']['input']>;
  folder?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailURL?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_MutationMediaUpdateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filesize?: InputMaybe<Scalars['Float']['input']>;
  focalX?: InputMaybe<Scalars['Float']['input']>;
  focalY?: InputMaybe<Scalars['Float']['input']>;
  folder?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailURL?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Cms_MutationPayloadFolderInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<Array<InputMaybe<Cms_PayloadFolder_FolderType_MutationInput>>>;
  name: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationPayloadFolderUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<Array<InputMaybe<Cms_PayloadFolderUpdate_FolderType_MutationInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationPayloadJobInput = {
  completedAt?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  log?: InputMaybe<Array<InputMaybe<Cms_MutationPayloadJob_LogInput>>>;
  processing?: InputMaybe<Scalars['Boolean']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  taskSlug?: InputMaybe<Cms_PayloadJob_TaskSlug_MutationInput>;
  taskStatus?: InputMaybe<Scalars['JSON']['input']>;
  totalTried?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  waitUntil?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationPayloadJobUpdateInput = {
  completedAt?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  log?: InputMaybe<Array<InputMaybe<Cms_MutationPayloadJobUpdate_LogInput>>>;
  processing?: InputMaybe<Scalars['Boolean']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  taskSlug?: InputMaybe<Cms_PayloadJobUpdate_TaskSlug_MutationInput>;
  taskStatus?: InputMaybe<Scalars['JSON']['input']>;
  totalTried?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  waitUntil?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationPayloadJobUpdate_LogInput = {
  completedAt: Scalars['String']['input'];
  error?: InputMaybe<Scalars['JSON']['input']>;
  executedAt: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  output?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  taskID: Scalars['String']['input'];
  taskSlug: Cms_PayloadJobUpdate_Log_TaskSlug_MutationInput;
};

export type Cms_MutationPayloadJob_LogInput = {
  completedAt: Scalars['String']['input'];
  error?: InputMaybe<Scalars['JSON']['input']>;
  executedAt: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  output?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  taskID: Scalars['String']['input'];
  taskSlug: Cms_PayloadJob_Log_TaskSlug_MutationInput;
};

export type Cms_MutationPayloadKvInput = {
  data: Scalars['JSON']['input'];
  key: Scalars['String']['input'];
};

export type Cms_MutationPayloadKvUpdateInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationPayloadLockedDocumentInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Cms_PayloadLockedDocument_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Cms_PayloadLockedDocument_UserRelationshipInput>;
};

export type Cms_MutationPayloadLockedDocumentUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Cms_PayloadLockedDocumentUpdate_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Cms_PayloadLockedDocumentUpdate_UserRelationshipInput>;
};

export type Cms_MutationPayloadPreferenceInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Cms_PayloadPreference_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_MutationPayloadPreferenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Cms_PayloadPreferenceUpdate_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_MutationTenantInput = {
  allowPublicRead?: InputMaybe<Scalars['Boolean']['input']>;
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationTenantUpdateInput = {
  allowPublicRead?: InputMaybe<Scalars['Boolean']['input']>;
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationUserInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  lockUntil?: InputMaybe<Scalars['String']['input']>;
  loginAttempts?: InputMaybe<Scalars['Float']['input']>;
  password: Scalars['String']['input'];
  resetPasswordExpiration?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Cms_User_Role_MutationInput>;
  salt?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<Array<InputMaybe<Cms_MutationUser_SessionsInput>>>;
  tenants?: InputMaybe<Array<InputMaybe<Cms_MutationUser_TenantsInput>>>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationUserUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  lockUntil?: InputMaybe<Scalars['String']['input']>;
  loginAttempts?: InputMaybe<Scalars['Float']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  resetPasswordExpiration?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Cms_UserUpdate_Role_MutationInput>;
  salt?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<Array<InputMaybe<Cms_MutationUserUpdate_SessionsInput>>>;
  tenants?: InputMaybe<Array<InputMaybe<Cms_MutationUserUpdate_TenantsInput>>>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_MutationUserUpdate_SessionsInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type Cms_MutationUserUpdate_TenantsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_MutationUser_SessionsInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type Cms_MutationUser_TenantsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_PagesAccess = {
  __typename?: 'CMS_pagesAccess';
  create?: Maybe<Cms_PagesCreateAccess>;
  delete?: Maybe<Cms_PagesDeleteAccess>;
  fields?: Maybe<Cms_PagesFields>;
  read?: Maybe<Cms_PagesReadAccess>;
  readVersions?: Maybe<Cms_PagesReadVersionsAccess>;
  update?: Maybe<Cms_PagesUpdateAccess>;
};

export type Cms_PagesDocAccess = {
  __typename?: 'CMS_pagesDocAccess';
  create?: Maybe<Cms_PagesCreateDocAccess>;
  delete?: Maybe<Cms_PagesDeleteDocAccess>;
  fields?: Maybe<Cms_PagesDocAccessFields>;
  read?: Maybe<Cms_PagesReadDocAccess>;
  readVersions?: Maybe<Cms_PagesReadVersionsDocAccess>;
  update?: Maybe<Cms_PagesUpdateDocAccess>;
};

export type Cms_Payload_FoldersAccess = {
  __typename?: 'CMS_payload_foldersAccess';
  create?: Maybe<Cms_PayloadFoldersCreateAccess>;
  delete?: Maybe<Cms_PayloadFoldersDeleteAccess>;
  fields?: Maybe<Cms_PayloadFoldersFields>;
  read?: Maybe<Cms_PayloadFoldersReadAccess>;
  update?: Maybe<Cms_PayloadFoldersUpdateAccess>;
};

export type Cms_Payload_FoldersDocAccess = {
  __typename?: 'CMS_payload_foldersDocAccess';
  create?: Maybe<Cms_PayloadFoldersCreateDocAccess>;
  delete?: Maybe<Cms_PayloadFoldersDeleteDocAccess>;
  fields?: Maybe<Cms_PayloadFoldersDocAccessFields>;
  read?: Maybe<Cms_PayloadFoldersReadDocAccess>;
  update?: Maybe<Cms_PayloadFoldersUpdateDocAccess>;
};

export type Cms_Payload_JobsAccess = {
  __typename?: 'CMS_payload_jobsAccess';
  create?: Maybe<Cms_PayloadJobsCreateAccess>;
  delete?: Maybe<Cms_PayloadJobsDeleteAccess>;
  fields?: Maybe<Cms_PayloadJobsFields>;
  read?: Maybe<Cms_PayloadJobsReadAccess>;
  update?: Maybe<Cms_PayloadJobsUpdateAccess>;
};

export type Cms_Payload_JobsDocAccess = {
  __typename?: 'CMS_payload_jobsDocAccess';
  create?: Maybe<Cms_PayloadJobsCreateDocAccess>;
  delete?: Maybe<Cms_PayloadJobsDeleteDocAccess>;
  fields?: Maybe<Cms_PayloadJobsDocAccessFields>;
  read?: Maybe<Cms_PayloadJobsReadDocAccess>;
  update?: Maybe<Cms_PayloadJobsUpdateDocAccess>;
};

export type Cms_Payload_KvAccess = {
  __typename?: 'CMS_payload_kvAccess';
  create?: Maybe<Cms_PayloadKvCreateAccess>;
  delete?: Maybe<Cms_PayloadKvDeleteAccess>;
  fields?: Maybe<Cms_PayloadKvFields>;
  read?: Maybe<Cms_PayloadKvReadAccess>;
  update?: Maybe<Cms_PayloadKvUpdateAccess>;
};

export type Cms_Payload_KvDocAccess = {
  __typename?: 'CMS_payload_kvDocAccess';
  create?: Maybe<Cms_PayloadKvCreateDocAccess>;
  delete?: Maybe<Cms_PayloadKvDeleteDocAccess>;
  fields?: Maybe<Cms_PayloadKvDocAccessFields>;
  read?: Maybe<Cms_PayloadKvReadDocAccess>;
  update?: Maybe<Cms_PayloadKvUpdateDocAccess>;
};

export type Cms_Payload_Locked_DocumentsAccess = {
  __typename?: 'CMS_payload_locked_documentsAccess';
  create?: Maybe<Cms_PayloadLockedDocumentsCreateAccess>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDeleteAccess>;
  fields?: Maybe<Cms_PayloadLockedDocumentsFields>;
  read?: Maybe<Cms_PayloadLockedDocumentsReadAccess>;
  update?: Maybe<Cms_PayloadLockedDocumentsUpdateAccess>;
};

export type Cms_Payload_Locked_DocumentsDocAccess = {
  __typename?: 'CMS_payload_locked_documentsDocAccess';
  create?: Maybe<Cms_PayloadLockedDocumentsCreateDocAccess>;
  delete?: Maybe<Cms_PayloadLockedDocumentsDeleteDocAccess>;
  fields?: Maybe<Cms_PayloadLockedDocumentsDocAccessFields>;
  read?: Maybe<Cms_PayloadLockedDocumentsReadDocAccess>;
  update?: Maybe<Cms_PayloadLockedDocumentsUpdateDocAccess>;
};

export type Cms_Payload_PreferencesAccess = {
  __typename?: 'CMS_payload_preferencesAccess';
  create?: Maybe<Cms_PayloadPreferencesCreateAccess>;
  delete?: Maybe<Cms_PayloadPreferencesDeleteAccess>;
  fields?: Maybe<Cms_PayloadPreferencesFields>;
  read?: Maybe<Cms_PayloadPreferencesReadAccess>;
  update?: Maybe<Cms_PayloadPreferencesUpdateAccess>;
};

export type Cms_Payload_PreferencesDocAccess = {
  __typename?: 'CMS_payload_preferencesDocAccess';
  create?: Maybe<Cms_PayloadPreferencesCreateDocAccess>;
  delete?: Maybe<Cms_PayloadPreferencesDeleteDocAccess>;
  fields?: Maybe<Cms_PayloadPreferencesDocAccessFields>;
  read?: Maybe<Cms_PayloadPreferencesReadDocAccess>;
  update?: Maybe<Cms_PayloadPreferencesUpdateDocAccess>;
};

export type Cms_Reassurance_CardsAccess = {
  __typename?: 'CMS_reassurance_cardsAccess';
  create?: Maybe<Cms_ReassuranceCardsCreateAccess>;
  delete?: Maybe<Cms_ReassuranceCardsDeleteAccess>;
  fields?: Maybe<Cms_ReassuranceCardsFields>;
  read?: Maybe<Cms_ReassuranceCardsReadAccess>;
  readVersions?: Maybe<Cms_ReassuranceCardsReadVersionsAccess>;
  update?: Maybe<Cms_ReassuranceCardsUpdateAccess>;
};

export type Cms_Reassurance_CardsDocAccess = {
  __typename?: 'CMS_reassurance_cardsDocAccess';
  create?: Maybe<Cms_ReassuranceCardsCreateDocAccess>;
  delete?: Maybe<Cms_ReassuranceCardsDeleteDocAccess>;
  fields?: Maybe<Cms_ReassuranceCardsDocAccessFields>;
  read?: Maybe<Cms_ReassuranceCardsReadDocAccess>;
  readVersions?: Maybe<Cms_ReassuranceCardsReadVersionsDocAccess>;
  update?: Maybe<Cms_ReassuranceCardsUpdateDocAccess>;
};

export type Cms_Seo_CategoriesAccess = {
  __typename?: 'CMS_seo_categoriesAccess';
  create?: Maybe<Cms_SeoCategoriesCreateAccess>;
  delete?: Maybe<Cms_SeoCategoriesDeleteAccess>;
  fields?: Maybe<Cms_SeoCategoriesFields>;
  read?: Maybe<Cms_SeoCategoriesReadAccess>;
  readVersions?: Maybe<Cms_SeoCategoriesReadVersionsAccess>;
  update?: Maybe<Cms_SeoCategoriesUpdateAccess>;
};

export type Cms_Seo_CategoriesDocAccess = {
  __typename?: 'CMS_seo_categoriesDocAccess';
  create?: Maybe<Cms_SeoCategoriesCreateDocAccess>;
  delete?: Maybe<Cms_SeoCategoriesDeleteDocAccess>;
  fields?: Maybe<Cms_SeoCategoriesDocAccessFields>;
  read?: Maybe<Cms_SeoCategoriesReadDocAccess>;
  readVersions?: Maybe<Cms_SeoCategoriesReadVersionsDocAccess>;
  update?: Maybe<Cms_SeoCategoriesUpdateDocAccess>;
};

export type Cms_TenantsAccess = {
  __typename?: 'CMS_tenantsAccess';
  create?: Maybe<Cms_TenantsCreateAccess>;
  delete?: Maybe<Cms_TenantsDeleteAccess>;
  fields?: Maybe<Cms_TenantsFields>;
  read?: Maybe<Cms_TenantsReadAccess>;
  update?: Maybe<Cms_TenantsUpdateAccess>;
};

export type Cms_TenantsDocAccess = {
  __typename?: 'CMS_tenantsDocAccess';
  create?: Maybe<Cms_TenantsCreateDocAccess>;
  delete?: Maybe<Cms_TenantsDeleteDocAccess>;
  fields?: Maybe<Cms_TenantsDocAccessFields>;
  read?: Maybe<Cms_TenantsReadDocAccess>;
  update?: Maybe<Cms_TenantsUpdateDocAccess>;
};

export type Cms_UsersAccess = {
  __typename?: 'CMS_usersAccess';
  create?: Maybe<Cms_UsersCreateAccess>;
  delete?: Maybe<Cms_UsersDeleteAccess>;
  fields?: Maybe<Cms_UsersFields>;
  read?: Maybe<Cms_UsersReadAccess>;
  unlock?: Maybe<Cms_UsersUnlockAccess>;
  update?: Maybe<Cms_UsersUpdateAccess>;
};

export type Cms_UsersDocAccess = {
  __typename?: 'CMS_usersDocAccess';
  create?: Maybe<Cms_UsersCreateDocAccess>;
  delete?: Maybe<Cms_UsersDeleteDocAccess>;
  fields?: Maybe<Cms_UsersDocAccessFields>;
  read?: Maybe<Cms_UsersReadDocAccess>;
  unlock?: Maybe<Cms_UsersUnlockDocAccess>;
  update?: Maybe<Cms_UsersUpdateDocAccess>;
};

export type Cms_UsersJwt = {
  __typename?: 'CMS_usersJWT';
  collection: Scalars['String']['output'];
  email: Scalars['EmailAddress']['output'];
  tenants?: Maybe<Array<Cms_UsersJwt_Tenants>>;
};

export type Cms_UsersJwt_Tenants = {
  __typename?: 'CMS_usersJWT_Tenants';
  id?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Cms_Tenant>;
};

export type Cms_UsersLoginResult = {
  __typename?: 'CMS_usersLoginResult';
  exp?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Cms_User>;
};

export type Cms_UsersMe = {
  __typename?: 'CMS_usersMe';
  collection?: Maybe<Scalars['String']['output']>;
  exp?: Maybe<Scalars['Int']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Cms_User>;
};

export type Cms_UsersRefreshedUser = {
  __typename?: 'CMS_usersRefreshedUser';
  exp?: Maybe<Scalars['Int']['output']>;
  refreshedToken?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Cms_UsersJwt>;
};

export type Cms_UsersResetPassword = {
  __typename?: 'CMS_usersResetPassword';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Cms_User>;
};

export type Cms_VersionsPage_Autosave_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsPage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_VersionsPage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Cms_VersionsPage_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_VersionsPage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Version___Status_Input>>>;
  equals?: InputMaybe<Cms_VersionsPage_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Version___Status_Input>>>;
  not_equals?: InputMaybe<Cms_VersionsPage_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Version___Status_Input>>>;
};

export type Cms_VersionsPage_Version__Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__CanonicalUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsPage_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__Folder_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__GenerateSlug_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsPage_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
};

export type Cms_VersionsPage_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__Path_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsPage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__Subtitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsPage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsPage_Version__UpdatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsPage_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsPage_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsPage_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsPage_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsPage_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Url_Operator>;
  version__canonicalUrl?: InputMaybe<Cms_VersionsPage_Version__CanonicalUrl_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsPage_Version__CreatedAt_Operator>;
  version__createdBy?: InputMaybe<Cms_VersionsPage_Version__CreatedBy_Operator>;
  version__folder?: InputMaybe<Cms_VersionsPage_Version__Folder_Operator>;
  version__generateSlug?: InputMaybe<Cms_VersionsPage_Version__GenerateSlug_Operator>;
  version__meta__description?: InputMaybe<Cms_VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<Cms_VersionsPage_Version__Meta__Image_Operator>;
  version__meta__title?: InputMaybe<Cms_VersionsPage_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<Cms_VersionsPage_Version__Parent_Operator>;
  version__path?: InputMaybe<Cms_VersionsPage_Version__Path_Operator>;
  version__publishedAt?: InputMaybe<Cms_VersionsPage_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<Cms_VersionsPage_Version__Slug_Operator>;
  version__subtitle?: InputMaybe<Cms_VersionsPage_Version__Subtitle_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsPage_Version__Tenant_Operator>;
  version__title?: InputMaybe<Cms_VersionsPage_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsPage_Version__UpdatedAt_Operator>;
  version__updatedBy?: InputMaybe<Cms_VersionsPage_Version__UpdatedBy_Operator>;
};

export type Cms_VersionsPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsPage_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsPage_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsPage_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsPage_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsPage_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Url_Operator>;
  version__canonicalUrl?: InputMaybe<Cms_VersionsPage_Version__CanonicalUrl_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsPage_Version__CreatedAt_Operator>;
  version__createdBy?: InputMaybe<Cms_VersionsPage_Version__CreatedBy_Operator>;
  version__folder?: InputMaybe<Cms_VersionsPage_Version__Folder_Operator>;
  version__generateSlug?: InputMaybe<Cms_VersionsPage_Version__GenerateSlug_Operator>;
  version__meta__description?: InputMaybe<Cms_VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<Cms_VersionsPage_Version__Meta__Image_Operator>;
  version__meta__title?: InputMaybe<Cms_VersionsPage_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<Cms_VersionsPage_Version__Parent_Operator>;
  version__path?: InputMaybe<Cms_VersionsPage_Version__Path_Operator>;
  version__publishedAt?: InputMaybe<Cms_VersionsPage_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<Cms_VersionsPage_Version__Slug_Operator>;
  version__subtitle?: InputMaybe<Cms_VersionsPage_Version__Subtitle_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsPage_Version__Tenant_Operator>;
  version__title?: InputMaybe<Cms_VersionsPage_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsPage_Version__UpdatedAt_Operator>;
  version__updatedBy?: InputMaybe<Cms_VersionsPage_Version__UpdatedBy_Operator>;
};

export type Cms_VersionsPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsPage_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsPage_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsPage_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsPage_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsPage_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsPage_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<Cms_VersionsPage_Version__Breadcrumbs__Url_Operator>;
  version__canonicalUrl?: InputMaybe<Cms_VersionsPage_Version__CanonicalUrl_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsPage_Version__CreatedAt_Operator>;
  version__createdBy?: InputMaybe<Cms_VersionsPage_Version__CreatedBy_Operator>;
  version__folder?: InputMaybe<Cms_VersionsPage_Version__Folder_Operator>;
  version__generateSlug?: InputMaybe<Cms_VersionsPage_Version__GenerateSlug_Operator>;
  version__meta__description?: InputMaybe<Cms_VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<Cms_VersionsPage_Version__Meta__Image_Operator>;
  version__meta__title?: InputMaybe<Cms_VersionsPage_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<Cms_VersionsPage_Version__Parent_Operator>;
  version__path?: InputMaybe<Cms_VersionsPage_Version__Path_Operator>;
  version__publishedAt?: InputMaybe<Cms_VersionsPage_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<Cms_VersionsPage_Version__Slug_Operator>;
  version__subtitle?: InputMaybe<Cms_VersionsPage_Version__Subtitle_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsPage_Version__Tenant_Operator>;
  version__title?: InputMaybe<Cms_VersionsPage_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsPage_Version__UpdatedAt_Operator>;
  version__updatedBy?: InputMaybe<Cms_VersionsPage_Version__UpdatedBy_Operator>;
};

export type Cms_VersionsPages = {
  __typename?: 'CMS_versionsPages';
  docs: Array<Cms_PageVersion>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_VersionsReassuranceCard_Autosave_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsReassuranceCard_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsReassuranceCard_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_VersionsReassuranceCard_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsReassuranceCard_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsReassuranceCard_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Cms_VersionsReassuranceCard_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_VersionsReassuranceCard_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Input>>>;
  equals?: InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Input>>>;
  not_equals?: InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Input>>>;
};

export type Cms_VersionsReassuranceCard_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsReassuranceCard_Version__TenantName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsReassuranceCard_Version__Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsReassuranceCard_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsReassuranceCard_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsReassuranceCard_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsReassuranceCard_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsReassuranceCard_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsReassuranceCard_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__CreatedAt_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsReassuranceCard_Version__Tenant_Operator>;
  version__tenantName?: InputMaybe<Cms_VersionsReassuranceCard_Version__TenantName_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__UpdatedAt_Operator>;
};

export type Cms_VersionsReassuranceCard_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsReassuranceCard_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsReassuranceCard_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsReassuranceCard_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsReassuranceCard_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__CreatedAt_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsReassuranceCard_Version__Tenant_Operator>;
  version__tenantName?: InputMaybe<Cms_VersionsReassuranceCard_Version__TenantName_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__UpdatedAt_Operator>;
};

export type Cms_VersionsReassuranceCard_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsReassuranceCard_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsReassuranceCard_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsReassuranceCard_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsReassuranceCard_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsReassuranceCard_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsReassuranceCard_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsReassuranceCard_Version___Status_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__CreatedAt_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsReassuranceCard_Version__Tenant_Operator>;
  version__tenantName?: InputMaybe<Cms_VersionsReassuranceCard_Version__TenantName_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsReassuranceCard_Version__UpdatedAt_Operator>;
};

export type Cms_VersionsReassuranceCards = {
  __typename?: 'CMS_versionsReassuranceCards';
  docs: Array<Cms_ReassuranceCardVersion>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_VersionsSeoCategories = {
  __typename?: 'CMS_versionsSeoCategories';
  docs: Array<Cms_SeoCategoryVersion>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Cms_VersionsSeoCategory_Autosave_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsSeoCategory_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsSeoCategory_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Int']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>;
  less_than?: InputMaybe<Scalars['Int']['input']>;
  less_than_equal?: InputMaybe<Scalars['Int']['input']>;
  not_equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Cms_VersionsSeoCategory_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  not_equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cms_VersionsSeoCategory_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsSeoCategory_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Cms_VersionsSeoCategory_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_VersionsSeoCategory_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Version___Status_Input>>>;
  equals?: InputMaybe<Cms_VersionsSeoCategory_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Version___Status_Input>>>;
  not_equals?: InputMaybe<Cms_VersionsSeoCategory_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Version___Status_Input>>>;
};

export type Cms_VersionsSeoCategory_Version__CategoryCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsSeoCategory_Version__CategoryName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Cms_VersionsSeoCategory_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsSeoCategory_Version__SeoContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
};

export type Cms_VersionsSeoCategory_Version__Tenant_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type Cms_VersionsSeoCategory_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['DateTime']['input']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  less_than?: InputMaybe<Scalars['DateTime']['input']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  not_equals?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Cms_VersionsSeoCategory_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsSeoCategory_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsSeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsSeoCategory_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsSeoCategory_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsSeoCategory_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsSeoCategory_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsSeoCategory_Version___Status_Operator>;
  version__categoryCode?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryCode_Operator>;
  version__categoryName?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryName_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsSeoCategory_Version__CreatedAt_Operator>;
  version__seoContent?: InputMaybe<Cms_VersionsSeoCategory_Version__SeoContent_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsSeoCategory_Version__Tenant_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsSeoCategory_Version__UpdatedAt_Operator>;
};

export type Cms_VersionsSeoCategory_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsSeoCategory_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsSeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsSeoCategory_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsSeoCategory_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsSeoCategory_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsSeoCategory_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsSeoCategory_Version___Status_Operator>;
  version__categoryCode?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryCode_Operator>;
  version__categoryName?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryName_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsSeoCategory_Version__CreatedAt_Operator>;
  version__seoContent?: InputMaybe<Cms_VersionsSeoCategory_Version__SeoContent_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsSeoCategory_Version__Tenant_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsSeoCategory_Version__UpdatedAt_Operator>;
};

export type Cms_VersionsSeoCategory_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_VersionsSeoCategory_Where_Or>>>;
  autosave?: InputMaybe<Cms_VersionsSeoCategory_Autosave_Operator>;
  createdAt?: InputMaybe<Cms_VersionsSeoCategory_CreatedAt_Operator>;
  id?: InputMaybe<Cms_VersionsSeoCategory_Id_Operator>;
  latest?: InputMaybe<Cms_VersionsSeoCategory_Latest_Operator>;
  parent?: InputMaybe<Cms_VersionsSeoCategory_Parent_Operator>;
  updatedAt?: InputMaybe<Cms_VersionsSeoCategory_UpdatedAt_Operator>;
  version___status?: InputMaybe<Cms_VersionsSeoCategory_Version___Status_Operator>;
  version__categoryCode?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryCode_Operator>;
  version__categoryName?: InputMaybe<Cms_VersionsSeoCategory_Version__CategoryName_Operator>;
  version__createdAt?: InputMaybe<Cms_VersionsSeoCategory_Version__CreatedAt_Operator>;
  version__seoContent?: InputMaybe<Cms_VersionsSeoCategory_Version__SeoContent_Operator>;
  version__tenant?: InputMaybe<Cms_VersionsSeoCategory_Version__Tenant_Operator>;
  version__updatedAt?: InputMaybe<Cms_VersionsSeoCategory_Version__UpdatedAt_Operator>;
};

/** Source: M2 (Contenu > Catalog event > Gestion des cards) */
export type Card = {
  baseline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  link?: Maybe<Scalars['URL']['output']>;
  title: Scalars['String']['output'];
};

/**
 * Represents the shopping cart containing items, prices, discount...
 * Source M2 + Ms-Agency
 */
export type Cart = {
  __typename?: 'Cart';
  amountUntilFreeDelivery?: Maybe<Scalars['Float']['output']>;
  /**
   * Total quantity of items available for click-and-collect in the cart
   * Source: M2
   */
  availableClickAndCollectQuantity?: Maybe<Scalars['Float']['output']>;
  /** A boolean indicating if the customer can request a delivery date. */
  canRequestDeliveryDate?: Maybe<Scalars['Boolean']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  /**
   * Date of creation.
   * Source: M2
   */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * Currency used in the website.
   * Source: M2
   */
  currency?: Maybe<Scalars['String']['output']>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Has items only in clickAndCollect mode
   * Source: Mesh-m2
   */
  hasClickAndCollectOnlyItems: Scalars['Boolean']['output'];
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']['output'];
  internalRef?: Maybe<Scalars['String']['output']>;
  /** True if the customer has enabled cart switching to clickAndCollect mode. */
  isClickAndCollectActivated: Scalars['Boolean']['output'];
  /**
   * True if the click-and-collect feature is enabled in M2 config and in Yext (via MS-Agency) for the point of sale.
   * Source: M2 + MS-Agency
   */
  isClickAndCollectFeatureAvailable: Scalars['Boolean']['output'];
  isClickAndCollectToggleAvailable: Scalars['Boolean']['output'];
  /** Lists the products with their quantities and other details, such as availability based on the shipping method */
  items?: Maybe<Array<Maybe<CartItem>>>;
  /**
   * Items grouped by delivery date, earliest delivery date first
   * Source: M2
   */
  itemsGroupedByEarliestDeliveryDate?: Maybe<Array<CartItemsSection>>;
  /**
   * Items split by delivery date, an item can be in multiple sections
   * Source: M2
   */
  itemsSplitByDeliveryDate?: Maybe<Array<CartItemsSection>>;
  /** Legal notice available for promotion in this cart. */
  legalNotices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Messages related to the cart
   * Source: M2
   */
  messages?: Maybe<Array<Maybe<CartMessage>>>;
  pointOfSale?: Maybe<PointOfSale>;
  requestedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /** Pre-assigned order ID reserved for the quote before order placement. */
  reservedOrderId?: Maybe<Scalars['String']['output']>;
  subtotalExclTax?: Maybe<Scalars['Float']['output']>;
  /** Sum of all item quantities in the cart */
  sumItemsQuantity?: Maybe<Scalars['Int']['output']>;
  taxesDetails?: Maybe<Array<CartTaxItem>>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  /**
   * Total amount of eco-part taxes of the cart
   * source: M2
   */
  totalEcoPart?: Maybe<Scalars['Float']['output']>;
  totalExclTax?: Maybe<Scalars['Float']['output']>;
  totalInclTax?: Maybe<Scalars['Float']['output']>;
  /** Total quantity of unique product in the cart */
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
  /**
   * Date of last update.
   * Source: M2
   */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CartAddress = {
  __typename?: 'CartAddress';
  _user_company_address_id?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  isoCountryCode: Scalars['IsoCountryCode2']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  type?: Maybe<UserCompanyAddressType>;
  userCompanyAddress?: Maybe<UserCompanyAddress>;
};

/** Input to add an Address */
export type CartAddressInput = {
  city: Scalars['String']['input'];
  isoCountryCode: Scalars['IsoCountryCode2']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
};

/**
 * Represent a product in cart with its quantity and other details, such as availability based on the shipping method
 * Source: M2 + Ms-Price&Stock
 */
export type CartItem = {
  __typename?: 'CartItem';
  /** Contains the analytics promotion status for the item (web - code promo / web - remise universelle/null) */
  analyticsPromotionStatus?: Maybe<Scalars['String']['output']>;
  /**
   * True if the cart contains an item clickAndCollect available in stock.
   * Source: MS-Price-Stock
   */
  availableClickAndCollect: Scalars['Boolean']['output'];
  /** Unit Price calculated for a product according its conditionning */
  calculatedConditionningPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Contains details about the delivery stock of the product Item.
   * Source: MS-Price-Stock
   */
  deliveryDetails?: Maybe<Array<Maybe<CartItemDeliveryStockDetails>>>;
  /**
   * Contains details about the discount of the product Item.
   * Source: Magento2, MS-Price-Stock
   */
  discount?: Maybe<CartItemDiscount>;
  /**
   * Has payment information to display.
   * If the product has a reduced tax rate and the payment functionality is active and enabled on the subsidiary,
   * we will indicate to the customer that credit card payment will not be available for the item concerned.
   * Source: M2
   */
  hasPaymentWarning: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  /** Indicates the item's status in Click and Collect and the associated pickup store */
  options?: Maybe<CartItemOptions>;
  /**
   * Represents the packaging details of a product, including the unit of measure and quantity per single item.
   * Example: Two 5-liter oil cans: quantity = 5, unit = L but two product in cart
   * Source: Ms-Price&Stock
   */
  packaging?: Maybe<ProductPackaging>;
  /** Product information related to the cart item. */
  product?: Maybe<Product>;
  /** Display code of the promotion applied to the product, if any. */
  promoPriceCode?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the promotion tag associated with the cart item, if applicable.
   *
   * Source: Magento2,MS-Price-Stock
   */
  promotionTag?: Maybe<PromotionTag>;
  /**
   * The quantity of this item in the cart.
   * Source: Magento2
   */
  quantity: Scalars['Float']['output'];
  /**
   * Quantity Max available if product is clickAndCollect or G9(discontinued) .
   * Source: M2
   */
  quantityMax?: Maybe<Scalars['Int']['output']>;
  totalExclTax?: Maybe<Scalars['Float']['output']>;
  unitPrice: CartItemUnitPrice;
  /**
   * Warning messages related to the cart item.
   * Source: Magento2
   */
  warnings?: Maybe<Array<Maybe<CartItemWarning>>>;
};

export type CartItemDeliveryStockDetails = {
  __typename?: 'CartItemDeliveryStockDetails';
  /**
   * Contains delivery availability for the item
   * Source: M2
   */
  availability: ShippingDelay;
  /**
   * Contains the delivery date if real delivery date is true
   * Source: M2
   */
  date?: Maybe<Scalars['String']['output']>;
  /**
   * Contains the quantity of this item concerned by the delivery details
   * Source: M2
   */
  quantity: Scalars['Int']['output'];
  /** Source: M2 */
  realDeliveryDate: Scalars['Boolean']['output'];
};

/**
 * Contains details about the discount of the product Item.
 * Source: M2
 */
export type CartItemDiscount = {
  __typename?: 'CartItemDiscount';
  /** The amount of discount applied from the catalog. */
  catalogDiscountAmount?: Maybe<Scalars['Float']['output']>;
  /** The original price of the item before discount. */
  oldPrice?: Maybe<Scalars['Float']['output']>;
  /** The percentage of the discount applied. */
  percentage?: Maybe<Scalars['Int']['output']>;
  /** Details about the next level of quantity sale discount. */
  quantitySaleNextLevel?: Maybe<QuantitySaleNextLevel>;
  /** Details about the web discount applied to the item. */
  webDiscount?: Maybe<WebDiscount>;
};

/**
 * Indicates the item's status in Click and Collect and the associated pickup store
 * Source: M2 + Ms-Agency
 */
export type CartItemOptions = {
  __typename?: 'CartItemOptions';
  /**
   * Pickup store Click And Collect
   * Source: MS Agency
   */
  clickAndCollectPointOfSale?: Maybe<PointOfSale>;
  /**
   * if item is in mode click and collect or not
   * Source: M2
   */
  isClickAndCollect: Scalars['Boolean']['output'];
  /**
   * Id shop delivery from session shop
   * Source: MS-Price-Stock
   */
  shop_id?: Maybe<Scalars['String']['output']>;
};

/**
 * Price related to a cart item.
 * Source: M2
 */
export type CartItemUnitPrice = {
  __typename?: 'CartItemUnitPrice';
  /**
   * Price returned by mrod for an item.
   * This price can sometimes be crossed out without a promotion
   */
  exclTax?: Maybe<Scalars['Float']['output']>;
};

/**
 * Warning message related to the cart item.
 * Source: M2
 */
export type CartItemWarning = {
  __typename?: 'CartItemWarning';
  /** Array of Additional data per warning message */
  additionalData?: Maybe<Array<Maybe<KeyValue>>>;
  /** Warning message */
  message: Scalars['String']['output'];
  /** Warning type */
  type: CartItemWarningType;
};

/**
 * Different type Warning for a cart item:
 * - UNDEFINED : undefined warning
 * - ITEM_QTY : item quantity warning
 * Source: M2
 */
export enum CartItemWarningType {
  ItemQty = 'ITEM_QTY',
  Undefined = 'UNDEFINED'
}

export type CartItemsSection = {
  __typename?: 'CartItemsSection';
  /**
   * This field can be of type CartItemsSectionInfoReal, CartItemsSectionInfoEstimated or CartItemsSectionInfoClickAndCollect
   * Source: M2
   */
  info: CartItemsSectionInfo;
  /** Items in this delivery section */
  items?: Maybe<Array<CartItem>>;
  /** Total quantity of items in this delivery section */
  quantity: Scalars['Int']['output'];
};

export type CartItemsSectionInfo = CartItemsSectionInfoClickAndCollect | CartItemsSectionInfoEstimated | CartItemsSectionInfoReal;

export type CartItemsSectionInfoClickAndCollect = {
  __typename?: 'CartItemsSectionInfoClickAndCollect';
  /** This is present only to be able to query the type, but value will not be used */
  noValue?: Maybe<Scalars['String']['output']>;
};

export type CartItemsSectionInfoEstimated = {
  __typename?: 'CartItemsSectionInfoEstimated';
  delay: ShippingDelay;
};

export type CartItemsSectionInfoReal = {
  __typename?: 'CartItemsSectionInfoReal';
  date?: Maybe<Scalars['String']['output']>;
};

export type CartMessage = {
  __typename?: 'CartMessage';
  /**
   * Message code
   * Source: M2
   */
  code: CartMessageCode;
  /**
   * Message text
   * Source: M2
   */
  message: Scalars['String']['output'];
};

export enum CartMessageCode {
  ApprovalUnavailableItems = 'APPROVAL_UNAVAILABLE_ITEMS',
  ClickAndCollectOnlyActivated = 'CLICK_AND_COLLECT_ONLY_ACTIVATED',
  DeliveryDateExpired = 'DELIVERY_DATE_EXPIRED',
  ErrorQty = 'ERROR_QTY',
  UnavailableItems = 'UNAVAILABLE_ITEMS',
  Unknown = 'UNKNOWN'
}

export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  amount: Money;
  label: Scalars['String']['output'];
};

/** Source: M2 (Contenu > Catalog event) */
export type CatalogEvent = {
  link?: Maybe<Scalars['URL']['output']>;
  title: Scalars['String']['output'];
};

export type CatalogInfo = {
  __typename?: 'CatalogInfo';
  events?: Maybe<Array<Scalars['String']['output']>>;
  parentReference?: Maybe<Scalars['String']['output']>;
};

export enum CatalogProductSellable {
  NotSellable = 'NOT_SELLABLE',
  NotSellableAsSteel = 'NOT_SELLABLE_AS_STEEL',
  Sellable = 'SELLABLE'
}

/**
 * Page data for serving a category page
 * Source : M2 (catalog_category) + FH
 * Orderby : M2 category tree
 */
export type Category = {
  __typename?: 'Category';
  baseline?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  categories?: Maybe<Array<Category>>;
  /** primary key */
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  /** Category page without products (based on category tree level : 1 or 2 => true, 3 or 4 => false) */
  isUniverse: Scalars['Boolean']['output'];
  mainImage?: Maybe<Image>;
  /** Banner displayed in the product list */
  marketingBanner?: Maybe<MarketingBanner>;
  name: Scalars['String']['output'];
  /** Resolve the products pageable collection belonging to the category, along with available filters for sub selection */
  productList?: Maybe<ProductList>;
  seoContent?: Maybe<Scalars['String']['output']>;
  urlKey: Scalars['String']['output'];
};


/**
 * Page data for serving a category page
 * Source : M2 (catalog_category) + FH
 * Orderby : M2 category tree
 */
export type CategoryProductListArgs = {
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryBreadcrumbArg = {
  descoursCategoryId?: InputMaybe<Scalars['String']['input']>;
  urlPath?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryByLevel = {
  __typename?: 'CategoryByLevel';
  niveau?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Array<Maybe<Category>>>;
};

/** Defines the filters to be used in the search */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the descours category ID for a `CategoryInterface` object. Source: Magento 2 */
  descours_category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by category type. Possible values (for now): `our_products` (root for level 1 product categories), `brands` (root for brand categories). */
  descours_category_type?: InputMaybe<FilterEqualTypeInput>;
  /** Set to true to exclude categories with no associated products in the current store. */
  exclude_empty_categories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Checkout = {
  __typename?: 'Checkout';
  cart: Cart;
  /** Return the payload to create a Lyra payment form for Ideal */
  generateLyraForm?: Maybe<LyraForm>;
  /** The payment methods and information used to complete an order */
  payment?: Maybe<Payment>;
  /** The shipping methods and information used to deliver and invoice an order */
  shipping?: Maybe<Shipping>;
  /** True is placeOrder will generate an order request */
  willGenerateOrderRequest: Scalars['Boolean']['output'];
};


export type CheckoutCartArgs = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CheckoutGenerateLyraFormArgs = {
  webRef?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Chorus informations about client (company)
 * Source: Esb
 */
export type ChorusData = {
  __typename?: 'ChorusData';
  /**
   * To know if the client is a chorus client
   * TRUE if "Is_Chorus":"YES" and "Chorus_Status":"ACTIF" else FALSE
   */
  isChorus?: Maybe<Scalars['Boolean']['output']>;
  /**
   * To know if legal commitment field is required
   * TRUE if "Required_Legal_Comittement":"YES" else FALSE
   */
  isRequiredLegalCommitment?: Maybe<Scalars['Boolean']['output']>;
  /**
   * To know if service field is required
   * TRUE if "Required_Service":"YES" else FALSE
   */
  isRequiredService?: Maybe<Scalars['Boolean']['output']>;
  /** To know if legal commitment and service field is required */
  isRequiredServiceOrRequiredLegalCommitment?: Maybe<Scalars['Boolean']['output']>;
  /** Chorus service of client */
  services?: Maybe<Array<ChorusService>>;
};

export type ChorusDataInput = {
  legalCommitment?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Chorus service informations
 * Source: Esb
 */
export type ChorusService = {
  __typename?: 'ChorusService';
  /** Code of the service */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * To know if the service is required
   * TRUE if "Service_Required_Legal_Comittment":"YES" else FALSE
   */
  isRequiredLegalCommitment?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the service */
  name?: Maybe<Scalars['String']['output']>;
  /** Status of the service */
  status?: Maybe<Scalars['String']['output']>;
};

/** Mesh Saas (CapAdresse) */
export type City = {
  __typename?: 'City';
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

/**
 * Source: M2
 * Input data to change clickAndCollect item quantities.
 */
export type ClickAndCollectCartItemUpdateInput = {
  /** The unique ID for a `CartItemInterface` object. */
  cartItemUid?: InputMaybe<Scalars['ID']['input']>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export enum ClickAndCollectStatus {
  Available = 'AVAILABLE',
  ClickAndCollectOnly = 'CLICK_AND_COLLECT_ONLY',
  StoreOnly = 'STORE_ONLY'
}

export type ClientContactEmails = {
  __typename?: 'ClientContactEmails';
  copyTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  principal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Source M2 */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  code?: Maybe<Scalars['String']['output']>;
  jsonContent?: Maybe<Scalars['String']['output']>;
};

export type CmsPage = {
  __typename?: 'CmsPage';
  code: Scalars['String']['output'];
  jsonContent: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
};

export type CollaboratorPermissions = {
  __typename?: 'CollaboratorPermissions';
  allowedRolesToManage: Array<UserRole>;
  canApproveOrderRequest: Scalars['Boolean']['output'];
  canManageAddress: Scalars['Boolean']['output'];
  canManageApprovalFlows: Scalars['Boolean']['output'];
  canManageCompanyUser: Scalars['Boolean']['output'];
  canManageLoyaltyAccount: Scalars['Boolean']['output'];
  canManageQuote: Scalars['Boolean']['output'];
  canShareWishlist: Scalars['Boolean']['output'];
  hasAccessToOrderRequestToApprove: Scalars['Boolean']['output'];
  hasAccessToStoreOrders: Scalars['Boolean']['output'];
  hasAccessToWebOrders: Scalars['Boolean']['output'];
  showBob: Scalars['Boolean']['output'];
  showCompanyOrders: Scalars['Boolean']['output'];
  showCompanyUsers: Scalars['Boolean']['output'];
  showOrderHistory: Scalars['Boolean']['output'];
  showPreferenceCommunication: Scalars['Boolean']['output'];
  showStoreOrderHistory: Scalars['Boolean']['output'];
};

/** General account information aggregate from different sources */
export type Company = {
  __typename?: 'Company';
  /** MS Client : specific address by id, if exist and linked to company */
  address?: Maybe<UserCompanyAddress>;
  /** MS Client : list of all the addresses share between all the users of the company */
  addresses?: Maybe<Array<UserCompanyAddress>>;
  /**
   * A list of approval flows, including their names and the users involved (both approvers and subjects).
   * Each query to the approvalFlows entry point will be filtered by the client ID of the current user.
   * Available filter fields :
   * * amount (less or equal)
   * * approvalFlowId
   * * userApprovalRole (accepted values if present : "ALL" / "APPROVER" / "USER")
   * * name
   * * userIds
   * * approvalFlowId
   * Available sort field :
   * * createdAt
   * * name
   */
  approvalFlows: ApprovalFlowPagination;
  availableUserRoles: Array<UserRole>;
  chorusData?: Maybe<ChorusData>;
  /**
   * MS Client : code of the company ([agencyLink][clientIdExternal] in MS Client)
   * header : x-company-code
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * Source : Mesh MS
   * Retrieve users eligible to be approvees
   * (+ the one already assigned to a specific approval flow if approvalFlowId is provided)
   */
  eligibleApprovees?: Maybe<Array<UserPartialInfos>>;
  /**
   * Source : Mesh MS
   * Retrieve eligible users allowed to be approvers in approval flows
   */
  eligibleApprovers?: Maybe<Array<UserPartialInfos>>;
  /**
   * Source : Mesh MS
   * Company is forbidden
   */
  forbidden: Scalars['Boolean']['output'];
  /** MS Client : internal id of the company */
  id: Scalars['String']['output'];
  /** Source MS : deliveryFeeExempted if the company has the delivery fee exemption activated */
  isDeliveryFeeExempted: Scalars['Boolean']['output'];
  /** MS Client :Determine whether orderReference is mandatory for this client when placing an order */
  isOrderReferenceMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** Source MS : isProspect if the company type is TP */
  isProspect: Scalars['Boolean']['output'];
  /** Source MS : isPublicAdministration if the building_hardware is AP */
  isPublicAdministration: Scalars['Boolean']['output'];
  managerEmailHidden: Scalars['String']['output'];
  /** MS Client : name of the company (clientName in MS Client) */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * MS Client : point of sale assigned to the company ([agencyLink][agencyId] in MS Client)
   * MS User : point of sale assigned to the company (agencyId in MS User)
   * MS Agency : return the point of sale information of the company from MS Agency
   */
  pointOfSale?: Maybe<PointOfSale>;
  /** MS Client : profession code */
  professionCode?: Maybe<Scalars['String']['output']>;
  /** MS Client : profession group code */
  professionGroupCode: Scalars['String']['output'];
  /**
   * Source : Mesh OnPrem
   * Get Quotes from the company
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * If no dates specified will take last year from today date
   * Available filter fields :
   * * startDate
   * * endDate
   * * id + pointOfSaleId (details view)
   * No sort available
   */
  quotes: QuotePagination;
  siret: Scalars['String']['output'];
  /** MS Client : status of the company */
  status: CompanyStatus;
  topPurchaseList: TopPurchase;
  /**
   * MS Client : creation type of the company (mrodClientType in MS Client)
   * values : NO (=normal), TP (=prospect, limited access on features)
   */
  type?: Maybe<Scalars['String']['output']>;
  /**
   * MS User : List of company collaborators
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * Each query to the users' entry point will be filtered by the client ID of the current user.
   * Available filter fields :
   * * userId (to get one other user of the company)
   * * search
   * * role
   * Available sort field :
   * * firstname
   * * email
   */
  users: UserPagination;
  /**
   * Source : Mesh MS
   * List of all users involved in any approval flow (as approver or approvee)
   */
  usersInApprovalFlows?: Maybe<Array<UserPartialInfos>>;
};


/** General account information aggregate from different sources */
export type CompanyAddressArgs = {
  id: Scalars['String']['input'];
};


/** General account information aggregate from different sources */
export type CompanyApprovalFlowsArgs = {
  input?: InputMaybe<Browsing>;
};


/** General account information aggregate from different sources */
export type CompanyEligibleApproveesArgs = {
  approvalFlowId?: InputMaybe<Scalars['String']['input']>;
};


/** General account information aggregate from different sources */
export type CompanyQuotesArgs = {
  input?: InputMaybe<Browsing>;
};


/** General account information aggregate from different sources */
export type CompanyTopPurchaseListArgs = {
  firstLevelCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


/** General account information aggregate from different sources */
export type CompanyUsersArgs = {
  input?: InputMaybe<Browsing>;
};

export enum CompanyNationalIdCharset {
  Numeric = 'NUMERIC'
}

export type CompanyNationalIdConfig = {
  __typename?: 'CompanyNationalIdConfig';
  /**
   * Source M2
   * Given the format of the company national id for the current store view
   */
  formatByCountry?: Maybe<Array<CompanyNationalIdFormat>>;
};

/**
 * Context : Return the company data from DQE
 * Source : Mesh saas
 */
export type CompanyNationalIdData = {
  __typename?: 'CompanyNationalIdData';
  activityIndicator?: Maybe<Scalars['String']['output']>;
  apeCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyNameComplement?: Maybe<Scalars['String']['output']>;
  currentWorkforce?: Maybe<Scalars['String']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  intraComVatNumber?: Maybe<Scalars['String']['output']>;
  isoCountryCode?: Maybe<Scalars['IsoCountryCode2']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  siren?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type CompanyNationalIdFormat = {
  __typename?: 'CompanyNationalIdFormat';
  charset: CompanyNationalIdCharset;
  isoCountryCode3: Scalars['String']['output'];
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
};

export type CompanyPagination = {
  __typename?: 'CompanyPagination';
  items: Array<Company>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * Source : Mesh unified
 * Context : Return type of the mutation requestCompanyRegistration, allowing to know the next step to execute
 */
export type CompanyRegistrationRequestAction = {
  __typename?: 'CompanyRegistrationRequestAction';
  action: CompanyRegistrationRequestEnum;
  company: CompanyRegistrationResult;
  email: Scalars['Email']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** The possible actions to execute after the DOC registration request */
export enum CompanyRegistrationRequestEnum {
  CompanyRegistrationRequestInProgressPageUrl = 'COMPANY_REGISTRATION_REQUEST_IN_PROGRESS_PAGE_URL',
  CompanyRegistrationRequestSuccessPageUrl = 'COMPANY_REGISTRATION_REQUEST_SUCCESS_PAGE_URL',
  IamPasswordPageUrl = 'IAM_PASSWORD_PAGE_URL',
  MultiAccountSuccessPageUrl = 'MULTI_ACCOUNT_SUCCESS_PAGE_URL'
}

/**
 * Source : Front
 * Context : Input to register a company request (DOC) with the company registration form
 */
export type CompanyRegistrationRequestInput = {
  acceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  companyNationalId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Email']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['Email']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['Phone']['input'];
  pointOfSaleId: Scalars['String']['input'];
  specialityId: Scalars['Int']['input'];
};

/**
 * Source : Mesh unified
 * Context : Return type of the mutation requestCompanyRegistration, allowing to pass company data to front
 * Cannot use Company type as when Classic doc we don't company creation in ms is async
 */
export type CompanyRegistrationResult = {
  __typename?: 'CompanyRegistrationResult';
  code?: Maybe<Scalars['String']['output']>;
  companyNationalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointOfSale?: Maybe<PointOfSale>;
};

/** MS Client : status of the company */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

/**
 * Context: Different configurations used in frontend
 * Source: M2 (core_config_data) + saas
 */
export type Config = {
  __typename?: 'Config';
  captcha?: Maybe<ConfigCaptcha>;
  catalog?: Maybe<ConfigCatalog>;
  checkout?: Maybe<ConfigCheckout>;
  customer?: Maybe<ConfigCustomer>;
  homepage?: Maybe<ConfigHomepage>;
  loyalty?: Maybe<ConfigLoyalty>;
  pointOfSale?: Maybe<ConfigPointOfSale>;
  preheader: ConfigPreheader;
  quotation?: Maybe<ConfigQuotation>;
  sales?: Maybe<ConfigSales>;
  site?: Maybe<ConfigSite>;
  support?: Maybe<ConfigSupport>;
};

export type ConfigCaptcha = {
  __typename?: 'ConfigCaptcha';
  /** Comes from magento core_config_data */
  isEnabled: Scalars['Boolean']['output'];
  /** Comes from saas environnement variables */
  siteKey: Scalars['String']['output'];
};

/**
 * Configuration of the catalog
 * Source: M2 (core_config_data)
 */
export type ConfigCatalog = {
  __typename?: 'ConfigCatalog';
  ccOnlyReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clickAndCollectOnlyList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  destockEventName?: Maybe<Scalars['String']['output']>;
  g9LowStockThreshold?: Maybe<Scalars['String']['output']>;
  isActiveHideVatPrice: Scalars['Boolean']['output'];
  isClickAndCollectOnlyEnabled: Scalars['Boolean']['output'];
  isConnectedLocalStockVisible: Scalars['Boolean']['output'];
  isLinkedProductEnabled: Scalars['Boolean']['output'];
  isOrderMarketingThresholdEnabled: Scalars['Boolean']['output'];
  isPriceFromEnabled: Scalars['Boolean']['output'];
  isProductLabelGenerationEnabled: Scalars['Boolean']['output'];
  isPublicPricesEnabled: Scalars['Boolean']['output'];
  isPublicSaleEnabled: Scalars['Boolean']['output'];
  isPublicStockEnabled: Scalars['Boolean']['output'];
  isStoreNameDisplayedOnProductLabel: Scalars['Boolean']['output'];
  lengthReference?: Maybe<Scalars['String']['output']>;
  onlineExcluded?: Maybe<Scalars['Boolean']['output']>;
  onlineExcludedList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  onlineExcludedReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orderMarketingThresholdAmount?: Maybe<Scalars['Float']['output']>;
  ourProductsCategoryUrlKey?: Maybe<Scalars['String']['output']>;
  publicExternalClientId?: Maybe<Scalars['String']['output']>;
  publicPointOfSaleId?: Maybe<Scalars['String']['output']>;
  publicSubsidiaryId?: Maybe<Scalars['String']['output']>;
};

/**
 * Checkout Configuration
 * Source: M2 (core_config_data)
 */
export type ConfigCheckout = {
  __typename?: 'ConfigCheckout';
  isActiveOrderRequest: Scalars['Boolean']['output'];
  isMiniCartEnabled: Scalars['Boolean']['output'];
};

export type ConfigCompany = {
  __typename?: 'ConfigCompany';
  approvalFlowApproveeRoles: Array<UserRole>;
  approvalFlowApproverRoles: Array<UserRole>;
};

/**
 * Configuration of the customer
 * Source: M2 (core_config_data)
 */
export type ConfigCustomer = {
  __typename?: 'ConfigCustomer';
  allowedPostcodePrefixes?: Maybe<Array<Scalars['String']['output']>>;
  companyNationalIdConfig: CompanyNationalIdConfig;
  europeanCountries: Array<Country>;
  forbiddenPhoneTypes?: Maybe<Array<Scalars['String']['output']>>;
  isAccountCreationEnabled: Scalars['Boolean']['output'];
  isAddressAutocompleteEnabled: Scalars['Boolean']['output'];
  isAddressCreationEnabled: Scalars['Boolean']['output'];
  isAddressDeletionEnabled: Scalars['Boolean']['output'];
  isAddressEditionEnabled: Scalars['Boolean']['output'];
  isExpressAccountOpeningRequestEnabled: Scalars['Boolean']['output'];
  isMailgunValidationEnabled: Scalars['Boolean']['output'];
  isPhoneNumberValidationServiceEnabled: Scalars['Boolean']['output'];
  isTopPurchaseEnabled: Scalars['Boolean']['output'];
  nameFormat: NameFormat;
};

export type ConfigDeliveryTime = {
  __typename?: 'ConfigDeliveryTime';
  isSaturdayAvailable: Scalars['Boolean']['output'];
  isSundayAvailable: Scalars['Boolean']['output'];
  nbDayMaximum: Scalars['Int']['output'];
  nbDayMinimum: Scalars['Int']['output'];
};

/**
 * Configuration of the homepage
 * Source: M2 (core_config_data)
 */
export type ConfigHomepage = {
  __typename?: 'ConfigHomepage';
  ourBrandsBlockEnabled: Scalars['Boolean']['output'];
  ourSelectionGuidesBlockEnabled: Scalars['Boolean']['output'];
  ourServicesBlockEnabled: Scalars['Boolean']['output'];
  showServicesBlock: Scalars['Boolean']['output'];
};

export type ConfigLoyalty = {
  __typename?: 'ConfigLoyalty';
  isEnabled: Scalars['Boolean']['output'];
};

/**
 * Configuration of the point of sale feature
 * Source: M2 (core_config_data)
 */
export type ConfigPointOfSale = {
  __typename?: 'ConfigPointOfSale';
  dashboardFavoritePointOfSaleImage?: Maybe<Image>;
  isFavoritePointOfSaleEnabled: Scalars['Boolean']['output'];
  isLocalStockByStoreEnabled: Scalars['Boolean']['output'];
  isPickupPointOfSaleEnabled: Scalars['Boolean']['output'];
  isSubsidiaryDisplayEnabled: Scalars['Boolean']['output'];
  storeLocatorUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Configuration of the preheader
 * Source: M2 (core_config_data)
 */
export type ConfigPreheader = {
  __typename?: 'ConfigPreheader';
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  textColor?: Maybe<Scalars['Color']['output']>;
};

export type ConfigQuotation = {
  __typename?: 'ConfigQuotation';
  isQuotationEnabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type ConfigSales = {
  __typename?: 'ConfigSales';
  deliveryTime?: Maybe<ConfigDeliveryTime>;
  ideal?: Maybe<IdealConfig>;
  isBilltrustRedirectEnabled: Scalars['Boolean']['output'];
  isChorusDisplayEnabled: Scalars['Boolean']['output'];
  isClickAndCollectEnabled?: Maybe<Scalars['Boolean']['output']>;
  isClickAndCollectOnlyEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFreeShippingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOnSiteDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPunchoutEnabled: Scalars['Boolean']['output'];
  isPunchoutLightEnabled: Scalars['Boolean']['output'];
  isQuickOrderEnabled: Scalars['Boolean']['output'];
  isRefOrderDisplayOnNonMandatoryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isRequestedDateEnabled?: Maybe<Scalars['Boolean']['output']>;
  isRoutingToOtherAgencyClickAndCollect?: Maybe<Scalars['Boolean']['output']>;
  isRoutingToOtherAgencyOnsiteDelivery?: Maybe<Scalars['Boolean']['output']>;
  isRoutingToOtherAgencyStorePickup?: Maybe<Scalars['Boolean']['output']>;
  isStoreOrderDetailsDisplayEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStorePickupEnabled?: Maybe<Scalars['Boolean']['output']>;
  isTrackingStoreOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  isTrackingWebOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  isUniqueOrderDetailsDisplayEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWebOrderDetailsDisplayEnabled?: Maybe<Scalars['Boolean']['output']>;
  maxShippingAmountWithoutCost?: Maybe<Scalars['Float']['output']>;
  orderReferenceRegex?: Maybe<Scalars['String']['output']>;
  payzen?: Maybe<PayzenConfig>;
  routingAgencyCodeClickAndCollect?: Maybe<Scalars['String']['output']>;
  routingAgencyCodeOnsiteDelivery?: Maybe<Scalars['String']['output']>;
  routingAgencyCodeStorePickup?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type ConfigSite = {
  __typename?: 'ConfigSite';
  defaultCountryIso2: Scalars['String']['output'];
  defaultCountryIso3: Scalars['String']['output'];
  robotsContent: Scalars['String']['output'];
  robotsMeta: Scalars['String']['output'];
  sitemapUrl: Scalars['String']['output'];
};

/**
 * Configuration of the support feature
 * Source: M2 (core_config_data)
 */
export type ConfigSupport = {
  __typename?: 'ConfigSupport';
  contactFormType: ContactFormType;
  enableFaq: Scalars['Boolean']['output'];
  isGlobalClick2ChatEnabled: Scalars['Boolean']['output'];
  isLoginAsEnabled: Scalars['Boolean']['output'];
  isLoginClick2ChatEnabled: Scalars['Boolean']['output'];
  scriptKey: Scalars['String']['output'];
};

export enum ContactFormType {
  Enhanced = 'ENHANCED',
  Simplified = 'SIMPLIFIED'
}

/**
 * Source : Mesh M2
 * Submit contact request to M2
 */
export type ContactRequestInput = {
  clientIdExternal?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  company: Scalars['String']['input'];
  companyNationalId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  pointOfSaleId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/**
 * Source M2
 * Context : subject for the contact form
 */
export type ContactSubject = {
  __typename?: 'ContactSubject';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/**
 * Source M2
 * Context : parent subject (category) for the contact form
 */
export type ContactSubjectCategory = {
  __typename?: 'ContactSubjectCategory';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  subjects: Array<ContactSubject>;
  type: Scalars['String']['output'];
};

export type ContactView = {
  __typename?: 'ContactView';
  email: Scalars['Email']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  iso: Scalars['String']['output'];
  iso3: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']['output']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']['output']>;
};

export enum CurrencyEnum {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azm = 'AZM',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Buk = 'BUK',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gek = 'GEK',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gqe = 'GQE',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lsm = 'LSM',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nic = 'NIC',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Rhd = 'RHD',
  Rol = 'ROL',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Std = 'STD',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmm = 'TMM',
  Tnd = 'TND',
  Top = 'TOP',
  Trl = 'TRL',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Veb = 'VEB',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Ytl = 'YTL',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zwd = 'ZWD'
}

/**
 * Recipient's delivery information
 * Source: M2
 */
export type Delivery = {
  __typename?: 'Delivery';
  /** Delivery instruction */
  comment?: Maybe<Scalars['String']['output']>;
  /** Delivery recipient name */
  recipientName?: Maybe<Scalars['String']['output']>;
  /** Delivery recipient phone */
  recipientPhone?: Maybe<Scalars['String']['output']>;
};

/** The sorting order: ascending or descending. */
export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DistributionId {
  DestilNl = 'DESTIL_NL',
  Dexis = 'DEXIS',
  DexisNl = 'DEXIS_NL',
  EcomEn = 'ECOM_EN',
  Hydralians = 'HYDRALIANS',
  Prolians = 'PROLIANS'
}

export enum DistributionNetwork {
  DestilNl = 'DESTIL_NL',
  Dexis = 'DEXIS',
  DexisNl = 'DEXIS_NL',
  EcomEn = 'ECOM_EN',
  Hydralians = 'HYDRALIANS',
  Prolians = 'PROLIANS'
}

/**
 * Document files of the product
 * Source: M2
 */
export type Document = {
  __typename?: 'Document';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
};

/**
 * Type of document
 * Source: M2
 */
export enum DocumentType {
  Fids = 'FIDS',
  Pdf = 'PDF'
}

export type EcoPart = {
  __typename?: 'EcoPart';
  deee?: Maybe<Scalars['Float']['output']>;
  furnishing?: Maybe<Scalars['Float']['output']>;
  pmcb?: Maybe<Scalars['Float']['output']>;
};

export type EmailExistsInIamResponse = {
  __typename?: 'EmailExistsInIAMResponse';
  existsInIAM: Scalars['Boolean']['output'];
  users?: Maybe<Array<IamUser>>;
};

/**
 * Source : MS
 * Context : Email preferences : type is the code of the email, value to know if the user is subscribed or not
 */
export type EmailPreference = {
  __typename?: 'EmailPreference';
  emailType: Scalars['String']['output'];
  receiveEmail: Scalars['Boolean']['output'];
};

export type EmailPreferenceInput = {
  emailType: Scalars['String']['input'];
  receiveEmail: Scalars['Boolean']['input'];
};

/** Different Entity types, used in breadcrumbs */
export enum Entity {
  Brand = 'BRAND',
  BrandList = 'BRAND_LIST',
  Category = 'CATEGORY',
  Event = 'EVENT',
  Home = 'HOME',
  Product = 'PRODUCT',
  Search = 'SEARCH',
  SearchList = 'SEARCH_LIST'
}

export type EquivalentProductConfig = {
  __typename?: 'EquivalentProductConfig';
  equivalentProductsLimit: Scalars['Int']['output'];
  isEquivalentProductsDeduplicated: Scalars['Boolean']['output'];
  isEquivalentProductsLinkVisible: Scalars['Boolean']['output'];
};

/**
 * List of error codes
 * Link: https://descours-cabaud.atlassian.net/wiki/spaces/magento2/pages/20692172851/Code+dans+les+extensions+GraphQLError
 */
export enum ErrorCode {
  /**
   * Error if action address has email notification enable, but couldn't send mail
   * Context:
   * createUserCompanyAddress
   * updateUserCompanyAddress
   * deleteUserCompanyAddress
   */
  AddressActionNotificationEmailError = 'ADDRESS_ACTION_NOTIFICATION_EMAIL_ERROR',
  /** Error code generic indicating an error occurred while adding simple products to the cart */
  AddSimpleProductsToCartGenericError = 'ADD_SIMPLE_PRODUCTS_TO_CART_GENERIC_ERROR',
  /** Error code indicating max quantity reached when a product add to cart */
  AddSimpleProductsToCartMaxQuantityReachedError = 'ADD_SIMPLE_PRODUCTS_TO_CART_MAX_QUANTITY_REACHED_ERROR',
  /** Error code indicating that coupon does not meet the required conditions for use */
  ApplyCouponToCartCouponConditionNotReachedError = 'APPLY_COUPON_TO_CART_COUPON_CONDITION_NOT_REACHED_ERROR',
  /** Error code indicating that coupon has reached its global usage limit or its per-user limit */
  ApplyCouponToCartCouponMaxUseError = 'APPLY_COUPON_TO_CART_COUPON_MAX_USE_ERROR',
  /** Error code indicating that coupon is not available or expired for the cart */
  ApplyCouponToCartCouponNotAvailableError = 'APPLY_COUPON_TO_CART_COUPON_NOT_AVAILABLE_ERROR',
  /** Error code indicating that coupon not exist for the cart */
  ApplyCouponToCartCouponNotExistError = 'APPLY_COUPON_TO_CART_COUPON_NOT_EXIST_ERROR',
  /**
   * Error when no approvees found in input
   * Context: createApprovalFlow / updateApprovalFlow
   */
  ApprovalFlowApproveesRequiredError = 'APPROVAL_FLOW_APPROVEES_REQUIRED_ERROR',
  /**
   * Error when no approvers found in input
   * Context: createApprovalFlow / updateApprovalFlow
   */
  ApprovalFlowApproversRequiredError = 'APPROVAL_FLOW_APPROVERS_REQUIRED_ERROR',
  /** Error code indicating that at least one user if in the approver and approvee list */
  ApprovalFlowCreateApproverApproveeConflictError = 'APPROVAL_FLOW_CREATE_APPROVER_APPROVEE_CONFLICT_ERROR',
  /** Error code when trying to delete an approval flow with at least one order request pending */
  ApprovalFlowDeletionRequestPendingError = 'APPROVAL_FLOW_DELETION_REQUEST_PENDING_ERROR',
  /** Error code indicating that no category was found for the product breadcrumb */
  BreadcrumbProductNoCategoryFoundError = 'BREADCRUMB_PRODUCT_NO_CATEGORY_FOUND_ERROR',
  /** Error code indicating that the product for a cart item was not found */
  CartItemProductNotFoundError = 'CART_ITEM_PRODUCT_NOT_FOUND_ERROR',
  /** Error code indicating that the segment ID is missing for catalog query */
  CatalogQueryMissingSegmentIdError = 'CATALOG_QUERY_MISSING_SEGMENT_ID_ERROR',
  /** Error code indicating that the segment ID is missing for catalog search */
  CatalogSearchMissingSegmentIdError = 'CATALOG_SEARCH_MISSING_SEGMENT_ID_ERROR',
  /** Error code indicating that the segment ID is missing while querying categories in MS */
  CategoriesMsMissingSegmentIdError = 'CATEGORIES_MS_MISSING_SEGMENT_ID_ERROR',
  /** Error code indicating an error occurred while fetching category by descours ID */
  CategoryByDescoursIdError = 'CATEGORY_BY_DESCOURS_ID_ERROR',
  /** Error code indicating an error occurred while fetching category by URL path */
  CategoryByUrlPathError = 'CATEGORY_BY_URL_PATH_ERROR',
  /** Error code indicating an error occurred while fetching category facets from catalog data resulting of a search or query */
  CategoryFacetError = 'CATEGORY_FACET_ERROR',
  /** Error code indicating that the category for the product list page was not found */
  CategoryFilterForListCategoryNotFoundError = 'CATEGORY_FILTER_FOR_LIST_CATEGORY_NOT_FOUND_ERROR',
  /** Error code indicating an error occurred while clearing the cart */
  ClearCartError = 'CLEAR_CART_ERROR',
  /**
   * Error when the companyNationalId is not validated or when company information is missing
   * on the Mesh SaaS CapAddress service during registration
   */
  CompanyNationalIdBadFormatError = 'COMPANY_NATIONAL_ID_BAD_FORMAT_ERROR',
  /**
   * Error after companyNationalId validation but no active company is found for this companyNationalId
   * on the Mesh SaaS CapAddress service during registration
   */
  CompanyNationalIdCompanyNotActiveError = 'COMPANY_NATIONAL_ID_COMPANY_NOT_ACTIVE_ERROR',
  /** Error when the companyNationalId is not shareable on the Mesh SaaS CapAddress service during registration */
  CompanyNationalIdNotDiffusibleError = 'COMPANY_NATIONAL_ID_NOT_DIFFUSIBLE_ERROR',
  /**
   * Error code indicating Zendesk ticket creation failed
   * Context :
   *     submitContactRequest
   */
  ContactCreateTicketError = 'CONTACT_CREATE_TICKET_ERROR',
  /**
   * Raised when trying to select an account for the giver user,
   * but the user doesn't have any
   */
  CurrentUserAccountNoResultError = 'CURRENT_USER_ACCOUNT_NO_RESULT_ERROR',
  /** Error when issue in params passe as filters */
  DisallowedFilterError = 'DISALLOWED_FILTER_ERROR',
  /** Error when distribution network header is misssing. */
  DistributionNetworkMissingError = 'DISTRIBUTION_NETWORK_MISSING_ERROR',
  /**
   * Error during validation for invoice email input.
   * Following a call to Mesh SaaS, the Mailgun service validates the format and existence of the email.
   */
  DocInvoiceEmailServiceEmailValidationError = 'DOC_INVOICE_EMAIL_SERVICE_EMAIL_VALIDATION_ERROR',
  /** Generic error code, used when a service responds with a critical error */
  DownstreamServiceError = 'DOWNSTREAM_SERVICE_ERROR',
  /** Error when trying to modify email preferences and currentUser hasn't the permission showPreferenceCommunication */
  EmailPreferencesNotAllowedError = 'EMAIL_PREFERENCES_NOT_ALLOWED_ERROR',
  /** Error code indicating a bad HTTP request */
  HttpBadRequestError = 'HTTP_BAD_REQUEST_ERROR',
  /** Error code indicating an unauthorized HTTP request */
  HttpUnauthorizedError = 'HTTP_UNAUTHORIZED_ERROR',
  /**
   * Context: currentInternalUser
   * Error when no email recover from token
   */
  InternalTokenEmailMissingError = 'INTERNAL_TOKEN_EMAIL_MISSING_ERROR',
  /** Error code indicating that the point of sale ID is invalid (3 digits) */
  InvalidPointOfSaleIdError = 'INVALID_POINT_OF_SALE_ID_ERROR',
  /** Error during express account creation if request is out of erp's service hours */
  IsErpClosedError = 'IS_ERP_CLOSED_ERROR',
  /**
   * Error during login.
   * Generic error code, used when the creation of the M2 customer fails when getting lastUserAccount
   * Used for autologin
   */
  LastUserAccountM2CustomerCreationError = 'LAST_USER_ACCOUNT_M2_CUSTOMER_CREATION_ERROR',
  /** Error code when no account found for this email and account creation disabled */
  LoginActionDisableError = 'LOGIN_ACTION_DISABLE_ERROR',
  /**
   * Error when the email exists in IAM but has no account in MS
   * during email input on the login page
   */
  LoginActionExistsInIamWithoutUserAccountsError = 'LOGIN_ACTION_EXISTS_IN_IAM_WITHOUT_USER_ACCOUNTS_ERROR',
  /**
   * Error when the user exist in ms but not in IAM
   * creation in IAM failed
   */
  LoginActionIamUserCreationError = 'LOGIN_ACTION_IAM_USER_CREATION_ERROR',
  /**
   * Error when the M2 customer creation fails,
   * especially when entering the email on the login page
   */
  LoginActionM2CustomerCreationError = 'LOGIN_ACTION_M2_CUSTOMER_CREATION_ERROR',
  /** Error when the email exists in ms but has no active account */
  LoginActionNoActiveUserAccountError = 'LOGIN_ACTION_NO_ACTIVE_USER_ACCOUNT_ERROR',
  /** Error when the email exists in IAM but has no account attached to active company */
  LoginActionNoActiveUserCompanyError = 'LOGIN_ACTION_NO_ACTIVE_USER_COMPANY_ERROR',
  /**
   * Error during email input.
   * Following a call to Mesh SaaS, the Mailgun service validates the format and existence of the email.
   */
  LoginActionServiceEmailValidationError = 'LOGIN_ACTION_SERVICE_EMAIL_VALIDATION_ERROR',
  /**
   * When internal user is not allowed to acces this subsidiary
   * Context: generateImpersonateAuthToken
   */
  LoginAsCustomerNotAllowedError = 'LOGIN_AS_CUSTOMER_NOT_ALLOWED_ERROR',
  /**
   * If target user is lik to inactive company
   * Context: generateImpersonateAuthToken
   */
  LoginAsNotExistUserError = 'LOGIN_AS_NOT_EXIST_USER_ERROR',
  /**
   * If target user is not active in ms
   * Context: generateImpersonateAuthToken
   */
  LoginAsNoActiveCompanyError = 'LOGIN_AS_NO_ACTIVE_COMPANY_ERROR',
  /**
   * Internal User's organization not allowed for distribution network
   * Context: generateInternalToken
   */
  LoginAsOrganizationNotAllowedError = 'LOGIN_AS_ORGANIZATION_NOT_ALLOWED_ERROR',
  /**
   * Internal User's Profession Code not allowed
   * Context: generateInternalToken
   */
  LoginAsProfessionCodeNotAllowedError = 'LOGIN_AS_PROFESSION_CODE_NOT_ALLOWED_ERROR',
  /**
   * If target user is not in iam
   * Context: generateImpersonateAuthToken
   */
  LoginAsTargetNotInIamError = 'LOGIN_AS_TARGET_NOT_IN_IAM_ERROR',
  /** Error on loyalty registration when no legal status provided */
  LoyaltyLegalStatusRequiredError = 'LOYALTY_LEGAL_STATUS_REQUIRED_ERROR',
  /** Error Loyalty call when auth token couldn't be recovered */
  LoyaltyNoAuthTokenError = 'LOYALTY_NO_AUTH_TOKEN_ERROR',
  /** Error Loyalty call when no source is defines for the current distribution network */
  LoyaltyNoSourceFoundError = 'LOYALTY_NO_SOURCE_FOUND_ERROR',
  /** Error on loyalty registration if user is not eligible */
  LoyaltyUserNotEligibleError = 'LOYALTY_USER_NOT_ELIGIBLE_ERROR',
  /** Error code indicating that the product category ID is missing a segment ID parameter */
  MsproductCategoryIdMissingSegmentIdError = 'MSPRODUCT_CATEGORY_ID_MISSING_SEGMENT_ID_ERROR',
  /** Error code when searchCities gives no result for postalCode and isoCountryCode association */
  NoCityFoundForPostalCodeError = 'NO_CITY_FOUND_FOR_POSTAL_CODE_ERROR',
  /**
   * Error code when no persistent customer cart exists for the current user
   * Context: persistentCustomerCart query
   */
  NoPersistentCustomerCart = 'NO_PERSISTENT_CUSTOMER_CART',
  /** Error code indicating that an element of a requested entity does not exist */
  NoSuchEntityExceptionError = 'NO_SUCH_ENTITY_EXCEPTION_ERROR',
  /** Error code indicating that the current approver was not found */
  OrderRequestToApproveApproverNotFoundError = 'ORDER_REQUEST_TO_APPROVE_APPROVER_NOT_FOUND_ERROR',
  /** Error code indicating that required input parameters are missing or invalid */
  OrderRequestToApproveInvalidInputError = 'ORDER_REQUEST_TO_APPROVE_INVALID_INPUT_ERROR',
  /** Error code indicating that the webRef format is invalid */
  OrderRequestToApproveInvalidWebRefFormatError = 'ORDER_REQUEST_TO_APPROVE_INVALID_WEB_REF_FORMAT_ERROR',
  /** Error code indicating that the OrderRequest to approve was not found */
  OrderRequestToApproveNotFoundError = 'ORDER_REQUEST_TO_APPROVE_NOT_FOUND_ERROR',
  /** Error code indicating that the order is not an order request */
  OrderRequestToApproveNotOrderRequestError = 'ORDER_REQUEST_TO_APPROVE_NOT_ORDER_REQUEST_ERROR',
  /** Error code indicating that the order requestcart has no items or items are no longer available */
  OrderRequestToApproveNoItemsError = 'ORDER_REQUEST_TO_APPROVE_NO_ITEMS_ERROR',
  /**
   * Error codes indicating an error occurred while placing an order, each one based on a possible M2 error code
   * Source: M2_PlaceOrderErrorCodes enum from M2
   */
  PlaceOrderCartNotActiveError = 'PLACE_ORDER_CART_NOT_ACTIVE_ERROR',
  PlaceOrderCartNotFoundError = 'PLACE_ORDER_CART_NOT_FOUND_ERROR',
  PlaceOrderGuestEmailMissingError = 'PLACE_ORDER_GUEST_EMAIL_MISSING_ERROR',
  /** Error code indicating multiple errors occurred while placing an order */
  PlaceOrderMultipleErrorsError = 'PLACE_ORDER_MULTIPLE_ERRORS_ERROR',
  PlaceOrderStocksProductsUnavailableError = 'PLACE_ORDER_STOCKS_PRODUCTS_UNAVAILABLE_ERROR',
  PlaceOrderUnableToPlaceOrderError = 'PLACE_ORDER_UNABLE_TO_PLACE_ORDER_ERROR',
  /** Error indicating that the user is not authorized to place this order */
  PlaceOrderUnauthorizedUserError = 'PLACE_ORDER_UNAUTHORIZED_USER_ERROR',
  PlaceOrderUndefinedError = 'PLACE_ORDER_UNDEFINED_ERROR',
  /**
   * Error code when address specified for distance calulation is not valid
   * In front probably the filter by postalCode
   * Context:
   *     Query.availablePointsOfSaleInventory
   *     currentUser.availablePointsOfSale
   *     currentUser.availablePointsOfSalePickup
   *     Query.pointOfSaleWithDistanceInvoice
   *     Query.pointsOfSale
   */
  PointOfSaleSearchAddressNotExistError = 'POINT_OF_SALE_SEARCH_ADDRESS_NOT_EXIST_ERROR',
  /** Error code indicating that the category level is missing for the product list */
  ProductListCategoryLevelMissingError = 'PRODUCT_LIST_CATEGORY_LEVEL_MISSING_ERROR',
  /** Error code indicating that the FH request for the product list is invalid */
  ProductListFhRequestInvalidError = 'PRODUCT_LIST_FH_REQUEST_INVALID_ERROR',
  /** Error code indicating that the search parameter is invalid for product list */
  ProductListSearchInvalidError = 'PRODUCT_LIST_SEARCH_INVALID_ERROR',
  /** Error code indicating that the search parameter is missing for product list */
  ProductListSearchMissingError = 'PRODUCT_LIST_SEARCH_MISSING_ERROR',
  /**
   * The given cart item is not part of the punchout cart
   * Context : updatePunchoutCartItemQuantity, removePunchoutCartItem
   */
  PunchoutCartItemNotFoundError = 'PUNCHOUT_CART_ITEM_NOT_FOUND_ERROR',
  /**
   * The given punchout cart id does not belong to the current session
   * Context : addProductToPunchoutCart, addProductsToPunchoutCart, updatePunchoutCartItemQuantity,
   * removePunchoutCartItem, clearPunchoutCartItems
   */
  PunchoutCartMismatchError = 'PUNCHOUT_CART_MISMATCH_ERROR',
  /**
   * No punchout cart found for the current session, or given cart id, or given punchout wishlist id
   * Context : addProductToPunchoutCart, addProductsToPunchoutCart, updatePunchoutCartItemQuantity,
   * removePunchoutCartItem, clearPunchoutCartItems, punchoutCart
   */
  PunchoutCartNotFoundError = 'PUNCHOUT_CART_NOT_FOUND_ERROR',
  /**
   * Customer don't exist or wrong credentials
   * Context : punchoutLogin
   */
  PunchoutCustomerNotFoundError = 'PUNCHOUT_CUSTOMER_NOT_FOUND_ERROR',
  /**
   * No punchout client configuration for the current website and format
   * Context : exportCartIntoPunchoutFormat
   */
  PunchoutExportClientConfigurationMissingError = 'PUNCHOUT_EXPORT_CLIENT_CONFIGURATION_MISSING_ERROR',
  /**
   * Punchout light is not enabled for the current website
   * Context : exportCartIntoPunchoutFormat
   */
  PunchoutExportDisabledError = 'PUNCHOUT_EXPORT_DISABLED_ERROR',
  /**
   * The punchout brick did not return any file
   * Context : exportCartIntoPunchoutFormat
   */
  PunchoutExportDownloadError = 'PUNCHOUT_EXPORT_DOWNLOAD_ERROR',
  /**
   * User company not exist in ms
   * Context : punchoutLogin
   */
  PunchoutLoginCompanyUnknowedError = 'PUNCHOUT_LOGIN_COMPANY_UNKNOWED_ERROR',
  /**
   * Param format is invalid
   * Context : punchoutLogin
   */
  PunchoutLoginParamInvalidError = 'PUNCHOUT_LOGIN_PARAM_INVALID_ERROR',
  /**
   * Error while user creation in ms
   * Context : punchoutLogin
   */
  PunchoutLoginUserCreationError = 'PUNCHOUT_LOGIN_USER_CREATION_ERROR',
  /**
   * User exist in ms but is missing his id or company id
   * Context : punchoutLogin
   */
  PunchoutLoginUserIncompleteError = 'PUNCHOUT_LOGIN_USER_INCOMPLETE_ERROR',
  /**
   * User exist in ms but not active
   * Context : punchoutLogin
   */
  PunchoutLoginUserNotActiveError = 'PUNCHOUT_LOGIN_USER_NOT_ACTIVE_ERROR',
  /**
   * No punchout session on the current user
   * Context : createNewPunchoutCart, addProductToPunchoutCart, addProductsToPunchoutCart,
   * updatePunchoutCartItemQuantity, removePunchoutCartItem, clearPunchoutCartItems, punchoutCart
   */
  PunchoutSessionRequiredError = 'PUNCHOUT_SESSION_REQUIRED_ERROR',
  /**
   * The punchout brick did not return a redirect url when transforming the cart
   * Context : punchoutCart
   */
  PunchoutTransformError = 'PUNCHOUT_TRANSFORM_ERROR',
  /**
   * Error when user is in an approvalflow with lower minimumAmount than total amount of quote
   * Context: approveQuote
   */
  QuoteApproveApprovalFlowLimitationError = 'QUOTE_APPROVE_APPROVAL_FLOW_LIMITATION_ERROR',
  /**
   * Error when the user's company is forbidden (currentUser.company.forbidden)
   * Context: approveQuote
   */
  QuoteApproveCompanyForbiddenError = 'QUOTE_APPROVE_COMPANY_FORBIDDEN_ERROR',
  /**
   * Error when chorus data aren't provided but user.company.isPublicAdministration = true
   * Context: approveQuote
   */
  QuoteApproveMissingChorusDataError = 'QUOTE_APPROVE_MISSING_CHORUS_DATA_ERROR',
  /**
   * Error when quote is in unallowed status to be approved (quote.status != EN)
   * Context: approveQuote
   */
  QuoteApproveStatusNotAllowedError = 'QUOTE_APPROVE_STATUS_NOT_ALLOWED_ERROR',
  /**
   * Error when quote is in unallowed status to be declined (quote.status = CP)
   * Context: declineQuote
   */
  QuoteDeclineStatusNotAllowedError = 'QUOTE_DECLINE_STATUS_NOT_ALLOWED_ERROR',
  /**
   * Error when the user's company is forbidden (currentUser.company.forbidden)
   * Context: renewQuote
   */
  QuoteRenewCompanyForbiddenError = 'QUOTE_RENEW_COMPANY_FORBIDDEN_ERROR',
  /**
   * Error Mrod is not opened
   * Context: renewQuote
   */
  QuoteRenewErpNotOpenedError = 'QUOTE_RENEW_ERP_NOT_OPENED_ERROR',
  /**
   * Error when quote is in unallowed status to be renewed (quote.status != DP)
   * Context: renewQuote
   */
  QuoteRenewStatusNotAllowedError = 'QUOTE_RENEW_STATUS_NOT_ALLOWED_ERROR',
  /**
   * Error when no email found in input
   * Context: shareQuote
   */
  QuoteShareEmailRequiredError = 'QUOTE_SHARE_EMAIL_REQUIRED_ERROR',
  /**
   * Context : quote share
   * Error Mrod is not opened
   */
  QuoteShareErpNotOpenedError = 'QUOTE_SHARE_ERP_NOT_OPENED_ERROR',
  /**
   * Error while sending emails for quote submition
   * Context: submitCurrentQuote
   */
  QuoteSubmitEmailSendingError = 'QUOTE_SUBMIT_EMAIL_SENDING_ERROR',
  /**
   * Error when the company's APE code is not allowed for registration
   * (APE code provided by Mesh SaaS CapAddress service)
   */
  RegistrationActionApeCodeNotAllowedError = 'REGISTRATION_ACTION_APE_CODE_NOT_ALLOWED_ERROR',
  /**
   * Error when the company's postal code is not allowed for registration
   * (postal code provided by Mesh SaaS CapAddress service)
   */
  RegistrationActionPostcodeNotAllowedError = 'REGISTRATION_ACTION_POSTCODE_NOT_ALLOWED_ERROR',
  /**
   * Error during user registration.
   * The company status code is 14 - manager account already created for this company
   */
  RegistrationUserCompanyAlreadyExistError = 'REGISTRATION_USER_COMPANY_ALREADY_EXIST_ERROR',
  /**
   * Error during user registration.
   * The company status code is 13 - it's a key account registered on DCClic
   */
  RegistrationUserCompanyDcClicUserError = 'REGISTRATION_USER_COMPANY_DC_CLIC_USER_ERROR',
  /**
   * Error during user registration.
   * The company status code is not allowed for registration
   */
  RegistrationUserCompanyStatusCodeNotAllowedError = 'REGISTRATION_USER_COMPANY_STATUS_CODE_NOT_ALLOWED_ERROR',
  /**
   * Error during user registration.
   * Generic error code, used when the last step of the registration process fails (MS creation)
   */
  RegistrationUserCreationError = 'REGISTRATION_USER_CREATION_ERROR',
  /**
   * Error during user registration.
   * Missing user information fields in the input to register
   */
  RegistrationUserMissingFieldsError = 'REGISTRATION_USER_MISSING_FIELDS_ERROR',
  /**
   * Error during user registration.
   * The company not exists in MS for the companyNationalId in input
   */
  RegistrationUserNotExistsCompanyError = 'REGISTRATION_USER_NOT_EXISTS_COMPANY_ERROR',
  /**
   * Error during user registration.
   * The user information are not valid
   */
  RegistrationUserValidationFieldsError = 'REGISTRATION_USER_VALIDATION_FIELDS_ERROR',
  /**
   * Error during company registration.
   * The fields firstname, lastname, and email must either be provided in the input or retrieved from the currentUser (multi-account scenario)
   */
  RequestCompanyRegistrationMissingRequiredFieldError = 'REQUEST_COMPANY_REGISTRATION_MISSING_REQUIRED_FIELD_ERROR',
  /**
   * Error during company registration.
   * The pointOfSale is not found
   */
  RequestCompanyRegistrationPointOfSaleNotFoundError = 'REQUEST_COMPANY_REGISTRATION_POINT_OF_SALE_NOT_FOUND_ERROR',
  /**
   * Error when too much companies corresponding to search
   * Context:
   *     searchCompanies
   *     searchUsers
   */
  SearchCompanyOutOfRangeError = 'SEARCH_COMPANY_OUT_OF_RANGE_ERROR',
  /** Error code indicating that the segment ID is missing for search result */
  SearchResultMissingSegmentIdError = 'SEARCH_RESULT_MISSING_SEGMENT_ID_ERROR',
  /**
   * Error when no internal jwt provided
   * Context:
   *     searchCompanies
   *     searchUsers
   */
  SearchUsersNotAllowedError = 'SEARCH_USERS_NOT_ALLOWED_ERROR',
  /**
   * Error during setShippingAddressOnCart input validation.
   * The input should have only one field filled, either address or customerAddressId.
   */
  SetShippingAddressOnCartValidationError = 'SET_SHIPPING_ADDRESS_ON_CART_VALIDATION_ERROR',
  /** Error code indicating that the companyNationalId parameter for store companies is empty */
  StoreCompaniesCompanyNationalIdEmptyError = 'STORE_COMPANIES_COMPANY_NATIONAL_ID_EMPTY_ERROR',
  /** Error code indicating that the external client ID for the store company is empty */
  StoreCompanyExternalClientIdEmptyError = 'STORE_COMPANY_EXTERNAL_CLIENT_ID_EMPTY_ERROR',
  /** Error code indicating a generic test error (to test error handling) */
  TestError = 'TEST_ERROR',
  /** Error code if trying to access topPurchase when feature is disabled */
  TopPurchaseNotEnabledError = 'TOP_PURCHASE_NOT_ENABLED_ERROR',
  /** Error code indicating that the distribution network is unsupported */
  UnsupportedDistributionNetworkError = 'UNSUPPORTED_DISTRIBUTION_NETWORK_ERROR',
  /** Error code indicating that the quantity provided for updating a cart item is invalid */
  UpdateCartItemQuantityInvalidQuantityError = 'UPDATE_CART_ITEM_QUANTITY_INVALID_QUANTITY_ERROR',
  /**
   * Error code when files uploaded exceed authorized limit
   * context: UpdateCurrentQuote, ...
   */
  UploadSizeLimitExceededError = 'UPLOAD_SIZE_LIMIT_EXCEEDED_ERROR',
  /** Error code indicating that the category was not found for the URL key by descours ID */
  UrlKeyByDescoursIdCategoryNotFoundError = 'URL_KEY_BY_DESCOURS_ID_CATEGORY_NOT_FOUND_ERROR',
  /** Error code indicating that the product was not found for the specified URL key */
  UrlKeyByProductNotFoundError = 'URL_KEY_BY_PRODUCT_NOT_FOUND_ERROR',
  /** Error code indicating that the URL key is not supported for this entity */
  UrlKeyEntityNotSupportedError = 'URL_KEY_ENTITY_NOT_SUPPORTED_ERROR',
  /** Error while trying to create a collaborator with an email already used by another collaborator in this same company */
  UserCreationEmailUsedError = 'USER_CREATION_EMAIL_USED_ERROR',
  /** Error when user deletion failed in ms */
  UserDeletionFailedError = 'USER_DELETION_FAILED_ERROR',
  /** Error when user is the last approver of an approvalFlow */
  UserDeletionIsLastApproverError = 'USER_DELETION_IS_LAST_APPROVER_ERROR',
  /** Error when user cannot be deleted because is the manager of company or current user */
  UserDeletionNotAllowedError = 'USER_DELETION_NOT_ALLOWED_ERROR',
  /** Error when user cannot be deleted because is not exists or already in deleted status */
  UserDeletionNotFoundError = 'USER_DELETION_NOT_FOUND_ERROR',
  /** Error when user try to do an action but has no sufficient permissions */
  UserMissingPermissionError = 'USER_MISSING_PERMISSION_ERROR',
  /** Error when no logged user found on operation available for logged in user only */
  UserNotLoggedError = 'USER_NOT_LOGGED_ERROR',
  /**
   * Error code indicating the role of the manager cannot be changed
   * Context: updateUser
   */
  UserUpdateRoleUserManagerError = 'USER_UPDATE_ROLE_USER_MANAGER_ERROR',
  /**
   * Error code indicating that the user to update was not found
   * Context: updateUser
   */
  UserUpdateUserNotFoundError = 'USER_UPDATE_USER_NOT_FOUND_ERROR',
  /**
   * Error code when address is a CEDEX or P.O box
   * Context:
   *     setShippingAddressOnCart
   *     updateUserCompanyAddress
   */
  ValidateAddressCedexNotAllowedError = 'VALIDATE_ADDRESS_CEDEX_NOT_ALLOWED_ERROR',
  /**
   * Error code when address is invalid
   * Context:
   *     setShippingAddressOnCart
   *     updateUserCompanyAddress
   */
  ValidateAddressIncorrectValueError = 'VALIDATE_ADDRESS_INCORRECT_VALUE_ERROR',
  /**
   * Error code when phone number is invalidate by regex check or api call
   * Context :
   *     createUser
   *     requestCompanyRegistration
   *     requestUserRegistration
   *     submitContactRequest
   *     setShippingDeliveryContactInfoOnCart
   *     updateUser
   */
  ValidatePhoneBadFormatError = 'VALIDATE_PHONE_BAD_FORMAT_ERROR',
  /**
   * Error code when phone number type is not allowed (depending on magento 2 config)
   * Context :
   *     createUser
   *     requestCompanyRegistration
   *     requestUserRegistration
   *     submitContactRequest
   *     setShippingDeliveryContactInfoOnCart
   *     updateUser
   */
  ValidatePhoneTypeNotAllowedError = 'VALIDATE_PHONE_TYPE_NOT_ALLOWED_ERROR',
  /** Error code indicating an error occurred while calculating VAT inclusive price */
  VatInclusivePriceCalculationError = 'VAT_INCLUSIVE_PRICE_CALCULATION_ERROR',
  /**
   * Error code if no wishlist name is provided during creation
   * Context: createWishlist
   */
  WishlistCreationNameRequiredError = 'WISHLIST_CREATION_NAME_REQUIRED_ERROR',
  /**
   * Error code when user tries to create a quotation type wishlist but already own one
   * Context: createWishlist
   */
  WishlistCreationQuotationTypeAlreadyExistError = 'WISHLIST_CREATION_QUOTATION_TYPE_ALREADY_EXIST_ERROR',
  /**
   * Error code if too many product provide for wishlit creation
   * Context: createWishlist/updateWishlist
   */
  WishlistLimitProductExceedError = 'WISHLIST_LIMIT_PRODUCT_EXCEED_ERROR',
  /**
   * Error code if no wishlist name contains not allowed caracteres
   * Context: createWishlist/updateWishlist
   */
  WishlistNameFormatNotAllowedError = 'WISHLIST_NAME_FORMAT_NOT_ALLOWED_ERROR',
  /**
   * Error code if no wishlist name is too long
   * Context: createWishlist/updateWishlist
   */
  WishlistNameInvalidLengthError = 'WISHLIST_NAME_INVALID_LENGTH_ERROR',
  /**
   * Error code if product code p found in product list
   * Context: createWishlist/updateWishlist
   */
  WishlistProductCodePIgnoredError = 'WISHLIST_PRODUCT_CODE_P_IGNORED_ERROR',
  /**
   * Error code if no users ids provided and allUser = false
   * Context: shareWishlist
   */
  WishlistShareUserIdsRequiredError = 'WISHLIST_SHARE_USER_IDS_REQUIRED_ERROR',
  /**
   * Error code if no products found in input
   * Context: updateQuickOrder/updateCurrentQuote
   */
  WishlistUpdateProductsRequiredError = 'WISHLIST_UPDATE_PRODUCTS_REQUIRED_ERROR'
}

export type Event = {
  __typename?: 'Event';
  _query: Scalars['String']['output'];
  baseline?: Maybe<Scalars['String']['output']>;
  baselineColor?: Maybe<Scalars['Color']['output']>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  catalogLink?: Maybe<Scalars['URL']['output']>;
  catalogLinkOpenInNewTab: Scalars['Boolean']['output'];
  catalogTitle?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  productList?: Maybe<ProductList>;
  redirectUrl: Scalars['URL']['output'];
  request: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleColor?: Maybe<Scalars['Color']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};


export type EventProductListArgs = {
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event Card (in UI context a card is a design pattern) to promote a marketing event
 * Source : M2 catalog event
 */
export type EventCard = Card & CatalogEvent & {
  __typename?: 'EventCard';
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  /** Subtitle */
  baseline?: Maybe<Scalars['String']['output']>;
  /** Subtitle color */
  baselineColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  /** CTA target url */
  link?: Maybe<Scalars['URL']['output']>;
  linkColor?: Maybe<Scalars['String']['output']>;
  linkTitle?: Maybe<Scalars['String']['output']>;
  openInNewTab: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  titleColor?: Maybe<Scalars['String']['output']>;
};

/** Represents the type of cross-selling event */
export enum EventCrossType {
  Deals = 'DEALS',
  Homepage = 'HOMEPAGE',
  Universe = 'UNIVERSE'
}

/** Represents the type of page where the marketing event is displayed */
export enum EventPageType {
  Checkout = 'CHECKOUT',
  Deals = 'DEALS',
  Homepage = 'HOMEPAGE'
}

export type EventProducts = {
  __typename?: 'EventProducts';
  link?: Maybe<Scalars['URL']['output']>;
  linkTitle?: Maybe<Scalars['String']['output']>;
  openInNewTab: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Product>>;
  title: Scalars['String']['output'];
};

/**
 * Source : MS Agency
 * Context : Exceptional date for a point of sale. Is used to declare an opened or closed day in place of the regular point of sale calendar at the given date.
 */
export type ExceptionalDate = {
  __typename?: 'ExceptionalDate';
  date?: Maybe<Scalars['Date']['output']>;
  intervals?: Maybe<Array<Interval>>;
  isClosed: Scalars['Boolean']['output'];
};

export type ExportCartIntoPunchoutOutput = {
  __typename?: 'ExportCartIntoPunchoutOutput';
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type Favorite = {
  __typename?: 'Favorite';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Product>>;
};

/** Represents a filter criterion with a field and its corresponding value. */
export type Filter = {
  /** Value to filter for the specified field if type is BOOLEAN */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field to apply the filter on. */
  field: Scalars['String']['input'];
  /** Value to filter for the specified field if type is NUMBER */
  numberValue?: InputMaybe<Scalars['Int']['input']>;
  /** Operator of the filter */
  operator: FilterOperator;
  /** Value to filter for the specified field if type is STRING_ARRAY */
  stringArrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Value to filter for the specified field if type is STRING */
  stringValue?: InputMaybe<Scalars['String']['input']>;
  /** Indicate in which filed the value is to recover */
  type: FilterType;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The filter operator */
export enum FilterOperator {
  Equal = 'EQUAL',
  In = 'IN',
  LessOrEqual = 'LESS_OR_EQUAL',
  Like = 'LIKE'
}

/** The filter types */
export enum FilterType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING',
  StringArray = 'STRING_ARRAY'
}

/**
 * Source: M2
 * Represent the higher category from product category tree
 * Comes from the product attribute descours_${x-distribution-network}_cat_level1
 */
export type FirstLevelCategory = {
  __typename?: 'FirstLevelCategory';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum FirstLoginOriginAnalytics {
  DoaStore = 'DOA_STORE',
  DoaWeb = 'DOA_WEB'
}

export type GenericResponse = {
  __typename?: 'GenericResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type Intl_Price_ArticlePrice = {
  __typename?: 'INTL_PRICE_ArticlePrice';
  /** List of other charges to apply */
  charges?: Maybe<Array<Maybe<Intl_Price_Charge>>>;
  /** Reference of the article for the company */
  company_article_code: Scalars['String']['output'];
  /** Sales price of the article for one price_unit, for a specific customer, applying its commercial terms */
  customer_gross_price?: Maybe<Scalars['Float']['output']>;
  /** List of cumulative discounts to apply in the price calculation */
  discounts?: Maybe<Array<Maybe<Intl_Price_Discount>>>;
  /** Amount of the eco-tax for one price_unit (if relevant) */
  eco_tax?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Net sales price of the article for one price_unit, after applying customer commercial terms and discounts */
  net_price?: Maybe<Scalars['Float']['output']>;
  /** Conversion ratio denominator */
  price_conversion_denominator: Scalars['Float']['output'];
  /** Conversion ratio numerator */
  price_conversion_numerator: Scalars['Float']['output'];
  /** List of pricing tiers based on quantity thresholds. Used for volume discounts and bulk pricing. Tiers should be sorted by tier_minimum_quantity in ascending order. */
  price_tiers?: Maybe<Array<Maybe<Intl_Price_PriceTier>>>;
  price_type_code?: Maybe<Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Price_Type_Code>;
  /** The unit of measure to express the price */
  price_unit: Scalars['String']['output'];
  /** Sales price of the article for one price_unit, before applying any specific commercial terms, discount, or tax */
  public_gross_price: Scalars['Float']['output'];
  /** Quantity expressed in the quantity_unit */
  quantity: Scalars['Float']['output'];
  quantity_unit?: Maybe<Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Quantity_Unit>;
  /** VAT percentage to apply in the price calculation */
  vat_percentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type Intl_Price_ArticleRequest_Input = {
  /** Reference of the article for the company */
  company_article_code: Scalars['String']['input'];
  /** Conversion ratio denominator */
  price_conversion_denominator: Scalars['PositiveFloat']['input'];
  /** Conversion ratio numerator */
  price_conversion_numerator: Scalars['PositiveFloat']['input'];
  price_type_code?: InputMaybe<Intl_Price_QueryInput_PostSalesPrice_Input_Articles_Items_Price_Type_Code>;
  /** The unit of measure to express the price */
  price_unit: Scalars['String']['input'];
  /** Quantity expressed in the quantity_unit */
  quantity: Scalars['PositiveFloat']['input'];
  quantity_unit?: InputMaybe<Intl_Price_QueryInput_PostSalesPrice_Input_Articles_Items_Quantity_Unit>;
};

export type Intl_Price_Charge = {
  __typename?: 'INTL_PRICE_Charge';
  /** Fixed amount of the charge to apply in the price calculation, for one price_unit */
  charge_amount?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Name of the charge to apply in the price calculation */
  charge_name?: Maybe<Scalars['String']['output']>;
  /** Percentage of the charge to apply in the price calculation */
  charge_percentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type Intl_Price_Discount = {
  __typename?: 'INTL_PRICE_Discount';
  /** Fixed monetary discount amount per unit in local currency (mutually exclusive with discount_percentage) */
  discount_amount?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Internal code/reference for this discount in the pricing system */
  discount_code?: Maybe<Scalars['INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_discounts_items_discount_code']['output']>;
  /** Human-readable label/name for the discount */
  discount_label?: Maybe<Scalars['INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_discounts_items_discount_label']['output']>;
  discount_origin?: Maybe<Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Discounts_Items_Discount_Origin>;
  /** Percentage of the discount to apply in the price calculation (mutually exclusive with discount_amount) */
  discount_percentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
  discount_type?: Maybe<Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Discounts_Items_Discount_Type>;
};

export type Intl_Price_ErrorResponse = {
  __typename?: 'INTL_PRICE_ErrorResponse';
  /** Additional error details */
  details?: Maybe<Scalars['String']['output']>;
  /** Machine-readable error code */
  error_code: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

export type Intl_Price_PriceTier = {
  __typename?: 'INTL_PRICE_PriceTier';
  /** amount discount from base price at this tier level */
  tier_discount_amount: Scalars['Float']['output'];
  /** Human-readable description of this pricing tier */
  tier_label?: Maybe<Scalars['INTL_PRICE_query_postSalesPrice_oneOf_0_articles_items_price_tiers_items_tier_label']['output']>;
  /** Minimum quantity to qualify for this tier (inclusive) */
  tier_minimum_quantity: Scalars['NonNegativeFloat']['output'];
};

export type Intl_Price_SalesPriceRequest_Input = {
  /** List of articles for which pricing is requested */
  articles: Array<InputMaybe<Intl_Price_ArticleRequest_Input>>;
  /** Unique identifier of the D&C subsidiary (ORBIS code) */
  company_code: Scalars['String']['input'];
  currency_code: Intl_Price_QueryInput_PostSalesPrice_Input_Currency_Code;
  /** Unique identifier of the customer account for the D&C subsidiary (optional for customer-specific pricing) */
  customer_account_code?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the D&C organisational unit (ORBIS code) */
  organisational_unit_code: Scalars['String']['input'];
  /** Date for pricing request (ISO 8601 format) */
  pricing_date: Scalars['DateTime']['input'];
  sales_channel_code?: InputMaybe<Intl_Price_QueryInput_PostSalesPrice_Input_Sales_Channel_Code>;
  system_code: Scalars['JSON']['input'];
};

export type Intl_Price_SalesPriceResponse = {
  __typename?: 'INTL_PRICE_SalesPriceResponse';
  /** List of articles with pricing information */
  articles: Array<Maybe<Intl_Price_ArticlePrice>>;
  /** Unique identifier of the D&C subsidiary (ORBIS code) */
  company_code: Scalars['String']['output'];
  /** ISO 4217 currency code */
  currency_code: Scalars['String']['output'];
  /** Unique identifier of the customer account */
  customer_account_code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the D&C organisational unit (ORBIS code) */
  organisational_unit_code: Scalars['String']['output'];
  /** Date for pricing request */
  pricing_date: Scalars['DateTime']['output'];
  /** Code of the system in the EA repository */
  system_code: Scalars['String']['output'];
};

export type Intl_Price_PostSalesPrice_Response = Intl_Price_ErrorResponse | Intl_Price_SalesPriceResponse;

/** Type of pricing being applied to this article */
export enum Intl_Price_QueryInput_PostSalesPrice_Input_Articles_Items_Price_Type_Code {
  BundlePrice = 'bundle_price',
  ContractPrice = 'contract_price',
  CustomerGroup = 'customer_group',
  CustomerSpecific = 'customer_specific',
  DynamicPrice = 'dynamic_price',
  ListPrice = 'list_price',
  MarketPrice = 'market_price',
  Promotional = 'promotional',
  SeasonalPrice = 'seasonal_price',
  SpotPrice = 'spot_price',
  TenderPrice = 'tender_price',
  TieredPrice = 'tiered_price',
  VolumePrice = 'volume_price'
}

/** The unit of measure to express the quantity */
export enum Intl_Price_QueryInput_PostSalesPrice_Input_Articles_Items_Quantity_Unit {
  Bb = 'BB',
  Bk = 'BK',
  Bl = 'BL',
  Bo = 'BO',
  Cm = 'CM',
  Ds = 'DS',
  Dz = 'DZ',
  Em = 'EM',
  Et = 'ET',
  Fl = 'FL',
  G = 'G',
  Ga = 'GA',
  Ka = 'KA',
  Kg = 'KG',
  Kgs = 'KGS',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Kt = 'KT',
  Ku = 'KU',
  Lg = 'LG',
  Lt = 'LT',
  M = 'M',
  M2 = 'M2',
  Mp = 'MP',
  Od = 'OD',
  Pa = 'PA',
  Pd = 'PD',
  Pk = 'PK',
  Pt = 'PT',
  Py = 'PY',
  Rep = 'REP',
  Rl = 'RL',
  Se = 'SE',
  Sl = 'SL',
  St = 'ST',
  Tr = 'TR',
  Un = 'UN',
  Va = 'VA',
  Vl = 'VL',
  Vp = 'VP',
  Za = 'ZA'
}

/** ISO 4217 currency code */
export enum Intl_Price_QueryInput_PostSalesPrice_Input_Currency_Code {
  Chf = 'CHF',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK',
  Usd = 'USD'
}

/** Code of the system in the EA repository */
export enum Intl_Price_QueryInput_PostSalesPrice_Input_Sales_Channel_Code {
  LessThanMobileAppNameListGreaterThan = '_LESS_THAN_mobile_app_name_list_GREATER_THAN_',
  LessThanOtherEcommerceSitesGreaterThan = '_LESS_THAN_other_ecommerce_sites_GREATER_THAN_',
  DcClic = 'dc_clic',
  DestilNl = 'destil_nl',
  DexisFr = 'dexis_fr',
  DexisNl = 'dexis_nl',
  EMailAutomated = 'e_mail_automated',
  EdiClient = 'edi_client',
  EdiIntragroupe = 'edi_intragroupe',
  Myscan2go = 'myscan2go',
  ProliansFr = 'prolians_fr',
  SalesRepByMail = 'sales_rep_by_mail',
  SalesRepByPhone = 'sales_rep_by_phone',
  SalesRepByVisit = 'sales_rep_by_visit',
  VendingMachine = 'vending_machine'
}

/** The system that emits the discount */
export enum Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Discounts_Items_Discount_Origin {
  Digital = 'digital',
  Erp = 'erp'
}

/** Category of discount being applied */
export enum Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Discounts_Items_Discount_Type {
  Bundle = 'bundle',
  Clearance = 'clearance',
  CustomerAgreement = 'customer_agreement',
  Damaged = 'damaged',
  Loyalty = 'loyalty',
  Manual = 'manual',
  Other = 'other',
  PriceMatch = 'price_match',
  Promotional = 'promotional',
  Rebate = 'rebate',
  Sample = 'sample',
  Seasonal = 'seasonal',
  TierPricing = 'tier_pricing',
  Volume = 'volume'
}

/** Type of pricing being applied to this article */
export enum Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Price_Type_Code {
  BundlePrice = 'bundle_price',
  ContractPrice = 'contract_price',
  CustomerGroup = 'customer_group',
  CustomerSpecific = 'customer_specific',
  DynamicPrice = 'dynamic_price',
  ListPrice = 'list_price',
  MarketPrice = 'market_price',
  Promotional = 'promotional',
  SeasonalPrice = 'seasonal_price',
  SpotPrice = 'spot_price',
  TenderPrice = 'tender_price',
  TieredPrice = 'tiered_price',
  VolumePrice = 'volume_price'
}

/** The unit of measure to express the quantity */
export enum Intl_Price_Query_PostSalesPrice_OneOf_0_Articles_Items_Quantity_Unit {
  Bb = 'BB',
  Bk = 'BK',
  Bl = 'BL',
  Bo = 'BO',
  Cm = 'CM',
  Ds = 'DS',
  Dz = 'DZ',
  Em = 'EM',
  Et = 'ET',
  Fl = 'FL',
  G = 'G',
  Ga = 'GA',
  Ka = 'KA',
  Kg = 'KG',
  Kgs = 'KGS',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Kt = 'KT',
  Ku = 'KU',
  Lg = 'LG',
  Lt = 'LT',
  M = 'M',
  M2 = 'M2',
  Mp = 'MP',
  Od = 'OD',
  Pa = 'PA',
  Pd = 'PD',
  Pk = 'PK',
  Pt = 'PT',
  Py = 'PY',
  Rep = 'REP',
  Rl = 'RL',
  Se = 'SE',
  Sl = 'SL',
  St = 'ST',
  Tr = 'TR',
  Un = 'UN',
  Va = 'VA',
  Vl = 'VL',
  Vp = 'VP',
  Za = 'ZA'
}

export type Intl_Stock_Article = {
  __typename?: 'INTL_STOCK_Article';
  /** Reference of the article for the company */
  company_article_code?: Maybe<Scalars['INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_company_article_code']['output']>;
  /** D&C Group unique article code */
  group_article_code?: Maybe<Scalars['String']['output']>;
  gtin_13_code?: Maybe<Scalars['INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_gtin_13_code']['output']>;
  /** Details of stock quantities available in different locations */
  inventory_details?: Maybe<Array<Maybe<Intl_Stock_InventoryDetail>>>;
  /** Unique article code in the supplier catalog */
  supplier_article_code?: Maybe<Scalars['String']['output']>;
  upc_12_code?: Maybe<Scalars['INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_upc_12_code']['output']>;
};

/** Article identifier - at least one identifier must be provided */
export type Intl_Stock_ArticleIdentifier_Input = {
  /** Reference of the article for the company */
  company_article_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_articles_items_company_article_code']['input']>;
  /** D&C Group unique article code */
  group_article_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_articles_items_group_article_code']['input']>;
  gtin_13_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_articles_items_gtin_13_code']['input']>;
  /** Unique article code in the supplier catalog */
  supplier_article_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_articles_items_supplier_article_code']['input']>;
  upc_12_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_articles_items_upc_12_code']['input']>;
};

export type Intl_Stock_BatchDetail = {
  __typename?: 'INTL_STOCK_BatchDetail';
  /** Expiration date of the article (ISO 8601 format) */
  batch_expiration_date?: Maybe<Scalars['DateTime']['output']>;
  /** Batch number */
  batch_number?: Maybe<Scalars['INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_inventory_details_items_stock_location_details_items_batch_details_items_batch_number']['output']>;
  /** Available quantity in the batch */
  batch_quantity?: Maybe<Scalars['Float']['output']>;
};

export type Intl_Stock_ErrorResponse = {
  __typename?: 'INTL_STOCK_ErrorResponse';
  /** Additional error details */
  details?: Maybe<Scalars['String']['output']>;
  /** Machine-readable error code */
  error_code: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

export type Intl_Stock_InventoryDetail = {
  __typename?: 'INTL_STOCK_InventoryDetail';
  /** Reference of the article for the company */
  company_article_code: Scalars['String']['output'];
  /** Total quantity available at company level */
  company_available_quantity?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier of the D&C subsidiary (ORBIS code) */
  company_code: Scalars['String']['output'];
  /** Details of available stock quantities at different locations */
  stock_location_details: Array<Maybe<Intl_Stock_StockLocationDetail>>;
  stock_measurement_unit: Intl_Stock_Query_PostStockLevel_OneOf_0_Articles_Items_Inventory_Details_Items_Stock_Measurement_Unit;
  /** Code of the system in the EA repository */
  system_code: Scalars['String']['output'];
};

export type Intl_Stock_SerialNumber = {
  __typename?: 'INTL_STOCK_SerialNumber';
  /** Serial number */
  serial_number?: Maybe<Scalars['INTL_STOCK_query_postStockLevel_oneOf_0_articles_items_inventory_details_items_stock_location_details_items_serial_number_list_items_serial_number']['output']>;
};

export type Intl_Stock_StockLevelRequest_Input = {
  /** List of articles to query for stock levels. Each article must have at least one identifier. */
  articles: Array<InputMaybe<Intl_Stock_ArticleIdentifier_Input>>;
  /** Unique identifier of the D&C subsidiary (ORBIS code) */
  company_code: Scalars['INTL_STOCK_queryInput_postStockLevel_input_company_code']['input'];
  /** Unique identifier of the customer account for the D&C subsidiary (optional) */
  customer_account_code?: InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_customer_account_code']['input']>;
  /** List of organizational unit codes to filter stock locations. If not provided, all locations for the company will be returned. */
  organisational_unit_codes?: InputMaybe<Array<InputMaybe<Scalars['INTL_STOCK_queryInput_postStockLevel_input_organisational_unit_codes_items']['input']>>>;
  /** Date for stock level request (ISO 8601 format) if not provided, current date by default */
  stock_level_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Intl_Stock_StockLevelResponse = {
  __typename?: 'INTL_STOCK_StockLevelResponse';
  /** List of articles with their stock information */
  articles: Array<Maybe<Intl_Stock_Article>>;
  /** Unique identifier of the D&C subsidiary (ORBIS code) */
  company_code: Scalars['String']['output'];
  /** Unique identifier of the customer account (if provided in request) */
  customer_account_code?: Maybe<Scalars['String']['output']>;
  /** Date for stock level request (ISO 8601 format) */
  stock_level_date: Scalars['DateTime']['output'];
};

export type Intl_Stock_StockLocationDetail = {
  __typename?: 'INTL_STOCK_StockLocationDetail';
  /** Details of each batch (included only if include_batch_details=true in request) */
  batch_details?: Maybe<Array<Maybe<Intl_Stock_BatchDetail>>>;
  /** Unique identifier of the organisational unit (ORBIS code) */
  organisational_unit_code: Scalars['String']['output'];
  /**
   * The packaging/conditioning type for this stock location.
   * This represents how the article is packaged/conditioned at this location.
   * If not specified in the request, the default packaging type from the warehouse is returned.
   */
  packaging_type?: Maybe<Scalars['String']['output']>;
  /** List of serial numbers for each article (included only if include_serial_numbers=true in request) */
  serial_number_list?: Maybe<Array<Maybe<Intl_Stock_SerialNumber>>>;
  /** Total quantity available at the stock location level */
  stock_location_available_quantity: Scalars['Float']['output'];
  /** Unique identifier of the stock location in the system */
  stock_location_code: Scalars['String']['output'];
};

export type Intl_Stock_PostStockLevel_Response = Intl_Stock_ErrorResponse | Intl_Stock_StockLevelResponse;

/** Unit of measurement for the quantity in stock */
export enum Intl_Stock_Query_PostStockLevel_OneOf_0_Articles_Items_Inventory_Details_Items_Stock_Measurement_Unit {
  Bb = 'BB',
  Bk = 'BK',
  Bl = 'BL',
  Bo = 'BO',
  Cm = 'CM',
  Ds = 'DS',
  Dz = 'DZ',
  Em = 'EM',
  Et = 'ET',
  Fl = 'FL',
  G = 'G',
  Ga = 'GA',
  Ka = 'KA',
  Kg = 'KG',
  Kgs = 'KGS',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Kt = 'KT',
  Ku = 'KU',
  Lg = 'LG',
  Lt = 'LT',
  M = 'M',
  M2 = 'M2',
  Mp = 'MP',
  Od = 'OD',
  Pa = 'PA',
  Pd = 'PD',
  Pk = 'PK',
  Pt = 'PT',
  Py = 'PY',
  Rep = 'REP',
  Rl = 'RL',
  Se = 'SE',
  Sl = 'SL',
  St = 'ST',
  Tr = 'TR',
  Un = 'UN',
  Va = 'VA',
  Vl = 'VL',
  Vp = 'VP',
  Za = 'ZA'
}

export type IamUser = {
  __typename?: 'IamUser';
  displayName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type IamUserUpdateInput = {
  givenName: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type IdealConfig = {
  __typename?: 'IdealConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type IdealIpnPayload = {
  payload: Scalars['String']['input'];
};

export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']['output']>;
  set?: Maybe<Array<ImageUrl>>;
};

/** Not intended to be used alone. Please use Image type. */
export type ImageUrl = {
  __typename?: 'ImageUrl';
  media: Media;
  url: Scalars['URL']['output'];
};

/**
 * Current authenticated internal collaborator
 * Returns null when no valid internal authorization token is provided.
 */
export type InternalUser = {
  __typename?: 'InternalUser';
  email: Scalars['Email']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  pointOfSaleId: Scalars['String']['output'];
  professionCode?: Maybe<Scalars['String']['output']>;
  subsidiaryId?: Maybe<Scalars['String']['output']>;
};

export type Interval = {
  __typename?: 'Interval';
  begin: Scalars['String']['output'];
  end: Scalars['String']['output'];
};

/**
 * Contains a key-value pair.
 * Source: M2
 */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  key?: Maybe<Scalars['String']['output']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The legal status for loyalty subscription service */
export enum LegalStatus {
  /** Value expected by the API : Travailleur indépendant */
  Ls1 = 'LS1',
  /** Value expected by the API : Représentant moral ou physique de l’entreprise */
  Ls2 = 'LS2'
}

/**
 * A link to a resource, either a URL or a Fred Hopper FH request to be sent to the server
 * Sources: M2
 */
export type Link = {
  __typename?: 'Link';
  type: LinkType;
  value: Scalars['String']['output'];
};

/** The type of link to use for the link field in the ValueLink type. */
export enum LinkType {
  RequestFh = 'REQUEST_FH',
  Url = 'URL'
}

export type LoginAction = {
  __typename?: 'LoginAction';
  action: LoginActionEnum;
  email?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum LoginActionEnum {
  CreateAccount = 'CREATE_ACCOUNT',
  CreatePassword = 'CREATE_PASSWORD',
  Error = 'ERROR',
  InternalLogIn = 'INTERNAL_LOG_IN',
  LogIn = 'LOG_IN',
  RenewPassword = 'RENEW_PASSWORD'
}

export enum LoginType {
  Ecom = 'ECOM',
  EcomImpersonated = 'ECOM_IMPERSONATED',
  Punchout = 'PUNCHOUT'
}

/** MS Saas : Loyalty account information from Rhinos service */
export type Loyalty = {
  __typename?: 'Loyalty';
  data?: Maybe<LoyaltyData>;
  status: LoyaltyStatus;
};

/** Mesh Saas : Loyalty data response, coming from Rhinos */
export type LoyaltyData = {
  __typename?: 'LoyaltyData';
  achievedGoalOnSalesOperation?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  authLink?: Maybe<Scalars['String']['output']>;
  /**
   * Can be null, if the user is not eligible to boosterMonth
   * "" if no month was selected for now
   * or contains the name of the month ex : "Juin"
   */
  boosterMonth?: Maybe<Scalars['String']['output']>;
  currentSalesOperations?: Maybe<Array<Scalars['String']['output']>>;
  customerStatus?: Maybe<Scalars['String']['output']>;
  eligibleOperations?: Maybe<Array<Scalars['String']['output']>>;
  isResponsable: Scalars['Boolean']['output'];
  pointNumberExpiringThisYear: Scalars['Int']['output'];
  pointsBalance: Scalars['Int']['output'];
  responsableEmail?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

/** The loyalty account status */
export enum LoyaltyStatus {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  Owner = 'OWNER',
  Pending = 'PENDING'
}

/**
 * Source : front
 * Information to subscribe to the loyalty program
 */
export type LoyaltySubscriptionInput = {
  isChecked: Scalars['Boolean']['input'];
  /** LegalStatus available codes : LS1, LS2 */
  legalStatus?: InputMaybe<LegalStatus>;
};

/** Endpoint and Payload for Lyra payment form */
export type LyraForm = {
  __typename?: 'LyraForm';
  endpoint?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type M2Breadcrumb = {
  __typename?: 'M2Breadcrumb';
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']['output']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID']['output'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

/** Input types for M2 CustomerOrder (from placeOrder response) */
export type M2CustomerOrderInput = {
  _clientId?: InputMaybe<Scalars['String']['input']>;
  _deliveryTimesForOrder?: InputMaybe<Scalars['String']['input']>;
  _nationalClientIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  _orderOrigin?: InputMaybe<OrderOrigin>;
  _routingAgencyCode?: InputMaybe<Scalars['String']['input']>;
  _userFirstname?: InputMaybe<Scalars['String']['input']>;
  /** User data passed from mesh-unified (prefixed with _ to avoid conflicts) */
  _userId?: InputMaybe<Scalars['String']['input']>;
  _userLastname?: InputMaybe<Scalars['String']['input']>;
  _webShopReference?: InputMaybe<Scalars['String']['input']>;
  billing_address?: InputMaybe<M2OrderAddressInput>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  chorusLegalCommitment?: InputMaybe<Scalars['String']['input']>;
  chorusServiceCode?: InputMaybe<Scalars['String']['input']>;
  customerOrderItems?: InputMaybe<Array<M2OrderItemInput>>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  /** Shipping options */
  deliveryKeepTogetherShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delivery recipient info for MS order */
  deliveryRecipientName?: InputMaybe<Scalars['String']['input']>;
  deliveryRecipientPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<M2OrderItemInput>>;
  mrodDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  number: Scalars['String']['input'];
  /** Nullable: no reference is generated when the customer order reference feature is disabled */
  orderReference?: InputMaybe<Scalars['String']['input']>;
  order_date?: InputMaybe<Scalars['String']['input']>;
  payId?: InputMaybe<Scalars['String']['input']>;
  payment_methods?: InputMaybe<Array<InputMaybe<M2OrderPaymentMethodInput>>>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  shipping_address?: InputMaybe<M2OrderAddressInput>;
  shipping_method?: InputMaybe<Scalars['String']['input']>;
  /** Store pickup */
  shopCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<M2OrderTotalInput>;
  totalWeeeAmount?: InputMaybe<Scalars['Float']['input']>;
  wentThroughApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type M2DiscountInput = {
  amount?: InputMaybe<M2MoneyInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type M2MoneyInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type M2OrderAddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  street: Array<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type M2OrderItemInput = {
  /** GTM tracking */
  addedFrom?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandInput>;
  discountAmountMrod?: InputMaybe<Scalars['Float']['input']>;
  discountAmountWeb?: InputMaybe<Scalars['Float']['input']>;
  /** Discount fields */
  discountLabelWeb?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<M2DiscountInput>>;
  /** Express collect (Click & Collect) */
  expressCollect?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  preparationUnit?: InputMaybe<Scalars['Int']['input']>;
  priceTagLabel?: InputMaybe<Scalars['String']['input']>;
  priceTagType?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  product_reference: Scalars['String']['input'];
  product_sale_price?: InputMaybe<M2MoneyInput>;
  promoTagLabel?: InputMaybe<Scalars['String']['input']>;
  quantity_ordered?: InputMaybe<Scalars['Float']['input']>;
  /** Row totals for price calculation */
  row_total?: InputMaybe<Scalars['Float']['input']>;
  /** Supplier info */
  supplierArticleNumber?: InputMaybe<Scalars['String']['input']>;
  supplierNumber?: InputMaybe<Scalars['String']['input']>;
  tax_amount?: InputMaybe<Scalars['Float']['input']>;
  /** WEEE taxes (eco-contribution) */
  taxes?: InputMaybe<Array<InputMaybe<M2OrderItemTaxInput>>>;
  /** Unit and packaging */
  unitOfMeasurement?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for WEEE taxes (eco-contribution) */
export type M2OrderItemTaxInput = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  taxeType?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type M2OrderPaymentMethodInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type M2OrderTaxInput = {
  amount: M2MoneyInput;
  title: Scalars['String']['input'];
};

export type M2OrderTotalInput = {
  discounts?: InputMaybe<Array<InputMaybe<M2DiscountInput>>>;
  grand_total?: InputMaybe<M2MoneyInput>;
  subtotal?: InputMaybe<M2MoneyInput>;
  taxes?: InputMaybe<Array<InputMaybe<M2OrderTaxInput>>>;
  total_shipping?: InputMaybe<M2MoneyInput>;
  total_tax?: InputMaybe<M2MoneyInput>;
};

/**
 * Return of validateEmail
 * Source : SAAS
 */
export type MailgunValidateEmail = {
  __typename?: 'MailgunValidateEmail';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  isDisposableAddress?: Maybe<Scalars['Boolean']['output']>;
  isRoleAddress?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  result?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<Scalars['String']['output']>;
};

/**
 * Marketing banner configuration used in product listing
 * Source : M2 Catalog event
 */
export type MarketingBanner = {
  __typename?: 'MarketingBanner';
  _bannerBackgroundColor?: Maybe<Scalars['String']['output']>;
  _bannerTextColor?: Maybe<Scalars['String']['output']>;
  _linkTextColor?: Maybe<Scalars['String']['output']>;
  _linkUrl?: Maybe<Scalars['String']['output']>;
  _tagBackgroundColor?: Maybe<Scalars['String']['output']>;
  _tagTextColor?: Maybe<Scalars['String']['output']>;
  bannerBackgroundColor?: Maybe<Scalars['Color']['output']>;
  bannerText?: Maybe<Scalars['String']['output']>;
  bannerTextColor?: Maybe<Scalars['Color']['output']>;
  linkIsOpenNewTab?: Maybe<Scalars['Boolean']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkTextColor?: Maybe<Scalars['Color']['output']>;
  linkUrl?: Maybe<Scalars['URL']['output']>;
  tagBackgroundColor?: Maybe<Scalars['Color']['output']>;
  tagText?: Maybe<Scalars['String']['output']>;
  tagTextColor?: Maybe<Scalars['Color']['output']>;
};

export enum Media {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

/** Source: M2 (catalog_category) */
export type MenuEntry = MenuEntryCategory | MenuEntryLink;

/**
 * Context : Menu link associated to a product category
 * M2 (catalog_category : attribute descours_category_id != null) + FH for enabled status
 */
export type MenuEntryCategory = {
  __typename?: 'MenuEntryCategory';
  baseline?: Maybe<Scalars['String']['output']>;
  /** primary key (M2 descours_category_id + FH) */
  code: Scalars['String']['output'];
  entries?: Maybe<Array<MenuEntry>>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  seoContent?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

/**
 * Context : Menu link NOT associated to a product category (direct link to content page)
 * M2 (catalog_category : attribute descours_category_id == null && front_url != null)
 */
export type MenuEntryLink = {
  __typename?: 'MenuEntryLink';
  baseline?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<MenuEntry>>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  seoContent?: Maybe<Scalars['String']['output']>;
  /** M2 (attr: front_url) */
  url: Scalars['String']['output'];
};

export type Money = {
  __typename?: 'Money';
  currency?: Maybe<CurrencyEnum>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Ms_ApprovalFlowUsers = {
  __typename?: 'Ms_ApprovalFlowUsers';
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  CMS_createFormSubmission?: Maybe<Cms_FormSubmission>;
  /**
   * Add a product to the cart with a specific quantity
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow to update a cart not owned by user in Authorization header
   */
  addProductToCart: Checkout;
  addProductToPunchoutCart: PunchoutCart;
  /**
   * Add products to the cart with a specific quantity
   * Response: true if the mutation was successful
   * Source: M2
   * Security: Magento 2 does not allow to update a cart not owned by user in Authorization header
   */
  addProductsToCart: AddProductsToCartResponse;
  addProductsToPunchoutCart: PunchoutCart;
  /**
   * Apply a coupon code to the specified cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  applyCouponToCart: Checkout;
  /** Used to approve an order request by web shop reference. */
  approveOrderRequest: Scalars['Boolean']['output'];
  approveQuote: Quote;
  /**
   * Clear All items from the cart
   * Response: true if the mutation was successful
   * Source: M2
   * Security: Magento 2 does not allow to update a cart not owned by user in Authorization header
   */
  clearCartItems: Scalars['Boolean']['output'];
  /**
   * Source M2
   * Remove all products in the current quote
   */
  clearCurrentQuote: Scalars['Boolean']['output'];
  clearPunchoutCartItems: PunchoutCart;
  /**
   * Source M2
   * Clean all products in the quick order wishlist
   */
  clearQuickOrder: Scalars['Boolean']['output'];
  createApprovalFlow: Scalars['Boolean']['output'];
  createNewPunchoutCart: PunchoutCart;
  /**
   * Source M2
   * Create a quote
   * Only one quote can be created at a time
   */
  createQuote: Wishlist;
  /** Create the user collaborator, only if the user is allowed to manage company users */
  createUser: Scalars['Boolean']['output'];
  createUserCompanyAddress: AddressActionResponse;
  /** Create a new wishlist for the current User */
  createWishlist_V2: Wishlist;
  declineQuote: Scalars['Boolean']['output'];
  deleteApprovalFlow: Scalars['Boolean']['output'];
  /** Delete the user collaborator, only if the user is allowed to manage company users */
  deleteUser: Scalars['Boolean']['output'];
  deleteUserCompanyAddress: AddressActionResponse;
  /** Delete a user's wishlist */
  deleteWishlist: Scalars['Boolean']['output'];
  directReOrder: ReOrderedProducts;
  exportCartIntoPunchoutFormat: ExportCartIntoPunchoutOutput;
  /** Get IAM JWT token with refresh token */
  generateAuthToken: Token;
  /** Generate an impersonate JWT token from an internal auth token */
  generateImpersonateAuthToken: Token;
  /** Generate a JWT token for internal Descours&Cabaud collaborators using the SAML response returned by Active Directory */
  generateInternalAuthToken: Token;
  /** Get IAM refresh token */
  generateRefreshToken: Token;
  /**
   * Finalize the order process and place the order for the current cart
   * Response: WebShop reference of the order
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  placeOrder: Scalars['String']['output'];
  punchoutCart: PunchoutCartOutput;
  /**
   * Source : Unified
   * Context : Returns the token to perform for punchout authentication
   */
  punchoutLogin: PunchoutLogin;
  /**
   * Source M2
   * Allow to convert an order to a reorder wishlist
   * Order should belong to the current user's company
   * @deprecated This mutation was called alongside the addProductToCart mutation, meaning it required multiple steps to do one thing. Use the directReOrder mutation instead of this double mutation.
   */
  reOrder: Wishlist;
  /** Used to refuse an order request by web shop reference. */
  refuseOrderRequest: Scalars['Boolean']['output'];
  /**
   * Remove the coupon code from the specified cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  removeCouponFromCart: Checkout;
  /**
   * Remove on item from the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow to update a cart not owned by user in Authorization header
   */
  removeItemFromCart: Checkout;
  removePunchoutCartItem: PunchoutCart;
  renewQuote: Scalars['Boolean']['output'];
  reportProductAnomaly: Scalars['Boolean']['output'];
  /**
   * Source : front
   * Context : DOC Form : to request a company registration
   */
  requestCompanyRegistration: CompanyRegistrationRequestAction;
  /**
   * Selects a delivery date for the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  requestDeliveryDate: Checkout;
  requestLoyaltyRegistration: Scalars['Boolean']['output'];
  /**
   * Source : front
   * Context : DOA Form : to request a user registration
   */
  requestUserRegistration: UserRegistrationRequestAction;
  /**
   * For mobile app use
   * Renew the refreshToken before it expires, to expanse session lifetime
   */
  resetRefreshToken: Token;
  /** Used to save updates on order request by web shop reference. */
  saveOrderRequestModifications: Scalars['Boolean']['output'];
  /**
   * Source : front
   * Context : The front will call this mutation each time a user decides to switch account
   * allowing Mesh to perform operations such as update the last login date
   */
  selectUser: Scalars['Boolean']['output'];
  /**
   * Set some custom additional data on cart.
   * Response: Returns a boolean indicating whether custom data is correctly set.
   * Headers: Authorization
   * Source: Magento2
   */
  setAdditionalOrderInfoOnCart: Scalars['Boolean']['output'];
  /**
   * Enable or disable the click and collect mode for the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setIsClickAndCollectOnCart: Checkout;
  /**
   * Set order reference on cart.
   * Response: Returns a boolean indicating whether the command reference is correctly set.
   * Headers: Authorization
   * Source: Magento2
   */
  setOrderReferenceOnCart: Scalars['Boolean']['output'];
  /**
   * Set the payment method for the ongoing order process
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setPaymentMethodOnCart: Checkout;
  /**
   * Set the shipping address for the ongoing order process
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setShippingAddressOnCart: Checkout;
  /**
   * Set Delivery contact Information on the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setShippingDeliveryContactInfoOnCart: Checkout;
  /**
   * Set Delivery instructions Information on the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setShippingDeliveryInstructionsOnCart: Checkout;
  /**
   * Set the shipping method used for the ongoing order process
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  setShippingMethodOnCart: Checkout;
  shareQuote: Scalars['Boolean']['output'];
  /** Share a wishlist copy with specific collaborators of the company */
  shareWishlist: Wishlist;
  /** Sign In mutation */
  signIn: Scalars['Boolean']['output'];
  /** Sign Out mutation */
  signOut: Scalars['Boolean']['output'];
  submitContactRequest: Scalars['Boolean']['output'];
  /**
   * Source M2
   * Push the quote to the commercial
   */
  submitCurrentQuote: Scalars['Boolean']['output'];
  /** Switch the favorite point of sale of the user (favoriteAgencyId in MS User) */
  switchFavoritePointOfSale?: Maybe<PointOfSale>;
  updateApprovalFlow: Scalars['Boolean']['output'];
  /**
   * Update the quantity of an item in the cart
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   * Source: M2
   * Security: Magento 2 does not allow updating a cart not owned by the user in the Authorization header
   */
  updateCartItemQuantity: Checkout;
  /**
   * Update clickAndCollect items quantity based on business rules
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   */
  updateClickAndCollectCartItemsQuantities: Checkout;
  /**
   * Source M2
   * Update a quote (rename ; add/update/delete products)
   */
  updateCurrentQuote_V2: Wishlist;
  updateFavoriteShippingAddress: Scalars['Boolean']['output'];
  /**
   * update ms-user.lastLoginDate
   * Used when app is opened and session still active
   */
  updateMobileLoginDate: Scalars['Boolean']['output'];
  updatePunchoutCartItemQuantity: PunchoutCart;
  /**
   * Source M2
   * Update the quick order wishlist
   */
  updateQuickOrder_V2: Wishlist;
  /**
   * Source M2
   * Update the cart with the current stocks and prices from MS P&S
   * Response: the updated Checkout aggregate (cart, shipping, payment) so a single round trip refreshes every part impacted by the mutation
   */
  updateStocksAndPricesOnCart: Checkout;
  updateUser: Scalars['Boolean']['output'];
  updateUserCompanyAddress: AddressActionResponse;
  /**
   * Update a user's wishlist.
   * Change the name, add product, change quantity and/or delete products
   */
  updateWishlist_V2: Wishlist;
  verifyAndHandleIdealIpn: Scalars['Boolean']['output'];
  verifyAndHandlePayzenIpn: Scalars['Boolean']['output'];
  verifyCaptcha: Scalars['Boolean']['output'];
};


export type MutationCms_CreateFormSubmissionArgs = {
  data: Cms_MutationFormSubmissionInput;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddProductToCartArgs = {
  cartId: Scalars['String']['input'];
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  preloadData?: InputMaybe<PreloadData>;
  quantity: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationAddProductToPunchoutCartArgs = {
  punchoutCartId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String']['input'];
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<ProductToCartInput>;
  preloadData?: InputMaybe<PreloadData>;
};


export type MutationAddProductsToPunchoutCartArgs = {
  items: Array<ProductToCartInput>;
  punchoutCartId: Scalars['Int']['input'];
};


export type MutationApplyCouponToCartArgs = {
  cartId: Scalars['String']['input'];
  couponCode: Scalars['String']['input'];
};


export type MutationApproveOrderRequestArgs = {
  webRef: Scalars['String']['input'];
};


export type MutationApproveQuoteArgs = {
  input: QuoteApproveInput;
};


export type MutationClearCartItemsArgs = {
  cartId: Scalars['String']['input'];
};


export type MutationClearPunchoutCartItemsArgs = {
  punchoutCartId: Scalars['Int']['input'];
};


export type MutationClearQuickOrderArgs = {
  firstLevelCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApprovalFlowArgs = {
  input: ApprovalFlowCreateInput;
};


export type MutationCreateQuoteArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateUserCompanyAddressArgs = {
  input: UserCompanyAddressInput;
};


export type MutationCreateWishlist_V2Args = {
  input: WishlistCreateInput_V2;
};


export type MutationDeclineQuoteArgs = {
  input: QuoteDeclineInput;
};


export type MutationDeleteApprovalFlowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteUserCompanyAddressArgs = {
  addressId: Scalars['ID']['input'];
};


export type MutationDeleteWishlistArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDirectReOrderArgs = {
  cartId: Scalars['String']['input'];
  webRef: Scalars['String']['input'];
};


export type MutationExportCartIntoPunchoutFormatArgs = {
  format: Punchoutformat;
};


export type MutationGenerateAuthTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationGenerateImpersonateAuthTokenArgs = {
  userId: Scalars['String']['input'];
};


export type MutationGenerateInternalAuthTokenArgs = {
  samlResponse: Scalars['String']['input'];
};


export type MutationGenerateRefreshTokenArgs = {
  code: Scalars['String']['input'];
  encCodeVerifier: Scalars['String']['input'];
};


export type MutationPlaceOrderArgs = {
  cartId: Scalars['String']['input'];
  payzenResponse?: InputMaybe<PayzenPaymentResponseInput>;
  setAdditionalOrderInfoInput?: InputMaybe<SetAdditionalOrderInfoInput>;
};


export type MutationPunchoutCartArgs = {
  cartId: Scalars['Int']['input'];
};


export type MutationPunchoutLoginArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['URL']['input'];
};


export type MutationReOrderArgs = {
  webRef: Scalars['String']['input'];
};


export type MutationRefuseOrderRequestArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  webRef: Scalars['String']['input'];
};


export type MutationRemoveCouponFromCartArgs = {
  cartId: Scalars['String']['input'];
};


export type MutationRemoveItemFromCartArgs = {
  cartId: Scalars['String']['input'];
  cartItemUid: Scalars['UUID']['input'];
};


export type MutationRemovePunchoutCartItemArgs = {
  cartItemId: Scalars['Int']['input'];
  punchoutCartId: Scalars['Int']['input'];
};


export type MutationRenewQuoteArgs = {
  input: QuoteIdInput;
};


export type MutationReportProductAnomalyArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  subType: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationRequestCompanyRegistrationArgs = {
  input: CompanyRegistrationRequestInput;
};


export type MutationRequestDeliveryDateArgs = {
  cartId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestLoyaltyRegistrationArgs = {
  input: LoyaltySubscriptionInput;
};


export type MutationRequestUserRegistrationArgs = {
  input: UserRegistrationRequestInput;
};


export type MutationResetRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationSaveOrderRequestModificationsArgs = {
  orderRequestData?: InputMaybe<OrderRequestDataInput>;
  webRef: Scalars['String']['input'];
};


export type MutationSelectUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSetAdditionalOrderInfoOnCartArgs = {
  additionalOrderInfo: SetAdditionalOrderInfoInput;
  cartId: Scalars['String']['input'];
};


export type MutationSetIsClickAndCollectOnCartArgs = {
  cartId: Scalars['String']['input'];
  isClickAndCollect: Scalars['Boolean']['input'];
};


export type MutationSetOrderReferenceOnCartArgs = {
  cartId: Scalars['String']['input'];
  orderReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetPaymentMethodOnCartArgs = {
  paymentMethodOnCartInput: SetPaymentMethodOnCartInput;
};


export type MutationSetShippingAddressOnCartArgs = {
  shippingAddressOnCartInput: SetShippingAddressesOnCartInput;
};


export type MutationSetShippingDeliveryContactInfoOnCartArgs = {
  cartId: Scalars['String']['input'];
  input: SetShippingDeliveryContactInfoInput;
};


export type MutationSetShippingDeliveryInstructionsOnCartArgs = {
  cartId: Scalars['String']['input'];
  input: SetShippingDeliveryInstructionsInput;
};


export type MutationSetShippingMethodOnCartArgs = {
  shippingMethodOnCartInput: SetShippingMethodOnCartInput;
};


export type MutationShareQuoteArgs = {
  input: QuoteShareInput;
};


export type MutationShareWishlistArgs = {
  input: WishlistSharingInput;
};


export type MutationSubmitContactRequestArgs = {
  input: ContactRequestInput;
};


export type MutationSwitchFavoritePointOfSaleArgs = {
  posId: Scalars['String']['input'];
};


export type MutationUpdateApprovalFlowArgs = {
  input: ApprovalFlowUpdateInput;
};


export type MutationUpdateCartItemQuantityArgs = {
  cartId: Scalars['String']['input'];
  cartItemUid: Scalars['UUID']['input'];
  quantity: Scalars['Float']['input'];
};


export type MutationUpdateClickAndCollectCartItemsQuantitiesArgs = {
  cartId: Scalars['String']['input'];
  cartItems: Array<ClickAndCollectCartItemUpdateInput>;
};


export type MutationUpdateCurrentQuote_V2Args = {
  input: QuoteUpdateInput_V2;
};


export type MutationUpdateFavoriteShippingAddressArgs = {
  addressId: Scalars['ID']['input'];
};


export type MutationUpdatePunchoutCartItemQuantityArgs = {
  cartItemId: Scalars['Int']['input'];
  punchoutCartId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationUpdateQuickOrder_V2Args = {
  input: QuickOrderInput_V2;
};


export type MutationUpdateStocksAndPricesOnCartArgs = {
  cartId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


export type MutationUpdateUserCompanyAddressArgs = {
  addressId: Scalars['ID']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
  input: UserCompanyAddressInput;
};


export type MutationUpdateWishlist_V2Args = {
  input: WishlistUpdateInput_V2;
};


export type MutationVerifyAndHandleIdealIpnArgs = {
  payload: IdealIpnPayload;
};


export type MutationVerifyAndHandlePayzenIpnArgs = {
  payload: PayzenIpnPayload;
};


export type MutationVerifyCaptchaArgs = {
  token: Scalars['String']['input'];
};

export type NameFormat = {
  __typename?: 'NameFormat';
  charset: Scalars['String']['output'];
  maxLength: Scalars['Int']['output'];
  regex: Scalars['String']['output'];
};

/** M2 Norm applicable to the product */
export type Norm = {
  __typename?: 'Norm';
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Opening hours of a point of sale */
export type OpeningHour = {
  __typename?: 'OpeningHour';
  day: Scalars['String']['output'];
  dayOfWeek: Scalars['Int']['output'];
  intervals?: Maybe<Array<Interval>>;
};

/**
 * Return type of all information about an order based on ms-order.orders response
 * Sources: MS-Order
 */
export type Order = {
  __typename?: 'Order';
  actions?: Maybe<Array<OrderAction>>;
  /** Order approver information */
  approver?: Maybe<User>;
  /**
   * Order request available approvers information
   * @deprecated Use `availableApprovers` instead.
   */
  approvers?: Maybe<Array<User>>;
  /** Order request available approvers information */
  availableApprovers?: Maybe<Array<User>>;
  buyer?: Maybe<OrderBuyer>;
  chorusLegalCommitment?: Maybe<Scalars['String']['output']>;
  chorusServiceCode?: Maybe<Scalars['String']['output']>;
  /** The collect point of sale is set if the order has click and collect items */
  collectPointOfSale?: Maybe<PointOfSale>;
  /** Coupon code used during checkout */
  coupon?: Maybe<Scalars['String']['output']>;
  /** Order delivery information */
  delivery?: Maybe<OrderDelivery>;
  /** The delivery date desired by the customer (order.requestedDate) */
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  /** The MROD order reference (order.order_number) */
  externalRef?: Maybe<Scalars['String']['output']>;
  /** Order has click and collect items */
  hasClickAndCollectItems?: Maybe<Scalars['Boolean']['output']>;
  /** Order has online delivery items */
  hasOnlineDeliveryItems?: Maybe<Scalars['Boolean']['output']>;
  /** The customer order reference requested (order.customerOrderReference) */
  internalRef?: Maybe<Scalars['String']['output']>;
  /** Check if shipping method is pick up */
  isPickUpShippingMethod?: Maybe<Scalars['Boolean']['output']>;
  /** Universal discount used during checkout */
  isUniversalDiscount?: Maybe<Scalars['Boolean']['output']>;
  /** Items in the order */
  items?: Maybe<Array<OrderItem>>;
  /** Items grouped by delivery date */
  itemsSplitByDeliveryDate?: Maybe<Array<OrderItemsSection>>;
  /** The date the order was placed (order.orderDate) */
  orderDate?: Maybe<Scalars['Date']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderOrigin?: Maybe<OrderOrigin>;
  /** The M2 reserved order ID */
  orderReferenceM2?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<OrderType>;
  /** Order payment information */
  payment?: Maybe<OrderPayment>;
  /** Order status */
  status: OrderStatus;
  /** Subtotal excluding tax of the order (order prices excluding VAT without total eco part) */
  subtotalExclTax?: Maybe<Scalars['Float']['output']>;
  /** Total excluding tax of the order (order.totalPriceVatExclusive) */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Total including tax of the order (order.priceVatInclusive) */
  totalAmountInclTax?: Maybe<Scalars['Float']['output']>;
  /** Total discounts on order (discount.totalDiscount) */
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  /** Total eco part on order articles (sum of articles.taxes.totalPrice) */
  totalEcoPart?: Maybe<Scalars['Float']['output']>;
  /** Total products ordered (sum of articles.quantity) */
  totalOrderedProducts?: Maybe<Scalars['Int']['output']>;
  /** V.A.T. (order.vat) */
  totalVat?: Maybe<Scalars['Float']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  /**
   * The buyer's information at the time of the order
   * @deprecated Use `buyer` instead.
   */
  user?: Maybe<OrderUser>;
  vatDetails?: Maybe<Array<VatDetail>>;
  /**
   * Order reference on the webstore side generated by the MS
   * Based on distribution network, shipper and order type (order.webShopReference)
   */
  webRef?: Maybe<Scalars['String']['output']>;
  webShopReference?: Maybe<Scalars['String']['output']>;
  /** True if the order went through approval flow */
  wentThroughApproval: Scalars['Boolean']['output'];
};

export enum OrderAction {
  DownloadPdf = 'DOWNLOAD_PDF',
  Reorder = 'REORDER'
}

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city: Scalars['String']['output'];
  isoCountryCode: Scalars['IsoCountryCode2']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type OrderBuyer = {
  __typename?: 'OrderBuyer';
  details?: Maybe<User>;
  /**
   * The buyer's email
   * Sources: MS-Order
   */
  email: Scalars['String']['output'];
  /** Sources: MS-Order */
  id: Scalars['String']['output'];
  /**
   * The buyer's name at the time of the order (not updated if changed later)
   * Sources: MS-Order
   */
  name: Scalars['String']['output'];
};

export enum OrderCurrency {
  Eur = 'EUR'
}

/**
 * Order delivery information
 * Sources: MS-Order
 */
export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  /** Delivery addresses */
  addresses?: Maybe<Array<Maybe<OrderAddress>>>;
  fee?: Maybe<ShippingFee>;
  /** Shipping price (order.shippingPrice) */
  price?: Maybe<Scalars['Float']['output']>;
  /** Requested date saved in MsOrder (order.requestedDate) */
  requestedDate?: Maybe<Scalars['Date']['output']>;
  trackingUrl?: Maybe<Scalars['URL']['output']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  /** Contains the analytics promotion status for the item (web - code promo / web - remise universelle/null) */
  analyticsPromotionStatus?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<OrderItemDiscount>;
  name?: Maybe<Scalars['String']['output']>;
  packaging: ProductPackaging;
  product?: Maybe<Product>;
  promotionTag?: Maybe<PromotionTag>;
  quantity: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  totalExclTax: Scalars['Float']['output'];
  unitPrice: CartItemUnitPrice;
};

export type OrderItemDiscount = {
  __typename?: 'OrderItemDiscount';
  amountTotal: Scalars['Float']['output'];
  catalogDiscountAmount: Scalars['Float']['output'];
  oldPrice: Scalars['Float']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  webDiscount?: Maybe<WebDiscount>;
};

/** Duplicated from CartItemsSection type to be used with OrderItem type from MS instead of CartItem type from M2 */
export type OrderItemsSection = {
  __typename?: 'OrderItemsSection';
  /**
   * This field can be of type OrderItemsSectionInfoReal, OrderItemsSectionInfoEstimated, OrderItemsSectionInfoClickAndCollect or OrderItemsSectionInfoNoDeliveryTime
   * Source: MS
   */
  info: OrderItemsSectionInfo;
  /**
   * Items concerned by the section
   * Source: MS
   */
  items?: Maybe<Array<OrderItem>>;
  /**
   * Total quantity of items concerned by the section
   * Source: MS
   */
  quantity: Scalars['Float']['output'];
};

export type OrderItemsSectionInfo = OrderItemsSectionInfoClickAndCollect | OrderItemsSectionInfoEstimated | OrderItemsSectionInfoNoDeliveryTime | OrderItemsSectionInfoReal;

export type OrderItemsSectionInfoClickAndCollect = {
  __typename?: 'OrderItemsSectionInfoClickAndCollect';
  /** This is present only to be able to query the type, but value will not be used */
  noValue?: Maybe<Scalars['String']['output']>;
};

export type OrderItemsSectionInfoEstimated = {
  __typename?: 'OrderItemsSectionInfoEstimated';
  delay: ShippingDelay;
};

export type OrderItemsSectionInfoNoDeliveryTime = {
  __typename?: 'OrderItemsSectionInfoNoDeliveryTime';
  /** This is present only to be able to query the type, but value will not be used */
  noDeliveryTime?: Maybe<Scalars['String']['output']>;
};

export type OrderItemsSectionInfoReal = {
  __typename?: 'OrderItemsSectionInfoReal';
  date?: Maybe<Scalars['String']['output']>;
};

export enum OrderOrigin {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type OrderPagination = {
  __typename?: 'OrderPagination';
  items?: Maybe<Array<Maybe<Order>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  code?: Maybe<OrderPaymentCode>;
  orderReference?: Maybe<Scalars['String']['output']>;
};

export enum OrderPaymentCode {
  Card = 'CARD',
  Ideal = 'IDEAL',
  Term = 'TERM'
}

/** Input data to update some DA fields. */
export type OrderRequestDataInput = {
  /** The chorus data to update on the order request */
  chorus?: InputMaybe<ChorusDataInput>;
  /** The reference provided by the customer */
  orderReference?: InputMaybe<Scalars['String']['input']>;
};

export type OrderRequestToApprove = {
  __typename?: 'OrderRequestToApprove';
  approvee: User;
  approver: User;
  chorusLegalCommitment?: Maybe<Scalars['String']['output']>;
  chorusServiceCode?: Maybe<Scalars['String']['output']>;
  delivery: OrderDelivery;
  /** Source MS */
  internalRef: Scalars['String']['output'];
  orderDate: Scalars['Date']['output'];
  payment: OrderPayment;
  /** Source M2 */
  updatedState?: Maybe<Cart>;
  webRef: Scalars['String']['output'];
};

export enum OrderStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Declined (order requests only) */
  Declined = 'DECLINED',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Waiting for approval (order requests only) */
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

export enum OrderStatusItems {
  An = 'AN',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Ec = 'EC',
  Et = 'ET',
  GatheringApprovalData = 'GATHERING_APPROVAL_DATA',
  NotReceivedByAgency = 'NOT_RECEIVED_BY_AGENCY',
  ReceivedByAgency = 'RECEIVED_BY_AGENCY',
  Tc = 'TC',
  WaitingForApproval = 'WAITING_FOR_APPROVAL',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export enum OrderType {
  Ecommerce = 'ECOMMERCE',
  Store = 'STORE'
}

export type OrderUser = {
  __typename?: 'OrderUser';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum OrderValuesReturned {
  Address = 'ADDRESS',
  Approval = 'APPROVAL',
  Articles = 'ARTICLES',
  Client = 'CLIENT',
  Customer = 'CUSTOMER',
  Delivery = 'DELIVERY',
  Discount = 'DISCOUNT',
  Intercompany = 'INTERCOMPANY',
  Navigation = 'NAVIGATION',
  Order = 'ORDER',
  Payment = 'PAYMENT'
}

export enum Punchoutformat {
  CxmlAriba = 'CXML_ARIBA',
  CxmlCoupa = 'CXML_COUPA',
  CxmlIvalua = 'CXML_IVALUA',
  /** @deprecated Use `OCI_TXT` or `OCI_CSV` instead. */
  Oci = 'OCI',
  OciCsv = 'OCI_CSV',
  OciTxt = 'OCI_TXT'
}

export type Packaging = {
  __typename?: 'Packaging';
  incrementQuantity?: Maybe<Scalars['Float']['output']>;
  minimalSalesQuantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Unit>;
};

/** Defines pagination details such as the page size and the current page index. */
export type Pagination = {
  /** Current page index (starting at 1). */
  index: Scalars['Int']['input'];
  /** Number of items per page. */
  size: Scalars['Int']['input'];
};

/**
 * The payment methods and information used to complete an order
 * Source: M2
 */
export type Payment = {
  __typename?: 'Payment';
  /** Available method for making a payment */
  availableMethods?: Maybe<PaymentMethod>;
  /** The code of the currently selected method */
  code?: Maybe<Scalars['String']['output']>;
  /** The reference provided by the customer for this order process (optional) */
  orderReference?: Maybe<Scalars['String']['output']>;
};

/**
 * Details about the payment methods existing for the order
 * Source: M2
 */
export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Payment method for a card transaction */
  card?: Maybe<PaymentMethodCard>;
  /** Payment method for a ideal transaction */
  ideal?: Maybe<PaymentMethodIdeal>;
  /** Payment method for a term transaction */
  term?: Maybe<PaymentMethodTerm>;
};

/**
 * Payment method details for a card transaction
 * Source: M2
 */
export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  /** Will be "payzen_standard" if active */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates the current status of the payment method */
  status: PaymentStatus;
  /** Payzen standard token */
  token: Scalars['String']['output'];
};

/**
 * Payment method details for a term transaction
 * Source: M2
 */
export type PaymentMethodIdeal = {
  __typename?: 'PaymentMethodIdeal';
  /** Will be "ideal" if active */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates the current status of the payment method */
  status: PaymentStatus;
};

export type PaymentMethodInput = {
  code: Scalars['String']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Payment method details for a term transaction
 * Source: M2
 */
export type PaymentMethodTerm = {
  __typename?: 'PaymentMethodTerm';
  /** Will be "termpayment" if active */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates the current status of the payment method */
  status: PaymentStatus;
};

/**
 * Indicates the current status of the payment method
 * - DISABLED: The payment method is not available
 * - ON: The payment method is active and ready for use
 */
export enum PaymentStatus {
  Disabled = 'DISABLED',
  DisabledVat = 'DISABLED_VAT',
  On = 'ON'
}

export type PayzenConfig = {
  __typename?: 'PayzenConfig';
  apiUrl?: Maybe<Scalars['String']['output']>;
  currentSubsidiary?: Maybe<PayzenConfigSubsidiaryEntries>;
  decimal?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  tokenEndPoint?: Maybe<Scalars['String']['output']>;
};

export type PayzenConfigSubsidiaryEntries = {
  __typename?: 'PayzenConfigSubsidiaryEntries';
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type PayzenIpnPayload = {
  answer: Scalars['String']['input'];
  answerType?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  hashAlgorithm: Scalars['String']['input'];
  hashKey: Scalars['String']['input'];
};

/**
 * Payzen payment response
 * https://payzen.io/fr-FR/rest/V4.0/api/playground/answer/Payment
 * Source: Payzen API
 */
export type PayzenPaymentResponseInput = {
  _name?: InputMaybe<Scalars['String']['input']>;
  _type?: InputMaybe<Scalars['String']['input']>;
  clientAnswer: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['JSON']['input']>;
  form?: InputMaybe<Scalars['JSON']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  hashAlgorithm?: InputMaybe<Scalars['String']['input']>;
  hashKey?: InputMaybe<Scalars['String']['input']>;
  rawClientAnswer?: InputMaybe<Scalars['String']['input']>;
  serverDate?: InputMaybe<Scalars['String']['input']>;
};

export type PersistentCart = {
  __typename?: 'PersistentCart';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<CartItem>>;
  /**
   * Id shop delivery from session shop
   * Source: MS-Price-Stock
   */
  shop_id?: Maybe<Scalars['String']['output']>;
};

/**
 * Source : MS Agency
 * Context : It can be a store (For Prolians/Hydralians), an agency (for Dexis)
 */
export type PointOfSale = {
  __typename?: 'PointOfSale';
  /**
   * specificActivities in MS
   * Activity of the point of sale (hydralians)
   */
  activity?: Maybe<Scalars['String']['output']>;
  address: PointOfSaleAddress;
  distance?: Maybe<Scalars['Float']['output']>;
  distributionNetworkLabel?: Maybe<Scalars['String']['output']>;
  /** Exceptional opening dates of this point of sale */
  exceptionalDates?: Maybe<Array<ExceptionalDate>>;
  /**
   * Point of sale id, unique identifier (MS : agency_id)
   * In the header, we found this id in the x-point-of-sale-id or x-pickup-point-of-sale-id header
   */
  id: Scalars['String']['output'];
  isClickAndCollectEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPickupStoreEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSelectable: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Link of the point of sale : (MS : gmb_link) */
  link?: Maybe<Scalars['URL']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the point of sale : (MS : agency_name) */
  name: Scalars['String']['output'];
  /** The point of sale is opened for public : (MS : opened_public) */
  open: Scalars['Boolean']['output'];
  /** The opening hours for the point of sale */
  openingHours?: Maybe<Array<OpeningHour>>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** In case where a point of sale has a parent point of sale */
  parentPointOfSale?: Maybe<PointOfSale>;
  phoneNumber?: Maybe<Scalars['Phone']['output']>;
  photo?: Maybe<Scalars['URL']['output']>;
  /** Subsidiary object for the point of sale */
  subsidiary: Subsidiary;
};

/**
 * Source: MS Agency
 * Can be returned in PointOfSale type, in the "address" field
 */
export type PointOfSaleAddress = {
  __typename?: 'PointOfSaleAddress';
  city: Scalars['String']['output'];
  department: Scalars['String']['output'];
  isoCountryCode: Scalars['IsoCountryCode2']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
};

export type PointOfSaleIdDistance = {
  __typename?: 'PointOfSaleIdDistance';
  distance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
};

export type PointOfSaleManagement = {
  __typename?: 'PointOfSaleManagement';
  scopeAdditionalData?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Represents the paginated result of point of sale
 * Contains total pages, total size and the list of points of sale
 */
export type PointOfSalePagination = {
  __typename?: 'PointOfSalePagination';
  /** Paginated list of point of sale. */
  items: Array<PointOfSale>;
  /** Total number of available pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** Total number of users matching the criteria. */
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * External data preloaded by mesh-unified plugin
 * Used to pass pre-fetched data from external services (MS, etc.) to resolvers
 */
export type PreloadData = {
  /** Approval flow data (JSON string) */
  approvalFlows?: InputMaybe<Scalars['String']['input']>;
  /** Client data indexed by company ID (JSON string) */
  clients?: InputMaybe<Scalars['String']['input']>;
  /** Pickup Point of Sale data */
  pickupPointOfSale?: InputMaybe<Scalars['String']['input']>;
  /** Main Point of Sale data */
  pointOfSale?: InputMaybe<Scalars['String']['input']>;
  /** Point of Sale data indexed by agency ID (JSON string) */
  pointsOfSale?: InputMaybe<Scalars['String']['input']>;
  /** Price and stock data indexed by PointOfSale ID and then by reference (JSON string) */
  priceAndStocks?: InputMaybe<Scalars['String']['input']>;
  /** Product data (price, stock, catalog) indexed by PointOfSale ID and then by reference (JSON string) */
  products?: InputMaybe<Scalars['String']['input']>;
  /** User data indexed by user ID (JSON string) */
  users?: InputMaybe<Scalars['String']['input']>;
};

export type Price = {
  __typename?: 'Price';
  discountExclTax?: Maybe<Scalars['Float']['output']>;
  discountInclTax?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  exclTax?: Maybe<Scalars['Float']['output']>;
  inclTax?: Maybe<Scalars['Float']['output']>;
  priceExcludingPromo?: Maybe<Scalars['Float']['output']>;
  referenceExclTax?: Maybe<Scalars['Float']['output']>;
  referenceInclTax?: Maybe<Scalars['Float']['output']>;
  referencePercentage?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Tag>;
  tiers?: Maybe<Array<TierPrice>>;
};

export type PriceInfo = {
  __typename?: 'PriceInfo';
  conditioning?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  exclTax?: Maybe<Scalars['Float']['output']>;
  hasRealPrice: Scalars['Boolean']['output'];
  inclTax?: Maybe<Scalars['Float']['output']>;
  packaging?: Maybe<Packaging>;
  price?: Maybe<Scalars['Float']['output']>;
  priceExcludingPromo?: Maybe<Scalars['Float']['output']>;
  priceLevels?: Maybe<Array<PriceStock_PriceLevel>>;
  pricePromoCode?: Maybe<Scalars['String']['output']>;
  priceReference?: Maybe<Scalars['Float']['output']>;
  priceReferencePercentage?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  priceUnit?: Maybe<Scalars['Float']['output']>;
  priceVat?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['String']['output'];
};

/** List of prices and stocks by codep or codag */
export type PriceStock = {
  __typename?: 'PriceStock';
  /** The codag if an article, codep if product */
  articleOrProduct?: Maybe<Scalars['String']['output']>;
  conditioning?: Maybe<Scalars['Float']['output']>;
  /** True if product is present on Lennie platform 111 */
  lennieProdexFixing?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<PriceStock_Price>;
  /** true if product is present on PX platform */
  prodexFixing?: Maybe<Scalars['Boolean']['output']>;
  stockLivre?: Maybe<PriceStock_Stock>;
  stockLocal?: Maybe<PriceStock_Stock>;
  stockPlateforme?: Maybe<PriceStock_Stock>;
};

/** List codag and quantity and stock type of acticles */
export type PriceStockRequest_Article = {
  /** the quantity */
  quantity: Scalars['Float']['input'];
  /** the codag */
  sku: Scalars['String']['input'];
  typeStock?: InputMaybe<PriceStockRequest_Article_TypeStock>;
};

/** if no stock type is provided, then the stock will not be fetched */
export enum PriceStockRequest_Article_TypeStock {
  Livre = 'LIVRE',
  Local = 'LOCAL',
  LocalLivre = 'LOCAL_LIVRE',
  Plateforme = 'PLATEFORME'
}

export type PriceStockRequest_Input = {
  /** Technical identifier of the agency. */
  agencyId: Scalars['String']['input'];
  /** List codag and quantity and stock type of acticles */
  articles?: InputMaybe<Array<InputMaybe<PriceStockRequest_Article>>>;
  /** Technical identifier of the client. */
  clientIdExternal: Scalars['String']['input'];
  /** List codeps and codags of products */
  products?: InputMaybe<Array<InputMaybe<PriceStockRequest_Product>>>;
  /** the subsidiary id */
  subsidiaryId: Scalars['String']['input'];
};

/** List codeps and codags of products */
export type PriceStockRequest_Product = {
  /** the codag list to search the best price from */
  codags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the product code */
  codep: Scalars['String']['input'];
};

export type PriceStockResponse = {
  __typename?: 'PriceStockResponse';
  /** List of prices and stocks by codep or codag */
  articlesAndProducts?: Maybe<Array<Maybe<PriceStock>>>;
};

/** The article list wanted for this platform */
export type PriceStock_DeliveryArticleRequest = {
  /** The article codag */
  codag: Scalars['String']['input'];
  /** The wanted quantity */
  quantity: Scalars['Int']['input'];
  /** The unit of measurement for quantity */
  unitOfMeasurement: Scalars['String']['input'];
};

/** The list of articles and quantities available at this delivery time */
export type PriceStock_DeliveryArticleResponse = {
  __typename?: 'PriceStock_DeliveryArticleResponse';
  /** The codag of the article */
  codag?: Maybe<Scalars['String']['output']>;
  /** The quantity available at this delivery time */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type PriceStock_DeliveryTimeRequest = {
  /** The client branch or agency id */
  agencyId: Scalars['String']['input'];
  /** The client department code, 2 first digits of the postal code */
  departmentCode: Scalars['String']['input'];
  /** True if onsite delivery, false if store pickup */
  onsiteDelivery: Scalars['Boolean']['input'];
  /** Articles wanted by platform */
  platforms?: InputMaybe<Array<InputMaybe<PriceStock_PlatformRequest>>>;
};

export type PriceStock_DeliveryTimeResponse = {
  __typename?: 'PriceStock_DeliveryTimeResponse';
  /** The list of articles and quantities available at this delivery time */
  articles?: Maybe<Array<Maybe<PriceStock_DeliveryArticleResponse>>>;
  /** Delivery date if present */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Delivery time if present */
  deliveryTime?: Maybe<Scalars['Int']['output']>;
};

/** Articles wanted by platform */
export type PriceStock_PlatformRequest = {
  /** The article list wanted for this platform */
  articles?: InputMaybe<Array<InputMaybe<PriceStock_DeliveryArticleRequest>>>;
  /** The attachment platform (PTEX) */
  attachmentPlatform: Scalars['String']['input'];
  /** The company code, linked to attachmentPlatform (PTEX) */
  companyCode: Scalars['String']['input'];
};

export type PriceStock_Price = {
  __typename?: 'PriceStock_Price';
  /** The best price as given by the ESB */
  bestPriceByPackaging?: Maybe<Scalars['Float']['output']>;
  /** The cost price of the article. */
  costPrice?: Maybe<Scalars['Float']['output']>;
  /** The calculated discount for the article. */
  discount?: Maybe<Scalars['Float']['output']>;
  /** An additional discount for the article. */
  discount1?: Maybe<Scalars['Float']['output']>;
  /** An additional discount for the article. */
  discount2?: Maybe<Scalars['Float']['output']>;
  ecoTaxIdentifier?: Maybe<Scalars['String']['output']>;
  ecoTaxPrice?: Maybe<Scalars['Float']['output']>;
  /** The gross price of the article. */
  grossPrice?: Maybe<Scalars['Float']['output']>;
  /** The increment quantity of the article. */
  incrementQuantity?: Maybe<Scalars['Float']['output']>;
  minimalSalesQuantity?: Maybe<Scalars['Float']['output']>;
  /** The price of the article. */
  price?: Maybe<Scalars['Float']['output']>;
  priceExcludingPromo?: Maybe<Scalars['Float']['output']>;
  priceLevels?: Maybe<Array<Maybe<PriceStock_PriceLevel>>>;
  priceType?: Maybe<Scalars['String']['output']>;
  /** The unitary price of the article. */
  priceUnit?: Maybe<Scalars['Float']['output']>;
  /** The product code used for the best price */
  productCode?: Maybe<Scalars['String']['output']>;
  promoDetails?: Maybe<Scalars['String']['output']>;
  promoPriceCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** Status message */
  statusMessage?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  /** The value added tax price. */
  valueAddedTax?: Maybe<Scalars['Float']['output']>;
};

export type PriceStock_PriceLevel = {
  __typename?: 'PriceStock_PriceLevel';
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PriceStock_PriceResponse = {
  __typename?: 'PriceStock_PriceResponse';
  /** The codag if an article, codep if product */
  articleOrProduct?: Maybe<Scalars['String']['output']>;
  conditioning?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<PriceStock_Price>;
};

export type PriceStock_Stock = {
  __typename?: 'PriceStock_Stock';
  attachmentPlatform?: Maybe<Scalars['String']['output']>;
  /** Whether the article is elligible for ExpressCollect or not. */
  canExpressCollect?: Maybe<Scalars['Boolean']['output']>;
  localArticleNumber?: Maybe<Scalars['String']['output']>;
  productRestockStatus?: Maybe<Scalars['String']['output']>;
  /** Available stock of the article. */
  stock?: Maybe<Scalars['Float']['output']>;
  stockReference?: Maybe<Scalars['Float']['output']>;
  storeStockPlan?: Maybe<Scalars['Boolean']['output']>;
  subscribeToPlatform?: Maybe<Scalars['Boolean']['output']>;
  subscribedPlatform?: Maybe<PriceStock_SubscribedPlatform>;
  unit?: Maybe<Scalars['String']['output']>;
  webItemAvailability?: Maybe<Scalars['String']['output']>;
};

export type PriceStock_StockResponse = {
  __typename?: 'PriceStock_StockResponse';
  conditioning?: Maybe<Scalars['Float']['output']>;
  /** True if product is present on Lennie platform 111 */
  lennieProdexFixing?: Maybe<Scalars['Boolean']['output']>;
  /** true if product is present on PX platform */
  prodexFixing?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  stockLivre?: Maybe<PriceStock_Stock>;
  stockLocal?: Maybe<PriceStock_Stock>;
  stockPlateforme?: Maybe<PriceStock_Stock>;
};

export type PriceStock_SubscribedPlatform = {
  __typename?: 'PriceStock_SubscribedPlatform';
  attachmentPlatform?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Source: MS Catalog + FH + M2 */
export type Product = {
  __typename?: 'Product';
  _breadcrumbs?: Maybe<Array<Breadcrumb>>;
  /** M2 technical spec specific to article */
  additionalTechnicalSpecs?: Maybe<Array<TechnicalSpec>>;
  analytics?: Maybe<ProductAnalytics>;
  articles?: Maybe<Array<Product>>;
  /** @deprecated use Product.stock instead */
  availability: Array<Maybe<Availability>>;
  /**
   * Availability status code for the product, possible values:
   * @deprecated Use the `custom_attributes` field instead.
   */
  availability_status_code?: Maybe<Scalars['String']['output']>;
  /** MS Price & Stock */
  bestArticlePrice?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Brand>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  /** Category id to use for breadcrumbs, will be the highest level category in the category tree for the product */
  breadcrumbs_descours_category_id?: Maybe<Scalars['String']['output']>;
  bundle?: Maybe<Array<Product>>;
  calculatedPrice?: Maybe<Price>;
  canAddToCart: Scalars['Boolean']['output'];
  canExpressCollect: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  charges: Array<Maybe<Charge>>;
  clickAndCollectStatus?: Maybe<ClickAndCollectStatus>;
  /** The product EAN13 barcode. */
  descoursEan13?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  /** M2 */
  ecoPart: EcoPart;
  equivalentProducts?: Maybe<Array<Product>>;
  favorites?: Maybe<Array<Product>>;
  /** MS : List of configurable attribute values, ex : shoe size, color, etc. */
  filters?: Maybe<Array<ProductFilter>>;
  /**
   * Represent the higher category from product category tree
   * Comes from the product attribute descours_xxxxx_cat_level1. where xxxxx is the distribution network code.
   */
  firstLevelCategory?: Maybe<FirstLevelCategory>;
  /** @deprecated use Product.stock instead */
  g9LowStockThreshold?: Maybe<Scalars['Int']['output']>;
  hasRseLabel?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Image>>;
  /**
   * Source : M2
   * Is the product is in click and collect only mode
   */
  isClickAndCollectOnly: Scalars['Boolean']['output'];
  /** M2 + MS Price & Stock */
  isEquivalentProductsLinkVisible: Scalars['Boolean']['output'];
  /** Is the product in one of the current customer wishlist (wishlistType = WISHLIST) */
  isFavorite: Scalars['Boolean']['output'];
  isLinkedProductsLinkVisible: Scalars['Boolean']['output'];
  /** @deprecated use Product.stock instead */
  isPriceAvailable: Scalars['Boolean']['output'];
  /** @deprecated use Product.stock instead */
  isSellable: Scalars['Boolean']['output'];
  linkedProducts?: Maybe<Array<Product>>;
  mainImage?: Maybe<Image>;
  /** M2 : Max 5 more important technical spec (mix product and article) */
  mainTechnicalSpecs?: Maybe<Array<TechnicalSpec>>;
  /** Displays promotional details, such as discounts or coupons, applicable to this product. */
  marketingInsert?: Maybe<ProductMarketingInsert>;
  /** @deprecated use Product.stock instead */
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** FH */
  nbArticles: Scalars['Int']['output'];
  /** M2 */
  nomenclatureFamily?: Maybe<Scalars['String']['output']>;
  /** M2 */
  nomenclatureGroup?: Maybe<Scalars['String']['output']>;
  /** M2 Norms applicable to the product */
  norms?: Maybe<Array<Norm>>;
  /** @deprecated use Product.stock instead */
  onlineQuantity?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use Product.stock instead */
  packaging?: Maybe<ProductPackaging>;
  /** MS */
  parentReference?: Maybe<Scalars['String']['output']>;
  /** The URL key of the parent product if this one is an article. Source: Magento 2 */
  parentUrlKey?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
  /** MS */
  promoPriceCode?: Maybe<Scalars['String']['output']>;
  recommendedProducts?: Maybe<Array<Product>>;
  reference: Scalars['String']['output'];
  /** @deprecated use Product.stock instead */
  shippingDelay?: Maybe<ShippingDelay>;
  /** M2 */
  shortDescription?: Maybe<Scalars['String']['output']>;
  stock: ProductStock;
  /** @deprecated use Product.stock instead */
  storeQuantity?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  supplierReference?: Maybe<Scalars['String']['output']>;
  technicalSpecs?: Maybe<Array<TechnicalSpec>>;
  /** PRODUCT if a configurable product, ARTICLE if simple product or a variation of a configurable */
  type: ProductType;
  /** The part of the URL that identifies the product */
  urlKey?: Maybe<Scalars['String']['output']>;
  variations?: Maybe<Array<Product>>;
  /** M2 */
  videoUrls?: Maybe<Array<Scalars['String']['output']>>;
};


/** Source: MS Catalog + FH + M2 */
export type ProductLinkedProductsArgs = {
  includeBundleInLinkedProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Source: MS Catalog + FH + M2 */
export type ProductRecommendedProductsArgs = {
  productDeduplication?: InputMaybe<Scalars['Boolean']['input']>;
  productLimit?: InputMaybe<Scalars['Int']['input']>;
};


/** Source: MS Catalog + FH + M2 */
export type ProductStockArgs = {
  pointOfSaleId?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAnalytics = {
  __typename?: 'ProductAnalytics';
  profileCase?: Maybe<Scalars['String']['output']>;
  promotionStatus?: Maybe<Scalars['String']['output']>;
};

export type ProductAnomaly = {
  __typename?: 'ProductAnomaly';
  categories?: Maybe<Array<ProductSubAnomaly>>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Source: M2
 * Attachment assigned to a specific product in wishlist
 */
export type ProductAttachment = {
  __typename?: 'ProductAttachment';
  /** File extension */
  extension: Scalars['String']['output'];
  /** Uuid generated for the attachment */
  id: Scalars['ID']['output'];
  /** Content-Length of the file (bytes) */
  length: Scalars['Int']['output'];
  /** Name of the file : myimage.png */
  name: Scalars['String']['output'];
};

/** Product attachment input */
export type ProductAttachmentInput = {
  /** Data in Base64 "iVBORw0KGgoAAAANSUhEUgAA..." */
  data: Scalars['String']['input'];
  /** Name of the file : image.png */
  name: Scalars['String']['input'];
  /** Mimetype : example image/png */
  type: Scalars['String']['input'];
};

/** Input allows to delete attachment in product */
export type ProductAttachmentToDeleteInput = {
  id: Scalars['ID']['input'];
};

/**
 * Context : Discriminant attribute of a product, like color, size, etc.
 * Source : MS Catalog
 */
export type ProductFilter = {
  __typename?: 'ProductFilter';
  label: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<ProductFilterValue>>;
};

/**
 * Context : Discriminant attribute values of a product, like color blue, red, yellow
 * Source : MS Catalog
 */
export type ProductFilterValue = {
  __typename?: 'ProductFilterValue';
  label: Scalars['String']['output'];
  /** Product references matching the filter value */
  references?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A filterable and pageable collection of products.
 * If some filters are activated, the collection is fed with products that match those filter values.
 * The filter values are chosen among all the available values listed in the fields productFilters and categoryFilters.
 * The activated filter values are listed in the fields
 * Headers: x-distribution-network
 * Sources: MS-Catalog, M2
 */
export type ProductList = {
  __typename?: 'ProductList';
  /** Filter values selected on the categories (may be empty if no selection) */
  categoryActiveFilters?: Maybe<Array<ProductListFilter>>;
  /** Available filters to apply on the categories (these are the categories in which the products are dispatched) */
  categoryFilters?: Maybe<Array<ProductListFilter>>;
  /** Filter values selected on the products attributes (may be empty if no selection) */
  productActiveFilters?: Maybe<Array<ProductListFilter>>;
  /** The number of products across all pages (not only the current page) */
  productCount?: Maybe<Scalars['Int']['output']>;
  /** Available filters to apply on the products attributes */
  productFilters?: Maybe<Array<ProductListFilter>>;
  /** The collection of products for the current page index (with products matching the activated filters, if any) */
  products?: Maybe<Array<Product>>;
  /** The total number of pages to fetch the entire products collection (collection reduced to the products matching the activated filters, if any) */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/**
 * A filter of a ProductList entity. Basically a title with values, and optionally an image.
 * For instance a color of a product, with the list of existing colors.
 * Sources: MS-Catalog, M2 (for category filters only)
 */
export type ProductListFilter = {
  __typename?: 'ProductListFilter';
  image?: Maybe<Image>;
  title: Scalars['String']['output'];
  values?: Maybe<Array<ProductListFilterValue>>;
};

/** The base type for value of a filter of a ProductList entity. */
export type ProductListFilterValue = ValueFilter | ValueLink;

/**
 * Represents marketing details for a product promotion,
 * such as discounts or special offers, displayed on the product page.
 * Source: M2
 */
export type ProductMarketingInsert = {
  __typename?: 'ProductMarketingInsert';
  /** Label describing the promotion or discount applied to the product */
  label: Scalars['String']['output'];
  /** Legal disclaimer or additional information about the promotion */
  legalNotice?: Maybe<Scalars['String']['output']>;
};

/** Source: MS Price&Stock */
export type ProductPackaging = {
  __typename?: 'ProductPackaging';
  incrementQuantity?: Maybe<Scalars['Float']['output']>;
  minimalSalesQuantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Unit>;
};

export type ProductPointOfSale = {
  __typename?: 'ProductPointOfSale';
  id: Scalars['String']['output'];
  pointOfSale: PointOfSale;
  product: Product;
};

export type ProductStock = {
  __typename?: 'ProductStock';
  _parent?: Maybe<Product>;
  availability: Array<Maybe<Availability>>;
  g9LowStockThreshold?: Maybe<Scalars['Int']['output']>;
  isPriceAvailable: Scalars['Boolean']['output'];
  isSellable: Scalars['Boolean']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  onlineQuantity?: Maybe<Scalars['Int']['output']>;
  packaging?: Maybe<ProductPackaging>;
  shippingDelay?: Maybe<ShippingDelay>;
  storeQuantity?: Maybe<Scalars['Int']['output']>;
};

export type ProductSubAnomaly = {
  __typename?: 'ProductSubAnomaly';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductToCartInput = {
  quantity: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};

export enum ProductType {
  Article = 'ARTICLE',
  Product = 'PRODUCT'
}

/**
 * Source: M2
 * Represent an item in product wishlist
 */
export type ProductWishlist = {
  __typename?: 'ProductWishlist';
  /** Attachments for a specific product */
  attachments?: Maybe<Array<ProductAttachment>>;
  catalogDiscountAmount?: Maybe<Scalars['Float']['output']>;
  /** Comment for a specific product */
  comment?: Maybe<Scalars['String']['output']>;
  conditioningUnitPriceExclTax?: Maybe<Scalars['Float']['output']>;
  /** Id of the item in wishlist */
  id: Scalars['Int']['output'];
  /** Product information related to the wishlist item */
  product: Product;
  /** Requested quantity of the item */
  quantity: Scalars['Int']['output'];
  rowTotalExclTax?: Maybe<Scalars['Float']['output']>;
  unitPriceExclTax?: Maybe<Scalars['Float']['output']>;
};

/**
 * Source : M2
 * Context : Get the list of activities and associated specialities for the DOC registration
 */
export type ProfessionActivity = {
  __typename?: 'ProfessionActivity';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  specialities?: Maybe<Array<ProfessionActivitySpeciality>>;
};

/**
 * Source : M2
 * Context : Return the speciality data of an activity
 */
export type ProfessionActivitySpeciality = {
  __typename?: 'ProfessionActivitySpeciality';
  activityId: Scalars['Int']['output'];
  codeProfession: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum PromoPriceCode {
  Clearance = 'CLEARANCE',
  Promotion = 'PROMOTION',
  Tier = 'TIER'
}

/** Contains the label and type of the tag to display for an item that benefits from a promotion */
export type PromotionTag = {
  __typename?: 'PromotionTag';
  /** The label of the tag to display */
  label?: Maybe<Scalars['String']['output']>;
  /** The type of the tag to display */
  type?: Maybe<Tag>;
};

export type Punchout = {
  __typename?: 'Punchout';
  cart?: Maybe<PunchoutCart>;
};

export type PunchoutCart = {
  __typename?: 'PunchoutCart';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<PunchoutCartItem>>>;
  itemsGroupedByEarliestDeliveryDate?: Maybe<Array<Maybe<PunchoutCartItemsSection>>>;
  messages?: Maybe<Array<Maybe<CartMessage>>>;
  subtotalExclTax?: Maybe<Scalars['Float']['output']>;
  taxesDetails?: Maybe<Array<CartTaxItem>>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  totalEcoPart?: Maybe<Scalars['Float']['output']>;
  totalExclTax?: Maybe<Scalars['Float']['output']>;
  totalInclTax?: Maybe<Scalars['Float']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PunchoutCartItem = {
  __typename?: 'PunchoutCartItem';
  catalogDiscountAmount?: Maybe<Scalars['Float']['output']>;
  conditioningUnitPriceExclTax?: Maybe<Scalars['Float']['output']>;
  deliveryDetails?: Maybe<Array<CartItemDeliveryStockDetails>>;
  id: Scalars['Int']['output'];
  product: Product;
  quantity: Scalars['Int']['output'];
  rowTotalExclTax?: Maybe<Scalars['Float']['output']>;
  unitPriceExclTax?: Maybe<Scalars['Float']['output']>;
};

export type PunchoutCartItemsSection = {
  __typename?: 'PunchoutCartItemsSection';
  info: CartItemsSectionInfo;
  items?: Maybe<Array<PunchoutCartItem>>;
  quantity: Scalars['Int']['output'];
};

export type PunchoutCartOutput = {
  __typename?: 'PunchoutCartOutput';
  formData: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PunchoutLogin = {
  __typename?: 'PunchoutLogin';
  additionalInformation?: Maybe<PunchoutLoginAdditionalInformation>;
  token: Token;
};

export type PunchoutLoginAdditionalInformation = {
  __typename?: 'PunchoutLoginAdditionalInformation';
  backToERPUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Details about the next level of quantity sale discount.
 * Source: M2
 */
export type QuantitySaleNextLevel = {
  __typename?: 'QuantitySaleNextLevel';
  /** The gap required to reach the next level of quantity sale discount. */
  gap?: Maybe<Scalars['Float']['output']>;
  /** The unit price at the next level of quantity sale discount. */
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  CMS_Page?: Maybe<Cms_Page>;
  CMS_Pages?: Maybe<Cms_Pages>;
  CMS_ReassuranceCard?: Maybe<Cms_ReassuranceCard>;
  CMS_ReassuranceCards?: Maybe<Cms_ReassuranceCards>;
  CMS_SeoCategories?: Maybe<Cms_SeoCategories>;
  CMS_SeoCategory?: Maybe<Cms_SeoCategory>;
  CMS_Tenants?: Maybe<Cms_Tenants>;
  articlesByReferences?: Maybe<Array<Product>>;
  /** Get list of country allowed on magento's side. */
  availableCountries?: Maybe<Array<Maybe<Country>>>;
  availablePointsOfSaleInventory?: Maybe<Array<ProductPointOfSale>>;
  /** M2 + MS : returns the matching brand for the given urlKey */
  brand?: Maybe<Brand>;
  /** M2 + MS : returns the brand list */
  brands?: Maybe<Array<Brand>>;
  /**
   * Source : M2
   * Context : Returns the level 1 categories if urlKey is not specified, otherwise the sub categories of the one that is pointed to by this urlKey.
   * If filterSubCats is set to true, we filter the sub categories based on FH categories. If one of those is not present on FH's side, it's removed from the result
   */
  categories?: Maybe<Array<Category>>;
  categoryBreadcrumb?: Maybe<Array<M2Breadcrumb>>;
  cmsPage?: Maybe<CmsPage>;
  companyNationalIdData?: Maybe<CompanyNationalIdData>;
  /** List of countries allowed at registration. */
  companyRegistrationRequestAvailableCountries?: Maybe<Array<Maybe<Country>>>;
  config: Config;
  /** Get contact form subjects list (use x-email header to get connected subjects, otherwise we return not connected ones). */
  contactFormSubjects: Array<Maybe<ContactSubjectCategory>>;
  /**
   * When authenticated with a valid internal token, return the current internal collaborator.
   * Returns null when no valid internal authorization token is provided.
   */
  currentInternalUser?: Maybe<InternalUser>;
  /**
   * When logged-in, return the current user logged
   * Context: mandatory headers needed :
   * * x-distribution-network
   * * Authorization (JWT token)
   * * x-company-code
   * * x-subsidiary-id
   * * x-point-of-sale-id
   * @deprecated 2026-13|Use Query.session instead
   */
  currentUser?: Maybe<User>;
  /**
   * When logged-in, return the accounts for the current user logged
   * Context: mandatory headers needed :
   * * x-distribution-network
   * * Authorization (JWT token)
   * We can specify the status (status from MS User, clientLink), to allow returning all companies
   * for the current user for the current website (x-distribution-network)
   */
  currentUserAccounts?: Maybe<Array<User>>;
  customerCart: Cart;
  /** Gets the front url depending on distribution network */
  ecomUrl: Scalars['URL']['output'];
  equivalentProductConfig?: Maybe<EquivalentProductConfig>;
  /** An event is a marketing operation that aims to push some products to the customers and that can be active for a specific period or not. */
  event?: Maybe<Event>;
  /**
   * Source : Unified
   * Context : Returns the action to perform for internal (support) authentication
   * Returns the SAML SSO URL used to redirect the user to Azure Entra ID for authentication.
   */
  internalLoginAction: LoginAction;
  isLoyaltyEligible: Scalars['Boolean']['output'];
  /**
   * Allowing to return the last company used for the current user if active
   * If the status on the client link has been inactived, we can return another user account only if there is only 1 available user account
   * from the currentUserAccounts(active), otherwise if there is more than 1 result, lastUserAccount return null
   */
  lastUserAccount?: Maybe<User>;
  /**
   * Source : MS User / IAM
   * Context : verify the user email, and return the login action to do (ie: LOGIN, CREATE_ACCOUNT, CREATE_PASSWORD)
   */
  loginAction: LoginAction;
  /** Get a list of marketing events to display on the HP or checkout confirmation order page, or on a category page */
  marketingCards?: Maybe<Array<Maybe<EventCard>>>;
  marketingProducts?: Maybe<Array<EventProducts>>;
  /** M2 returns the menu entries */
  menu?: Maybe<Array<MenuEntry>>;
  /** Generate a URL to define or reset password for specified customer. */
  passwordRedirectUrl: Scalars['String']['output'];
  persistentCustomerCart?: Maybe<PersistentCart>;
  /**
   * Source : MS Agency
   * Context : get a point of sale by id
   */
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleWithDistanceInvoice?: Maybe<Array<PointOfSale>>;
  /**
   * Source : MS Agency
   * Context : get a list of points of sale
   * The input is not required and allows filtering, pagination, and sorting.
   * Available filter fields :
   * * postalCode
   * * subsidiaryId
   */
  pointsOfSale: PointOfSalePagination;
  /** M2 + MS : returns the matching product for the given urlKey */
  product?: Maybe<Product>;
  productAnomalies?: Maybe<Array<ProductAnomaly>>;
  /** M2 + MS : returns the matching product for the given reference */
  productByReference?: Maybe<Product>;
  productsByReferences?: Maybe<Array<Product>>;
  /** Get the list of activities and associated specialities for the DOC registration, for a given website */
  professionActivities?: Maybe<Array<Maybe<ProfessionActivity>>>;
  /** Get a detail of a speciality for the DOC registration */
  professionActivitySpeciality: ProfessionActivitySpeciality;
  registrationAction: RegistrationAction;
  /** Return the given IAM URL allowing the user to reset its password. */
  resetPasswordUrl: Scalars['String']['output'];
  search?: Maybe<Search>;
  searchAddresses: Array<ServiceAddress>;
  searchCities: Array<ServiceCity>;
  /**
   * Source : MS
   * Context : Only for internal collaborators (currentInternalUser is not null), allow to search companies by company name or siret
   * Depending of the internal collaborators rights
   * Available filter fields :
   * * accountNumber
   * * name
   */
  searchCompanies: CompanyPagination;
  searchList?: Maybe<SearchList>;
  /**
   * Source : MS
   * Context : Only for internal collaborators (currentInternalUser is not null), allow to search users by company id
   * Depending of the internal collaborators rights
   * Available filter fields :
   * * companyId
   * * email
   * * search
   * * role
   * Available sort field :
   * * firstname
   * * email
   */
  searchUsers: UserPagination;
  session?: Maybe<Session>;
  shareUserList?: Maybe<Array<UserPartialInfos>>;
  technicalCartByMaskedId?: Maybe<TechnicalCart>;
  /** M2 get the entity url_key */
  urlKey: Scalars['String']['output'];
  validateEmail?: Maybe<MailgunValidateEmail>;
  validateStoreCompany: ValidateStoreCompanyResponse;
};


export type QueryCms_PageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  select?: InputMaybe<Scalars['Boolean']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCms_PagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Scalars['Boolean']['input']>;
  select?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Cms_Page_Where>;
};


export type QueryCms_ReassuranceCardArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  select?: InputMaybe<Scalars['Boolean']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCms_ReassuranceCardsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Scalars['Boolean']['input']>;
  select?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Cms_ReassuranceCard_Where>;
};


export type QueryCms_SeoCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Scalars['Boolean']['input']>;
  select?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Cms_SeoCategory_Where>;
};


export type QueryCms_SeoCategoryArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  select?: InputMaybe<Scalars['Boolean']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCms_TenantsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Scalars['Boolean']['input']>;
  select?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  trash?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Cms_Tenant_Where>;
};


export type QueryArticlesByReferencesArgs = {
  references: Array<Scalars['String']['input']>;
};


export type QueryAvailablePointsOfSaleInventoryArgs = {
  reference: Scalars['String']['input'];
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandArgs = {
  urlKey: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  filterSubCats?: InputMaybe<Scalars['Boolean']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryBreadcrumbArgs = {
  filter?: InputMaybe<CategoryBreadcrumbArg>;
};


export type QueryCmsPageArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyNationalIdDataArgs = {
  companyNationalId: Scalars['String']['input'];
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
};


export type QueryCurrentUserAccountsArgs = {
  status?: InputMaybe<UserStatus>;
};


export type QueryCustomerCartArgs = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEcomUrlArgs = {
  distributionNetwork: Scalars['String']['input'];
};


export type QueryEquivalentProductConfigArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryEventArgs = {
  urlKey: Scalars['String']['input'];
};


export type QueryIsLoyaltyEligibleArgs = {
  email: Scalars['String']['input'];
  siret: Scalars['String']['input'];
};


export type QueryLoginActionArgs = {
  email: Scalars['Email']['input'];
};


export type QueryMarketingCardsArgs = {
  type?: InputMaybe<EventPageType>;
};


export type QueryMarketingProductsArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventCrossType>;
};


export type QueryPasswordRedirectUrlArgs = {
  email: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPointOfSaleArgs = {
  pointOfSaleId: Scalars['String']['input'];
};


export type QueryPointOfSaleWithDistanceInvoiceArgs = {
  companyNationalId: Scalars['String']['input'];
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPointsOfSaleArgs = {
  input?: InputMaybe<Browsing>;
};


export type QueryProductArgs = {
  urlKey: Scalars['String']['input'];
};


export type QueryProductByReferenceArgs = {
  reference: Scalars['String']['input'];
};


export type QueryProductsByReferencesArgs = {
  references: Array<Scalars['String']['input']>;
};


export type QueryProfessionActivitySpecialityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRegistrationActionArgs = {
  companyNationalId: Scalars['String']['input'];
  isoCountryCode3?: InputMaybe<Scalars['IsoCountryCode3']['input']>;
};


export type QueryResetPasswordUrlArgs = {
  email: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchAddressesArgs = {
  input: ServiceAddressInput;
};


export type QuerySearchCitiesArgs = {
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
  postalCode: Scalars['String']['input'];
};


export type QuerySearchCompaniesArgs = {
  input: Browsing;
};


export type QuerySearchListArgs = {
  search: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  input: Browsing;
};


export type QueryShareUserListArgs = {
  type: SharingType;
};


export type QueryUrlKeyArgs = {
  code: Scalars['String']['input'];
  entity: TypeEntity;
};


export type QueryValidateEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateStoreCompanyArgs = {
  companyNationalId: Scalars['String']['input'];
  externalClientId: Scalars['String']['input'];
};

/**
 * Source front
 * Allow to add/update product in the quick order wishlist
 */
export type QuickOrderInput_V2 = {
  /** List of product to add (when no id specified) or update */
  products?: InputMaybe<Array<WishlistProductInput_V2>>;
};

/** Source : Mesh OnPrem */
export type Quote = {
  __typename?: 'Quote';
  addresses?: Maybe<Array<QuoteAddress>>;
  /** Can share Quote? */
  canShareQuote: Scalars['Boolean']['output'];
  /** Salesperson's Note */
  comment?: Maybe<Array<QuoteComment>>;
  commercialName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  expiredAt: Scalars['Date']['output'];
  /**
   * A specific product is a product with is_procurage=1, which is not sold on the site (= outside the convergence scope)
   * Return true if at least one product is not sold on the site (in products at least one QuoteProduct.product is null)
   */
  hasSpecificProduct?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  /** Actions on quote */
  management?: Maybe<QuoteManagement>;
  orderId?: Maybe<Scalars['String']['output']>;
  pointOfSale: PointOfSale;
  pointOfSaleId?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<QuoteProduct>>;
  /** The quote reference provided by the customer when requesting a quote or receiving an immediate quote on the site */
  ref?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  totalExcludingTax: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

/**
 * Source : Mesh OnPrem
 * Address from quote : delivery (shipping) and billing (invoice) address
 */
export type QuoteAddress = {
  __typename?: 'QuoteAddress';
  city?: Maybe<Scalars['String']['output']>;
  isoCountryCode?: Maybe<Scalars['IsoCountryCode2']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Type of the address from enum */
  type: UserCompanyAddressType;
};

export type QuoteApproveInput = {
  chorusData?: InputMaybe<ChorusDataInput>;
  id: QuoteIdInput;
};

/**
 * Comment quote
 * The salesperson's note is displayed in the quote, at header or footer
 */
export type QuoteComment = {
  __typename?: 'QuoteComment';
  comment: Scalars['String']['output'];
  level: QuoteCommentLevel;
};

/** Position to display the comment in quote */
export enum QuoteCommentLevel {
  Footer = 'FOOTER',
  Header = 'HEADER'
}

export type QuoteDeclineInput = {
  declineReason: QuoteDeclineReasonInput;
  id: QuoteIdInput;
};

export enum QuoteDeclineReason {
  /**  Canceled  */
  An = 'AN',
  /**  More satisfactory competition proposal  */
  Cc = 'CC',
  /**  Reported  */
  Cl = 'CL',
  /**  Packaging not accepted  */
  Co = 'CO',
  /**  Delivery time too long  */
  De = 'DE',
  /**  Quote received too late  */
  En = 'EN',
  /**  Offer does not meet my needs  */
  In = 'IN',
  /**  Item not available in stock  */
  Nd = 'ND',
  /**  Unsatisfactory pricing  */
  Pr = 'PR'
}

export type QuoteDeclineReasonInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: QuoteDeclineReason;
};

export type QuoteIdInput = {
  id: Scalars['String']['input'];
  pointOfSaleId: Scalars['String']['input'];
};

/** Quote management */
export type QuoteManagement = {
  __typename?: 'QuoteManagement';
  approveNotAllowedReason?: Maybe<QuoteManagementNotAllowedReason>;
  canBeApproved: Scalars['Boolean']['output'];
  canBeRenewed: Scalars['Boolean']['output'];
  canBeShared: Scalars['Boolean']['output'];
  renewedNotAllowedReason?: Maybe<QuoteManagementNotAllowedReason>;
  sharedNotAllowedReason?: Maybe<QuoteManagementNotAllowedReason>;
};

/** Quote management reason why quote cannot be approved */
export enum QuoteManagementNotAllowedReason {
  ApprovalFlowLimitation = 'APPROVAL_FLOW_LIMITATION',
  CompanyForbidden = 'COMPANY_FORBIDDEN',
  ErpNotOpened = 'ERP_NOT_OPENED',
  StatusNotAllowed = 'STATUS_NOT_ALLOWED'
}

/** Source : Mesh OnPrem */
export type QuotePagination = {
  __typename?: 'QuotePagination';
  items: Array<Quote>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * Source : Mesh OnPrem
 * Product from quote
 */
export type QuoteProduct = {
  __typename?: 'QuoteProduct';
  /** Product brand, coming from ERP (skuBrand) */
  brand?: Maybe<Scalars['String']['output']>;
  /** Product comment */
  comment?: Maybe<Array<Scalars['String']['output']>>;
  conditionning?: Maybe<Scalars['String']['output']>;
  conditionningType?: Maybe<Scalars['String']['output']>;
  /** Line number */
  lineNum: Scalars['String']['output'];
  /** Product name, coming from ERP (name) */
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  /** Conditioning, coming from ERP */
  packaging?: Maybe<ProductPackaging>;
  /** Price excluding tax */
  priceExcludingTax?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  /** Quantity requested */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Codag reference, coming from ERP */
  reference?: Maybe<Scalars['String']['output']>;
  /** Total excluding tax */
  totalExcludingTax?: Maybe<Scalars['Float']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type QuoteShareInput = {
  email: Array<Scalars['Email']['input']>;
  id: QuoteIdInput;
};

/**
 * Source Mesh Onprem
 * Quote status
 */
export enum QuoteStatus {
  /** Annulé */
  An = 'AN',
  /** Commandé */
  Co = 'CO',
  /** Partiellement commandé */
  Cp = 'CP',
  /** Délai dépassé */
  Dp = 'DP',
  /** Envoyé */
  En = 'EN'
}

/**
 * Source M2
 * Update a quote to add/update/delete products
 */
export type QuoteUpdateInput_V2 = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of product to add (when no id specified) or update */
  products?: InputMaybe<Array<WishlistProductInput_V2>>;
};

export type ReOrderedProduct = {
  __typename?: 'ReOrderedProduct';
  productReference: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type ReOrderedProducts = {
  __typename?: 'ReOrderedProducts';
  addedProducts: Array<ReOrderedProduct>;
  unavailableProducts: Array<ReOrderedProduct>;
};

export type ReferencePriceStock = {
  products?: InputMaybe<Array<InputMaybe<ReferencePriceStockProduct>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reference: Scalars['String']['input'];
  typeStock?: InputMaybe<PriceStockRequest_Article_TypeStock>;
};

export type ReferencePriceStockProduct = {
  codags?: InputMaybe<Array<Scalars['String']['input']>>;
  codep?: InputMaybe<Scalars['String']['input']>;
};

export enum RegistrationAction {
  ClassicDoc = 'CLASSIC_DOC',
  Doa = 'DOA',
  ExpressDoc = 'EXPRESS_DOC'
}

/** M2 (direct call to search/ajax/suggest/?q={searchTerm}) */
export type Search = {
  __typename?: 'Search';
  /** M2 (internally completed with FH) */
  brands?: Maybe<Array<Brand>>;
  /** M2 (internally completed with FH) */
  categories?: Maybe<Array<Category>>;
  /** M2: single product result from search term used as exact match on reference */
  product?: Maybe<Product>;
  /** M2 (internally completed with FH) */
  products?: Maybe<Array<Product>>;
  /** M2 (internally completed with FH) */
  suggestions?: Maybe<Array<Suggestion>>;
  /** M2 automatically redirect based on search term (ex: acier) */
  targetUrl?: Maybe<Scalars['URL']['output']>;
};

export type SearchList = {
  __typename?: 'SearchList';
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  categories?: Maybe<Array<Category>>;
  productList?: Maybe<ProductList>;
  search?: Maybe<Scalars['String']['output']>;
};


export type SearchListProductListArgs = {
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceAddress = {
  __typename?: 'ServiceAddress';
  city: Scalars['String']['output'];
  cityId: Scalars['String']['output'];
  isoCountryCode3: Scalars['IsoCountryCode3']['output'];
  /** Latitude of the center of the city */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude of the center of the city */
  longitude?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  streetId: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  streetType: Scalars['String']['output'];
};

export type ServiceAddressInput = {
  address: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
};

export type ServiceCity = {
  __typename?: 'ServiceCity';
  cityId: Scalars['String']['output'];
  isoCountryCode3: Scalars['IsoCountryCode3']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  /** Available point of sales (MS agency : show_agency_to_client), depends of the attached company of the user (pointOfSale : parentId) */
  availablePointsOfSale?: Maybe<Array<PointOfSale>>;
  /**
   * Source: MS + M2
   * Available point of sales for pickup shop (MS agency : show_agency_to_client),
   * depends of the config pickup scope
   */
  availablePointsOfSalePickup?: Maybe<Array<PointOfSale>>;
  /**
   * Informations related to Billtrust.
   * Contains the SSO link to access Billtrust
   */
  billtrust: Billtrust;
  /** Three-step process enabling the customer to place and complete an order */
  checkout?: Maybe<Checkout>;
  /** A user can edit only one quote at a time before submitting it */
  currentQuote?: Maybe<Wishlist>;
  /**
   * For DOA analytics purpose only
   * is null if not on currentUser, currentUser is not the MANAGER or if it's firstLogin of user
   * otherwise return type of DOA depending on ms-client.created_from
   */
  firstLoginManagerOrigin?: Maybe<FirstLoginOriginAnalytics>;
  /** Is user just defined or reset his password */
  hasPasswordChanged: Scalars['Boolean']['output'];
  /** Display or not an icon when quotation feature is enabled and connected user has at least one quotation */
  hasProcessingQuotes: Scalars['Boolean']['output'];
  /** Determined depending on type of jwt token used for auth: classic, impersonate, punchout... */
  loginType: LoginType;
  /** Mesh Saas : Return the loyalty data and status for the user, service Rhinos */
  loyalty: Loyalty;
  /**
   * Return the approver's order request for a given web shop reference.
   * resetData parameter is used to reset the data when the user refreshes the page or discards their changes,
   * so that we can get the latest data from MS.
   * Note : The approver's order requests are fetched from M2.
   * Source : M2
   */
  orderRequestToApprove?: Maybe<OrderRequestToApprove>;
  /**
   * MS Order
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * Each query to the orderRequests entry point will be filtered by current user to match approvee ID
   * if "approver" filter is set to false or not present, or to match approver ID if set to true.
   * Available filter fields :
   * * approvee (id to match the approvee ID)
   * * approver (true/false)
   * * inputRef (will match either internalRef or webRef)
   * * since ('LAST_7_DAYS', 'LAST_30_DAYS', or 'LAST_3_MONTHS')
   * * webRef
   * Available sort field :
   * * internalRef
   * * orderDate
   * * price (contains the subtotal price VAT exclusive + ecopart + shipping fee)
   * * webRef
   */
  orderRequests: OrderPagination;
  /**
   * MS Order
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * Each query to the orders entry point will be filtered by the client ID of the current user.
   * If user has rights it will return all company orders
   * Available filter fields :
   * * inputSearch (will match either internalRef, webRef or buyer's name)
   * * orderNumber (set by MROD, used to search a specific 'STORE' type order)
   * * orderType ('STORE' or 'ECOMMERCE', default is 'ECOMMERCE' if invalid value or not specified)
   * * since ('LAST_30_DAYS', 'LAST_3_MONTHS', 'LAST_6_MONTHS', 'THIS_YEAR', 'YEAR_MINUS_1', 'YEAR_MINUS_2' or 'YEAR_MINUS_3')
   * * status
   * * webRef
   * Available sort field :
   * * buyer
   * * internalRef
   * * orderDate
   * * price (contains the subtotal price VAT exclusive + ecopart + shipping fee)
   * * webRef
   */
  orders: OrderPagination;
  permissions?: Maybe<CollaboratorPermissions>;
  /** Punchout session namespace: the simplified cart used when the buyer comes from his ERP */
  punchout: Punchout;
  /**
   * Source : M2
   * Quick order is a special wishlist (wishlist_type = 1 in M2)
   * We can filtered the wishlist products by productFirstLevelCategory
   */
  quickOrderList: Wishlist;
  /** Primary data of user like names, email, phone. Depend on user and not session state */
  user: User;
  /**
   * Source : M2
   * The input is not required and allows searching, filtering, pagination, and sorting
   * Return the user's wishlists
   * products are ordered by codag ASC
   * Available filter fields :
   * * id
   * * productFirstLevelCategory (only if filter id is provided)
   * Available sort field :
   * * createdAt
   * * name
   */
  wishlists: WishlistPagination;
};


export type SessionAvailablePointsOfSaleArgs = {
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type SessionAvailablePointsOfSalePickupArgs = {
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type SessionOrderRequestToApproveArgs = {
  resetData?: InputMaybe<Scalars['Boolean']['input']>;
  webRef: Scalars['String']['input'];
};


export type SessionOrderRequestsArgs = {
  input?: InputMaybe<Browsing>;
};


export type SessionOrdersArgs = {
  input?: InputMaybe<Browsing>;
};


export type SessionQuickOrderListArgs = {
  firstLevelCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


export type SessionWishlistsArgs = {
  input?: InputMaybe<Browsing>;
};

export type SetAdditionalOrderInfoInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  chorusData?: InputMaybe<ChorusDataInput>;
};

export type SetPaymentMethodOnCartInput = {
  cartId: Scalars['String']['input'];
  paymentMethod: PaymentMethodInput;
};

export type SetShippingAddressesOnCartInput = {
  cartId: Scalars['String']['input'];
  customerAddressId: Scalars['ID']['input'];
};

export type SetShippingDeliveryContactInfoInput = {
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
};

export type SetShippingDeliveryInstructionsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type SetShippingMethodOnCartInput = {
  cartId: Scalars['String']['input'];
  methodCode: Scalars['String']['input'];
};

export enum SharingType {
  Quote = 'QUOTE',
  Wishlist = 'WISHLIST'
}

export type Shipping = {
  __typename?: 'Shipping';
  address?: Maybe<CartAddress>;
  availableMethods?: Maybe<ShippingAvailableMethods>;
  availablePointsOfSale?: Maybe<Array<PointOfSale>>;
  /**
   * Contains true if user can choose a delivery date
   * Source : M2
   */
  canRequestDeliveryDate: Scalars['Boolean']['output'];
  carrierCode?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Delivery>;
  fee?: Maybe<ShippingFee>;
  /**
   * True if all conditions are met to use the clickAndCollect method
   * source: MS-PriceStock
   */
  isClickAndCollectAvailable: Scalars['Boolean']['output'];
  methodCode?: Maybe<Scalars['String']['output']>;
};


export type ShippingAvailablePointsOfSaleArgs = {
  forceStorePickup?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Dictionary of shipping methods */
export type ShippingAvailableMethods = {
  __typename?: 'ShippingAvailableMethods';
  clickAndCollect?: Maybe<ShippingMethodClickAndCollect>;
  onsiteDelivery?: Maybe<ShippingMethodOnsiteDelivery>;
  storePickup?: Maybe<ShippingMethodStorePickup>;
};

/** list of available shipping delays from the logistics platform */
export enum ShippingDelay {
  Days_3To_5 = 'DAYS_3_TO_5',
  Hours_24To_48 = 'HOURS_24_TO_48',
  Unknown = 'UNKNOWN',
  Weeks_4 = 'WEEKS_4'
}

export type ShippingFee = ShippingFeeFree | ShippingFeeWithAmount;

export type ShippingFeeFree = {
  __typename?: 'ShippingFeeFree';
  isFranco?: Maybe<Scalars['Boolean']['output']>;
};

export type ShippingFeeWithAmount = {
  __typename?: 'ShippingFeeWithAmount';
  amount: Scalars['Float']['output'];
};

export type ShippingMethodClickAndCollect = {
  __typename?: 'ShippingMethodClickAndCollect';
  /**
   * Null if cart has partial C&C
   * Source: M2
   */
  code?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<ShippingFeeFree>;
  status?: Maybe<ShippingMethodStatus>;
};

export type ShippingMethodOnsiteDelivery = {
  __typename?: 'ShippingMethodOnsiteDelivery';
  code: Scalars['String']['output'];
  fee?: Maybe<ShippingFee>;
  status?: Maybe<ShippingMethodStatus>;
};

export enum ShippingMethodStatus {
  Disabled = 'DISABLED',
  On = 'ON',
  Readonly = 'READONLY'
}

export type ShippingMethodStorePickup = {
  __typename?: 'ShippingMethodStorePickup';
  /**
   * Null if user has to change point of sale
   * Source: M2
   */
  code?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<ShippingFeeFree>;
  status?: Maybe<ShippingMethodStatus>;
};

/**
 * Source : Mesh MS
 * Context : Values used for the 'since' filter on orders and order requests (see pagination helpers for details about allowed values in each)
 */
export enum SinceValue {
  Last_3Months = 'LAST_3_MONTHS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  ThisYear = 'THIS_YEAR',
  YearMinus_1 = 'YEAR_MINUS_1',
  YearMinus_2 = 'YEAR_MINUS_2',
  YearMinus_3 = 'YEAR_MINUS_3'
}

/** Defines sorting criteria including the field to sort by and the direction. */
export type Sort = {
  /** Sorting direction (ascending or descending). */
  direction?: InputMaybe<Direction>;
  /** Field to apply sorting on. */
  field: Scalars['String']['input'];
};

export type StockInfo = {
  __typename?: 'StockInfo';
  canExpressCollectLocal?: Maybe<Scalars['Boolean']['output']>;
  conditioning?: Maybe<Scalars['Float']['output']>;
  isInRestockStatus?: Maybe<Scalars['Boolean']['output']>;
  lennieProdex: Scalars['Boolean']['output'];
  prodex: Scalars['Boolean']['output'];
  productRestockStatusLivre: Scalars['String']['output'];
  productRestockStatusLocal: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  stockLivre?: Maybe<Scalars['Int']['output']>;
  stockLocal?: Maybe<Scalars['Int']['output']>;
  stockReferenceLivre?: Maybe<Scalars['Float']['output']>;
  stockReferenceLocal?: Maybe<Scalars['Float']['output']>;
  storeStockPlan: Scalars['Boolean']['output'];
  subscribeToPlatform: Scalars['Boolean']['output'];
};

export type StoreCompany = {
  __typename?: 'StoreCompany';
  clientIdExternal?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientStatusCode?: Maybe<Scalars['String']['output']>;
  companyNationalId?: Maybe<Scalars['String']['output']>;
  pointOfSaleId?: Maybe<Scalars['String']['output']>;
  pointOfSaleName?: Maybe<Scalars['String']['output']>;
  subsidiaryId?: Maybe<Scalars['String']['output']>;
};

/**
 * Source : MS Client
 * Context : subsidiary of the company
 */
export type Subsidiary = {
  __typename?: 'Subsidiary';
  /** In the header, we found this id in the x-subsidiary-id header */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** French SIRET : we found this id in MS Client: national_client_id_number */
  siret: Scalars['String']['output'];
};

/** FH */
export type Suggestion = {
  __typename?: 'Suggestion';
  label: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

/**
 * Context : List of displayable tags for a product card (carousel + product list). Only one tag can be applied to a product.
 * Source : MS Price & Stock
 */
export enum Tag {
  Bundle = 'BUNDLE',
  /** Product is not produced anymore, getting rid of the remaining stock */
  Clearance = 'CLEARANCE',
  /** Product is available through click & collect */
  ClickAndCollect = 'CLICK_AND_COLLECT',
  CustomerAgreement = 'CUSTOMER_AGREEMENT',
  CustomPrice = 'CUSTOM_PRICE',
  Damaged = 'DAMAGED',
  /** The product includes a discount for loyal customers */
  Loyalty = 'LOYALTY',
  Manual = 'MANUAL',
  /** Product price is specific to the connected client */
  MarketPrice = 'MARKET_PRICE',
  Other = 'OTHER',
  PriceMatch = 'PRICE_MATCH',
  /** TAGS DCNL */
  Promotional = 'PROMOTIONAL',
  /** Decreasing price based on quantity added to cart */
  QuantitySale = 'QUANTITY_SALE',
  Rebate = 'REBATE',
  /** Product is refurbished and sold at a lower price */
  Refurbished = 'REFURBISHED',
  /** Product is REFURBISHED_GRADE_A and sold at a lower price */
  RefurbishedGradeA = 'REFURBISHED_GRADE_A',
  /** Product is REFURBISHED_GRADE_B and sold at a lower price */
  RefurbishedGradeB = 'REFURBISHED_GRADE_B',
  /** Product is REFURBISHED_GRADE_C and sold at a lower price */
  RefurbishedGradeC = 'REFURBISHED_GRADE_C',
  /** Basic discount with lower price than default */
  Sale = 'SALE',
  Sample = 'SAMPLE',
  Seasonal = 'SEASONAL',
  TierPricing = 'TIER_PRICING',
  Volume = 'VOLUME',
  /** Discount price from coupon code or universal promotions in cart */
  WebSale = 'WEB_SALE'
}

/** Light version of the type Cart : it only contains restricted data since the query only requires a cart masked id without any other authentification. This type is mostly used to get data for the IPN request */
export type TechnicalCart = {
  __typename?: 'TechnicalCart';
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']['output'];
  /**
   * Id shop delivery from session shop
   * Source: MS-Price-Stock
   */
  shop_id?: Maybe<Scalars['String']['output']>;
};

/** M2 product attribute */
export type TechnicalSpec = {
  __typename?: 'TechnicalSpec';
  label?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['String']['output']>;
  rawUnit?: Maybe<Scalars['String']['output']>;
  rawValues?: Maybe<Array<Scalars['String']['output']>>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TierPrice = {
  __typename?: 'TierPrice';
  exclTax?: Maybe<Scalars['Float']['output']>;
  inclTax?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Token = {
  __typename?: 'Token';
  maxAge?: Maybe<Scalars['Int']['output']>;
  type: TokenType;
  value: Scalars['String']['output'];
};

export enum TokenType {
  Auth = 'AUTH',
  ImpersonateAuth = 'IMPERSONATE_AUTH',
  InternalAuth = 'INTERNAL_AUTH',
  Punchout = 'PUNCHOUT',
  Refresh = 'REFRESH'
}

export type TopPurchase = {
  __typename?: 'TopPurchase';
  products?: Maybe<Array<Product>>;
};

export type TopPurchaseProduct = {
  __typename?: 'TopPurchaseProduct';
  lastOrderDate?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  totalQty?: Maybe<Scalars['String']['output']>;
};

export type TopPurchaseResponse = {
  __typename?: 'TopPurchaseResponse';
  products?: Maybe<Array<Maybe<TopPurchaseProduct>>>;
};

export enum TypeEntity {
  Category = 'CATEGORY',
  Product = 'PRODUCT'
}

/**
 * Source : MS Catalog + INTL format
 * Context : Available values for product packaging unit.
 */
export enum Unit {
  Bb = 'BB',
  Bk = 'BK',
  Bl = 'BL',
  Bo = 'BO',
  Cm = 'CM',
  Ds = 'DS',
  Dz = 'DZ',
  Em = 'EM',
  Et = 'ET',
  Fl = 'FL',
  G = 'G',
  Ga = 'GA',
  K = 'K',
  Ka = 'KA',
  Kg = 'KG',
  Kgs = 'KGS',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Kt = 'KT',
  Ku = 'KU',
  L = 'L',
  Lg = 'LG',
  Lt = 'LT',
  /** M value is duplicated, it will be used in FR and INTL products */
  M = 'M',
  M2 = 'M2',
  Mp = 'MP',
  Od = 'OD',
  P = 'P',
  Pa = 'PA',
  Pd = 'PD',
  Pk = 'PK',
  Pt = 'PT',
  Py = 'PY',
  Rep = 'REP',
  Rl = 'RL',
  S = 'S',
  Se = 'SE',
  Sl = 'SL',
  St = 'ST',
  Tr = 'TR',
  Un = 'UN',
  Va = 'VA',
  Vl = 'VL',
  Vp = 'VP',
  Za = 'ZA'
}

export type UpdateEmailPreferenceInput = {
  emailPreferences?: InputMaybe<Array<InputMaybe<EmailPreferenceInput>>>;
};

export type UpdatePreferredAddress_Input = {
  addressId: Scalars['String']['input'];
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  Category = 'CATEGORY',
  CmsPage = 'CMS_PAGE',
  Custom = 'CUSTOM',
  Product = 'PRODUCT'
}

/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type User = {
  __typename?: 'User';
  /** @deprecated 2026-13|Use session.availablePointsOfSale instead */
  availablePointsOfSale?: Maybe<Array<PointOfSale>>;
  /** @deprecated 2026-13|Use session.availablePointsOfSalePickup instead */
  availablePointsOfSalePickup?: Maybe<Array<PointOfSale>>;
  /**
   * Informations related to Billtrust.
   * Contains the SSO link to access Billtrust
   * @deprecated 2026-13|Use session.billtrust instead
   */
  billtrust: Billtrust;
  /** Mesh Ms: Does the currentUser has rights to delete this user */
  canBeDeleted: Scalars['Boolean']['output'];
  /** Mesh Ms: Does the currentUser has rights to edit this user */
  canBeEdited: Scalars['Boolean']['output'];
  /** @deprecated 2026-13|Use session.checkout instead */
  checkout?: Maybe<Checkout>;
  /** MS Client : company (client) of the user */
  company?: Maybe<Company>;
  /**
   * A user can edit only one quote at a time before submitting it
   * @deprecated 2026-13|Use session.currentQuote instead
   */
  currentQuote?: Maybe<Wishlist>;
  /** Source : MS */
  distributionNetwork: Scalars['String']['output'];
  /** MS User */
  email?: Maybe<Scalars['Email']['output']>;
  /**
   * Source MS
   * Context : Email preferences of the user - if EmailPreference exists, the user does not accept to receive email
   */
  emailPreferences?: Maybe<Array<Maybe<EmailPreference>>>;
  /** MS User : favorite billing address of the user */
  favoriteBillingAddress?: Maybe<UserCompanyAddress>;
  favoritePointOfSale?: Maybe<PointOfSale>;
  favoritePointOfSaleId?: Maybe<Scalars['String']['output']>;
  /** MS User : favorite shipping address of the user */
  favoriteShippingAddress?: Maybe<UserCompanyAddress>;
  firstLogin?: Maybe<Scalars['DateTime']['output']>;
  /**
   * For DOA analytics purpose only
   * is null if not on currentUser, currentUSer is not the MANAGER or if it's firstLogin of user
   * otherwise return type of DOA depending on ms-client.created_from
   * @deprecated 2026-13|Use session.firstLoginManagerOrigin instead
   */
  firstLoginManagerOrigin?: Maybe<FirstLoginOriginAnalytics>;
  firstLoginMobile?: Maybe<Scalars['DateTime']['output']>;
  /** MS User */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   * Is user just defined or reset his password
   * @deprecated 2026-13|Use session.hasPasswordChanged instead
   */
  hasPasswordChanged: Scalars['Boolean']['output'];
  /**
   * Display or not an icon when quotation feature is enabled and connected user has at least one quotation
   * @deprecated 2026-13|Use session.hasProcessingQuotes instead
   */
  hasProcessingQuotes: Scalars['Boolean']['output'];
  hasTermsAndConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** MS User : ClientLink : id : it's the ID that links the user to the company */
  id: Scalars['String']['output'];
  /** Indicates if the user is subject or not to an approval flow (i.e. he is engaged in a purchase request process) */
  isSubjectToApprovalFlow: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastLoginMobile?: Maybe<Scalars['DateTime']['output']>;
  /** MS User */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   * Determined depending on type of jwt token used for auth: classic, impersonate, punchout...
   * @deprecated 2026-13|Use session.loginType instead
   */
  loginType: LoginType;
  /**
   * Mesh Saas : Return the loyalty data and status for the user, service Rhinos
   * @deprecated 2026-13|Use session.loyalty instead
   */
  loyalty: Loyalty;
  mobileVerified?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Return the approver's order request for a given web shop reference.
   * resetData parameter is used to reset the data when the user refreshes the page or discards their changes,
   * so that we can get the latest data from MS.
   * Note : The approver's order requests are fetched from M2.
   * Source : M2
   * @deprecated 2026-13|Use session.orderRequestToApprove instead
   */
  orderRequestToApprove?: Maybe<OrderRequestToApprove>;
  /**
   * MS Order
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * Each query to the orderRequests entry point will be filtered by current user to match approvee ID
   * if "approver" filter is set to false or not present, or to match approver ID if set to true.
   * Available filter fields :
   * * approvee (id to match the approvee ID)
   * * approver (true/false)
   * * inputRef (will match either internalRef or webRef)
   * * since ('LAST_7_DAYS', 'LAST_30_DAYS', or 'LAST_3_MONTHS')
   * * webRef
   * Available sort field :
   * * internalRef
   * * orderDate
   * * price (contains the subtotal price VAT exclusive + ecopart + shipping fee)
   * * webRef
   * @deprecated 2026-13|Use session.orderRequests instead
   */
  orderRequests: OrderPagination;
  /**
   * MS Order
   * The input is not required and allows searching, filtering, pagination, and sorting.
   * Each query to the orders entry point will be filtered by the client ID of the current user.
   * If user has rights it will return all company orders
   * Available filter fields :
   * * inputSearch (will match either internalRef, webRef or buyer's name)
   * * orderNumber (set by MROD, used to search a specific 'STORE' type order)
   * * orderType ('STORE' or 'ECOMMERCE', default is 'ECOMMERCE' if invalid value or not specified)
   * * since ('LAST_30_DAYS', 'LAST_3_MONTHS', 'LAST_6_MONTHS', 'THIS_YEAR', 'YEAR_MINUS_1', 'YEAR_MINUS_2' or 'YEAR_MINUS_3')
   * * status
   * * webRef
   * Available sort field :
   * * buyer
   * * internalRef
   * * orderDate
   * * price (contains the subtotal price VAT exclusive + ecopart + shipping fee)
   * * webRef
   * @deprecated 2026-13|Use session.orders instead
   */
  orders: OrderPagination;
  /** @deprecated 2026-13|Use session.permissions instead */
  permissions?: Maybe<CollaboratorPermissions>;
  /** MS User */
  phone?: Maybe<Scalars['Phone']['output']>;
  pointOfSaleId?: Maybe<Scalars['String']['output']>;
  /** @deprecated 2026-13|Use session.punchout instead */
  punchout: Punchout;
  /**
   * Source : M2
   * Quick order is a special wishlist (wishlist_type = 1 in M2)
   * We can filtered the wishlist products by productFirstLevelCategory
   * @deprecated 2026-13|Use session.quickOrderList instead
   */
  quickOrderList: Wishlist;
  /**
   * Source : M2
   * Reorder is a special wishlist (wishlist_type = 2 in M2)
   * We can filtered the wishlist products by productFirstLevelCategory
   */
  reOrderList: Wishlist;
  /** MS User : Client_link : user role for the current company selected */
  role?: Maybe<UserRole>;
  status: UserStatus;
  /**
   * Source : M2
   * The input is not required and allows searching, filtering, pagination, and sorting
   * Return the user's wishlists
   * products are ordered by codag ASC
   * Available filter fields :
   * * id
   * * productFirstLevelCategory (only if filter id is provided)
   * Available sort field :
   * * createdAt
   * * name
   * @deprecated 2026-13|Use session.wishlists instead
   */
  wishlists: WishlistPagination;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserAvailablePointsOfSaleArgs = {
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserAvailablePointsOfSalePickupArgs = {
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserOrderRequestToApproveArgs = {
  resetData?: InputMaybe<Scalars['Boolean']['input']>;
  webRef: Scalars['String']['input'];
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserOrderRequestsArgs = {
  input?: InputMaybe<Browsing>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserOrdersArgs = {
  input?: InputMaybe<Browsing>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserQuickOrderListArgs = {
  firstLevelCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserReOrderListArgs = {
  firstLevelCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


/** Source : M2 Customer / session Vérifier principe de pagination sur Orders */
export type UserWishlistsArgs = {
  input?: InputMaybe<Browsing>;
};

/** MS Client : address of the users share between all the users of the same company */
export type UserCompanyAddress = {
  __typename?: 'UserCompanyAddress';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isoCountryCode: Scalars['IsoCountryCode2']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  /** Is the primary address of the company, primary address could not be deleted */
  primary: Scalars['Boolean']['output'];
  /** Type of the address from enum */
  type: UserCompanyAddressType;
};

/** Input to add an Address or update an existing one to a company */
export type UserCompanyAddressInput = {
  city: Scalars['String']['input'];
  isoCountryCode: Scalars['IsoCountryCode2']['input'];
  latitude?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetId?: InputMaybe<Scalars['String']['input']>;
};

export enum UserCompanyAddressRequest_Type {
  Invoice = 'INVOICE',
  Main = 'MAIN',
  Shipping = 'SHIPPING'
}

/** Available types of the address for a company in MS Client (Invoice and Main can't be deleted or updated) */
export enum UserCompanyAddressType {
  Invoice = 'INVOICE',
  Main = 'MAIN',
  Shipping = 'SHIPPING'
}

/**
 * Source : Front
 * Context : Input to create the user
 */
export type UserCreateInput = {
  email: Scalars['Email']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phoneNumber: Scalars['Phone']['input'];
  role: UserRole;
};

export type UserInput = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  permissions: UserPermissionInput;
  role: UserRole;
};

/**
 * Represents the paginated result of users
 * Contains total pages, total size and the list of users
 */
export type UserPagination = {
  __typename?: 'UserPagination';
  /** Paginated list of users. */
  items: Array<User>;
  /** Total number of available pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** Total number of users matching the criteria. */
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

export type UserPartialInfos = {
  __typename?: 'UserPartialInfos';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
};

export type UserPermissionInput = {
  showCompanyOrders: Scalars['Boolean']['input'];
  showOrderHistory: Scalars['Boolean']['input'];
};

/**
 * Source : Mesh unified
 * Context : Return type of the mutation requestUserRegistration, allowing to know the next step to execute
 */
export type UserRegistrationRequestAction = {
  __typename?: 'UserRegistrationRequestAction';
  action?: Maybe<UserRegistrationRequestEnum>;
  company?: Maybe<Company>;
  email?: Maybe<Scalars['Email']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The possible actions to execute after the DOA registration request */
export enum UserRegistrationRequestEnum {
  IamPasswordPageUrl = 'IAM_PASSWORD_PAGE_URL',
  UserRegistrationRequestInProgressPageUrl = 'USER_REGISTRATION_REQUEST_IN_PROGRESS_PAGE_URL',
  UserRegistrationRequestSuccessPageUrl = 'USER_REGISTRATION_REQUEST_SUCCESS_PAGE_URL'
}

/**
 * Source : Front
 * Context : DOA form to register an user
 */
export type UserRegistrationRequestInput = {
  acceptTerms: Scalars['Boolean']['input'];
  clientIdExternal: Scalars['String']['input'];
  companyNationalId: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  loyaltySubscription?: InputMaybe<LoyaltySubscriptionInput>;
  phone: Scalars['Phone']['input'];
};

/**
 * Source : MS User ClientLink
 * Context : User role
 */
export enum UserRole {
  Admin = 'ADMIN',
  AdminDemo = 'ADMIN_DEMO',
  Buyer = 'BUYER',
  Demo = 'DEMO',
  Guest = 'GUEST',
  Manager = 'MANAGER'
}

/** If present, the role applies to 'userId' field */
export enum UserRoleInProcess {
  All = 'ALL',
  Approver = 'APPROVER',
  OrderRequester = 'ORDER_REQUESTER'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type UserUpdateInput = {
  emailPreferences?: InputMaybe<Array<InputMaybe<EmailPreferenceInput>>>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['Phone']['input']>;
  role?: InputMaybe<UserRole>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateStoreCompanyResponse = {
  __typename?: 'ValidateStoreCompanyResponse';
  company?: Maybe<Company>;
  isValid: Scalars['Boolean']['output'];
};

/**
 * A specialization of the ProductListFilterValue type, to be used for filter values that can be selected for filtering.
 * For instance, a specific color of the 'color' attribute of the products.
 * Sources: MS-Catalog, M2 (for category filters only)
 */
export type ValueFilter = {
  __typename?: 'ValueFilter';
  /** Whether this filter value is applied or not to the products collection of the ProductList entity it belongs to. */
  isActive: Scalars['Boolean']['output'];
  /** The link to use when this filter value is clicked, either a URL or a FH request to be sent to the server */
  link: Link;
  productCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/**
 * A specialization of the ProductListFilterValue type, to be used for filter values and optionally sub values.
 * For instance a category tree of an Event page, used to filter among the categories covered by an Event page products.
 * Sources: MS-Catalog, M2 (for category filters only)
 */
export type ValueLink = {
  __typename?: 'ValueLink';
  image?: Maybe<Image>;
  /** Whether this filter value is applied or not to the products collection of the ProductList entity it belongs to. */
  isActive: Scalars['Boolean']['output'];
  /** The link to use when this filter value is clicked, either a URL or a FH request to be sent to the server */
  link: Link;
  productCount: Scalars['Int']['output'];
  /** The human readable value */
  title: Scalars['String']['output'];
  /** Optionally a value can contain sub values */
  values?: Maybe<Array<ProductListFilterValue>>;
};

export type VatDetail = {
  __typename?: 'VatDetail';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

/**
 * Details about the web discount applied to the item.
 * Source: M2
 */
export type WebDiscount = {
  __typename?: 'WebDiscount';
  /** The amount of the web discount. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Indicates if the web discount is associated with a coupon. */
  hasCoupon?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the web discount. */
  label?: Maybe<Scalars['String']['output']>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  /** Date of creation for this wishlist */
  createdAt: Scalars['Date']['output'];
  /** Id of the wishlist */
  id: Scalars['Int']['output'];
  /** Name of wishlist (not unique) */
  name?: Maybe<Scalars['String']['output']>;
  /** Count of reference in the wishlist */
  productCount: Scalars['Int']['output'];
  /** List of product contained in this wishlist */
  products?: Maybe<Array<ProductWishlist>>;
  /** Total amount of all products in the wishlist */
  totalExclTax?: Maybe<Scalars['Float']['output']>;
};

export type WishlistCreateInput_V2 = {
  /**
   * When create wishlist from a copy from another, type of wishlist copied
   * Will be used to generate a name
   */
  from: WishlistOrigin;
  /**
   * Name of the wishlist
   * Required if from = WISHLIST
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of product to add in the wishlist */
  products?: InputMaybe<Array<WishlistProductInput_V2>>;
};

export enum WishlistOrigin {
  Cart = 'CART',
  QuickOrder = 'QUICK_ORDER',
  ReOrder = 'RE_ORDER',
  Wishlist = 'WISHLIST'
}

/**
 * Represents the paginated result of users
 * Contains total pages, total size and the list of wishlists, with products
 */
export type WishlistPagination = {
  __typename?: 'WishlistPagination';
  /** Paginated list of wishlist. */
  items: Array<Wishlist>;
  /** Total number of available pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** Total number of wishlist matching the criteria. */
  totalSize?: Maybe<Scalars['BigInt']['output']>;
};

export type WishlistProductInput_V2 = {
  /** Allows to delete attachment in specific product */
  attachmentToDelete?: InputMaybe<ProductAttachmentToDeleteInput>;
  /** Allows to add attachments in specific product */
  attachments?: InputMaybe<Array<ProductAttachmentInput>>;
  /** For specific products, allows to describe the product in a free text input */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Id of the item (used for update purpose) */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity for this product in the wishlist */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Reference for the product to add/update in the wishlist */
  reference: Scalars['String']['input'];
};

export type WishlistSharingInput = {
  /** Id of the wishlist to update */
  id: Scalars['Int']['input'];
  /** Ids of the company's user to share the wishlist with */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum WishlistType {
  Punchout = 'PUNCHOUT',
  QuickOrder = 'QUICK_ORDER',
  Quotation = 'QUOTATION',
  ReOrder = 'RE_ORDER',
  Wishlist = 'WISHLIST'
}

export type WishlistUpdateInput_V2 = {
  /** Id of the wishlist to update */
  id: Scalars['Int']['input'];
  /** New name if need to rename wishlist */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of product to add (when no id specified) or update */
  products?: InputMaybe<Array<WishlistProductInput_V2>>;
};

export type SiteConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', site?: { __typename?: 'ConfigSite', defaultCountryIso3: string } | null } };

export type AccountSelectionCurrentUserAccountsFragment = { __typename?: 'User', id: string, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null };

export type AccountListCurrentUserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountListCurrentUserAccountsQuery = { __typename?: 'Query', currentUserAccounts?: Array<{ __typename?: 'User', email?: string | null, id: string, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null }> | null };

export type CurrentUserCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCompanyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, code?: string | null } | null } | null };

export type ResetPasswordUrlQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordUrlQuery = { __typename?: 'Query', resetPasswordUrl: string };

export type OrdersHistoryConfigFragment = { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null };

export type GetOrdersPageContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersPageContextQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null, permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToWebOrders: boolean, hasAccessToStoreOrders: boolean } | null } | null, config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null } };

export type CurrentUserOrdersPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserOrdersPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToStoreOrders: boolean } | null } | null };

export type GetCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null, permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToWebOrders: boolean } | null } | null };

export type CurrentQuoteDetailPage_ProductWishlistFragment = { __typename?: 'ProductWishlist', id: number, comment?: string | null, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null }, attachments?: Array<{ __typename?: 'ProductAttachment', id: string, name: string, extension: string, length: number }> | null };

export type CurrentQuoteDetailPage_WishlistFragment = { __typename?: 'Wishlist', id: number, productCount: number, totalExclTax?: number | null, products?: Array<{ __typename?: 'ProductWishlist', id: number, comment?: string | null, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null }, attachments?: Array<{ __typename?: 'ProductAttachment', id: string, name: string, extension: string, length: number }> | null }> | null };

export type GetCurrentQuoteProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentQuoteProductsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, currentQuote?: { __typename?: 'Wishlist', id: number, productCount: number, totalExclTax?: number | null, products?: Array<{ __typename?: 'ProductWishlist', id: number, comment?: string | null, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null }, attachments?: Array<{ __typename?: 'ProductAttachment', id: string, name: string, extension: string, length: number }> | null }> | null } | null } | null };

export type CurrentQuoteInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentQuoteInfosQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, currentQuote?: { __typename?: 'Wishlist', id: number, name?: string | null } | null } | null };

export type QuoteProductDetail_QuoteProductFragment = { __typename?: 'QuoteProduct', reference?: string | null, quantity?: number | null };

export type QuoteDetail_QuoteManagementFragment = { __typename?: 'QuoteManagement', approveNotAllowedReason?: QuoteManagementNotAllowedReason | null, renewedNotAllowedReason?: QuoteManagementNotAllowedReason | null, sharedNotAllowedReason?: QuoteManagementNotAllowedReason | null, canBeApproved: boolean, canBeRenewed: boolean, canBeShared: boolean };

export type QuoteDetail_QuoteFragment = { __typename?: 'Quote', id: string, status: QuoteStatus, createdAt: string, expiredAt: string, updatedAt: string, commercialName: string, ref?: string | null, totalExcludingTax: number, hasSpecificProduct?: boolean | null, orderId?: string | null, comment?: Array<{ __typename?: 'QuoteComment', comment: string, level: QuoteCommentLevel }> | null, management?: { __typename?: 'QuoteManagement', approveNotAllowedReason?: QuoteManagementNotAllowedReason | null, renewedNotAllowedReason?: QuoteManagementNotAllowedReason | null, sharedNotAllowedReason?: QuoteManagementNotAllowedReason | null, canBeApproved: boolean, canBeRenewed: boolean, canBeShared: boolean } | null, pointOfSale: { __typename?: 'PointOfSale', name: string, id: string }, products?: Array<{ __typename?: 'QuoteProduct', quantity?: number | null, priceExcludingTax?: number | null, totalExcludingTax?: number | null, comment?: Array<string> | null, uniqueKey: string, reference?: string | null, name?: string | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null };

export type GetQuoteDetailQueryVariables = Exact<{
  quoteId: Scalars['String']['input'];
  posId: Scalars['String']['input'];
}>;


export type GetQuoteDetailQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSubjectToApprovalFlow: boolean, company?: { __typename?: 'Company', id: string, forbidden: boolean, isPublicAdministration: boolean, quotes: { __typename?: 'QuotePagination', items: Array<{ __typename?: 'Quote', id: string, status: QuoteStatus, createdAt: string, expiredAt: string, updatedAt: string, commercialName: string, ref?: string | null, totalExcludingTax: number, hasSpecificProduct?: boolean | null, orderId?: string | null, comment?: Array<{ __typename?: 'QuoteComment', comment: string, level: QuoteCommentLevel }> | null, management?: { __typename?: 'QuoteManagement', approveNotAllowedReason?: QuoteManagementNotAllowedReason | null, renewedNotAllowedReason?: QuoteManagementNotAllowedReason | null, sharedNotAllowedReason?: QuoteManagementNotAllowedReason | null, canBeApproved: boolean, canBeRenewed: boolean, canBeShared: boolean } | null, pointOfSale: { __typename?: 'PointOfSale', name: string, id: string }, products?: Array<{ __typename?: 'QuoteProduct', quantity?: number | null, priceExcludingTax?: number | null, totalExcludingTax?: number | null, comment?: Array<string> | null, uniqueKey: string, reference?: string | null, name?: string | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> } } | null, favoriteBillingAddress?: { __typename?: 'UserCompanyAddress', line1: string, line2?: string | null, line3?: string | null, postalCode: string, city: string, isoCountryCode: any } | null } | null };

export type GetQuotesConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuotesConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type QuotesPage_ConfigFragment = { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null };

export type GetQuotesPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuotesPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote: boolean } | null } | null };

export type GetCurrentQuoteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentQuoteQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, currentQuote?: { __typename?: 'Wishlist', id: number } | null } | null };

export type GetLastUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastUserAccountQuery = { __typename?: 'Query', lastUserAccount?: { __typename?: 'User', id: string, favoritePointOfSaleId?: string | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null } | null };

export type GenerateAuthTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type GenerateAuthTokenMutation = { __typename?: 'Mutation', generateAuthToken: { __typename?: 'Token', type: TokenType, value: string, maxAge?: number | null } };

export type CurrentUserApprovalFlowPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserApprovalFlowPermissionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', canManageApprovalFlows: boolean } | null } | null };

export type GetCurrentCollaboratorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCollaboratorQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, company?: { __typename?: 'Company', id: string, availableUserRoles: Array<UserRole> } | null } | null };

export type CurrentCollaborator_UserFragment = { __typename?: 'User', id: string, role?: UserRole | null };

export type GetCurrentUserCollaboratorPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserCollaboratorPermissionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', showCompanyUsers: boolean } | null } | null };

export type GetLoyaltyConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null }, currentUser?: { __typename?: 'User', id: string, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus } } | null };

export type OrderRequestDetails_OrderFragment = { __typename?: 'Order', totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, totalOrderedProducts?: number | null, subtotalExclTax?: number | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null };

export type OrderRequestDetailsAsBuyerPageQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type OrderRequestDetailsAsBuyerPageQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSubjectToApprovalFlow: boolean, company?: { __typename?: 'Company', id: string, chorusData?: { __typename?: 'ChorusData', services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null }> | null } | null } | null, orderRequests: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', orderDate?: string | null, internalRef?: string | null, webRef?: string | null, chorusLegalCommitment?: string | null, chorusServiceCode?: string | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, totalOrderedProducts?: number | null, subtotalExclTax?: number | null, delivery?: { __typename?: 'OrderDelivery', addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, approvers?: Array<{ __typename?: 'User', lastname?: string | null, firstname?: string | null }> | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename?: 'OrderItemsSectionInfoClickAndCollect' } | { __typename?: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename?: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', amountTotal: number, catalogDiscountAmount: number, oldPrice: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, reference: string, name?: string | null, urlKey?: string | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, user?: { __typename?: 'OrderUser', name: string } | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null } | null> | null } } | null, config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isChorusDisplayEnabled: boolean, isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null, checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null } };

export type OrderRequestDetailsAsValidationPageQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
  resetData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderRequestDetailsAsValidationPageQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, isRequiredLegalCommitment?: boolean | null }> | null } | null } | null, orderRequestToApprove?: { __typename?: 'OrderRequestToApprove', internalRef: string, orderDate: string, webRef: string, chorusServiceCode?: string | null, chorusLegalCommitment?: string | null, approvee: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, approver: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, delivery: { __typename?: 'OrderDelivery', requestedDate?: string | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null }, payment: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null }, updatedState?: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string, code: CartMessageCode } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', items?: Array<{ __typename?: 'CartItem', id?: any | null, totalExclTax?: number | null, quantity: number, quantityMax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, quantity: number, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, oldPrice?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, product?: { __typename?: 'Product', name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null }> | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', items?: Array<{ __typename?: 'CartItem', id?: any | null, totalExclTax?: number | null, quantity: number, quantityMax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, quantity: number, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, oldPrice?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, product?: { __typename?: 'Product', name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } | null } | null } | null, config: { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', g9LowStockThreshold?: string | null } | null, checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null, sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type GetOrderRequestPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrderRequestPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToOrderRequestToApprove: boolean } | null } | null, config: { __typename?: 'Config', checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null } };

export type GetOnGoingOrderRequestPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnGoingOrderRequestPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', isSubjectToApprovalFlow: boolean } | null, config: { __typename?: 'Config', checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null } };

export type OrderRequestConfig_ConfigFragment = { __typename?: 'Config', checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null };

export type QuickOrderProductList_ProductsFragment = { __typename?: 'Wishlist', id: number, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', id: number, quantity: number, comment?: string | null, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null };

export type GetQuickOrderConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickOrderConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isQuickOrderEnabled: boolean } | null } };

export type GetQuickOrderListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickOrderListQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, quickOrderList: { __typename?: 'Wishlist', id: number, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', id: number, quantity: number, comment?: string | null, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null } } | null };

export type GetQuickOrderListCheckoutInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickOrderListCheckoutInformationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type TopPurchaseCartInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type TopPurchaseCartInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type TopPurchasesQueryVariables = Exact<{ [key: string]: never; }>;


export type TopPurchasesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, topPurchaseList: { __typename?: 'TopPurchase', products?: Array<{ __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null }> | null } } | null } | null };

export type TopPurchaseConfig_ConfigFragment = { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', isTopPurchaseEnabled: boolean } | null };

export type TopPurchasesConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type TopPurchasesConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', isTopPurchaseEnabled: boolean } | null } };

export type GetCurrentUserInformationFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserInformationFormQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, emailPreferences?: Array<{ __typename?: 'EmailPreference', emailType: string, receiveEmail: boolean } | null> | null, permissions?: { __typename?: 'CollaboratorPermissions', showPreferenceCommunication: boolean } | null, company?: { __typename?: 'Company', id: string, name?: string | null, code?: string | null } | null } | null };

export type GetCategoriesQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', categories?: Array<{ __typename?: 'Category', urlKey: string, id?: string | null, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null }> | null };

export type HubList_CategoriesFragment = { __typename?: 'Category', code: string, name: string, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type GetCategoryImagesQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoryImagesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', name: string, categories?: Array<{ __typename?: 'Category', code: string, name: string, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null }> | null };

export type BrandsList_BrandsFragment = { __typename?: 'Brand', name: string, urlKey?: string | null };

export type OurBrandsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type OurBrandsPageQuery = { __typename?: 'Query', brands?: Array<{ __typename?: 'Brand', name: string, urlKey?: string | null }> | null };

export type BrandListHeaderQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type BrandListHeaderQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', name: string, description?: string | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, productList?: { __typename?: 'ProductList', productCount?: number | null } | null } | null };

export type ProductListBrandPageQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductListBrandPageQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', productList?: { __typename?: 'ProductList', totalPages?: number | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null } | null };

export type ProductListBrandFiltersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductListBrandFiltersQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', productList?: { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null } | null } | null };

export type ProductListBrandPageSeoContentQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductListBrandPageSeoContentQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', name: string, description?: string | null } | null };

export type EventHeaderInformation_EventFragment = { __typename?: 'Event', title: string, baseline?: string | null, catalogLink?: string | null, catalogLinkOpenInNewTab: boolean, catalogTitle?: string | null, conditions?: string | null, description?: string | null, youtubeLink?: string | null, productList?: { __typename?: 'ProductList', productCount?: number | null } | null };

export type ProductListEventQueryHeaderQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter: Scalars['String']['input'];
}>;


export type ProductListEventQueryHeaderQuery = { __typename?: 'Query', event?: { __typename?: 'Event', title: string, baseline?: string | null, catalogLink?: string | null, catalogLinkOpenInNewTab: boolean, catalogTitle?: string | null, conditions?: string | null, description?: string | null, youtubeLink?: string | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, productList?: { __typename?: 'ProductList', productCount?: number | null } | null } | null };

export type ProductListEventProductsQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListEventProductsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', productList?: { __typename?: 'ProductList', totalPages?: number | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null } | null };

export type ProductListEventFiltersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListEventFiltersQuery = { __typename?: 'Query', event?: { __typename?: 'Event', productList?: { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null } | null } | null };

export type ProductListEventFiltersExcludingCategoriesQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListEventFiltersExcludingCategoriesQuery = { __typename?: 'Query', event?: { __typename?: 'Event', productList?: { __typename?: 'ProductList', productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null } | null } | null };

export type ProductListCategoryHeaderQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListCategoryHeaderQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', name: string, baseline?: string | null, code: string, seoContent?: string | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null, productList?: { __typename?: 'ProductList', productCount?: number | null } | null }> | null };

export type Breadcrumb_PathFragment = { __typename?: 'Breadcrumb', urlKey?: string | null, name: string };

export type GetUniverseBreadcrumbsQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniverseBreadcrumbsQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null }> | null };

export type UniversePageQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type UniversePageQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null }> | null };

export type GetUniverseProductCountQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniverseProductCountQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', productList?: { __typename?: 'ProductList', productCount?: number | null } | null }> | null };

export type ProductListCategoryMetadataQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListCategoryMetadataQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', name: string, urlKey: string, seoContent?: string | null, code: string, productList?: { __typename?: 'ProductList', productCount?: number | null } | null }> | null };

export type GetSearchResultHeaderQueryVariables = Exact<{
  search: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter: Scalars['String']['input'];
}>;


export type GetSearchResultHeaderQuery = { __typename?: 'Query', searchList?: { __typename?: 'SearchList', categories?: Array<{ __typename?: 'Category', urlKey: string, id?: string | null, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, productList?: { __typename?: 'ProductList', productCount?: number | null } | null } | null };

export type GetSearchResultCountQueryVariables = Exact<{
  search: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter: Scalars['String']['input'];
}>;


export type GetSearchResultCountQuery = { __typename?: 'Query', searchList?: { __typename?: 'SearchList', productList?: { __typename?: 'ProductList', productCount?: number | null, products?: Array<{ __typename?: 'Product', urlKey?: string | null }> | null } | null } | null };

export type GetSearchResultQueryVariables = Exact<{
  search: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter: Scalars['String']['input'];
}>;


export type GetSearchResultQuery = { __typename?: 'Query', searchList?: { __typename?: 'SearchList', productList?: { __typename?: 'ProductList', totalPages?: number | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null } | null };

export type GetSearchFiltersQueryVariables = Exact<{
  search: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  requestFilter: Scalars['String']['input'];
}>;


export type GetSearchFiltersQuery = { __typename?: 'Query', searchList?: { __typename?: 'SearchList', productList?: { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null } | null } | null };

export type SearchTargetUrlQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchTargetUrlQuery = { __typename?: 'Query', search?: { __typename?: 'Search', targetUrl?: string | null } | null };

export type ProductPageBreadcrumbsQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductPageBreadcrumbsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', breadcrumbs?: Array<{ __typename?: 'Breadcrumb', urlKey?: string | null, name: string }> | null } | null };

export type EquivalentProductFieldsWithoutPriceFragment = { __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null };

export type GetEquivalentProductsQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetEquivalentProductsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', type: ProductType, reference: string, name?: string | null, urlKey?: string | null, equivalentProducts?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null }> | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null } | null };

export type GetEquivalentProductsPriceAndStockQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetEquivalentProductsPriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, reference: string, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type GetProductBundleDataQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetProductBundleDataQuery = { __typename?: 'Query', product?: { __typename?: 'Product', canAddToCart: boolean, stock: { __typename?: 'ProductStock', isSellable: boolean }, bundle?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, nbArticles: number, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null };

export type GetProductBundlePriceAndStockQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetProductBundlePriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type ProductBundle_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductBundle_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type ProductDetail_ProductFragment = { __typename?: 'Product', reference: string, videoUrls?: Array<string> | null, description?: string | null, shortDescription?: string | null, name?: string | null, supplierReference?: string | null, type: ProductType, urlKey?: string | null, hasRseLabel?: boolean | null, nbArticles: number, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, documents?: Array<{ __typename?: 'Document', name?: string | null, link?: string | null }> | null, mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, marketingInsert?: { __typename?: 'ProductMarketingInsert', label: string, legalNotice?: string | null } | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductDetailsQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductDetailsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, videoUrls?: Array<string> | null, description?: string | null, shortDescription?: string | null, name?: string | null, supplierReference?: string | null, type: ProductType, urlKey?: string | null, hasRseLabel?: boolean | null, nbArticles: number, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, documents?: Array<{ __typename?: 'Document', name?: string | null, link?: string | null }> | null, mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, marketingInsert?: { __typename?: 'ProductMarketingInsert', label: string, legalNotice?: string | null } | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type ProductPageCurrentUserQueryVariables = Exact<{
  pickupPointOfSaleId: Scalars['String']['input'];
}>;


export type ProductPageCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, phoneNumber?: string | null } | null } | null, pickupPointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type ProductDetailInfosHeader_ProductFragment = { __typename?: 'Product', reference: string, name?: string | null, supplierReference?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null };

export type ProductDetailInfos_ProductFragment = { __typename?: 'Product', description?: string | null, shortDescription?: string | null, reference: string, name?: string | null, supplierReference?: string | null, type: ProductType, urlKey?: string | null, hasRseLabel?: boolean | null, nbArticles: number, documents?: Array<{ __typename?: 'Document', name?: string | null, link?: string | null }> | null, mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, marketingInsert?: { __typename?: 'ProductMarketingInsert', label: string, legalNotice?: string | null } | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductJsonLdBaseQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductJsonLdBaseQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, name?: string | null, description?: string | null, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null } | null };

export type ProductJsonLdPriceAndStockQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductJsonLdPriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, canAddToCart: boolean, bestArticlePrice?: number | null, price?: { __typename?: 'Price', exclTax?: number | null } | null }> | null };

export type ProductPageAnalytics_ProductFragment = { __typename?: 'Product', reference: string, name?: string | null, description?: string | null, type: ProductType, supplierReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', name?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name: string, urlKey?: string | null }> | null, brand?: { __typename?: 'Brand', urlKey?: string | null, name: string } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, equivalentProducts?: Array<{ __typename?: 'Product', reference: string, name?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null };

export type ProductPageTracking_ProductBundleQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductPageTracking_ProductBundleQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, bundle?: Array<{ __typename?: 'Product', name?: string | null, reference: string, stock: { __typename?: 'ProductStock', availability: Array<Availability | null> } }> | null } | null };

export type ProductPageTracking_ProductQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductPageTracking_ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, name?: string | null, description?: string | null, type: ProductType, supplierReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', name?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name: string, urlKey?: string | null }> | null, brand?: { __typename?: 'Brand', urlKey?: string | null, name: string } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, equivalentProducts?: Array<{ __typename?: 'Product', reference: string, name?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null } | null };

export type ProductPageTracking_ProductWithReferenceQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductPageTracking_ProductWithReferenceQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, name?: string | null, description?: string | null, type: ProductType, supplierReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', name?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name: string, urlKey?: string | null }> | null, brand?: { __typename?: 'Brand', urlKey?: string | null, name: string } | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, equivalentProducts?: Array<{ __typename?: 'Product', reference: string, name?: string | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null } | null };

export type ProductPageTracking_ProductPriceAndStockQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductPageTracking_ProductPriceAndStockQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, parentReference?: string | null, canAddToCart: boolean, bestArticlePrice?: number | null, price?: { __typename?: 'Price', exclTax?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null> }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null } | null };

export type ProductPageProductNavigationQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductPageProductNavigationQuery = { __typename?: 'Query', product?: { __typename?: 'Product', urlKey?: string | null, parentUrlKey?: string | null, reference: string } | null };

export type ProductPageProductMetadataQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductPageProductMetadataQuery = { __typename?: 'Query', product?: { __typename?: 'Product', name?: string | null, mainImage?: { __typename?: 'Image', set?: Array<{ __typename?: 'ImageUrl', url: string }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } | null };

export type ProductPageProductAnomaliesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductPageProductAnomaliesQuery = { __typename?: 'Query', productAnomalies?: Array<{ __typename?: 'ProductAnomaly', name: string, value: string, categories?: Array<{ __typename?: 'ProductSubAnomaly', name: string, value: string }> | null }> | null };

export type GetUserRootCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRootCompanyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, phoneNumber?: string | null } | null } | null } | null };

export type GetCurrentUserLoyaltyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserLoyaltyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus, data?: { __typename?: 'LoyaltyData', active: boolean, customerStatus?: string | null, state: string } | null } } | null };

export type GetCmsLoyaltyConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCmsLoyaltyConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null } };

export type SearchProductsField_SearchFragment = { __typename?: 'Search', products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', product?: { __typename?: 'Product', reference: string, urlKey?: string | null } | null, categories?: Array<{ __typename?: 'Category', name: string, urlKey: string }> | null, suggestions?: Array<{ __typename?: 'Suggestion', label: string }> | null, brands?: Array<{ __typename?: 'Brand', name: string, urlKey?: string | null }> | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null };

export type CreateFormSubmissionMutationVariables = Exact<{
  data: Cms_MutationFormSubmissionInput;
}>;


export type CreateFormSubmissionMutation = { __typename?: 'Mutation', CMS_createFormSubmission?: { __typename?: 'CMS_FormSubmission', id: number } | null };

export type GetMetadataBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  tenantId: Scalars['JSON']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMetadataBySlugQuery = { __typename?: 'Query', CMS_Pages?: { __typename?: 'CMS_Pages', docs: Array<{ __typename?: 'CMS_Page', canonicalUrl?: string | null, meta?: { __typename?: 'CMS_Page_Meta', title?: string | null, description?: string | null, image?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null } | null }> } | null };

export type CmsTwoColumnsImageFragment = { __typename?: 'CMS_TwoColumnsImageBlock', id?: string | null, blockType?: string | null, title?: string | null, content?: any | null, tint?: string | null, picturePosition?: Cms_TwoColumnsImageBlock_PicturePosition | null, pictureLinkUrl?: string | null, pictureLinkTarget?: Cms_TwoColumnsImageBlock_PictureLinkTarget | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_TwoColumnsImageBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null };

export type CmsTitleH2H3Fragment = { __typename?: 'CMS_SectionHeaderBlock', id?: string | null, blockType?: string | null, title?: string | null, titleAs?: Cms_SectionHeaderBlock_TitleAs | null, description?: string | null, descriptionSize?: Cms_SectionHeaderBlock_DescriptionSize | null, link?: Array<{ __typename?: 'CMS_SectionHeaderBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null };

export type CmsCalloutFragment = { __typename?: 'CMS_CalloutBlock', id?: string | null, blockType?: string | null, title?: string | null, calloutDescriptionRichText?: any | null, tint?: string | null, icon?: string | null };

export type CmsInnerHtmlFragment = { __typename?: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null };

export type CmsEpigraphFragment = { __typename?: 'CMS_QuoteBlock', id?: string | null, blockType?: string | null, text?: string | null, size?: string | null, align?: Cms_QuoteBlock_Align | null };

export type CmsBrandsSliderFragment = { __typename?: 'CMS_BrandsSliderBlock', id?: string | null, blockType?: string | null };

export type CmsCatalogListFragment = { __typename?: 'CMS_CatalogListBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, buttonLabelSeeLess?: string | null, buttonLabelSeeMore?: string | null, layout: Array<{ __typename?: 'CMS_CatalogCardBlock', id?: string | null, blockType?: string | null, title?: string | null, url?: string | null, label?: Cms_CatalogCardBlock_Label | null, catalogCardPicture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> };

export type CmsColumnFragment = { __typename?: 'CMS_ColumnsBlock', id?: string | null, blockType?: string | null, columns?: Array<{ __typename: 'CMS_CardBlock', id?: string | null, blockType?: string | null, title?: string | null, titleTag?: Cms_CardBlock_TitleTag | null, titleSize?: string | null, isTitleBold?: boolean | null, pictureHeight?: Cms_CardBlock_PictureHeight | null, pictureLink?: string | null, cardRichText?: any | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_CardBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename: 'CMS_CardIconBlock', id?: string | null, blockType?: string | null, title?: string | null, icon?: string | null, description?: string | null, linkUrl?: string | null, linkLabel?: string | null } | { __typename: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null } | { __typename: 'CMS_KeyInformationBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, description?: string | null, icon?: string | null, illustration?: string | null } | { __typename: 'CMS_StepBlock', id?: string | null, blockType?: string | null, number?: number | null, title?: string | null, description?: string | null, icon?: string | null, illustration?: string | null }> | null };

export type CmsVideoPlayerFragment = { __typename?: 'CMS_VideoPlayerBlock', id?: string | null, blockType?: string | null, platform?: Cms_VideoPlayerBlock_Platform | null, videoId?: string | null, aspectRatio?: string | null, youtubeControls?: boolean | null, youtubePlaysInline?: boolean | null, youtubeMute?: boolean | null, youtubeAutoplay?: boolean | null, vimeoControls?: boolean | null, vimeoMute?: boolean | null, vimeoAutoplay?: boolean | null, vimeoLoop?: boolean | null, thumbnail?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null };

export type CmsPictureFragment = { __typename?: 'CMS_PictureBlock', id?: string | null, blockType?: string | null, mode?: Cms_PictureBlock_Mode | null, pictureDesktop?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null, pictureMobile?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null };

export type CmsPhoneCallbackBannerFragment = { __typename?: 'CMS_PhoneCallbackBannerBlock', id?: string | null, blockType?: string | null };

export type CmsFormFragment = { __typename?: 'CMS_FormBlock', id?: string | null, blockType?: string | null, form?: { __typename?: 'CMS_Form', id: number, title: string, submitButtonLabel?: string | null, confirmationType?: Cms_Form_ConfirmationType | null, confirmationMessage?: string | null, redirect?: { __typename?: 'CMS_Form_Redirect', url?: string | null } | null, fields?: Array<{ __typename?: 'CMS_Checkbox', id?: string | null, name: string, label?: string | null, width?: number | null, required?: boolean | null, blockName?: string | null, blockType?: string | null, defaultChecked?: boolean | null } | { __typename?: 'CMS_Email', id?: string | null, name: string, label?: string | null, width?: number | null, required?: boolean | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CMS_Text', blockType?: string | null, blockName?: string | null, name: string, label?: string | null, defaultValue?: string | null, width?: number | null, required?: boolean | null, id?: string | null }> | null } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  tenantId: Scalars['JSON']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', CMS_Pages?: { __typename?: 'CMS_Pages', docs: Array<{ __typename?: 'CMS_Page', id: number, slug?: string | null, title?: string | null, subtitle?: string | null, breadcrumbs?: Array<{ __typename?: 'CMS_Page_Breadcrumbs', label?: string | null, url?: string | null }> | null, layout: Array<{ __typename: 'CMS_BrandsSliderBlock', id?: string | null, blockType?: string | null } | { __typename: 'CMS_CalloutBlock', id?: string | null, blockType?: string | null, title?: string | null, calloutDescriptionRichText?: any | null, tint?: string | null, icon?: string | null } | { __typename: 'CMS_CatalogListBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, buttonLabelSeeLess?: string | null, buttonLabelSeeMore?: string | null, layout: Array<{ __typename?: 'CMS_CatalogCardBlock', id?: string | null, blockType?: string | null, title?: string | null, url?: string | null, label?: Cms_CatalogCardBlock_Label | null, catalogCardPicture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> } | { __typename: 'CMS_CategoryLinkListBlock', id?: string | null, blockType?: string | null, links: Array<{ __typename?: 'CMS_ButtonLinkBlock', id?: string | null, blockType?: string | null, title?: string | null, plainLink?: string | null, icon?: string | null, image?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> } | { __typename: 'CMS_ColumnsBlock', id?: string | null, blockType?: string | null, columns?: Array<{ __typename: 'CMS_CardBlock', id?: string | null, blockType?: string | null, title?: string | null, titleTag?: Cms_CardBlock_TitleTag | null, titleSize?: string | null, isTitleBold?: boolean | null, pictureHeight?: Cms_CardBlock_PictureHeight | null, pictureLink?: string | null, cardRichText?: any | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_CardBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename: 'CMS_CardIconBlock', id?: string | null, blockType?: string | null, title?: string | null, icon?: string | null, description?: string | null, linkUrl?: string | null, linkLabel?: string | null } | { __typename: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null } | { __typename: 'CMS_KeyInformationBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, description?: string | null, icon?: string | null, illustration?: string | null } | { __typename: 'CMS_StepBlock', id?: string | null, blockType?: string | null, number?: number | null, title?: string | null, description?: string | null, icon?: string | null, illustration?: string | null }> | null } | { __typename: 'CMS_FormBlock', id?: string | null, blockType?: string | null, form?: { __typename?: 'CMS_Form', id: number, title: string, submitButtonLabel?: string | null, confirmationType?: Cms_Form_ConfirmationType | null, confirmationMessage?: string | null, redirect?: { __typename?: 'CMS_Form_Redirect', url?: string | null } | null, fields?: Array<{ __typename?: 'CMS_Checkbox', id?: string | null, name: string, label?: string | null, width?: number | null, required?: boolean | null, blockName?: string | null, blockType?: string | null, defaultChecked?: boolean | null } | { __typename?: 'CMS_Email', id?: string | null, name: string, label?: string | null, width?: number | null, required?: boolean | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CMS_Text', blockType?: string | null, blockName?: string | null, name: string, label?: string | null, defaultValue?: string | null, width?: number | null, required?: boolean | null, id?: string | null }> | null } | null } | { __typename: 'CMS_FullImageCardBlock', id?: string | null, blockType?: string | null, title?: string | null, subtitle?: string | null, size?: string | null, linkUrl?: string | null, imageFullImageCard?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null } | { __typename: 'CMS_HeroBannerBlock', id?: string | null, blockType?: string | null, title?: string | null, contentTop?: string | null, contentBottom?: any | null } | { __typename: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null } | { __typename: 'CMS_PhoneCallbackBannerBlock', id?: string | null, blockType?: string | null } | { __typename: 'CMS_PictureBlock', id?: string | null, blockType?: string | null, mode?: Cms_PictureBlock_Mode | null, pictureDesktop?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null, pictureMobile?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null } | { __typename: 'CMS_QuoteBlock', id?: string | null, blockType?: string | null, text?: string | null, size?: string | null, align?: Cms_QuoteBlock_Align | null } | { __typename: 'CMS_SectionHeaderBlock', id?: string | null, blockType?: string | null, title?: string | null, titleAs?: Cms_SectionHeaderBlock_TitleAs | null, description?: string | null, descriptionSize?: Cms_SectionHeaderBlock_DescriptionSize | null, link?: Array<{ __typename?: 'CMS_SectionHeaderBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename: 'CMS_SimpleTableBlock', id?: string | null, blockType?: string | null, overflowing?: boolean | null, rows: Array<{ __typename?: 'CMS_SimpleTableBlock_Rows', columns: Array<{ __typename?: 'CMS_SimpleTableBlock_Rows_Columns', tint?: string | null, contentRichText?: any | null, align?: string | null, verticalAlign?: string | null, fontWeight?: string | null }> }> } | { __typename: 'CMS_SkinBlock', id?: string | null, blockType?: string | null, tint?: string | null, layout: Array<{ __typename?: 'CMS_BrandsSliderBlock', id?: string | null, blockType?: string | null } | { __typename?: 'CMS_CalloutBlock', id?: string | null, blockType?: string | null, title?: string | null, calloutDescriptionRichText?: any | null, tint?: string | null, icon?: string | null } | { __typename?: 'CMS_CatalogListBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, buttonLabelSeeLess?: string | null, buttonLabelSeeMore?: string | null, layout: Array<{ __typename?: 'CMS_CatalogCardBlock', id?: string | null, blockType?: string | null, title?: string | null, url?: string | null, label?: Cms_CatalogCardBlock_Label | null, catalogCardPicture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> } | { __typename?: 'CMS_ColumnsBlock', id?: string | null, blockType?: string | null, columns?: Array<{ __typename: 'CMS_CardBlock', id?: string | null, blockType?: string | null, title?: string | null, titleTag?: Cms_CardBlock_TitleTag | null, titleSize?: string | null, isTitleBold?: boolean | null, pictureHeight?: Cms_CardBlock_PictureHeight | null, pictureLink?: string | null, cardRichText?: any | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_CardBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename: 'CMS_CardIconBlock', id?: string | null, blockType?: string | null, title?: string | null, icon?: string | null, description?: string | null, linkUrl?: string | null, linkLabel?: string | null } | { __typename: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null } | { __typename: 'CMS_KeyInformationBlock', id?: string | null, blockType?: string | null, title?: string | null, subTitle?: string | null, description?: string | null, icon?: string | null, illustration?: string | null } | { __typename: 'CMS_StepBlock', id?: string | null, blockType?: string | null, number?: number | null, title?: string | null, description?: string | null, icon?: string | null, illustration?: string | null }> | null } | { __typename?: 'CMS_InnerHtmlBlock', id?: string | null, htmlContent?: any | null, blockType?: string | null, blockName?: string | null } | { __typename?: 'CMS_PhoneCallbackBannerBlock', id?: string | null, blockType?: string | null } | { __typename?: 'CMS_PictureBlock', id?: string | null, blockType?: string | null, mode?: Cms_PictureBlock_Mode | null, pictureDesktop?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null, pictureMobile?: { __typename?: 'CMS_Media', url?: string | null, width?: number | null, height?: number | null } | null } | { __typename?: 'CMS_SectionHeaderBlock', id?: string | null, blockType?: string | null, title?: string | null, titleAs?: Cms_SectionHeaderBlock_TitleAs | null, description?: string | null, descriptionSize?: Cms_SectionHeaderBlock_DescriptionSize | null, link?: Array<{ __typename?: 'CMS_SectionHeaderBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename?: 'CMS_TwoColumnsImageBlock', id?: string | null, blockType?: string | null, title?: string | null, content?: any | null, tint?: string | null, picturePosition?: Cms_TwoColumnsImageBlock_PicturePosition | null, pictureLinkUrl?: string | null, pictureLinkTarget?: Cms_TwoColumnsImageBlock_PictureLinkTarget | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_TwoColumnsImageBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename?: 'CMS_VideoPlayerBlock', id?: string | null, blockType?: string | null, platform?: Cms_VideoPlayerBlock_Platform | null, videoId?: string | null, aspectRatio?: string | null, youtubeControls?: boolean | null, youtubePlaysInline?: boolean | null, youtubeMute?: boolean | null, youtubeAutoplay?: boolean | null, vimeoControls?: boolean | null, vimeoMute?: boolean | null, vimeoAutoplay?: boolean | null, vimeoLoop?: boolean | null, thumbnail?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> } | { __typename: 'CMS_TwoColumnsImageBlock', id?: string | null, blockType?: string | null, title?: string | null, content?: any | null, tint?: string | null, picturePosition?: Cms_TwoColumnsImageBlock_PicturePosition | null, pictureLinkUrl?: string | null, pictureLinkTarget?: Cms_TwoColumnsImageBlock_PictureLinkTarget | null, picture?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null, link?: Array<{ __typename?: 'CMS_TwoColumnsImageBlock_Link', label?: string | null, url?: string | null, variant?: string | null, iconLeft?: string | null, iconRight?: string | null }> | null } | { __typename: 'CMS_VideoPlayerBlock', id?: string | null, blockType?: string | null, platform?: Cms_VideoPlayerBlock_Platform | null, videoId?: string | null, aspectRatio?: string | null, youtubeControls?: boolean | null, youtubePlaysInline?: boolean | null, youtubeMute?: boolean | null, youtubeAutoplay?: boolean | null, vimeoControls?: boolean | null, vimeoMute?: boolean | null, vimeoAutoplay?: boolean | null, vimeoLoop?: boolean | null, thumbnail?: { __typename?: 'CMS_Media', url?: string | null, alt: string, width?: number | null, height?: number | null } | null }> }> } | null };

export type ContactPageConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPageConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', support?: { __typename?: 'ConfigSupport', contactFormType: ContactFormType } | null } };

export type MarketingPageCurrentUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingPageCurrentUserDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, favoritePointOfSaleId?: string | null } | null };

export type GetHomePageConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomePageConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', homepage?: { __typename?: 'ConfigHomepage', ourServicesBlockEnabled: boolean, ourSelectionGuidesBlockEnabled: boolean, ourBrandsBlockEnabled: boolean } | null } };

export type HomePage_ConfigFragment = { __typename?: 'Config', homepage?: { __typename?: 'ConfigHomepage', ourServicesBlockEnabled: boolean, ourSelectionGuidesBlockEnabled: boolean, ourBrandsBlockEnabled: boolean } | null };

export type GenerateLyraFormQueryVariables = Exact<{
  webRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateLyraFormQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', generateLyraForm?: { __typename?: 'LyraForm', endpoint?: string | null, payload?: string | null } | null } | null } | null };

export type CartPreview_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartPreview_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename: 'CartItemsSectionInfoClickAndCollect' } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null, company?: { __typename?: 'Company', name?: string | null, code?: string | null } | null } | null };

export type PunchoutCartPreview_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type PunchoutCartPreview_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, info: { __typename: 'CartItemsSectionInfoClickAndCollect' } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null } }> | null } | null> | null } | null }, company?: { __typename?: 'Company', name?: string | null, code?: string | null } | null } | null };

export type StoreOrderPreviewQueryVariables = Exact<{
  externalRef: Scalars['String']['input'];
}>;


export type StoreOrderPreviewQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', externalRef?: string | null, internalRef?: string | null, orderDate?: string | null, status: OrderStatus, hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, collectPointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', name?: string | null, urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null } | null> | null } } | null, config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type WebOrderPreviewQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type WebOrderPreviewQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, webRef?: string | null, internalRef?: string | null, orderDate?: string | null, status: OrderStatus, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, wentThroughApproval: boolean, approver?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, collectPointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null }> | null } | null> | null } } | null, config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type CartExportQueryVariables = Exact<{ [key: string]: never; }>;


export type CartExportQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null } | null, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalQuantity?: number | null, couponCode?: string | null, createdAt?: string | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, calculatedConditionningPrice?: number | null, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', reference: string, supplierReference?: string | null, name?: string | null, description?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, ecoPart: { __typename?: 'EcoPart', deee?: number | null, pmcb?: number | null, furnishing?: number | null }, charges: Array<{ __typename?: 'Charge', name: string, amount: number } | null>, packaging?: { __typename?: 'ProductPackaging', unit?: Unit | null, quantity?: number | null } | null } | null }> | null }> | null } } | null } | null };

export type PunchoutCartExportQueryVariables = Exact<{ [key: string]: never; }>;


export type PunchoutCartExportQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, rowTotalExclTax?: number | null, unitPriceExclTax?: number | null, product: { __typename?: 'Product', reference: string, supplierReference?: string | null, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, ecoPart: { __typename?: 'EcoPart', deee?: number | null, pmcb?: number | null, furnishing?: number | null }, charges: Array<{ __typename?: 'Charge', name: string, amount: number } | null> } } | null> | null } | null } } | null };

export type ProductsStickersProductFragment = { __typename?: 'Product', reference: string, name?: string | null, urlKey?: string | null, brand?: { __typename?: 'Brand', name: string } | null, mainImage?: { __typename?: 'Image', set?: Array<{ __typename?: 'ImageUrl', media: Media, url: string }> | null } | null };

export type ProductsStickersQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductsStickersQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, name?: string | null, urlKey?: string | null, brand?: { __typename?: 'Brand', name: string } | null, mainImage?: { __typename?: 'Image', set?: Array<{ __typename?: 'ImageUrl', media: Media, url: string }> | null } | null }> | null };

export type ProductsStickersConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsStickersConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', isProductLabelGenerationEnabled: boolean, isStoreNameDisplayedOnProductLabel: boolean } | null } };

export type AddressByIdQueryVariables = Exact<{
  addressId: Scalars['String']['input'];
}>;


export type AddressByIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, address?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null } | null } | null };

export type FavoritePointOfSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritePointOfSaleQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null } | null };

export type FavoriteListNameByIdQueryVariables = Exact<{
  input: Browsing;
}>;


export type FavoriteListNameByIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, wishlists: { __typename?: 'WishlistPagination', items: Array<{ __typename?: 'Wishlist', id: number, name?: string | null }> } } | null };

export type EventConditionsDrawerQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type EventConditionsDrawerQuery = { __typename?: 'Query', event?: { __typename?: 'Event', conditions?: string | null } | null };

export type AvailablePointsOfSalePickupQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailablePointsOfSalePickupQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', availablePointsOfSalePickup?: Array<{ __typename?: 'PointOfSale', id: string }> | null } | null };

export type EmbedEditShippingContactQueryVariables = Exact<{ [key: string]: never; }>;


export type EmbedEditShippingContactQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string }, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null } | null } | null } | null } | null };

export type EmbedEditShippingInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type EmbedEditShippingInformationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string }, shipping?: { __typename?: 'Shipping', delivery?: { __typename?: 'Delivery', comment?: string | null } | null } | null } | null } | null };

export type EmbedSelectAddressCartQueryVariables = Exact<{ [key: string]: never; }>;


export type EmbedSelectAddressCartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type EmbedSetDeliveryDatePickerQueryVariables = Exact<{ [key: string]: never; }>;


export type EmbedSetDeliveryDatePickerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type ProductByUrlKeyQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductByUrlKeyQuery = { __typename?: 'Query', product?: { __typename?: 'Product', urlKey?: string | null } | null };

export type GetCurrentUserTriptychQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserTriptychQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', code?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null } | null };

export type GetUserTriptychForImpersonationQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetUserTriptychForImpersonationQuery = { __typename?: 'Query', searchUsers: { __typename?: 'UserPagination', items: Array<{ __typename?: 'User', id: string, company?: { __typename?: 'Company', code?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null }> } };

export type GetTestCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTestCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, role?: UserRole | null } | null };

export type InternalLoginActionQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalLoginActionQuery = { __typename?: 'Query', internalLoginAction: { __typename?: 'LoginAction', url?: string | null } };

export type GenerateInternalAuthTokenMutationVariables = Exact<{
  samlResponse: Scalars['String']['input'];
}>;


export type GenerateInternalAuthTokenMutation = { __typename?: 'Mutation', generateInternalAuthToken: { __typename?: 'Token', type: TokenType, value: string, maxAge?: number | null } };

export type SitemapConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', site?: { __typename?: 'ConfigSite', sitemapUrl: string } | null } };

export type AccountCard_CompanyFragment = { __typename?: 'Company', code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null };

export type CurrentUser_FavoritePointOfSaleFragment = { __typename?: 'User', favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null };

export type AddAccountLink_CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AddAccountLink_CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null } | null };

export type AccountDrawer_QuoteNotificationConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDrawer_QuoteNotificationConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type AccountDrawer_UserPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDrawer_UserPermissionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote: boolean } | null } | null };

export type AccountDrawer_CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDrawer_CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, email?: string | null, hasProcessingQuotes: boolean, permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToWebOrders: boolean } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, id: string, address: { __typename?: 'PointOfSaleAddress', line1: string, city: string }, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null } | null };

export type AccountHomeSlider_OrderFragment = { __typename?: 'Order', deliveryDate?: string | null, orderDate?: string | null, webRef?: string | null, internalRef?: string | null, externalRef?: string | null, status: OrderStatus, totalAmount?: number | null };

export type AccountHomeSlider_PointOfSaleAddressFragment = { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string };

export type AccountHomeSlider_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type GetAccountHomeSliderQueryVariables = Exact<{
  isLoyaltyEnabled: Scalars['Boolean']['input'];
  isQuoteEnabled: Scalars['Boolean']['input'];
}>;


export type GetAccountHomeSliderQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', orderDate?: string | null, webRef?: string | null, status: OrderStatus, totalAmount?: number | null } | null> | null }, permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote?: boolean, showOrderHistory: boolean, showStoreOrderHistory: boolean, hasAccessToWebOrders: boolean, hasAccessToStoreOrders: boolean } | null, loyalty?: { __typename?: 'Loyalty', status: LoyaltyStatus } } | null };

export type GetAccountHomeSliderConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountHomeSliderConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null, loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null, sales?: { __typename?: 'ConfigSales', isQuickOrderEnabled: boolean, isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null } };

export type AccountHomeSliderMyQuotesTileQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountHomeSliderMyQuotesTileQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, hasProcessingQuotes: boolean } | null };

export type DashboardProspectBenefitsCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardProspectBenefitsCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, isProspect: boolean } | null, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, canManageQuote: boolean } | null } | null };

export type AccountSelectionDrawerCurrentUserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSelectionDrawerCurrentUserAccountsQuery = { __typename?: 'Query', currentUserAccounts?: Array<{ __typename?: 'User', email?: string | null, id: string, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null }> | null };

export type CompanyList_PointOfSaleFragment = { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, id: string, address: { __typename?: 'PointOfSaleAddress', line1: string, city: string }, subsidiary: { __typename?: 'Subsidiary', id: string } };

export type CompanyList_CompanyFragment = { __typename?: 'Company', code?: string | null, name?: string | null, id: string, pointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, id: string, address: { __typename?: 'PointOfSaleAddress', line1: string, city: string }, subsidiary: { __typename?: 'Subsidiary', id: string } } | null };

export type CompanyList_CurrentUserAccountsFragment = { __typename?: 'User', id: string, email?: string | null, company?: { __typename?: 'Company', code?: string | null, name?: string | null, id: string, pointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, id: string, address: { __typename?: 'PointOfSaleAddress', line1: string, city: string }, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type CompanyListCurrentUserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyListCurrentUserAccountsQuery = { __typename?: 'Query', currentUserAccounts?: Array<{ __typename?: 'User', id: string, email?: string | null, company?: { __typename?: 'Company', code?: string | null, name?: string | null, id: string, pointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, id: string, address: { __typename?: 'PointOfSaleAddress', line1: string, city: string }, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }> | null };

export type RegistrationActionQueryVariables = Exact<{
  companyNationalId: Scalars['String']['input'];
  isoCountryCode3?: InputMaybe<Scalars['IsoCountryCode3']['input']>;
}>;


export type RegistrationActionQuery = { __typename?: 'Query', registrationAction: RegistrationAction };

export type CompanyNationalIdInput_CompanyNationalIdFormatFragment = { __typename?: 'CompanyNationalIdFormat', charset: CompanyNationalIdCharset, isoCountryCode3: string, maxLength: number, minLength: number };

export type CompanyNationalIdConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyNationalIdConfigurationQuery = { __typename?: 'Query', config: { __typename?: 'Config', site?: { __typename?: 'ConfigSite', defaultCountryIso3: string } | null, customer?: { __typename?: 'ConfigCustomer', companyNationalIdConfig: { __typename?: 'CompanyNationalIdConfig', formatByCountry?: Array<{ __typename?: 'CompanyNationalIdFormat', charset: CompanyNationalIdCharset, isoCountryCode3: string, maxLength: number, minLength: number }> | null } } | null } };

export type GetAccountIdByCompanyNationalIdQueryVariables = Exact<{
  externalClientId: Scalars['String']['input'];
  companyNationalId: Scalars['String']['input'];
}>;


export type GetAccountIdByCompanyNationalIdQuery = { __typename?: 'Query', validateStoreCompany: { __typename?: 'ValidateStoreCompanyResponse', isValid: boolean } };

export type IsDoaFormLoyaltyStatusEligibleQueryVariables = Exact<{
  email: Scalars['String']['input'];
  companyNationalId: Scalars['String']['input'];
}>;


export type IsDoaFormLoyaltyStatusEligibleQuery = { __typename?: 'Query', isLoyaltyEligible: boolean };

export type IsDoaFormLoyaltyEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IsDoaFormLoyaltyEnabledQuery = { __typename?: 'Query', config: { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null } };

export type CurrentUserDoaFormQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserDoaFormQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null } | null };

export type CompanyNationalIdQueryVariables = Exact<{
  companyNationalId: Scalars['String']['input'];
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
}>;


export type CompanyNationalIdQuery = { __typename?: 'Query', companyNationalIdData?: { __typename?: 'CompanyNationalIdData', city?: string | null, companyName?: string | null, isoCountryCode?: any | null, postalCode?: string | null, streetLine1?: string | null, streetLine2?: string | null } | null };

export type GetDocUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null } | null };

export type DocForm_PointOfSaleAddressFragment = { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string };

export type DocForm_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, activity?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type DocFormPointsOfSaleByPostalCodeQueryVariables = Exact<{
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
  companyNationalId: Scalars['String']['input'];
}>;


export type DocFormPointsOfSaleByPostalCodeQuery = { __typename?: 'Query', pointOfSaleWithDistanceInvoice?: Array<{ __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, activity?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null };

export type BusinessContactExpressDocAllowedPhoneCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessContactExpressDocAllowedPhoneCountriesQuery = { __typename?: 'Query', companyRegistrationRequestAvailableCountries?: Array<{ __typename?: 'Country', iso: string } | null> | null };

export type VerifyCaptchaMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyCaptchaMutation = { __typename?: 'Mutation', verifyCaptcha: boolean };

export type CaptchaConfigFragment = { __typename?: 'ConfigCaptcha', isEnabled: boolean, siteKey: string };

export type LoginFormConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginFormConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', captcha?: { __typename?: 'ConfigCaptcha', isEnabled: boolean, siteKey: string } | null, support?: { __typename?: 'ConfigSupport', isLoginAsEnabled: boolean } | null } };

export type UserInformationForm_UserFragment = { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, emailPreferences?: Array<{ __typename?: 'EmailPreference', emailType: string, receiveEmail: boolean } | null> | null, permissions?: { __typename?: 'CollaboratorPermissions', showPreferenceCommunication: boolean } | null, company?: { __typename?: 'Company', id: string, name?: string | null, code?: string | null } | null };

export type NavigationHubOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationHubOrdersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, showStoreOrderHistory: boolean, hasAccessToWebOrders: boolean } | null } | null, config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null } };

export type NavigationHubQuickOrderQueryVariables = Exact<{
  isQuoteEnabled: Scalars['Boolean']['input'];
}>;


export type NavigationHubQuickOrderQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote?: boolean } | null } | null, config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isQuickOrderEnabled: boolean } | null, quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type NavigationHubQuotesQueryVariables = Exact<{
  isQuoteEnabled: Scalars['Boolean']['input'];
}>;


export type NavigationHubQuotesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, hasProcessingQuotes: boolean, permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote?: boolean } | null } | null, config: { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type SelectCompanyCard_UserFragment = { __typename?: 'User', id: string, email?: string | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, subsidiary: { __typename?: 'Subsidiary', id: string }, address: { __typename?: 'PointOfSaleAddress', line1: string } } | null } | null };

export type UsernameFormatQueryVariables = Exact<{ [key: string]: never; }>;


export type UsernameFormatQuery = { __typename?: 'Query', config: { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', nameFormat: { __typename?: 'NameFormat', maxLength: number, charset: string, regex: string } } | null } };

export type RequestCompanyRegistrationAction_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, distributionNetworkLabel?: string | null, phoneNumber?: string | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string }, address: { __typename?: 'PointOfSaleAddress', line1: string, line2?: string | null, line3?: string | null, postalCode: string, city: string, isoCountryCode: any } };

export type RequestCompanyRegistration_CompanyRegistrationResultFragment = { __typename?: 'CompanyRegistrationResult', code?: string | null, name?: string | null, companyNationalId?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, distributionNetworkLabel?: string | null, phoneNumber?: string | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string }, address: { __typename?: 'PointOfSaleAddress', line1: string, line2?: string | null, line3?: string | null, postalCode: string, city: string, isoCountryCode: any } } | null };

export type RequestUseRegistration_CompanyFragment = { __typename?: 'Company', code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null };

export type LoginActionQueryVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type LoginActionQuery = { __typename?: 'Query', loginAction: { __typename?: 'LoginAction', action: LoginActionEnum, url?: string | null, email?: string | null } };

export type RequestUseRegistrationMutationVariables = Exact<{
  input: UserRegistrationRequestInput;
}>;


export type RequestUseRegistrationMutation = { __typename?: 'Mutation', requestUserRegistration: { __typename?: 'UserRegistrationRequestAction', email?: string | null, action?: UserRegistrationRequestEnum | null, url?: string | null, company?: { __typename?: 'Company', code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', name: string, id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null } };

export type RequestCompanyRegistrationMutationVariables = Exact<{
  input: CompanyRegistrationRequestInput;
}>;


export type RequestCompanyRegistrationMutation = { __typename?: 'Mutation', requestCompanyRegistration: { __typename?: 'CompanyRegistrationRequestAction', action: CompanyRegistrationRequestEnum, url?: string | null, email: string, company: { __typename?: 'CompanyRegistrationResult', code?: string | null, name?: string | null, companyNationalId?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, distributionNetworkLabel?: string | null, phoneNumber?: string | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string }, address: { __typename?: 'PointOfSaleAddress', line1: string, line2?: string | null, line3?: string | null, postalCode: string, city: string, isoCountryCode: any } } | null } } };

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: boolean };

export type SelectUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type SelectUserMutation = { __typename?: 'Mutation', selectUser: boolean };

export type ProfessionActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionActivitiesQuery = { __typename?: 'Query', professionActivities?: Array<{ __typename?: 'ProfessionActivity', name: string, id: number, specialities?: Array<{ __typename?: 'ProfessionActivitySpeciality', name: string, id: number, activityId: number }> | null } | null> | null };

export type ActivityFragment = { __typename?: 'ProfessionActivity', name: string, id: number, specialities?: Array<{ __typename?: 'ProfessionActivitySpeciality', name: string, id: number, activityId: number }> | null };

export type SpecialtyFragment = { __typename?: 'ProfessionActivitySpeciality', name: string, id: number, activityId: number };

export type UpdateFavoriteShippingAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type UpdateFavoriteShippingAddressMutation = { __typename?: 'Mutation', updateFavoriteShippingAddress: boolean };

export type DeleteAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteUserCompanyAddress: { __typename?: 'AddressActionResponse', isActionDeferred: boolean } };

export type AdressesContainerCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AdressesContainerCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, favoriteBillingAddress?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null, favoriteShippingAddress?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null, company?: { __typename?: 'Company', id: string, addresses?: Array<{ __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType }> | null } | null } | null };

export type UserCompanyAddressFragment = { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType };

export type CartAddressFragment = { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null };

export type UniversalAddressInputDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UniversalAddressInputDataQuery = { __typename?: 'Query', availableCountries?: Array<{ __typename?: 'Country', iso: string, iso3: string, name: string } | null> | null, config: { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', allowedPostcodePrefixes?: Array<string> | null } | null } };

export type ServiceAddressMetadataFragment = { __typename?: 'ServiceAddress', streetId: string, latitude?: string | null, longitude?: string | null };

export type UniversalAddressInputSearchCitiesQueryVariables = Exact<{
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
  postalCode: Scalars['String']['input'];
}>;


export type UniversalAddressInputSearchCitiesQuery = { __typename?: 'Query', searchCities: Array<{ __typename?: 'ServiceCity', cityId: string, name: string, postalCode: string, isoCountryCode3: any }> };

export type UniversalAddressInputSearchAddressesQueryVariables = Exact<{
  isoCountryCode3: Scalars['IsoCountryCode3']['input'];
  cityId: Scalars['String']['input'];
  address: Scalars['String']['input'];
}>;


export type UniversalAddressInputSearchAddressesQuery = { __typename?: 'Query', searchAddresses: Array<{ __typename?: 'ServiceAddress', streetNumber: string, streetType: string, streetName: string, streetId: string, latitude?: string | null, longitude?: string | null }> };

export type OpenAddressDrawerButtonCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenAddressDrawerButtonCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, favoriteBillingAddress?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null, favoriteShippingAddress?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null, company?: { __typename?: 'Company', id: string, addresses?: Array<{ __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType }> | null } | null, permissions?: { __typename?: 'CollaboratorPermissions', canManageAddress: boolean } | null } | null };

export type SelectAddressCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectAddressCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, favoriteShippingAddress?: { __typename?: 'UserCompanyAddress', id: string, city: string, isoCountryCode: any, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null, company?: { __typename?: 'Company', id: string, addresses?: Array<{ __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType }> | null } | null, checkout?: { __typename?: 'Checkout', shipping?: { __typename?: 'Shipping', address?: { __typename?: 'CartAddress', userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null } | null } | null } | null };

export type UpsertAddressDrawerCartQueryVariables = Exact<{ [key: string]: never; }>;


export type UpsertAddressDrawerCartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type GetCurrentUserNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserNameQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null };

export type CreateAddressMutationVariables = Exact<{
  input: UserCompanyAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createUserCompanyAddress: { __typename?: 'AddressActionResponse', isActionDeferred: boolean, address?: { __typename?: 'UserCompanyAddress', city: string, isoCountryCode: any, id: string, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null } };

export type UpdateAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  input: UserCompanyAddressInput;
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateUserCompanyAddress: { __typename?: 'AddressActionResponse', isActionDeferred: boolean, address?: { __typename?: 'UserCompanyAddress', id: string, city: string, isoCountryCode: any, isDefault: boolean, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string, primary: boolean, type: UserCompanyAddressType } | null } };

export type ApprovalFlowTable_CompanyFragment = { __typename?: 'Company', approvalFlows: { __typename?: 'ApprovalFlowPagination', totalPages?: number | null, totalSize?: number | null, items: Array<{ __typename?: 'ApprovalFlow', minimumAmount?: number | null, id: string, name: string, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }> }> } };

export type ApprovalFlowTable_ApprovalFlowFragment = { __typename?: 'ApprovalFlow', id: string, name: string, minimumAmount?: number | null, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }> };

export type ApprovalFlowTable_UserFragment = { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null };

export type GetApprovalFlowsQueryVariables = Exact<{
  input?: InputMaybe<Browsing>;
}>;


export type GetApprovalFlowsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, approvalFlows: { __typename?: 'ApprovalFlowPagination', totalPages?: number | null, totalSize?: number | null, items: Array<{ __typename?: 'ApprovalFlow', minimumAmount?: number | null, id: string, name: string, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }> }> } } | null } | null };

export type GetUsersInApprovalFlowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersInApprovalFlowsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, usersInApprovalFlows?: Array<{ __typename?: 'UserPartialInfos', id: string, firstname: string, lastname: string }> | null } | null } | null };

export type ApproveesSelectQueryVariables = Exact<{
  approvalFlowId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveesSelectQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, eligibleApprovees?: Array<{ __typename?: 'UserPartialInfos', firstname: string, lastname: string, id: string }> | null } | null } | null };

export type ApproversSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ApproversSelectQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, eligibleApprovers?: Array<{ __typename?: 'UserPartialInfos', firstname: string, lastname: string, id: string }> | null } | null } | null };

export type UpsertApprovalFlowDrawer_ApprovalFlowFragment = { __typename?: 'ApprovalFlow', id: string, name: string, minimumAmount?: number | null, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null }> };

export type UpdateApprovalFlowMutationVariables = Exact<{
  input: ApprovalFlowUpdateInput;
}>;


export type UpdateApprovalFlowMutation = { __typename?: 'Mutation', updateApprovalFlow: boolean };

export type CreateApprovalFlowMutationVariables = Exact<{
  input: ApprovalFlowCreateInput;
}>;


export type CreateApprovalFlowMutation = { __typename?: 'Mutation', createApprovalFlow: boolean };

export type DeleteApprovalFlowMutationVariables = Exact<{
  approvalFlowId: Scalars['ID']['input'];
}>;


export type DeleteApprovalFlowMutation = { __typename?: 'Mutation', deleteApprovalFlow: boolean };

export type ImpersonationBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpersonationBannerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null } | null } | null };

export type GenerateImpersonateAuthTokenMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GenerateImpersonateAuthTokenMutation = { __typename?: 'Mutation', generateImpersonateAuthToken: { __typename?: 'Token', value: string, maxAge?: number | null } };

export type AlreadyActiveAccountQueryVariables = Exact<{
  externalClientId: Scalars['String']['input'];
  companyNationalId: Scalars['String']['input'];
}>;


export type AlreadyActiveAccountQuery = { __typename?: 'Query', validateStoreCompany: { __typename?: 'ValidateStoreCompanyResponse', company?: { __typename?: 'Company', id: string, code?: string | null, managerEmailHidden: string } | null } };

export type AlreadyActiveAccountFragment = { __typename?: 'Company', id: string, code?: string | null, managerEmailHidden: string };

export type PunchoutLogin_TokenFragment = { __typename?: 'Token', maxAge?: number | null, type: TokenType, value: string };

export type PunchoutLoginMutationVariables = Exact<{
  url: Scalars['URL']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
}>;


export type PunchoutLoginMutation = { __typename?: 'Mutation', punchoutLogin: { __typename?: 'PunchoutLogin', token: { __typename?: 'Token', maxAge?: number | null, type: TokenType, value: string }, additionalInformation?: { __typename?: 'PunchoutLoginAdditionalInformation', backToERPUrl?: string | null } | null } };

export type GetPunchoutEnabledConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPunchoutEnabledConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isPunchoutEnabled: boolean } | null } };

export type BilltrustQueryVariables = Exact<{ [key: string]: never; }>;


export type BilltrustQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', billtrust: { __typename?: 'Billtrust', urlredirect?: string | null } } | null };

export type GetBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsQuery = { __typename?: 'Query', brands?: Array<{ __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type CartItemLimitedQuantityBox_ItemFragment = { __typename?: 'CartItem', id?: any | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type CartItemPaymentWarningQueryVariables = Exact<{ [key: string]: never; }>;


export type CartItemPaymentWarningQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', payment?: { __typename?: 'Payment', availableMethods?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', status: PaymentStatus } | null } | null } | null } | null } | null };

export type CartItemReadOnlyRowInfosFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type CartItemsSummaryAccordionCard_SectionsFragment = { __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null };

export type CartItemsSummaryAccordionCard_ItemsFragment = { __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type CartActionsCard_ItemFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string } | null };

export type CartActionsCard_CartFragment = { __typename?: 'Cart', id: string, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string } | null }> | null }> | null };

export type CartActionsCart_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartActionsCart_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, loginType: LoginType, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string } | null }> | null }> | null } } | null } | null };

export type ExportCartIntoPunchoutFormatMutationVariables = Exact<{
  format: Punchoutformat;
}>;


export type ExportCartIntoPunchoutFormatMutation = { __typename?: 'Mutation', exportCartIntoPunchoutFormat: { __typename?: 'ExportCartIntoPunchoutOutput', filename: string, content: string, mimeType: string } };

export type CartFixedBar_CartFragment = { __typename?: 'Cart', totalExclTax?: number | null };

export type CartItemsSectionLabel_SectionFragment = { __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } };

export type CartPdfTemplate_CurrentUserFragment = { __typename?: 'User', email?: string | null, firstname?: string | null, lastname?: string | null, company?: { __typename?: 'Company', name?: string | null, code?: string | null } | null };

export type CartPdfTemplate_ProductFragment = { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type CartPdfTemplate_CartFragment = { __typename?: 'Cart', id: string, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename: 'CartItemsSectionInfoClickAndCollect' } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null }> | null };

export type CartSummaryPricing_CartFragment = { __typename?: 'Cart', id: string, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null };

export type CartSummaryPricing_ShippingFragment = { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null };

export type CartSummaryPricing_OrderFragment = { __typename: 'Order', totalAmount?: number | null, totalEcoPart?: number | null, totalDiscount?: number | null, totalOrderedProducts?: number | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null };

export type CartSummaryPricingQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
  isOrderRequest: Scalars['Boolean']['input'];
}>;


export type CartSummaryPricingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null, orderRequests?: { __typename?: 'OrderPagination', items?: Array<{ __typename: 'Order', subtotalExclTax?: number | null, totalAmount?: number | null, totalEcoPart?: number | null, totalDiscount?: number | null, totalOrderedProducts?: number | null, payment?: { __typename?: 'OrderPayment', orderReference?: string | null, code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null> | null } } | null };

export type CartSummary_CartFragment = { __typename?: 'Cart', subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null };

export type CartSummary_ShippingFragment = { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null };

export type CartSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CartSummaryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null } | null };

export type Cart_CartFragment = { __typename?: 'Cart', id: string, totalQuantity?: number | null, couponCode?: string | null, legalNotices?: Array<string | null> | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string } | null }> | null }> | null };

export type Cart_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, legalNotices?: Array<string | null> | null, couponCode?: string | null, isClickAndCollectActivated: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, isClickAndCollectFeatureAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, sumItemsQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, loginType: LoginType, checkout?: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, legalNotices?: Array<string | null> | null, couponCode?: string | null, isClickAndCollectActivated: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, isClickAndCollectFeatureAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, sumItemsQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null, company?: { __typename?: 'Company', id: string, forbidden: boolean } | null } | null };

export type AddProductReferenceForm_CartFragment = { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, items?: Array<{ __typename?: 'CartItem', id?: any | null, product?: { __typename?: 'Product', reference: string } | null } | null> | null };

export type AddProductReference_AddProductToCartMutationVariables = Exact<{
  reference: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  cartId: Scalars['String']['input'];
}>;


export type AddProductReference_AddProductToCartMutation = { __typename?: 'Mutation', addProductToCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', isClickAndCollectToggleAvailable: boolean, isClickAndCollectFeatureAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null, id: string, isClickAndCollectActivated: boolean, hasClickAndCollectOnlyItems: boolean, sumItemsQuantity?: number | null, messages?: Array<{ __typename?: 'CartMessage', code: CartMessageCode, message: string } | null> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, availableClickAndCollect: boolean, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type CartContent_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, legalNotices?: Array<string | null> | null, couponCode?: string | null, isClickAndCollectActivated: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, isClickAndCollectFeatureAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, sumItemsQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null } };

export type CartContent_CartFragment = { __typename?: 'Cart', id: string, totalQuantity?: number | null, legalNotices?: Array<string | null> | null, couponCode?: string | null, isClickAndCollectActivated: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, isClickAndCollectFeatureAvailable: boolean, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, product?: { __typename?: 'Product', reference: string } | null } | null> | null };

export type CartItem_ItemFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null };

export type CartItem_CartFragment = { __typename?: 'Cart', subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null };

export type UpdateCartItemQuantityMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItemUid: Scalars['UUID']['input'];
  quantity: Scalars['Float']['input'];
}>;


export type UpdateCartItemQuantityMutation = { __typename?: 'Mutation', updateCartItemQuantity: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null, id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, sumItemsQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type RemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItemUid: Scalars['UUID']['input'];
}>;


export type RemoveItemFromCartMutation = { __typename?: 'Mutation', removeItemFromCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', totalQuantity?: number | null, sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, id: string, hasClickAndCollectOnlyItems: boolean, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type CartItems_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type CartItems_ItemsSectionFragment = { __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } };

export type CartItems_CartFragment = { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null };

export type CartItemsWarnings_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartItemsWarnings_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, isClickAndCollectFeatureAvailable: boolean, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null } } | null } | null };

export type CartItemsWarnings_CartFragment = { __typename?: 'Cart', id: string, isClickAndCollectFeatureAvailable: boolean, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null };

export type UpdateStocksAndPricesOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type UpdateStocksAndPricesOnCartMutation = { __typename?: 'Mutation', updateStocksAndPricesOnCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type CheckoutCartContentToasts_MessagesFragment = { __typename?: 'CartMessage', message: string };

export type CheckoutCartSubmit_UpdateStocksAndPricesMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type CheckoutCartSubmit_UpdateStocksAndPricesMutation = { __typename?: 'Mutation', updateStocksAndPricesOnCart: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, totalQuantity?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null } | null } };

export type CheckoutCartForm_UserFragment = { __typename?: 'User', id: string, role?: UserRole | null, company?: { __typename?: 'Company', id: string, forbidden: boolean } | null, checkout?: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string } } | null };

export type EmptyCart_CartQueryVariables = Exact<{ [key: string]: never; }>;


export type EmptyCart_CartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, messages?: Array<{ __typename?: 'CartMessage', code: CartMessageCode } | null> | null } } | null } | null };

export type ClickAndCollectSwitchBanner_CartFragment = { __typename?: 'Cart', id: string, sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type SetIsClickAndCollectOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  isClickAndCollect: Scalars['Boolean']['input'];
}>;


export type SetIsClickAndCollectOnCartMutation = { __typename?: 'Mutation', setIsClickAndCollectOnCart: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, legalNotices?: Array<string | null> | null, couponCode?: string | null, isClickAndCollectActivated: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, isClickAndCollectFeatureAvailable: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, sumItemsQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type ConfirmClearCart_CartFragment = { __typename?: 'Cart', id: string };

export type ClearCartItemsMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type ClearCartItemsMutation = { __typename?: 'Mutation', clearCartItems: boolean };

export type ConvertOrderRequestDeliveryDrawer_CartFragment = { __typename?: 'Cart', id: string };

export type MiniCart_CartFragment = { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null };

export type MiniCart_ItemFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null };

type MiniCart_ShippingFee_ShippingFeeFree_Fragment = { __typename?: 'ShippingFeeFree', isFranco?: boolean | null };

type MiniCart_ShippingFee_ShippingFeeWithAmount_Fragment = { __typename?: 'ShippingFeeWithAmount', amount: number };

export type MiniCart_ShippingFeeFragment = MiniCart_ShippingFee_ShippingFeeFree_Fragment | MiniCart_ShippingFee_ShippingFeeWithAmount_Fragment;

export type ResolveClickAndCollectOfCartItemsDrawer_ItemsFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type UpdateClickAndCollectCartItemsQuantitiesMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItems: Array<ClickAndCollectCartItemUpdateInput> | ClickAndCollectCartItemUpdateInput;
}>;


export type UpdateClickAndCollectCartItemsQuantitiesMutation = { __typename?: 'Mutation', updateClickAndCollectCartItemsQuantities: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, couponCode?: string | null, legalNotices?: Array<string | null> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null } | null> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type MiniCartQueryVariables = Exact<{ [key: string]: never; }>;


export type MiniCartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null } } | null } | null };

export type UseCartIdQueryVariables = Exact<{ [key: string]: never; }>;


export type UseCartIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type Cart_PointOfSaleAddressFragment = { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string };

export type PointOfSaleFragmentFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type BaseProductFragment = { __typename?: 'Product', reference: string, name?: string | null, urlKey?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type BaseCartItemFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, quantityMax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null };

export type ExtendedProductFragment = { __typename?: 'Product', type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, reference: string, name?: string | null, urlKey?: string | null, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean }, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type CartItemFieldsFragment = { __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, quantityMax?: number | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, urlKey?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, options?: { __typename?: 'CartItemOptions', isClickAndCollect: boolean } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null };

export type CartItemRowInfosFragment = { __typename?: 'CartItem', quantity: number, hasPaymentWarning: boolean, availableClickAndCollect: boolean, id?: any | null, totalExclTax?: number | null, quantityMax?: number | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, discount?: { __typename?: 'CartItemDiscount', percentage?: number | null, catalogDiscountAmount?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, urlKey?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, options?: { __typename?: 'CartItemOptions', isClickAndCollect: boolean } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null };

export type AddToCartTrackingQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AddToCartTrackingQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, promoPriceCode?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null } | null, currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, currency?: string | null, couponCode?: string | null } } | null } | null };

export type CartItemTrackingMultipleQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CartItemTrackingMultipleQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', name?: string | null, reference: string, parentReference?: string | null, type: ProductType, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, promoPriceCode?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null }> | null };

export type CartUserTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type CartUserTrackingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, currency?: string | null, totalExclTax?: number | null, couponCode?: string | null } } | null } | null };

export type CartTracking_CartFragment = { __typename?: 'Cart', isClickAndCollectActivated: boolean, totalExclTax?: number | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, availableClickAndCollect: boolean, totalExclTax?: number | null, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null }> | null }> | null };

export type CartTracking_ItemFragment = { __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, availableClickAndCollect: boolean, totalExclTax?: number | null, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null };

export type CartEmptyProbeQueryVariables = Exact<{ [key: string]: never; }>;


export type CartEmptyProbeQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null } } | null } | null };

export type PunchoutCartEmptyProbeQueryVariables = Exact<{ [key: string]: never; }>;


export type PunchoutCartEmptyProbeQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null } | null } } | null };

export type GetTenantBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetTenantBySlugQuery = { __typename?: 'Query', CMS_Tenants?: { __typename?: 'CMS_Tenants', docs: Array<{ __typename?: 'CMS_Tenant', id: number }> } | null };

export type IsCmsHeadlessPageExistsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  tenantId: Scalars['JSON']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IsCmsHeadlessPageExistsQuery = { __typename?: 'Query', CMS_Pages?: { __typename?: 'CMS_Pages', docs: Array<{ __typename?: 'CMS_Page', id: number }> } | null };

export type CmsPageQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type CmsPageQuery = { __typename?: 'Query', cmsPage?: { __typename?: 'CmsPage', code: string, metadata: string, jsonContent: string } | null };

export type GetCollaboratorsQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetCollaboratorsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, users: { __typename?: 'UserPagination', totalPages?: number | null, totalSize?: number | null, items: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }> } } | null } | null };

export type GetAvailableUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableUserRolesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, availableUserRoles: Array<UserRole> } | null } | null };

export type Collaborator_UserFragment = { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean };

export type ApprovalFlowsApprovers_CompanyFragment = { __typename?: 'Company', approvalFlows: { __typename?: 'ApprovalFlowPagination', items: Array<{ __typename?: 'ApprovalFlow', approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }> }> } };

export type Collaborators_CompanyFragment = { __typename?: 'Company', users: { __typename?: 'UserPagination', totalPages?: number | null, totalSize?: number | null, items: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }> } };

export type RoleInfoDrawerCurrentUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleInfoDrawerCurrentUserRolesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', role?: UserRole | null, company?: { __typename?: 'Company', availableUserRoles: Array<UserRole> } | null, permissions?: { __typename?: 'CollaboratorPermissions', allowedRolesToManage: Array<UserRole> } | null } | null };

export type UpdateCollaboratorMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateCollaboratorMutation = { __typename?: 'Mutation', updateUser: boolean };

export type ApprovalFlowByUserFragment = { __typename?: 'ApprovalFlow', id: string, name: string, minimumAmount?: number | null, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }> };

export type CollaboratorPermissionsFragment = { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', allowedRolesToManage: Array<UserRole>, canManageApprovalFlows: boolean } | null };

export type CollaboratorPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollaboratorPermissionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', allowedRolesToManage: Array<UserRole>, canManageApprovalFlows: boolean } | null } | null };

export type GetApprovalFlowByUserQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetApprovalFlowByUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, approvalFlows: { __typename?: 'ApprovalFlowPagination', items: Array<{ __typename?: 'ApprovalFlow', id: string, name: string, minimumAmount?: number | null, approvers: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }>, approvees: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, phone?: string | null, canBeEdited: boolean, canBeDeleted: boolean }> }> } } | null } | null };

export type CreateCollaboratorMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type CreateCollaboratorMutation = { __typename?: 'Mutation', createUser: boolean };

export type DeleteCollaboratorMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DeleteCollaboratorMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type SiteConfigFragment = { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', isPublicPricesEnabled: boolean, isPublicStockEnabled: boolean, isConnectedLocalStockVisible: boolean, lengthReference?: string | null, isProductLabelGenerationEnabled: boolean, isStoreNameDisplayedOnProductLabel: boolean, isActiveHideVatPrice: boolean } | null, customer?: { __typename?: 'ConfigCustomer', isAccountCreationEnabled: boolean, isAddressAutocompleteEnabled: boolean, isAddressCreationEnabled: boolean, isAddressDeletionEnabled: boolean, isAddressEditionEnabled: boolean, europeanCountries: Array<{ __typename?: 'Country', iso: string, name: string }> } | null, pointOfSale?: { __typename?: 'ConfigPointOfSale', storeLocatorUrl?: string | null, isLocalStockByStoreEnabled: boolean, isSubsidiaryDisplayEnabled: boolean } | null, sales?: { __typename?: 'ConfigSales', isChorusDisplayEnabled: boolean, isClickAndCollectEnabled?: boolean | null, isPunchoutLightEnabled: boolean, isQuickOrderEnabled: boolean, orderReferenceRegex?: string | null, deliveryTime?: { __typename?: 'ConfigDeliveryTime', nbDayMinimum: number, nbDayMaximum: number, isSaturdayAvailable: boolean, isSundayAvailable: boolean } | null } | null, quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null, site?: { __typename?: 'ConfigSite', defaultCountryIso2: string } | null };

export type __Private__UseSiteConfig__QueryVariables = Exact<{ [key: string]: never; }>;


export type __Private__UseSiteConfig__Query = { __typename?: 'Query', config: { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', isPublicPricesEnabled: boolean, isPublicStockEnabled: boolean, isConnectedLocalStockVisible: boolean, lengthReference?: string | null, isProductLabelGenerationEnabled: boolean, isStoreNameDisplayedOnProductLabel: boolean, isActiveHideVatPrice: boolean } | null, customer?: { __typename?: 'ConfigCustomer', isAccountCreationEnabled: boolean, isAddressAutocompleteEnabled: boolean, isAddressCreationEnabled: boolean, isAddressDeletionEnabled: boolean, isAddressEditionEnabled: boolean, europeanCountries: Array<{ __typename?: 'Country', iso: string, name: string }> } | null, pointOfSale?: { __typename?: 'ConfigPointOfSale', storeLocatorUrl?: string | null, isLocalStockByStoreEnabled: boolean, isSubsidiaryDisplayEnabled: boolean } | null, sales?: { __typename?: 'ConfigSales', isChorusDisplayEnabled: boolean, isClickAndCollectEnabled?: boolean | null, isPunchoutLightEnabled: boolean, isQuickOrderEnabled: boolean, orderReferenceRegex?: string | null, deliveryTime?: { __typename?: 'ConfigDeliveryTime', nbDayMinimum: number, nbDayMaximum: number, isSaturdayAvailable: boolean, isSundayAvailable: boolean } | null } | null, quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null, site?: { __typename?: 'ConfigSite', defaultCountryIso2: string } | null } };

export type ConfirmationClickAndCollectCard_PointOfSaleFragment = { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, id: string, open: boolean, subsidiary: { __typename?: 'Subsidiary', name: string, id: string }, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string } };

export type ConfirmationContactCard_PointOfSaleFragment = { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null };

export type OrderItemProductFragment = { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } };

export type OrderItemFragment = { __typename?: 'OrderItem', analyticsPromotionStatus?: string | null, totalExclTax: number, quantity: number, coupon?: string | null, product?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null } };

export type OrderItemsSectionFragment = { __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', analyticsPromotionStatus?: string | null, totalExclTax: number, quantity: number, coupon?: string | null, product?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null } }> | null };

export type OrderDetailsFragment = { __typename?: 'Order', transactionId?: string | null, isUniversalDiscount?: boolean | null, coupon?: string | null, totalVat?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', analyticsPromotionStatus?: string | null, totalExclTax: number, quantity: number, coupon?: string | null, product?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null } }> | null }> | null };

export type OrderInfoTrackingQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type OrderInfoTrackingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, currency?: string | null } } | null, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', transactionId?: string | null, isUniversalDiscount?: boolean | null, coupon?: string | null, totalVat?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', analyticsPromotionStatus?: string | null, totalExclTax: number, quantity: number, coupon?: string | null, product?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null } }> | null }> | null } | null> | null } } | null };

export type ConfirmationStorePickupCard_PointOfSaleFragment = { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, id: string, open: boolean, subsidiary: { __typename?: 'Subsidiary', name: string, id: string }, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string } };

export type ConfirmationSummaryCard_OrderFragment = { __typename?: 'Order', internalRef?: string | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, webRef?: string | null, wentThroughApproval: boolean, items?: Array<{ __typename?: 'OrderItem', reference: string }> | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null };

export type CheckoutConfirmationQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
  marketingCardType?: InputMaybe<EventPageType>;
}>;


export type CheckoutConfirmationQuery = { __typename?: 'Query', config: { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', isOrderMarketingThresholdEnabled: boolean, orderMarketingThresholdAmount?: number | null } | null, pointOfSale?: { __typename?: 'ConfigPointOfSale', isPickupPointOfSaleEnabled: boolean } | null, sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null }, marketingCards?: Array<{ __typename?: 'EventCard', openInNewTab: boolean, id: string, backgroundColor?: string | null, baseline?: string | null, baselineColor?: string | null, link?: string | null, linkColor?: string | null, linkTitle?: string | null, title: string, titleColor?: string | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null> | null, currentUser?: { __typename?: 'User', id: string, email?: string | null, company?: { __typename?: 'Company', pointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null } | null } | null, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, internalRef?: string | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, webRef?: string | null, wentThroughApproval: boolean, collectPointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, id: string, open: boolean, subsidiary: { __typename?: 'Subsidiary', id: string, name: string }, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string } } | null, items?: Array<{ __typename?: 'OrderItem', reference: string }> | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null } | null> | null } } | null };

export type FaqConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', support?: { __typename?: 'ConfigSupport', enableFaq: boolean } | null } };

export type SubmitContactRequestMutationVariables = Exact<{
  input: ContactRequestInput;
}>;


export type SubmitContactRequestMutation = { __typename?: 'Mutation', submitContactRequest: boolean };

export type ContactTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactTypeSelectQuery = { __typename?: 'Query', contactFormSubjects: Array<{ __typename?: 'ContactSubjectCategory', id: number, label: string, type: string, subjects: Array<{ __typename?: 'ContactSubject', code: string, id: number, name: string }> } | null> };

export type ContactForm_PointsOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, address: { __typename?: 'PointOfSaleAddress', department: string, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string, id: string } };

export type ContactForm_UserFragment = { __typename?: 'User', email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, siret: string, code?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, address: { __typename?: 'PointOfSaleAddress', department: string, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string, id: string } } | null } | null };

export type ContactPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPageDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, siret: string, code?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, address: { __typename?: 'PointOfSaleAddress', department: string, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string, id: string } } | null } | null } | null };

export type ContactPointsOfSaleQueryVariables = Exact<{
  input?: InputMaybe<Browsing>;
}>;


export type ContactPointsOfSaleQuery = { __typename?: 'Query', pointsOfSale: { __typename?: 'PointOfSalePagination', items: Array<{ __typename?: 'PointOfSale', id: string, name: string, address: { __typename?: 'PointOfSaleAddress', department: string, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string, id: string } }> } };

export type SimplifiedContactPageConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SimplifiedContactPageConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', support?: { __typename?: 'ConfigSupport', isGlobalClick2ChatEnabled: boolean } | null } };

export type ContactCardFragment = { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null, comment?: string | null };

export type ApplyCouponToCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  couponCode: Scalars['String']['input'];
}>;


export type ApplyCouponToCartMutation = { __typename?: 'Mutation', applyCouponToCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, couponCode?: string | null, legalNotices?: Array<string | null> | null, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type RemoveCouponFromCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type RemoveCouponFromCartMutation = { __typename?: 'Mutation', removeCouponFromCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, couponCode?: string | null, legalNotices?: Array<string | null> | null, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, isClickAndCollectToggleAvailable: boolean, hasClickAndCollectOnlyItems: boolean, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, warnings?: Array<{ __typename?: 'CartItemWarning', type: CartItemWarningType, message: string, additionalData?: Array<{ __typename?: 'KeyValue', value?: string | null, key?: string | null } | null> | null } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, items?: Array<{ __typename?: 'CartItem', quantity: number, id?: any | null, quantityMax?: number | null, totalExclTax?: number | null, hasPaymentWarning: boolean, availableClickAndCollect: boolean, analyticsPromotionStatus?: string | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean } | null> | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect' } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } }> | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type ApplyCouponCodeForm_CartFragment = { __typename?: 'Cart', id: string, couponCode?: string | null, legalNotices?: Array<string | null> | null };

export type CurrentUser_DashboardMenuHeaderCardsFragment = { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, distributionNetworkLabel?: string | null, subsidiary: { __typename?: 'Subsidiary', name: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null } | null };

export type CurrentUserAccounts_DashboardMenuHeaderCardsFragment = { __typename?: 'User', id: string };

export type AvailablePointsOfSale_DashboardMenuHeaderCardsFragment = { __typename?: 'User', availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string }> | null };

export type DashboardMenu_CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMenu_CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, distributionNetworkLabel?: string | null, subsidiary: { __typename?: 'Subsidiary', name: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null } | null, availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string }> | null } | null };

export type DashboardMenu_CurrentUserAccountsQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
}>;


export type DashboardMenu_CurrentUserAccountsQuery = { __typename?: 'Query', currentUserAccounts?: Array<{ __typename?: 'User', id: string }> | null };

export type DashboardMenu_ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMenu_ConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean } | null } };

export type DashboardWebshopConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardWebshopConfigsQuery = { __typename?: 'Query', config: { __typename?: 'Config', quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null, loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null, customer?: { __typename?: 'ConfigCustomer', isTopPurchaseEnabled: boolean } | null, checkout?: { __typename?: 'ConfigCheckout', isActiveOrderRequest: boolean } | null, sales?: { __typename?: 'ConfigSales', isQuickOrderEnabled: boolean, isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null } };

export type DashboardUserQuoteConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUserQuoteConfigQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', canManageQuote: boolean } | null } | null };

export type DashboardMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMenuQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSubjectToApprovalFlow: boolean, hasProcessingQuotes: boolean, permissions?: { __typename?: 'CollaboratorPermissions', canApproveOrderRequest: boolean, canManageApprovalFlows: boolean, hasAccessToStoreOrders: boolean, hasAccessToWebOrders: boolean, showOrderHistory: boolean, showStoreOrderHistory: boolean, showCompanyUsers: boolean, hasAccessToOrderRequestToApprove: boolean } | null, orderRequests: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', webRef?: string | null } | null> | null }, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus } } | null };

export type DashboardApproverOrderRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardApproverOrderRequestsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orderRequests: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', webRef?: string | null } | null> | null } } | null };

export type AddProductToFavoritesList_ListFragment = { __typename?: 'Wishlist', id: number, name?: string | null };

export type GetUserFavoriteListsQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetUserFavoriteListsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, wishlists: { __typename?: 'WishlistPagination', items: Array<{ __typename?: 'Wishlist', id: number, name?: string | null }> } } | null };

export type AddProductReferenceQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AddProductReferenceQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string } | null };

export type AddProductToListMutationVariables = Exact<{
  input: WishlistUpdateInput_V2;
}>;


export type AddProductToListMutation = { __typename?: 'Mutation', updateWishlist_V2: { __typename?: 'Wishlist', id: number } };

export type DeleteFavoritesListMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFavoritesListMutation = { __typename?: 'Mutation', deleteWishlist: boolean };

export type FavoritesActionsList_PermissionsFragment = { __typename?: 'CollaboratorPermissions', canShareWishlist: boolean };

export type FavoritesDetailsPage_ProductFragment = { __typename?: 'ProductWishlist', comment?: string | null, quantity: number, id: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } };

export type FavoritesDetailsPage_WishlistFragment = { __typename?: 'Wishlist', id: number, createdAt: string, name?: string | null, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, comment?: string | null, id: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null };

export type GetFavoritesListProductsQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetFavoritesListProductsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, wishlists: { __typename?: 'WishlistPagination', items: Array<{ __typename?: 'Wishlist', id: number, createdAt: string, name?: string | null, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, comment?: string | null, id: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null }> } } | null };

export type UpdateFavoritesListMutationVariables = Exact<{
  input: WishlistUpdateInput_V2;
}>;


export type UpdateFavoritesListMutation = { __typename?: 'Mutation', updateWishlist_V2: { __typename?: 'Wishlist', id: number } };

export type FavoritesTable_FavoriteFragment = { __typename?: 'Wishlist', id: number, createdAt: string, name?: string | null, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, product: { __typename?: 'Product', reference: string } }> | null };

export type GetFavoritesTableQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetFavoritesTableQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, wishlists: { __typename?: 'WishlistPagination', totalPages?: number | null, items: Array<{ __typename?: 'Wishlist', id: number, createdAt: string, name?: string | null, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, product: { __typename?: 'Product', reference: string } }> | null }> } } | null };

export type ShareFavoritesListDrawerRecipientsQueryVariables = Exact<{
  type: SharingType;
}>;


export type ShareFavoritesListDrawerRecipientsQuery = { __typename?: 'Query', shareUserList?: Array<{ __typename?: 'UserPartialInfos', id: string, firstname: string, lastname: string, email: string }> | null };

export type ShareFavoriteListMutationVariables = Exact<{
  input: WishlistSharingInput;
}>;


export type ShareFavoriteListMutation = { __typename?: 'Mutation', shareWishlist: { __typename?: 'Wishlist', id: number } };

export type CreateFavoritesListMutationVariables = Exact<{
  input: WishlistCreateInput_V2;
}>;


export type CreateFavoritesListMutation = { __typename?: 'Mutation', createWishlist_V2: { __typename?: 'Wishlist', id: number, name?: string | null } };

export type GetFavoritesListCheckoutInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoritesListCheckoutInformationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type ProductFirstLevelCategoryFragment = { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null };

export type GetFavoritesListDetailQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetFavoritesListDetailQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', canShareWishlist: boolean } | null, wishlists: { __typename?: 'WishlistPagination', items: Array<{ __typename?: 'Wishlist', id: number, createdAt: string, name?: string | null, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, product: { __typename?: 'Product', reference: string, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null } }> | null }> } } | null };

export type Footer_ReassuranceCardsFragment = { __typename?: 'CMS_ReassuranceCardBlock', id?: string | null, blockType?: string | null, blockName?: string | null, illustration?: string | null, line1?: string | null, line2?: string | null, href?: string | null };

export type GetReassuranceCardsQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetReassuranceCardsQuery = { __typename?: 'Query', CMS_ReassuranceCards?: { __typename?: 'CMS_ReassuranceCards', docs: Array<{ __typename?: 'CMS_ReassuranceCard', layout: Array<{ __typename?: 'CMS_ReassuranceCardBlock', id?: string | null, blockType?: string | null, blockName?: string | null, illustration?: string | null, line1?: string | null, line2?: string | null, href?: string | null }> }> } | null };

export type Header_MenuEntryLinkFragment = { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type Header_MenuEntryCategoryFragment = { __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

type MenuEntry_MenuEntryCategory_Fragment = { __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

type MenuEntry_MenuEntryLink_Fragment = { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type MenuEntryFragment = MenuEntry_MenuEntryCategory_Fragment | MenuEntry_MenuEntryLink_Fragment;

export type HeaderButtonsV2_ConfigFragment = { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean, isLocalStockByStoreEnabled: boolean, isPickupPointOfSaleEnabled: boolean, storeLocatorUrl?: string | null, dashboardFavoritePointOfSaleImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type Header_NavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type Header_NavigationQuery = { __typename?: 'Query', menu?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, entries?: Array<{ __typename?: 'MenuEntryCategory', name?: string | null, baseline?: string | null, seoContent?: string | null, slug: string, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | { __typename?: 'MenuEntryLink', name?: string | null, baseline?: string | null, seoContent?: string | null, url: string, openInNewTab?: boolean | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type Header_PointOfSaleConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type Header_PointOfSaleConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean, isLocalStockByStoreEnabled: boolean, isPickupPointOfSaleEnabled: boolean, storeLocatorUrl?: string | null, dashboardFavoritePointOfSaleImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } };

export type Header_PickUpPointOfSaleQueryVariables = Exact<{
  pickupPointOfSaleId: Scalars['String']['input'];
}>;


export type Header_PickUpPointOfSaleQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', availablePointsOfSalePickup?: Array<{ __typename?: 'PointOfSale', id: string }> | null } | null, pickupPointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type SignedInPointOfSaleButton_PickupPointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string };

export type InternalClientPageQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalClientPageQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', email: string, firstname: string, lastname: string } | null };

export type SearchCompaniesQueryVariables = Exact<{
  input: Browsing;
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', searchCompanies: { __typename?: 'CompanyPagination', items: Array<{ __typename?: 'Company', id: string, code?: string | null, name?: string | null }> } };

export type SearchUsersQueryVariables = Exact<{
  input: Browsing;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: { __typename?: 'UserPagination', items: Array<{ __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: UserRole | null, company?: { __typename?: 'Company', id: string, code?: string | null, name?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, subsidiary: { __typename?: 'Subsidiary', id: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string } | null }> } };

export type GetUserLoyaltyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLoyaltyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus, data?: { __typename?: 'LoyaltyData', active: boolean, authLink?: string | null, boosterMonth?: string | null, customerStatus?: string | null, isResponsable: boolean, pointNumberExpiringThisYear: number, pointsBalance: number, responsableEmail?: string | null, state: string } | null } } | null };

export type LoyaltyConfigFragment = { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null };

export type LoyaltyOperationsLoyaltyDataPropsFragment = { __typename?: 'LoyaltyData', authLink?: string | null, currentSalesOperations?: Array<string> | null, eligibleOperations?: Array<string> | null };

export type GetLoyaltyOperationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyOperationsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus, data?: { __typename?: 'LoyaltyData', authLink?: string | null, currentSalesOperations?: Array<string> | null, eligibleOperations?: Array<string> | null } | null } } | null };

export type DashboardUserLoyaltyStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUserLoyaltyStatusQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus } } | null };

export type GetDashboardConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null, quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type RequestLoyaltyRegistrationMutationVariables = Exact<{
  isChecked: Scalars['Boolean']['input'];
  legalStatus: LegalStatus;
}>;


export type RequestLoyaltyRegistrationMutation = { __typename?: 'Mutation', requestLoyaltyRegistration: boolean };

export type MarketingEventCard_EventCardFragment = { __typename?: 'EventCard', id: string, backgroundColor?: string | null, baseline?: string | null, baselineColor?: string | null, link?: string | null, linkColor?: string | null, linkTitle?: string | null, title: string, titleColor?: string | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type GetMarketingEventCardsQueryVariables = Exact<{
  type?: InputMaybe<EventPageType>;
}>;


export type GetMarketingEventCardsQuery = { __typename?: 'Query', marketingCards?: Array<{ __typename?: 'EventCard', openInNewTab: boolean, id: string, backgroundColor?: string | null, baseline?: string | null, baselineColor?: string | null, link?: string | null, linkColor?: string | null, linkTitle?: string | null, title: string, titleColor?: string | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null> | null };

export type MarketingEventSlide_EventCardFragment = { __typename?: 'EventCard', openInNewTab: boolean, id: string, backgroundColor?: string | null, baseline?: string | null, baselineColor?: string | null, link?: string | null, linkColor?: string | null, linkTitle?: string | null, title: string, titleColor?: string | null, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type GetSignedOutWelcomeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignedOutWelcomeConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', isAccountCreationEnabled: boolean } | null } };

export type GetBannerInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannerInfosQuery = { __typename?: 'Query', config: { __typename?: 'Config', preheader: { __typename?: 'ConfigPreheader', isEnabled: boolean, textColor?: string | null, backgroundColor?: string | null, text: string } } };

export type MarketingProductFieldsFragment = { __typename?: 'EventProducts', link?: string | null, linkTitle?: string | null, openInNewTab: boolean, title: string, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, nbArticles: number, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type GetMarketingProductsQueryVariables = Exact<{
  type?: InputMaybe<EventCrossType>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMarketingProductsQuery = { __typename?: 'Query', marketingProducts?: Array<{ __typename?: 'EventProducts', link?: string | null, linkTitle?: string | null, openInNewTab: boolean, title: string, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, nbArticles: number, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null }> | null };

export type GetMarketingProductsPriceAndStockQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMarketingProductsPriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type MiniCartButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type MiniCartButtonQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalExclTax?: number | null } } | null } | null, config: { __typename?: 'Config', checkout?: { __typename?: 'ConfigCheckout', isMiniCartEnabled: boolean } | null } };

export type MiniCartButton_CartFragment = { __typename?: 'Cart', id: string, totalExclTax?: number | null };

export type MiniCartButtonPunchoutQueryVariables = Exact<{ [key: string]: never; }>;


export type MiniCartButtonPunchoutQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number, totalExclTax?: number | null } | null } } | null };

export type MixedOrdersContainer_ItemFragment = { __typename?: 'Order', orderType?: OrderType | null, webRef?: string | null, externalRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null };

export type GetMixedOrdersQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetMixedOrdersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, showStoreOrderHistory: boolean } | null, orders: { __typename?: 'OrderPagination', totalPages?: number | null, items?: Array<{ __typename?: 'Order', orderType?: OrderType | null, webRef?: string | null, externalRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null } | null> | null } } | null };

export type OrderSummaryCard_OrderFragment = { __typename?: 'Order', orderDate?: string | null, webRef?: string | null, status: OrderStatus, totalAmount?: number | null };

export type OrdersResumeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersResumeConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null } | null } };

export type MixedOrdersResumeCurrentUserQueryVariables = Exact<{
  input: Browsing;
}>;


export type MixedOrdersResumeCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, showStoreOrderHistory: boolean } | null, orders: { __typename?: 'OrderPagination', totalPages?: number | null, items?: Array<{ __typename?: 'Order', orderType?: OrderType | null, webRef?: string | null, externalRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null } | null> | null }, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type OrdersResumeCurrentUserQueryVariables = Exact<{
  input: Browsing;
}>;


export type OrdersResumeCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, hasAccessToWebOrders: boolean } | null, orders: { __typename?: 'OrderPagination', totalPages?: number | null, items?: Array<{ __typename?: 'Order', webRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null } | null> | null }, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type StoreOrdersContainer_ItemFragment = { __typename?: 'Order', internalRef?: string | null, externalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, wentThroughApproval: boolean, buyer?: { __typename?: 'OrderBuyer', name: string } | null, approver?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null };

export type GetStoreOrdersQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetStoreOrdersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, hasAccessToStoreOrders: boolean } | null, orders: { __typename?: 'OrderPagination', totalPages?: number | null, items?: Array<{ __typename?: 'Order', internalRef?: string | null, externalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, wentThroughApproval: boolean, buyer?: { __typename?: 'OrderBuyer', name: string } | null, approver?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null } | null> | null } } | null };

export type WebOrderPdfTemplate_OrderFragment = { __typename?: 'Order', hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, webRef?: string | null, internalRef?: string | null, orderDate?: string | null, status: OrderStatus, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, wentThroughApproval: boolean, approver?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, collectPointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime' } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null }> | null };

export type WebOrderProductRow_OrderItemFragment = { __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null };

export type WebOrderSummaryCard_OrderFragment = { __typename?: 'Order', webRef?: string | null, actions?: Array<OrderAction> | null, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', trackingUrl?: string | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null };

export type WebOrdersContainer_ItemFragment = { __typename?: 'Order', webRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null };

export type GetWebOrdersQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetWebOrdersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, hasAccessToWebOrders: boolean } | null, orders: { __typename?: 'OrderPagination', totalPages?: number | null, items?: Array<{ __typename?: 'Order', webRef?: string | null, internalRef?: string | null, status: OrderStatus, totalAmount?: number | null, orderDate?: string | null, actions?: Array<OrderAction> | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null } | null> | null } } | null };

export type StoreOrderDetailsQueryVariables = Exact<{
  externalRef: Scalars['String']['input'];
}>;


export type StoreOrderDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', internalRef?: string | null, orderDate?: string | null, status: OrderStatus, hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, externalRef?: string | null, actions?: Array<OrderAction> | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, delivery?: { __typename?: 'OrderDelivery', trackingUrl?: string | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, collectPointOfSale?: { __typename?: 'PointOfSale', distributionNetworkLabel?: string | null, name: string, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', name?: string | null, urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null } | null> | null } } | null, config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null, isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type StoreOrdersPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreOrdersPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToStoreOrders: boolean } | null } | null };

export type WebOrderDetailsQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type WebOrderDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, internalRef?: string | null, orderDate?: string | null, status: OrderStatus, wentThroughApproval: boolean, webRef?: string | null, actions?: Array<OrderAction> | null, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, approver?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, delivery?: { __typename?: 'OrderDelivery', trackingUrl?: string | null, addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, collectPointOfSale?: { __typename?: 'PointOfSale', distributionNetworkLabel?: string | null, name: string, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'OrderItemsSection', info: { __typename: 'OrderItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'OrderItemsSectionInfoNoDeliveryTime', noDeliveryTime?: string | null } | { __typename: 'OrderItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null }> | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null } | null> | null } } | null, config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isUniqueOrderDetailsDisplayEnabled?: boolean | null, isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type WebOrdersPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type WebOrdersPermissionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', permissions?: { __typename?: 'CollaboratorPermissions', hasAccessToWebOrders: boolean } | null } | null };

export type WebOrderDetails_AddressFragment = { __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string };

export type OrderRequestAddProductForm_OrderRequestToApproveFragment = { __typename?: 'OrderRequestToApprove', webRef: string, updatedState?: { __typename?: 'Cart', id: string } | null };

export type OrderRequestBuyerTable_ItemFragment = { __typename?: 'Order', webRef?: string | null, internalRef?: string | null, orderDate?: string | null, totalAmount?: number | null, payment?: { __typename?: 'OrderPayment', orderReference?: string | null } | null };

export type OrderRequestsQueryVariables = Exact<{
  since?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderRequestsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orderRequests: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', webRef?: string | null, internalRef?: string | null, orderDate?: string | null, totalAmount?: number | null, payment?: { __typename?: 'OrderPayment', orderReference?: string | null } | null } | null> | null } } | null };

export type OrderCartSummaryCard_OrderRequestToApproveFragment = { __typename?: 'OrderRequestToApprove', internalRef: string, orderDate: string, webRef: string, chorusServiceCode?: string | null, chorusLegalCommitment?: string | null, approvee: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, approver: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, delivery: { __typename?: 'OrderDelivery', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null }, payment: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null }, updatedState?: { __typename?: 'Cart', id: string, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } | null };

export type SaveOrderRequestModificationsMutationVariables = Exact<{
  webRef: Scalars['String']['input'];
  orderRequestData?: InputMaybe<OrderRequestDataInput>;
}>;


export type SaveOrderRequestModificationsMutation = { __typename?: 'Mutation', saveOrderRequestModifications: boolean };

export type SetOrderReferenceOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  orderReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetOrderReferenceOnCartMutation = { __typename?: 'Mutation', setOrderReferenceOnCart: boolean };

export type RefuseOrderRequestMutationVariables = Exact<{
  webRef: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RefuseOrderRequestMutation = { __typename?: 'Mutation', refuseOrderRequest: boolean };

export type OrderRequestDeliveryDateMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderRequestDeliveryDateMutation = { __typename?: 'Mutation', requestDeliveryDate: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null } } };

export type OrderRequestDeliverySection_OrderItemsSectionInfoEstimatedFragment = { __typename?: 'OrderItemsSectionInfoEstimated', delay: ShippingDelay };

export type OrderRequestDeliverySection_OrderItemsSectionInfoRealFragment = { __typename?: 'OrderItemsSectionInfoReal', date?: string | null };

export type OrderRequestDetailsFields_ChorusDataFragment = { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, isRequiredLegalCommitment?: boolean | null }> | null };

export type OrderRequestProductRowReadOnly_OrderItemFragment = { __typename?: 'OrderItem', totalExclTax: number, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', amountTotal: number, catalogDiscountAmount: number, oldPrice: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, reference: string, name?: string | null, urlKey?: string | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type OrderRequestProductRowReadOnly_CartItemFragment = { __typename?: 'CartItem', id?: any | null, totalExclTax?: number | null, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, oldPrice?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, reference: string, name?: string | null, urlKey?: string | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type OrderRequestProductRow_CartItemFragment = { __typename?: 'CartItem', id?: any | null, totalExclTax?: number | null, quantity: number, quantityMax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, quantity: number, realDeliveryDate: boolean } | null> | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, oldPrice?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null, quantitySaleNextLevel?: { __typename?: 'QuantitySaleNextLevel', gap?: number | null, unitPrice?: number | null } | null } | null, product?: { __typename?: 'Product', name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null };

export type OrderRequestSectionLabel_CartItemDeliveryStockDetailsFragment = { __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, quantity: number, realDeliveryDate: boolean };

export type OrderRequestUnavailableProduct_CartMessageFragment = { __typename?: 'CartMessage', message: string, code: CartMessageCode };

export type ApproveOrderRequestMutationVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type ApproveOrderRequestMutation = { __typename?: 'Mutation', approveOrderRequest: boolean };

export type OrderRequestValidationTable_OrderFragment = { __typename?: 'Order', webRef?: string | null, internalRef?: string | null, orderDate?: string | null, totalAmount?: number | null, payment?: { __typename?: 'OrderPayment', orderReference?: string | null } | null, buyer?: { __typename?: 'OrderBuyer', name: string, id: string, email: string, details?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null } | null };

export type OrderRequestsValidationQueryVariables = Exact<{
  since?: InputMaybe<Scalars['String']['input']>;
  sortField: Scalars['String']['input'];
  sortDirection?: InputMaybe<Direction>;
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type OrderRequestsValidationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orderRequests: { __typename?: 'OrderPagination', totalPages?: number | null, totalSize?: number | null, items?: Array<{ __typename?: 'Order', webRef?: string | null, internalRef?: string | null, orderDate?: string | null, totalAmount?: number | null, payment?: { __typename?: 'OrderPayment', orderReference?: string | null } | null, buyer?: { __typename?: 'OrderBuyer', name: string, id: string, email: string, details?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null } | null } | null> | null } } | null };

export type OrderRequestValidationTableFilter_OrderFragment = { __typename?: 'Order', buyer?: { __typename?: 'OrderBuyer', name: string, id: string, email: string, details?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null } | null };

export type OrderRequestResetQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type OrderRequestResetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orderRequestToApprove?: { __typename?: 'OrderRequestToApprove', internalRef: string, orderDate: string, webRef: string, approvee: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, approver: { __typename?: 'User', firstname?: string | null, lastname?: string | null }, delivery: { __typename?: 'OrderDelivery', addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null }, payment: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null }, updatedState?: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, totalQuantity?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string, code: CartMessageCode } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', items?: Array<{ __typename?: 'CartItem', totalExclTax?: number | null, id?: any | null, quantity: number, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, quantity: number, realDeliveryDate: boolean } | null> | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, oldPrice?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, product?: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, urlKey?: string | null, type: ProductType, nbArticles: number, description?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, reference: string, name?: string | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null }> | null }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } | null } | null } | null };

export type StoreOrderPdfTemplate_OrderFragment = { __typename?: 'Order', externalRef?: string | null, internalRef?: string | null, orderDate?: string | null, status: OrderStatus, hasClickAndCollectItems?: boolean | null, hasOnlineDeliveryItems?: boolean | null, isPickUpShippingMethod?: boolean | null, subtotalExclTax?: number | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, buyer?: { __typename?: 'OrderBuyer', name: string } | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', addresses?: Array<{ __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string } | null> | null } | null, collectPointOfSale?: { __typename?: 'PointOfSale', name: string, phoneNumber?: string | null, distributionNetworkLabel?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } } | null, items?: Array<{ __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', name?: string | null, urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null }> | null };

export type StoreOrderProductRow_OrderItemFragment = { __typename?: 'OrderItem', totalExclTax: number, coupon?: string | null, name?: string | null, reference: string, quantity: number, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'OrderItemDiscount', catalogDiscountAmount: number, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null, product?: { __typename?: 'Product', name?: string | null, urlKey?: string | null, type: ProductType, reference: string, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null };

export type StoreOrderSummaryCard_OrderFragment = { __typename?: 'Order', externalRef?: string | null, actions?: Array<OrderAction> | null, totalAmount?: number | null, totalAmountInclTax?: number | null, totalDiscount?: number | null, vatDetails?: Array<{ __typename?: 'VatDetail', amount: number, label: string }> | null, payment?: { __typename?: 'OrderPayment', code?: OrderPaymentCode | null } | null, delivery?: { __typename?: 'OrderDelivery', trackingUrl?: string | null } | null };

export type OrderReferenceDisplayQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderReferenceDisplayQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null } };

export type CollectPointOfSaleFragment = { __typename?: 'PointOfSale', distributionNetworkLabel?: string | null, name: string, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, subsidiary: { __typename?: 'Subsidiary', name: string } };

export type OrderAddressFragment = { __typename?: 'OrderAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name: string, postalCode: string };

export type OrderReferenceDisplay_ConfigFragment = { __typename?: 'Config', sales?: { __typename: 'ConfigSales', isRefOrderDisplayOnNonMandatoryEnabled?: boolean | null } | null };

export type Chorus_ChorusDataFragment = { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null };

export type PaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isChorusDisplayEnabled: boolean } | null }, currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, company?: { __typename?: 'Company', id: string, isProspect: boolean, isOrderReferenceMandatory?: boolean | null, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null } | null } | null, checkout?: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, payment?: { __typename?: 'Payment', code?: string | null, availableMethods?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', code?: string | null, status: PaymentStatus } | null, term?: { __typename?: 'PaymentMethodTerm', code?: string | null, status: PaymentStatus } | null, ideal?: { __typename?: 'PaymentMethodIdeal', code?: string | null, status: PaymentStatus } | null } | null } | null, shipping?: { __typename?: 'Shipping', methodCode?: string | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null } | null };

export type PaymentForm_UserFragment = { __typename?: 'User', role?: UserRole | null, company?: { __typename?: 'Company', id: string, isProspect: boolean, isOrderReferenceMandatory?: boolean | null, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null } | null } | null, checkout?: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, payment?: { __typename?: 'Payment', code?: string | null, availableMethods?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', code?: string | null, status: PaymentStatus } | null, term?: { __typename?: 'PaymentMethodTerm', code?: string | null, status: PaymentStatus } | null, ideal?: { __typename?: 'PaymentMethodIdeal', code?: string | null, status: PaymentStatus } | null } | null } | null, shipping?: { __typename?: 'Shipping', methodCode?: string | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null };

export type PaymentForm_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null }, payment?: { __typename?: 'Payment', code?: string | null, availableMethods?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', code?: string | null, status: PaymentStatus } | null, term?: { __typename?: 'PaymentMethodTerm', code?: string | null, status: PaymentStatus } | null, ideal?: { __typename?: 'PaymentMethodIdeal', code?: string | null, status: PaymentStatus } | null } | null } | null, shipping?: { __typename?: 'Shipping', methodCode?: string | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null };

export type PaymentForm_CompanyFragment = { __typename?: 'Company', isProspect: boolean, isOrderReferenceMandatory?: boolean | null, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null } | null };

export type PaymentForm_PaymentMethodFragment = { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', code?: string | null, status: PaymentStatus } | null, term?: { __typename?: 'PaymentMethodTerm', code?: string | null, status: PaymentStatus } | null, ideal?: { __typename?: 'PaymentMethodIdeal', code?: string | null, status: PaymentStatus } | null };

export type PayzenPublicKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type PayzenPublicKeyQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', payzen?: { __typename?: 'PayzenConfig', currentSubsidiary?: { __typename?: 'PayzenConfigSubsidiaryEntries', publicKey?: string | null } | null } | null } | null } };

export type PayzenTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type PayzenTokenQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', payment?: { __typename?: 'Payment', availableMethods?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentMethodCard', token: string } | null } | null } | null } | null } | null };

export type PayzenForm_CheckoutFragment = { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } };

export type SetAdditionalOrderInfoOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  additionalOrderInfo: SetAdditionalOrderInfoInput;
}>;


export type SetAdditionalOrderInfoOnCartMutation = { __typename?: 'Mutation', setAdditionalOrderInfoOnCart: boolean };

export type PlaceOrderWithPayzenMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  payzenResponse: PayzenPaymentResponseInput;
}>;


export type PlaceOrderWithPayzenMutation = { __typename?: 'Mutation', placeOrder: string };

export type PlaceOrderMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  setAdditionalOrderInfoInput?: InputMaybe<SetAdditionalOrderInfoInput>;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder: string };

export type SetPaymentMethodOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  paymentCode: Scalars['String']['input'];
}>;


export type SetPaymentMethodOnCartMutation = { __typename?: 'Mutation', setPaymentMethodOnCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string }, payment?: { __typename?: 'Payment', code?: string | null } | null } };

export type CartItemsAtPaymentTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type CartItemsAtPaymentTrackingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, totalExclTax?: number | null, isClickAndCollectActivated: boolean, currency?: string | null, couponCode?: string | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'CartItemsSection', items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, availableClickAndCollect: boolean, quantity: number, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', name?: string | null, reference: string, type: ProductType, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } } | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null }> | null }> | null } } | null } | null };

export type PointOfSaleDrawerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PointOfSaleDrawerQuery = { __typename?: 'Query', pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, link?: string | null, distributionNetworkLabel?: string | null, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, isoCountryCode: any }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, subsidiary: { __typename?: 'Subsidiary', name: string } } | null };

export type GetPointOfSaleDrawerConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointOfSaleDrawerConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean, isPickupPointOfSaleEnabled: boolean } | null } };

export type ConfirmationClickAndCollectCardConfigFragment = { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isPickupPointOfSaleEnabled: boolean } | null };

export type DisplayPointOfSaleInfos_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, link?: string | null, distributionNetworkLabel?: string | null, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, isoCountryCode: any }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, subsidiary: { __typename?: 'Subsidiary', name: string } };

export type SelectFavoritePointOfSaleDrawerQueryVariables = Exact<{
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectFavoritePointOfSaleDrawerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null } | null };

export type SelectPickupPointOfSaleDrawerQueryVariables = Exact<{
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectPickupPointOfSaleDrawerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', availablePointsOfSalePickup?: Array<{ __typename?: 'PointOfSale', id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null } | null };

export type SelectProductPickupPointOfSaleDrawerConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectProductPickupPointOfSaleDrawerConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isLocalStockByStoreEnabled: boolean } | null } };

export type SelectProductPickupPointOfSaleDrawerQueryVariables = Exact<{
  reference: Scalars['String']['input'];
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectProductPickupPointOfSaleDrawerQuery = { __typename?: 'Query', availablePointsOfSaleInventory?: Array<{ __typename?: 'ProductPointOfSale', id: string, pointOfSale: { __typename?: 'PointOfSale', isSelectable: boolean, id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }, product: { __typename?: 'Product', reference: string, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null } } }> | null };

export type SelectShippingPickupPointOfSaleDrawerQueryVariables = Exact<{
  forceStorePickup?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SelectShippingPickupPointOfSaleDrawerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', shipping?: { __typename?: 'Shipping', methodCode?: string | null, availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null } | null } | null } | null };

export type FavoritePointOfSaleCard_PointOfSaleAddressFragment = { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string };

export type FavoritePointOfSaleCard_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, distributionNetworkLabel?: string | null, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type FavoritePointOfSaleFragment = { __typename?: 'User', favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, distributionNetworkLabel?: string | null, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type AvailablePointOfSalesFragment = { __typename?: 'User', availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string, name: string, open: boolean, distributionNetworkLabel?: string | null, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null };

export type PointOfSaleConfigFragment = { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean };

export type GetDashboardPointOfSaleDrawerConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardPointOfSaleDrawerConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', isFavoritePointOfSaleEnabled: boolean, dashboardFavoritePointOfSaleImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } };

export type GetAvailablePointOfSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePointOfSalesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string, name: string, open: boolean, distributionNetworkLabel?: string | null, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, distributionNetworkLabel?: string | null, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null } | null };

export type PointOfSaleOpeningStatus_ExceptionalDatesFragment = { __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean };

export type PointOfSaleStatusCard_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type CurrentUserPickupPointOfSaleInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPickupPointOfSaleInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, availablePointsOfSalePickup?: Array<{ __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null } | null };

export type GetPointOfSaleStatusCardImageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointOfSaleStatusCardImageQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', dashboardFavoritePointOfSaleImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null } };

export type SelectablePointOfSaleCard_V2_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type CurrentUserPointOfSalePageQueryVariables = Exact<{
  searchPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserPointOfSalePageQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', favoritePointOfSaleId?: string | null, availablePointsOfSale?: Array<{ __typename?: 'PointOfSale', id: string, name: string, activity?: string | null, distance?: number | null, parentId?: string | null, address: { __typename?: 'PointOfSaleAddress', line1: string, postalCode: string, city: string }, openingHours?: Array<{ __typename?: 'OpeningHour', day: string, dayOfWeek: number, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } }> | null } | null };

export type UsePointOfSale_PointOfSaleAddressFragment = { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string };

export type UsePointOfSale_PointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } };

export type SwitchFavoritePointOfSaleMutationVariables = Exact<{
  posId: Scalars['String']['input'];
}>;


export type SwitchFavoritePointOfSaleMutation = { __typename?: 'Mutation', switchFavoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type FullOpeningHourFragment = { __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null };

export type ProductListActiveFiltersFragment = { __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null };

export type ProductListEventBanner_BannerFragment = { __typename?: 'MarketingBanner', bannerBackgroundColor?: string | null, bannerText?: string | null, bannerTextColor?: string | null, linkIsOpenNewTab?: boolean | null, linkText?: string | null, linkTextColor?: string | null, linkUrl?: string | null, tagBackgroundColor?: string | null, tagText?: string | null, tagTextColor?: string | null };

export type ProductListFilterValueFilterFragment = { __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } };

export type ProductListFiltersCategory_CategoryFiltersFragment = { __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type ProductListFiltersSubcategories_SubCategoriesFragment = { __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter' } | { __typename?: 'ValueLink', title: string, productCount: number, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type ProductListPriceAndStockQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductListPriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type ProductListCategoryFiltersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListCategoryFiltersQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', productList?: { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null } | null }> | null };

export type ProductListCategoryProductsQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  requestFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type ProductListCategoryProductsQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', marketingBanner?: { __typename?: 'MarketingBanner', bannerBackgroundColor?: string | null, bannerText?: string | null, bannerTextColor?: string | null, linkIsOpenNewTab?: boolean | null, linkText?: string | null, linkTextColor?: string | null, linkUrl?: string | null, tagBackgroundColor?: string | null, tagText?: string | null, tagTextColor?: string | null } | null, productList?: { __typename?: 'ProductList', totalPages?: number | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null } | null }> | null };

export type ValueLinkFragment = { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null };

type ProductListFilterValue_ValueFilter_Fragment = { __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } };

type ProductListFilterValue_ValueLink_Fragment = { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null };

export type ProductListFilterValueFragment = ProductListFilterValue_ValueFilter_Fragment | ProductListFilterValue_ValueLink_Fragment;

export type ProductListFilterFragment = { __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null };

export type ProductListProductsWithoutPriceFragment = { __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductListTemplate_ProductsPricesFragment = { __typename?: 'ProductList', products?: Array<{ __typename?: 'Product', urlKey?: string | null, bestArticlePrice?: number | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, isPriceAvailable: boolean, isSellable: boolean } }> | null };

export type ProductListTemplate_QueryFiltersFragment = { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null };

export type ProductListCount_ProductListFragment = { __typename?: 'ProductList', productCount?: number | null };

export type ProductListTemplate_ProductListFragment = { __typename?: 'ProductList', totalPages?: number | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, nbArticles: number, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null };

export type ProductListFilters_DataFragment = { __typename?: 'ProductList', categoryActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, categoryFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productActiveFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null, productFilters?: Array<{ __typename?: 'ProductListFilter', title: string, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string }, image?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, values?: Array<{ __typename?: 'ValueFilter', title: string, productCount: number, isActive: boolean, link: { __typename?: 'Link', type: LinkType, value: string } } | { __typename?: 'ValueLink' }> | null }> | null }> | null };

export type GetAlsoBoughtSliderQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetAlsoBoughtSliderQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, recommendedProducts?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, nbArticles: number, type: ProductType, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null } | null };

export type GetOurProductsCategoryQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOurProductsCategoryQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', name: string, categories?: Array<{ __typename?: 'Category', urlKey: string, name: string, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, categories?: Array<{ __typename?: 'Category', urlKey: string, name: string }> | null }> | null }> | null };

export type CategoryCard_CategoryFragment = { __typename?: 'Category', urlKey: string, name: string, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, categories?: Array<{ __typename?: 'Category', urlKey: string, name: string }> | null };

export type EquivalentProductsDrawerQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type EquivalentProductsDrawerQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, equivalentProducts?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, nbArticles: number, type: ProductType, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null } | null };

export type GetLinkedProductsSliderQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetLinkedProductsSliderQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, type: ProductType, linkedProducts?: Array<{ __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, nbArticles: number, type: ProductType, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null } | null };

export type ProductAvailabilities_ProductFragment = { __typename?: 'Product', canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null } };

export type ProductAvailabilities_PointOfSaleListFragment = { __typename?: 'User', favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type ProductAvailabilities_PickupPointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string };

export type ProductStock_AvailabilitiesFragment = { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null };

export type ProductAvailabilityItem_AvailabilityFragment = { __typename?: 'Product', stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null } };

export type FullProductAvailabilityItem_AvailabilityFragment = { __typename?: 'Product', canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null } };

export type GetProductAnomaliesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductAnomaliesQuery = { __typename?: 'Query', productAnomalies?: Array<{ __typename?: 'ProductAnomaly', name: string, value: string, categories?: Array<{ __typename?: 'ProductSubAnomaly', name: string, value: string }> | null }> | null };

export type ProductBob_CurrentUserPermissionsShowbobQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductBob_CurrentUserPermissionsShowbobQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, permissions?: { __typename?: 'CollaboratorPermissions', showBob: boolean } | null } | null };

export type ProductBuyBox_CartFragment = { __typename?: 'Cart', id: string };

export type ProductBuyBoxFields_ProductFragment = { __typename?: 'Product', name?: string | null, nbArticles: number, reference: string, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductBuyBox_ProductFragment = { __typename?: 'Product', urlKey?: string | null, name?: string | null, nbArticles: number, reference: string, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductBuyBoxArticle_ProductFragment = { __typename?: 'Product', description?: string | null, supplierReference?: string | null, name?: string | null, nbArticles: number, reference: string, type: ProductType, images?: Array<{ __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null }> | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductBuyBox_FavoritePointOfSaleFragment = { __typename?: 'PointOfSale', id: string, phoneNumber?: string | null };

export type ProductBuyBox_ProductPriceAndStockFragment = { __typename?: 'Product', reference: string, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, ecoPart: { __typename?: 'EcoPart', deee?: number | null, pmcb?: number | null, furnishing?: number | null }, charges: Array<{ __typename?: 'Charge', name: string, amount: number } | null>, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', referenceExclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, exclTax?: number | null, inclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null };

export type ProductBuyBoxPriceAndStockQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductBuyBoxPriceAndStockQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, parentReference?: string | null, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, ecoPart: { __typename?: 'EcoPart', deee?: number | null, pmcb?: number | null, furnishing?: number | null }, charges: Array<{ __typename?: 'Charge', name: string, amount: number } | null>, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, price?: { __typename?: 'Price', referenceExclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, exclTax?: number | null, inclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null } | null };

export type BundleProductCardInfoFragment = { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type ProductCardBaseFragment = { __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, type: ProductType, nbArticles: number, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type ProductCard_AddToCartFragment = { __typename?: 'Product', reference: string, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null } | null, stock: { __typename?: 'ProductStock', packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null } | null } };

export type ProductCard_ProductPriceAndStockFragment = { __typename?: 'Product', parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, reference: string, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null };

export type ProductRichDescription_ProductFragment = { __typename?: 'Product', reference: string, type: ProductType, nbArticles: number, description?: string | null, shortDescription?: string | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null };

export type ProductRichDescriptionQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductRichDescriptionQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, type: ProductType, nbArticles: number, description?: string | null, shortDescription?: string | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null } | null };

export type ProductDocuments_DocumentsFragment = { __typename?: 'Document', name?: string | null, link?: string | null };

export type ProductLabels_ProductFragment = { __typename?: 'Product', hasRseLabel?: boolean | null };

export type ProductNorms_NormFragment = { __typename?: 'Norm', id: string, name: string, image?: string | null };

export type ProductRowLinkedProducts_ProductFragment = { __typename?: 'Product', reference: string, canAddToCart: boolean, linkedProducts?: Array<{ __typename?: 'Product', reference: string, bestArticlePrice?: number | null, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, tag?: Tag | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, maxQuantity?: number | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type ProductRowLinkedProductsQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductRowLinkedProductsQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, canAddToCart: boolean, linkedProducts?: Array<{ __typename?: 'Product', reference: string, bestArticlePrice?: number | null, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', exclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, tag?: Tag | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, maxQuantity?: number | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null } | null };

export type ProductRowReadOnly_ProductFragment = { __typename?: 'Product', urlKey?: string | null, reference: string, parentReference?: string | null, type: ProductType, name?: string | null, bestArticlePrice?: number | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type ProductRowReadOnly_CartItemFragment = { __typename?: 'CartItem', id?: any | null, quantity: number, analyticsPromotionStatus?: string | null, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'CartItemDiscount', percentage?: number | null, catalogDiscountAmount?: number | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, reference: string, parentReference?: string | null, type: ProductType, name?: string | null, bestArticlePrice?: number | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null };

export type FullPackagingFragment = { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null };

export type ProductRowBase_ProductFragment = { __typename?: 'Product', name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null };

export type ProductRowPriceAndStock_ProductFragment = { __typename?: 'Product', reference: string, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type ProductRow_ProductFragment = { __typename?: 'Product', name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type GetLinkedProductsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkedProductsConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', catalog?: { __typename?: 'ConfigCatalog', isLinkedProductEnabled: boolean, g9LowStockThreshold?: string | null } | null } };

export type ProductStoreStockLinkProductReferenceFragment = { __typename?: 'Product', reference: string };

export type ProductMarketingInsertTag_ProductFragment = { __typename?: 'Product', marketingInsert?: { __typename?: 'ProductMarketingInsert', label: string, legalNotice?: string | null } | null };

export type PromotionTagFieldsFragment = { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null };

export type ProductTechnicalSpecs_TechnicalSpecsFragment = { __typename?: 'TechnicalSpec', label?: string | null, value?: string | null };

export type ProductTechnicalSpecsFull_NormsFragment = { __typename?: 'Norm', id: string, name: string };

export type ProductTechnicalSpecsFull_ProductFragment = { __typename?: 'Product', reference: string, type: ProductType, nbArticles: number, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string }> | null };

export type ProductTechnicalSpecsFullQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductTechnicalSpecsFullQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, type: ProductType, nbArticles: number, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string }> | null } | null };

export type ProductTechnicalSpecsSection_ProductFragment = { __typename?: 'Product', mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string }> | null };

export type GetReferencesProductArticlesQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetReferencesProductArticlesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, nbArticles: number, articles?: Array<{ __typename?: 'Product', urlKey?: string | null, reference: string, name?: string | null, type: ProductType, supplierReference?: string | null, hasRseLabel?: boolean | null, nbArticles: number, description?: string | null, shortDescription?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, additionalTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null, documents?: Array<{ __typename?: 'Document', name?: string | null, link?: string | null }> | null }> | null } | null };

export type GetReferencesProductFiltersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetReferencesProductFiltersQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, filters?: Array<{ __typename?: 'ProductFilter', label: string, unit?: string | null, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null } | null };

export type ReferencesProduct_CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencesProduct_CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null } | null };

export type ReferencesProduct_PickupPointOfSaleQueryVariables = Exact<{
  pickupPointOfSaleId: Scalars['String']['input'];
}>;


export type ReferencesProduct_PickupPointOfSaleQuery = { __typename?: 'Query', pickupPointOfSale?: { __typename?: 'PointOfSale', id: string, name: string } | null };

export type ReferencesProductFilters_FiltersFragment = { __typename?: 'ProductFilter', label: string, unit?: string | null, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null };

export type ReferencesProductTable_ArticleFragment = { __typename?: 'Product', urlKey?: string | null, reference: string, name?: string | null, type: ProductType, supplierReference?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, additionalTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null };

export type ReferencesProductTableRows_PriceAndStockFragment = { __typename?: 'Product', reference: string, parentReference?: string | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null };

export type ReferencesProductTableRows_PriceAndStockQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReferencesProductTableRows_PriceAndStockQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type AddProductToCartMutationVariables = Exact<{
  reference: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  cartId: Scalars['String']['input'];
}>;


export type AddProductToCartMutation = { __typename?: 'Mutation', addProductToCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, hasClickAndCollectOnlyItems: boolean, sumItemsQuantity?: number | null, availableClickAndCollectQuantity?: number | null, totalQuantity?: number | null, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, analyticsPromotionStatus?: string | null, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, discount?: { __typename?: 'CartItemDiscount', percentage?: number | null, catalogDiscountAmount?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, parentReference?: string | null, bestArticlePrice?: number | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

export type AddProductToPunchoutCartFromProductMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type AddProductToPunchoutCartFromProductMutation = { __typename?: 'Mutation', addProductToPunchoutCart: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, totalExclTax?: number | null, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, urlKey?: string | null, parentReference?: string | null, type: ProductType, name?: string | null, bestArticlePrice?: number | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } } | null> | null } };

export type UpdateFavoritesListForProductMutationVariables = Exact<{
  input: WishlistUpdateInput_V2;
}>;


export type UpdateFavoritesListForProductMutation = { __typename?: 'Mutation', updateWishlist_V2: { __typename?: 'Wishlist', id: number } };

export type CreateFavoritesListForProductMutationVariables = Exact<{
  input: WishlistCreateInput_V2;
}>;


export type CreateFavoritesListForProductMutation = { __typename?: 'Mutation', createWishlist_V2: { __typename?: 'Wishlist', id: number, name?: string | null } };

export type ProductAnalyticsDataQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductAnalyticsDataQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, parentReference?: string | null, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name: string, urlKey?: string | null }> | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null } | null };

export type ProductFavoriteStatusQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ProductFavoriteStatusQuery = { __typename?: 'Query', productByReference?: { __typename?: 'Product', reference: string, isFavorite: boolean } | null };

export type ProductArticleDetails_ArticleFragment = { __typename?: 'Product', hasRseLabel?: boolean | null, reference: string, type: ProductType, nbArticles: number, description?: string | null, shortDescription?: string | null, mainTechnicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null, norms?: Array<{ __typename?: 'Norm', id: string, name: string, image?: string | null }> | null, documents?: Array<{ __typename?: 'Document', name?: string | null, link?: string | null }> | null };

export type ProductListFavoriteStatusQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductListFavoriteStatusQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, isFavorite: boolean }> | null };

export type VisibleCardsAnalyticsByReferencesQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type VisibleCardsAnalyticsByReferencesQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, name?: string | null, type: ProductType, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name: string }> | null }> | null };

export type VisibleCardsPriceAndStockByReferencesQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type VisibleCardsPriceAndStockByReferencesQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, urlKey?: string | null, bestArticlePrice?: number | null, clickAndCollectStatus?: ClickAndCollectStatus | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, stock: { __typename?: 'ProductStock', isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', minimalSalesQuantity?: number | null, incrementQuantity?: number | null, quantity?: number | null, unit?: Unit | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null }> | null };

export type ProductPageProductQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type ProductPageProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', reference: string, type: ProductType, parentUrlKey?: string | null, filters?: Array<{ __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null }> | null } | null };

export type ReportProductAnomalyMutationVariables = Exact<{
  reference: Scalars['String']['input'];
  type: Scalars['String']['input'];
  subType: Scalars['String']['input'];
  url: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportProductAnomalyMutation = { __typename?: 'Mutation', reportProductAnomaly: boolean };

export type FullPriceFragment = { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null };

export type TiersPriceFragment = { __typename?: 'Price', tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null };

export type ProductCalculatedPriceFragment = { __typename?: 'Product', calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null };

export type FiltersFieldsFragment = { __typename?: 'ProductFilter', label: string, values?: Array<{ __typename?: 'ProductFilterValue', label: string, references?: Array<string> | null }> | null };

export type ProductCardFragment = { __typename?: 'Product', name?: string | null, urlKey?: string | null, reference: string, bestArticlePrice?: number | null, isEquivalentProductsLinkVisible: boolean, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, nbArticles: number, type: ProductType, price?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountInclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, referenceInclTax?: number | null, referencePercentage?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null, logo?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null, profileCase?: string | null } | null, calculatedPrice?: { __typename?: 'Price', exclTax?: number | null, inclTax?: number | null, discountExclTax?: number | null, discountPercentage?: number | null, referenceExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null };

export type ProductTechSpecsFragment = { __typename?: 'Product', technicalSpecs?: Array<{ __typename?: 'TechnicalSpec', label?: string | null, value?: string | null }> | null };

export type ClearPunchoutCartItemsMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
}>;


export type ClearPunchoutCartItemsMutation = { __typename?: 'Mutation', clearPunchoutCartItems: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type PunchoutCartActionsCard_CartFragment = { __typename?: 'PunchoutCart', id: number, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, product: { __typename?: 'Product', reference: string } }> | null } | null> | null };

export type PunchoutCartItem_ItemFragment = { __typename?: 'PunchoutCartItem', id: number, quantity: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } };

export type PunchoutCartItems_SectionFragment = { __typename?: 'PunchoutCartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null };

export type PunchoutCartItems_CartFragment = { __typename?: 'PunchoutCart', id: number, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null } | null> | null };

export type PunchoutCartSummary_CartFragment = { __typename?: 'PunchoutCart', subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null };

export type SendPunchoutCartToErpButton_UserFragment = { __typename?: 'User', id: string, role?: UserRole | null };

export type SendPunchoutCartToErpMutationVariables = Exact<{
  cartId: Scalars['Int']['input'];
}>;


export type SendPunchoutCartToErpMutation = { __typename?: 'Mutation', punchoutCart: { __typename?: 'PunchoutCartOutput', url: string, formData: string } };

export type AddProductToPunchoutCartMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type AddProductToPunchoutCartMutation = { __typename?: 'Mutation', addProductToPunchoutCart: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type AddProductsToPunchoutCartMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
  items: Array<ProductToCartInput> | ProductToCartInput;
}>;


export type AddProductsToPunchoutCartMutation = { __typename?: 'Mutation', addProductsToPunchoutCart: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type PunchoutCart_CartFragment = { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null };

export type PunchoutCartQueryVariables = Exact<{ [key: string]: never; }>;


export type PunchoutCartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } | null } } | null };

export type UsePunchoutCartIdQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePunchoutCartIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, punchout: { __typename?: 'Punchout', cart?: { __typename?: 'PunchoutCart', id: number } | null } } | null };

export type UpdatePunchoutCartItemQuantityMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
  cartItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type UpdatePunchoutCartItemQuantityMutation = { __typename?: 'Mutation', updatePunchoutCartItemQuantity: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type RemovePunchoutCartItemMutationVariables = Exact<{
  punchoutCartId: Scalars['Int']['input'];
  cartItemId: Scalars['Int']['input'];
}>;


export type RemovePunchoutCartItemMutation = { __typename?: 'Mutation', removePunchoutCartItem: { __typename?: 'PunchoutCart', id: number, totalQuantity?: number | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, messages?: Array<{ __typename?: 'CartMessage', message: string } | null> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, items?: Array<{ __typename?: 'PunchoutCartItem', quantity: number, id: number, unitPriceExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, rowTotalExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null }> | null, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename?: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } };

export type PunchoutCartPdf_CartFragment = { __typename?: 'PunchoutCart', id: number, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, totalQuantity?: number | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, itemsGroupedByEarliestDeliveryDate?: Array<{ __typename?: 'PunchoutCartItemsSection', quantity: number, info: { __typename: 'CartItemsSectionInfoClickAndCollect' } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'PunchoutCartItem', id: number, quantity: number, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', date?: string | null, quantity: number, availability: ShippingDelay, realDeliveryDate: boolean }> | null, product: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null }, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, price?: { __typename?: 'Price', discountPercentage?: number | null, discountExclTax?: number | null } | null } }> | null } | null> | null };

export type UpdateQuickOrderListMutationVariables = Exact<{
  input: QuickOrderInput_V2;
}>;


export type UpdateQuickOrderListMutation = { __typename?: 'Mutation', updateQuickOrder_V2: { __typename?: 'Wishlist', id: number } };

export type GetQuickOrderListFilteredCartAmountQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQuickOrderListFilteredCartAmountQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, quickOrderList: { __typename?: 'Wishlist', id: number, totalExclTax?: number | null, products?: Array<{ __typename?: 'ProductWishlist', id: number, quantity: number, product: { __typename?: 'Product', reference: string, canAddToCart: boolean, stock: { __typename?: 'ProductStock', availability: Array<Availability | null> } } }> | null } } | null };

export type ClearQuickOrderMutationVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClearQuickOrderMutation = { __typename?: 'Mutation', clearQuickOrder: boolean };

export type GetQuickOrderListProductsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQuickOrderListProductsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, quickOrderList: { __typename?: 'Wishlist', id: number, productCount: number, products?: Array<{ __typename?: 'ProductWishlist', id: number, quantity: number, comment?: string | null, rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null, product: { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null } }> | null } } | null };

export type QuickOrderConfigFragment = { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isQuickOrderEnabled: boolean } | null };

export type UpdateCurrentQuoteMutationVariables = Exact<{
  input: QuoteUpdateInput_V2;
}>;


export type UpdateCurrentQuoteMutation = { __typename?: 'Mutation', updateCurrentQuote_V2: { __typename?: 'Wishlist', id: number } };

export type Company_ChorusDataFragment = { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null };

export type CompanyChorusDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyChorusDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null, isRequiredService?: boolean | null, isRequiredLegalCommitment?: boolean | null, isRequiredServiceOrRequiredLegalCommitment?: boolean | null, services?: Array<{ __typename?: 'ChorusService', name?: string | null, code?: string | null, status?: string | null, isRequiredLegalCommitment?: boolean | null }> | null } | null } | null } | null };

export type ApproveChorusQuoteMutationVariables = Exact<{
  quoteId: Scalars['String']['input'];
  posId: Scalars['String']['input'];
  legalCommitment: Scalars['String']['input'];
  serviceCode: Scalars['String']['input'];
}>;


export type ApproveChorusQuoteMutation = { __typename?: 'Mutation', approveQuote: { __typename?: 'Quote', id: string } };

export type ApproveQuoteMutationVariables = Exact<{
  quoteId: Scalars['String']['input'];
  posId: Scalars['String']['input'];
}>;


export type ApproveQuoteMutation = { __typename?: 'Mutation', approveQuote: { __typename?: 'Quote', id: string } };

export type ClearCurrentQuoteMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearCurrentQuoteMutation = { __typename?: 'Mutation', clearCurrentQuote: boolean };

export type DeclineQuoteMutationVariables = Exact<{
  quoteId: Scalars['String']['input'];
  posId: Scalars['String']['input'];
  reason: QuoteDeclineReason;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineQuoteMutation = { __typename?: 'Mutation', declineQuote: boolean };

export type IsPublicAdministrationQueryVariables = Exact<{ [key: string]: never; }>;


export type IsPublicAdministrationQuery = { __typename?: 'Query', config: { __typename?: 'Config', sales?: { __typename?: 'ConfigSales', isChorusDisplayEnabled: boolean } | null }, currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, chorusData?: { __typename?: 'ChorusData', isChorus?: boolean | null } | null } | null } | null };

export type QuoteComment_QuoteFragment = { __typename?: 'QuoteComment', comment: string, level: QuoteCommentLevel };

export type QuoteProductsTable_QuoteProductFragment = { __typename?: 'QuoteProduct', quantity?: number | null, priceExcludingTax?: number | null, totalExcludingTax?: number | null, comment?: Array<string> | null, uniqueKey: string, reference?: string | null, name?: string | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null } | null, product?: { __typename?: 'Product', urlKey?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type QuoteProductsInfo_QuoteProductFragment = { __typename?: 'QuoteProduct', reference?: string | null, name?: string | null, product?: { __typename?: 'Product', urlKey?: string | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null };

export type QuotesResumeCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type QuotesResumeCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, isProspect: boolean } | null, permissions?: { __typename?: 'CollaboratorPermissions', showOrderHistory: boolean, canManageQuote: boolean } | null } | null };

export type GetQuotesResumeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuotesResumeConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', loyalty?: { __typename?: 'ConfigLoyalty', isEnabled: boolean } | null, quotation?: { __typename?: 'ConfigQuotation', isQuotationEnabled?: boolean | null } | null } };

export type QuotesTable_QuoteFragment = { __typename?: 'Quote', id: string, ref?: string | null, commercialName: string, status: QuoteStatus, createdAt: string, expiredAt: string, totalExcludingTax: number, pointOfSale: { __typename?: 'PointOfSale', id: string, name: string } };

export type GetQuotesQueryVariables = Exact<{
  input?: InputMaybe<Browsing>;
}>;


export type GetQuotesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, company?: { __typename?: 'Company', id: string, quotes: { __typename?: 'QuotePagination', totalPages?: number | null, totalSize?: number | null, items: Array<{ __typename?: 'Quote', id: string, ref?: string | null, commercialName: string, status: QuoteStatus, createdAt: string, expiredAt: string, totalExcludingTax: number, pointOfSale: { __typename?: 'PointOfSale', id: string, name: string } }> } } | null } | null };

export type RenewQuoteMutationVariables = Exact<{
  quoteId: Scalars['String']['input'];
  pointOfSaleId: Scalars['String']['input'];
}>;


export type RenewQuoteMutation = { __typename?: 'Mutation', renewQuote: boolean };

export type GetIsCurrentUserSignedInQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsCurrentUserSignedInQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null } | null };

export type ShareQuoteDrawerQueryVariables = Exact<{
  type: SharingType;
}>;


export type ShareQuoteDrawerQuery = { __typename?: 'Query', shareUserList?: Array<{ __typename?: 'UserPartialInfos', id: string, firstname: string, lastname: string, email: string }> | null };

export type ShareQuoteMutationVariables = Exact<{
  input: QuoteShareInput;
}>;


export type ShareQuoteMutation = { __typename?: 'Mutation', shareQuote: boolean };

export type SubmitCurrentQuoteMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitCurrentQuoteMutation = { __typename?: 'Mutation', submitCurrentQuote: boolean };

export type CreateQuoteMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'Wishlist', name?: string | null } };

export type DirectReOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
}>;


export type DirectReOrderMutation = { __typename?: 'Mutation', directReOrder: { __typename?: 'ReOrderedProducts', addedProducts: Array<{ __typename?: 'ReOrderedProduct', productReference: string, quantity: number }>, unavailableProducts: Array<{ __typename?: 'ReOrderedProduct', productReference: string }> } };

export type ReOrderButton_OrderItemsQueryVariables = Exact<{
  webRef: Scalars['String']['input'];
}>;


export type ReOrderButton_OrderItemsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, orders: { __typename?: 'OrderPagination', items?: Array<{ __typename?: 'Order', webRef?: string | null, items?: Array<{ __typename?: 'OrderItem', reference: string, quantity: number }> | null } | null> | null } } | null };

export type CmsSeoCategoryQueryVariables = Exact<{
  categoryCode: Scalars['String']['input'];
  tenantId: Scalars['JSON']['input'];
}>;


export type CmsSeoCategoryQuery = { __typename?: 'Query', CMS_SeoCategories?: { __typename?: 'CMS_SeoCategories', docs: Array<{ __typename?: 'CMS_SeoCategory', seoContent?: any | null }> } | null };

export type SetShippingDeliveryContactInfoOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  input: SetShippingDeliveryContactInfoInput;
}>;


export type SetShippingDeliveryContactInfoOnCartMutation = { __typename?: 'Mutation', setShippingDeliveryContactInfoOnCart: { __typename?: 'Checkout', shipping?: { __typename?: 'Shipping', delivery?: { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null } | null } | null } };

export type SetShippingDeliveryInstructionsOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  input: SetShippingDeliveryInstructionsInput;
}>;


export type SetShippingDeliveryInstructionsOnCartMutation = { __typename?: 'Mutation', setShippingDeliveryInstructionsOnCart: { __typename?: 'Checkout', shipping?: { __typename?: 'Shipping', delivery?: { __typename?: 'Delivery', comment?: string | null } | null } | null } };

type DeliveryDatePicker_Info_CartItemsSectionInfoClickAndCollect_Fragment = { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null };

type DeliveryDatePicker_Info_CartItemsSectionInfoEstimated_Fragment = { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay };

type DeliveryDatePicker_Info_CartItemsSectionInfoReal_Fragment = { __typename?: 'CartItemsSectionInfoReal', date?: string | null };

export type DeliveryDatePicker_InfoFragment = DeliveryDatePicker_Info_CartItemsSectionInfoClickAndCollect_Fragment | DeliveryDatePicker_Info_CartItemsSectionInfoEstimated_Fragment | DeliveryDatePicker_Info_CartItemsSectionInfoReal_Fragment;

export type RequestCartShippingDeliveryDateMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestCartShippingDeliveryDateMutation = { __typename?: 'Mutation', requestDeliveryDate: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null }, shipping?: { __typename?: 'Shipping', fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } };

type ShippingFeeTag_Fee_ShippingFeeFree_Fragment = { __typename?: 'ShippingFeeFree', isFranco?: boolean | null };

type ShippingFeeTag_Fee_ShippingFeeWithAmount_Fragment = { __typename?: 'ShippingFeeWithAmount', amount: number };

export type ShippingFeeTag_FeeFragment = ShippingFeeTag_Fee_ShippingFeeFree_Fragment | ShippingFeeTag_Fee_ShippingFeeWithAmount_Fragment;

export type ShippingFields_CartFragment = { __typename?: 'Cart', id: string, isClickAndCollectFeatureAvailable: boolean, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, totalQuantity?: number | null, isClickAndCollectActivated: boolean, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type ShippingFields_ShippingFragment = { __typename?: 'Shipping', methodCode?: string | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null };

export type ShippingFields_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null } | null };

export type SetShippingMethodOnCartMutationVariables = Exact<{
  shippingMethodOnCartInput: SetShippingMethodOnCartInput;
}>;


export type SetShippingMethodOnCartMutation = { __typename?: 'Mutation', setShippingMethodOnCart: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, isClickAndCollectActivated: boolean, totalQuantity?: number | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, isClickAndCollectFeatureAvailable: boolean, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null } | null } };

export type ChooseDeliveryDate_CartFragment = { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null };

export type DelaysSummary_ItemSectionsFragment = { __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null } };

export type ShippingContentStoreAddress_FavoritePointOfSaleFragment = { __typename?: 'PointOfSale', id: string, name: string, phoneNumber?: string | null, address: { __typename?: 'PointOfSaleAddress', city: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, isoCountryCode: any }, subsidiary: { __typename?: 'Subsidiary', name: string } };

export type ShippingAddress_ShippingFragment = { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null };

export type ShippingAddressOption_ShippingFragment = { __typename?: 'Shipping', address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null } | null, delivery?: { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null, comment?: string | null } | null };

export type ShippingClickAndCollectOption_ShippingFragment = { __typename?: 'Shipping', availableMethods?: { __typename?: 'ShippingAvailableMethods', clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null, delivery?: { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null, comment?: string | null } | null };

export type ShippingClickAndCollectOption_CartFragment = { __typename?: 'Cart', id: string, availableClickAndCollectQuantity?: number | null, isClickAndCollectActivated: boolean, sumItemsQuantity?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type ShippingStoreOption_ShippingFragment = { __typename?: 'Shipping', methodCode?: string | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', recipientName?: string | null, recipientPhone?: string | null, comment?: string | null } | null };

export type ShippingStoreOption_CartFragment = { __typename?: 'Cart', id: string, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type Shipping_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, totalQuantity?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null } | null };

export type ShippingQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, checkout?: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, totalQuantity?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null } | null } | null } | null };

export type SetShippingAddressOnCartMutationVariables = Exact<{
  shippingAddressOnCartInput: SetShippingAddressesOnCartInput;
}>;


export type SetShippingAddressOnCartMutation = { __typename?: 'Mutation', setShippingAddressOnCart: { __typename?: 'Checkout', willGenerateOrderRequest: boolean, shipping?: { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null } | null, cart: { __typename?: 'Cart', id: string, isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, totalQuantity?: number | null, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, subtotalExclTax?: number | null, totalExclTax?: number | null, totalInclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, amountUntilFreeDelivery?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null } } };

export type ShippingForm_CheckoutFragment = { __typename?: 'Checkout', willGenerateOrderRequest: boolean, cart: { __typename?: 'Cart', isClickAndCollectActivated: boolean, isClickAndCollectFeatureAvailable: boolean, id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, totalQuantity?: number | null, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null }, shipping?: { __typename?: 'Shipping', methodCode?: string | null } | null };

export type ShippingForm_CartFragment = { __typename?: 'Cart', id: string, totalQuantity?: number | null, isClickAndCollectFeatureAvailable: boolean, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, isClickAndCollectActivated: boolean, availableClickAndCollectQuantity?: number | null, internalRef?: string | null, couponCode?: string | null, sumItemsQuantity?: number | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, name: string, open: boolean, phoneNumber?: string | null, latitude?: number | null, longitude?: number | null, link?: string | null, distance?: number | null, openingHours?: Array<{ __typename?: 'OpeningHour', dayOfWeek: number, day: string, intervals?: Array<{ __typename?: 'Interval', begin: string, end: string }> | null }> | null, address: { __typename?: 'PointOfSaleAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, postalCode: string }, exceptionalDates?: Array<{ __typename?: 'ExceptionalDate', date?: string | null, isClosed: boolean }> | null, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null };

export type ShippingForm_ShippingFragment = { __typename?: 'Shipping', methodCode?: string | null, delivery?: { __typename?: 'Delivery', comment?: string | null, recipientName?: string | null, recipientPhone?: string | null } | null, address?: { __typename?: 'CartAddress', city: string, isoCountryCode: any, line1: string, line2?: string | null, line3?: string | null, name?: string | null, postalCode: string, type?: UserCompanyAddressType | null, userCompanyAddress?: { __typename?: 'UserCompanyAddress', id: string } | null } | null, availableMethods?: { __typename?: 'ShippingAvailableMethods', onsiteDelivery?: { __typename?: 'ShippingMethodOnsiteDelivery', code: string, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | { __typename?: 'ShippingFeeWithAmount', amount: number } | null } | null, storePickup?: { __typename?: 'ShippingMethodStorePickup', code?: string | null, status?: ShippingMethodStatus | null, fee?: { __typename?: 'ShippingFeeFree', isFranco?: boolean | null } | null } | null, clickAndCollect?: { __typename?: 'ShippingMethodClickAndCollect', code?: string | null, status?: ShippingMethodStatus | null } | null } | null };

export type ShippingItemsSplitByDeliveryDateQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingItemsSplitByDeliveryDateQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, requestedDeliveryDate?: string | null, canRequestDeliveryDate?: boolean | null, itemsSplitByDeliveryDate?: Array<{ __typename?: 'CartItemsSection', quantity: number, info: { __typename?: 'CartItemsSectionInfoClickAndCollect', noValue?: string | null } | { __typename: 'CartItemsSectionInfoEstimated', delay: ShippingDelay } | { __typename?: 'CartItemsSectionInfoReal', date?: string | null }, items?: Array<{ __typename?: 'CartItem', availableClickAndCollect: boolean, id?: any | null, quantity: number, totalExclTax?: number | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null } | null } | null, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null } | null }> | null }> | null } } | null } | null };

export type ShippingTracking_CartFragment = { __typename?: 'Cart', id: string, items?: Array<{ __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null } | null> | null };

export type ShippingTracking_ItemsFragment = { __typename?: 'CartItem', id?: any | null, analyticsPromotionStatus?: string | null, quantity: number, totalExclTax?: number | null, availableClickAndCollect: boolean, product?: { __typename?: 'Product', reference: string } | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, deliveryDetails?: Array<{ __typename?: 'CartItemDeliveryStockDetails', availability: ShippingDelay, date?: string | null, realDeliveryDate: boolean, quantity: number } | null> | null };

export type CartShippingTrackingQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CartShippingTrackingQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, parentReference?: string | null, name?: string | null, type: ProductType, nomenclatureFamily?: string | null, nomenclatureGroup?: string | null, canAddToCart: boolean, price?: { __typename?: 'Price', exclTax?: number | null, tag?: Tag | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, analytics?: { __typename?: 'ProductAnalytics', promotionStatus?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isSellable: boolean } }> | null, currentUser?: { __typename?: 'User', id: string, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string, currency?: string | null, totalExclTax?: number | null, couponCode?: string | null } } | null } | null };

export type StoreLocatorConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreLocatorConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', pointOfSale?: { __typename?: 'ConfigPointOfSale', storeLocatorUrl?: string | null } | null } };

export type TrackFirstSignInQueryVariables = Exact<{ [key: string]: never; }>;


export type TrackFirstSignInQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstLoginManagerOrigin?: FirstLoginOriginAnalytics | null } | null };

export type CategoriesSlider_CategoriesFragment = { __typename?: 'Category', urlKey: string, id?: string | null, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type GetAllUniversesQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllUniversesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', categories?: Array<{ __typename?: 'Category', urlKey: string, id?: string | null, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null }> | null };

export type MainCategoryFragment = { __typename?: 'Category', id?: string | null, isUniverse: boolean, urlKey: string, name: string, baseline?: string | null, seoContent?: string | null, code: string };

export type SubCategoryFragment = { __typename?: 'Category', urlKey: string, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null };

export type GetUniverseQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
  filterSubCats?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUniverseQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', id?: string | null, isUniverse: boolean, urlKey: string, name: string, baseline?: string | null, seoContent?: string | null, code: string, categories?: Array<{ __typename?: 'Category', urlKey: string, name: string, isUniverse: boolean, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null }> | null }> | null };

export type CategoryUrlKeyQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type CategoryUrlKeyQuery = { __typename?: 'Query', urlKey: string };

export type GetFavoritesListFilteredCartAmountQueryVariables = Exact<{
  input: Browsing;
}>;


export type GetFavoritesListFilteredCartAmountQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, wishlists: { __typename?: 'WishlistPagination', items: Array<{ __typename?: 'Wishlist', id: number, totalExclTax?: number | null, products?: Array<{ __typename?: 'ProductWishlist', quantity: number, product: { __typename?: 'Product', reference: string, availability: Array<Availability | null>, canAddToCart: boolean } }> | null }> } } | null };

export type AddProductsToCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  items: Array<ProductToCartInput> | ProductToCartInput;
}>;


export type AddProductsToCartMutation = { __typename?: 'Mutation', addProductsToCart: { __typename?: 'AddProductsToCartResponse', addedReferences: number, cart: { __typename?: 'Cart', id: string, totalQuantity?: number | null, totalExclTax?: number | null, totalDiscount?: number | null, totalEcoPart?: number | null, subtotalExclTax?: number | null, totalInclTax?: number | null, amountUntilFreeDelivery?: number | null, items?: Array<{ __typename?: 'CartItem', id?: any | null, quantity: number, totalExclTax?: number | null, unitPrice: { __typename?: 'CartItemUnitPrice', exclTax?: number | null }, product?: { __typename?: 'Product', reference: string, name?: string | null, type: ProductType, urlKey?: string | null, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null, stock: { __typename?: 'ProductStock', availability: Array<Availability | null>, isPriceAvailable: boolean, isSellable: boolean, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } } | null, discount?: { __typename?: 'CartItemDiscount', catalogDiscountAmount?: number | null, percentage?: number | null, webDiscount?: { __typename?: 'WebDiscount', amount?: number | null, hasCoupon?: boolean | null, label?: string | null } | null } | null, promotionTag?: { __typename?: 'PromotionTag', label?: string | null, type?: Tag | null } | null } | null> | null, taxesDetails?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null } }> | null } } };

export type WishlistPriceAndStocks_ProductFragment = { __typename?: 'Product', reference: string, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', tag?: Tag | null, exclTax?: number | null, referenceExclTax?: number | null, discountPercentage?: number | null, discountExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } };

export type WishlistProductsAvailabilityQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type WishlistProductsAvailabilityQuery = { __typename?: 'Query', productsByReferences?: Array<{ __typename?: 'Product', reference: string, canAddToCart: boolean, clickAndCollectStatus?: ClickAndCollectStatus | null, price?: { __typename?: 'Price', tag?: Tag | null, exclTax?: number | null, referenceExclTax?: number | null, discountPercentage?: number | null, discountExclTax?: number | null, tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, exclTax?: number | null }> | null } | null, stock: { __typename?: 'ProductStock', maxQuantity?: number | null, onlineQuantity?: number | null, g9LowStockThreshold?: number | null, isPriceAvailable: boolean, isSellable: boolean, availability: Array<Availability | null>, storeQuantity?: number | null, shippingDelay?: ShippingDelay | null, packaging?: { __typename?: 'ProductPackaging', quantity?: number | null, unit?: Unit | null, incrementQuantity?: number | null, minimalSalesQuantity?: number | null } | null } }> | null };

export type ValidArticlesReferencesQueryVariables = Exact<{
  references: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidArticlesReferencesQuery = { __typename?: 'Query', articlesByReferences?: Array<{ __typename?: 'Product', reference: string }> | null };

export type WishlistProduct_ProductFragment = { __typename?: 'Product', isEquivalentProductsLinkVisible: boolean, name?: string | null, type: ProductType, reference: string, isLinkedProductsLinkVisible: boolean, urlKey?: string | null, firstLevelCategory?: { __typename?: 'FirstLevelCategory', code?: string | null, name?: string | null } | null, mainImage?: { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null } | null, brand?: { __typename?: 'Brand', name: string, urlKey?: string | null } | null };

export type WishlistResolvedPricing_ProductWishlistFragment = { __typename?: 'ProductWishlist', rowTotalExclTax?: number | null, conditioningUnitPriceExclTax?: number | null, catalogDiscountAmount?: number | null };

export type GenerateRefreshTokenMutationVariables = Exact<{
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
}>;


export type GenerateRefreshTokenMutation = { __typename?: 'Mutation', generateRefreshToken: { __typename?: 'Token', type: TokenType, value: string } };

export type ProductUrlKeyQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ProductUrlKeyQuery = { __typename?: 'Query', urlKey: string };

export type RobotsTxtConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type RobotsTxtConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', site?: { __typename?: 'ConfigSite', robotsContent: string, robotsMeta: string } | null } };

export type UserTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTrackingQuery = { __typename?: 'Query', currentUserAccounts?: Array<{ __typename?: 'User', id: string }> | null, currentUser?: { __typename?: 'User', id: string, role?: UserRole | null, company?: { __typename?: 'Company', id: string, type?: string | null, code?: string | null, professionCode?: string | null, pointOfSale?: { __typename?: 'PointOfSale', id: string, parentId?: string | null, name: string, subsidiary: { __typename?: 'Subsidiary', id: string, name: string } } | null } | null, favoritePointOfSale?: { __typename?: 'PointOfSale', id: string, parentId?: string | null } | null, checkout?: { __typename?: 'Checkout', cart: { __typename?: 'Cart', id: string } } | null, loyalty: { __typename?: 'Loyalty', status: LoyaltyStatus, data?: { __typename?: 'LoyaltyData', active: boolean } | null } } | null };

export type ZendeskScriptQueryVariables = Exact<{ [key: string]: never; }>;


export type ZendeskScriptQuery = { __typename?: 'Query', config: { __typename?: 'Config', support?: { __typename?: 'ConfigSupport', isGlobalClick2ChatEnabled: boolean, isLoginClick2ChatEnabled: boolean, scriptKey: string } | null } };

export type ForbiddenPhoneTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ForbiddenPhoneTypesQuery = { __typename?: 'Query', config: { __typename?: 'Config', customer?: { __typename?: 'ConfigCustomer', forbiddenPhoneTypes?: Array<string> | null } | null } };

export type FullPictureFragment = { __typename?: 'Image', alt?: string | null, set?: Array<{ __typename?: 'ImageUrl', url: string, media: Media }> | null };

export const AccountSelectionCurrentUserAccountsFragmentDoc = gql`
    fragment AccountSelectionCurrentUserAccounts on User {
  id
  favoritePointOfSale {
    id
    name
  }
  company {
    id
    code
    name
    pointOfSale {
      name
      id
      subsidiary {
        id
      }
    }
  }
}
    `;
export const OrdersHistoryConfigFragmentDoc = gql`
    fragment OrdersHistoryConfig on Config {
  sales {
    isUniqueOrderDetailsDisplayEnabled
  }
}
    `;
export const WishlistResolvedPricing_ProductWishlistFragmentDoc = gql`
    fragment WishlistResolvedPricing_ProductWishlist on ProductWishlist {
  rowTotalExclTax
  conditioningUnitPriceExclTax
  catalogDiscountAmount
}
    `;
export const FullPictureFragmentDoc = gql`
    fragment FullPicture on Image {
  alt
  set {
    url
    media
  }
}
    `;
export const ProductRowBase_ProductFragmentDoc = gql`
    fragment ProductRowBase_Product on Product {
  name
  type
  mainImage {
    ...FullPicture
  }
  brand {
    name
    urlKey
  }
  reference
  isLinkedProductsLinkVisible
  urlKey
}
    ${FullPictureFragmentDoc}`;
export const WishlistProduct_ProductFragmentDoc = gql`
    fragment WishlistProduct_Product on Product {
  ...ProductRowBase_Product
  firstLevelCategory {
    code
    name
  }
  isEquivalentProductsLinkVisible
}
    ${ProductRowBase_ProductFragmentDoc}`;
export const FullPackagingFragmentDoc = gql`
    fragment FullPackaging on ProductPackaging {
  quantity
  unit
  incrementQuantity
  minimalSalesQuantity
}
    `;
export const CurrentQuoteDetailPage_ProductWishlistFragmentDoc = gql`
    fragment CurrentQuoteDetailPage_ProductWishlist on ProductWishlist {
  id
  comment
  quantity
  ...WishlistResolvedPricing_ProductWishlist
  product {
    ...WishlistProduct_Product
    stock {
      packaging {
        ...FullPackaging
      }
    }
  }
  attachments {
    id
    name
    extension
    length
  }
}
    ${WishlistResolvedPricing_ProductWishlistFragmentDoc}
${WishlistProduct_ProductFragmentDoc}
${FullPackagingFragmentDoc}`;
export const CurrentQuoteDetailPage_WishlistFragmentDoc = gql`
    fragment CurrentQuoteDetailPage_Wishlist on Wishlist {
  id
  productCount
  totalExclTax
  products {
    ...CurrentQuoteDetailPage_ProductWishlist
  }
}
    ${CurrentQuoteDetailPage_ProductWishlistFragmentDoc}`;
export const QuoteProductDetail_QuoteProductFragmentDoc = gql`
    fragment QuoteProductDetail_QuoteProduct on QuoteProduct {
  reference
  quantity
}
    `;
export const QuoteComment_QuoteFragmentDoc = gql`
    fragment QuoteComment_Quote on QuoteComment {
  comment
  level
}
    `;
export const QuoteDetail_QuoteManagementFragmentDoc = gql`
    fragment QuoteDetail_QuoteManagement on QuoteManagement {
  approveNotAllowedReason
  renewedNotAllowedReason
  sharedNotAllowedReason
  canBeApproved
  canBeRenewed
  canBeShared
}
    `;
export const QuoteProductsInfo_QuoteProductFragmentDoc = gql`
    fragment QuoteProductsInfo_QuoteProduct on QuoteProduct {
  reference
  name
  product {
    mainImage {
      ...FullPicture
    }
    urlKey
  }
}
    ${FullPictureFragmentDoc}`;
export const QuoteProductsTable_QuoteProductFragmentDoc = gql`
    fragment QuoteProductsTable_QuoteProduct on QuoteProduct {
  quantity
  priceExcludingTax
  totalExcludingTax
  comment
  uniqueKey
  packaging {
    quantity
    unit
  }
  ...QuoteProductsInfo_QuoteProduct
}
    ${QuoteProductsInfo_QuoteProductFragmentDoc}`;
export const QuoteDetail_QuoteFragmentDoc = gql`
    fragment QuoteDetail_Quote on Quote {
  id
  status
  createdAt
  expiredAt
  updatedAt
  commercialName
  ref
  totalExcludingTax
  hasSpecificProduct
  orderId
  comment {
    ...QuoteComment_Quote
  }
  management {
    ...QuoteDetail_QuoteManagement
  }
  pointOfSale {
    ... on PointOfSale {
      name
      id
    }
  }
  products {
    ...QuoteProductsTable_QuoteProduct
  }
}
    ${QuoteComment_QuoteFragmentDoc}
${QuoteDetail_QuoteManagementFragmentDoc}
${QuoteProductsTable_QuoteProductFragmentDoc}`;
export const QuotesPage_ConfigFragmentDoc = gql`
    fragment QuotesPage_Config on Config {
  quotation {
    isQuotationEnabled
  }
}
    `;
export const CurrentCollaborator_UserFragmentDoc = gql`
    fragment CurrentCollaborator_User on User {
  id
  role
}
    `;
export const OrderRequestDetails_OrderFragmentDoc = gql`
    fragment OrderRequestDetails_Order on Order {
  payment {
    code
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
  }
  totalAmount
  totalAmountInclTax
  vatDetails {
    amount
    label
  }
  totalDiscount
  totalEcoPart
  totalOrderedProducts
  subtotalExclTax
}
    `;
export const OrderRequestConfig_ConfigFragmentDoc = gql`
    fragment OrderRequestConfig_Config on Config {
  checkout {
    isActiveOrderRequest
  }
}
    `;
export const QuickOrderProductList_ProductsFragmentDoc = gql`
    fragment QuickOrderProductList_Products on Wishlist {
  id
  products {
    id
    quantity
    comment
    ...WishlistResolvedPricing_ProductWishlist
    product {
      ...WishlistProduct_Product
    }
  }
  productCount
}
    ${WishlistResolvedPricing_ProductWishlistFragmentDoc}
${WishlistProduct_ProductFragmentDoc}`;
export const TopPurchaseConfig_ConfigFragmentDoc = gql`
    fragment TopPurchaseConfig_Config on Config {
  customer {
    isTopPurchaseEnabled
  }
}
    `;
export const HubList_CategoriesFragmentDoc = gql`
    fragment HubList_Categories on Category {
  code
  name
  mainImage {
    ...FullPicture
  }
}
    ${FullPictureFragmentDoc}`;
export const BrandsList_BrandsFragmentDoc = gql`
    fragment BrandsList_Brands on Brand {
  name
  urlKey
}
    `;
export const EventHeaderInformation_EventFragmentDoc = gql`
    fragment EventHeaderInformation_Event on Event {
  title
  baseline
  catalogLink
  catalogLinkOpenInNewTab
  catalogTitle
  conditions
  description
  youtubeLink
  productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
    productCount
  }
}
    `;
export const Breadcrumb_PathFragmentDoc = gql`
    fragment Breadcrumb_Path on Breadcrumb {
  urlKey
  name
}
    `;
export const EquivalentProductFieldsWithoutPriceFragmentDoc = gql`
    fragment EquivalentProductFieldsWithoutPrice on Product {
  name
  urlKey
  reference
  brand {
    logo {
      ...FullPicture
    }
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  type
  technicalSpecs {
    label
    value
  }
}
    ${FullPictureFragmentDoc}`;
export const ProductDetailInfosHeader_ProductFragmentDoc = gql`
    fragment ProductDetailInfosHeader_Product on Product {
  brand {
    name
    urlKey
  }
  reference
  name
  supplierReference
  type
}
    `;
export const ProductMarketingInsertTag_ProductFragmentDoc = gql`
    fragment ProductMarketingInsertTag_Product on Product {
  marketingInsert {
    label
    legalNotice
  }
}
    `;
export const ProductBuyBoxFields_ProductFragmentDoc = gql`
    fragment ProductBuyBoxFields_Product on Product {
  brand {
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  name
  nbArticles
  reference
  type
}
    ${FullPictureFragmentDoc}`;
export const FiltersFieldsFragmentDoc = gql`
    fragment FiltersFields on ProductFilter {
  label
  values {
    label
    references
  }
}
    `;
export const ProductBuyBox_ProductFragmentDoc = gql`
    fragment ProductBuyBox_Product on Product {
  ...ProductBuyBoxFields_Product
  brand {
    urlKey
    logo {
      ...FullPicture
    }
  }
  filters {
    ...FiltersFields
  }
  urlKey
}
    ${ProductBuyBoxFields_ProductFragmentDoc}
${FullPictureFragmentDoc}
${FiltersFieldsFragmentDoc}`;
export const ProductStoreStockLinkProductReferenceFragmentDoc = gql`
    fragment ProductStoreStockLinkProductReference on Product {
  reference
}
    `;
export const ProductDocuments_DocumentsFragmentDoc = gql`
    fragment ProductDocuments_Documents on Document {
  name
  link
}
    `;
export const ProductTechnicalSpecs_TechnicalSpecsFragmentDoc = gql`
    fragment ProductTechnicalSpecs_TechnicalSpecs on TechnicalSpec {
  label
  value
}
    `;
export const ProductTechnicalSpecsFull_NormsFragmentDoc = gql`
    fragment ProductTechnicalSpecsFull_Norms on Norm {
  id
  name
}
    `;
export const ProductTechnicalSpecsSection_ProductFragmentDoc = gql`
    fragment ProductTechnicalSpecsSection_Product on Product {
  mainTechnicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  technicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  norms {
    ...ProductTechnicalSpecsFull_Norms
  }
}
    ${ProductTechnicalSpecs_TechnicalSpecsFragmentDoc}
${ProductTechnicalSpecsFull_NormsFragmentDoc}`;
export const ProductNorms_NormFragmentDoc = gql`
    fragment ProductNorms_Norm on Norm {
  id
  name
  image
}
    `;
export const ProductLabels_ProductFragmentDoc = gql`
    fragment ProductLabels_Product on Product {
  hasRseLabel
}
    `;
export const ProductDetailInfos_ProductFragmentDoc = gql`
    fragment ProductDetailInfos_Product on Product {
  description
  shortDescription
  ...ProductDetailInfosHeader_Product
  ...ProductMarketingInsertTag_Product
  ...ProductBuyBox_Product
  ...ProductStoreStockLinkProductReference
  documents {
    ...ProductDocuments_Documents
  }
  ...ProductTechnicalSpecsSection_Product
  mainTechnicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  norms {
    ...ProductNorms_Norm
  }
  ...ProductLabels_Product
}
    ${ProductDetailInfosHeader_ProductFragmentDoc}
${ProductMarketingInsertTag_ProductFragmentDoc}
${ProductBuyBox_ProductFragmentDoc}
${ProductStoreStockLinkProductReferenceFragmentDoc}
${ProductDocuments_DocumentsFragmentDoc}
${ProductTechnicalSpecsSection_ProductFragmentDoc}
${ProductTechnicalSpecs_TechnicalSpecsFragmentDoc}
${ProductNorms_NormFragmentDoc}
${ProductLabels_ProductFragmentDoc}`;
export const ProductDetail_ProductFragmentDoc = gql`
    fragment ProductDetail_Product on Product {
  ...ProductDetailInfos_Product
  reference
  images {
    ...FullPicture
  }
  videoUrls
}
    ${ProductDetailInfos_ProductFragmentDoc}
${FullPictureFragmentDoc}`;
export const ProductPageAnalytics_ProductFragmentDoc = gql`
    fragment ProductPageAnalytics_Product on Product {
  reference
  name
  description
  type
  firstLevelCategory {
    name
  }
  breadcrumbs {
    name
    urlKey
  }
  brand {
    urlKey
    name
  }
  technicalSpecs {
    label
    value
  }
  equivalentProducts {
    reference
    name
  }
  supplierReference
  mainImage {
    ...FullPicture
  }
  images {
    ...FullPicture
  }
  filters {
    ...FiltersFields
  }
  nomenclatureFamily
  nomenclatureGroup
}
    ${FullPictureFragmentDoc}
${FiltersFieldsFragmentDoc}`;
export const SearchProductsField_SearchFragmentDoc = gql`
    fragment SearchProductsField_Search on Search {
  products {
    name
    urlKey
    reference
    brand {
      name
      urlKey
    }
    mainImage {
      ...FullPicture
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const CmsTwoColumnsImageFragmentDoc = gql`
    fragment CMSTwoColumnsImage on CMS_TwoColumnsImageBlock {
  id
  blockType
  title
  content
  tint
  picture {
    url
    alt
    width
    height
  }
  picturePosition
  pictureLinkUrl
  pictureLinkTarget
  link {
    label
    url
    variant
    iconLeft
    iconRight
  }
}
    `;
export const CmsTitleH2H3FragmentDoc = gql`
    fragment CMSTitleH2H3 on CMS_SectionHeaderBlock {
  id
  blockType
  title
  titleAs
  description
  descriptionSize
  link {
    label
    url
    variant
    iconLeft
    iconRight
  }
}
    `;
export const CmsCalloutFragmentDoc = gql`
    fragment CMSCallout on CMS_CalloutBlock {
  id
  blockType
  title
  calloutDescriptionRichText
  tint
  icon
}
    `;
export const CmsEpigraphFragmentDoc = gql`
    fragment CMSEpigraph on CMS_QuoteBlock {
  id
  blockType
  text
  size
  align
}
    `;
export const CmsBrandsSliderFragmentDoc = gql`
    fragment CMSBrandsSlider on CMS_BrandsSliderBlock {
  id
  blockType
}
    `;
export const CmsCatalogListFragmentDoc = gql`
    fragment CMSCatalogList on CMS_CatalogListBlock {
  id
  blockType
  title
  subTitle
  buttonLabelSeeLess
  buttonLabelSeeMore
  layout {
    ... on CMS_CatalogCardBlock {
      id
      blockType
      title
      url
      label
      catalogCardPicture {
        url
        alt
        width
        height
      }
    }
  }
}
    `;
export const CmsInnerHtmlFragmentDoc = gql`
    fragment CMSInnerHtml on CMS_InnerHtmlBlock {
  id
  htmlContent
  blockType
  blockName
}
    `;
export const CmsColumnFragmentDoc = gql`
    fragment CMSColumn on CMS_ColumnsBlock {
  id
  blockType
  columns {
    __typename
    ... on CMS_StepBlock {
      id
      blockType
      number
      title
      description
      icon
      illustration
    }
    ... on CMS_KeyInformationBlock {
      id
      blockType
      title
      subTitle
      description
      icon
      illustration
    }
    ... on CMS_CardBlock {
      id
      blockType
      title
      titleTag
      titleSize
      isTitleBold
      picture {
        url
        alt
        width
        height
      }
      pictureHeight
      pictureLink
      cardRichText
      link {
        label
        url
        variant
        iconLeft
        iconRight
      }
    }
    ... on CMS_CardIconBlock {
      id
      blockType
      title
      icon
      description
      linkUrl
      linkLabel
    }
    ... on CMS_InnerHtmlBlock {
      ...CMSInnerHtml
    }
  }
}
    ${CmsInnerHtmlFragmentDoc}`;
export const CmsVideoPlayerFragmentDoc = gql`
    fragment CMSVideoPlayer on CMS_VideoPlayerBlock {
  id
  blockType
  platform
  videoId
  aspectRatio
  thumbnail {
    url
    alt
    width
    height
  }
  youtubeControls
  youtubePlaysInline
  youtubeMute
  youtubeAutoplay
  vimeoControls
  vimeoMute
  vimeoAutoplay
  vimeoLoop
}
    `;
export const CmsPictureFragmentDoc = gql`
    fragment CMSPicture on CMS_PictureBlock {
  id
  blockType
  pictureDesktop {
    url
    width
    height
  }
  pictureMobile {
    url
    width
    height
  }
  mode
}
    `;
export const CmsPhoneCallbackBannerFragmentDoc = gql`
    fragment CMSPhoneCallbackBanner on CMS_PhoneCallbackBannerBlock {
  id
  blockType
}
    `;
export const CmsFormFragmentDoc = gql`
    fragment CMSForm on CMS_FormBlock {
  id
  blockType
  form {
    id
    title
    submitButtonLabel
    confirmationType
    confirmationMessage
    redirect {
      url
    }
    fields {
      ... on CMS_Text {
        blockType
        blockName
        name
        label
        defaultValue
        width
        required
        id
      }
      ... on CMS_Email {
        id
        name
        label
        width
        required
        blockName
        blockType
      }
      ... on CMS_Checkbox {
        id
        name
        label
        width
        defaultChecked: defaultValue
        required
        blockName
        blockType
      }
    }
  }
}
    `;
export const HomePage_ConfigFragmentDoc = gql`
    fragment HomePage_Config on Config {
  homepage {
    ourServicesBlockEnabled
    ourSelectionGuidesBlockEnabled
    ourBrandsBlockEnabled
  }
}
    `;
export const ProductsStickersProductFragmentDoc = gql`
    fragment ProductsStickersProduct on Product {
  reference
  name
  urlKey
  brand {
    name
  }
  mainImage {
    set {
      media
      url
    }
  }
}
    `;
export const AccountCard_CompanyFragmentDoc = gql`
    fragment AccountCard_Company on Company {
  code
  name
  pointOfSale {
    name
    id
    subsidiary {
      id
    }
  }
}
    `;
export const CurrentUser_FavoritePointOfSaleFragmentDoc = gql`
    fragment CurrentUser_FavoritePointOfSale on User {
  favoritePointOfSale {
    id
  }
}
    `;
export const AccountHomeSlider_OrderFragmentDoc = gql`
    fragment AccountHomeSlider_Order on Order {
  deliveryDate
  orderDate
  webRef
  internalRef
  externalRef
  status
  totalAmount
}
    `;
export const FullOpeningHourFragmentDoc = gql`
    fragment FullOpeningHour on OpeningHour {
  dayOfWeek
  day
  intervals {
    begin
    end
  }
}
    `;
export const AccountHomeSlider_PointOfSaleAddressFragmentDoc = gql`
    fragment AccountHomeSlider_PointOfSaleAddress on PointOfSaleAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  postalCode
}
    `;
export const AccountHomeSlider_PointOfSaleFragmentDoc = gql`
    fragment AccountHomeSlider_PointOfSale on PointOfSale {
  id
  name
  open
  openingHours {
    ...FullOpeningHour
  }
  phoneNumber
  latitude
  longitude
  address {
    ...AccountHomeSlider_PointOfSaleAddress
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
}
    ${FullOpeningHourFragmentDoc}
${AccountHomeSlider_PointOfSaleAddressFragmentDoc}`;
export const CompanyList_PointOfSaleFragmentDoc = gql`
    fragment CompanyList_PointOfSale on PointOfSale {
  name
  phoneNumber
  id
  address {
    line1
    city
  }
  subsidiary {
    id
  }
}
    `;
export const CompanyList_CompanyFragmentDoc = gql`
    fragment CompanyList_Company on Company {
  code
  name
  id
  pointOfSale {
    ...CompanyList_PointOfSale
  }
}
    ${CompanyList_PointOfSaleFragmentDoc}`;
export const CompanyList_CurrentUserAccountsFragmentDoc = gql`
    fragment CompanyList_CurrentUserAccounts on User {
  id
  email
  company {
    ...CompanyList_Company
  }
  favoritePointOfSale {
    id
    name
  }
}
    ${CompanyList_CompanyFragmentDoc}`;
export const CompanyNationalIdInput_CompanyNationalIdFormatFragmentDoc = gql`
    fragment CompanyNationalIdInput_CompanyNationalIdFormat on CompanyNationalIdFormat {
  charset
  isoCountryCode3
  maxLength
  minLength
}
    `;
export const DocForm_PointOfSaleAddressFragmentDoc = gql`
    fragment DOCForm_PointOfSaleAddress on PointOfSaleAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  postalCode
}
    `;
export const DocForm_PointOfSaleFragmentDoc = gql`
    fragment DOCForm_PointOfSale on PointOfSale {
  id
  name
  open
  phoneNumber
  latitude
  longitude
  address {
    ...DOCForm_PointOfSaleAddress
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
  activity
}
    ${DocForm_PointOfSaleAddressFragmentDoc}`;
export const CaptchaConfigFragmentDoc = gql`
    fragment CaptchaConfig on ConfigCaptcha {
  isEnabled
  siteKey
}
    `;
export const UserInformationForm_UserFragmentDoc = gql`
    fragment UserInformationForm_User on User {
  id
  email
  firstname
  lastname
  phone
  emailPreferences {
    emailType
    receiveEmail
  }
  permissions {
    showPreferenceCommunication
  }
  company {
    id
    name
    code
  }
}
    `;
export const SelectCompanyCard_UserFragmentDoc = gql`
    fragment SelectCompanyCard_User on User {
  id
  email
  favoritePointOfSale {
    id
    name
  }
  company {
    id
    code
    name
    pointOfSale {
      id
      name
      subsidiary {
        id
      }
      address {
        line1
      }
    }
  }
}
    `;
export const RequestCompanyRegistrationAction_PointOfSaleFragmentDoc = gql`
    fragment RequestCompanyRegistrationAction_PointOfSale on PointOfSale {
  id
  name
  distributionNetworkLabel
  subsidiary {
    id
    name
  }
  address {
    line1
    line2
    line3
    postalCode
    city
    isoCountryCode
  }
  phoneNumber
}
    `;
export const RequestCompanyRegistration_CompanyRegistrationResultFragmentDoc = gql`
    fragment RequestCompanyRegistration_CompanyRegistrationResult on CompanyRegistrationResult {
  code
  name
  companyNationalId
  pointOfSale {
    ...RequestCompanyRegistrationAction_PointOfSale
  }
}
    ${RequestCompanyRegistrationAction_PointOfSaleFragmentDoc}`;
export const RequestUseRegistration_CompanyFragmentDoc = gql`
    fragment RequestUseRegistration_Company on Company {
  code
  name
  pointOfSale {
    name
    id
    subsidiary {
      id
    }
  }
}
    `;
export const SpecialtyFragmentDoc = gql`
    fragment Specialty on ProfessionActivitySpeciality {
  name
  id
  activityId
}
    `;
export const ActivityFragmentDoc = gql`
    fragment Activity on ProfessionActivity {
  name
  id
  specialities {
    ...Specialty
  }
}
    ${SpecialtyFragmentDoc}`;
export const UserCompanyAddressFragmentDoc = gql`
    fragment UserCompanyAddress on UserCompanyAddress {
  city
  isoCountryCode
  id
  isDefault
  line1
  line2
  line3
  name
  postalCode
  primary
  type
}
    `;
export const ServiceAddressMetadataFragmentDoc = gql`
    fragment ServiceAddressMetadata on ServiceAddress {
  streetId
  latitude
  longitude
}
    `;
export const ApprovalFlowTable_UserFragmentDoc = gql`
    fragment ApprovalFlowTable_User on User {
  id
  firstname
  lastname
  email
  role
  phone
}
    `;
export const ApprovalFlowTable_ApprovalFlowFragmentDoc = gql`
    fragment ApprovalFlowTable_ApprovalFlow on ApprovalFlow {
  id
  name
  minimumAmount
  approvers {
    ...ApprovalFlowTable_User
  }
  approvees {
    ...ApprovalFlowTable_User
  }
}
    ${ApprovalFlowTable_UserFragmentDoc}`;
export const ApprovalFlowTable_CompanyFragmentDoc = gql`
    fragment ApprovalFlowTable_Company on Company {
  approvalFlows(input: $input) {
    items {
      ...ApprovalFlowTable_ApprovalFlow
      minimumAmount
    }
    totalPages
    totalSize
  }
}
    ${ApprovalFlowTable_ApprovalFlowFragmentDoc}`;
export const UpsertApprovalFlowDrawer_ApprovalFlowFragmentDoc = gql`
    fragment UpsertApprovalFlowDrawer_ApprovalFlow on ApprovalFlow {
  id
  name
  minimumAmount
  approvers {
    ...ApprovalFlowTable_User
  }
  approvees {
    ...ApprovalFlowTable_User
  }
}
    ${ApprovalFlowTable_UserFragmentDoc}`;
export const AlreadyActiveAccountFragmentDoc = gql`
    fragment AlreadyActiveAccount on Company {
  id
  code
  managerEmailHidden
}
    `;
export const PunchoutLogin_TokenFragmentDoc = gql`
    fragment PunchoutLogin_Token on Token {
  maxAge
  type
  value
}
    `;
export const CartFixedBar_CartFragmentDoc = gql`
    fragment CartFixedBar_Cart on Cart {
  totalExclTax
}
    `;
export const CartItemsSectionLabel_SectionFragmentDoc = gql`
    fragment CartItemsSectionLabel_Section on CartItemsSection {
  quantity
  info {
    ... on CartItemsSectionInfoReal {
      date
    }
    ... on CartItemsSectionInfoEstimated {
      delay
    }
    ... on CartItemsSectionInfoClickAndCollect {
      noValue
    }
  }
}
    `;
export const CartPdfTemplate_CurrentUserFragmentDoc = gql`
    fragment CartPdfTemplate_CurrentUser on User {
  email
  firstname
  lastname
  company {
    name
    code
  }
}
    `;
export const CartPdfTemplate_ProductFragmentDoc = gql`
    fragment CartPdfTemplate_Product on Product {
  reference
  name
  type
  mainImage {
    ...FullPicture
  }
  brand {
    name
    urlKey
  }
  price {
    discountPercentage
    discountExclTax
  }
  stock {
    availability
    isPriceAvailable
    isSellable
    packaging {
      ...FullPackaging
    }
  }
  isLinkedProductsLinkVisible
  urlKey
  canAddToCart
  clickAndCollectStatus
}
    ${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const CartPdfTemplate_CartFragmentDoc = gql`
    fragment CartPdfTemplate_Cart on Cart {
  id
  subtotalExclTax
  totalExclTax
  totalInclTax
  taxesDetails {
    amount {
      value
    }
    label
  }
  totalDiscount
  totalEcoPart
  amountUntilFreeDelivery
  totalQuantity
  itemsGroupedByEarliestDeliveryDate {
    quantity
    info {
      __typename
      ... on CartItemsSectionInfoReal {
        date
      }
      ... on CartItemsSectionInfoEstimated {
        delay
      }
    }
    items {
      id
      quantity
      quantityMax
      totalExclTax
      unitPrice {
        exclTax
      }
      deliveryDetails {
        date
        quantity
        availability
        realDeliveryDate
      }
      product {
        ...CartPdfTemplate_Product
      }
      discount {
        catalogDiscountAmount
        percentage
        webDiscount {
          amount
          hasCoupon
          label
        }
        quantitySaleNextLevel {
          gap
          unitPrice
        }
      }
      promotionTag {
        label
        type
      }
      hasPaymentWarning
      availableClickAndCollect
    }
  }
}
    ${CartPdfTemplate_ProductFragmentDoc}`;
export const CartSummaryPricing_CartFragmentDoc = gql`
    fragment CartSummaryPricing_Cart on Cart {
  id
  totalExclTax
  totalDiscount
  totalEcoPart
}
    `;
export const CartSummaryPricing_ShippingFragmentDoc = gql`
    fragment CartSummaryPricing_Shipping on Shipping {
  fee {
    ... on ShippingFeeFree {
      isFranco
    }
    ... on ShippingFeeWithAmount {
      amount
    }
  }
}
    `;
export const CartSummaryPricing_OrderFragmentDoc = gql`
    fragment CartSummaryPricing_Order on Order {
  __typename
  payment {
    code
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
  }
  totalAmount
  totalEcoPart
  totalDiscount
  totalOrderedProducts
}
    `;
export const ConvertOrderRequestDeliveryDrawer_CartFragmentDoc = gql`
    fragment ConvertOrderRequestDeliveryDrawer_Cart on Cart {
  id
}
    `;
export const ApplyCouponCodeForm_CartFragmentDoc = gql`
    fragment ApplyCouponCodeForm_Cart on Cart {
  id
  couponCode
  legalNotices
}
    `;
export const CartSummary_CartFragmentDoc = gql`
    fragment CartSummary_Cart on Cart {
  subtotalExclTax
  totalExclTax
  taxesDetails {
    amount {
      value
    }
    label
  }
  totalInclTax
  totalDiscount
  totalEcoPart
  amountUntilFreeDelivery
  totalQuantity
}
    `;
export const CartActionsCard_ItemFragmentDoc = gql`
    fragment CartActionsCard_Item on CartItem {
  id
  quantity
  product {
    reference
  }
}
    `;
export const CartActionsCard_CartFragmentDoc = gql`
    fragment CartActionsCard_Cart on Cart {
  id
  itemsGroupedByEarliestDeliveryDate {
    quantity
    items {
      ...CartActionsCard_Item
    }
  }
}
    ${CartActionsCard_ItemFragmentDoc}`;
export const Cart_CartFragmentDoc = gql`
    fragment Cart_Cart on Cart {
  id
  ...ConvertOrderRequestDeliveryDrawer_Cart
  ...ApplyCouponCodeForm_Cart
  ...CartSummary_Cart
  ...CartActionsCard_Cart
  totalQuantity
}
    ${ConvertOrderRequestDeliveryDrawer_CartFragmentDoc}
${ApplyCouponCodeForm_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${CartActionsCard_CartFragmentDoc}`;
export const ShippingFeeTag_FeeFragmentDoc = gql`
    fragment ShippingFeeTag_Fee on ShippingFee {
  ... on ShippingFeeFree {
    isFranco
  }
  ... on ShippingFeeWithAmount {
    amount
  }
}
    `;
export const CartSummary_ShippingFragmentDoc = gql`
    fragment CartSummary_Shipping on Shipping {
  fee {
    ...ShippingFeeTag_Fee
  }
}
    ${ShippingFeeTag_FeeFragmentDoc}`;
export const ClickAndCollectSwitchBanner_CartFragmentDoc = gql`
    fragment ClickAndCollectSwitchBanner_Cart on Cart {
  id
  sumItemsQuantity
  availableClickAndCollectQuantity
  isClickAndCollectActivated
  isClickAndCollectFeatureAvailable
  pointOfSale {
    id
    name
  }
}
    `;
export const AddProductReferenceForm_CartFragmentDoc = gql`
    fragment AddProductReferenceForm_Cart on Cart {
  id
  isClickAndCollectActivated
  items {
    id
    product {
      reference
    }
  }
}
    `;
export const CartContent_CartFragmentDoc = gql`
    fragment CartContent_Cart on Cart {
  id
  totalQuantity
  legalNotices
  couponCode
  isClickAndCollectActivated
  isClickAndCollectToggleAvailable
  hasClickAndCollectOnlyItems
  ...ClickAndCollectSwitchBanner_Cart
  ...AddProductReferenceForm_Cart
}
    ${ClickAndCollectSwitchBanner_CartFragmentDoc}
${AddProductReferenceForm_CartFragmentDoc}`;
export const CartItemLimitedQuantityBox_ItemFragmentDoc = gql`
    fragment CartItemLimitedQuantityBox_Item on CartItem {
  id
  product {
    reference
    name
    brand {
      name
      urlKey
    }
    mainImage {
      ...FullPicture
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const ResolveClickAndCollectOfCartItemsDrawer_ItemsFragmentDoc = gql`
    fragment ResolveClickAndCollectOfCartItemsDrawer_Items on CartItem {
  id
  quantity
  ...CartItemLimitedQuantityBox_Item
  warnings {
    type
    message
    additionalData {
      value
      key
    }
  }
}
    ${CartItemLimitedQuantityBox_ItemFragmentDoc}`;
export const ProductStock_AvailabilitiesFragmentDoc = gql`
    fragment ProductStock_Availabilities on ProductStock {
  availability
  storeQuantity
  shippingDelay
}
    `;
export const FullProductAvailabilityItem_AvailabilityFragmentDoc = gql`
    fragment FullProductAvailabilityItem_Availability on Product {
  canAddToCart
  clickAndCollectStatus
  stock {
    ...ProductStock_Availabilities
    maxQuantity
    onlineQuantity
    g9LowStockThreshold
    isPriceAvailable
    isSellable
  }
}
    ${ProductStock_AvailabilitiesFragmentDoc}`;
export const ProductRowPriceAndStock_ProductFragmentDoc = gql`
    fragment ProductRowPriceAndStock_Product on Product {
  reference
  ...FullProductAvailabilityItem_Availability
  price {
    discountPercentage
    discountExclTax
  }
  stock {
    packaging {
      ...FullPackaging
    }
  }
}
    ${FullProductAvailabilityItem_AvailabilityFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductRow_ProductFragmentDoc = gql`
    fragment ProductRow_Product on Product {
  ...ProductRowBase_Product
  ...ProductRowPriceAndStock_Product
}
    ${ProductRowBase_ProductFragmentDoc}
${ProductRowPriceAndStock_ProductFragmentDoc}`;
export const CartItem_ItemFragmentDoc = gql`
    fragment CartItem_Item on CartItem {
  id
  quantity
  quantityMax
  totalExclTax
  unitPrice {
    exclTax
  }
  deliveryDetails {
    date
    quantity
    availability
    realDeliveryDate
  }
  product {
    reference
    ...ProductRow_Product
  }
  discount {
    catalogDiscountAmount
    percentage
    webDiscount {
      amount
      hasCoupon
      label
    }
    quantitySaleNextLevel {
      gap
      unitPrice
    }
  }
  promotionTag {
    label
    type
  }
  hasPaymentWarning
  availableClickAndCollect
}
    ${ProductRow_ProductFragmentDoc}`;
export const CartTracking_ItemFragmentDoc = gql`
    fragment CartTracking_Item on CartItem {
  id
  analyticsPromotionStatus
  product {
    reference
  }
  quantity
  unitPrice {
    exclTax
  }
  deliveryDetails {
    date
    quantity
    availability
    realDeliveryDate
  }
  availableClickAndCollect
  totalExclTax
}
    `;
export const CartItems_ItemsSectionFragmentDoc = gql`
    fragment CartItems_ItemsSection on CartItemsSection {
  quantity
  items {
    ...CartItem_Item
    ...CartTracking_Item
    quantity
  }
  info {
    ... on CartItemsSectionInfoReal {
      date
    }
    ... on CartItemsSectionInfoEstimated {
      delay
    }
  }
}
    ${CartItem_ItemFragmentDoc}
${CartTracking_ItemFragmentDoc}`;
export const CheckoutCartContentToasts_MessagesFragmentDoc = gql`
    fragment CheckoutCartContentToasts_Messages on CartMessage {
  message
}
    `;
export const ConfirmClearCart_CartFragmentDoc = gql`
    fragment ConfirmClearCart_Cart on Cart {
  id
}
    `;
export const CartItems_CartFragmentDoc = gql`
    fragment CartItems_Cart on Cart {
  id
  items {
    ...ResolveClickAndCollectOfCartItemsDrawer_Items
  }
  itemsGroupedByEarliestDeliveryDate {
    ...CartItems_ItemsSection
  }
  isClickAndCollectActivated
  isClickAndCollectFeatureAvailable
  isClickAndCollectToggleAvailable
  hasClickAndCollectOnlyItems
  messages {
    ...CheckoutCartContentToasts_Messages
  }
  taxesDetails {
    amount {
      value
    }
    label
  }
  ...ConfirmClearCart_Cart
}
    ${ResolveClickAndCollectOfCartItemsDrawer_ItemsFragmentDoc}
${CartItems_ItemsSectionFragmentDoc}
${CheckoutCartContentToasts_MessagesFragmentDoc}
${ConfirmClearCart_CartFragmentDoc}`;
export const CartItem_CartFragmentDoc = gql`
    fragment CartItem_Cart on Cart {
  subtotalExclTax
  totalExclTax
  totalInclTax
  totalDiscount
  totalEcoPart
  amountUntilFreeDelivery
  totalQuantity
  availableClickAndCollectQuantity
}
    `;
export const CartItems_CheckoutFragmentDoc = gql`
    fragment CartItems_Checkout on Checkout {
  cart(forceRefresh: true) {
    id
    ...CartItems_Cart
    ...CartItem_Cart
  }
  willGenerateOrderRequest
}
    ${CartItems_CartFragmentDoc}
${CartItem_CartFragmentDoc}`;
export const CartContent_CheckoutFragmentDoc = gql`
    fragment CartContent_Checkout on Checkout {
  cart(forceRefresh: true) {
    id
    ...CartContent_Cart
  }
  willGenerateOrderRequest
  ...CartItems_Checkout
}
    ${CartContent_CartFragmentDoc}
${CartItems_CheckoutFragmentDoc}`;
export const Cart_CheckoutFragmentDoc = gql`
    fragment Cart_Checkout on Checkout {
  cart(forceRefresh: true) {
    ...Cart_Cart
  }
  shipping {
    ...CartSummary_Shipping
  }
  ...CartContent_Checkout
}
    ${Cart_CartFragmentDoc}
${CartSummary_ShippingFragmentDoc}
${CartContent_CheckoutFragmentDoc}`;
export const CartItemsWarnings_CartFragmentDoc = gql`
    fragment CartItemsWarnings_Cart on Cart {
  id
  isClickAndCollectFeatureAvailable
  messages {
    ...CheckoutCartContentToasts_Messages
  }
  items {
    ...ResolveClickAndCollectOfCartItemsDrawer_Items
  }
}
    ${CheckoutCartContentToasts_MessagesFragmentDoc}
${ResolveClickAndCollectOfCartItemsDrawer_ItemsFragmentDoc}`;
export const CheckoutCartForm_UserFragmentDoc = gql`
    fragment CheckoutCartForm_User on User {
  id
  role
  company {
    id
    forbidden
  }
  checkout {
    willGenerateOrderRequest
    cart(forceRefresh: true) {
      id
    }
  }
}
    `;
export const MiniCart_ItemFragmentDoc = gql`
    fragment MiniCart_Item on CartItem {
  id
  quantity
  totalExclTax
  unitPrice {
    exclTax
  }
  product {
    reference
    name
    type
    urlKey
    mainImage {
      ...FullPicture
    }
    brand {
      name
      urlKey
    }
    stock {
      availability
      isPriceAvailable
      isSellable
      packaging {
        ...FullPackaging
      }
    }
    canAddToCart
    clickAndCollectStatus
  }
  discount {
    catalogDiscountAmount
    percentage
    webDiscount {
      amount
      hasCoupon
      label
    }
  }
  promotionTag {
    label
    type
  }
}
    ${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const MiniCart_CartFragmentDoc = gql`
    fragment MiniCart_Cart on Cart {
  id
  totalQuantity
  totalExclTax
  totalDiscount
  totalEcoPart
  items {
    ...MiniCart_Item
  }
}
    ${MiniCart_ItemFragmentDoc}`;
export const MiniCart_ShippingFeeFragmentDoc = gql`
    fragment MiniCart_ShippingFee on ShippingFee {
  ... on ShippingFeeFree {
    isFranco
  }
  ... on ShippingFeeWithAmount {
    amount
  }
}
    `;
export const BaseCartItemFragmentDoc = gql`
    fragment BaseCartItem on CartItem {
  id
  quantity
  totalExclTax
  quantityMax
  unitPrice {
    exclTax
  }
  packaging {
    quantity
    unit
  }
}
    `;
export const CartItemReadOnlyRowInfosFragmentDoc = gql`
    fragment CartItemReadOnlyRowInfos on CartItem {
  id
  quantity
  totalExclTax
  discount {
    catalogDiscountAmount
    percentage
    webDiscount {
      amount
    }
  }
  product {
    reference
    name
    brand {
      name
      urlKey
    }
    type
    mainImage {
      ...FullPicture
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const BaseProductFragmentDoc = gql`
    fragment BaseProduct on Product {
  reference
  name
  urlKey
  brand {
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
}
    ${FullPictureFragmentDoc}`;
export const ExtendedProductFragmentDoc = gql`
    fragment ExtendedProduct on Product {
  ...BaseProduct
  type
  nbArticles
  description
  price {
    exclTax
    discountExclTax
    discountPercentage
  }
  canAddToCart
  clickAndCollectStatus
  stock {
    availability
    isSellable
  }
}
    ${BaseProductFragmentDoc}`;
export const CartItemFieldsFragmentDoc = gql`
    fragment CartItemFields on CartItem {
  ...BaseCartItem
  ...CartItemReadOnlyRowInfos
  availableClickAndCollect
  product {
    ...ExtendedProduct
  }
  options {
    isClickAndCollect
  }
}
    ${BaseCartItemFragmentDoc}
${CartItemReadOnlyRowInfosFragmentDoc}
${ExtendedProductFragmentDoc}`;
export const PromotionTagFieldsFragmentDoc = gql`
    fragment PromotionTagFields on PromotionTag {
  label
  type
}
    `;
export const CartItemRowInfosFragmentDoc = gql`
    fragment CartItemRowInfos on CartItem {
  ...CartItemFields
  quantity
  hasPaymentWarning
  promotionTag {
    ...PromotionTagFields
  }
  discount {
    percentage
    catalogDiscountAmount
  }
  product {
    reference
    canAddToCart
    price {
      discountPercentage
      discountExclTax
    }
  }
}
    ${CartItemFieldsFragmentDoc}
${PromotionTagFieldsFragmentDoc}`;
export const CartTracking_CartFragmentDoc = gql`
    fragment CartTracking_Cart on Cart {
  itemsGroupedByEarliestDeliveryDate {
    items {
      ...CartTracking_Item
    }
  }
  isClickAndCollectActivated
  totalExclTax
}
    ${CartTracking_ItemFragmentDoc}`;
export const Collaborator_UserFragmentDoc = gql`
    fragment Collaborator_User on User {
  id
  firstname
  lastname
  email
  role
  phone
  canBeEdited
  canBeDeleted
}
    `;
export const ApprovalFlowsApprovers_CompanyFragmentDoc = gql`
    fragment ApprovalFlowsApprovers_Company on Company {
  approvalFlows {
    items {
      approvers {
        ...Collaborator_User
      }
    }
  }
}
    ${Collaborator_UserFragmentDoc}`;
export const Collaborators_CompanyFragmentDoc = gql`
    fragment Collaborators_Company on Company {
  users(input: $input) {
    items {
      ...Collaborator_User
    }
    totalPages
    totalSize
  }
}
    ${Collaborator_UserFragmentDoc}`;
export const ApprovalFlowByUserFragmentDoc = gql`
    fragment ApprovalFlowByUser on ApprovalFlow {
  id
  name
  approvers {
    ...Collaborator_User
  }
  approvees {
    ...Collaborator_User
  }
  minimumAmount
}
    ${Collaborator_UserFragmentDoc}`;
export const CollaboratorPermissionsFragmentDoc = gql`
    fragment CollaboratorPermissions on User {
  permissions {
    allowedRolesToManage
    canManageApprovalFlows
  }
}
    `;
export const SiteConfigFragmentDoc = gql`
    fragment SiteConfig on Config {
  catalog {
    isPublicPricesEnabled
    isPublicStockEnabled
    isConnectedLocalStockVisible
    lengthReference
    isProductLabelGenerationEnabled
    isStoreNameDisplayedOnProductLabel
    isActiveHideVatPrice
  }
  customer {
    isAccountCreationEnabled
    isAddressAutocompleteEnabled
    europeanCountries {
      iso
      name
    }
    isAddressCreationEnabled
    isAddressDeletionEnabled
    isAddressEditionEnabled
  }
  pointOfSale {
    storeLocatorUrl
    isLocalStockByStoreEnabled
    isSubsidiaryDisplayEnabled
  }
  sales {
    isChorusDisplayEnabled
    isClickAndCollectEnabled
    isPunchoutLightEnabled
    isQuickOrderEnabled
    orderReferenceRegex
    deliveryTime {
      nbDayMinimum
      nbDayMaximum
      isSaturdayAvailable
      isSundayAvailable
    }
  }
  quotation {
    isQuotationEnabled
  }
  site {
    defaultCountryIso2
  }
}
    `;
export const ConfirmationClickAndCollectCard_PointOfSaleFragmentDoc = gql`
    fragment ConfirmationClickAndCollectCard_PointOfSale on PointOfSale {
  name
  phoneNumber
  distributionNetworkLabel
  subsidiary {
    name
    id
  }
  id
  open
  address {
    city
    isoCountryCode
    line1
    line2
    line3
    postalCode
  }
}
    `;
export const ConfirmationContactCard_PointOfSaleFragmentDoc = gql`
    fragment ConfirmationContactCard_PointOfSale on PointOfSale {
  name
  phoneNumber
}
    `;
export const OrderItemProductFragmentDoc = gql`
    fragment OrderItemProduct on Product {
  name
  reference
  type
  parentReference
  price {
    tag
  }
  brand {
    name
    urlKey
  }
  nomenclatureFamily
  nomenclatureGroup
  analytics {
    promotionStatus
  }
  canAddToCart
  stock {
    availability
    isSellable
  }
}
    `;
export const OrderItemFragmentDoc = gql`
    fragment OrderItem on OrderItem {
  analyticsPromotionStatus
  product {
    ...OrderItemProduct
  }
  totalExclTax
  quantity
  coupon
  unitPrice {
    exclTax
  }
}
    ${OrderItemProductFragmentDoc}`;
export const OrderItemsSectionFragmentDoc = gql`
    fragment OrderItemsSection on OrderItemsSection {
  info {
    __typename
    ... on OrderItemsSectionInfoReal {
      date
    }
    ... on OrderItemsSectionInfoEstimated {
      delay
    }
    ... on OrderItemsSectionInfoClickAndCollect {
      noValue
    }
  }
  items {
    ...OrderItem
  }
}
    ${OrderItemFragmentDoc}`;
export const OrderDetailsFragmentDoc = gql`
    fragment OrderDetails on Order {
  itemsSplitByDeliveryDate {
    ...OrderItemsSection
  }
  transactionId
  isUniversalDiscount
  coupon
  totalVat
}
    ${OrderItemsSectionFragmentDoc}`;
export const ConfirmationStorePickupCard_PointOfSaleFragmentDoc = gql`
    fragment ConfirmationStorePickupCard_PointOfSale on PointOfSale {
  name
  phoneNumber
  distributionNetworkLabel
  subsidiary {
    name
    id
  }
  id
  open
  address {
    city
    isoCountryCode
    line1
    line2
    line3
    postalCode
  }
}
    `;
export const OrderAddressFragmentDoc = gql`
    fragment OrderAddress on OrderAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  name
  postalCode
}
    `;
export const ConfirmationSummaryCard_OrderFragmentDoc = gql`
    fragment ConfirmationSummaryCard_Order on Order {
  internalRef
  totalAmount
  totalAmountInclTax
  totalDiscount
  items {
    reference
  }
  totalEcoPart
  webRef
  wentThroughApproval
  vatDetails {
    amount
    label
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
    addresses {
      ...OrderAddress
    }
  }
  payment {
    code
  }
}
    ${OrderAddressFragmentDoc}`;
export const ContactForm_PointsOfSaleFragmentDoc = gql`
    fragment ContactForm_PointsOfSale on PointOfSale {
  id
  name
  address {
    department
    postalCode
  }
  subsidiary {
    name
    id
  }
}
    `;
export const ContactForm_UserFragmentDoc = gql`
    fragment ContactForm_User on User {
  company {
    id
    name
    siret
    code
    pointOfSale {
      ...ContactForm_PointsOfSale
    }
  }
  email
  firstname
  lastname
  phone
}
    ${ContactForm_PointsOfSaleFragmentDoc}`;
export const PointOfSaleOpeningStatus_ExceptionalDatesFragmentDoc = gql`
    fragment PointOfSaleOpeningStatus_ExceptionalDates on ExceptionalDate {
  date
  isClosed
}
    `;
export const CurrentUser_DashboardMenuHeaderCardsFragmentDoc = gql`
    fragment CurrentUser_DashboardMenuHeaderCards on User {
  id
  firstname
  lastname
  email
  company {
    id
    code
    name
  }
  favoritePointOfSale {
    id
    name
    distributionNetworkLabel
    subsidiary {
      name
    }
    exceptionalDates {
      ...PointOfSaleOpeningStatus_ExceptionalDates
    }
    openingHours {
      ...FullOpeningHour
    }
  }
}
    ${PointOfSaleOpeningStatus_ExceptionalDatesFragmentDoc}
${FullOpeningHourFragmentDoc}`;
export const CurrentUserAccounts_DashboardMenuHeaderCardsFragmentDoc = gql`
    fragment CurrentUserAccounts_DashboardMenuHeaderCards on User {
  id
}
    `;
export const AvailablePointsOfSale_DashboardMenuHeaderCardsFragmentDoc = gql`
    fragment AvailablePointsOfSale_DashboardMenuHeaderCards on User {
  availablePointsOfSale {
    id
  }
}
    `;
export const AddProductToFavoritesList_ListFragmentDoc = gql`
    fragment AddProductToFavoritesList_List on Wishlist {
  id
  name
}
    `;
export const FavoritesActionsList_PermissionsFragmentDoc = gql`
    fragment FavoritesActionsList_Permissions on CollaboratorPermissions {
  canShareWishlist
}
    `;
export const FavoritesTable_FavoriteFragmentDoc = gql`
    fragment FavoritesTable_Favorite on Wishlist {
  id
  createdAt
  name
  productCount
  products {
    product {
      reference
    }
    quantity
  }
}
    `;
export const FavoritesDetailsPage_ProductFragmentDoc = gql`
    fragment FavoritesDetailsPage_Product on ProductWishlist {
  product {
    ...WishlistProduct_Product
  }
  comment
  quantity
  id
  ...WishlistResolvedPricing_ProductWishlist
}
    ${WishlistProduct_ProductFragmentDoc}
${WishlistResolvedPricing_ProductWishlistFragmentDoc}`;
export const FavoritesDetailsPage_WishlistFragmentDoc = gql`
    fragment FavoritesDetailsPage_Wishlist on Wishlist {
  ...FavoritesTable_Favorite
  products {
    ...FavoritesDetailsPage_Product
  }
}
    ${FavoritesTable_FavoriteFragmentDoc}
${FavoritesDetailsPage_ProductFragmentDoc}`;
export const ProductFirstLevelCategoryFragmentDoc = gql`
    fragment ProductFirstLevelCategory on FirstLevelCategory {
  code
  name
}
    `;
export const Footer_ReassuranceCardsFragmentDoc = gql`
    fragment Footer_ReassuranceCards on CMS_ReassuranceCardBlock {
  id
  blockType
  blockName
  illustration
  line1
  line2
  href
}
    `;
export const Header_MenuEntryCategoryFragmentDoc = gql`
    fragment Header_MenuEntryCategory on MenuEntryCategory {
  name
  image {
    ...FullPicture
  }
  baseline
  seoContent
  slug
}
    ${FullPictureFragmentDoc}`;
export const Header_MenuEntryLinkFragmentDoc = gql`
    fragment Header_MenuEntryLink on MenuEntryLink {
  name
  image {
    ...FullPicture
  }
  baseline
  seoContent
  url
  openInNewTab
}
    ${FullPictureFragmentDoc}`;
export const MenuEntryFragmentDoc = gql`
    fragment MenuEntry on MenuEntry {
  ... on MenuEntryCategory {
    ...Header_MenuEntryCategory
    entries {
      ... on MenuEntryCategory {
        ...Header_MenuEntryCategory
        entries {
          ... on MenuEntryCategory {
            ...Header_MenuEntryCategory
          }
          ... on MenuEntryLink {
            ...Header_MenuEntryLink
          }
        }
      }
      ... on MenuEntryLink {
        ...Header_MenuEntryLink
        entries {
          ... on MenuEntryCategory {
            ...Header_MenuEntryCategory
          }
          ... on MenuEntryLink {
            ...Header_MenuEntryLink
          }
        }
      }
    }
  }
  ... on MenuEntryLink {
    ...Header_MenuEntryLink
    entries {
      ... on MenuEntryCategory {
        ...Header_MenuEntryCategory
        entries {
          ... on MenuEntryCategory {
            ...Header_MenuEntryCategory
          }
          ... on MenuEntryLink {
            ...Header_MenuEntryLink
          }
        }
      }
      ... on MenuEntryLink {
        ...Header_MenuEntryLink
        entries {
          ... on MenuEntryCategory {
            ...Header_MenuEntryCategory
          }
          ... on MenuEntryLink {
            ...Header_MenuEntryLink
          }
        }
      }
    }
  }
}
    ${Header_MenuEntryCategoryFragmentDoc}
${Header_MenuEntryLinkFragmentDoc}`;
export const HeaderButtonsV2_ConfigFragmentDoc = gql`
    fragment HeaderButtonsV2_Config on Config {
  pointOfSale {
    isFavoritePointOfSaleEnabled
    isLocalStockByStoreEnabled
    isPickupPointOfSaleEnabled
    storeLocatorUrl
    dashboardFavoritePointOfSaleImage {
      ...FullPicture
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const SignedInPointOfSaleButton_PickupPointOfSaleFragmentDoc = gql`
    fragment SignedInPointOfSaleButton_pickupPointOfSale on PointOfSale {
  id
  name
}
    `;
export const LoyaltyConfigFragmentDoc = gql`
    fragment LoyaltyConfig on Config {
  loyalty {
    isEnabled
  }
}
    `;
export const LoyaltyOperationsLoyaltyDataPropsFragmentDoc = gql`
    fragment LoyaltyOperationsLoyaltyDataProps on LoyaltyData {
  authLink
  currentSalesOperations
  eligibleOperations
}
    `;
export const MarketingEventCard_EventCardFragmentDoc = gql`
    fragment MarketingEventCard_EventCard on EventCard {
  id
  backgroundColor
  baseline
  baselineColor
  image {
    ...FullPicture
  }
  link
  linkColor
  linkTitle
  title
  titleColor
}
    ${FullPictureFragmentDoc}`;
export const MarketingEventSlide_EventCardFragmentDoc = gql`
    fragment MarketingEventSlide_EventCard on EventCard {
  ...MarketingEventCard_EventCard
  openInNewTab
}
    ${MarketingEventCard_EventCardFragmentDoc}`;
export const ProductCardBaseFragmentDoc = gql`
    fragment ProductCardBase on Product {
  name
  urlKey
  reference
  brand {
    logo {
      ...FullPicture
    }
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  type
  nbArticles
}
    ${FullPictureFragmentDoc}`;
export const MarketingProductFieldsFragmentDoc = gql`
    fragment MarketingProductFields on EventProducts {
  link
  linkTitle
  openInNewTab
  products {
    ...ProductCardBase
  }
  title
}
    ${ProductCardBaseFragmentDoc}`;
export const MiniCartButton_CartFragmentDoc = gql`
    fragment MiniCartButton_Cart on Cart {
  id
  totalExclTax
}
    `;
export const MixedOrdersContainer_ItemFragmentDoc = gql`
    fragment MixedOrdersContainer_Item on Order {
  orderType
  webRef
  externalRef
  internalRef
  status
  totalAmount
  orderDate
  actions
  buyer {
    name
  }
}
    `;
export const OrderSummaryCard_OrderFragmentDoc = gql`
    fragment OrderSummaryCard_Order on Order {
  orderDate
  webRef
  status
  totalAmount
}
    `;
export const StoreOrdersContainer_ItemFragmentDoc = gql`
    fragment StoreOrdersContainer_Item on Order {
  internalRef
  externalRef
  status
  totalAmount
  orderDate
  actions
  wentThroughApproval
  buyer {
    name
  }
  approver {
    firstname
    lastname
  }
}
    `;
export const WebOrderProductRow_OrderItemFragmentDoc = gql`
    fragment WebOrderProductRow_OrderItem on OrderItem {
  totalExclTax
  unitPrice {
    exclTax
  }
  discount {
    catalogDiscountAmount
    percentage
    webDiscount {
      amount
      hasCoupon
      label
    }
  }
  coupon
  name
  reference
  quantity
  promotionTag {
    ...PromotionTagFields
  }
  product {
    urlKey
    type
    reference
    brand {
      name
      urlKey
    }
    mainImage {
      ...FullPicture
    }
    stock {
      packaging {
        ...FullPackaging
      }
    }
  }
}
    ${PromotionTagFieldsFragmentDoc}
${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const WebOrderPdfTemplate_OrderFragmentDoc = gql`
    fragment WebOrderPdfTemplate_Order on Order {
  hasClickAndCollectItems
  hasOnlineDeliveryItems
  isPickUpShippingMethod
  webRef
  internalRef
  orderDate
  status
  approver {
    firstname
    lastname
  }
  buyer {
    name
  }
  payment {
    code
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
    addresses {
      city
      isoCountryCode
      line1
      line2
      line3
      name
      postalCode
    }
  }
  subtotalExclTax
  totalAmount
  totalAmountInclTax
  vatDetails {
    amount
    label
  }
  totalDiscount
  totalEcoPart
  collectPointOfSale {
    name
    phoneNumber
    distributionNetworkLabel
    address {
      city
      isoCountryCode
      line1
      line2
      line3
      postalCode
    }
    subsidiary {
      name
    }
  }
  wentThroughApproval
  itemsSplitByDeliveryDate {
    info {
      __typename
      ... on OrderItemsSectionInfoReal {
        date
      }
      ... on OrderItemsSectionInfoEstimated {
        delay
      }
      ... on OrderItemsSectionInfoClickAndCollect {
        noValue
      }
    }
    items {
      ...WebOrderProductRow_OrderItem
    }
  }
}
    ${WebOrderProductRow_OrderItemFragmentDoc}`;
export const WebOrderSummaryCard_OrderFragmentDoc = gql`
    fragment WebOrderSummaryCard_Order on Order {
  webRef
  actions
  subtotalExclTax
  totalAmount
  totalAmountInclTax
  vatDetails {
    amount
    label
  }
  totalDiscount
  totalEcoPart
  payment {
    code
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
    trackingUrl
  }
}
    `;
export const WebOrdersContainer_ItemFragmentDoc = gql`
    fragment WebOrdersContainer_Item on Order {
  webRef
  internalRef
  status
  totalAmount
  orderDate
  actions
  buyer {
    name
  }
}
    `;
export const WebOrderDetails_AddressFragmentDoc = gql`
    fragment WebOrderDetails_Address on OrderAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  name
  postalCode
}
    `;
export const OrderRequestAddProductForm_OrderRequestToApproveFragmentDoc = gql`
    fragment OrderRequestAddProductForm_OrderRequestToApprove on OrderRequestToApprove {
  webRef
  updatedState {
    id
  }
}
    `;
export const OrderRequestBuyerTable_ItemFragmentDoc = gql`
    fragment OrderRequestBuyerTable_Item on Order {
  webRef
  internalRef
  orderDate
  totalAmount
  payment {
    orderReference
  }
}
    `;
export const OrderCartSummaryCard_OrderRequestToApproveFragmentDoc = gql`
    fragment OrderCartSummaryCard_OrderRequestToApprove on OrderRequestToApprove {
  internalRef
  orderDate
  webRef
  chorusServiceCode
  chorusLegalCommitment
  approvee {
    firstname
    lastname
  }
  approver {
    firstname
    lastname
  }
  delivery {
    fee {
      ... on ShippingFeeFree {
        isFranco
      }
      ... on ShippingFeeWithAmount {
        amount
      }
    }
  }
  payment {
    code
  }
  updatedState {
    id
    subtotalExclTax
    totalExclTax
    totalInclTax
    taxesDetails {
      amount {
        value
      }
      label
    }
    totalDiscount
    totalEcoPart
    amountUntilFreeDelivery
  }
}
    `;
export const OrderRequestDeliverySection_OrderItemsSectionInfoEstimatedFragmentDoc = gql`
    fragment OrderRequestDeliverySection_OrderItemsSectionInfoEstimated on OrderItemsSectionInfoEstimated {
  delay
}
    `;
export const OrderRequestDeliverySection_OrderItemsSectionInfoRealFragmentDoc = gql`
    fragment OrderRequestDeliverySection_OrderItemsSectionInfoReal on OrderItemsSectionInfoReal {
  date
}
    `;
export const OrderRequestDetailsFields_ChorusDataFragmentDoc = gql`
    fragment OrderRequestDetailsFields_ChorusData on ChorusData {
  isChorus
  isRequiredService
  isRequiredLegalCommitment
  services {
    name
    code
    isRequiredLegalCommitment
  }
}
    `;
export const OrderRequestProductRowReadOnly_OrderItemFragmentDoc = gql`
    fragment OrderRequestProductRowReadOnly_OrderItem on OrderItem {
  totalExclTax
  unitPrice {
    exclTax
  }
  discount {
    amountTotal
    catalogDiscountAmount
    oldPrice
    percentage
    webDiscount {
      amount
      hasCoupon
      label
    }
  }
  quantity
  promotionTag {
    ...PromotionTagFields
  }
  product {
    ...ExtendedProduct
    stock {
      packaging {
        ...FullPackaging
      }
    }
  }
}
    ${PromotionTagFieldsFragmentDoc}
${ExtendedProductFragmentDoc}
${FullPackagingFragmentDoc}`;
export const OrderRequestProductRowReadOnly_CartItemFragmentDoc = gql`
    fragment OrderRequestProductRowReadOnly_CartItem on CartItem {
  id
  totalExclTax
  unitPrice {
    exclTax
  }
  discount {
    webDiscount {
      amount
      hasCoupon
      label
    }
    catalogDiscountAmount
    oldPrice
    percentage
  }
  quantity
  promotionTag {
    ...PromotionTagFields
  }
  product {
    ...ExtendedProduct
    stock {
      packaging {
        ...FullPackaging
      }
    }
  }
}
    ${PromotionTagFieldsFragmentDoc}
${ExtendedProductFragmentDoc}
${FullPackagingFragmentDoc}`;
export const OrderRequestSectionLabel_CartItemDeliveryStockDetailsFragmentDoc = gql`
    fragment OrderRequestSectionLabel_CartItemDeliveryStockDetails on CartItemDeliveryStockDetails {
  availability
  date
  quantity
  realDeliveryDate
}
    `;
export const OrderRequestProductRow_CartItemFragmentDoc = gql`
    fragment OrderRequestProductRow_CartItem on CartItem {
  id
  totalExclTax
  quantity
  quantityMax
  unitPrice {
    exclTax
  }
  deliveryDetails {
    ...OrderRequestSectionLabel_CartItemDeliveryStockDetails
  }
  discount {
    webDiscount {
      amount
      hasCoupon
      label
    }
    catalogDiscountAmount
    oldPrice
    percentage
    quantitySaleNextLevel {
      gap
      unitPrice
    }
  }
  product {
    ...ProductRow_Product
  }
  promotionTag {
    ...PromotionTagFields
  }
}
    ${OrderRequestSectionLabel_CartItemDeliveryStockDetailsFragmentDoc}
${ProductRow_ProductFragmentDoc}
${PromotionTagFieldsFragmentDoc}`;
export const OrderRequestUnavailableProduct_CartMessageFragmentDoc = gql`
    fragment OrderRequestUnavailableProduct_CartMessage on CartMessage {
  message
  code
}
    `;
export const OrderRequestValidationTableFilter_OrderFragmentDoc = gql`
    fragment OrderRequestValidationTableFilter_Order on Order {
  buyer {
    name
    id
    email
    details {
      id
      firstname
      lastname
    }
  }
}
    `;
export const OrderRequestValidationTable_OrderFragmentDoc = gql`
    fragment OrderRequestValidationTable_Order on Order {
  ...OrderRequestValidationTableFilter_Order
  webRef
  internalRef
  orderDate
  totalAmount
  payment {
    orderReference
  }
}
    ${OrderRequestValidationTableFilter_OrderFragmentDoc}`;
export const StoreOrderProductRow_OrderItemFragmentDoc = gql`
    fragment StoreOrderProductRow_OrderItem on OrderItem {
  totalExclTax
  unitPrice {
    exclTax
  }
  discount {
    catalogDiscountAmount
    percentage
    webDiscount {
      amount
      hasCoupon
      label
    }
  }
  coupon
  name
  reference
  quantity
  promotionTag {
    ...PromotionTagFields
  }
  product {
    name
    urlKey
    type
    reference
    brand {
      name
      urlKey
    }
    mainImage {
      ...FullPicture
    }
    stock {
      packaging {
        ...FullPackaging
      }
    }
  }
}
    ${PromotionTagFieldsFragmentDoc}
${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const StoreOrderPdfTemplate_OrderFragmentDoc = gql`
    fragment StoreOrderPdfTemplate_Order on Order {
  externalRef
  internalRef
  orderDate
  status
  buyer {
    name
  }
  hasClickAndCollectItems
  hasOnlineDeliveryItems
  isPickUpShippingMethod
  subtotalExclTax
  totalAmount
  totalAmountInclTax
  vatDetails {
    amount
    label
  }
  totalDiscount
  totalEcoPart
  payment {
    code
  }
  delivery {
    addresses {
      city
      isoCountryCode
      line1
      line2
      line3
      name
      postalCode
    }
  }
  collectPointOfSale {
    name
    phoneNumber
    distributionNetworkLabel
    address {
      city
      isoCountryCode
      line1
      line2
      line3
      postalCode
    }
    subsidiary {
      name
    }
  }
  items {
    ...StoreOrderProductRow_OrderItem
  }
}
    ${StoreOrderProductRow_OrderItemFragmentDoc}`;
export const StoreOrderSummaryCard_OrderFragmentDoc = gql`
    fragment StoreOrderSummaryCard_Order on Order {
  externalRef
  actions
  totalAmount
  totalAmountInclTax
  vatDetails {
    amount
    label
  }
  totalDiscount
  payment {
    code
  }
  delivery {
    trackingUrl
  }
}
    `;
export const CollectPointOfSaleFragmentDoc = gql`
    fragment CollectPointOfSale on PointOfSale {
  distributionNetworkLabel
  address {
    city
    isoCountryCode
    line1
    line2
    line3
    postalCode
  }
  name
  phoneNumber
  subsidiary {
    name
  }
}
    `;
export const OrderReferenceDisplay_ConfigFragmentDoc = gql`
    fragment OrderReferenceDisplay_Config on Config {
  sales {
    __typename
    isRefOrderDisplayOnNonMandatoryEnabled
  }
}
    `;
export const Chorus_ChorusDataFragmentDoc = gql`
    fragment Chorus_ChorusData on ChorusData {
  isChorus
  isRequiredService
  isRequiredLegalCommitment
  isRequiredServiceOrRequiredLegalCommitment
  services {
    name
    code
    status
    isRequiredLegalCommitment
  }
}
    `;
export const PaymentForm_CompanyFragmentDoc = gql`
    fragment PaymentForm_Company on Company {
  isProspect
  isOrderReferenceMandatory
  chorusData {
    ...Chorus_ChorusData
  }
}
    ${Chorus_ChorusDataFragmentDoc}`;
export const PayzenForm_CheckoutFragmentDoc = gql`
    fragment PayzenForm_Checkout on Checkout {
  cart(forceRefresh: true) {
    id
  }
}
    `;
export const CartItemsSummaryAccordionCard_ItemsFragmentDoc = gql`
    fragment CartItemsSummaryAccordionCard_Items on CartItem {
  ...CartItemReadOnlyRowInfos
  availableClickAndCollect
}
    ${CartItemReadOnlyRowInfosFragmentDoc}`;
export const CartItemsSummaryAccordionCard_SectionsFragmentDoc = gql`
    fragment CartItemsSummaryAccordionCard_Sections on CartItemsSection {
  quantity
  info {
    ... on CartItemsSectionInfoReal {
      date
    }
    ... on CartItemsSectionInfoEstimated {
      __typename
      delay
    }
    ... on CartItemsSectionInfoClickAndCollect {
      noValue
    }
  }
  items {
    ...CartItemsSummaryAccordionCard_Items
  }
}
    ${CartItemsSummaryAccordionCard_ItemsFragmentDoc}`;
export const ChooseDeliveryDate_CartFragmentDoc = gql`
    fragment ChooseDeliveryDate_Cart on Cart {
  id
  requestedDeliveryDate
  canRequestDeliveryDate
}
    `;
export const PaymentForm_PaymentMethodFragmentDoc = gql`
    fragment PaymentForm_PaymentMethod on PaymentMethod {
  card {
    code
    status
  }
  term {
    code
    status
  }
  ideal {
    code
    status
  }
}
    `;
export const PaymentForm_CheckoutFragmentDoc = gql`
    fragment PaymentForm_Checkout on Checkout {
  ...PayzenForm_Checkout
  cart(forceRefresh: true) {
    id
    totalQuantity
    totalExclTax
    itemsSplitByDeliveryDate {
      ...CartItemsSummaryAccordionCard_Sections
    }
    ...ChooseDeliveryDate_Cart
    ...CartSummary_Cart
  }
  payment {
    code
    availableMethods {
      ...PaymentForm_PaymentMethod
    }
  }
  shipping {
    methodCode
    ...CartSummary_Shipping
  }
  willGenerateOrderRequest
}
    ${PayzenForm_CheckoutFragmentDoc}
${CartItemsSummaryAccordionCard_SectionsFragmentDoc}
${ChooseDeliveryDate_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${PaymentForm_PaymentMethodFragmentDoc}
${CartSummary_ShippingFragmentDoc}`;
export const PaymentForm_UserFragmentDoc = gql`
    fragment PaymentForm_User on User {
  company {
    id
    ...PaymentForm_Company
  }
  role
  checkout {
    ...PaymentForm_Checkout
  }
}
    ${PaymentForm_CompanyFragmentDoc}
${PaymentForm_CheckoutFragmentDoc}`;
export const ConfirmationClickAndCollectCardConfigFragmentDoc = gql`
    fragment ConfirmationClickAndCollectCardConfig on Config {
  pointOfSale {
    isPickupPointOfSaleEnabled
  }
}
    `;
export const DisplayPointOfSaleInfos_PointOfSaleFragmentDoc = gql`
    fragment DisplayPointOfSaleInfos_pointOfSale on PointOfSale {
  id
  name
  link
  distributionNetworkLabel
  address {
    city
    line1
    line2
    line3
    postalCode
    isoCountryCode
  }
  phoneNumber
  exceptionalDates {
    date
    intervals {
      begin
      end
    }
    isClosed
  }
  openingHours {
    day
    dayOfWeek
    intervals {
      begin
      end
    }
  }
  subsidiary {
    name
  }
}
    `;
export const FavoritePointOfSaleCard_PointOfSaleAddressFragmentDoc = gql`
    fragment FavoritePointOfSaleCard_PointOfSaleAddress on PointOfSaleAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  postalCode
}
    `;
export const FavoritePointOfSaleCard_PointOfSaleFragmentDoc = gql`
    fragment FavoritePointOfSaleCard_PointOfSale on PointOfSale {
  id
  name
  open
  distributionNetworkLabel
  openingHours {
    ...FullOpeningHour
  }
  phoneNumber
  latitude
  longitude
  address {
    ...FavoritePointOfSaleCard_PointOfSaleAddress
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
}
    ${FullOpeningHourFragmentDoc}
${FavoritePointOfSaleCard_PointOfSaleAddressFragmentDoc}`;
export const FavoritePointOfSaleFragmentDoc = gql`
    fragment FavoritePointOfSale on User {
  favoritePointOfSale {
    ...FavoritePointOfSaleCard_PointOfSale
  }
}
    ${FavoritePointOfSaleCard_PointOfSaleFragmentDoc}`;
export const AvailablePointOfSalesFragmentDoc = gql`
    fragment AvailablePointOfSales on User {
  availablePointsOfSale {
    ...FavoritePointOfSaleCard_PointOfSale
  }
}
    ${FavoritePointOfSaleCard_PointOfSaleFragmentDoc}`;
export const PointOfSaleConfigFragmentDoc = gql`
    fragment PointOfSaleConfig on ConfigPointOfSale {
  isFavoritePointOfSaleEnabled
}
    `;
export const PointOfSaleStatusCard_PointOfSaleFragmentDoc = gql`
    fragment PointOfSaleStatusCard_PointOfSale on PointOfSale {
  id
  name
  open
  openingHours {
    dayOfWeek
    intervals {
      begin
      end
    }
    day
  }
  phoneNumber
  latitude
  longitude
  address {
    city
    isoCountryCode
    line1
    line2
    line3
    postalCode
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
}
    `;
export const SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc = gql`
    fragment SelectablePointOfSaleCard_V2_pointOfSale on PointOfSale {
  id
  name
  activity
  distance
  parentId
  address {
    line1
    postalCode
    city
  }
  openingHours {
    day
    dayOfWeek
    intervals {
      begin
      end
    }
  }
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
}
    `;
export const UsePointOfSale_PointOfSaleAddressFragmentDoc = gql`
    fragment UsePointOfSale_PointOfSaleAddress on PointOfSaleAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  postalCode
}
    `;
export const UsePointOfSale_PointOfSaleFragmentDoc = gql`
    fragment UsePointOfSale_PointOfSale on PointOfSale {
  id
  name
  open
  openingHours {
    ...FullOpeningHour
  }
  phoneNumber
  latitude
  longitude
  address {
    ...UsePointOfSale_PointOfSaleAddress
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
}
    ${FullOpeningHourFragmentDoc}
${UsePointOfSale_PointOfSaleAddressFragmentDoc}`;
export const ProductListEventBanner_BannerFragmentDoc = gql`
    fragment ProductListEventBanner_Banner on MarketingBanner {
  bannerBackgroundColor
  bannerText
  bannerTextColor
  linkIsOpenNewTab
  linkText
  linkTextColor
  linkUrl
  tagBackgroundColor
  tagText
  tagTextColor
}
    `;
export const ProductListFiltersCategory_CategoryFiltersFragmentDoc = gql`
    fragment ProductListFiltersCategory_CategoryFilters on ProductListFilter {
  title
  values {
    ... on ValueFilter {
      title
      productCount
      link {
        type
        value
      }
      isActive
    }
    ... on ValueLink {
      title
      productCount
      link {
        type
        value
      }
      isActive
      image {
        ...FullPicture
      }
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const ProductListFiltersSubcategories_SubCategoriesFragmentDoc = gql`
    fragment ProductListFiltersSubcategories_SubCategories on ProductListFilter {
  title
  values {
    ... on ValueLink {
      title
      productCount
      link {
        type
        value
      }
      image {
        ...FullPicture
      }
    }
  }
}
    ${FullPictureFragmentDoc}`;
export const FullPriceFragmentDoc = gql`
    fragment FullPrice on Price {
  exclTax
  inclTax
  discountExclTax
  discountInclTax
  discountPercentage
  referenceExclTax
  referenceInclTax
  referencePercentage
  tag
}
    `;
export const ProductListTemplate_ProductsPricesFragmentDoc = gql`
    fragment ProductListTemplate_ProductsPrices on ProductList {
  products {
    urlKey
    bestArticlePrice
    price {
      ...FullPrice
    }
    canAddToCart
    clickAndCollectStatus
    stock {
      availability
      storeQuantity
      shippingDelay
      isPriceAvailable
      isSellable
    }
  }
}
    ${FullPriceFragmentDoc}`;
export const ProductListCount_ProductListFragmentDoc = gql`
    fragment ProductListCount_ProductList on ProductList {
  productCount
}
    `;
export const ProductListProductsWithoutPriceFragmentDoc = gql`
    fragment ProductListProductsWithoutPrice on Product {
  name
  urlKey
  reference
  brand {
    logo {
      ...FullPicture
    }
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  nbArticles
  type
}
    ${FullPictureFragmentDoc}`;
export const ProductListTemplate_ProductListFragmentDoc = gql`
    fragment ProductListTemplate_ProductList on ProductList {
  products {
    ...ProductListProductsWithoutPrice
  }
  totalPages
  productCount
}
    ${ProductListProductsWithoutPriceFragmentDoc}`;
export const ProductListFilterValueFilterFragmentDoc = gql`
    fragment ProductListFilterValueFilter on ValueFilter {
  title
  productCount
  isActive
  link {
    type
    value
  }
}
    `;
export const ValueLinkFragmentDoc = gql`
    fragment ValueLink on ValueLink {
  title
  productCount
  isActive
  link {
    type
    value
  }
  image {
    ...FullPicture
  }
  values {
    ...ProductListFilterValueFilter
  }
}
    ${FullPictureFragmentDoc}
${ProductListFilterValueFilterFragmentDoc}`;
export const ProductListFilterValueFragmentDoc = gql`
    fragment ProductListFilterValue on ProductListFilterValue {
  ... on ValueFilter {
    ...ProductListFilterValueFilter
  }
  ... on ValueLink {
    ...ValueLink
  }
}
    ${ProductListFilterValueFilterFragmentDoc}
${ValueLinkFragmentDoc}`;
export const ProductListActiveFiltersFragmentDoc = gql`
    fragment ProductListActiveFilters on ProductListFilter {
  title
  values {
    ...ProductListFilterValue
  }
}
    ${ProductListFilterValueFragmentDoc}`;
export const ProductListFilterFragmentDoc = gql`
    fragment ProductListFilter on ProductListFilter {
  title
  values {
    ...ProductListFilterValue
  }
}
    ${ProductListFilterValueFragmentDoc}`;
export const ProductListTemplate_QueryFiltersFragmentDoc = gql`
    fragment ProductListTemplate_QueryFilters on ProductList {
  categoryActiveFilters {
    ...ProductListActiveFilters
  }
  categoryFilters {
    ...ProductListFilter
  }
  productActiveFilters {
    ...ProductListActiveFilters
  }
  productFilters {
    ...ProductListFilter
  }
}
    ${ProductListActiveFiltersFragmentDoc}
${ProductListFilterFragmentDoc}`;
export const ProductListFilters_DataFragmentDoc = gql`
    fragment ProductListFilters_Data on ProductList {
  ...ProductListTemplate_QueryFilters
}
    ${ProductListTemplate_QueryFiltersFragmentDoc}`;
export const CategoryCard_CategoryFragmentDoc = gql`
    fragment CategoryCard_Category on Category {
  urlKey
  name
  mainImage {
    ...FullPicture
  }
  categories {
    urlKey
    name
  }
}
    ${FullPictureFragmentDoc}`;
export const ProductAvailabilities_PickupPointOfSaleFragmentDoc = gql`
    fragment ProductAvailabilities_PickupPointOfSale on PointOfSale {
  id
  name
}
    `;
export const ProductAvailabilities_PointOfSaleListFragmentDoc = gql`
    fragment ProductAvailabilities_PointOfSaleList on User {
  favoritePointOfSale {
    ...ProductAvailabilities_PickupPointOfSale
  }
}
    ${ProductAvailabilities_PickupPointOfSaleFragmentDoc}`;
export const ProductAvailabilityItem_AvailabilityFragmentDoc = gql`
    fragment ProductAvailabilityItem_Availability on Product {
  stock {
    ...ProductStock_Availabilities
    maxQuantity
    onlineQuantity
    g9LowStockThreshold
  }
}
    ${ProductStock_AvailabilitiesFragmentDoc}`;
export const ProductBuyBox_CartFragmentDoc = gql`
    fragment ProductBuyBox_Cart on Cart {
  id
}
    `;
export const ProductBuyBoxArticle_ProductFragmentDoc = gql`
    fragment ProductBuyBoxArticle_Product on Product {
  ...ProductBuyBoxFields_Product
  description
  images {
    ...FullPicture
  }
  supplierReference
}
    ${ProductBuyBoxFields_ProductFragmentDoc}
${FullPictureFragmentDoc}`;
export const ProductBuyBox_FavoritePointOfSaleFragmentDoc = gql`
    fragment ProductBuyBox_FavoritePointOfSale on PointOfSale {
  id
  phoneNumber
}
    `;
export const ProductAvailabilities_ProductFragmentDoc = gql`
    fragment ProductAvailabilities_Product on Product {
  ...FullProductAvailabilityItem_Availability
}
    ${FullProductAvailabilityItem_AvailabilityFragmentDoc}`;
export const ProductCalculatedPriceFragmentDoc = gql`
    fragment ProductCalculatedPrice on Product {
  calculatedPrice {
    exclTax
    inclTax
    discountExclTax
    discountPercentage
    referenceExclTax
    tiers {
      quantity
      exclTax
    }
  }
}
    `;
export const TiersPriceFragmentDoc = gql`
    fragment TiersPrice on Price {
  tiers {
    quantity
    exclTax
  }
}
    `;
export const ProductBuyBox_ProductPriceAndStockFragmentDoc = gql`
    fragment ProductBuyBox_ProductPriceAndStock on Product {
  ...ProductAvailabilities_Product
  ...ProductCalculatedPrice
  reference
  bestArticlePrice
  ecoPart {
    deee
    pmcb
    furnishing
  }
  charges {
    name
    amount
  }
  isEquivalentProductsLinkVisible
  stock {
    packaging {
      ...FullPackaging
    }
  }
  price {
    referenceExclTax
    ...FullPrice
    ...TiersPrice
    discountExclTax
    discountInclTax
    discountPercentage
  }
}
    ${ProductAvailabilities_ProductFragmentDoc}
${ProductCalculatedPriceFragmentDoc}
${FullPackagingFragmentDoc}
${FullPriceFragmentDoc}
${TiersPriceFragmentDoc}`;
export const BundleProductCardInfoFragmentDoc = gql`
    fragment BundleProductCardInfo on Product {
  reference
  name
  type
  brand {
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  stock {
    packaging {
      ...FullPackaging
    }
  }
}
    ${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductCard_AddToCartFragmentDoc = gql`
    fragment ProductCard_AddToCart on Product {
  reference
  canAddToCart
  price {
    exclTax
  }
  stock {
    packaging {
      minimalSalesQuantity
      incrementQuantity
      quantity
    }
  }
}
    `;
export const ProductCard_ProductPriceAndStockFragmentDoc = gql`
    fragment ProductCard_ProductPriceAndStock on Product {
  ...ProductCard_AddToCart
  ...ProductCalculatedPrice
  parentReference
  urlKey
  bestArticlePrice
  price {
    ...FullPrice
  }
  clickAndCollectStatus
  stock {
    ...ProductStock_Availabilities
    isPriceAvailable
    isSellable
    packaging {
      ...FullPackaging
    }
  }
  isEquivalentProductsLinkVisible
  analytics {
    promotionStatus
    profileCase
  }
}
    ${ProductCard_AddToCartFragmentDoc}
${ProductCalculatedPriceFragmentDoc}
${FullPriceFragmentDoc}
${ProductStock_AvailabilitiesFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductRowLinkedProducts_ProductFragmentDoc = gql`
    fragment ProductRowLinkedProducts_Product on Product {
  reference
  canAddToCart
  linkedProducts(includeBundleInLinkedProducts: true) {
    reference
    ...ProductCalculatedPrice
    bestArticlePrice
    price {
      exclTax
      discountExclTax
      discountPercentage
      tag
    }
    name
    type
    mainImage {
      ...FullPicture
    }
    brand {
      name
      urlKey
    }
    stock {
      availability
      maxQuantity
      isPriceAvailable
      isSellable
      packaging {
        ...FullPackaging
      }
    }
    urlKey
    canAddToCart
    clickAndCollectStatus
  }
}
    ${ProductCalculatedPriceFragmentDoc}
${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductRowReadOnly_ProductFragmentDoc = gql`
    fragment ProductRowReadOnly_Product on Product {
  urlKey
  reference
  parentReference
  type
  name
  brand {
    name
    urlKey
  }
  analytics {
    promotionStatus
    profileCase
  }
  bestArticlePrice
  mainImage {
    ...FullPicture
  }
  stock {
    availability
    isSellable
    packaging {
      ...FullPackaging
    }
  }
  nomenclatureFamily
  nomenclatureGroup
  canAddToCart
  clickAndCollectStatus
}
    ${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductRowReadOnly_CartItemFragmentDoc = gql`
    fragment ProductRowReadOnly_CartItem on CartItem {
  id
  quantity
  analyticsPromotionStatus
  totalExclTax
  unitPrice {
    exclTax
  }
  discount {
    percentage
    catalogDiscountAmount
  }
  product {
    ...ProductRowReadOnly_Product
  }
}
    ${ProductRowReadOnly_ProductFragmentDoc}`;
export const ProductTechnicalSpecsFull_ProductFragmentDoc = gql`
    fragment ProductTechnicalSpecsFull_Product on Product {
  reference
  type
  nbArticles
  technicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  norms {
    ...ProductTechnicalSpecsFull_Norms
  }
}
    ${ProductTechnicalSpecs_TechnicalSpecsFragmentDoc}
${ProductTechnicalSpecsFull_NormsFragmentDoc}`;
export const ReferencesProductFilters_FiltersFragmentDoc = gql`
    fragment ReferencesProductFilters_Filters on ProductFilter {
  label
  values {
    label
    references
  }
  unit
}
    `;
export const ReferencesProductTable_ArticleFragmentDoc = gql`
    fragment ReferencesProductTable_Article on Product {
  urlKey
  reference
  name
  type
  supplierReference
  brand {
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  additionalTechnicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
}
    ${FullPictureFragmentDoc}
${ProductTechnicalSpecs_TechnicalSpecsFragmentDoc}`;
export const ReferencesProductTableRows_PriceAndStockFragmentDoc = gql`
    fragment ReferencesProductTableRows_PriceAndStock on Product {
  ...ProductCalculatedPrice
  reference
  parentReference
  price {
    ...FullPrice
    ...TiersPrice
  }
  stock {
    isPriceAvailable
    isSellable
    packaging {
      ...FullPackaging
    }
  }
  isEquivalentProductsLinkVisible
  canAddToCart
  clickAndCollectStatus
  ...ProductAvailabilities_Product
}
    ${ProductCalculatedPriceFragmentDoc}
${FullPriceFragmentDoc}
${TiersPriceFragmentDoc}
${FullPackagingFragmentDoc}
${ProductAvailabilities_ProductFragmentDoc}`;
export const ProductRichDescription_ProductFragmentDoc = gql`
    fragment ProductRichDescription_Product on Product {
  reference
  type
  nbArticles
  description
  shortDescription
  norms {
    ...ProductNorms_Norm
  }
}
    ${ProductNorms_NormFragmentDoc}`;
export const ProductArticleDetails_ArticleFragmentDoc = gql`
    fragment ProductArticleDetails_Article on Product {
  mainTechnicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  technicalSpecs {
    ...ProductTechnicalSpecs_TechnicalSpecs
  }
  norms {
    ...ProductNorms_Norm
  }
  documents {
    ...ProductDocuments_Documents
  }
  ...ProductLabels_Product
  ...ProductRichDescription_Product
}
    ${ProductTechnicalSpecs_TechnicalSpecsFragmentDoc}
${ProductNorms_NormFragmentDoc}
${ProductDocuments_DocumentsFragmentDoc}
${ProductLabels_ProductFragmentDoc}
${ProductRichDescription_ProductFragmentDoc}`;
export const ProductCardFragmentDoc = gql`
    fragment ProductCard on Product {
  ...ProductCalculatedPrice
  name
  urlKey
  reference
  bestArticlePrice
  price {
    ...FullPrice
  }
  brand {
    logo {
      ...FullPicture
    }
    name
    urlKey
  }
  mainImage {
    ...FullPicture
  }
  isEquivalentProductsLinkVisible
  canAddToCart
  clickAndCollectStatus
  nbArticles
  type
  stock {
    availability
    storeQuantity
    shippingDelay
    isPriceAvailable
    isSellable
    packaging {
      ...FullPackaging
    }
  }
  analytics {
    promotionStatus
    profileCase
  }
}
    ${ProductCalculatedPriceFragmentDoc}
${FullPriceFragmentDoc}
${FullPictureFragmentDoc}
${FullPackagingFragmentDoc}`;
export const ProductTechSpecsFragmentDoc = gql`
    fragment ProductTechSpecs on Product {
  technicalSpecs {
    label
    value
  }
}
    `;
export const SendPunchoutCartToErpButton_UserFragmentDoc = gql`
    fragment SendPunchoutCartToErpButton_User on User {
  id
  role
}
    `;
export const PunchoutCartItem_ItemFragmentDoc = gql`
    fragment PunchoutCartItem_Item on PunchoutCartItem {
  id
  quantity
  unitPriceExclTax
  conditioningUnitPriceExclTax
  rowTotalExclTax
  catalogDiscountAmount
  deliveryDetails {
    date
    quantity
    availability
    realDeliveryDate
  }
  product {
    reference
    price {
      discountPercentage
    }
    stock {
      maxQuantity
    }
    ...ProductRow_Product
  }
}
    ${ProductRow_ProductFragmentDoc}`;
export const PunchoutCartItems_SectionFragmentDoc = gql`
    fragment PunchoutCartItems_Section on PunchoutCartItemsSection {
  quantity
  info {
    ... on CartItemsSectionInfoReal {
      date
    }
    ... on CartItemsSectionInfoEstimated {
      delay
    }
    ... on CartItemsSectionInfoClickAndCollect {
      noValue
    }
  }
  items {
    ...PunchoutCartItem_Item
  }
}
    ${PunchoutCartItem_ItemFragmentDoc}`;
export const PunchoutCartItems_CartFragmentDoc = gql`
    fragment PunchoutCartItems_Cart on PunchoutCart {
  id
  itemsGroupedByEarliestDeliveryDate {
    ...PunchoutCartItems_Section
  }
}
    ${PunchoutCartItems_SectionFragmentDoc}`;
export const PunchoutCartSummary_CartFragmentDoc = gql`
    fragment PunchoutCartSummary_Cart on PunchoutCart {
  subtotalExclTax
  totalExclTax
  totalInclTax
  totalDiscount
  totalEcoPart
  totalQuantity
  taxesDetails {
    amount {
      value
    }
    label
  }
}
    `;
export const PunchoutCartActionsCard_CartFragmentDoc = gql`
    fragment PunchoutCartActionsCard_Cart on PunchoutCart {
  id
  itemsGroupedByEarliestDeliveryDate {
    items {
      quantity
      product {
        reference
      }
    }
  }
}
    `;
export const PunchoutCart_CartFragmentDoc = gql`
    fragment PunchoutCart_Cart on PunchoutCart {
  id
  totalQuantity
  messages {
    ...CheckoutCartContentToasts_Messages
  }
  ...PunchoutCartItems_Cart
  ...PunchoutCartSummary_Cart
  ...PunchoutCartActionsCard_Cart
}
    ${CheckoutCartContentToasts_MessagesFragmentDoc}
${PunchoutCartItems_CartFragmentDoc}
${PunchoutCartSummary_CartFragmentDoc}
${PunchoutCartActionsCard_CartFragmentDoc}`;
export const PunchoutCartPdf_CartFragmentDoc = gql`
    fragment PunchoutCartPdf_Cart on PunchoutCart {
  id
  subtotalExclTax
  totalExclTax
  totalInclTax
  totalDiscount
  totalEcoPart
  totalQuantity
  taxesDetails {
    amount {
      value
    }
    label
  }
  itemsGroupedByEarliestDeliveryDate {
    quantity
    info {
      __typename
      ... on CartItemsSectionInfoReal {
        date
      }
      ... on CartItemsSectionInfoEstimated {
        delay
      }
    }
    items {
      id
      quantity
      rowTotalExclTax
      conditioningUnitPriceExclTax
      catalogDiscountAmount
      deliveryDetails {
        date
        quantity
        availability
        realDeliveryDate
      }
      product {
        ...CartPdfTemplate_Product
        stock {
          maxQuantity
        }
      }
    }
  }
}
    ${CartPdfTemplate_ProductFragmentDoc}`;
export const QuickOrderConfigFragmentDoc = gql`
    fragment QuickOrderConfig on Config {
  sales {
    isQuickOrderEnabled
  }
}
    `;
export const Company_ChorusDataFragmentDoc = gql`
    fragment Company_ChorusData on ChorusData {
  isChorus
  isRequiredService
  isRequiredLegalCommitment
  isRequiredServiceOrRequiredLegalCommitment
  services {
    name
    code
    status
    isRequiredLegalCommitment
  }
}
    `;
export const QuotesTable_QuoteFragmentDoc = gql`
    fragment QuotesTable_Quote on Quote {
  id
  ref
  commercialName
  status
  createdAt
  expiredAt
  totalExcludingTax
  pointOfSale {
    id
    name
  }
}
    `;
export const DeliveryDatePicker_InfoFragmentDoc = gql`
    fragment DeliveryDatePicker_Info on CartItemsSectionInfo {
  ... on CartItemsSectionInfoReal {
    date
  }
  ... on CartItemsSectionInfoEstimated {
    __typename
    delay
  }
  ... on CartItemsSectionInfoClickAndCollect {
    noValue
  }
}
    `;
export const DelaysSummary_ItemSectionsFragmentDoc = gql`
    fragment DelaysSummary_ItemSections on CartItemsSection {
  quantity
  info {
    ... on CartItemsSectionInfoReal {
      date
    }
    ... on CartItemsSectionInfoEstimated {
      __typename
      delay
    }
    ... on CartItemsSectionInfoClickAndCollect {
      noValue
    }
  }
}
    `;
export const ShippingContentStoreAddress_FavoritePointOfSaleFragmentDoc = gql`
    fragment ShippingContentStoreAddress_favoritePointOfSale on PointOfSale {
  id
  name
  phoneNumber
  address {
    city
    line1
    line2
    line3
    postalCode
    isoCountryCode
  }
  subsidiary {
    name
  }
}
    `;
export const Cart_PointOfSaleAddressFragmentDoc = gql`
    fragment Cart_PointOfSaleAddress on PointOfSaleAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  postalCode
}
    `;
export const PointOfSaleFragmentFragmentDoc = gql`
    fragment PointOfSaleFragment on PointOfSale {
  id
  name
  open
  openingHours {
    ...FullOpeningHour
  }
  phoneNumber
  latitude
  longitude
  address {
    ...Cart_PointOfSaleAddress
  }
  link
  exceptionalDates {
    date
    isClosed
  }
  subsidiary {
    id
    name
  }
  distance
}
    ${FullOpeningHourFragmentDoc}
${Cart_PointOfSaleAddressFragmentDoc}`;
export const ShippingStoreOption_CartFragmentDoc = gql`
    fragment ShippingStoreOption_Cart on Cart {
  id
  pointOfSale {
    ...PointOfSaleFragment
  }
}
    ${PointOfSaleFragmentFragmentDoc}`;
export const ShippingClickAndCollectOption_CartFragmentDoc = gql`
    fragment ShippingClickAndCollectOption_Cart on Cart {
  id
  availableClickAndCollectQuantity
  isClickAndCollectActivated
  sumItemsQuantity
  requestedDeliveryDate
  canRequestDeliveryDate
  pointOfSale {
    ...PointOfSaleFragment
  }
}
    ${PointOfSaleFragmentFragmentDoc}`;
export const ShippingFields_CartFragmentDoc = gql`
    fragment ShippingFields_Cart on Cart {
  id
  ...ShippingStoreOption_Cart
  ...ShippingClickAndCollectOption_Cart
  isClickAndCollectFeatureAvailable
  requestedDeliveryDate
  canRequestDeliveryDate
  totalQuantity
  isClickAndCollectActivated
  availableClickAndCollectQuantity
  internalRef
  couponCode
  pointOfSale {
    ...PointOfSaleFragment
  }
}
    ${ShippingStoreOption_CartFragmentDoc}
${ShippingClickAndCollectOption_CartFragmentDoc}
${PointOfSaleFragmentFragmentDoc}`;
export const ShippingFields_CheckoutFragmentDoc = gql`
    fragment ShippingFields_Checkout on Checkout {
  willGenerateOrderRequest
  cart(forceRefresh: true) {
    ...ShippingFields_Cart
    isClickAndCollectActivated
    isClickAndCollectFeatureAvailable
  }
  shipping {
    methodCode
  }
}
    ${ShippingFields_CartFragmentDoc}`;
export const ShippingForm_CheckoutFragmentDoc = gql`
    fragment ShippingForm_Checkout on Checkout {
  ...ShippingFields_Checkout
}
    ${ShippingFields_CheckoutFragmentDoc}`;
export const ShippingTracking_ItemsFragmentDoc = gql`
    fragment ShippingTracking_Items on CartItem {
  id
  analyticsPromotionStatus
  product {
    reference
  }
  quantity
  totalExclTax
  unitPrice {
    exclTax
  }
  deliveryDetails {
    availability
    date
    realDeliveryDate
    quantity
  }
  availableClickAndCollect
}
    `;
export const ShippingTracking_CartFragmentDoc = gql`
    fragment ShippingTracking_Cart on Cart {
  id
  items {
    ...ShippingTracking_Items
  }
}
    ${ShippingTracking_ItemsFragmentDoc}`;
export const ShippingForm_CartFragmentDoc = gql`
    fragment ShippingForm_Cart on Cart {
  id
  totalQuantity
  ...ShippingFields_Cart
}
    ${ShippingFields_CartFragmentDoc}`;
export const CartAddressFragmentDoc = gql`
    fragment CartAddress on CartAddress {
  city
  isoCountryCode
  line1
  line2
  line3
  name
  postalCode
  type
}
    `;
export const ShippingAddress_ShippingFragmentDoc = gql`
    fragment ShippingAddress_Shipping on CartAddress {
  ...CartAddress
  userCompanyAddress {
    id
  }
}
    ${CartAddressFragmentDoc}`;
export const ContactCardFragmentDoc = gql`
    fragment ContactCard on Delivery {
  recipientName
  recipientPhone
  comment
}
    `;
export const ShippingAddressOption_ShippingFragmentDoc = gql`
    fragment ShippingAddressOption_Shipping on Shipping {
  address {
    ...ShippingAddress_Shipping
  }
  availableMethods {
    onsiteDelivery {
      code
      status
      fee {
        ... on ShippingFeeFree {
          isFranco
        }
        ... on ShippingFeeWithAmount {
          amount
        }
        ...ShippingFeeTag_Fee
      }
    }
  }
  delivery {
    ...ContactCard
  }
}
    ${ShippingAddress_ShippingFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}
${ContactCardFragmentDoc}`;
export const ShippingStoreOption_ShippingFragmentDoc = gql`
    fragment ShippingStoreOption_Shipping on Shipping {
  methodCode
  address {
    ...CartAddress
  }
  availableMethods {
    storePickup {
      code
      status
      fee {
        isFranco
      }
    }
  }
  delivery {
    ...ContactCard
  }
}
    ${CartAddressFragmentDoc}
${ContactCardFragmentDoc}`;
export const ShippingClickAndCollectOption_ShippingFragmentDoc = gql`
    fragment ShippingClickAndCollectOption_Shipping on Shipping {
  availableMethods {
    clickAndCollect {
      code
      status
    }
  }
  delivery {
    ...ContactCard
  }
}
    ${ContactCardFragmentDoc}`;
export const ShippingFields_ShippingFragmentDoc = gql`
    fragment ShippingFields_Shipping on Shipping {
  methodCode
  ...ShippingAddressOption_Shipping
  ...ShippingStoreOption_Shipping
  ...ShippingClickAndCollectOption_Shipping
}
    ${ShippingAddressOption_ShippingFragmentDoc}
${ShippingStoreOption_ShippingFragmentDoc}
${ShippingClickAndCollectOption_ShippingFragmentDoc}`;
export const ShippingForm_ShippingFragmentDoc = gql`
    fragment ShippingForm_Shipping on Shipping {
  ...ShippingFields_Shipping
  delivery {
    recipientPhone
  }
}
    ${ShippingFields_ShippingFragmentDoc}`;
export const Shipping_CheckoutFragmentDoc = gql`
    fragment Shipping_Checkout on Checkout {
  ...ShippingForm_Checkout
  cart(forceRefresh: true) {
    id
    isClickAndCollectActivated
    itemsSplitByDeliveryDate {
      ...CartItemsSummaryAccordionCard_Sections
    }
    ...ShippingTracking_Cart
    ...ShippingForm_Cart
    ...ChooseDeliveryDate_Cart
    ...CartSummary_Cart
  }
  shipping {
    delivery {
      comment
      recipientName
      recipientPhone
    }
    ...ShippingForm_Shipping
    ...CartSummary_Shipping
  }
}
    ${ShippingForm_CheckoutFragmentDoc}
${CartItemsSummaryAccordionCard_SectionsFragmentDoc}
${ShippingTracking_CartFragmentDoc}
${ShippingForm_CartFragmentDoc}
${ChooseDeliveryDate_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingForm_ShippingFragmentDoc}
${CartSummary_ShippingFragmentDoc}`;
export const CategoriesSlider_CategoriesFragmentDoc = gql`
    fragment CategoriesSlider_Categories on Category {
  urlKey
  id
  name
  mainImage {
    ...FullPicture
  }
  isUniverse
}
    ${FullPictureFragmentDoc}`;
export const MainCategoryFragmentDoc = gql`
    fragment MainCategory on Category {
  id
  isUniverse
  urlKey
  name
  baseline
  seoContent
  code
}
    `;
export const SubCategoryFragmentDoc = gql`
    fragment SubCategory on Category {
  urlKey
  name
  isUniverse
  mainImage {
    ...FullPicture
  }
}
    ${FullPictureFragmentDoc}`;
export const WishlistPriceAndStocks_ProductFragmentDoc = gql`
    fragment WishlistPriceAndStocks_Product on Product {
  ...ProductRowPriceAndStock_Product
  price {
    tag
    exclTax
    referenceExclTax
    tiers {
      quantity
      exclTax
    }
  }
}
    ${ProductRowPriceAndStock_ProductFragmentDoc}`;
export const SiteConfigDocument = gql`
    query SiteConfig {
  config {
    site {
      defaultCountryIso3
    }
  }
}
    `;

/**
 * __useSiteConfigQuery__
 *
 * To run a query within a React component, call `useSiteConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteConfigQuery(baseOptions?: Apollo.QueryHookOptions<SiteConfigQuery, SiteConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteConfigQuery, SiteConfigQueryVariables>(SiteConfigDocument, options);
      }
export function useSiteConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteConfigQuery, SiteConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteConfigQuery, SiteConfigQueryVariables>(SiteConfigDocument, options);
        }
export function useSiteConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteConfigQuery, SiteConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteConfigQuery, SiteConfigQueryVariables>(SiteConfigDocument, options);
        }
export type SiteConfigQueryHookResult = ReturnType<typeof useSiteConfigQuery>;
export type SiteConfigLazyQueryHookResult = ReturnType<typeof useSiteConfigLazyQuery>;
export type SiteConfigSuspenseQueryHookResult = ReturnType<typeof useSiteConfigSuspenseQuery>;
export type SiteConfigQueryResult = Apollo.QueryResult<SiteConfigQuery, SiteConfigQueryVariables>;
export const AccountListCurrentUserAccountsDocument = gql`
    query AccountListCurrentUserAccounts {
  currentUserAccounts(status: ACTIVE) {
    email
    ...AccountSelectionCurrentUserAccounts
  }
}
    ${AccountSelectionCurrentUserAccountsFragmentDoc}`;

/**
 * __useAccountListCurrentUserAccountsQuery__
 *
 * To run a query within a React component, call `useAccountListCurrentUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountListCurrentUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountListCurrentUserAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountListCurrentUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>(AccountListCurrentUserAccountsDocument, options);
      }
export function useAccountListCurrentUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>(AccountListCurrentUserAccountsDocument, options);
        }
export function useAccountListCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>(AccountListCurrentUserAccountsDocument, options);
        }
export type AccountListCurrentUserAccountsQueryHookResult = ReturnType<typeof useAccountListCurrentUserAccountsQuery>;
export type AccountListCurrentUserAccountsLazyQueryHookResult = ReturnType<typeof useAccountListCurrentUserAccountsLazyQuery>;
export type AccountListCurrentUserAccountsSuspenseQueryHookResult = ReturnType<typeof useAccountListCurrentUserAccountsSuspenseQuery>;
export type AccountListCurrentUserAccountsQueryResult = Apollo.QueryResult<AccountListCurrentUserAccountsQuery, AccountListCurrentUserAccountsQueryVariables>;
export const CurrentUserCompanyDocument = gql`
    query CurrentUserCompany {
  currentUser {
    id
    company {
      id
      code
    }
  }
}
    `;

/**
 * __useCurrentUserCompanyQuery__
 *
 * To run a query within a React component, call `useCurrentUserCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCompanyQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>(CurrentUserCompanyDocument, options);
      }
export function useCurrentUserCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>(CurrentUserCompanyDocument, options);
        }
export function useCurrentUserCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>(CurrentUserCompanyDocument, options);
        }
export type CurrentUserCompanyQueryHookResult = ReturnType<typeof useCurrentUserCompanyQuery>;
export type CurrentUserCompanyLazyQueryHookResult = ReturnType<typeof useCurrentUserCompanyLazyQuery>;
export type CurrentUserCompanySuspenseQueryHookResult = ReturnType<typeof useCurrentUserCompanySuspenseQuery>;
export type CurrentUserCompanyQueryResult = Apollo.QueryResult<CurrentUserCompanyQuery, CurrentUserCompanyQueryVariables>;
export const ResetPasswordUrlDocument = gql`
    query ResetPasswordUrl($email: String!) {
  resetPasswordUrl(email: $email)
}
    `;

/**
 * __useResetPasswordUrlQuery__
 *
 * To run a query within a React component, call `useResetPasswordUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetPasswordUrlQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordUrlQuery(baseOptions: Apollo.QueryHookOptions<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables> & ({ variables: ResetPasswordUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>(ResetPasswordUrlDocument, options);
      }
export function useResetPasswordUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>(ResetPasswordUrlDocument, options);
        }
export function useResetPasswordUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>(ResetPasswordUrlDocument, options);
        }
export type ResetPasswordUrlQueryHookResult = ReturnType<typeof useResetPasswordUrlQuery>;
export type ResetPasswordUrlLazyQueryHookResult = ReturnType<typeof useResetPasswordUrlLazyQuery>;
export type ResetPasswordUrlSuspenseQueryHookResult = ReturnType<typeof useResetPasswordUrlSuspenseQuery>;
export type ResetPasswordUrlQueryResult = Apollo.QueryResult<ResetPasswordUrlQuery, ResetPasswordUrlQueryVariables>;
export const GetOrdersPageContextDocument = gql`
    query GetOrdersPageContext {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
    permissions {
      hasAccessToWebOrders
      hasAccessToStoreOrders
    }
  }
  config {
    ...OrdersHistoryConfig
  }
}
    ${OrdersHistoryConfigFragmentDoc}`;

/**
 * __useGetOrdersPageContextQuery__
 *
 * To run a query within a React component, call `useGetOrdersPageContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersPageContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersPageContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersPageContextQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>(GetOrdersPageContextDocument, options);
      }
export function useGetOrdersPageContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>(GetOrdersPageContextDocument, options);
        }
export function useGetOrdersPageContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>(GetOrdersPageContextDocument, options);
        }
export type GetOrdersPageContextQueryHookResult = ReturnType<typeof useGetOrdersPageContextQuery>;
export type GetOrdersPageContextLazyQueryHookResult = ReturnType<typeof useGetOrdersPageContextLazyQuery>;
export type GetOrdersPageContextSuspenseQueryHookResult = ReturnType<typeof useGetOrdersPageContextSuspenseQuery>;
export type GetOrdersPageContextQueryResult = Apollo.QueryResult<GetOrdersPageContextQuery, GetOrdersPageContextQueryVariables>;
export const CurrentUserOrdersPermissionDocument = gql`
    query CurrentUserOrdersPermission {
  currentUser {
    permissions {
      hasAccessToStoreOrders
    }
  }
}
    `;

/**
 * __useCurrentUserOrdersPermissionQuery__
 *
 * To run a query within a React component, call `useCurrentUserOrdersPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserOrdersPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserOrdersPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserOrdersPermissionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>(CurrentUserOrdersPermissionDocument, options);
      }
export function useCurrentUserOrdersPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>(CurrentUserOrdersPermissionDocument, options);
        }
export function useCurrentUserOrdersPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>(CurrentUserOrdersPermissionDocument, options);
        }
export type CurrentUserOrdersPermissionQueryHookResult = ReturnType<typeof useCurrentUserOrdersPermissionQuery>;
export type CurrentUserOrdersPermissionLazyQueryHookResult = ReturnType<typeof useCurrentUserOrdersPermissionLazyQuery>;
export type CurrentUserOrdersPermissionSuspenseQueryHookResult = ReturnType<typeof useCurrentUserOrdersPermissionSuspenseQuery>;
export type CurrentUserOrdersPermissionQueryResult = Apollo.QueryResult<CurrentUserOrdersPermissionQuery, CurrentUserOrdersPermissionQueryVariables>;
export const GetCartDocument = gql`
    query GetCart {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
    permissions {
      hasAccessToWebOrders
    }
  }
}
    `;

/**
 * __useGetCartQuery__
 *
 * To run a query within a React component, call `useGetCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartQuery(baseOptions?: Apollo.QueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
      }
export function useGetCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export function useGetCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export type GetCartQueryHookResult = ReturnType<typeof useGetCartQuery>;
export type GetCartLazyQueryHookResult = ReturnType<typeof useGetCartLazyQuery>;
export type GetCartSuspenseQueryHookResult = ReturnType<typeof useGetCartSuspenseQuery>;
export type GetCartQueryResult = Apollo.QueryResult<GetCartQuery, GetCartQueryVariables>;
export const GetCurrentQuoteProductsDocument = gql`
    query GetCurrentQuoteProducts {
  currentUser {
    id
    currentQuote {
      ...CurrentQuoteDetailPage_Wishlist
    }
  }
}
    ${CurrentQuoteDetailPage_WishlistFragmentDoc}`;

/**
 * __useGetCurrentQuoteProductsQuery__
 *
 * To run a query within a React component, call `useGetCurrentQuoteProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuoteProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuoteProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentQuoteProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>(GetCurrentQuoteProductsDocument, options);
      }
export function useGetCurrentQuoteProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>(GetCurrentQuoteProductsDocument, options);
        }
export function useGetCurrentQuoteProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>(GetCurrentQuoteProductsDocument, options);
        }
export type GetCurrentQuoteProductsQueryHookResult = ReturnType<typeof useGetCurrentQuoteProductsQuery>;
export type GetCurrentQuoteProductsLazyQueryHookResult = ReturnType<typeof useGetCurrentQuoteProductsLazyQuery>;
export type GetCurrentQuoteProductsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentQuoteProductsSuspenseQuery>;
export type GetCurrentQuoteProductsQueryResult = Apollo.QueryResult<GetCurrentQuoteProductsQuery, GetCurrentQuoteProductsQueryVariables>;
export const CurrentQuoteInfosDocument = gql`
    query CurrentQuoteInfos {
  currentUser {
    id
    currentQuote {
      id
      name
    }
  }
}
    `;

/**
 * __useCurrentQuoteInfosQuery__
 *
 * To run a query within a React component, call `useCurrentQuoteInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentQuoteInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentQuoteInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentQuoteInfosQuery(baseOptions?: Apollo.QueryHookOptions<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>(CurrentQuoteInfosDocument, options);
      }
export function useCurrentQuoteInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>(CurrentQuoteInfosDocument, options);
        }
export function useCurrentQuoteInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>(CurrentQuoteInfosDocument, options);
        }
export type CurrentQuoteInfosQueryHookResult = ReturnType<typeof useCurrentQuoteInfosQuery>;
export type CurrentQuoteInfosLazyQueryHookResult = ReturnType<typeof useCurrentQuoteInfosLazyQuery>;
export type CurrentQuoteInfosSuspenseQueryHookResult = ReturnType<typeof useCurrentQuoteInfosSuspenseQuery>;
export type CurrentQuoteInfosQueryResult = Apollo.QueryResult<CurrentQuoteInfosQuery, CurrentQuoteInfosQueryVariables>;
export const GetQuoteDetailDocument = gql`
    query GetQuoteDetail($quoteId: String!, $posId: String!) {
  currentUser {
    id
    isSubjectToApprovalFlow
    company {
      id
      forbidden
      quotes(
        input: {pagination: {size: 1, index: 0}, filter: [{type: STRING, field: "id", operator: EQUAL, stringValue: $quoteId}, {type: STRING, field: "pointOfSaleId", operator: EQUAL, stringValue: $posId}]}
      ) {
        items {
          ...QuoteDetail_Quote
        }
      }
      isPublicAdministration
    }
    favoriteBillingAddress {
      line1
      line2
      line3
      postalCode
      city
      isoCountryCode
    }
  }
}
    ${QuoteDetail_QuoteFragmentDoc}`;

/**
 * __useGetQuoteDetailQuery__
 *
 * To run a query within a React component, call `useGetQuoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteDetailQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      posId: // value for 'posId'
 *   },
 * });
 */
export function useGetQuoteDetailQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteDetailQuery, GetQuoteDetailQueryVariables> & ({ variables: GetQuoteDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>(GetQuoteDetailDocument, options);
      }
export function useGetQuoteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>(GetQuoteDetailDocument, options);
        }
export function useGetQuoteDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>(GetQuoteDetailDocument, options);
        }
export type GetQuoteDetailQueryHookResult = ReturnType<typeof useGetQuoteDetailQuery>;
export type GetQuoteDetailLazyQueryHookResult = ReturnType<typeof useGetQuoteDetailLazyQuery>;
export type GetQuoteDetailSuspenseQueryHookResult = ReturnType<typeof useGetQuoteDetailSuspenseQuery>;
export type GetQuoteDetailQueryResult = Apollo.QueryResult<GetQuoteDetailQuery, GetQuoteDetailQueryVariables>;
export const GetQuotesConfigDocument = gql`
    query getQuotesConfig {
  config {
    ...QuotesPage_Config
  }
}
    ${QuotesPage_ConfigFragmentDoc}`;

/**
 * __useGetQuotesConfigQuery__
 *
 * To run a query within a React component, call `useGetQuotesConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuotesConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>(GetQuotesConfigDocument, options);
      }
export function useGetQuotesConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>(GetQuotesConfigDocument, options);
        }
export function useGetQuotesConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>(GetQuotesConfigDocument, options);
        }
export type GetQuotesConfigQueryHookResult = ReturnType<typeof useGetQuotesConfigQuery>;
export type GetQuotesConfigLazyQueryHookResult = ReturnType<typeof useGetQuotesConfigLazyQuery>;
export type GetQuotesConfigSuspenseQueryHookResult = ReturnType<typeof useGetQuotesConfigSuspenseQuery>;
export type GetQuotesConfigQueryResult = Apollo.QueryResult<GetQuotesConfigQuery, GetQuotesConfigQueryVariables>;
export const GetQuotesPermissionDocument = gql`
    query getQuotesPermission {
  currentUser {
    id
    permissions {
      canManageQuote
    }
  }
}
    `;

/**
 * __useGetQuotesPermissionQuery__
 *
 * To run a query within a React component, call `useGetQuotesPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuotesPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>(GetQuotesPermissionDocument, options);
      }
export function useGetQuotesPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>(GetQuotesPermissionDocument, options);
        }
export function useGetQuotesPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>(GetQuotesPermissionDocument, options);
        }
export type GetQuotesPermissionQueryHookResult = ReturnType<typeof useGetQuotesPermissionQuery>;
export type GetQuotesPermissionLazyQueryHookResult = ReturnType<typeof useGetQuotesPermissionLazyQuery>;
export type GetQuotesPermissionSuspenseQueryHookResult = ReturnType<typeof useGetQuotesPermissionSuspenseQuery>;
export type GetQuotesPermissionQueryResult = Apollo.QueryResult<GetQuotesPermissionQuery, GetQuotesPermissionQueryVariables>;
export const GetCurrentQuoteDocument = gql`
    query getCurrentQuote {
  currentUser {
    id
    currentQuote {
      id
    }
  }
}
    `;

/**
 * __useGetCurrentQuoteQuery__
 *
 * To run a query within a React component, call `useGetCurrentQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuoteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>(GetCurrentQuoteDocument, options);
      }
export function useGetCurrentQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>(GetCurrentQuoteDocument, options);
        }
export function useGetCurrentQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>(GetCurrentQuoteDocument, options);
        }
export type GetCurrentQuoteQueryHookResult = ReturnType<typeof useGetCurrentQuoteQuery>;
export type GetCurrentQuoteLazyQueryHookResult = ReturnType<typeof useGetCurrentQuoteLazyQuery>;
export type GetCurrentQuoteSuspenseQueryHookResult = ReturnType<typeof useGetCurrentQuoteSuspenseQuery>;
export type GetCurrentQuoteQueryResult = Apollo.QueryResult<GetCurrentQuoteQuery, GetCurrentQuoteQueryVariables>;
export const GetLastUserAccountDocument = gql`
    query GetLastUserAccount {
  lastUserAccount {
    id
    favoritePointOfSaleId
    favoritePointOfSale {
      id
    }
    company {
      id
      code
      name
      pointOfSale {
        id
        subsidiary {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetLastUserAccountQuery__
 *
 * To run a query within a React component, call `useGetLastUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastUserAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastUserAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>(GetLastUserAccountDocument, options);
      }
export function useGetLastUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>(GetLastUserAccountDocument, options);
        }
export function useGetLastUserAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>(GetLastUserAccountDocument, options);
        }
export type GetLastUserAccountQueryHookResult = ReturnType<typeof useGetLastUserAccountQuery>;
export type GetLastUserAccountLazyQueryHookResult = ReturnType<typeof useGetLastUserAccountLazyQuery>;
export type GetLastUserAccountSuspenseQueryHookResult = ReturnType<typeof useGetLastUserAccountSuspenseQuery>;
export type GetLastUserAccountQueryResult = Apollo.QueryResult<GetLastUserAccountQuery, GetLastUserAccountQueryVariables>;
export const GenerateAuthTokenDocument = gql`
    mutation generateAuthToken($refreshToken: String!) {
  generateAuthToken(refreshToken: $refreshToken) {
    type
    value
    maxAge
  }
}
    `;
export type GenerateAuthTokenMutationFn = Apollo.MutationFunction<GenerateAuthTokenMutation, GenerateAuthTokenMutationVariables>;

/**
 * __useGenerateAuthTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuthTokenMutation, { data, loading, error }] = useGenerateAuthTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useGenerateAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAuthTokenMutation, GenerateAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAuthTokenMutation, GenerateAuthTokenMutationVariables>(GenerateAuthTokenDocument, options);
      }
export type GenerateAuthTokenMutationHookResult = ReturnType<typeof useGenerateAuthTokenMutation>;
export type GenerateAuthTokenMutationResult = Apollo.MutationResult<GenerateAuthTokenMutation>;
export type GenerateAuthTokenMutationOptions = Apollo.BaseMutationOptions<GenerateAuthTokenMutation, GenerateAuthTokenMutationVariables>;
export const CurrentUserApprovalFlowPermissionsDocument = gql`
    query currentUserApprovalFlowPermissions {
  currentUser {
    permissions {
      canManageApprovalFlows
    }
  }
}
    `;

/**
 * __useCurrentUserApprovalFlowPermissionsQuery__
 *
 * To run a query within a React component, call `useCurrentUserApprovalFlowPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserApprovalFlowPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserApprovalFlowPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserApprovalFlowPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>(CurrentUserApprovalFlowPermissionsDocument, options);
      }
export function useCurrentUserApprovalFlowPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>(CurrentUserApprovalFlowPermissionsDocument, options);
        }
export function useCurrentUserApprovalFlowPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>(CurrentUserApprovalFlowPermissionsDocument, options);
        }
export type CurrentUserApprovalFlowPermissionsQueryHookResult = ReturnType<typeof useCurrentUserApprovalFlowPermissionsQuery>;
export type CurrentUserApprovalFlowPermissionsLazyQueryHookResult = ReturnType<typeof useCurrentUserApprovalFlowPermissionsLazyQuery>;
export type CurrentUserApprovalFlowPermissionsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserApprovalFlowPermissionsSuspenseQuery>;
export type CurrentUserApprovalFlowPermissionsQueryResult = Apollo.QueryResult<CurrentUserApprovalFlowPermissionsQuery, CurrentUserApprovalFlowPermissionsQueryVariables>;
export const GetCurrentCollaboratorDocument = gql`
    query GetCurrentCollaborator {
  currentUser {
    ...CurrentCollaborator_User
    company {
      id
      availableUserRoles
    }
  }
}
    ${CurrentCollaborator_UserFragmentDoc}`;

/**
 * __useGetCurrentCollaboratorQuery__
 *
 * To run a query within a React component, call `useGetCurrentCollaboratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCollaboratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCollaboratorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCollaboratorQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>(GetCurrentCollaboratorDocument, options);
      }
export function useGetCurrentCollaboratorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>(GetCurrentCollaboratorDocument, options);
        }
export function useGetCurrentCollaboratorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>(GetCurrentCollaboratorDocument, options);
        }
export type GetCurrentCollaboratorQueryHookResult = ReturnType<typeof useGetCurrentCollaboratorQuery>;
export type GetCurrentCollaboratorLazyQueryHookResult = ReturnType<typeof useGetCurrentCollaboratorLazyQuery>;
export type GetCurrentCollaboratorSuspenseQueryHookResult = ReturnType<typeof useGetCurrentCollaboratorSuspenseQuery>;
export type GetCurrentCollaboratorQueryResult = Apollo.QueryResult<GetCurrentCollaboratorQuery, GetCurrentCollaboratorQueryVariables>;
export const GetCurrentUserCollaboratorPermissionsDocument = gql`
    query GetCurrentUserCollaboratorPermissions {
  currentUser {
    permissions {
      showCompanyUsers
    }
  }
}
    `;

/**
 * __useGetCurrentUserCollaboratorPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCollaboratorPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCollaboratorPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCollaboratorPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserCollaboratorPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>(GetCurrentUserCollaboratorPermissionsDocument, options);
      }
export function useGetCurrentUserCollaboratorPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>(GetCurrentUserCollaboratorPermissionsDocument, options);
        }
export function useGetCurrentUserCollaboratorPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>(GetCurrentUserCollaboratorPermissionsDocument, options);
        }
export type GetCurrentUserCollaboratorPermissionsQueryHookResult = ReturnType<typeof useGetCurrentUserCollaboratorPermissionsQuery>;
export type GetCurrentUserCollaboratorPermissionsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCollaboratorPermissionsLazyQuery>;
export type GetCurrentUserCollaboratorPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCollaboratorPermissionsSuspenseQuery>;
export type GetCurrentUserCollaboratorPermissionsQueryResult = Apollo.QueryResult<GetCurrentUserCollaboratorPermissionsQuery, GetCurrentUserCollaboratorPermissionsQueryVariables>;
export const GetLoyaltyConfigDocument = gql`
    query GetLoyaltyConfig {
  config {
    ...LoyaltyConfig
  }
  currentUser {
    id
    loyalty {
      status
    }
  }
}
    ${LoyaltyConfigFragmentDoc}`;

/**
 * __useGetLoyaltyConfigQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoyaltyConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>(GetLoyaltyConfigDocument, options);
      }
export function useGetLoyaltyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>(GetLoyaltyConfigDocument, options);
        }
export function useGetLoyaltyConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>(GetLoyaltyConfigDocument, options);
        }
export type GetLoyaltyConfigQueryHookResult = ReturnType<typeof useGetLoyaltyConfigQuery>;
export type GetLoyaltyConfigLazyQueryHookResult = ReturnType<typeof useGetLoyaltyConfigLazyQuery>;
export type GetLoyaltyConfigSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyConfigSuspenseQuery>;
export type GetLoyaltyConfigQueryResult = Apollo.QueryResult<GetLoyaltyConfigQuery, GetLoyaltyConfigQueryVariables>;
export const OrderRequestDetailsAsBuyerPageDocument = gql`
    query OrderRequestDetailsAsBuyerPage($webRef: String!) {
  currentUser {
    id
    isSubjectToApprovalFlow
    company {
      id
      chorusData {
        services {
          name
          code
        }
      }
    }
    orderRequests(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $webRef}]}
    ) {
      items {
        ...OrderRequestDetails_Order
        orderDate
        internalRef
        webRef
        chorusLegalCommitment
        chorusServiceCode
        delivery {
          addresses {
            ...OrderAddress
          }
        }
        approvers {
          lastname
          firstname
        }
        itemsSplitByDeliveryDate {
          info {
            ...OrderRequestDeliverySection_OrderItemsSectionInfoEstimated
            ...OrderRequestDeliverySection_OrderItemsSectionInfoReal
          }
          items {
            ...OrderRequestProductRowReadOnly_OrderItem
          }
        }
        user {
          name
        }
      }
    }
  }
  config {
    ...OrderRequestConfig_Config
    ...OrderReferenceDisplay_Config
    sales {
      isChorusDisplayEnabled
    }
  }
}
    ${OrderRequestDetails_OrderFragmentDoc}
${OrderAddressFragmentDoc}
${OrderRequestDeliverySection_OrderItemsSectionInfoEstimatedFragmentDoc}
${OrderRequestDeliverySection_OrderItemsSectionInfoRealFragmentDoc}
${OrderRequestProductRowReadOnly_OrderItemFragmentDoc}
${OrderRequestConfig_ConfigFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useOrderRequestDetailsAsBuyerPageQuery__
 *
 * To run a query within a React component, call `useOrderRequestDetailsAsBuyerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestDetailsAsBuyerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestDetailsAsBuyerPageQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useOrderRequestDetailsAsBuyerPageQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables> & ({ variables: OrderRequestDetailsAsBuyerPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>(OrderRequestDetailsAsBuyerPageDocument, options);
      }
export function useOrderRequestDetailsAsBuyerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>(OrderRequestDetailsAsBuyerPageDocument, options);
        }
export function useOrderRequestDetailsAsBuyerPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>(OrderRequestDetailsAsBuyerPageDocument, options);
        }
export type OrderRequestDetailsAsBuyerPageQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsBuyerPageQuery>;
export type OrderRequestDetailsAsBuyerPageLazyQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsBuyerPageLazyQuery>;
export type OrderRequestDetailsAsBuyerPageSuspenseQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsBuyerPageSuspenseQuery>;
export type OrderRequestDetailsAsBuyerPageQueryResult = Apollo.QueryResult<OrderRequestDetailsAsBuyerPageQuery, OrderRequestDetailsAsBuyerPageQueryVariables>;
export const OrderRequestDetailsAsValidationPageDocument = gql`
    query OrderRequestDetailsAsValidationPage($webRef: String!, $resetData: Boolean) {
  currentUser {
    id
    company {
      id
      chorusData {
        ...OrderRequestDetailsFields_ChorusData
      }
    }
    orderRequestToApprove(webRef: $webRef, resetData: $resetData) {
      internalRef
      orderDate
      webRef
      chorusServiceCode
      chorusLegalCommitment
      approvee {
        firstname
        lastname
      }
      approver {
        firstname
        lastname
      }
      delivery {
        addresses {
          ...OrderAddress
        }
        fee {
          ... on ShippingFeeFree {
            isFranco
          }
          ... on ShippingFeeWithAmount {
            amount
          }
        }
        requestedDate
      }
      payment {
        code
      }
      updatedState {
        id
        ...CartSummary_Cart
        requestedDeliveryDate
        canRequestDeliveryDate
        messages {
          ...OrderRequestUnavailableProduct_CartMessage
        }
        itemsGroupedByEarliestDeliveryDate {
          items {
            ...OrderRequestProductRow_CartItem
          }
        }
        itemsSplitByDeliveryDate {
          items {
            ...OrderRequestProductRow_CartItem
          }
        }
      }
    }
  }
  config {
    ...OrderRequestConfig_Config
    ...OrderReferenceDisplay_Config
    catalog {
      g9LowStockThreshold
    }
  }
}
    ${OrderRequestDetailsFields_ChorusDataFragmentDoc}
${OrderAddressFragmentDoc}
${CartSummary_CartFragmentDoc}
${OrderRequestUnavailableProduct_CartMessageFragmentDoc}
${OrderRequestProductRow_CartItemFragmentDoc}
${OrderRequestConfig_ConfigFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useOrderRequestDetailsAsValidationPageQuery__
 *
 * To run a query within a React component, call `useOrderRequestDetailsAsValidationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestDetailsAsValidationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestDetailsAsValidationPageQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *      resetData: // value for 'resetData'
 *   },
 * });
 */
export function useOrderRequestDetailsAsValidationPageQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables> & ({ variables: OrderRequestDetailsAsValidationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>(OrderRequestDetailsAsValidationPageDocument, options);
      }
export function useOrderRequestDetailsAsValidationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>(OrderRequestDetailsAsValidationPageDocument, options);
        }
export function useOrderRequestDetailsAsValidationPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>(OrderRequestDetailsAsValidationPageDocument, options);
        }
export type OrderRequestDetailsAsValidationPageQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsValidationPageQuery>;
export type OrderRequestDetailsAsValidationPageLazyQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsValidationPageLazyQuery>;
export type OrderRequestDetailsAsValidationPageSuspenseQueryHookResult = ReturnType<typeof useOrderRequestDetailsAsValidationPageSuspenseQuery>;
export type OrderRequestDetailsAsValidationPageQueryResult = Apollo.QueryResult<OrderRequestDetailsAsValidationPageQuery, OrderRequestDetailsAsValidationPageQueryVariables>;
export const GetOrderRequestPermissionDocument = gql`
    query getOrderRequestPermission {
  currentUser {
    permissions {
      hasAccessToOrderRequestToApprove
    }
  }
  config {
    ...OrderRequestConfig_Config
  }
}
    ${OrderRequestConfig_ConfigFragmentDoc}`;

/**
 * __useGetOrderRequestPermissionQuery__
 *
 * To run a query within a React component, call `useGetOrderRequestPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRequestPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderRequestPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderRequestPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>(GetOrderRequestPermissionDocument, options);
      }
export function useGetOrderRequestPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>(GetOrderRequestPermissionDocument, options);
        }
export function useGetOrderRequestPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>(GetOrderRequestPermissionDocument, options);
        }
export type GetOrderRequestPermissionQueryHookResult = ReturnType<typeof useGetOrderRequestPermissionQuery>;
export type GetOrderRequestPermissionLazyQueryHookResult = ReturnType<typeof useGetOrderRequestPermissionLazyQuery>;
export type GetOrderRequestPermissionSuspenseQueryHookResult = ReturnType<typeof useGetOrderRequestPermissionSuspenseQuery>;
export type GetOrderRequestPermissionQueryResult = Apollo.QueryResult<GetOrderRequestPermissionQuery, GetOrderRequestPermissionQueryVariables>;
export const GetOnGoingOrderRequestPermissionDocument = gql`
    query getOnGoingOrderRequestPermission {
  currentUser {
    isSubjectToApprovalFlow
  }
  config {
    ...OrderRequestConfig_Config
  }
}
    ${OrderRequestConfig_ConfigFragmentDoc}`;

/**
 * __useGetOnGoingOrderRequestPermissionQuery__
 *
 * To run a query within a React component, call `useGetOnGoingOrderRequestPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnGoingOrderRequestPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnGoingOrderRequestPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnGoingOrderRequestPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>(GetOnGoingOrderRequestPermissionDocument, options);
      }
export function useGetOnGoingOrderRequestPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>(GetOnGoingOrderRequestPermissionDocument, options);
        }
export function useGetOnGoingOrderRequestPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>(GetOnGoingOrderRequestPermissionDocument, options);
        }
export type GetOnGoingOrderRequestPermissionQueryHookResult = ReturnType<typeof useGetOnGoingOrderRequestPermissionQuery>;
export type GetOnGoingOrderRequestPermissionLazyQueryHookResult = ReturnType<typeof useGetOnGoingOrderRequestPermissionLazyQuery>;
export type GetOnGoingOrderRequestPermissionSuspenseQueryHookResult = ReturnType<typeof useGetOnGoingOrderRequestPermissionSuspenseQuery>;
export type GetOnGoingOrderRequestPermissionQueryResult = Apollo.QueryResult<GetOnGoingOrderRequestPermissionQuery, GetOnGoingOrderRequestPermissionQueryVariables>;
export const GetQuickOrderConfigDocument = gql`
    query GetQuickOrderConfig {
  config {
    ...QuickOrderConfig
  }
}
    ${QuickOrderConfigFragmentDoc}`;

/**
 * __useGetQuickOrderConfigQuery__
 *
 * To run a query within a React component, call `useGetQuickOrderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickOrderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickOrderConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickOrderConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>(GetQuickOrderConfigDocument, options);
      }
export function useGetQuickOrderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>(GetQuickOrderConfigDocument, options);
        }
export function useGetQuickOrderConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>(GetQuickOrderConfigDocument, options);
        }
export type GetQuickOrderConfigQueryHookResult = ReturnType<typeof useGetQuickOrderConfigQuery>;
export type GetQuickOrderConfigLazyQueryHookResult = ReturnType<typeof useGetQuickOrderConfigLazyQuery>;
export type GetQuickOrderConfigSuspenseQueryHookResult = ReturnType<typeof useGetQuickOrderConfigSuspenseQuery>;
export type GetQuickOrderConfigQueryResult = Apollo.QueryResult<GetQuickOrderConfigQuery, GetQuickOrderConfigQueryVariables>;
export const GetQuickOrderListDocument = gql`
    query GetQuickOrderList {
  currentUser {
    id
    quickOrderList {
      ...QuickOrderProductList_Products
    }
  }
}
    ${QuickOrderProductList_ProductsFragmentDoc}`;

/**
 * __useGetQuickOrderListQuery__
 *
 * To run a query within a React component, call `useGetQuickOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickOrderListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickOrderListQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>(GetQuickOrderListDocument, options);
      }
export function useGetQuickOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>(GetQuickOrderListDocument, options);
        }
export function useGetQuickOrderListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>(GetQuickOrderListDocument, options);
        }
export type GetQuickOrderListQueryHookResult = ReturnType<typeof useGetQuickOrderListQuery>;
export type GetQuickOrderListLazyQueryHookResult = ReturnType<typeof useGetQuickOrderListLazyQuery>;
export type GetQuickOrderListSuspenseQueryHookResult = ReturnType<typeof useGetQuickOrderListSuspenseQuery>;
export type GetQuickOrderListQueryResult = Apollo.QueryResult<GetQuickOrderListQuery, GetQuickOrderListQueryVariables>;
export const GetQuickOrderListCheckoutInformationDocument = gql`
    query GetQuickOrderListCheckoutInformation {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useGetQuickOrderListCheckoutInformationQuery__
 *
 * To run a query within a React component, call `useGetQuickOrderListCheckoutInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickOrderListCheckoutInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickOrderListCheckoutInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickOrderListCheckoutInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>(GetQuickOrderListCheckoutInformationDocument, options);
      }
export function useGetQuickOrderListCheckoutInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>(GetQuickOrderListCheckoutInformationDocument, options);
        }
export function useGetQuickOrderListCheckoutInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>(GetQuickOrderListCheckoutInformationDocument, options);
        }
export type GetQuickOrderListCheckoutInformationQueryHookResult = ReturnType<typeof useGetQuickOrderListCheckoutInformationQuery>;
export type GetQuickOrderListCheckoutInformationLazyQueryHookResult = ReturnType<typeof useGetQuickOrderListCheckoutInformationLazyQuery>;
export type GetQuickOrderListCheckoutInformationSuspenseQueryHookResult = ReturnType<typeof useGetQuickOrderListCheckoutInformationSuspenseQuery>;
export type GetQuickOrderListCheckoutInformationQueryResult = Apollo.QueryResult<GetQuickOrderListCheckoutInformationQuery, GetQuickOrderListCheckoutInformationQueryVariables>;
export const TopPurchaseCartInfoDocument = gql`
    query TopPurchaseCartInfo {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useTopPurchaseCartInfoQuery__
 *
 * To run a query within a React component, call `useTopPurchaseCartInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopPurchaseCartInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopPurchaseCartInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopPurchaseCartInfoQuery(baseOptions?: Apollo.QueryHookOptions<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>(TopPurchaseCartInfoDocument, options);
      }
export function useTopPurchaseCartInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>(TopPurchaseCartInfoDocument, options);
        }
export function useTopPurchaseCartInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>(TopPurchaseCartInfoDocument, options);
        }
export type TopPurchaseCartInfoQueryHookResult = ReturnType<typeof useTopPurchaseCartInfoQuery>;
export type TopPurchaseCartInfoLazyQueryHookResult = ReturnType<typeof useTopPurchaseCartInfoLazyQuery>;
export type TopPurchaseCartInfoSuspenseQueryHookResult = ReturnType<typeof useTopPurchaseCartInfoSuspenseQuery>;
export type TopPurchaseCartInfoQueryResult = Apollo.QueryResult<TopPurchaseCartInfoQuery, TopPurchaseCartInfoQueryVariables>;
export const TopPurchasesDocument = gql`
    query TopPurchases {
  currentUser {
    id
    company {
      id
      topPurchaseList {
        products {
          ...WishlistProduct_Product
        }
      }
    }
  }
}
    ${WishlistProduct_ProductFragmentDoc}`;

/**
 * __useTopPurchasesQuery__
 *
 * To run a query within a React component, call `useTopPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopPurchasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<TopPurchasesQuery, TopPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopPurchasesQuery, TopPurchasesQueryVariables>(TopPurchasesDocument, options);
      }
export function useTopPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopPurchasesQuery, TopPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopPurchasesQuery, TopPurchasesQueryVariables>(TopPurchasesDocument, options);
        }
export function useTopPurchasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopPurchasesQuery, TopPurchasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopPurchasesQuery, TopPurchasesQueryVariables>(TopPurchasesDocument, options);
        }
export type TopPurchasesQueryHookResult = ReturnType<typeof useTopPurchasesQuery>;
export type TopPurchasesLazyQueryHookResult = ReturnType<typeof useTopPurchasesLazyQuery>;
export type TopPurchasesSuspenseQueryHookResult = ReturnType<typeof useTopPurchasesSuspenseQuery>;
export type TopPurchasesQueryResult = Apollo.QueryResult<TopPurchasesQuery, TopPurchasesQueryVariables>;
export const TopPurchasesConfigDocument = gql`
    query TopPurchasesConfig {
  config {
    ...TopPurchaseConfig_Config
  }
}
    ${TopPurchaseConfig_ConfigFragmentDoc}`;

/**
 * __useTopPurchasesConfigQuery__
 *
 * To run a query within a React component, call `useTopPurchasesConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopPurchasesConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopPurchasesConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopPurchasesConfigQuery(baseOptions?: Apollo.QueryHookOptions<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>(TopPurchasesConfigDocument, options);
      }
export function useTopPurchasesConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>(TopPurchasesConfigDocument, options);
        }
export function useTopPurchasesConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>(TopPurchasesConfigDocument, options);
        }
export type TopPurchasesConfigQueryHookResult = ReturnType<typeof useTopPurchasesConfigQuery>;
export type TopPurchasesConfigLazyQueryHookResult = ReturnType<typeof useTopPurchasesConfigLazyQuery>;
export type TopPurchasesConfigSuspenseQueryHookResult = ReturnType<typeof useTopPurchasesConfigSuspenseQuery>;
export type TopPurchasesConfigQueryResult = Apollo.QueryResult<TopPurchasesConfigQuery, TopPurchasesConfigQueryVariables>;
export const GetCurrentUserInformationFormDocument = gql`
    query GetCurrentUserInformationForm {
  currentUser {
    id
    ...UserInformationForm_User
  }
}
    ${UserInformationForm_UserFragmentDoc}`;

/**
 * __useGetCurrentUserInformationFormQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserInformationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserInformationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserInformationFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserInformationFormQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>(GetCurrentUserInformationFormDocument, options);
      }
export function useGetCurrentUserInformationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>(GetCurrentUserInformationFormDocument, options);
        }
export function useGetCurrentUserInformationFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>(GetCurrentUserInformationFormDocument, options);
        }
export type GetCurrentUserInformationFormQueryHookResult = ReturnType<typeof useGetCurrentUserInformationFormQuery>;
export type GetCurrentUserInformationFormLazyQueryHookResult = ReturnType<typeof useGetCurrentUserInformationFormLazyQuery>;
export type GetCurrentUserInformationFormSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserInformationFormSuspenseQuery>;
export type GetCurrentUserInformationFormQueryResult = Apollo.QueryResult<GetCurrentUserInformationFormQuery, GetCurrentUserInformationFormQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($urlKey: String) {
  categories(urlKey: $urlKey) {
    categories {
      ...CategoriesSlider_Categories
    }
  }
}
    ${CategoriesSlider_CategoriesFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryImagesDocument = gql`
    query GetCategoryImages($urlKey: String) {
  categories(urlKey: $urlKey) {
    name
    categories {
      ...HubList_Categories
    }
  }
}
    ${HubList_CategoriesFragmentDoc}`;

/**
 * __useGetCategoryImagesQuery__
 *
 * To run a query within a React component, call `useGetCategoryImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryImagesQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetCategoryImagesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>(GetCategoryImagesDocument, options);
      }
export function useGetCategoryImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>(GetCategoryImagesDocument, options);
        }
export function useGetCategoryImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>(GetCategoryImagesDocument, options);
        }
export type GetCategoryImagesQueryHookResult = ReturnType<typeof useGetCategoryImagesQuery>;
export type GetCategoryImagesLazyQueryHookResult = ReturnType<typeof useGetCategoryImagesLazyQuery>;
export type GetCategoryImagesSuspenseQueryHookResult = ReturnType<typeof useGetCategoryImagesSuspenseQuery>;
export type GetCategoryImagesQueryResult = Apollo.QueryResult<GetCategoryImagesQuery, GetCategoryImagesQueryVariables>;
export const OurBrandsPageDocument = gql`
    query OurBrandsPage {
  brands {
    ...BrandsList_Brands
  }
}
    ${BrandsList_BrandsFragmentDoc}`;

/**
 * __useOurBrandsPageQuery__
 *
 * To run a query within a React component, call `useOurBrandsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOurBrandsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOurBrandsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useOurBrandsPageQuery(baseOptions?: Apollo.QueryHookOptions<OurBrandsPageQuery, OurBrandsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OurBrandsPageQuery, OurBrandsPageQueryVariables>(OurBrandsPageDocument, options);
      }
export function useOurBrandsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OurBrandsPageQuery, OurBrandsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OurBrandsPageQuery, OurBrandsPageQueryVariables>(OurBrandsPageDocument, options);
        }
export function useOurBrandsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OurBrandsPageQuery, OurBrandsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OurBrandsPageQuery, OurBrandsPageQueryVariables>(OurBrandsPageDocument, options);
        }
export type OurBrandsPageQueryHookResult = ReturnType<typeof useOurBrandsPageQuery>;
export type OurBrandsPageLazyQueryHookResult = ReturnType<typeof useOurBrandsPageLazyQuery>;
export type OurBrandsPageSuspenseQueryHookResult = ReturnType<typeof useOurBrandsPageSuspenseQuery>;
export type OurBrandsPageQueryResult = Apollo.QueryResult<OurBrandsPageQuery, OurBrandsPageQueryVariables>;
export const BrandListHeaderDocument = gql`
    query BrandListHeader($urlKey: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String) {
  brand(urlKey: $urlKey) {
    name
    description
    breadcrumbs {
      ...Breadcrumb_Path
    }
    logo {
      ...FullPicture
    }
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      productCount
    }
  }
}
    ${Breadcrumb_PathFragmentDoc}
${FullPictureFragmentDoc}`;

/**
 * __useBrandListHeaderQuery__
 *
 * To run a query within a React component, call `useBrandListHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListHeaderQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useBrandListHeaderQuery(baseOptions: Apollo.QueryHookOptions<BrandListHeaderQuery, BrandListHeaderQueryVariables> & ({ variables: BrandListHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandListHeaderQuery, BrandListHeaderQueryVariables>(BrandListHeaderDocument, options);
      }
export function useBrandListHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandListHeaderQuery, BrandListHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandListHeaderQuery, BrandListHeaderQueryVariables>(BrandListHeaderDocument, options);
        }
export function useBrandListHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandListHeaderQuery, BrandListHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandListHeaderQuery, BrandListHeaderQueryVariables>(BrandListHeaderDocument, options);
        }
export type BrandListHeaderQueryHookResult = ReturnType<typeof useBrandListHeaderQuery>;
export type BrandListHeaderLazyQueryHookResult = ReturnType<typeof useBrandListHeaderLazyQuery>;
export type BrandListHeaderSuspenseQueryHookResult = ReturnType<typeof useBrandListHeaderSuspenseQuery>;
export type BrandListHeaderQueryResult = Apollo.QueryResult<BrandListHeaderQuery, BrandListHeaderQueryVariables>;
export const ProductListBrandPageDocument = gql`
    query ProductListBrandPage($urlKey: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String) {
  brand(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListTemplate_ProductList
    }
  }
}
    ${ProductListTemplate_ProductListFragmentDoc}`;

/**
 * __useProductListBrandPageQuery__
 *
 * To run a query within a React component, call `useProductListBrandPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListBrandPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListBrandPageQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useProductListBrandPageQuery(baseOptions: Apollo.QueryHookOptions<ProductListBrandPageQuery, ProductListBrandPageQueryVariables> & ({ variables: ProductListBrandPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>(ProductListBrandPageDocument, options);
      }
export function useProductListBrandPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>(ProductListBrandPageDocument, options);
        }
export function useProductListBrandPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>(ProductListBrandPageDocument, options);
        }
export type ProductListBrandPageQueryHookResult = ReturnType<typeof useProductListBrandPageQuery>;
export type ProductListBrandPageLazyQueryHookResult = ReturnType<typeof useProductListBrandPageLazyQuery>;
export type ProductListBrandPageSuspenseQueryHookResult = ReturnType<typeof useProductListBrandPageSuspenseQuery>;
export type ProductListBrandPageQueryResult = Apollo.QueryResult<ProductListBrandPageQuery, ProductListBrandPageQueryVariables>;
export const ProductListBrandFiltersDocument = gql`
    query ProductListBrandFilters($urlKey: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String) {
  brand(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListTemplate_QueryFilters
    }
  }
}
    ${ProductListTemplate_QueryFiltersFragmentDoc}`;

/**
 * __useProductListBrandFiltersQuery__
 *
 * To run a query within a React component, call `useProductListBrandFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListBrandFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListBrandFiltersQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useProductListBrandFiltersQuery(baseOptions: Apollo.QueryHookOptions<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables> & ({ variables: ProductListBrandFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>(ProductListBrandFiltersDocument, options);
      }
export function useProductListBrandFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>(ProductListBrandFiltersDocument, options);
        }
export function useProductListBrandFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>(ProductListBrandFiltersDocument, options);
        }
export type ProductListBrandFiltersQueryHookResult = ReturnType<typeof useProductListBrandFiltersQuery>;
export type ProductListBrandFiltersLazyQueryHookResult = ReturnType<typeof useProductListBrandFiltersLazyQuery>;
export type ProductListBrandFiltersSuspenseQueryHookResult = ReturnType<typeof useProductListBrandFiltersSuspenseQuery>;
export type ProductListBrandFiltersQueryResult = Apollo.QueryResult<ProductListBrandFiltersQuery, ProductListBrandFiltersQueryVariables>;
export const ProductListBrandPageSeoContentDocument = gql`
    query ProductListBrandPageSeoContent($urlKey: String!) {
  brand(urlKey: $urlKey) {
    name
    description
  }
}
    `;

/**
 * __useProductListBrandPageSeoContentQuery__
 *
 * To run a query within a React component, call `useProductListBrandPageSeoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListBrandPageSeoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListBrandPageSeoContentQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductListBrandPageSeoContentQuery(baseOptions: Apollo.QueryHookOptions<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables> & ({ variables: ProductListBrandPageSeoContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>(ProductListBrandPageSeoContentDocument, options);
      }
export function useProductListBrandPageSeoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>(ProductListBrandPageSeoContentDocument, options);
        }
export function useProductListBrandPageSeoContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>(ProductListBrandPageSeoContentDocument, options);
        }
export type ProductListBrandPageSeoContentQueryHookResult = ReturnType<typeof useProductListBrandPageSeoContentQuery>;
export type ProductListBrandPageSeoContentLazyQueryHookResult = ReturnType<typeof useProductListBrandPageSeoContentLazyQuery>;
export type ProductListBrandPageSeoContentSuspenseQueryHookResult = ReturnType<typeof useProductListBrandPageSeoContentSuspenseQuery>;
export type ProductListBrandPageSeoContentQueryResult = Apollo.QueryResult<ProductListBrandPageSeoContentQuery, ProductListBrandPageSeoContentQueryVariables>;
export const ProductListEventQueryHeaderDocument = gql`
    query ProductListEventQueryHeader($urlKey: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String!) {
  event(urlKey: $urlKey) {
    breadcrumbs {
      ...Breadcrumb_Path
    }
    image {
      ...FullPicture
    }
    ...EventHeaderInformation_Event
  }
}
    ${Breadcrumb_PathFragmentDoc}
${FullPictureFragmentDoc}
${EventHeaderInformation_EventFragmentDoc}`;

/**
 * __useProductListEventQueryHeaderQuery__
 *
 * To run a query within a React component, call `useProductListEventQueryHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListEventQueryHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListEventQueryHeaderQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useProductListEventQueryHeaderQuery(baseOptions: Apollo.QueryHookOptions<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables> & ({ variables: ProductListEventQueryHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>(ProductListEventQueryHeaderDocument, options);
      }
export function useProductListEventQueryHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>(ProductListEventQueryHeaderDocument, options);
        }
export function useProductListEventQueryHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>(ProductListEventQueryHeaderDocument, options);
        }
export type ProductListEventQueryHeaderQueryHookResult = ReturnType<typeof useProductListEventQueryHeaderQuery>;
export type ProductListEventQueryHeaderLazyQueryHookResult = ReturnType<typeof useProductListEventQueryHeaderLazyQuery>;
export type ProductListEventQueryHeaderSuspenseQueryHookResult = ReturnType<typeof useProductListEventQueryHeaderSuspenseQuery>;
export type ProductListEventQueryHeaderQueryResult = Apollo.QueryResult<ProductListEventQueryHeaderQuery, ProductListEventQueryHeaderQueryVariables>;
export const ProductListEventProductsDocument = gql`
    query ProductListEventProducts($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  event(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListTemplate_ProductList
    }
  }
}
    ${ProductListTemplate_ProductListFragmentDoc}`;

/**
 * __useProductListEventProductsQuery__
 *
 * To run a query within a React component, call `useProductListEventProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListEventProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListEventProductsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListEventProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductListEventProductsQuery, ProductListEventProductsQueryVariables> & ({ variables: ProductListEventProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>(ProductListEventProductsDocument, options);
      }
export function useProductListEventProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>(ProductListEventProductsDocument, options);
        }
export function useProductListEventProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>(ProductListEventProductsDocument, options);
        }
export type ProductListEventProductsQueryHookResult = ReturnType<typeof useProductListEventProductsQuery>;
export type ProductListEventProductsLazyQueryHookResult = ReturnType<typeof useProductListEventProductsLazyQuery>;
export type ProductListEventProductsSuspenseQueryHookResult = ReturnType<typeof useProductListEventProductsSuspenseQuery>;
export type ProductListEventProductsQueryResult = Apollo.QueryResult<ProductListEventProductsQuery, ProductListEventProductsQueryVariables>;
export const ProductListEventFiltersDocument = gql`
    query ProductListEventFilters($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  event(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListFilters_Data
    }
  }
}
    ${ProductListFilters_DataFragmentDoc}`;

/**
 * __useProductListEventFiltersQuery__
 *
 * To run a query within a React component, call `useProductListEventFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListEventFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListEventFiltersQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListEventFiltersQuery(baseOptions: Apollo.QueryHookOptions<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables> & ({ variables: ProductListEventFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>(ProductListEventFiltersDocument, options);
      }
export function useProductListEventFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>(ProductListEventFiltersDocument, options);
        }
export function useProductListEventFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>(ProductListEventFiltersDocument, options);
        }
export type ProductListEventFiltersQueryHookResult = ReturnType<typeof useProductListEventFiltersQuery>;
export type ProductListEventFiltersLazyQueryHookResult = ReturnType<typeof useProductListEventFiltersLazyQuery>;
export type ProductListEventFiltersSuspenseQueryHookResult = ReturnType<typeof useProductListEventFiltersSuspenseQuery>;
export type ProductListEventFiltersQueryResult = Apollo.QueryResult<ProductListEventFiltersQuery, ProductListEventFiltersQueryVariables>;
export const ProductListEventFiltersExcludingCategoriesDocument = gql`
    query ProductListEventFiltersExcludingCategories($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  event(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      productActiveFilters {
        ...ProductListActiveFilters
      }
      productFilters {
        ...ProductListFilter
      }
    }
  }
}
    ${ProductListActiveFiltersFragmentDoc}
${ProductListFilterFragmentDoc}`;

/**
 * __useProductListEventFiltersExcludingCategoriesQuery__
 *
 * To run a query within a React component, call `useProductListEventFiltersExcludingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListEventFiltersExcludingCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListEventFiltersExcludingCategoriesQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListEventFiltersExcludingCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables> & ({ variables: ProductListEventFiltersExcludingCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>(ProductListEventFiltersExcludingCategoriesDocument, options);
      }
export function useProductListEventFiltersExcludingCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>(ProductListEventFiltersExcludingCategoriesDocument, options);
        }
export function useProductListEventFiltersExcludingCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>(ProductListEventFiltersExcludingCategoriesDocument, options);
        }
export type ProductListEventFiltersExcludingCategoriesQueryHookResult = ReturnType<typeof useProductListEventFiltersExcludingCategoriesQuery>;
export type ProductListEventFiltersExcludingCategoriesLazyQueryHookResult = ReturnType<typeof useProductListEventFiltersExcludingCategoriesLazyQuery>;
export type ProductListEventFiltersExcludingCategoriesSuspenseQueryHookResult = ReturnType<typeof useProductListEventFiltersExcludingCategoriesSuspenseQuery>;
export type ProductListEventFiltersExcludingCategoriesQueryResult = Apollo.QueryResult<ProductListEventFiltersExcludingCategoriesQuery, ProductListEventFiltersExcludingCategoriesQueryVariables>;
export const ProductListCategoryHeaderDocument = gql`
    query ProductListCategoryHeader($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  categories(urlKey: $urlKey) {
    name
    baseline
    code
    breadcrumbs {
      ...Breadcrumb_Path
    }
    seoContent
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      productCount
    }
  }
}
    ${Breadcrumb_PathFragmentDoc}`;

/**
 * __useProductListCategoryHeaderQuery__
 *
 * To run a query within a React component, call `useProductListCategoryHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListCategoryHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListCategoryHeaderQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListCategoryHeaderQuery(baseOptions: Apollo.QueryHookOptions<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables> & ({ variables: ProductListCategoryHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>(ProductListCategoryHeaderDocument, options);
      }
export function useProductListCategoryHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>(ProductListCategoryHeaderDocument, options);
        }
export function useProductListCategoryHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>(ProductListCategoryHeaderDocument, options);
        }
export type ProductListCategoryHeaderQueryHookResult = ReturnType<typeof useProductListCategoryHeaderQuery>;
export type ProductListCategoryHeaderLazyQueryHookResult = ReturnType<typeof useProductListCategoryHeaderLazyQuery>;
export type ProductListCategoryHeaderSuspenseQueryHookResult = ReturnType<typeof useProductListCategoryHeaderSuspenseQuery>;
export type ProductListCategoryHeaderQueryResult = Apollo.QueryResult<ProductListCategoryHeaderQuery, ProductListCategoryHeaderQueryVariables>;
export const GetUniverseBreadcrumbsDocument = gql`
    query GetUniverseBreadcrumbs($urlKey: String) {
  categories(urlKey: $urlKey) {
    breadcrumbs {
      ...Breadcrumb_Path
    }
  }
}
    ${Breadcrumb_PathFragmentDoc}`;

/**
 * __useGetUniverseBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useGetUniverseBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniverseBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniverseBreadcrumbsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetUniverseBreadcrumbsQuery(baseOptions?: Apollo.QueryHookOptions<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>(GetUniverseBreadcrumbsDocument, options);
      }
export function useGetUniverseBreadcrumbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>(GetUniverseBreadcrumbsDocument, options);
        }
export function useGetUniverseBreadcrumbsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>(GetUniverseBreadcrumbsDocument, options);
        }
export type GetUniverseBreadcrumbsQueryHookResult = ReturnType<typeof useGetUniverseBreadcrumbsQuery>;
export type GetUniverseBreadcrumbsLazyQueryHookResult = ReturnType<typeof useGetUniverseBreadcrumbsLazyQuery>;
export type GetUniverseBreadcrumbsSuspenseQueryHookResult = ReturnType<typeof useGetUniverseBreadcrumbsSuspenseQuery>;
export type GetUniverseBreadcrumbsQueryResult = Apollo.QueryResult<GetUniverseBreadcrumbsQuery, GetUniverseBreadcrumbsQueryVariables>;
export const UniversePageDocument = gql`
    query UniversePage($urlKey: String!) {
  categories(urlKey: $urlKey) {
    breadcrumbs {
      ...Breadcrumb_Path
    }
  }
}
    ${Breadcrumb_PathFragmentDoc}`;

/**
 * __useUniversePageQuery__
 *
 * To run a query within a React component, call `useUniversePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversePageQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useUniversePageQuery(baseOptions: Apollo.QueryHookOptions<UniversePageQuery, UniversePageQueryVariables> & ({ variables: UniversePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversePageQuery, UniversePageQueryVariables>(UniversePageDocument, options);
      }
export function useUniversePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversePageQuery, UniversePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversePageQuery, UniversePageQueryVariables>(UniversePageDocument, options);
        }
export function useUniversePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversePageQuery, UniversePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversePageQuery, UniversePageQueryVariables>(UniversePageDocument, options);
        }
export type UniversePageQueryHookResult = ReturnType<typeof useUniversePageQuery>;
export type UniversePageLazyQueryHookResult = ReturnType<typeof useUniversePageLazyQuery>;
export type UniversePageSuspenseQueryHookResult = ReturnType<typeof useUniversePageSuspenseQuery>;
export type UniversePageQueryResult = Apollo.QueryResult<UniversePageQuery, UniversePageQueryVariables>;
export const GetUniverseProductCountDocument = gql`
    query GetUniverseProductCount($urlKey: String) {
  categories(urlKey: $urlKey) {
    productList {
      productCount
    }
  }
}
    `;

/**
 * __useGetUniverseProductCountQuery__
 *
 * To run a query within a React component, call `useGetUniverseProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniverseProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniverseProductCountQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetUniverseProductCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>(GetUniverseProductCountDocument, options);
      }
export function useGetUniverseProductCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>(GetUniverseProductCountDocument, options);
        }
export function useGetUniverseProductCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>(GetUniverseProductCountDocument, options);
        }
export type GetUniverseProductCountQueryHookResult = ReturnType<typeof useGetUniverseProductCountQuery>;
export type GetUniverseProductCountLazyQueryHookResult = ReturnType<typeof useGetUniverseProductCountLazyQuery>;
export type GetUniverseProductCountSuspenseQueryHookResult = ReturnType<typeof useGetUniverseProductCountSuspenseQuery>;
export type GetUniverseProductCountQueryResult = Apollo.QueryResult<GetUniverseProductCountQuery, GetUniverseProductCountQueryVariables>;
export const ProductListCategoryMetadataDocument = gql`
    query ProductListCategoryMetadata($urlKey: String!, $pageSize: Int!) {
  categories(urlKey: $urlKey) {
    name
    urlKey
    seoContent
    code
    productList(pageIndex: 1, pageSize: $pageSize) {
      productCount
    }
  }
}
    `;

/**
 * __useProductListCategoryMetadataQuery__
 *
 * To run a query within a React component, call `useProductListCategoryMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListCategoryMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListCategoryMetadataQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListCategoryMetadataQuery(baseOptions: Apollo.QueryHookOptions<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables> & ({ variables: ProductListCategoryMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>(ProductListCategoryMetadataDocument, options);
      }
export function useProductListCategoryMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>(ProductListCategoryMetadataDocument, options);
        }
export function useProductListCategoryMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>(ProductListCategoryMetadataDocument, options);
        }
export type ProductListCategoryMetadataQueryHookResult = ReturnType<typeof useProductListCategoryMetadataQuery>;
export type ProductListCategoryMetadataLazyQueryHookResult = ReturnType<typeof useProductListCategoryMetadataLazyQuery>;
export type ProductListCategoryMetadataSuspenseQueryHookResult = ReturnType<typeof useProductListCategoryMetadataSuspenseQuery>;
export type ProductListCategoryMetadataQueryResult = Apollo.QueryResult<ProductListCategoryMetadataQuery, ProductListCategoryMetadataQueryVariables>;
export const GetSearchResultHeaderDocument = gql`
    query GetSearchResultHeader($search: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String!) {
  searchList(search: $search) {
    categories {
      ...CategoriesSlider_Categories
    }
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      productCount
    }
  }
}
    ${CategoriesSlider_CategoriesFragmentDoc}`;

/**
 * __useGetSearchResultHeaderQuery__
 *
 * To run a query within a React component, call `useGetSearchResultHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultHeaderQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useGetSearchResultHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables> & ({ variables: GetSearchResultHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>(GetSearchResultHeaderDocument, options);
      }
export function useGetSearchResultHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>(GetSearchResultHeaderDocument, options);
        }
export function useGetSearchResultHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>(GetSearchResultHeaderDocument, options);
        }
export type GetSearchResultHeaderQueryHookResult = ReturnType<typeof useGetSearchResultHeaderQuery>;
export type GetSearchResultHeaderLazyQueryHookResult = ReturnType<typeof useGetSearchResultHeaderLazyQuery>;
export type GetSearchResultHeaderSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultHeaderSuspenseQuery>;
export type GetSearchResultHeaderQueryResult = Apollo.QueryResult<GetSearchResultHeaderQuery, GetSearchResultHeaderQueryVariables>;
export const GetSearchResultCountDocument = gql`
    query GetSearchResultCount($search: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String!) {
  searchList(search: $search) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      productCount
      products {
        urlKey
      }
    }
  }
}
    `;

/**
 * __useGetSearchResultCountQuery__
 *
 * To run a query within a React component, call `useGetSearchResultCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useGetSearchResultCountQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultCountQuery, GetSearchResultCountQueryVariables> & ({ variables: GetSearchResultCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>(GetSearchResultCountDocument, options);
      }
export function useGetSearchResultCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>(GetSearchResultCountDocument, options);
        }
export function useGetSearchResultCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>(GetSearchResultCountDocument, options);
        }
export type GetSearchResultCountQueryHookResult = ReturnType<typeof useGetSearchResultCountQuery>;
export type GetSearchResultCountLazyQueryHookResult = ReturnType<typeof useGetSearchResultCountLazyQuery>;
export type GetSearchResultCountSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultCountSuspenseQuery>;
export type GetSearchResultCountQueryResult = Apollo.QueryResult<GetSearchResultCountQuery, GetSearchResultCountQueryVariables>;
export const GetSearchResultDocument = gql`
    query GetSearchResult($search: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String!) {
  searchList(search: $search) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListTemplate_ProductList
    }
  }
}
    ${ProductListTemplate_ProductListFragmentDoc}`;

/**
 * __useGetSearchResultQuery__
 *
 * To run a query within a React component, call `useGetSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useGetSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultQuery, GetSearchResultQueryVariables> & ({ variables: GetSearchResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultQuery, GetSearchResultQueryVariables>(GetSearchResultDocument, options);
      }
export function useGetSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultQuery, GetSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultQuery, GetSearchResultQueryVariables>(GetSearchResultDocument, options);
        }
export function useGetSearchResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultQuery, GetSearchResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchResultQuery, GetSearchResultQueryVariables>(GetSearchResultDocument, options);
        }
export type GetSearchResultQueryHookResult = ReturnType<typeof useGetSearchResultQuery>;
export type GetSearchResultLazyQueryHookResult = ReturnType<typeof useGetSearchResultLazyQuery>;
export type GetSearchResultSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultSuspenseQuery>;
export type GetSearchResultQueryResult = Apollo.QueryResult<GetSearchResultQuery, GetSearchResultQueryVariables>;
export const GetSearchFiltersDocument = gql`
    query GetSearchFilters($search: String!, $pageIndex: Int!, $pageSize: Int!, $requestFilter: String!) {
  searchList(search: $search) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListFilters_Data
    }
  }
}
    ${ProductListFilters_DataFragmentDoc}`;

/**
 * __useGetSearchFiltersQuery__
 *
 * To run a query within a React component, call `useGetSearchFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFiltersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      requestFilter: // value for 'requestFilter'
 *   },
 * });
 */
export function useGetSearchFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetSearchFiltersQuery, GetSearchFiltersQueryVariables> & ({ variables: GetSearchFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>(GetSearchFiltersDocument, options);
      }
export function useGetSearchFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>(GetSearchFiltersDocument, options);
        }
export function useGetSearchFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>(GetSearchFiltersDocument, options);
        }
export type GetSearchFiltersQueryHookResult = ReturnType<typeof useGetSearchFiltersQuery>;
export type GetSearchFiltersLazyQueryHookResult = ReturnType<typeof useGetSearchFiltersLazyQuery>;
export type GetSearchFiltersSuspenseQueryHookResult = ReturnType<typeof useGetSearchFiltersSuspenseQuery>;
export type GetSearchFiltersQueryResult = Apollo.QueryResult<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>;
export const SearchTargetUrlDocument = gql`
    query SearchTargetUrl($query: String!) {
  search(query: $query) {
    targetUrl
  }
}
    `;

/**
 * __useSearchTargetUrlQuery__
 *
 * To run a query within a React component, call `useSearchTargetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTargetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTargetUrlQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTargetUrlQuery(baseOptions: Apollo.QueryHookOptions<SearchTargetUrlQuery, SearchTargetUrlQueryVariables> & ({ variables: SearchTargetUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>(SearchTargetUrlDocument, options);
      }
export function useSearchTargetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>(SearchTargetUrlDocument, options);
        }
export function useSearchTargetUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>(SearchTargetUrlDocument, options);
        }
export type SearchTargetUrlQueryHookResult = ReturnType<typeof useSearchTargetUrlQuery>;
export type SearchTargetUrlLazyQueryHookResult = ReturnType<typeof useSearchTargetUrlLazyQuery>;
export type SearchTargetUrlSuspenseQueryHookResult = ReturnType<typeof useSearchTargetUrlSuspenseQuery>;
export type SearchTargetUrlQueryResult = Apollo.QueryResult<SearchTargetUrlQuery, SearchTargetUrlQueryVariables>;
export const ProductPageBreadcrumbsDocument = gql`
    query ProductPageBreadcrumbs($urlKey: String!) {
  product(urlKey: $urlKey) {
    breadcrumbs {
      ...Breadcrumb_Path
    }
  }
}
    ${Breadcrumb_PathFragmentDoc}`;

/**
 * __useProductPageBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useProductPageBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageBreadcrumbsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductPageBreadcrumbsQuery(baseOptions: Apollo.QueryHookOptions<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables> & ({ variables: ProductPageBreadcrumbsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>(ProductPageBreadcrumbsDocument, options);
      }
export function useProductPageBreadcrumbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>(ProductPageBreadcrumbsDocument, options);
        }
export function useProductPageBreadcrumbsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>(ProductPageBreadcrumbsDocument, options);
        }
export type ProductPageBreadcrumbsQueryHookResult = ReturnType<typeof useProductPageBreadcrumbsQuery>;
export type ProductPageBreadcrumbsLazyQueryHookResult = ReturnType<typeof useProductPageBreadcrumbsLazyQuery>;
export type ProductPageBreadcrumbsSuspenseQueryHookResult = ReturnType<typeof useProductPageBreadcrumbsSuspenseQuery>;
export type ProductPageBreadcrumbsQueryResult = Apollo.QueryResult<ProductPageBreadcrumbsQuery, ProductPageBreadcrumbsQueryVariables>;
export const GetEquivalentProductsDocument = gql`
    query GetEquivalentProducts($urlKey: String!) {
  product(urlKey: $urlKey) {
    type
    reference
    ...EquivalentProductFieldsWithoutPrice
    equivalentProducts {
      ...EquivalentProductFieldsWithoutPrice
    }
  }
}
    ${EquivalentProductFieldsWithoutPriceFragmentDoc}`;

/**
 * __useGetEquivalentProductsQuery__
 *
 * To run a query within a React component, call `useGetEquivalentProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquivalentProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquivalentProductsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetEquivalentProductsQuery(baseOptions: Apollo.QueryHookOptions<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables> & ({ variables: GetEquivalentProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>(GetEquivalentProductsDocument, options);
      }
export function useGetEquivalentProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>(GetEquivalentProductsDocument, options);
        }
export function useGetEquivalentProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>(GetEquivalentProductsDocument, options);
        }
export type GetEquivalentProductsQueryHookResult = ReturnType<typeof useGetEquivalentProductsQuery>;
export type GetEquivalentProductsLazyQueryHookResult = ReturnType<typeof useGetEquivalentProductsLazyQuery>;
export type GetEquivalentProductsSuspenseQueryHookResult = ReturnType<typeof useGetEquivalentProductsSuspenseQuery>;
export type GetEquivalentProductsQueryResult = Apollo.QueryResult<GetEquivalentProductsQuery, GetEquivalentProductsQueryVariables>;
export const GetEquivalentProductsPriceAndStockDocument = gql`
    query GetEquivalentProductsPriceAndStock($references: [String!]!) {
  productsByReferences(references: $references) {
    ...ProductCard_ProductPriceAndStock
  }
}
    ${ProductCard_ProductPriceAndStockFragmentDoc}`;

/**
 * __useGetEquivalentProductsPriceAndStockQuery__
 *
 * To run a query within a React component, call `useGetEquivalentProductsPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquivalentProductsPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquivalentProductsPriceAndStockQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useGetEquivalentProductsPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables> & ({ variables: GetEquivalentProductsPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>(GetEquivalentProductsPriceAndStockDocument, options);
      }
export function useGetEquivalentProductsPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>(GetEquivalentProductsPriceAndStockDocument, options);
        }
export function useGetEquivalentProductsPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>(GetEquivalentProductsPriceAndStockDocument, options);
        }
export type GetEquivalentProductsPriceAndStockQueryHookResult = ReturnType<typeof useGetEquivalentProductsPriceAndStockQuery>;
export type GetEquivalentProductsPriceAndStockLazyQueryHookResult = ReturnType<typeof useGetEquivalentProductsPriceAndStockLazyQuery>;
export type GetEquivalentProductsPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useGetEquivalentProductsPriceAndStockSuspenseQuery>;
export type GetEquivalentProductsPriceAndStockQueryResult = Apollo.QueryResult<GetEquivalentProductsPriceAndStockQuery, GetEquivalentProductsPriceAndStockQueryVariables>;
export const GetProductBundleDataDocument = gql`
    query GetProductBundleData($urlKey: String!) {
  product(urlKey: $urlKey) {
    canAddToCart
    stock {
      isSellable
    }
    bundle {
      ...ProductCardBase
    }
  }
}
    ${ProductCardBaseFragmentDoc}`;

/**
 * __useGetProductBundleDataQuery__
 *
 * To run a query within a React component, call `useGetProductBundleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductBundleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductBundleDataQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetProductBundleDataQuery(baseOptions: Apollo.QueryHookOptions<GetProductBundleDataQuery, GetProductBundleDataQueryVariables> & ({ variables: GetProductBundleDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>(GetProductBundleDataDocument, options);
      }
export function useGetProductBundleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>(GetProductBundleDataDocument, options);
        }
export function useGetProductBundleDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>(GetProductBundleDataDocument, options);
        }
export type GetProductBundleDataQueryHookResult = ReturnType<typeof useGetProductBundleDataQuery>;
export type GetProductBundleDataLazyQueryHookResult = ReturnType<typeof useGetProductBundleDataLazyQuery>;
export type GetProductBundleDataSuspenseQueryHookResult = ReturnType<typeof useGetProductBundleDataSuspenseQuery>;
export type GetProductBundleDataQueryResult = Apollo.QueryResult<GetProductBundleDataQuery, GetProductBundleDataQueryVariables>;
export const GetProductBundlePriceAndStockDocument = gql`
    query GetProductBundlePriceAndStock($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    ...ProductCard_ProductPriceAndStock
  }
}
    ${ProductCard_ProductPriceAndStockFragmentDoc}`;

/**
 * __useGetProductBundlePriceAndStockQuery__
 *
 * To run a query within a React component, call `useGetProductBundlePriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductBundlePriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductBundlePriceAndStockQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useGetProductBundlePriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables> & ({ variables: GetProductBundlePriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>(GetProductBundlePriceAndStockDocument, options);
      }
export function useGetProductBundlePriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>(GetProductBundlePriceAndStockDocument, options);
        }
export function useGetProductBundlePriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>(GetProductBundlePriceAndStockDocument, options);
        }
export type GetProductBundlePriceAndStockQueryHookResult = ReturnType<typeof useGetProductBundlePriceAndStockQuery>;
export type GetProductBundlePriceAndStockLazyQueryHookResult = ReturnType<typeof useGetProductBundlePriceAndStockLazyQuery>;
export type GetProductBundlePriceAndStockSuspenseQueryHookResult = ReturnType<typeof useGetProductBundlePriceAndStockSuspenseQuery>;
export type GetProductBundlePriceAndStockQueryResult = Apollo.QueryResult<GetProductBundlePriceAndStockQuery, GetProductBundlePriceAndStockQueryVariables>;
export const ProductBundle_CartDocument = gql`
    query ProductBundle_Cart {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useProductBundle_CartQuery__
 *
 * To run a query within a React component, call `useProductBundle_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBundle_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBundle_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBundle_CartQuery(baseOptions?: Apollo.QueryHookOptions<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>(ProductBundle_CartDocument, options);
      }
export function useProductBundle_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>(ProductBundle_CartDocument, options);
        }
export function useProductBundle_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>(ProductBundle_CartDocument, options);
        }
export type ProductBundle_CartQueryHookResult = ReturnType<typeof useProductBundle_CartQuery>;
export type ProductBundle_CartLazyQueryHookResult = ReturnType<typeof useProductBundle_CartLazyQuery>;
export type ProductBundle_CartSuspenseQueryHookResult = ReturnType<typeof useProductBundle_CartSuspenseQuery>;
export type ProductBundle_CartQueryResult = Apollo.QueryResult<ProductBundle_CartQuery, ProductBundle_CartQueryVariables>;
export const ProductDetailsDocument = gql`
    query ProductDetails($urlKey: String!) {
  product(urlKey: $urlKey) {
    ...ProductDetail_Product
  }
}
    ${ProductDetail_ProductFragmentDoc}`;

/**
 * __useProductDetailsQuery__
 *
 * To run a query within a React component, call `useProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables> & ({ variables: ProductDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(ProductDetailsDocument, options);
      }
export function useProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(ProductDetailsDocument, options);
        }
export function useProductDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(ProductDetailsDocument, options);
        }
export type ProductDetailsQueryHookResult = ReturnType<typeof useProductDetailsQuery>;
export type ProductDetailsLazyQueryHookResult = ReturnType<typeof useProductDetailsLazyQuery>;
export type ProductDetailsSuspenseQueryHookResult = ReturnType<typeof useProductDetailsSuspenseQuery>;
export type ProductDetailsQueryResult = Apollo.QueryResult<ProductDetailsQuery, ProductDetailsQueryVariables>;
export const ProductPageCurrentUserDocument = gql`
    query ProductPageCurrentUser($pickupPointOfSaleId: String!) {
  currentUser {
    checkout {
      cart {
        ...ProductBuyBox_Cart
      }
    }
    favoritePointOfSale {
      ...ProductBuyBox_FavoritePointOfSale
    }
  }
  pickupPointOfSale: pointOfSale(pointOfSaleId: $pickupPointOfSaleId) {
    ...ProductAvailabilities_PickupPointOfSale
  }
}
    ${ProductBuyBox_CartFragmentDoc}
${ProductBuyBox_FavoritePointOfSaleFragmentDoc}
${ProductAvailabilities_PickupPointOfSaleFragmentDoc}`;

/**
 * __useProductPageCurrentUserQuery__
 *
 * To run a query within a React component, call `useProductPageCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageCurrentUserQuery({
 *   variables: {
 *      pickupPointOfSaleId: // value for 'pickupPointOfSaleId'
 *   },
 * });
 */
export function useProductPageCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables> & ({ variables: ProductPageCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>(ProductPageCurrentUserDocument, options);
      }
export function useProductPageCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>(ProductPageCurrentUserDocument, options);
        }
export function useProductPageCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>(ProductPageCurrentUserDocument, options);
        }
export type ProductPageCurrentUserQueryHookResult = ReturnType<typeof useProductPageCurrentUserQuery>;
export type ProductPageCurrentUserLazyQueryHookResult = ReturnType<typeof useProductPageCurrentUserLazyQuery>;
export type ProductPageCurrentUserSuspenseQueryHookResult = ReturnType<typeof useProductPageCurrentUserSuspenseQuery>;
export type ProductPageCurrentUserQueryResult = Apollo.QueryResult<ProductPageCurrentUserQuery, ProductPageCurrentUserQueryVariables>;
export const ProductJsonLdBaseDocument = gql`
    query ProductJsonLdBase($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    name
    description
    images {
      ...FullPicture
    }
  }
}
    ${FullPictureFragmentDoc}`;

/**
 * __useProductJsonLdBaseQuery__
 *
 * To run a query within a React component, call `useProductJsonLdBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductJsonLdBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductJsonLdBaseQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductJsonLdBaseQuery(baseOptions: Apollo.QueryHookOptions<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables> & ({ variables: ProductJsonLdBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>(ProductJsonLdBaseDocument, options);
      }
export function useProductJsonLdBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>(ProductJsonLdBaseDocument, options);
        }
export function useProductJsonLdBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>(ProductJsonLdBaseDocument, options);
        }
export type ProductJsonLdBaseQueryHookResult = ReturnType<typeof useProductJsonLdBaseQuery>;
export type ProductJsonLdBaseLazyQueryHookResult = ReturnType<typeof useProductJsonLdBaseLazyQuery>;
export type ProductJsonLdBaseSuspenseQueryHookResult = ReturnType<typeof useProductJsonLdBaseSuspenseQuery>;
export type ProductJsonLdBaseQueryResult = Apollo.QueryResult<ProductJsonLdBaseQuery, ProductJsonLdBaseQueryVariables>;
export const ProductJsonLdPriceAndStockDocument = gql`
    query ProductJsonLdPriceAndStock($reference: String!) {
  productsByReferences(references: [$reference]) {
    reference
    price {
      exclTax
    }
    canAddToCart
    bestArticlePrice
  }
}
    `;

/**
 * __useProductJsonLdPriceAndStockQuery__
 *
 * To run a query within a React component, call `useProductJsonLdPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductJsonLdPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductJsonLdPriceAndStockQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductJsonLdPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables> & ({ variables: ProductJsonLdPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>(ProductJsonLdPriceAndStockDocument, options);
      }
export function useProductJsonLdPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>(ProductJsonLdPriceAndStockDocument, options);
        }
export function useProductJsonLdPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>(ProductJsonLdPriceAndStockDocument, options);
        }
export type ProductJsonLdPriceAndStockQueryHookResult = ReturnType<typeof useProductJsonLdPriceAndStockQuery>;
export type ProductJsonLdPriceAndStockLazyQueryHookResult = ReturnType<typeof useProductJsonLdPriceAndStockLazyQuery>;
export type ProductJsonLdPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useProductJsonLdPriceAndStockSuspenseQuery>;
export type ProductJsonLdPriceAndStockQueryResult = Apollo.QueryResult<ProductJsonLdPriceAndStockQuery, ProductJsonLdPriceAndStockQueryVariables>;
export const ProductPageTracking_ProductBundleDocument = gql`
    query ProductPageTracking_ProductBundle($reference: String!) {
  productByReference(reference: $reference) {
    reference
    bundle {
      name
      reference
      stock {
        availability
      }
    }
  }
}
    `;

/**
 * __useProductPageTracking_ProductBundleQuery__
 *
 * To run a query within a React component, call `useProductPageTracking_ProductBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageTracking_ProductBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageTracking_ProductBundleQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductPageTracking_ProductBundleQuery(baseOptions: Apollo.QueryHookOptions<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables> & ({ variables: ProductPageTracking_ProductBundleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>(ProductPageTracking_ProductBundleDocument, options);
      }
export function useProductPageTracking_ProductBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>(ProductPageTracking_ProductBundleDocument, options);
        }
export function useProductPageTracking_ProductBundleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>(ProductPageTracking_ProductBundleDocument, options);
        }
export type ProductPageTracking_ProductBundleQueryHookResult = ReturnType<typeof useProductPageTracking_ProductBundleQuery>;
export type ProductPageTracking_ProductBundleLazyQueryHookResult = ReturnType<typeof useProductPageTracking_ProductBundleLazyQuery>;
export type ProductPageTracking_ProductBundleSuspenseQueryHookResult = ReturnType<typeof useProductPageTracking_ProductBundleSuspenseQuery>;
export type ProductPageTracking_ProductBundleQueryResult = Apollo.QueryResult<ProductPageTracking_ProductBundleQuery, ProductPageTracking_ProductBundleQueryVariables>;
export const ProductPageTracking_ProductDocument = gql`
    query ProductPageTracking_Product($urlKey: String!) {
  product(urlKey: $urlKey) {
    ...ProductPageAnalytics_Product
  }
}
    ${ProductPageAnalytics_ProductFragmentDoc}`;

/**
 * __useProductPageTracking_ProductQuery__
 *
 * To run a query within a React component, call `useProductPageTracking_ProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageTracking_ProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageTracking_ProductQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductPageTracking_ProductQuery(baseOptions: Apollo.QueryHookOptions<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables> & ({ variables: ProductPageTracking_ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>(ProductPageTracking_ProductDocument, options);
      }
export function useProductPageTracking_ProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>(ProductPageTracking_ProductDocument, options);
        }
export function useProductPageTracking_ProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>(ProductPageTracking_ProductDocument, options);
        }
export type ProductPageTracking_ProductQueryHookResult = ReturnType<typeof useProductPageTracking_ProductQuery>;
export type ProductPageTracking_ProductLazyQueryHookResult = ReturnType<typeof useProductPageTracking_ProductLazyQuery>;
export type ProductPageTracking_ProductSuspenseQueryHookResult = ReturnType<typeof useProductPageTracking_ProductSuspenseQuery>;
export type ProductPageTracking_ProductQueryResult = Apollo.QueryResult<ProductPageTracking_ProductQuery, ProductPageTracking_ProductQueryVariables>;
export const ProductPageTracking_ProductWithReferenceDocument = gql`
    query ProductPageTracking_ProductWithReference($reference: String!) {
  productByReference(reference: $reference) {
    ...ProductPageAnalytics_Product
  }
}
    ${ProductPageAnalytics_ProductFragmentDoc}`;

/**
 * __useProductPageTracking_ProductWithReferenceQuery__
 *
 * To run a query within a React component, call `useProductPageTracking_ProductWithReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageTracking_ProductWithReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageTracking_ProductWithReferenceQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductPageTracking_ProductWithReferenceQuery(baseOptions: Apollo.QueryHookOptions<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables> & ({ variables: ProductPageTracking_ProductWithReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>(ProductPageTracking_ProductWithReferenceDocument, options);
      }
export function useProductPageTracking_ProductWithReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>(ProductPageTracking_ProductWithReferenceDocument, options);
        }
export function useProductPageTracking_ProductWithReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>(ProductPageTracking_ProductWithReferenceDocument, options);
        }
export type ProductPageTracking_ProductWithReferenceQueryHookResult = ReturnType<typeof useProductPageTracking_ProductWithReferenceQuery>;
export type ProductPageTracking_ProductWithReferenceLazyQueryHookResult = ReturnType<typeof useProductPageTracking_ProductWithReferenceLazyQuery>;
export type ProductPageTracking_ProductWithReferenceSuspenseQueryHookResult = ReturnType<typeof useProductPageTracking_ProductWithReferenceSuspenseQuery>;
export type ProductPageTracking_ProductWithReferenceQueryResult = Apollo.QueryResult<ProductPageTracking_ProductWithReferenceQuery, ProductPageTracking_ProductWithReferenceQueryVariables>;
export const ProductPageTracking_ProductPriceAndStockDocument = gql`
    query ProductPageTracking_ProductPriceAndStock($reference: String!) {
  productByReference(reference: $reference) {
    reference
    price {
      exclTax
    }
    parentReference
    stock {
      availability
    }
    canAddToCart
    bestArticlePrice
    analytics {
      promotionStatus
      profileCase
    }
  }
}
    `;

/**
 * __useProductPageTracking_ProductPriceAndStockQuery__
 *
 * To run a query within a React component, call `useProductPageTracking_ProductPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageTracking_ProductPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageTracking_ProductPriceAndStockQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductPageTracking_ProductPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables> & ({ variables: ProductPageTracking_ProductPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>(ProductPageTracking_ProductPriceAndStockDocument, options);
      }
export function useProductPageTracking_ProductPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>(ProductPageTracking_ProductPriceAndStockDocument, options);
        }
export function useProductPageTracking_ProductPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>(ProductPageTracking_ProductPriceAndStockDocument, options);
        }
export type ProductPageTracking_ProductPriceAndStockQueryHookResult = ReturnType<typeof useProductPageTracking_ProductPriceAndStockQuery>;
export type ProductPageTracking_ProductPriceAndStockLazyQueryHookResult = ReturnType<typeof useProductPageTracking_ProductPriceAndStockLazyQuery>;
export type ProductPageTracking_ProductPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useProductPageTracking_ProductPriceAndStockSuspenseQuery>;
export type ProductPageTracking_ProductPriceAndStockQueryResult = Apollo.QueryResult<ProductPageTracking_ProductPriceAndStockQuery, ProductPageTracking_ProductPriceAndStockQueryVariables>;
export const ProductPageProductNavigationDocument = gql`
    query ProductPageProductNavigation($urlKey: String!) {
  product(urlKey: $urlKey) {
    urlKey
    parentUrlKey
    reference
  }
}
    `;

/**
 * __useProductPageProductNavigationQuery__
 *
 * To run a query within a React component, call `useProductPageProductNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageProductNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageProductNavigationQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductPageProductNavigationQuery(baseOptions: Apollo.QueryHookOptions<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables> & ({ variables: ProductPageProductNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>(ProductPageProductNavigationDocument, options);
      }
export function useProductPageProductNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>(ProductPageProductNavigationDocument, options);
        }
export function useProductPageProductNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>(ProductPageProductNavigationDocument, options);
        }
export type ProductPageProductNavigationQueryHookResult = ReturnType<typeof useProductPageProductNavigationQuery>;
export type ProductPageProductNavigationLazyQueryHookResult = ReturnType<typeof useProductPageProductNavigationLazyQuery>;
export type ProductPageProductNavigationSuspenseQueryHookResult = ReturnType<typeof useProductPageProductNavigationSuspenseQuery>;
export type ProductPageProductNavigationQueryResult = Apollo.QueryResult<ProductPageProductNavigationQuery, ProductPageProductNavigationQueryVariables>;
export const ProductPageProductMetadataDocument = gql`
    query ProductPageProductMetadata($urlKey: String!) {
  product(urlKey: $urlKey) {
    name
    mainImage {
      set {
        url
      }
    }
    brand {
      name
      urlKey
    }
  }
}
    `;

/**
 * __useProductPageProductMetadataQuery__
 *
 * To run a query within a React component, call `useProductPageProductMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageProductMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageProductMetadataQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductPageProductMetadataQuery(baseOptions: Apollo.QueryHookOptions<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables> & ({ variables: ProductPageProductMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>(ProductPageProductMetadataDocument, options);
      }
export function useProductPageProductMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>(ProductPageProductMetadataDocument, options);
        }
export function useProductPageProductMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>(ProductPageProductMetadataDocument, options);
        }
export type ProductPageProductMetadataQueryHookResult = ReturnType<typeof useProductPageProductMetadataQuery>;
export type ProductPageProductMetadataLazyQueryHookResult = ReturnType<typeof useProductPageProductMetadataLazyQuery>;
export type ProductPageProductMetadataSuspenseQueryHookResult = ReturnType<typeof useProductPageProductMetadataSuspenseQuery>;
export type ProductPageProductMetadataQueryResult = Apollo.QueryResult<ProductPageProductMetadataQuery, ProductPageProductMetadataQueryVariables>;
export const ProductPageProductAnomaliesDocument = gql`
    query ProductPageProductAnomalies {
  productAnomalies {
    name
    value
    categories {
      name
      value
    }
  }
}
    `;

/**
 * __useProductPageProductAnomaliesQuery__
 *
 * To run a query within a React component, call `useProductPageProductAnomaliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageProductAnomaliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageProductAnomaliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPageProductAnomaliesQuery(baseOptions?: Apollo.QueryHookOptions<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>(ProductPageProductAnomaliesDocument, options);
      }
export function useProductPageProductAnomaliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>(ProductPageProductAnomaliesDocument, options);
        }
export function useProductPageProductAnomaliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>(ProductPageProductAnomaliesDocument, options);
        }
export type ProductPageProductAnomaliesQueryHookResult = ReturnType<typeof useProductPageProductAnomaliesQuery>;
export type ProductPageProductAnomaliesLazyQueryHookResult = ReturnType<typeof useProductPageProductAnomaliesLazyQuery>;
export type ProductPageProductAnomaliesSuspenseQueryHookResult = ReturnType<typeof useProductPageProductAnomaliesSuspenseQuery>;
export type ProductPageProductAnomaliesQueryResult = Apollo.QueryResult<ProductPageProductAnomaliesQuery, ProductPageProductAnomaliesQueryVariables>;
export const GetUserRootCompanyDocument = gql`
    query GetUserRootCompany {
  currentUser {
    id
    company {
      id
      pointOfSale {
        id
        name
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useGetUserRootCompanyQuery__
 *
 * To run a query within a React component, call `useGetUserRootCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRootCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRootCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRootCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>(GetUserRootCompanyDocument, options);
      }
export function useGetUserRootCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>(GetUserRootCompanyDocument, options);
        }
export function useGetUserRootCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>(GetUserRootCompanyDocument, options);
        }
export type GetUserRootCompanyQueryHookResult = ReturnType<typeof useGetUserRootCompanyQuery>;
export type GetUserRootCompanyLazyQueryHookResult = ReturnType<typeof useGetUserRootCompanyLazyQuery>;
export type GetUserRootCompanySuspenseQueryHookResult = ReturnType<typeof useGetUserRootCompanySuspenseQuery>;
export type GetUserRootCompanyQueryResult = Apollo.QueryResult<GetUserRootCompanyQuery, GetUserRootCompanyQueryVariables>;
export const GetCurrentUserLoyaltyDocument = gql`
    query GetCurrentUserLoyalty {
  currentUser {
    id
    loyalty {
      data {
        active
        customerStatus
        state
      }
      status
    }
  }
}
    `;

/**
 * __useGetCurrentUserLoyaltyQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserLoyaltyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserLoyaltyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserLoyaltyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserLoyaltyQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>(GetCurrentUserLoyaltyDocument, options);
      }
export function useGetCurrentUserLoyaltyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>(GetCurrentUserLoyaltyDocument, options);
        }
export function useGetCurrentUserLoyaltySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>(GetCurrentUserLoyaltyDocument, options);
        }
export type GetCurrentUserLoyaltyQueryHookResult = ReturnType<typeof useGetCurrentUserLoyaltyQuery>;
export type GetCurrentUserLoyaltyLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLoyaltyLazyQuery>;
export type GetCurrentUserLoyaltySuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserLoyaltySuspenseQuery>;
export type GetCurrentUserLoyaltyQueryResult = Apollo.QueryResult<GetCurrentUserLoyaltyQuery, GetCurrentUserLoyaltyQueryVariables>;
export const GetCmsLoyaltyConfigDocument = gql`
    query getCmsLoyaltyConfig {
  config {
    loyalty {
      isEnabled
    }
  }
}
    `;

/**
 * __useGetCmsLoyaltyConfigQuery__
 *
 * To run a query within a React component, call `useGetCmsLoyaltyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsLoyaltyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsLoyaltyConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCmsLoyaltyConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>(GetCmsLoyaltyConfigDocument, options);
      }
export function useGetCmsLoyaltyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>(GetCmsLoyaltyConfigDocument, options);
        }
export function useGetCmsLoyaltyConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>(GetCmsLoyaltyConfigDocument, options);
        }
export type GetCmsLoyaltyConfigQueryHookResult = ReturnType<typeof useGetCmsLoyaltyConfigQuery>;
export type GetCmsLoyaltyConfigLazyQueryHookResult = ReturnType<typeof useGetCmsLoyaltyConfigLazyQuery>;
export type GetCmsLoyaltyConfigSuspenseQueryHookResult = ReturnType<typeof useGetCmsLoyaltyConfigSuspenseQuery>;
export type GetCmsLoyaltyConfigQueryResult = Apollo.QueryResult<GetCmsLoyaltyConfigQuery, GetCmsLoyaltyConfigQueryVariables>;
export const SearchDocument = gql`
    query Search($query: String!) {
  search(query: $query) {
    ...SearchProductsField_Search
    product {
      reference
      urlKey
    }
    categories {
      name
      urlKey
    }
    suggestions {
      label
    }
    brands {
      name
      urlKey
    }
  }
}
    ${SearchProductsField_SearchFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const CreateFormSubmissionDocument = gql`
    mutation createFormSubmission($data: CMS_mutationFormSubmissionInput!) {
  CMS_createFormSubmission(data: $data) {
    id
  }
}
    `;
export type CreateFormSubmissionMutationFn = Apollo.MutationFunction<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;

/**
 * __useCreateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormSubmissionMutation, { data, loading, error }] = useCreateFormSubmissionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>(CreateFormSubmissionDocument, options);
      }
export type CreateFormSubmissionMutationHookResult = ReturnType<typeof useCreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationResult = Apollo.MutationResult<CreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;
export const GetMetadataBySlugDocument = gql`
    query GetMetadataBySlug($slug: String!, $tenantId: JSON!, $draft: Boolean) {
  CMS_Pages(
    where: {path: {equals: $slug}, tenant: {equals: $tenantId}}
    limit: 1
    draft: $draft
  ) {
    docs {
      canonicalUrl
      meta {
        title
        description
        image {
          url
          width
          height
        }
      }
    }
  }
}
    `;

/**
 * __useGetMetadataBySlugQuery__
 *
 * To run a query within a React component, call `useGetMetadataBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetadataBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetadataBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      tenantId: // value for 'tenantId'
 *      draft: // value for 'draft'
 *   },
 * });
 */
export function useGetMetadataBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables> & ({ variables: GetMetadataBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>(GetMetadataBySlugDocument, options);
      }
export function useGetMetadataBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>(GetMetadataBySlugDocument, options);
        }
export function useGetMetadataBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>(GetMetadataBySlugDocument, options);
        }
export type GetMetadataBySlugQueryHookResult = ReturnType<typeof useGetMetadataBySlugQuery>;
export type GetMetadataBySlugLazyQueryHookResult = ReturnType<typeof useGetMetadataBySlugLazyQuery>;
export type GetMetadataBySlugSuspenseQueryHookResult = ReturnType<typeof useGetMetadataBySlugSuspenseQuery>;
export type GetMetadataBySlugQueryResult = Apollo.QueryResult<GetMetadataBySlugQuery, GetMetadataBySlugQueryVariables>;
export const GetPageBySlugDocument = gql`
    query GetPageBySlug($slug: String!, $tenantId: JSON!, $draft: Boolean) {
  CMS_Pages(
    where: {path: {equals: $slug}, tenant: {equals: $tenantId}}
    limit: 1
    draft: $draft
  ) {
    docs {
      id
      slug
      title
      subtitle
      breadcrumbs {
        label
        url
      }
      layout {
        __typename
        ... on CMS_HeroBannerBlock {
          id
          blockType
          title
          contentTop
          contentBottom
        }
        ... on CMS_TwoColumnsImageBlock {
          ...CMSTwoColumnsImage
        }
        ... on CMS_SectionHeaderBlock {
          ...CMSTitleH2H3
        }
        ... on CMS_CalloutBlock {
          ...CMSCallout
        }
        ... on CMS_PhoneCallbackBannerBlock {
          ...CMSPhoneCallbackBanner
        }
        ... on CMS_ColumnsBlock {
          ...CMSColumn
        }
        ... on CMS_InnerHtmlBlock {
          ...CMSInnerHtml
        }
        ... on CMS_QuoteBlock {
          ...CMSEpigraph
        }
        ... on CMS_CatalogListBlock {
          ...CMSCatalogList
        }
        ... on CMS_VideoPlayerBlock {
          ...CMSVideoPlayer
        }
        ... on CMS_SkinBlock {
          id
          blockType
          tint
          layout {
            ... on CMS_CalloutBlock {
              ...CMSCallout
            }
            ... on CMS_CatalogListBlock {
              ...CMSCatalogList
            }
            ... on CMS_ColumnsBlock {
              ...CMSColumn
            }
            ... on CMS_InnerHtmlBlock {
              ...CMSInnerHtml
            }
            ... on CMS_SectionHeaderBlock {
              ...CMSTitleH2H3
            }
            ... on CMS_TwoColumnsImageBlock {
              ...CMSTwoColumnsImage
            }
            ... on CMS_VideoPlayerBlock {
              ...CMSVideoPlayer
            }
            ... on CMS_BrandsSliderBlock {
              ...CMSBrandsSlider
            }
            ... on CMS_PictureBlock {
              ...CMSPicture
            }
            ... on CMS_PhoneCallbackBannerBlock {
              ...CMSPhoneCallbackBanner
            }
          }
        }
        ... on CMS_CategoryLinkListBlock {
          id
          blockType
          links {
            ... on CMS_ButtonLinkBlock {
              id
              blockType
              title
              plainLink
              icon
              image {
                url
                alt
                width
                height
              }
            }
          }
        }
        ... on CMS_BrandsSliderBlock {
          ...CMSBrandsSlider
        }
        ... on CMS_PictureBlock {
          ...CMSPicture
        }
        ... on CMS_SimpleTableBlock {
          id
          blockType
          overflowing
          rows {
            columns {
              tint
              contentRichText
              align
              verticalAlign
              fontWeight
            }
          }
        }
        ... on CMS_FormBlock {
          ...CMSForm
        }
        ... on CMS_FullImageCardBlock {
          id
          blockType
          title
          subtitle
          size
          imageFullImageCard {
            url
            alt
            width
            height
          }
          linkUrl
        }
      }
    }
  }
}
    ${CmsTwoColumnsImageFragmentDoc}
${CmsTitleH2H3FragmentDoc}
${CmsCalloutFragmentDoc}
${CmsPhoneCallbackBannerFragmentDoc}
${CmsColumnFragmentDoc}
${CmsInnerHtmlFragmentDoc}
${CmsEpigraphFragmentDoc}
${CmsCatalogListFragmentDoc}
${CmsVideoPlayerFragmentDoc}
${CmsBrandsSliderFragmentDoc}
${CmsPictureFragmentDoc}
${CmsFormFragmentDoc}`;

/**
 * __useGetPageBySlugQuery__
 *
 * To run a query within a React component, call `useGetPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      tenantId: // value for 'tenantId'
 *      draft: // value for 'draft'
 *   },
 * });
 */
export function useGetPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables> & ({ variables: GetPageBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
      }
export function useGetPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
        }
export function useGetPageBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
        }
export type GetPageBySlugQueryHookResult = ReturnType<typeof useGetPageBySlugQuery>;
export type GetPageBySlugLazyQueryHookResult = ReturnType<typeof useGetPageBySlugLazyQuery>;
export type GetPageBySlugSuspenseQueryHookResult = ReturnType<typeof useGetPageBySlugSuspenseQuery>;
export type GetPageBySlugQueryResult = Apollo.QueryResult<GetPageBySlugQuery, GetPageBySlugQueryVariables>;
export const ContactPageConfigDocument = gql`
    query ContactPageConfig {
  config {
    support {
      contactFormType
    }
  }
}
    `;

/**
 * __useContactPageConfigQuery__
 *
 * To run a query within a React component, call `useContactPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPageConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactPageConfigQuery(baseOptions?: Apollo.QueryHookOptions<ContactPageConfigQuery, ContactPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPageConfigQuery, ContactPageConfigQueryVariables>(ContactPageConfigDocument, options);
      }
export function useContactPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPageConfigQuery, ContactPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPageConfigQuery, ContactPageConfigQueryVariables>(ContactPageConfigDocument, options);
        }
export function useContactPageConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactPageConfigQuery, ContactPageConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactPageConfigQuery, ContactPageConfigQueryVariables>(ContactPageConfigDocument, options);
        }
export type ContactPageConfigQueryHookResult = ReturnType<typeof useContactPageConfigQuery>;
export type ContactPageConfigLazyQueryHookResult = ReturnType<typeof useContactPageConfigLazyQuery>;
export type ContactPageConfigSuspenseQueryHookResult = ReturnType<typeof useContactPageConfigSuspenseQuery>;
export type ContactPageConfigQueryResult = Apollo.QueryResult<ContactPageConfigQuery, ContactPageConfigQueryVariables>;
export const MarketingPageCurrentUserDataDocument = gql`
    query MarketingPageCurrentUserData {
  currentUser {
    id
    firstname
    favoritePointOfSaleId
  }
}
    `;

/**
 * __useMarketingPageCurrentUserDataQuery__
 *
 * To run a query within a React component, call `useMarketingPageCurrentUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingPageCurrentUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingPageCurrentUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingPageCurrentUserDataQuery(baseOptions?: Apollo.QueryHookOptions<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>(MarketingPageCurrentUserDataDocument, options);
      }
export function useMarketingPageCurrentUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>(MarketingPageCurrentUserDataDocument, options);
        }
export function useMarketingPageCurrentUserDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>(MarketingPageCurrentUserDataDocument, options);
        }
export type MarketingPageCurrentUserDataQueryHookResult = ReturnType<typeof useMarketingPageCurrentUserDataQuery>;
export type MarketingPageCurrentUserDataLazyQueryHookResult = ReturnType<typeof useMarketingPageCurrentUserDataLazyQuery>;
export type MarketingPageCurrentUserDataSuspenseQueryHookResult = ReturnType<typeof useMarketingPageCurrentUserDataSuspenseQuery>;
export type MarketingPageCurrentUserDataQueryResult = Apollo.QueryResult<MarketingPageCurrentUserDataQuery, MarketingPageCurrentUserDataQueryVariables>;
export const GetHomePageConfigDocument = gql`
    query GetHomePageConfig {
  config {
    ...HomePage_Config
  }
}
    ${HomePage_ConfigFragmentDoc}`;

/**
 * __useGetHomePageConfigQuery__
 *
 * To run a query within a React component, call `useGetHomePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomePageConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>(GetHomePageConfigDocument, options);
      }
export function useGetHomePageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>(GetHomePageConfigDocument, options);
        }
export function useGetHomePageConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>(GetHomePageConfigDocument, options);
        }
export type GetHomePageConfigQueryHookResult = ReturnType<typeof useGetHomePageConfigQuery>;
export type GetHomePageConfigLazyQueryHookResult = ReturnType<typeof useGetHomePageConfigLazyQuery>;
export type GetHomePageConfigSuspenseQueryHookResult = ReturnType<typeof useGetHomePageConfigSuspenseQuery>;
export type GetHomePageConfigQueryResult = Apollo.QueryResult<GetHomePageConfigQuery, GetHomePageConfigQueryVariables>;
export const GenerateLyraFormDocument = gql`
    query GenerateLyraForm($webRef: String) {
  currentUser {
    checkout {
      generateLyraForm(webRef: $webRef) {
        endpoint
        payload
      }
    }
  }
}
    `;

/**
 * __useGenerateLyraFormQuery__
 *
 * To run a query within a React component, call `useGenerateLyraFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateLyraFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateLyraFormQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useGenerateLyraFormQuery(baseOptions?: Apollo.QueryHookOptions<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>(GenerateLyraFormDocument, options);
      }
export function useGenerateLyraFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>(GenerateLyraFormDocument, options);
        }
export function useGenerateLyraFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>(GenerateLyraFormDocument, options);
        }
export type GenerateLyraFormQueryHookResult = ReturnType<typeof useGenerateLyraFormQuery>;
export type GenerateLyraFormLazyQueryHookResult = ReturnType<typeof useGenerateLyraFormLazyQuery>;
export type GenerateLyraFormSuspenseQueryHookResult = ReturnType<typeof useGenerateLyraFormSuspenseQuery>;
export type GenerateLyraFormQueryResult = Apollo.QueryResult<GenerateLyraFormQuery, GenerateLyraFormQueryVariables>;
export const CartPreview_CartDocument = gql`
    query CartPreview_Cart {
  currentUser {
    id
    ...CartPdfTemplate_CurrentUser
    checkout {
      cart(forceRefresh: true) {
        ...CartPdfTemplate_Cart
      }
      shipping {
        fee {
          ...ShippingFeeTag_Fee
        }
      }
    }
  }
}
    ${CartPdfTemplate_CurrentUserFragmentDoc}
${CartPdfTemplate_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;

/**
 * __useCartPreview_CartQuery__
 *
 * To run a query within a React component, call `useCartPreview_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartPreview_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartPreview_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartPreview_CartQuery(baseOptions?: Apollo.QueryHookOptions<CartPreview_CartQuery, CartPreview_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartPreview_CartQuery, CartPreview_CartQueryVariables>(CartPreview_CartDocument, options);
      }
export function useCartPreview_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartPreview_CartQuery, CartPreview_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartPreview_CartQuery, CartPreview_CartQueryVariables>(CartPreview_CartDocument, options);
        }
export function useCartPreview_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartPreview_CartQuery, CartPreview_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartPreview_CartQuery, CartPreview_CartQueryVariables>(CartPreview_CartDocument, options);
        }
export type CartPreview_CartQueryHookResult = ReturnType<typeof useCartPreview_CartQuery>;
export type CartPreview_CartLazyQueryHookResult = ReturnType<typeof useCartPreview_CartLazyQuery>;
export type CartPreview_CartSuspenseQueryHookResult = ReturnType<typeof useCartPreview_CartSuspenseQuery>;
export type CartPreview_CartQueryResult = Apollo.QueryResult<CartPreview_CartQuery, CartPreview_CartQueryVariables>;
export const PunchoutCartPreview_CartDocument = gql`
    query PunchoutCartPreview_Cart {
  currentUser {
    id
    ...CartPdfTemplate_CurrentUser
    punchout {
      cart {
        ...PunchoutCartPdf_Cart
      }
    }
  }
}
    ${CartPdfTemplate_CurrentUserFragmentDoc}
${PunchoutCartPdf_CartFragmentDoc}`;

/**
 * __usePunchoutCartPreview_CartQuery__
 *
 * To run a query within a React component, call `usePunchoutCartPreview_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchoutCartPreview_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchoutCartPreview_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function usePunchoutCartPreview_CartQuery(baseOptions?: Apollo.QueryHookOptions<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>(PunchoutCartPreview_CartDocument, options);
      }
export function usePunchoutCartPreview_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>(PunchoutCartPreview_CartDocument, options);
        }
export function usePunchoutCartPreview_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>(PunchoutCartPreview_CartDocument, options);
        }
export type PunchoutCartPreview_CartQueryHookResult = ReturnType<typeof usePunchoutCartPreview_CartQuery>;
export type PunchoutCartPreview_CartLazyQueryHookResult = ReturnType<typeof usePunchoutCartPreview_CartLazyQuery>;
export type PunchoutCartPreview_CartSuspenseQueryHookResult = ReturnType<typeof usePunchoutCartPreview_CartSuspenseQuery>;
export type PunchoutCartPreview_CartQueryResult = Apollo.QueryResult<PunchoutCartPreview_CartQuery, PunchoutCartPreview_CartQueryVariables>;
export const StoreOrderPreviewDocument = gql`
    query StoreOrderPreview($externalRef: String!) {
  currentUser {
    id
    orders(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $externalRef}, {type: STRING, field: "orderType", operator: EQUAL, stringValue: "STORE"}]}
    ) {
      items {
        ...StoreOrderPdfTemplate_Order
      }
    }
  }
  config {
    ...OrderReferenceDisplay_Config
  }
}
    ${StoreOrderPdfTemplate_OrderFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useStoreOrderPreviewQuery__
 *
 * To run a query within a React component, call `useStoreOrderPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreOrderPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreOrderPreviewQuery({
 *   variables: {
 *      externalRef: // value for 'externalRef'
 *   },
 * });
 */
export function useStoreOrderPreviewQuery(baseOptions: Apollo.QueryHookOptions<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables> & ({ variables: StoreOrderPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>(StoreOrderPreviewDocument, options);
      }
export function useStoreOrderPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>(StoreOrderPreviewDocument, options);
        }
export function useStoreOrderPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>(StoreOrderPreviewDocument, options);
        }
export type StoreOrderPreviewQueryHookResult = ReturnType<typeof useStoreOrderPreviewQuery>;
export type StoreOrderPreviewLazyQueryHookResult = ReturnType<typeof useStoreOrderPreviewLazyQuery>;
export type StoreOrderPreviewSuspenseQueryHookResult = ReturnType<typeof useStoreOrderPreviewSuspenseQuery>;
export type StoreOrderPreviewQueryResult = Apollo.QueryResult<StoreOrderPreviewQuery, StoreOrderPreviewQueryVariables>;
export const WebOrderPreviewDocument = gql`
    query WebOrderPreview($webRef: String!) {
  currentUser {
    id
    orders(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $webRef}, {type: STRING, field: "orderType", operator: EQUAL, stringValue: "ECOMMERCE"}]}
    ) {
      items {
        ...WebOrderPdfTemplate_Order
      }
    }
  }
  config {
    ...OrderReferenceDisplay_Config
  }
}
    ${WebOrderPdfTemplate_OrderFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useWebOrderPreviewQuery__
 *
 * To run a query within a React component, call `useWebOrderPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOrderPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOrderPreviewQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useWebOrderPreviewQuery(baseOptions: Apollo.QueryHookOptions<WebOrderPreviewQuery, WebOrderPreviewQueryVariables> & ({ variables: WebOrderPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>(WebOrderPreviewDocument, options);
      }
export function useWebOrderPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>(WebOrderPreviewDocument, options);
        }
export function useWebOrderPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>(WebOrderPreviewDocument, options);
        }
export type WebOrderPreviewQueryHookResult = ReturnType<typeof useWebOrderPreviewQuery>;
export type WebOrderPreviewLazyQueryHookResult = ReturnType<typeof useWebOrderPreviewLazyQuery>;
export type WebOrderPreviewSuspenseQueryHookResult = ReturnType<typeof useWebOrderPreviewSuspenseQuery>;
export type WebOrderPreviewQueryResult = Apollo.QueryResult<WebOrderPreviewQuery, WebOrderPreviewQueryVariables>;
export const CartExportDocument = gql`
    query CartExport {
  currentUser {
    id
    firstname
    lastname
    email
    company {
      id
      code
      name
    }
    checkout {
      cart(forceRefresh: true) {
        id
        totalExclTax
        totalInclTax
        taxesDetails {
          amount {
            value
          }
          label
        }
        totalDiscount
        totalQuantity
        couponCode
        createdAt
        itemsGroupedByEarliestDeliveryDate {
          quantity
          items {
            id
            quantity
            unitPrice {
              exclTax
            }
            calculatedConditionningPrice
            totalExclTax
            discount {
              catalogDiscountAmount
              percentage
              webDiscount {
                amount
                hasCoupon
                label
              }
            }
            promotionTag {
              label
              type
            }
            product {
              reference
              supplierReference
              name
              description
              brand {
                name
                urlKey
              }
              ecoPart {
                deee
                pmcb
                furnishing
              }
              charges {
                name
                amount
              }
              packaging {
                unit
                quantity
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCartExportQuery__
 *
 * To run a query within a React component, call `useCartExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartExportQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartExportQuery(baseOptions?: Apollo.QueryHookOptions<CartExportQuery, CartExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartExportQuery, CartExportQueryVariables>(CartExportDocument, options);
      }
export function useCartExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartExportQuery, CartExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartExportQuery, CartExportQueryVariables>(CartExportDocument, options);
        }
export function useCartExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartExportQuery, CartExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartExportQuery, CartExportQueryVariables>(CartExportDocument, options);
        }
export type CartExportQueryHookResult = ReturnType<typeof useCartExportQuery>;
export type CartExportLazyQueryHookResult = ReturnType<typeof useCartExportLazyQuery>;
export type CartExportSuspenseQueryHookResult = ReturnType<typeof useCartExportSuspenseQuery>;
export type CartExportQueryResult = Apollo.QueryResult<CartExportQuery, CartExportQueryVariables>;
export const PunchoutCartExportDocument = gql`
    query PunchoutCartExport {
  currentUser {
    id
    punchout {
      cart {
        id
        items {
          id
          quantity
          rowTotalExclTax
          unitPriceExclTax
          product {
            reference
            supplierReference
            name
            brand {
              name
              urlKey
            }
            ecoPart {
              deee
              pmcb
              furnishing
            }
            charges {
              name
              amount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePunchoutCartExportQuery__
 *
 * To run a query within a React component, call `usePunchoutCartExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchoutCartExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchoutCartExportQuery({
 *   variables: {
 *   },
 * });
 */
export function usePunchoutCartExportQuery(baseOptions?: Apollo.QueryHookOptions<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>(PunchoutCartExportDocument, options);
      }
export function usePunchoutCartExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>(PunchoutCartExportDocument, options);
        }
export function usePunchoutCartExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>(PunchoutCartExportDocument, options);
        }
export type PunchoutCartExportQueryHookResult = ReturnType<typeof usePunchoutCartExportQuery>;
export type PunchoutCartExportLazyQueryHookResult = ReturnType<typeof usePunchoutCartExportLazyQuery>;
export type PunchoutCartExportSuspenseQueryHookResult = ReturnType<typeof usePunchoutCartExportSuspenseQuery>;
export type PunchoutCartExportQueryResult = Apollo.QueryResult<PunchoutCartExportQuery, PunchoutCartExportQueryVariables>;
export const ProductsStickersDocument = gql`
    query ProductsStickers($references: [String!]!) {
  productsByReferences(references: $references) {
    ...ProductsStickersProduct
  }
}
    ${ProductsStickersProductFragmentDoc}`;

/**
 * __useProductsStickersQuery__
 *
 * To run a query within a React component, call `useProductsStickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsStickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsStickersQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useProductsStickersQuery(baseOptions: Apollo.QueryHookOptions<ProductsStickersQuery, ProductsStickersQueryVariables> & ({ variables: ProductsStickersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsStickersQuery, ProductsStickersQueryVariables>(ProductsStickersDocument, options);
      }
export function useProductsStickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsStickersQuery, ProductsStickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsStickersQuery, ProductsStickersQueryVariables>(ProductsStickersDocument, options);
        }
export function useProductsStickersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsStickersQuery, ProductsStickersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsStickersQuery, ProductsStickersQueryVariables>(ProductsStickersDocument, options);
        }
export type ProductsStickersQueryHookResult = ReturnType<typeof useProductsStickersQuery>;
export type ProductsStickersLazyQueryHookResult = ReturnType<typeof useProductsStickersLazyQuery>;
export type ProductsStickersSuspenseQueryHookResult = ReturnType<typeof useProductsStickersSuspenseQuery>;
export type ProductsStickersQueryResult = Apollo.QueryResult<ProductsStickersQuery, ProductsStickersQueryVariables>;
export const ProductsStickersConfigDocument = gql`
    query ProductsStickersConfig {
  config {
    catalog {
      isProductLabelGenerationEnabled
      isStoreNameDisplayedOnProductLabel
    }
  }
}
    `;

/**
 * __useProductsStickersConfigQuery__
 *
 * To run a query within a React component, call `useProductsStickersConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsStickersConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsStickersConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsStickersConfigQuery(baseOptions?: Apollo.QueryHookOptions<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>(ProductsStickersConfigDocument, options);
      }
export function useProductsStickersConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>(ProductsStickersConfigDocument, options);
        }
export function useProductsStickersConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>(ProductsStickersConfigDocument, options);
        }
export type ProductsStickersConfigQueryHookResult = ReturnType<typeof useProductsStickersConfigQuery>;
export type ProductsStickersConfigLazyQueryHookResult = ReturnType<typeof useProductsStickersConfigLazyQuery>;
export type ProductsStickersConfigSuspenseQueryHookResult = ReturnType<typeof useProductsStickersConfigSuspenseQuery>;
export type ProductsStickersConfigQueryResult = Apollo.QueryResult<ProductsStickersConfigQuery, ProductsStickersConfigQueryVariables>;
export const AddressByIdDocument = gql`
    query AddressById($addressId: String!) {
  currentUser {
    id
    company {
      id
      address(id: $addressId) {
        ...UserCompanyAddress
      }
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;

/**
 * __useAddressByIdQuery__
 *
 * To run a query within a React component, call `useAddressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressByIdQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useAddressByIdQuery(baseOptions: Apollo.QueryHookOptions<AddressByIdQuery, AddressByIdQueryVariables> & ({ variables: AddressByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressByIdQuery, AddressByIdQueryVariables>(AddressByIdDocument, options);
      }
export function useAddressByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressByIdQuery, AddressByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressByIdQuery, AddressByIdQueryVariables>(AddressByIdDocument, options);
        }
export function useAddressByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressByIdQuery, AddressByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressByIdQuery, AddressByIdQueryVariables>(AddressByIdDocument, options);
        }
export type AddressByIdQueryHookResult = ReturnType<typeof useAddressByIdQuery>;
export type AddressByIdLazyQueryHookResult = ReturnType<typeof useAddressByIdLazyQuery>;
export type AddressByIdSuspenseQueryHookResult = ReturnType<typeof useAddressByIdSuspenseQuery>;
export type AddressByIdQueryResult = Apollo.QueryResult<AddressByIdQuery, AddressByIdQueryVariables>;
export const FavoritePointOfSaleDocument = gql`
    query FavoritePointOfSale {
  currentUser {
    ...CurrentUser_FavoritePointOfSale
  }
}
    ${CurrentUser_FavoritePointOfSaleFragmentDoc}`;

/**
 * __useFavoritePointOfSaleQuery__
 *
 * To run a query within a React component, call `useFavoritePointOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritePointOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritePointOfSaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritePointOfSaleQuery(baseOptions?: Apollo.QueryHookOptions<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>(FavoritePointOfSaleDocument, options);
      }
export function useFavoritePointOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>(FavoritePointOfSaleDocument, options);
        }
export function useFavoritePointOfSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>(FavoritePointOfSaleDocument, options);
        }
export type FavoritePointOfSaleQueryHookResult = ReturnType<typeof useFavoritePointOfSaleQuery>;
export type FavoritePointOfSaleLazyQueryHookResult = ReturnType<typeof useFavoritePointOfSaleLazyQuery>;
export type FavoritePointOfSaleSuspenseQueryHookResult = ReturnType<typeof useFavoritePointOfSaleSuspenseQuery>;
export type FavoritePointOfSaleQueryResult = Apollo.QueryResult<FavoritePointOfSaleQuery, FavoritePointOfSaleQueryVariables>;
export const FavoriteListNameByIdDocument = gql`
    query FavoriteListNameById($input: Browsing!) {
  currentUser {
    id
    wishlists(input: $input) {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFavoriteListNameByIdQuery__
 *
 * To run a query within a React component, call `useFavoriteListNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteListNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteListNameByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavoriteListNameByIdQuery(baseOptions: Apollo.QueryHookOptions<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables> & ({ variables: FavoriteListNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>(FavoriteListNameByIdDocument, options);
      }
export function useFavoriteListNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>(FavoriteListNameByIdDocument, options);
        }
export function useFavoriteListNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>(FavoriteListNameByIdDocument, options);
        }
export type FavoriteListNameByIdQueryHookResult = ReturnType<typeof useFavoriteListNameByIdQuery>;
export type FavoriteListNameByIdLazyQueryHookResult = ReturnType<typeof useFavoriteListNameByIdLazyQuery>;
export type FavoriteListNameByIdSuspenseQueryHookResult = ReturnType<typeof useFavoriteListNameByIdSuspenseQuery>;
export type FavoriteListNameByIdQueryResult = Apollo.QueryResult<FavoriteListNameByIdQuery, FavoriteListNameByIdQueryVariables>;
export const EventConditionsDrawerDocument = gql`
    query EventConditionsDrawer($urlKey: String!) {
  event(urlKey: $urlKey) {
    conditions
  }
}
    `;

/**
 * __useEventConditionsDrawerQuery__
 *
 * To run a query within a React component, call `useEventConditionsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventConditionsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventConditionsDrawerQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useEventConditionsDrawerQuery(baseOptions: Apollo.QueryHookOptions<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables> & ({ variables: EventConditionsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>(EventConditionsDrawerDocument, options);
      }
export function useEventConditionsDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>(EventConditionsDrawerDocument, options);
        }
export function useEventConditionsDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>(EventConditionsDrawerDocument, options);
        }
export type EventConditionsDrawerQueryHookResult = ReturnType<typeof useEventConditionsDrawerQuery>;
export type EventConditionsDrawerLazyQueryHookResult = ReturnType<typeof useEventConditionsDrawerLazyQuery>;
export type EventConditionsDrawerSuspenseQueryHookResult = ReturnType<typeof useEventConditionsDrawerSuspenseQuery>;
export type EventConditionsDrawerQueryResult = Apollo.QueryResult<EventConditionsDrawerQuery, EventConditionsDrawerQueryVariables>;
export const AvailablePointsOfSalePickupDocument = gql`
    query availablePointsOfSalePickup {
  currentUser {
    availablePointsOfSalePickup {
      id
    }
  }
}
    `;

/**
 * __useAvailablePointsOfSalePickupQuery__
 *
 * To run a query within a React component, call `useAvailablePointsOfSalePickupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePointsOfSalePickupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePointsOfSalePickupQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailablePointsOfSalePickupQuery(baseOptions?: Apollo.QueryHookOptions<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>(AvailablePointsOfSalePickupDocument, options);
      }
export function useAvailablePointsOfSalePickupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>(AvailablePointsOfSalePickupDocument, options);
        }
export function useAvailablePointsOfSalePickupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>(AvailablePointsOfSalePickupDocument, options);
        }
export type AvailablePointsOfSalePickupQueryHookResult = ReturnType<typeof useAvailablePointsOfSalePickupQuery>;
export type AvailablePointsOfSalePickupLazyQueryHookResult = ReturnType<typeof useAvailablePointsOfSalePickupLazyQuery>;
export type AvailablePointsOfSalePickupSuspenseQueryHookResult = ReturnType<typeof useAvailablePointsOfSalePickupSuspenseQuery>;
export type AvailablePointsOfSalePickupQueryResult = Apollo.QueryResult<AvailablePointsOfSalePickupQuery, AvailablePointsOfSalePickupQueryVariables>;
export const EmbedEditShippingContactDocument = gql`
    query EmbedEditShippingContact {
  currentUser {
    id
    checkout {
      cart {
        id
      }
      shipping {
        delivery {
          recipientName
          recipientPhone
        }
        methodCode
      }
    }
  }
}
    `;

/**
 * __useEmbedEditShippingContactQuery__
 *
 * To run a query within a React component, call `useEmbedEditShippingContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedEditShippingContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedEditShippingContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmbedEditShippingContactQuery(baseOptions?: Apollo.QueryHookOptions<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>(EmbedEditShippingContactDocument, options);
      }
export function useEmbedEditShippingContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>(EmbedEditShippingContactDocument, options);
        }
export function useEmbedEditShippingContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>(EmbedEditShippingContactDocument, options);
        }
export type EmbedEditShippingContactQueryHookResult = ReturnType<typeof useEmbedEditShippingContactQuery>;
export type EmbedEditShippingContactLazyQueryHookResult = ReturnType<typeof useEmbedEditShippingContactLazyQuery>;
export type EmbedEditShippingContactSuspenseQueryHookResult = ReturnType<typeof useEmbedEditShippingContactSuspenseQuery>;
export type EmbedEditShippingContactQueryResult = Apollo.QueryResult<EmbedEditShippingContactQuery, EmbedEditShippingContactQueryVariables>;
export const EmbedEditShippingInformationDocument = gql`
    query EmbedEditShippingInformation {
  currentUser {
    id
    checkout {
      cart {
        id
      }
      shipping {
        delivery {
          comment
        }
      }
    }
  }
}
    `;

/**
 * __useEmbedEditShippingInformationQuery__
 *
 * To run a query within a React component, call `useEmbedEditShippingInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedEditShippingInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedEditShippingInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmbedEditShippingInformationQuery(baseOptions?: Apollo.QueryHookOptions<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>(EmbedEditShippingInformationDocument, options);
      }
export function useEmbedEditShippingInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>(EmbedEditShippingInformationDocument, options);
        }
export function useEmbedEditShippingInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>(EmbedEditShippingInformationDocument, options);
        }
export type EmbedEditShippingInformationQueryHookResult = ReturnType<typeof useEmbedEditShippingInformationQuery>;
export type EmbedEditShippingInformationLazyQueryHookResult = ReturnType<typeof useEmbedEditShippingInformationLazyQuery>;
export type EmbedEditShippingInformationSuspenseQueryHookResult = ReturnType<typeof useEmbedEditShippingInformationSuspenseQuery>;
export type EmbedEditShippingInformationQueryResult = Apollo.QueryResult<EmbedEditShippingInformationQuery, EmbedEditShippingInformationQueryVariables>;
export const EmbedSelectAddressCartDocument = gql`
    query EmbedSelectAddressCart {
  currentUser {
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useEmbedSelectAddressCartQuery__
 *
 * To run a query within a React component, call `useEmbedSelectAddressCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedSelectAddressCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedSelectAddressCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmbedSelectAddressCartQuery(baseOptions?: Apollo.QueryHookOptions<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>(EmbedSelectAddressCartDocument, options);
      }
export function useEmbedSelectAddressCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>(EmbedSelectAddressCartDocument, options);
        }
export function useEmbedSelectAddressCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>(EmbedSelectAddressCartDocument, options);
        }
export type EmbedSelectAddressCartQueryHookResult = ReturnType<typeof useEmbedSelectAddressCartQuery>;
export type EmbedSelectAddressCartLazyQueryHookResult = ReturnType<typeof useEmbedSelectAddressCartLazyQuery>;
export type EmbedSelectAddressCartSuspenseQueryHookResult = ReturnType<typeof useEmbedSelectAddressCartSuspenseQuery>;
export type EmbedSelectAddressCartQueryResult = Apollo.QueryResult<EmbedSelectAddressCartQuery, EmbedSelectAddressCartQueryVariables>;
export const EmbedSetDeliveryDatePickerDocument = gql`
    query EmbedSetDeliveryDatePicker {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useEmbedSetDeliveryDatePickerQuery__
 *
 * To run a query within a React component, call `useEmbedSetDeliveryDatePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedSetDeliveryDatePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedSetDeliveryDatePickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmbedSetDeliveryDatePickerQuery(baseOptions?: Apollo.QueryHookOptions<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>(EmbedSetDeliveryDatePickerDocument, options);
      }
export function useEmbedSetDeliveryDatePickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>(EmbedSetDeliveryDatePickerDocument, options);
        }
export function useEmbedSetDeliveryDatePickerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>(EmbedSetDeliveryDatePickerDocument, options);
        }
export type EmbedSetDeliveryDatePickerQueryHookResult = ReturnType<typeof useEmbedSetDeliveryDatePickerQuery>;
export type EmbedSetDeliveryDatePickerLazyQueryHookResult = ReturnType<typeof useEmbedSetDeliveryDatePickerLazyQuery>;
export type EmbedSetDeliveryDatePickerSuspenseQueryHookResult = ReturnType<typeof useEmbedSetDeliveryDatePickerSuspenseQuery>;
export type EmbedSetDeliveryDatePickerQueryResult = Apollo.QueryResult<EmbedSetDeliveryDatePickerQuery, EmbedSetDeliveryDatePickerQueryVariables>;
export const ProductByUrlKeyDocument = gql`
    query productByUrlKey($urlKey: String!) {
  product(urlKey: $urlKey) {
    urlKey
  }
}
    `;

/**
 * __useProductByUrlKeyQuery__
 *
 * To run a query within a React component, call `useProductByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByUrlKeyQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables> & ({ variables: ProductByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
      }
export function useProductByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
        }
export function useProductByUrlKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
        }
export type ProductByUrlKeyQueryHookResult = ReturnType<typeof useProductByUrlKeyQuery>;
export type ProductByUrlKeyLazyQueryHookResult = ReturnType<typeof useProductByUrlKeyLazyQuery>;
export type ProductByUrlKeySuspenseQueryHookResult = ReturnType<typeof useProductByUrlKeySuspenseQuery>;
export type ProductByUrlKeyQueryResult = Apollo.QueryResult<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>;
export const GetCurrentUserTriptychDocument = gql`
    query GetCurrentUserTriptych {
  currentUser {
    id
    company {
      code
      pointOfSale {
        id
        subsidiary {
          id
        }
      }
    }
    favoritePointOfSale {
      id
    }
  }
}
    `;

/**
 * __useGetCurrentUserTriptychQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserTriptychQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserTriptychQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserTriptychQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserTriptychQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>(GetCurrentUserTriptychDocument, options);
      }
export function useGetCurrentUserTriptychLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>(GetCurrentUserTriptychDocument, options);
        }
export function useGetCurrentUserTriptychSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>(GetCurrentUserTriptychDocument, options);
        }
export type GetCurrentUserTriptychQueryHookResult = ReturnType<typeof useGetCurrentUserTriptychQuery>;
export type GetCurrentUserTriptychLazyQueryHookResult = ReturnType<typeof useGetCurrentUserTriptychLazyQuery>;
export type GetCurrentUserTriptychSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserTriptychSuspenseQuery>;
export type GetCurrentUserTriptychQueryResult = Apollo.QueryResult<GetCurrentUserTriptychQuery, GetCurrentUserTriptychQueryVariables>;
export const GetUserTriptychForImpersonationDocument = gql`
    query GetUserTriptychForImpersonation($input: Browsing!) {
  searchUsers(input: $input) {
    items {
      id
      company {
        code
        pointOfSale {
          id
          subsidiary {
            id
          }
        }
      }
      favoritePointOfSale {
        id
      }
    }
  }
}
    `;

/**
 * __useGetUserTriptychForImpersonationQuery__
 *
 * To run a query within a React component, call `useGetUserTriptychForImpersonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTriptychForImpersonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTriptychForImpersonationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserTriptychForImpersonationQuery(baseOptions: Apollo.QueryHookOptions<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables> & ({ variables: GetUserTriptychForImpersonationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>(GetUserTriptychForImpersonationDocument, options);
      }
export function useGetUserTriptychForImpersonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>(GetUserTriptychForImpersonationDocument, options);
        }
export function useGetUserTriptychForImpersonationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>(GetUserTriptychForImpersonationDocument, options);
        }
export type GetUserTriptychForImpersonationQueryHookResult = ReturnType<typeof useGetUserTriptychForImpersonationQuery>;
export type GetUserTriptychForImpersonationLazyQueryHookResult = ReturnType<typeof useGetUserTriptychForImpersonationLazyQuery>;
export type GetUserTriptychForImpersonationSuspenseQueryHookResult = ReturnType<typeof useGetUserTriptychForImpersonationSuspenseQuery>;
export type GetUserTriptychForImpersonationQueryResult = Apollo.QueryResult<GetUserTriptychForImpersonationQuery, GetUserTriptychForImpersonationQueryVariables>;
export const GetTestCurrentUserDocument = gql`
    query GetTestCurrentUser {
  currentUser {
    id
    email
    firstname
    lastname
    role
  }
}
    `;

/**
 * __useGetTestCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetTestCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTestCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>(GetTestCurrentUserDocument, options);
      }
export function useGetTestCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>(GetTestCurrentUserDocument, options);
        }
export function useGetTestCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>(GetTestCurrentUserDocument, options);
        }
export type GetTestCurrentUserQueryHookResult = ReturnType<typeof useGetTestCurrentUserQuery>;
export type GetTestCurrentUserLazyQueryHookResult = ReturnType<typeof useGetTestCurrentUserLazyQuery>;
export type GetTestCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetTestCurrentUserSuspenseQuery>;
export type GetTestCurrentUserQueryResult = Apollo.QueryResult<GetTestCurrentUserQuery, GetTestCurrentUserQueryVariables>;
export const InternalLoginActionDocument = gql`
    query InternalLoginAction {
  internalLoginAction {
    url
  }
}
    `;

/**
 * __useInternalLoginActionQuery__
 *
 * To run a query within a React component, call `useInternalLoginActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalLoginActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalLoginActionQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalLoginActionQuery(baseOptions?: Apollo.QueryHookOptions<InternalLoginActionQuery, InternalLoginActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalLoginActionQuery, InternalLoginActionQueryVariables>(InternalLoginActionDocument, options);
      }
export function useInternalLoginActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalLoginActionQuery, InternalLoginActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalLoginActionQuery, InternalLoginActionQueryVariables>(InternalLoginActionDocument, options);
        }
export function useInternalLoginActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalLoginActionQuery, InternalLoginActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalLoginActionQuery, InternalLoginActionQueryVariables>(InternalLoginActionDocument, options);
        }
export type InternalLoginActionQueryHookResult = ReturnType<typeof useInternalLoginActionQuery>;
export type InternalLoginActionLazyQueryHookResult = ReturnType<typeof useInternalLoginActionLazyQuery>;
export type InternalLoginActionSuspenseQueryHookResult = ReturnType<typeof useInternalLoginActionSuspenseQuery>;
export type InternalLoginActionQueryResult = Apollo.QueryResult<InternalLoginActionQuery, InternalLoginActionQueryVariables>;
export const GenerateInternalAuthTokenDocument = gql`
    mutation GenerateInternalAuthToken($samlResponse: String!) {
  generateInternalAuthToken(samlResponse: $samlResponse) {
    type
    value
    maxAge
  }
}
    `;
export type GenerateInternalAuthTokenMutationFn = Apollo.MutationFunction<GenerateInternalAuthTokenMutation, GenerateInternalAuthTokenMutationVariables>;

/**
 * __useGenerateInternalAuthTokenMutation__
 *
 * To run a mutation, you first call `useGenerateInternalAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInternalAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInternalAuthTokenMutation, { data, loading, error }] = useGenerateInternalAuthTokenMutation({
 *   variables: {
 *      samlResponse: // value for 'samlResponse'
 *   },
 * });
 */
export function useGenerateInternalAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInternalAuthTokenMutation, GenerateInternalAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInternalAuthTokenMutation, GenerateInternalAuthTokenMutationVariables>(GenerateInternalAuthTokenDocument, options);
      }
export type GenerateInternalAuthTokenMutationHookResult = ReturnType<typeof useGenerateInternalAuthTokenMutation>;
export type GenerateInternalAuthTokenMutationResult = Apollo.MutationResult<GenerateInternalAuthTokenMutation>;
export type GenerateInternalAuthTokenMutationOptions = Apollo.BaseMutationOptions<GenerateInternalAuthTokenMutation, GenerateInternalAuthTokenMutationVariables>;
export const SitemapConfigDocument = gql`
    query SitemapConfig {
  config {
    site {
      sitemapUrl
    }
  }
}
    `;

/**
 * __useSitemapConfigQuery__
 *
 * To run a query within a React component, call `useSitemapConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitemapConfigQuery(baseOptions?: Apollo.QueryHookOptions<SitemapConfigQuery, SitemapConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapConfigQuery, SitemapConfigQueryVariables>(SitemapConfigDocument, options);
      }
export function useSitemapConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapConfigQuery, SitemapConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapConfigQuery, SitemapConfigQueryVariables>(SitemapConfigDocument, options);
        }
export function useSitemapConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapConfigQuery, SitemapConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapConfigQuery, SitemapConfigQueryVariables>(SitemapConfigDocument, options);
        }
export type SitemapConfigQueryHookResult = ReturnType<typeof useSitemapConfigQuery>;
export type SitemapConfigLazyQueryHookResult = ReturnType<typeof useSitemapConfigLazyQuery>;
export type SitemapConfigSuspenseQueryHookResult = ReturnType<typeof useSitemapConfigSuspenseQuery>;
export type SitemapConfigQueryResult = Apollo.QueryResult<SitemapConfigQuery, SitemapConfigQueryVariables>;
export const AddAccountLink_CurrentUserDocument = gql`
    query AddAccountLink_CurrentUser {
  currentUser {
    id
    email
  }
}
    `;

/**
 * __useAddAccountLink_CurrentUserQuery__
 *
 * To run a query within a React component, call `useAddAccountLink_CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAccountLink_CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAccountLink_CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddAccountLink_CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>(AddAccountLink_CurrentUserDocument, options);
      }
export function useAddAccountLink_CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>(AddAccountLink_CurrentUserDocument, options);
        }
export function useAddAccountLink_CurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>(AddAccountLink_CurrentUserDocument, options);
        }
export type AddAccountLink_CurrentUserQueryHookResult = ReturnType<typeof useAddAccountLink_CurrentUserQuery>;
export type AddAccountLink_CurrentUserLazyQueryHookResult = ReturnType<typeof useAddAccountLink_CurrentUserLazyQuery>;
export type AddAccountLink_CurrentUserSuspenseQueryHookResult = ReturnType<typeof useAddAccountLink_CurrentUserSuspenseQuery>;
export type AddAccountLink_CurrentUserQueryResult = Apollo.QueryResult<AddAccountLink_CurrentUserQuery, AddAccountLink_CurrentUserQueryVariables>;
export const AccountDrawer_QuoteNotificationConfigDocument = gql`
    query AccountDrawer_QuoteNotificationConfig {
  config {
    quotation {
      isQuotationEnabled
    }
  }
}
    `;

/**
 * __useAccountDrawer_QuoteNotificationConfigQuery__
 *
 * To run a query within a React component, call `useAccountDrawer_QuoteNotificationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDrawer_QuoteNotificationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDrawer_QuoteNotificationConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountDrawer_QuoteNotificationConfigQuery(baseOptions?: Apollo.QueryHookOptions<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>(AccountDrawer_QuoteNotificationConfigDocument, options);
      }
export function useAccountDrawer_QuoteNotificationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>(AccountDrawer_QuoteNotificationConfigDocument, options);
        }
export function useAccountDrawer_QuoteNotificationConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>(AccountDrawer_QuoteNotificationConfigDocument, options);
        }
export type AccountDrawer_QuoteNotificationConfigQueryHookResult = ReturnType<typeof useAccountDrawer_QuoteNotificationConfigQuery>;
export type AccountDrawer_QuoteNotificationConfigLazyQueryHookResult = ReturnType<typeof useAccountDrawer_QuoteNotificationConfigLazyQuery>;
export type AccountDrawer_QuoteNotificationConfigSuspenseQueryHookResult = ReturnType<typeof useAccountDrawer_QuoteNotificationConfigSuspenseQuery>;
export type AccountDrawer_QuoteNotificationConfigQueryResult = Apollo.QueryResult<AccountDrawer_QuoteNotificationConfigQuery, AccountDrawer_QuoteNotificationConfigQueryVariables>;
export const AccountDrawer_UserPermissionsDocument = gql`
    query AccountDrawer_UserPermissions {
  currentUser {
    permissions {
      canManageQuote
    }
  }
}
    `;

/**
 * __useAccountDrawer_UserPermissionsQuery__
 *
 * To run a query within a React component, call `useAccountDrawer_UserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDrawer_UserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDrawer_UserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountDrawer_UserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>(AccountDrawer_UserPermissionsDocument, options);
      }
export function useAccountDrawer_UserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>(AccountDrawer_UserPermissionsDocument, options);
        }
export function useAccountDrawer_UserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>(AccountDrawer_UserPermissionsDocument, options);
        }
export type AccountDrawer_UserPermissionsQueryHookResult = ReturnType<typeof useAccountDrawer_UserPermissionsQuery>;
export type AccountDrawer_UserPermissionsLazyQueryHookResult = ReturnType<typeof useAccountDrawer_UserPermissionsLazyQuery>;
export type AccountDrawer_UserPermissionsSuspenseQueryHookResult = ReturnType<typeof useAccountDrawer_UserPermissionsSuspenseQuery>;
export type AccountDrawer_UserPermissionsQueryResult = Apollo.QueryResult<AccountDrawer_UserPermissionsQuery, AccountDrawer_UserPermissionsQueryVariables>;
export const AccountDrawer_CurrentUserDocument = gql`
    query AccountDrawer_CurrentUser {
  currentUser {
    id
    firstname
    email
    hasProcessingQuotes
    permissions {
      hasAccessToWebOrders
    }
    company {
      id
      code
      name
      pointOfSale {
        name
        phoneNumber
        id
        address {
          line1
          city
        }
        subsidiary {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAccountDrawer_CurrentUserQuery__
 *
 * To run a query within a React component, call `useAccountDrawer_CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDrawer_CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDrawer_CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountDrawer_CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>(AccountDrawer_CurrentUserDocument, options);
      }
export function useAccountDrawer_CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>(AccountDrawer_CurrentUserDocument, options);
        }
export function useAccountDrawer_CurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>(AccountDrawer_CurrentUserDocument, options);
        }
export type AccountDrawer_CurrentUserQueryHookResult = ReturnType<typeof useAccountDrawer_CurrentUserQuery>;
export type AccountDrawer_CurrentUserLazyQueryHookResult = ReturnType<typeof useAccountDrawer_CurrentUserLazyQuery>;
export type AccountDrawer_CurrentUserSuspenseQueryHookResult = ReturnType<typeof useAccountDrawer_CurrentUserSuspenseQuery>;
export type AccountDrawer_CurrentUserQueryResult = Apollo.QueryResult<AccountDrawer_CurrentUserQuery, AccountDrawer_CurrentUserQueryVariables>;
export const GetAccountHomeSliderDocument = gql`
    query GetAccountHomeSlider($isLoyaltyEnabled: Boolean!, $isQuoteEnabled: Boolean!) {
  currentUser {
    id
    orders(
      input: {pagination: {size: 5, index: 1}, filter: [{type: STRING_ARRAY, field: "status", operator: IN, stringArrayValue: ["COMPLETED", "CANCELED", "IN_PROGRESS"]}]}
    ) {
      items {
        ...OrderSummaryCard_Order
      }
    }
    permissions {
      ... on CollaboratorPermissions {
        canManageQuote @include(if: $isQuoteEnabled)
        showOrderHistory
        showStoreOrderHistory
        hasAccessToWebOrders
        hasAccessToStoreOrders
      }
    }
    loyalty @include(if: $isLoyaltyEnabled) {
      status
    }
  }
}
    ${OrderSummaryCard_OrderFragmentDoc}`;

/**
 * __useGetAccountHomeSliderQuery__
 *
 * To run a query within a React component, call `useGetAccountHomeSliderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountHomeSliderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountHomeSliderQuery({
 *   variables: {
 *      isLoyaltyEnabled: // value for 'isLoyaltyEnabled'
 *      isQuoteEnabled: // value for 'isQuoteEnabled'
 *   },
 * });
 */
export function useGetAccountHomeSliderQuery(baseOptions: Apollo.QueryHookOptions<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables> & ({ variables: GetAccountHomeSliderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>(GetAccountHomeSliderDocument, options);
      }
export function useGetAccountHomeSliderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>(GetAccountHomeSliderDocument, options);
        }
export function useGetAccountHomeSliderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>(GetAccountHomeSliderDocument, options);
        }
export type GetAccountHomeSliderQueryHookResult = ReturnType<typeof useGetAccountHomeSliderQuery>;
export type GetAccountHomeSliderLazyQueryHookResult = ReturnType<typeof useGetAccountHomeSliderLazyQuery>;
export type GetAccountHomeSliderSuspenseQueryHookResult = ReturnType<typeof useGetAccountHomeSliderSuspenseQuery>;
export type GetAccountHomeSliderQueryResult = Apollo.QueryResult<GetAccountHomeSliderQuery, GetAccountHomeSliderQueryVariables>;
export const GetAccountHomeSliderConfigDocument = gql`
    query GetAccountHomeSliderConfig {
  config {
    ...LoyaltyConfig
    ...QuickOrderConfig
    ...OrdersHistoryConfig
    quotation {
      isQuotationEnabled
    }
  }
}
    ${LoyaltyConfigFragmentDoc}
${QuickOrderConfigFragmentDoc}
${OrdersHistoryConfigFragmentDoc}`;

/**
 * __useGetAccountHomeSliderConfigQuery__
 *
 * To run a query within a React component, call `useGetAccountHomeSliderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountHomeSliderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountHomeSliderConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountHomeSliderConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>(GetAccountHomeSliderConfigDocument, options);
      }
export function useGetAccountHomeSliderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>(GetAccountHomeSliderConfigDocument, options);
        }
export function useGetAccountHomeSliderConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>(GetAccountHomeSliderConfigDocument, options);
        }
export type GetAccountHomeSliderConfigQueryHookResult = ReturnType<typeof useGetAccountHomeSliderConfigQuery>;
export type GetAccountHomeSliderConfigLazyQueryHookResult = ReturnType<typeof useGetAccountHomeSliderConfigLazyQuery>;
export type GetAccountHomeSliderConfigSuspenseQueryHookResult = ReturnType<typeof useGetAccountHomeSliderConfigSuspenseQuery>;
export type GetAccountHomeSliderConfigQueryResult = Apollo.QueryResult<GetAccountHomeSliderConfigQuery, GetAccountHomeSliderConfigQueryVariables>;
export const AccountHomeSliderMyQuotesTileDocument = gql`
    query AccountHomeSliderMyQuotesTile {
  currentUser {
    id
    hasProcessingQuotes
  }
}
    `;

/**
 * __useAccountHomeSliderMyQuotesTileQuery__
 *
 * To run a query within a React component, call `useAccountHomeSliderMyQuotesTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountHomeSliderMyQuotesTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountHomeSliderMyQuotesTileQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountHomeSliderMyQuotesTileQuery(baseOptions?: Apollo.QueryHookOptions<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>(AccountHomeSliderMyQuotesTileDocument, options);
      }
export function useAccountHomeSliderMyQuotesTileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>(AccountHomeSliderMyQuotesTileDocument, options);
        }
export function useAccountHomeSliderMyQuotesTileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>(AccountHomeSliderMyQuotesTileDocument, options);
        }
export type AccountHomeSliderMyQuotesTileQueryHookResult = ReturnType<typeof useAccountHomeSliderMyQuotesTileQuery>;
export type AccountHomeSliderMyQuotesTileLazyQueryHookResult = ReturnType<typeof useAccountHomeSliderMyQuotesTileLazyQuery>;
export type AccountHomeSliderMyQuotesTileSuspenseQueryHookResult = ReturnType<typeof useAccountHomeSliderMyQuotesTileSuspenseQuery>;
export type AccountHomeSliderMyQuotesTileQueryResult = Apollo.QueryResult<AccountHomeSliderMyQuotesTileQuery, AccountHomeSliderMyQuotesTileQueryVariables>;
export const DashboardProspectBenefitsCurrentUserDocument = gql`
    query DashboardProspectBenefitsCurrentUser {
  currentUser {
    id
    company {
      id
      isProspect
    }
    permissions {
      showOrderHistory
      canManageQuote
    }
  }
}
    `;

/**
 * __useDashboardProspectBenefitsCurrentUserQuery__
 *
 * To run a query within a React component, call `useDashboardProspectBenefitsCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardProspectBenefitsCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardProspectBenefitsCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardProspectBenefitsCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>(DashboardProspectBenefitsCurrentUserDocument, options);
      }
export function useDashboardProspectBenefitsCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>(DashboardProspectBenefitsCurrentUserDocument, options);
        }
export function useDashboardProspectBenefitsCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>(DashboardProspectBenefitsCurrentUserDocument, options);
        }
export type DashboardProspectBenefitsCurrentUserQueryHookResult = ReturnType<typeof useDashboardProspectBenefitsCurrentUserQuery>;
export type DashboardProspectBenefitsCurrentUserLazyQueryHookResult = ReturnType<typeof useDashboardProspectBenefitsCurrentUserLazyQuery>;
export type DashboardProspectBenefitsCurrentUserSuspenseQueryHookResult = ReturnType<typeof useDashboardProspectBenefitsCurrentUserSuspenseQuery>;
export type DashboardProspectBenefitsCurrentUserQueryResult = Apollo.QueryResult<DashboardProspectBenefitsCurrentUserQuery, DashboardProspectBenefitsCurrentUserQueryVariables>;
export const AccountSelectionDrawerCurrentUserAccountsDocument = gql`
    query AccountSelectionDrawerCurrentUserAccounts {
  currentUserAccounts(status: ACTIVE) {
    email
    ...AccountSelectionCurrentUserAccounts
  }
}
    ${AccountSelectionCurrentUserAccountsFragmentDoc}`;

/**
 * __useAccountSelectionDrawerCurrentUserAccountsQuery__
 *
 * To run a query within a React component, call `useAccountSelectionDrawerCurrentUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSelectionDrawerCurrentUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSelectionDrawerCurrentUserAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSelectionDrawerCurrentUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>(AccountSelectionDrawerCurrentUserAccountsDocument, options);
      }
export function useAccountSelectionDrawerCurrentUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>(AccountSelectionDrawerCurrentUserAccountsDocument, options);
        }
export function useAccountSelectionDrawerCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>(AccountSelectionDrawerCurrentUserAccountsDocument, options);
        }
export type AccountSelectionDrawerCurrentUserAccountsQueryHookResult = ReturnType<typeof useAccountSelectionDrawerCurrentUserAccountsQuery>;
export type AccountSelectionDrawerCurrentUserAccountsLazyQueryHookResult = ReturnType<typeof useAccountSelectionDrawerCurrentUserAccountsLazyQuery>;
export type AccountSelectionDrawerCurrentUserAccountsSuspenseQueryHookResult = ReturnType<typeof useAccountSelectionDrawerCurrentUserAccountsSuspenseQuery>;
export type AccountSelectionDrawerCurrentUserAccountsQueryResult = Apollo.QueryResult<AccountSelectionDrawerCurrentUserAccountsQuery, AccountSelectionDrawerCurrentUserAccountsQueryVariables>;
export const CompanyListCurrentUserAccountsDocument = gql`
    query CompanyListCurrentUserAccounts {
  currentUserAccounts(status: ACTIVE) {
    ...CompanyList_CurrentUserAccounts
  }
}
    ${CompanyList_CurrentUserAccountsFragmentDoc}`;

/**
 * __useCompanyListCurrentUserAccountsQuery__
 *
 * To run a query within a React component, call `useCompanyListCurrentUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListCurrentUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListCurrentUserAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyListCurrentUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>(CompanyListCurrentUserAccountsDocument, options);
      }
export function useCompanyListCurrentUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>(CompanyListCurrentUserAccountsDocument, options);
        }
export function useCompanyListCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>(CompanyListCurrentUserAccountsDocument, options);
        }
export type CompanyListCurrentUserAccountsQueryHookResult = ReturnType<typeof useCompanyListCurrentUserAccountsQuery>;
export type CompanyListCurrentUserAccountsLazyQueryHookResult = ReturnType<typeof useCompanyListCurrentUserAccountsLazyQuery>;
export type CompanyListCurrentUserAccountsSuspenseQueryHookResult = ReturnType<typeof useCompanyListCurrentUserAccountsSuspenseQuery>;
export type CompanyListCurrentUserAccountsQueryResult = Apollo.QueryResult<CompanyListCurrentUserAccountsQuery, CompanyListCurrentUserAccountsQueryVariables>;
export const RegistrationActionDocument = gql`
    query RegistrationAction($companyNationalId: String!, $isoCountryCode3: IsoCountryCode3) {
  registrationAction(
    companyNationalId: $companyNationalId
    isoCountryCode3: $isoCountryCode3
  )
}
    `;

/**
 * __useRegistrationActionQuery__
 *
 * To run a query within a React component, call `useRegistrationActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationActionQuery({
 *   variables: {
 *      companyNationalId: // value for 'companyNationalId'
 *      isoCountryCode3: // value for 'isoCountryCode3'
 *   },
 * });
 */
export function useRegistrationActionQuery(baseOptions: Apollo.QueryHookOptions<RegistrationActionQuery, RegistrationActionQueryVariables> & ({ variables: RegistrationActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationActionQuery, RegistrationActionQueryVariables>(RegistrationActionDocument, options);
      }
export function useRegistrationActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationActionQuery, RegistrationActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationActionQuery, RegistrationActionQueryVariables>(RegistrationActionDocument, options);
        }
export function useRegistrationActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegistrationActionQuery, RegistrationActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegistrationActionQuery, RegistrationActionQueryVariables>(RegistrationActionDocument, options);
        }
export type RegistrationActionQueryHookResult = ReturnType<typeof useRegistrationActionQuery>;
export type RegistrationActionLazyQueryHookResult = ReturnType<typeof useRegistrationActionLazyQuery>;
export type RegistrationActionSuspenseQueryHookResult = ReturnType<typeof useRegistrationActionSuspenseQuery>;
export type RegistrationActionQueryResult = Apollo.QueryResult<RegistrationActionQuery, RegistrationActionQueryVariables>;
export const CompanyNationalIdConfigurationDocument = gql`
    query CompanyNationalIdConfiguration {
  config {
    site {
      defaultCountryIso3
    }
    customer {
      companyNationalIdConfig {
        formatByCountry {
          ...CompanyNationalIdInput_CompanyNationalIdFormat
        }
      }
    }
  }
}
    ${CompanyNationalIdInput_CompanyNationalIdFormatFragmentDoc}`;

/**
 * __useCompanyNationalIdConfigurationQuery__
 *
 * To run a query within a React component, call `useCompanyNationalIdConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNationalIdConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNationalIdConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyNationalIdConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>(CompanyNationalIdConfigurationDocument, options);
      }
export function useCompanyNationalIdConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>(CompanyNationalIdConfigurationDocument, options);
        }
export function useCompanyNationalIdConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>(CompanyNationalIdConfigurationDocument, options);
        }
export type CompanyNationalIdConfigurationQueryHookResult = ReturnType<typeof useCompanyNationalIdConfigurationQuery>;
export type CompanyNationalIdConfigurationLazyQueryHookResult = ReturnType<typeof useCompanyNationalIdConfigurationLazyQuery>;
export type CompanyNationalIdConfigurationSuspenseQueryHookResult = ReturnType<typeof useCompanyNationalIdConfigurationSuspenseQuery>;
export type CompanyNationalIdConfigurationQueryResult = Apollo.QueryResult<CompanyNationalIdConfigurationQuery, CompanyNationalIdConfigurationQueryVariables>;
export const GetAccountIdByCompanyNationalIdDocument = gql`
    query GetAccountIdByCompanyNationalId($externalClientId: String!, $companyNationalId: String!) {
  validateStoreCompany(
    externalClientId: $externalClientId
    companyNationalId: $companyNationalId
  ) {
    isValid
  }
}
    `;

/**
 * __useGetAccountIdByCompanyNationalIdQuery__
 *
 * To run a query within a React component, call `useGetAccountIdByCompanyNationalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountIdByCompanyNationalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountIdByCompanyNationalIdQuery({
 *   variables: {
 *      externalClientId: // value for 'externalClientId'
 *      companyNationalId: // value for 'companyNationalId'
 *   },
 * });
 */
export function useGetAccountIdByCompanyNationalIdQuery(baseOptions: Apollo.QueryHookOptions<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables> & ({ variables: GetAccountIdByCompanyNationalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>(GetAccountIdByCompanyNationalIdDocument, options);
      }
export function useGetAccountIdByCompanyNationalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>(GetAccountIdByCompanyNationalIdDocument, options);
        }
export function useGetAccountIdByCompanyNationalIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>(GetAccountIdByCompanyNationalIdDocument, options);
        }
export type GetAccountIdByCompanyNationalIdQueryHookResult = ReturnType<typeof useGetAccountIdByCompanyNationalIdQuery>;
export type GetAccountIdByCompanyNationalIdLazyQueryHookResult = ReturnType<typeof useGetAccountIdByCompanyNationalIdLazyQuery>;
export type GetAccountIdByCompanyNationalIdSuspenseQueryHookResult = ReturnType<typeof useGetAccountIdByCompanyNationalIdSuspenseQuery>;
export type GetAccountIdByCompanyNationalIdQueryResult = Apollo.QueryResult<GetAccountIdByCompanyNationalIdQuery, GetAccountIdByCompanyNationalIdQueryVariables>;
export const IsDoaFormLoyaltyStatusEligibleDocument = gql`
    query isDoaFormLoyaltyStatusEligible($email: String!, $companyNationalId: String!) {
  isLoyaltyEligible(email: $email, siret: $companyNationalId)
}
    `;

/**
 * __useIsDoaFormLoyaltyStatusEligibleQuery__
 *
 * To run a query within a React component, call `useIsDoaFormLoyaltyStatusEligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDoaFormLoyaltyStatusEligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDoaFormLoyaltyStatusEligibleQuery({
 *   variables: {
 *      email: // value for 'email'
 *      companyNationalId: // value for 'companyNationalId'
 *   },
 * });
 */
export function useIsDoaFormLoyaltyStatusEligibleQuery(baseOptions: Apollo.QueryHookOptions<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables> & ({ variables: IsDoaFormLoyaltyStatusEligibleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>(IsDoaFormLoyaltyStatusEligibleDocument, options);
      }
export function useIsDoaFormLoyaltyStatusEligibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>(IsDoaFormLoyaltyStatusEligibleDocument, options);
        }
export function useIsDoaFormLoyaltyStatusEligibleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>(IsDoaFormLoyaltyStatusEligibleDocument, options);
        }
export type IsDoaFormLoyaltyStatusEligibleQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyStatusEligibleQuery>;
export type IsDoaFormLoyaltyStatusEligibleLazyQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyStatusEligibleLazyQuery>;
export type IsDoaFormLoyaltyStatusEligibleSuspenseQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyStatusEligibleSuspenseQuery>;
export type IsDoaFormLoyaltyStatusEligibleQueryResult = Apollo.QueryResult<IsDoaFormLoyaltyStatusEligibleQuery, IsDoaFormLoyaltyStatusEligibleQueryVariables>;
export const IsDoaFormLoyaltyEnabledDocument = gql`
    query isDoaFormLoyaltyEnabled {
  config {
    ...LoyaltyConfig
  }
}
    ${LoyaltyConfigFragmentDoc}`;

/**
 * __useIsDoaFormLoyaltyEnabledQuery__
 *
 * To run a query within a React component, call `useIsDoaFormLoyaltyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDoaFormLoyaltyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDoaFormLoyaltyEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsDoaFormLoyaltyEnabledQuery(baseOptions?: Apollo.QueryHookOptions<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>(IsDoaFormLoyaltyEnabledDocument, options);
      }
export function useIsDoaFormLoyaltyEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>(IsDoaFormLoyaltyEnabledDocument, options);
        }
export function useIsDoaFormLoyaltyEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>(IsDoaFormLoyaltyEnabledDocument, options);
        }
export type IsDoaFormLoyaltyEnabledQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyEnabledQuery>;
export type IsDoaFormLoyaltyEnabledLazyQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyEnabledLazyQuery>;
export type IsDoaFormLoyaltyEnabledSuspenseQueryHookResult = ReturnType<typeof useIsDoaFormLoyaltyEnabledSuspenseQuery>;
export type IsDoaFormLoyaltyEnabledQueryResult = Apollo.QueryResult<IsDoaFormLoyaltyEnabledQuery, IsDoaFormLoyaltyEnabledQueryVariables>;
export const CurrentUserDoaFormDocument = gql`
    query CurrentUserDOAForm {
  currentUser {
    id
    firstname
    lastname
    phone
  }
}
    `;

/**
 * __useCurrentUserDoaFormQuery__
 *
 * To run a query within a React component, call `useCurrentUserDoaFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDoaFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDoaFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserDoaFormQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>(CurrentUserDoaFormDocument, options);
      }
export function useCurrentUserDoaFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>(CurrentUserDoaFormDocument, options);
        }
export function useCurrentUserDoaFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>(CurrentUserDoaFormDocument, options);
        }
export type CurrentUserDoaFormQueryHookResult = ReturnType<typeof useCurrentUserDoaFormQuery>;
export type CurrentUserDoaFormLazyQueryHookResult = ReturnType<typeof useCurrentUserDoaFormLazyQuery>;
export type CurrentUserDoaFormSuspenseQueryHookResult = ReturnType<typeof useCurrentUserDoaFormSuspenseQuery>;
export type CurrentUserDoaFormQueryResult = Apollo.QueryResult<CurrentUserDoaFormQuery, CurrentUserDoaFormQueryVariables>;
export const CompanyNationalIdDocument = gql`
    query CompanyNationalId($companyNationalId: String!, $isoCountryCode3: IsoCountryCode3!) {
  companyNationalIdData(
    companyNationalId: $companyNationalId
    isoCountryCode3: $isoCountryCode3
  ) {
    city
    companyName
    isoCountryCode
    postalCode
    streetLine1
    streetLine2
  }
}
    `;

/**
 * __useCompanyNationalIdQuery__
 *
 * To run a query within a React component, call `useCompanyNationalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNationalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNationalIdQuery({
 *   variables: {
 *      companyNationalId: // value for 'companyNationalId'
 *      isoCountryCode3: // value for 'isoCountryCode3'
 *   },
 * });
 */
export function useCompanyNationalIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyNationalIdQuery, CompanyNationalIdQueryVariables> & ({ variables: CompanyNationalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>(CompanyNationalIdDocument, options);
      }
export function useCompanyNationalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>(CompanyNationalIdDocument, options);
        }
export function useCompanyNationalIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>(CompanyNationalIdDocument, options);
        }
export type CompanyNationalIdQueryHookResult = ReturnType<typeof useCompanyNationalIdQuery>;
export type CompanyNationalIdLazyQueryHookResult = ReturnType<typeof useCompanyNationalIdLazyQuery>;
export type CompanyNationalIdSuspenseQueryHookResult = ReturnType<typeof useCompanyNationalIdSuspenseQuery>;
export type CompanyNationalIdQueryResult = Apollo.QueryResult<CompanyNationalIdQuery, CompanyNationalIdQueryVariables>;
export const GetDocUserDocument = gql`
    query getDOCUser {
  currentUser {
    id
    firstname
    lastname
    phone
  }
}
    `;

/**
 * __useGetDocUserQuery__
 *
 * To run a query within a React component, call `useGetDocUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocUserQuery(baseOptions?: Apollo.QueryHookOptions<GetDocUserQuery, GetDocUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocUserQuery, GetDocUserQueryVariables>(GetDocUserDocument, options);
      }
export function useGetDocUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocUserQuery, GetDocUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocUserQuery, GetDocUserQueryVariables>(GetDocUserDocument, options);
        }
export function useGetDocUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocUserQuery, GetDocUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocUserQuery, GetDocUserQueryVariables>(GetDocUserDocument, options);
        }
export type GetDocUserQueryHookResult = ReturnType<typeof useGetDocUserQuery>;
export type GetDocUserLazyQueryHookResult = ReturnType<typeof useGetDocUserLazyQuery>;
export type GetDocUserSuspenseQueryHookResult = ReturnType<typeof useGetDocUserSuspenseQuery>;
export type GetDocUserQueryResult = Apollo.QueryResult<GetDocUserQuery, GetDocUserQueryVariables>;
export const DocFormPointsOfSaleByPostalCodeDocument = gql`
    query DocFormPointsOfSaleByPostalCode($searchPostalCode: String, $companyNationalId: String!) {
  pointOfSaleWithDistanceInvoice(
    searchPostalCode: $searchPostalCode
    companyNationalId: $companyNationalId
  ) {
    ...DOCForm_PointOfSale
  }
}
    ${DocForm_PointOfSaleFragmentDoc}`;

/**
 * __useDocFormPointsOfSaleByPostalCodeQuery__
 *
 * To run a query within a React component, call `useDocFormPointsOfSaleByPostalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocFormPointsOfSaleByPostalCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocFormPointsOfSaleByPostalCodeQuery({
 *   variables: {
 *      searchPostalCode: // value for 'searchPostalCode'
 *      companyNationalId: // value for 'companyNationalId'
 *   },
 * });
 */
export function useDocFormPointsOfSaleByPostalCodeQuery(baseOptions: Apollo.QueryHookOptions<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables> & ({ variables: DocFormPointsOfSaleByPostalCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>(DocFormPointsOfSaleByPostalCodeDocument, options);
      }
export function useDocFormPointsOfSaleByPostalCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>(DocFormPointsOfSaleByPostalCodeDocument, options);
        }
export function useDocFormPointsOfSaleByPostalCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>(DocFormPointsOfSaleByPostalCodeDocument, options);
        }
export type DocFormPointsOfSaleByPostalCodeQueryHookResult = ReturnType<typeof useDocFormPointsOfSaleByPostalCodeQuery>;
export type DocFormPointsOfSaleByPostalCodeLazyQueryHookResult = ReturnType<typeof useDocFormPointsOfSaleByPostalCodeLazyQuery>;
export type DocFormPointsOfSaleByPostalCodeSuspenseQueryHookResult = ReturnType<typeof useDocFormPointsOfSaleByPostalCodeSuspenseQuery>;
export type DocFormPointsOfSaleByPostalCodeQueryResult = Apollo.QueryResult<DocFormPointsOfSaleByPostalCodeQuery, DocFormPointsOfSaleByPostalCodeQueryVariables>;
export const BusinessContactExpressDocAllowedPhoneCountriesDocument = gql`
    query BusinessContactExpressDOCAllowedPhoneCountries {
  companyRegistrationRequestAvailableCountries {
    iso
  }
}
    `;

/**
 * __useBusinessContactExpressDocAllowedPhoneCountriesQuery__
 *
 * To run a query within a React component, call `useBusinessContactExpressDocAllowedPhoneCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessContactExpressDocAllowedPhoneCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessContactExpressDocAllowedPhoneCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessContactExpressDocAllowedPhoneCountriesQuery(baseOptions?: Apollo.QueryHookOptions<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>(BusinessContactExpressDocAllowedPhoneCountriesDocument, options);
      }
export function useBusinessContactExpressDocAllowedPhoneCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>(BusinessContactExpressDocAllowedPhoneCountriesDocument, options);
        }
export function useBusinessContactExpressDocAllowedPhoneCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>(BusinessContactExpressDocAllowedPhoneCountriesDocument, options);
        }
export type BusinessContactExpressDocAllowedPhoneCountriesQueryHookResult = ReturnType<typeof useBusinessContactExpressDocAllowedPhoneCountriesQuery>;
export type BusinessContactExpressDocAllowedPhoneCountriesLazyQueryHookResult = ReturnType<typeof useBusinessContactExpressDocAllowedPhoneCountriesLazyQuery>;
export type BusinessContactExpressDocAllowedPhoneCountriesSuspenseQueryHookResult = ReturnType<typeof useBusinessContactExpressDocAllowedPhoneCountriesSuspenseQuery>;
export type BusinessContactExpressDocAllowedPhoneCountriesQueryResult = Apollo.QueryResult<BusinessContactExpressDocAllowedPhoneCountriesQuery, BusinessContactExpressDocAllowedPhoneCountriesQueryVariables>;
export const VerifyCaptchaDocument = gql`
    mutation VerifyCaptcha($token: String!) {
  verifyCaptcha(token: $token)
}
    `;
export type VerifyCaptchaMutationFn = Apollo.MutationFunction<VerifyCaptchaMutation, VerifyCaptchaMutationVariables>;

/**
 * __useVerifyCaptchaMutation__
 *
 * To run a mutation, you first call `useVerifyCaptchaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCaptchaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCaptchaMutation, { data, loading, error }] = useVerifyCaptchaMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyCaptchaMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCaptchaMutation, VerifyCaptchaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCaptchaMutation, VerifyCaptchaMutationVariables>(VerifyCaptchaDocument, options);
      }
export type VerifyCaptchaMutationHookResult = ReturnType<typeof useVerifyCaptchaMutation>;
export type VerifyCaptchaMutationResult = Apollo.MutationResult<VerifyCaptchaMutation>;
export type VerifyCaptchaMutationOptions = Apollo.BaseMutationOptions<VerifyCaptchaMutation, VerifyCaptchaMutationVariables>;
export const LoginFormConfigDocument = gql`
    query LoginFormConfig {
  config {
    captcha {
      ...CaptchaConfig
    }
    support {
      isLoginAsEnabled
    }
  }
}
    ${CaptchaConfigFragmentDoc}`;

/**
 * __useLoginFormConfigQuery__
 *
 * To run a query within a React component, call `useLoginFormConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginFormConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginFormConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginFormConfigQuery(baseOptions?: Apollo.QueryHookOptions<LoginFormConfigQuery, LoginFormConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginFormConfigQuery, LoginFormConfigQueryVariables>(LoginFormConfigDocument, options);
      }
export function useLoginFormConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginFormConfigQuery, LoginFormConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginFormConfigQuery, LoginFormConfigQueryVariables>(LoginFormConfigDocument, options);
        }
export function useLoginFormConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginFormConfigQuery, LoginFormConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginFormConfigQuery, LoginFormConfigQueryVariables>(LoginFormConfigDocument, options);
        }
export type LoginFormConfigQueryHookResult = ReturnType<typeof useLoginFormConfigQuery>;
export type LoginFormConfigLazyQueryHookResult = ReturnType<typeof useLoginFormConfigLazyQuery>;
export type LoginFormConfigSuspenseQueryHookResult = ReturnType<typeof useLoginFormConfigSuspenseQuery>;
export type LoginFormConfigQueryResult = Apollo.QueryResult<LoginFormConfigQuery, LoginFormConfigQueryVariables>;
export const NavigationHubOrdersDocument = gql`
    query NavigationHubOrders {
  currentUser {
    id
    permissions {
      showOrderHistory
      showStoreOrderHistory
      hasAccessToWebOrders
    }
  }
  config {
    ...OrdersHistoryConfig
  }
}
    ${OrdersHistoryConfigFragmentDoc}`;

/**
 * __useNavigationHubOrdersQuery__
 *
 * To run a query within a React component, call `useNavigationHubOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationHubOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationHubOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationHubOrdersQuery(baseOptions?: Apollo.QueryHookOptions<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>(NavigationHubOrdersDocument, options);
      }
export function useNavigationHubOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>(NavigationHubOrdersDocument, options);
        }
export function useNavigationHubOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>(NavigationHubOrdersDocument, options);
        }
export type NavigationHubOrdersQueryHookResult = ReturnType<typeof useNavigationHubOrdersQuery>;
export type NavigationHubOrdersLazyQueryHookResult = ReturnType<typeof useNavigationHubOrdersLazyQuery>;
export type NavigationHubOrdersSuspenseQueryHookResult = ReturnType<typeof useNavigationHubOrdersSuspenseQuery>;
export type NavigationHubOrdersQueryResult = Apollo.QueryResult<NavigationHubOrdersQuery, NavigationHubOrdersQueryVariables>;
export const NavigationHubQuickOrderDocument = gql`
    query NavigationHubQuickOrder($isQuoteEnabled: Boolean!) {
  currentUser {
    id
    permissions {
      canManageQuote @include(if: $isQuoteEnabled)
    }
  }
  config {
    sales {
      isQuickOrderEnabled
    }
    quotation {
      isQuotationEnabled
    }
  }
}
    `;

/**
 * __useNavigationHubQuickOrderQuery__
 *
 * To run a query within a React component, call `useNavigationHubQuickOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationHubQuickOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationHubQuickOrderQuery({
 *   variables: {
 *      isQuoteEnabled: // value for 'isQuoteEnabled'
 *   },
 * });
 */
export function useNavigationHubQuickOrderQuery(baseOptions: Apollo.QueryHookOptions<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables> & ({ variables: NavigationHubQuickOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>(NavigationHubQuickOrderDocument, options);
      }
export function useNavigationHubQuickOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>(NavigationHubQuickOrderDocument, options);
        }
export function useNavigationHubQuickOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>(NavigationHubQuickOrderDocument, options);
        }
export type NavigationHubQuickOrderQueryHookResult = ReturnType<typeof useNavigationHubQuickOrderQuery>;
export type NavigationHubQuickOrderLazyQueryHookResult = ReturnType<typeof useNavigationHubQuickOrderLazyQuery>;
export type NavigationHubQuickOrderSuspenseQueryHookResult = ReturnType<typeof useNavigationHubQuickOrderSuspenseQuery>;
export type NavigationHubQuickOrderQueryResult = Apollo.QueryResult<NavigationHubQuickOrderQuery, NavigationHubQuickOrderQueryVariables>;
export const NavigationHubQuotesDocument = gql`
    query NavigationHubQuotes($isQuoteEnabled: Boolean!) {
  currentUser {
    id
    hasProcessingQuotes
    permissions {
      canManageQuote @include(if: $isQuoteEnabled)
    }
  }
  config {
    quotation {
      isQuotationEnabled
    }
  }
}
    `;

/**
 * __useNavigationHubQuotesQuery__
 *
 * To run a query within a React component, call `useNavigationHubQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationHubQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationHubQuotesQuery({
 *   variables: {
 *      isQuoteEnabled: // value for 'isQuoteEnabled'
 *   },
 * });
 */
export function useNavigationHubQuotesQuery(baseOptions: Apollo.QueryHookOptions<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables> & ({ variables: NavigationHubQuotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>(NavigationHubQuotesDocument, options);
      }
export function useNavigationHubQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>(NavigationHubQuotesDocument, options);
        }
export function useNavigationHubQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>(NavigationHubQuotesDocument, options);
        }
export type NavigationHubQuotesQueryHookResult = ReturnType<typeof useNavigationHubQuotesQuery>;
export type NavigationHubQuotesLazyQueryHookResult = ReturnType<typeof useNavigationHubQuotesLazyQuery>;
export type NavigationHubQuotesSuspenseQueryHookResult = ReturnType<typeof useNavigationHubQuotesSuspenseQuery>;
export type NavigationHubQuotesQueryResult = Apollo.QueryResult<NavigationHubQuotesQuery, NavigationHubQuotesQueryVariables>;
export const UsernameFormatDocument = gql`
    query UsernameFormat {
  config {
    customer {
      nameFormat {
        maxLength
        charset
        regex
      }
    }
  }
}
    `;

/**
 * __useUsernameFormatQuery__
 *
 * To run a query within a React component, call `useUsernameFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsernameFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsernameFormatQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsernameFormatQuery(baseOptions?: Apollo.QueryHookOptions<UsernameFormatQuery, UsernameFormatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsernameFormatQuery, UsernameFormatQueryVariables>(UsernameFormatDocument, options);
      }
export function useUsernameFormatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsernameFormatQuery, UsernameFormatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsernameFormatQuery, UsernameFormatQueryVariables>(UsernameFormatDocument, options);
        }
export function useUsernameFormatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsernameFormatQuery, UsernameFormatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsernameFormatQuery, UsernameFormatQueryVariables>(UsernameFormatDocument, options);
        }
export type UsernameFormatQueryHookResult = ReturnType<typeof useUsernameFormatQuery>;
export type UsernameFormatLazyQueryHookResult = ReturnType<typeof useUsernameFormatLazyQuery>;
export type UsernameFormatSuspenseQueryHookResult = ReturnType<typeof useUsernameFormatSuspenseQuery>;
export type UsernameFormatQueryResult = Apollo.QueryResult<UsernameFormatQuery, UsernameFormatQueryVariables>;
export const LoginActionDocument = gql`
    query LoginAction($email: Email!) {
  loginAction(email: $email) {
    action
    url
    email
  }
}
    `;

/**
 * __useLoginActionQuery__
 *
 * To run a query within a React component, call `useLoginActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginActionQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginActionQuery(baseOptions: Apollo.QueryHookOptions<LoginActionQuery, LoginActionQueryVariables> & ({ variables: LoginActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginActionQuery, LoginActionQueryVariables>(LoginActionDocument, options);
      }
export function useLoginActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginActionQuery, LoginActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginActionQuery, LoginActionQueryVariables>(LoginActionDocument, options);
        }
export function useLoginActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginActionQuery, LoginActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginActionQuery, LoginActionQueryVariables>(LoginActionDocument, options);
        }
export type LoginActionQueryHookResult = ReturnType<typeof useLoginActionQuery>;
export type LoginActionLazyQueryHookResult = ReturnType<typeof useLoginActionLazyQuery>;
export type LoginActionSuspenseQueryHookResult = ReturnType<typeof useLoginActionSuspenseQuery>;
export type LoginActionQueryResult = Apollo.QueryResult<LoginActionQuery, LoginActionQueryVariables>;
export const RequestUseRegistrationDocument = gql`
    mutation requestUseRegistration($input: UserRegistrationRequestInput!) {
  requestUserRegistration(input: $input) {
    email
    action
    company {
      ...RequestUseRegistration_Company
    }
    url
  }
}
    ${RequestUseRegistration_CompanyFragmentDoc}`;
export type RequestUseRegistrationMutationFn = Apollo.MutationFunction<RequestUseRegistrationMutation, RequestUseRegistrationMutationVariables>;

/**
 * __useRequestUseRegistrationMutation__
 *
 * To run a mutation, you first call `useRequestUseRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUseRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUseRegistrationMutation, { data, loading, error }] = useRequestUseRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestUseRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RequestUseRegistrationMutation, RequestUseRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUseRegistrationMutation, RequestUseRegistrationMutationVariables>(RequestUseRegistrationDocument, options);
      }
export type RequestUseRegistrationMutationHookResult = ReturnType<typeof useRequestUseRegistrationMutation>;
export type RequestUseRegistrationMutationResult = Apollo.MutationResult<RequestUseRegistrationMutation>;
export type RequestUseRegistrationMutationOptions = Apollo.BaseMutationOptions<RequestUseRegistrationMutation, RequestUseRegistrationMutationVariables>;
export const RequestCompanyRegistrationDocument = gql`
    mutation RequestCompanyRegistration($input: CompanyRegistrationRequestInput!) {
  requestCompanyRegistration(input: $input) {
    action
    url
    email
    company {
      ...RequestCompanyRegistration_CompanyRegistrationResult
    }
  }
}
    ${RequestCompanyRegistration_CompanyRegistrationResultFragmentDoc}`;
export type RequestCompanyRegistrationMutationFn = Apollo.MutationFunction<RequestCompanyRegistrationMutation, RequestCompanyRegistrationMutationVariables>;

/**
 * __useRequestCompanyRegistrationMutation__
 *
 * To run a mutation, you first call `useRequestCompanyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCompanyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCompanyRegistrationMutation, { data, loading, error }] = useRequestCompanyRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCompanyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RequestCompanyRegistrationMutation, RequestCompanyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCompanyRegistrationMutation, RequestCompanyRegistrationMutationVariables>(RequestCompanyRegistrationDocument, options);
      }
export type RequestCompanyRegistrationMutationHookResult = ReturnType<typeof useRequestCompanyRegistrationMutation>;
export type RequestCompanyRegistrationMutationResult = Apollo.MutationResult<RequestCompanyRegistrationMutation>;
export type RequestCompanyRegistrationMutationOptions = Apollo.BaseMutationOptions<RequestCompanyRegistrationMutation, RequestCompanyRegistrationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UserUpdateInput!) {
  updateUser(input: $input)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const SelectUserDocument = gql`
    mutation selectUser($userId: String!) {
  selectUser(userId: $userId)
}
    `;
export type SelectUserMutationFn = Apollo.MutationFunction<SelectUserMutation, SelectUserMutationVariables>;

/**
 * __useSelectUserMutation__
 *
 * To run a mutation, you first call `useSelectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectUserMutation, { data, loading, error }] = useSelectUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSelectUserMutation(baseOptions?: Apollo.MutationHookOptions<SelectUserMutation, SelectUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectUserMutation, SelectUserMutationVariables>(SelectUserDocument, options);
      }
export type SelectUserMutationHookResult = ReturnType<typeof useSelectUserMutation>;
export type SelectUserMutationResult = Apollo.MutationResult<SelectUserMutation>;
export type SelectUserMutationOptions = Apollo.BaseMutationOptions<SelectUserMutation, SelectUserMutationVariables>;
export const ProfessionActivitiesDocument = gql`
    query ProfessionActivities {
  professionActivities {
    ...Activity
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useProfessionActivitiesQuery__
 *
 * To run a query within a React component, call `useProfessionActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessionActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessionActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessionActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>(ProfessionActivitiesDocument, options);
      }
export function useProfessionActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>(ProfessionActivitiesDocument, options);
        }
export function useProfessionActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>(ProfessionActivitiesDocument, options);
        }
export type ProfessionActivitiesQueryHookResult = ReturnType<typeof useProfessionActivitiesQuery>;
export type ProfessionActivitiesLazyQueryHookResult = ReturnType<typeof useProfessionActivitiesLazyQuery>;
export type ProfessionActivitiesSuspenseQueryHookResult = ReturnType<typeof useProfessionActivitiesSuspenseQuery>;
export type ProfessionActivitiesQueryResult = Apollo.QueryResult<ProfessionActivitiesQuery, ProfessionActivitiesQueryVariables>;
export const UpdateFavoriteShippingAddressDocument = gql`
    mutation updateFavoriteShippingAddress($addressId: ID!) {
  updateFavoriteShippingAddress(addressId: $addressId)
}
    `;
export type UpdateFavoriteShippingAddressMutationFn = Apollo.MutationFunction<UpdateFavoriteShippingAddressMutation, UpdateFavoriteShippingAddressMutationVariables>;

/**
 * __useUpdateFavoriteShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteShippingAddressMutation, { data, loading, error }] = useUpdateFavoriteShippingAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useUpdateFavoriteShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteShippingAddressMutation, UpdateFavoriteShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteShippingAddressMutation, UpdateFavoriteShippingAddressMutationVariables>(UpdateFavoriteShippingAddressDocument, options);
      }
export type UpdateFavoriteShippingAddressMutationHookResult = ReturnType<typeof useUpdateFavoriteShippingAddressMutation>;
export type UpdateFavoriteShippingAddressMutationResult = Apollo.MutationResult<UpdateFavoriteShippingAddressMutation>;
export type UpdateFavoriteShippingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteShippingAddressMutation, UpdateFavoriteShippingAddressMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation deleteAddress($addressId: ID!) {
  deleteUserCompanyAddress(addressId: $addressId) {
    isActionDeferred
  }
}
    `;
export type DeleteAddressMutationFn = Apollo.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const AdressesContainerCurrentUserDocument = gql`
    query AdressesContainerCurrentUser {
  currentUser {
    id
    favoriteBillingAddress {
      ...UserCompanyAddress
    }
    favoriteShippingAddress {
      ...UserCompanyAddress
    }
    company {
      id
      addresses {
        ...UserCompanyAddress
      }
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;

/**
 * __useAdressesContainerCurrentUserQuery__
 *
 * To run a query within a React component, call `useAdressesContainerCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdressesContainerCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdressesContainerCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdressesContainerCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>(AdressesContainerCurrentUserDocument, options);
      }
export function useAdressesContainerCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>(AdressesContainerCurrentUserDocument, options);
        }
export function useAdressesContainerCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>(AdressesContainerCurrentUserDocument, options);
        }
export type AdressesContainerCurrentUserQueryHookResult = ReturnType<typeof useAdressesContainerCurrentUserQuery>;
export type AdressesContainerCurrentUserLazyQueryHookResult = ReturnType<typeof useAdressesContainerCurrentUserLazyQuery>;
export type AdressesContainerCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAdressesContainerCurrentUserSuspenseQuery>;
export type AdressesContainerCurrentUserQueryResult = Apollo.QueryResult<AdressesContainerCurrentUserQuery, AdressesContainerCurrentUserQueryVariables>;
export const UniversalAddressInputDataDocument = gql`
    query UniversalAddressInputData {
  availableCountries {
    iso
    iso3
    name
  }
  config {
    customer {
      allowedPostcodePrefixes
    }
  }
}
    `;

/**
 * __useUniversalAddressInputDataQuery__
 *
 * To run a query within a React component, call `useUniversalAddressInputDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalAddressInputDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalAddressInputDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUniversalAddressInputDataQuery(baseOptions?: Apollo.QueryHookOptions<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>(UniversalAddressInputDataDocument, options);
      }
export function useUniversalAddressInputDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>(UniversalAddressInputDataDocument, options);
        }
export function useUniversalAddressInputDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>(UniversalAddressInputDataDocument, options);
        }
export type UniversalAddressInputDataQueryHookResult = ReturnType<typeof useUniversalAddressInputDataQuery>;
export type UniversalAddressInputDataLazyQueryHookResult = ReturnType<typeof useUniversalAddressInputDataLazyQuery>;
export type UniversalAddressInputDataSuspenseQueryHookResult = ReturnType<typeof useUniversalAddressInputDataSuspenseQuery>;
export type UniversalAddressInputDataQueryResult = Apollo.QueryResult<UniversalAddressInputDataQuery, UniversalAddressInputDataQueryVariables>;
export const UniversalAddressInputSearchCitiesDocument = gql`
    query UniversalAddressInputSearchCities($isoCountryCode3: IsoCountryCode3!, $postalCode: String!) {
  searchCities(isoCountryCode3: $isoCountryCode3, postalCode: $postalCode) {
    cityId
    name
    postalCode
    isoCountryCode3
  }
}
    `;

/**
 * __useUniversalAddressInputSearchCitiesQuery__
 *
 * To run a query within a React component, call `useUniversalAddressInputSearchCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalAddressInputSearchCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalAddressInputSearchCitiesQuery({
 *   variables: {
 *      isoCountryCode3: // value for 'isoCountryCode3'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useUniversalAddressInputSearchCitiesQuery(baseOptions: Apollo.QueryHookOptions<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables> & ({ variables: UniversalAddressInputSearchCitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>(UniversalAddressInputSearchCitiesDocument, options);
      }
export function useUniversalAddressInputSearchCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>(UniversalAddressInputSearchCitiesDocument, options);
        }
export function useUniversalAddressInputSearchCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>(UniversalAddressInputSearchCitiesDocument, options);
        }
export type UniversalAddressInputSearchCitiesQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchCitiesQuery>;
export type UniversalAddressInputSearchCitiesLazyQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchCitiesLazyQuery>;
export type UniversalAddressInputSearchCitiesSuspenseQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchCitiesSuspenseQuery>;
export type UniversalAddressInputSearchCitiesQueryResult = Apollo.QueryResult<UniversalAddressInputSearchCitiesQuery, UniversalAddressInputSearchCitiesQueryVariables>;
export const UniversalAddressInputSearchAddressesDocument = gql`
    query UniversalAddressInputSearchAddresses($isoCountryCode3: IsoCountryCode3!, $cityId: String!, $address: String!) {
  searchAddresses(
    input: {isoCountryCode3: $isoCountryCode3, cityId: $cityId, address: $address}
  ) {
    streetNumber
    streetType
    streetName
    ...ServiceAddressMetadata
  }
}
    ${ServiceAddressMetadataFragmentDoc}`;

/**
 * __useUniversalAddressInputSearchAddressesQuery__
 *
 * To run a query within a React component, call `useUniversalAddressInputSearchAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalAddressInputSearchAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalAddressInputSearchAddressesQuery({
 *   variables: {
 *      isoCountryCode3: // value for 'isoCountryCode3'
 *      cityId: // value for 'cityId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUniversalAddressInputSearchAddressesQuery(baseOptions: Apollo.QueryHookOptions<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables> & ({ variables: UniversalAddressInputSearchAddressesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>(UniversalAddressInputSearchAddressesDocument, options);
      }
export function useUniversalAddressInputSearchAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>(UniversalAddressInputSearchAddressesDocument, options);
        }
export function useUniversalAddressInputSearchAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>(UniversalAddressInputSearchAddressesDocument, options);
        }
export type UniversalAddressInputSearchAddressesQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchAddressesQuery>;
export type UniversalAddressInputSearchAddressesLazyQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchAddressesLazyQuery>;
export type UniversalAddressInputSearchAddressesSuspenseQueryHookResult = ReturnType<typeof useUniversalAddressInputSearchAddressesSuspenseQuery>;
export type UniversalAddressInputSearchAddressesQueryResult = Apollo.QueryResult<UniversalAddressInputSearchAddressesQuery, UniversalAddressInputSearchAddressesQueryVariables>;
export const OpenAddressDrawerButtonCurrentUserDocument = gql`
    query OpenAddressDrawerButtonCurrentUser {
  currentUser {
    id
    favoriteBillingAddress {
      ...UserCompanyAddress
    }
    favoriteShippingAddress {
      ...UserCompanyAddress
    }
    company {
      id
      addresses {
        ...UserCompanyAddress
      }
    }
    permissions {
      canManageAddress
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;

/**
 * __useOpenAddressDrawerButtonCurrentUserQuery__
 *
 * To run a query within a React component, call `useOpenAddressDrawerButtonCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenAddressDrawerButtonCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenAddressDrawerButtonCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenAddressDrawerButtonCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>(OpenAddressDrawerButtonCurrentUserDocument, options);
      }
export function useOpenAddressDrawerButtonCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>(OpenAddressDrawerButtonCurrentUserDocument, options);
        }
export function useOpenAddressDrawerButtonCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>(OpenAddressDrawerButtonCurrentUserDocument, options);
        }
export type OpenAddressDrawerButtonCurrentUserQueryHookResult = ReturnType<typeof useOpenAddressDrawerButtonCurrentUserQuery>;
export type OpenAddressDrawerButtonCurrentUserLazyQueryHookResult = ReturnType<typeof useOpenAddressDrawerButtonCurrentUserLazyQuery>;
export type OpenAddressDrawerButtonCurrentUserSuspenseQueryHookResult = ReturnType<typeof useOpenAddressDrawerButtonCurrentUserSuspenseQuery>;
export type OpenAddressDrawerButtonCurrentUserQueryResult = Apollo.QueryResult<OpenAddressDrawerButtonCurrentUserQuery, OpenAddressDrawerButtonCurrentUserQueryVariables>;
export const SelectAddressCurrentUserDocument = gql`
    query SelectAddressCurrentUser {
  currentUser {
    id
    favoriteShippingAddress {
      id
      ...UserCompanyAddress
    }
    company {
      id
      addresses {
        ...UserCompanyAddress
      }
    }
    checkout {
      shipping {
        address {
          userCompanyAddress {
            id
          }
        }
      }
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;

/**
 * __useSelectAddressCurrentUserQuery__
 *
 * To run a query within a React component, call `useSelectAddressCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectAddressCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectAddressCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectAddressCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>(SelectAddressCurrentUserDocument, options);
      }
export function useSelectAddressCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>(SelectAddressCurrentUserDocument, options);
        }
export function useSelectAddressCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>(SelectAddressCurrentUserDocument, options);
        }
export type SelectAddressCurrentUserQueryHookResult = ReturnType<typeof useSelectAddressCurrentUserQuery>;
export type SelectAddressCurrentUserLazyQueryHookResult = ReturnType<typeof useSelectAddressCurrentUserLazyQuery>;
export type SelectAddressCurrentUserSuspenseQueryHookResult = ReturnType<typeof useSelectAddressCurrentUserSuspenseQuery>;
export type SelectAddressCurrentUserQueryResult = Apollo.QueryResult<SelectAddressCurrentUserQuery, SelectAddressCurrentUserQueryVariables>;
export const UpsertAddressDrawerCartDocument = gql`
    query UpsertAddressDrawerCart {
  currentUser {
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useUpsertAddressDrawerCartQuery__
 *
 * To run a query within a React component, call `useUpsertAddressDrawerCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpsertAddressDrawerCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpsertAddressDrawerCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpsertAddressDrawerCartQuery(baseOptions?: Apollo.QueryHookOptions<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>(UpsertAddressDrawerCartDocument, options);
      }
export function useUpsertAddressDrawerCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>(UpsertAddressDrawerCartDocument, options);
        }
export function useUpsertAddressDrawerCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>(UpsertAddressDrawerCartDocument, options);
        }
export type UpsertAddressDrawerCartQueryHookResult = ReturnType<typeof useUpsertAddressDrawerCartQuery>;
export type UpsertAddressDrawerCartLazyQueryHookResult = ReturnType<typeof useUpsertAddressDrawerCartLazyQuery>;
export type UpsertAddressDrawerCartSuspenseQueryHookResult = ReturnType<typeof useUpsertAddressDrawerCartSuspenseQuery>;
export type UpsertAddressDrawerCartQueryResult = Apollo.QueryResult<UpsertAddressDrawerCartQuery, UpsertAddressDrawerCartQueryVariables>;
export const GetCurrentUserNameDocument = gql`
    query GetCurrentUserName {
  currentUser {
    id
    firstname
    lastname
  }
}
    `;

/**
 * __useGetCurrentUserNameQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserNameQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
      }
export function useGetCurrentUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
        }
export function useGetCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
        }
export type GetCurrentUserNameQueryHookResult = ReturnType<typeof useGetCurrentUserNameQuery>;
export type GetCurrentUserNameLazyQueryHookResult = ReturnType<typeof useGetCurrentUserNameLazyQuery>;
export type GetCurrentUserNameSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserNameSuspenseQuery>;
export type GetCurrentUserNameQueryResult = Apollo.QueryResult<GetCurrentUserNameQuery, GetCurrentUserNameQueryVariables>;
export const CreateAddressDocument = gql`
    mutation createAddress($input: UserCompanyAddressInput!) {
  createUserCompanyAddress(input: $input) {
    isActionDeferred
    address {
      ...UserCompanyAddress
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($addressId: ID!, $input: UserCompanyAddressInput!, $cartId: String) {
  updateUserCompanyAddress(addressId: $addressId, input: $input, cartId: $cartId) {
    isActionDeferred
    address {
      id
      ...UserCompanyAddress
    }
  }
}
    ${UserCompanyAddressFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      input: // value for 'input'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const GetApprovalFlowsDocument = gql`
    query GetApprovalFlows($input: Browsing) {
  currentUser {
    id
    company {
      id
      ...ApprovalFlowTable_Company
    }
  }
}
    ${ApprovalFlowTable_CompanyFragmentDoc}`;

/**
 * __useGetApprovalFlowsQuery__
 *
 * To run a query within a React component, call `useGetApprovalFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalFlowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApprovalFlowsQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>(GetApprovalFlowsDocument, options);
      }
export function useGetApprovalFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>(GetApprovalFlowsDocument, options);
        }
export function useGetApprovalFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>(GetApprovalFlowsDocument, options);
        }
export type GetApprovalFlowsQueryHookResult = ReturnType<typeof useGetApprovalFlowsQuery>;
export type GetApprovalFlowsLazyQueryHookResult = ReturnType<typeof useGetApprovalFlowsLazyQuery>;
export type GetApprovalFlowsSuspenseQueryHookResult = ReturnType<typeof useGetApprovalFlowsSuspenseQuery>;
export type GetApprovalFlowsQueryResult = Apollo.QueryResult<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>;
export const GetUsersInApprovalFlowsDocument = gql`
    query getUsersInApprovalFlows {
  currentUser {
    id
    company {
      id
      usersInApprovalFlows {
        id
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useGetUsersInApprovalFlowsQuery__
 *
 * To run a query within a React component, call `useGetUsersInApprovalFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersInApprovalFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersInApprovalFlowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersInApprovalFlowsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>(GetUsersInApprovalFlowsDocument, options);
      }
export function useGetUsersInApprovalFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>(GetUsersInApprovalFlowsDocument, options);
        }
export function useGetUsersInApprovalFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>(GetUsersInApprovalFlowsDocument, options);
        }
export type GetUsersInApprovalFlowsQueryHookResult = ReturnType<typeof useGetUsersInApprovalFlowsQuery>;
export type GetUsersInApprovalFlowsLazyQueryHookResult = ReturnType<typeof useGetUsersInApprovalFlowsLazyQuery>;
export type GetUsersInApprovalFlowsSuspenseQueryHookResult = ReturnType<typeof useGetUsersInApprovalFlowsSuspenseQuery>;
export type GetUsersInApprovalFlowsQueryResult = Apollo.QueryResult<GetUsersInApprovalFlowsQuery, GetUsersInApprovalFlowsQueryVariables>;
export const ApproveesSelectDocument = gql`
    query ApproveesSelect($approvalFlowId: String) {
  currentUser {
    id
    company {
      id
      eligibleApprovees(approvalFlowId: $approvalFlowId) {
        firstname
        lastname
        id
      }
    }
  }
}
    `;

/**
 * __useApproveesSelectQuery__
 *
 * To run a query within a React component, call `useApproveesSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproveesSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproveesSelectQuery({
 *   variables: {
 *      approvalFlowId: // value for 'approvalFlowId'
 *   },
 * });
 */
export function useApproveesSelectQuery(baseOptions?: Apollo.QueryHookOptions<ApproveesSelectQuery, ApproveesSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproveesSelectQuery, ApproveesSelectQueryVariables>(ApproveesSelectDocument, options);
      }
export function useApproveesSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproveesSelectQuery, ApproveesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproveesSelectQuery, ApproveesSelectQueryVariables>(ApproveesSelectDocument, options);
        }
export function useApproveesSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApproveesSelectQuery, ApproveesSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApproveesSelectQuery, ApproveesSelectQueryVariables>(ApproveesSelectDocument, options);
        }
export type ApproveesSelectQueryHookResult = ReturnType<typeof useApproveesSelectQuery>;
export type ApproveesSelectLazyQueryHookResult = ReturnType<typeof useApproveesSelectLazyQuery>;
export type ApproveesSelectSuspenseQueryHookResult = ReturnType<typeof useApproveesSelectSuspenseQuery>;
export type ApproveesSelectQueryResult = Apollo.QueryResult<ApproveesSelectQuery, ApproveesSelectQueryVariables>;
export const ApproversSelectDocument = gql`
    query ApproversSelect {
  currentUser {
    id
    company {
      id
      eligibleApprovers {
        firstname
        lastname
        id
      }
    }
  }
}
    `;

/**
 * __useApproversSelectQuery__
 *
 * To run a query within a React component, call `useApproversSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproversSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproversSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useApproversSelectQuery(baseOptions?: Apollo.QueryHookOptions<ApproversSelectQuery, ApproversSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproversSelectQuery, ApproversSelectQueryVariables>(ApproversSelectDocument, options);
      }
export function useApproversSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproversSelectQuery, ApproversSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproversSelectQuery, ApproversSelectQueryVariables>(ApproversSelectDocument, options);
        }
export function useApproversSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApproversSelectQuery, ApproversSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApproversSelectQuery, ApproversSelectQueryVariables>(ApproversSelectDocument, options);
        }
export type ApproversSelectQueryHookResult = ReturnType<typeof useApproversSelectQuery>;
export type ApproversSelectLazyQueryHookResult = ReturnType<typeof useApproversSelectLazyQuery>;
export type ApproversSelectSuspenseQueryHookResult = ReturnType<typeof useApproversSelectSuspenseQuery>;
export type ApproversSelectQueryResult = Apollo.QueryResult<ApproversSelectQuery, ApproversSelectQueryVariables>;
export const UpdateApprovalFlowDocument = gql`
    mutation updateApprovalFlow($input: ApprovalFlowUpdateInput!) {
  updateApprovalFlow(input: $input)
}
    `;
export type UpdateApprovalFlowMutationFn = Apollo.MutationFunction<UpdateApprovalFlowMutation, UpdateApprovalFlowMutationVariables>;

/**
 * __useUpdateApprovalFlowMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalFlowMutation, { data, loading, error }] = useUpdateApprovalFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovalFlowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApprovalFlowMutation, UpdateApprovalFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApprovalFlowMutation, UpdateApprovalFlowMutationVariables>(UpdateApprovalFlowDocument, options);
      }
export type UpdateApprovalFlowMutationHookResult = ReturnType<typeof useUpdateApprovalFlowMutation>;
export type UpdateApprovalFlowMutationResult = Apollo.MutationResult<UpdateApprovalFlowMutation>;
export type UpdateApprovalFlowMutationOptions = Apollo.BaseMutationOptions<UpdateApprovalFlowMutation, UpdateApprovalFlowMutationVariables>;
export const CreateApprovalFlowDocument = gql`
    mutation createApprovalFlow($input: ApprovalFlowCreateInput!) {
  createApprovalFlow(input: $input)
}
    `;
export type CreateApprovalFlowMutationFn = Apollo.MutationFunction<CreateApprovalFlowMutation, CreateApprovalFlowMutationVariables>;

/**
 * __useCreateApprovalFlowMutation__
 *
 * To run a mutation, you first call `useCreateApprovalFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApprovalFlowMutation, { data, loading, error }] = useCreateApprovalFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApprovalFlowMutation(baseOptions?: Apollo.MutationHookOptions<CreateApprovalFlowMutation, CreateApprovalFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApprovalFlowMutation, CreateApprovalFlowMutationVariables>(CreateApprovalFlowDocument, options);
      }
export type CreateApprovalFlowMutationHookResult = ReturnType<typeof useCreateApprovalFlowMutation>;
export type CreateApprovalFlowMutationResult = Apollo.MutationResult<CreateApprovalFlowMutation>;
export type CreateApprovalFlowMutationOptions = Apollo.BaseMutationOptions<CreateApprovalFlowMutation, CreateApprovalFlowMutationVariables>;
export const DeleteApprovalFlowDocument = gql`
    mutation deleteApprovalFlow($approvalFlowId: ID!) {
  deleteApprovalFlow(id: $approvalFlowId)
}
    `;
export type DeleteApprovalFlowMutationFn = Apollo.MutationFunction<DeleteApprovalFlowMutation, DeleteApprovalFlowMutationVariables>;

/**
 * __useDeleteApprovalFlowMutation__
 *
 * To run a mutation, you first call `useDeleteApprovalFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApprovalFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApprovalFlowMutation, { data, loading, error }] = useDeleteApprovalFlowMutation({
 *   variables: {
 *      approvalFlowId: // value for 'approvalFlowId'
 *   },
 * });
 */
export function useDeleteApprovalFlowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApprovalFlowMutation, DeleteApprovalFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApprovalFlowMutation, DeleteApprovalFlowMutationVariables>(DeleteApprovalFlowDocument, options);
      }
export type DeleteApprovalFlowMutationHookResult = ReturnType<typeof useDeleteApprovalFlowMutation>;
export type DeleteApprovalFlowMutationResult = Apollo.MutationResult<DeleteApprovalFlowMutation>;
export type DeleteApprovalFlowMutationOptions = Apollo.BaseMutationOptions<DeleteApprovalFlowMutation, DeleteApprovalFlowMutationVariables>;
export const ImpersonationBannerDocument = gql`
    query ImpersonationBanner {
  currentUser {
    id
    company {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useImpersonationBannerQuery__
 *
 * To run a query within a React component, call `useImpersonationBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonationBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonationBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpersonationBannerQuery(baseOptions?: Apollo.QueryHookOptions<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>(ImpersonationBannerDocument, options);
      }
export function useImpersonationBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>(ImpersonationBannerDocument, options);
        }
export function useImpersonationBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>(ImpersonationBannerDocument, options);
        }
export type ImpersonationBannerQueryHookResult = ReturnType<typeof useImpersonationBannerQuery>;
export type ImpersonationBannerLazyQueryHookResult = ReturnType<typeof useImpersonationBannerLazyQuery>;
export type ImpersonationBannerSuspenseQueryHookResult = ReturnType<typeof useImpersonationBannerSuspenseQuery>;
export type ImpersonationBannerQueryResult = Apollo.QueryResult<ImpersonationBannerQuery, ImpersonationBannerQueryVariables>;
export const GenerateImpersonateAuthTokenDocument = gql`
    mutation GenerateImpersonateAuthToken($userId: String!) {
  generateImpersonateAuthToken(userId: $userId) {
    value
    maxAge
  }
}
    `;
export type GenerateImpersonateAuthTokenMutationFn = Apollo.MutationFunction<GenerateImpersonateAuthTokenMutation, GenerateImpersonateAuthTokenMutationVariables>;

/**
 * __useGenerateImpersonateAuthTokenMutation__
 *
 * To run a mutation, you first call `useGenerateImpersonateAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImpersonateAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImpersonateAuthTokenMutation, { data, loading, error }] = useGenerateImpersonateAuthTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateImpersonateAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateImpersonateAuthTokenMutation, GenerateImpersonateAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateImpersonateAuthTokenMutation, GenerateImpersonateAuthTokenMutationVariables>(GenerateImpersonateAuthTokenDocument, options);
      }
export type GenerateImpersonateAuthTokenMutationHookResult = ReturnType<typeof useGenerateImpersonateAuthTokenMutation>;
export type GenerateImpersonateAuthTokenMutationResult = Apollo.MutationResult<GenerateImpersonateAuthTokenMutation>;
export type GenerateImpersonateAuthTokenMutationOptions = Apollo.BaseMutationOptions<GenerateImpersonateAuthTokenMutation, GenerateImpersonateAuthTokenMutationVariables>;
export const AlreadyActiveAccountDocument = gql`
    query AlreadyActiveAccount($externalClientId: String!, $companyNationalId: String!) {
  validateStoreCompany(
    externalClientId: $externalClientId
    companyNationalId: $companyNationalId
  ) {
    company {
      ...AlreadyActiveAccount
    }
  }
}
    ${AlreadyActiveAccountFragmentDoc}`;

/**
 * __useAlreadyActiveAccountQuery__
 *
 * To run a query within a React component, call `useAlreadyActiveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlreadyActiveAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlreadyActiveAccountQuery({
 *   variables: {
 *      externalClientId: // value for 'externalClientId'
 *      companyNationalId: // value for 'companyNationalId'
 *   },
 * });
 */
export function useAlreadyActiveAccountQuery(baseOptions: Apollo.QueryHookOptions<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables> & ({ variables: AlreadyActiveAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>(AlreadyActiveAccountDocument, options);
      }
export function useAlreadyActiveAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>(AlreadyActiveAccountDocument, options);
        }
export function useAlreadyActiveAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>(AlreadyActiveAccountDocument, options);
        }
export type AlreadyActiveAccountQueryHookResult = ReturnType<typeof useAlreadyActiveAccountQuery>;
export type AlreadyActiveAccountLazyQueryHookResult = ReturnType<typeof useAlreadyActiveAccountLazyQuery>;
export type AlreadyActiveAccountSuspenseQueryHookResult = ReturnType<typeof useAlreadyActiveAccountSuspenseQuery>;
export type AlreadyActiveAccountQueryResult = Apollo.QueryResult<AlreadyActiveAccountQuery, AlreadyActiveAccountQueryVariables>;
export const PunchoutLoginDocument = gql`
    mutation PunchoutLogin($url: URL!, $body: String) {
  punchoutLogin(url: $url, body: $body) {
    token {
      ...PunchoutLogin_Token
    }
    additionalInformation {
      backToERPUrl
    }
  }
}
    ${PunchoutLogin_TokenFragmentDoc}`;
export type PunchoutLoginMutationFn = Apollo.MutationFunction<PunchoutLoginMutation, PunchoutLoginMutationVariables>;

/**
 * __usePunchoutLoginMutation__
 *
 * To run a mutation, you first call `usePunchoutLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePunchoutLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [punchoutLoginMutation, { data, loading, error }] = usePunchoutLoginMutation({
 *   variables: {
 *      url: // value for 'url'
 *      body: // value for 'body'
 *   },
 * });
 */
export function usePunchoutLoginMutation(baseOptions?: Apollo.MutationHookOptions<PunchoutLoginMutation, PunchoutLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PunchoutLoginMutation, PunchoutLoginMutationVariables>(PunchoutLoginDocument, options);
      }
export type PunchoutLoginMutationHookResult = ReturnType<typeof usePunchoutLoginMutation>;
export type PunchoutLoginMutationResult = Apollo.MutationResult<PunchoutLoginMutation>;
export type PunchoutLoginMutationOptions = Apollo.BaseMutationOptions<PunchoutLoginMutation, PunchoutLoginMutationVariables>;
export const GetPunchoutEnabledConfigDocument = gql`
    query GetPunchoutEnabledConfig {
  config {
    sales {
      isPunchoutEnabled
    }
  }
}
    `;

/**
 * __useGetPunchoutEnabledConfigQuery__
 *
 * To run a query within a React component, call `useGetPunchoutEnabledConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPunchoutEnabledConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPunchoutEnabledConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPunchoutEnabledConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>(GetPunchoutEnabledConfigDocument, options);
      }
export function useGetPunchoutEnabledConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>(GetPunchoutEnabledConfigDocument, options);
        }
export function useGetPunchoutEnabledConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>(GetPunchoutEnabledConfigDocument, options);
        }
export type GetPunchoutEnabledConfigQueryHookResult = ReturnType<typeof useGetPunchoutEnabledConfigQuery>;
export type GetPunchoutEnabledConfigLazyQueryHookResult = ReturnType<typeof useGetPunchoutEnabledConfigLazyQuery>;
export type GetPunchoutEnabledConfigSuspenseQueryHookResult = ReturnType<typeof useGetPunchoutEnabledConfigSuspenseQuery>;
export type GetPunchoutEnabledConfigQueryResult = Apollo.QueryResult<GetPunchoutEnabledConfigQuery, GetPunchoutEnabledConfigQueryVariables>;
export const BilltrustDocument = gql`
    query Billtrust {
  currentUser {
    billtrust {
      urlredirect
    }
  }
}
    `;

/**
 * __useBilltrustQuery__
 *
 * To run a query within a React component, call `useBilltrustQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilltrustQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilltrustQuery({
 *   variables: {
 *   },
 * });
 */
export function useBilltrustQuery(baseOptions?: Apollo.QueryHookOptions<BilltrustQuery, BilltrustQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BilltrustQuery, BilltrustQueryVariables>(BilltrustDocument, options);
      }
export function useBilltrustLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BilltrustQuery, BilltrustQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BilltrustQuery, BilltrustQueryVariables>(BilltrustDocument, options);
        }
export function useBilltrustSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BilltrustQuery, BilltrustQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BilltrustQuery, BilltrustQueryVariables>(BilltrustDocument, options);
        }
export type BilltrustQueryHookResult = ReturnType<typeof useBilltrustQuery>;
export type BilltrustLazyQueryHookResult = ReturnType<typeof useBilltrustLazyQuery>;
export type BilltrustSuspenseQueryHookResult = ReturnType<typeof useBilltrustSuspenseQuery>;
export type BilltrustQueryResult = Apollo.QueryResult<BilltrustQuery, BilltrustQueryVariables>;
export const GetBrandsDocument = gql`
    query GetBrands {
  brands {
    logo {
      ...FullPicture
    }
    name
    urlKey
  }
}
    ${FullPictureFragmentDoc}`;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export function useGetBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsSuspenseQueryHookResult = ReturnType<typeof useGetBrandsSuspenseQuery>;
export type GetBrandsQueryResult = Apollo.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const CartItemPaymentWarningDocument = gql`
    query CartItemPaymentWarning {
  currentUser {
    id
    checkout {
      payment {
        availableMethods {
          card {
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCartItemPaymentWarningQuery__
 *
 * To run a query within a React component, call `useCartItemPaymentWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemPaymentWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemPaymentWarningQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartItemPaymentWarningQuery(baseOptions?: Apollo.QueryHookOptions<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>(CartItemPaymentWarningDocument, options);
      }
export function useCartItemPaymentWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>(CartItemPaymentWarningDocument, options);
        }
export function useCartItemPaymentWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>(CartItemPaymentWarningDocument, options);
        }
export type CartItemPaymentWarningQueryHookResult = ReturnType<typeof useCartItemPaymentWarningQuery>;
export type CartItemPaymentWarningLazyQueryHookResult = ReturnType<typeof useCartItemPaymentWarningLazyQuery>;
export type CartItemPaymentWarningSuspenseQueryHookResult = ReturnType<typeof useCartItemPaymentWarningSuspenseQuery>;
export type CartItemPaymentWarningQueryResult = Apollo.QueryResult<CartItemPaymentWarningQuery, CartItemPaymentWarningQueryVariables>;
export const CartActionsCart_CartDocument = gql`
    query CartActionsCart_Cart {
  currentUser {
    id
    loginType
    checkout {
      cart {
        ...CartActionsCard_Cart
      }
    }
  }
}
    ${CartActionsCard_CartFragmentDoc}`;

/**
 * __useCartActionsCart_CartQuery__
 *
 * To run a query within a React component, call `useCartActionsCart_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartActionsCart_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartActionsCart_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartActionsCart_CartQuery(baseOptions?: Apollo.QueryHookOptions<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>(CartActionsCart_CartDocument, options);
      }
export function useCartActionsCart_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>(CartActionsCart_CartDocument, options);
        }
export function useCartActionsCart_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>(CartActionsCart_CartDocument, options);
        }
export type CartActionsCart_CartQueryHookResult = ReturnType<typeof useCartActionsCart_CartQuery>;
export type CartActionsCart_CartLazyQueryHookResult = ReturnType<typeof useCartActionsCart_CartLazyQuery>;
export type CartActionsCart_CartSuspenseQueryHookResult = ReturnType<typeof useCartActionsCart_CartSuspenseQuery>;
export type CartActionsCart_CartQueryResult = Apollo.QueryResult<CartActionsCart_CartQuery, CartActionsCart_CartQueryVariables>;
export const ExportCartIntoPunchoutFormatDocument = gql`
    mutation ExportCartIntoPunchoutFormat($format: PUNCHOUTFORMAT!) {
  exportCartIntoPunchoutFormat(format: $format) {
    filename
    content
    mimeType
  }
}
    `;
export type ExportCartIntoPunchoutFormatMutationFn = Apollo.MutationFunction<ExportCartIntoPunchoutFormatMutation, ExportCartIntoPunchoutFormatMutationVariables>;

/**
 * __useExportCartIntoPunchoutFormatMutation__
 *
 * To run a mutation, you first call `useExportCartIntoPunchoutFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCartIntoPunchoutFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCartIntoPunchoutFormatMutation, { data, loading, error }] = useExportCartIntoPunchoutFormatMutation({
 *   variables: {
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportCartIntoPunchoutFormatMutation(baseOptions?: Apollo.MutationHookOptions<ExportCartIntoPunchoutFormatMutation, ExportCartIntoPunchoutFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCartIntoPunchoutFormatMutation, ExportCartIntoPunchoutFormatMutationVariables>(ExportCartIntoPunchoutFormatDocument, options);
      }
export type ExportCartIntoPunchoutFormatMutationHookResult = ReturnType<typeof useExportCartIntoPunchoutFormatMutation>;
export type ExportCartIntoPunchoutFormatMutationResult = Apollo.MutationResult<ExportCartIntoPunchoutFormatMutation>;
export type ExportCartIntoPunchoutFormatMutationOptions = Apollo.BaseMutationOptions<ExportCartIntoPunchoutFormatMutation, ExportCartIntoPunchoutFormatMutationVariables>;
export const CartSummaryPricingDocument = gql`
    query CartSummaryPricing($webRef: String!, $isOrderRequest: Boolean!) {
  currentUser {
    checkout @skip(if: $isOrderRequest) {
      cart(forceRefresh: false) {
        ...CartSummaryPricing_Cart
      }
      shipping {
        ...CartSummaryPricing_Shipping
      }
    }
    orderRequests(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $webRef}]}
    ) @include(if: $isOrderRequest) {
      items {
        ...CartSummaryPricing_Order
        subtotalExclTax
        payment {
          orderReference
        }
      }
    }
  }
}
    ${CartSummaryPricing_CartFragmentDoc}
${CartSummaryPricing_ShippingFragmentDoc}
${CartSummaryPricing_OrderFragmentDoc}`;

/**
 * __useCartSummaryPricingQuery__
 *
 * To run a query within a React component, call `useCartSummaryPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartSummaryPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartSummaryPricingQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *      isOrderRequest: // value for 'isOrderRequest'
 *   },
 * });
 */
export function useCartSummaryPricingQuery(baseOptions: Apollo.QueryHookOptions<CartSummaryPricingQuery, CartSummaryPricingQueryVariables> & ({ variables: CartSummaryPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>(CartSummaryPricingDocument, options);
      }
export function useCartSummaryPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>(CartSummaryPricingDocument, options);
        }
export function useCartSummaryPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>(CartSummaryPricingDocument, options);
        }
export type CartSummaryPricingQueryHookResult = ReturnType<typeof useCartSummaryPricingQuery>;
export type CartSummaryPricingLazyQueryHookResult = ReturnType<typeof useCartSummaryPricingLazyQuery>;
export type CartSummaryPricingSuspenseQueryHookResult = ReturnType<typeof useCartSummaryPricingSuspenseQuery>;
export type CartSummaryPricingQueryResult = Apollo.QueryResult<CartSummaryPricingQuery, CartSummaryPricingQueryVariables>;
export const CartSummaryDocument = gql`
    query CartSummary {
  currentUser {
    id
    role
    checkout {
      cart {
        id
        ...CartSummary_Cart
      }
      shipping {
        ...CartSummary_Shipping
      }
    }
  }
}
    ${CartSummary_CartFragmentDoc}
${CartSummary_ShippingFragmentDoc}`;

/**
 * __useCartSummaryQuery__
 *
 * To run a query within a React component, call `useCartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartSummaryQuery(baseOptions?: Apollo.QueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
      }
export function useCartSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
        }
export function useCartSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
        }
export type CartSummaryQueryHookResult = ReturnType<typeof useCartSummaryQuery>;
export type CartSummaryLazyQueryHookResult = ReturnType<typeof useCartSummaryLazyQuery>;
export type CartSummarySuspenseQueryHookResult = ReturnType<typeof useCartSummarySuspenseQuery>;
export type CartSummaryQueryResult = Apollo.QueryResult<CartSummaryQuery, CartSummaryQueryVariables>;
export const CartDocument = gql`
    query Cart {
  currentUser {
    id
    role
    loginType
    checkout {
      ...Cart_Checkout
    }
    ...CheckoutCartForm_User
  }
}
    ${Cart_CheckoutFragmentDoc}
${CheckoutCartForm_UserFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export function useCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartSuspenseQueryHookResult = ReturnType<typeof useCartSuspenseQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const AddProductReference_AddProductToCartDocument = gql`
    mutation AddProductReference_AddProductToCart($reference: String!, $quantity: Int!, $cartId: String!) {
  addProductToCart(reference: $reference, quantity: $quantity, cartId: $cartId) {
    cart {
      ...CartItem_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
      ...ClickAndCollectSwitchBanner_Cart
      isClickAndCollectToggleAvailable
      isClickAndCollectFeatureAvailable
      messages {
        code
      }
      items {
        id
        availableClickAndCollect
        product {
          reference
          name
        }
        quantity
      }
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItem_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ClickAndCollectSwitchBanner_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type AddProductReference_AddProductToCartMutationFn = Apollo.MutationFunction<AddProductReference_AddProductToCartMutation, AddProductReference_AddProductToCartMutationVariables>;

/**
 * __useAddProductReference_AddProductToCartMutation__
 *
 * To run a mutation, you first call `useAddProductReference_AddProductToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductReference_AddProductToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductReferenceAddProductToCartMutation, { data, loading, error }] = useAddProductReference_AddProductToCartMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *      quantity: // value for 'quantity'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAddProductReference_AddProductToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductReference_AddProductToCartMutation, AddProductReference_AddProductToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductReference_AddProductToCartMutation, AddProductReference_AddProductToCartMutationVariables>(AddProductReference_AddProductToCartDocument, options);
      }
export type AddProductReference_AddProductToCartMutationHookResult = ReturnType<typeof useAddProductReference_AddProductToCartMutation>;
export type AddProductReference_AddProductToCartMutationResult = Apollo.MutationResult<AddProductReference_AddProductToCartMutation>;
export type AddProductReference_AddProductToCartMutationOptions = Apollo.BaseMutationOptions<AddProductReference_AddProductToCartMutation, AddProductReference_AddProductToCartMutationVariables>;
export const UpdateCartItemQuantityDocument = gql`
    mutation UpdateCartItemQuantity($cartId: String!, $cartItemUid: UUID!, $quantity: Float!) {
  updateCartItemQuantity(
    cartId: $cartId
    cartItemUid: $cartItemUid
    quantity: $quantity
  ) {
    willGenerateOrderRequest
    cart {
      ...CartItem_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
      ...ClickAndCollectSwitchBanner_Cart
      ...MiniCart_Cart
      ...MiniCartButton_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItem_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ClickAndCollectSwitchBanner_CartFragmentDoc}
${MiniCart_CartFragmentDoc}
${MiniCartButton_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type UpdateCartItemQuantityMutationFn = Apollo.MutationFunction<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;

/**
 * __useUpdateCartItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemQuantityMutation, { data, loading, error }] = useUpdateCartItemQuantityMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      cartItemUid: // value for 'cartItemUid'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateCartItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>(UpdateCartItemQuantityDocument, options);
      }
export type UpdateCartItemQuantityMutationHookResult = ReturnType<typeof useUpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationResult = Apollo.MutationResult<UpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($cartId: String!, $cartItemUid: UUID!) {
  removeItemFromCart(cartId: $cartId, cartItemUid: $cartItemUid) {
    cart {
      ...CartItem_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
      totalQuantity
      sumItemsQuantity
      availableClickAndCollectQuantity
      isClickAndCollectActivated
      isClickAndCollectFeatureAvailable
      isClickAndCollectToggleAvailable
      ...MiniCart_Cart
      ...MiniCartButton_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItem_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${MiniCart_CartFragmentDoc}
${MiniCartButton_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type RemoveItemFromCartMutationFn = Apollo.MutationFunction<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;

/**
 * __useRemoveItemFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromCartMutation, { data, loading, error }] = useRemoveItemFromCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      cartItemUid: // value for 'cartItemUid'
 *   },
 * });
 */
export function useRemoveItemFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument, options);
      }
export type RemoveItemFromCartMutationHookResult = ReturnType<typeof useRemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationResult = Apollo.MutationResult<RemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;
export const CartItemsWarnings_CartDocument = gql`
    query CartItemsWarnings_Cart {
  currentUser {
    id
    checkout {
      cart(forceRefresh: true) {
        ...CartItemsWarnings_Cart
      }
    }
  }
}
    ${CartItemsWarnings_CartFragmentDoc}`;

/**
 * __useCartItemsWarnings_CartQuery__
 *
 * To run a query within a React component, call `useCartItemsWarnings_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemsWarnings_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemsWarnings_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartItemsWarnings_CartQuery(baseOptions?: Apollo.QueryHookOptions<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>(CartItemsWarnings_CartDocument, options);
      }
export function useCartItemsWarnings_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>(CartItemsWarnings_CartDocument, options);
        }
export function useCartItemsWarnings_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>(CartItemsWarnings_CartDocument, options);
        }
export type CartItemsWarnings_CartQueryHookResult = ReturnType<typeof useCartItemsWarnings_CartQuery>;
export type CartItemsWarnings_CartLazyQueryHookResult = ReturnType<typeof useCartItemsWarnings_CartLazyQuery>;
export type CartItemsWarnings_CartSuspenseQueryHookResult = ReturnType<typeof useCartItemsWarnings_CartSuspenseQuery>;
export type CartItemsWarnings_CartQueryResult = Apollo.QueryResult<CartItemsWarnings_CartQuery, CartItemsWarnings_CartQueryVariables>;
export const UpdateStocksAndPricesOnCartDocument = gql`
    mutation UpdateStocksAndPricesOnCart($cartId: String!) {
  updateStocksAndPricesOnCart(cartId: $cartId) {
    cart {
      ...CartItems_Cart
      ...CartItemsWarnings_Cart
      ...CartSummary_Cart
      sumItemsQuantity
      availableClickAndCollectQuantity
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItems_CartFragmentDoc}
${CartItemsWarnings_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type UpdateStocksAndPricesOnCartMutationFn = Apollo.MutationFunction<UpdateStocksAndPricesOnCartMutation, UpdateStocksAndPricesOnCartMutationVariables>;

/**
 * __useUpdateStocksAndPricesOnCartMutation__
 *
 * To run a mutation, you first call `useUpdateStocksAndPricesOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStocksAndPricesOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStocksAndPricesOnCartMutation, { data, loading, error }] = useUpdateStocksAndPricesOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useUpdateStocksAndPricesOnCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStocksAndPricesOnCartMutation, UpdateStocksAndPricesOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStocksAndPricesOnCartMutation, UpdateStocksAndPricesOnCartMutationVariables>(UpdateStocksAndPricesOnCartDocument, options);
      }
export type UpdateStocksAndPricesOnCartMutationHookResult = ReturnType<typeof useUpdateStocksAndPricesOnCartMutation>;
export type UpdateStocksAndPricesOnCartMutationResult = Apollo.MutationResult<UpdateStocksAndPricesOnCartMutation>;
export type UpdateStocksAndPricesOnCartMutationOptions = Apollo.BaseMutationOptions<UpdateStocksAndPricesOnCartMutation, UpdateStocksAndPricesOnCartMutationVariables>;
export const CheckoutCartSubmit_UpdateStocksAndPricesDocument = gql`
    mutation CheckoutCartSubmit_UpdateStocksAndPrices($cartId: String!) {
  updateStocksAndPricesOnCart(cartId: $cartId) {
    ...Shipping_Checkout
  }
}
    ${Shipping_CheckoutFragmentDoc}`;
export type CheckoutCartSubmit_UpdateStocksAndPricesMutationFn = Apollo.MutationFunction<CheckoutCartSubmit_UpdateStocksAndPricesMutation, CheckoutCartSubmit_UpdateStocksAndPricesMutationVariables>;

/**
 * __useCheckoutCartSubmit_UpdateStocksAndPricesMutation__
 *
 * To run a mutation, you first call `useCheckoutCartSubmit_UpdateStocksAndPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCartSubmit_UpdateStocksAndPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCartSubmitUpdateStocksAndPricesMutation, { data, loading, error }] = useCheckoutCartSubmit_UpdateStocksAndPricesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCheckoutCartSubmit_UpdateStocksAndPricesMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutCartSubmit_UpdateStocksAndPricesMutation, CheckoutCartSubmit_UpdateStocksAndPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutCartSubmit_UpdateStocksAndPricesMutation, CheckoutCartSubmit_UpdateStocksAndPricesMutationVariables>(CheckoutCartSubmit_UpdateStocksAndPricesDocument, options);
      }
export type CheckoutCartSubmit_UpdateStocksAndPricesMutationHookResult = ReturnType<typeof useCheckoutCartSubmit_UpdateStocksAndPricesMutation>;
export type CheckoutCartSubmit_UpdateStocksAndPricesMutationResult = Apollo.MutationResult<CheckoutCartSubmit_UpdateStocksAndPricesMutation>;
export type CheckoutCartSubmit_UpdateStocksAndPricesMutationOptions = Apollo.BaseMutationOptions<CheckoutCartSubmit_UpdateStocksAndPricesMutation, CheckoutCartSubmit_UpdateStocksAndPricesMutationVariables>;
export const EmptyCart_CartDocument = gql`
    query EmptyCart_Cart {
  currentUser {
    id
    checkout {
      cart {
        id
        totalQuantity
        messages {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useEmptyCart_CartQuery__
 *
 * To run a query within a React component, call `useEmptyCart_CartQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmptyCart_CartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptyCart_CartQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmptyCart_CartQuery(baseOptions?: Apollo.QueryHookOptions<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>(EmptyCart_CartDocument, options);
      }
export function useEmptyCart_CartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>(EmptyCart_CartDocument, options);
        }
export function useEmptyCart_CartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>(EmptyCart_CartDocument, options);
        }
export type EmptyCart_CartQueryHookResult = ReturnType<typeof useEmptyCart_CartQuery>;
export type EmptyCart_CartLazyQueryHookResult = ReturnType<typeof useEmptyCart_CartLazyQuery>;
export type EmptyCart_CartSuspenseQueryHookResult = ReturnType<typeof useEmptyCart_CartSuspenseQuery>;
export type EmptyCart_CartQueryResult = Apollo.QueryResult<EmptyCart_CartQuery, EmptyCart_CartQueryVariables>;
export const SetIsClickAndCollectOnCartDocument = gql`
    mutation setIsClickAndCollectOnCart($cartId: String!, $isClickAndCollect: Boolean!) {
  setIsClickAndCollectOnCart(
    cartId: $cartId
    isClickAndCollect: $isClickAndCollect
  ) {
    ...Cart_Checkout
    cart(forceRefresh: true) {
      ...ClickAndCollectSwitchBanner_Cart
      ...CartSummary_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${Cart_CheckoutFragmentDoc}
${ClickAndCollectSwitchBanner_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type SetIsClickAndCollectOnCartMutationFn = Apollo.MutationFunction<SetIsClickAndCollectOnCartMutation, SetIsClickAndCollectOnCartMutationVariables>;

/**
 * __useSetIsClickAndCollectOnCartMutation__
 *
 * To run a mutation, you first call `useSetIsClickAndCollectOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIsClickAndCollectOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIsClickAndCollectOnCartMutation, { data, loading, error }] = useSetIsClickAndCollectOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      isClickAndCollect: // value for 'isClickAndCollect'
 *   },
 * });
 */
export function useSetIsClickAndCollectOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetIsClickAndCollectOnCartMutation, SetIsClickAndCollectOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIsClickAndCollectOnCartMutation, SetIsClickAndCollectOnCartMutationVariables>(SetIsClickAndCollectOnCartDocument, options);
      }
export type SetIsClickAndCollectOnCartMutationHookResult = ReturnType<typeof useSetIsClickAndCollectOnCartMutation>;
export type SetIsClickAndCollectOnCartMutationResult = Apollo.MutationResult<SetIsClickAndCollectOnCartMutation>;
export type SetIsClickAndCollectOnCartMutationOptions = Apollo.BaseMutationOptions<SetIsClickAndCollectOnCartMutation, SetIsClickAndCollectOnCartMutationVariables>;
export const ClearCartItemsDocument = gql`
    mutation clearCartItems($cartId: String!) {
  clearCartItems(cartId: $cartId)
}
    `;
export type ClearCartItemsMutationFn = Apollo.MutationFunction<ClearCartItemsMutation, ClearCartItemsMutationVariables>;

/**
 * __useClearCartItemsMutation__
 *
 * To run a mutation, you first call `useClearCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCartItemsMutation, { data, loading, error }] = useClearCartItemsMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useClearCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<ClearCartItemsMutation, ClearCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCartItemsMutation, ClearCartItemsMutationVariables>(ClearCartItemsDocument, options);
      }
export type ClearCartItemsMutationHookResult = ReturnType<typeof useClearCartItemsMutation>;
export type ClearCartItemsMutationResult = Apollo.MutationResult<ClearCartItemsMutation>;
export type ClearCartItemsMutationOptions = Apollo.BaseMutationOptions<ClearCartItemsMutation, ClearCartItemsMutationVariables>;
export const UpdateClickAndCollectCartItemsQuantitiesDocument = gql`
    mutation UpdateClickAndCollectCartItemsQuantities($cartId: String!, $cartItems: [ClickAndCollectCartItemUpdateInput!]!) {
  updateClickAndCollectCartItemsQuantities(cartId: $cartId, cartItems: $cartItems) {
    cart {
      id
      ...Cart_Cart
      ...ClickAndCollectSwitchBanner_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
      items {
        id
        quantity
        ...ResolveClickAndCollectOfCartItemsDrawer_Items
      }
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${Cart_CartFragmentDoc}
${ClickAndCollectSwitchBanner_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ResolveClickAndCollectOfCartItemsDrawer_ItemsFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type UpdateClickAndCollectCartItemsQuantitiesMutationFn = Apollo.MutationFunction<UpdateClickAndCollectCartItemsQuantitiesMutation, UpdateClickAndCollectCartItemsQuantitiesMutationVariables>;

/**
 * __useUpdateClickAndCollectCartItemsQuantitiesMutation__
 *
 * To run a mutation, you first call `useUpdateClickAndCollectCartItemsQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClickAndCollectCartItemsQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClickAndCollectCartItemsQuantitiesMutation, { data, loading, error }] = useUpdateClickAndCollectCartItemsQuantitiesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      cartItems: // value for 'cartItems'
 *   },
 * });
 */
export function useUpdateClickAndCollectCartItemsQuantitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClickAndCollectCartItemsQuantitiesMutation, UpdateClickAndCollectCartItemsQuantitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClickAndCollectCartItemsQuantitiesMutation, UpdateClickAndCollectCartItemsQuantitiesMutationVariables>(UpdateClickAndCollectCartItemsQuantitiesDocument, options);
      }
export type UpdateClickAndCollectCartItemsQuantitiesMutationHookResult = ReturnType<typeof useUpdateClickAndCollectCartItemsQuantitiesMutation>;
export type UpdateClickAndCollectCartItemsQuantitiesMutationResult = Apollo.MutationResult<UpdateClickAndCollectCartItemsQuantitiesMutation>;
export type UpdateClickAndCollectCartItemsQuantitiesMutationOptions = Apollo.BaseMutationOptions<UpdateClickAndCollectCartItemsQuantitiesMutation, UpdateClickAndCollectCartItemsQuantitiesMutationVariables>;
export const MiniCartDocument = gql`
    query MiniCart {
  currentUser {
    checkout {
      cart(forceRefresh: false) {
        ...MiniCart_Cart
        ...CartSummaryPricing_Cart
      }
    }
  }
}
    ${MiniCart_CartFragmentDoc}
${CartSummaryPricing_CartFragmentDoc}`;

/**
 * __useMiniCartQuery__
 *
 * To run a query within a React component, call `useMiniCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiniCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiniCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useMiniCartQuery(baseOptions?: Apollo.QueryHookOptions<MiniCartQuery, MiniCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiniCartQuery, MiniCartQueryVariables>(MiniCartDocument, options);
      }
export function useMiniCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiniCartQuery, MiniCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiniCartQuery, MiniCartQueryVariables>(MiniCartDocument, options);
        }
export function useMiniCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MiniCartQuery, MiniCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MiniCartQuery, MiniCartQueryVariables>(MiniCartDocument, options);
        }
export type MiniCartQueryHookResult = ReturnType<typeof useMiniCartQuery>;
export type MiniCartLazyQueryHookResult = ReturnType<typeof useMiniCartLazyQuery>;
export type MiniCartSuspenseQueryHookResult = ReturnType<typeof useMiniCartSuspenseQuery>;
export type MiniCartQueryResult = Apollo.QueryResult<MiniCartQuery, MiniCartQueryVariables>;
export const UseCartIdDocument = gql`
    query UseCartId {
  currentUser {
    id
    checkout {
      cart(forceRefresh: false) {
        id
      }
    }
  }
}
    `;

/**
 * __useUseCartIdQuery__
 *
 * To run a query within a React component, call `useUseCartIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCartIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCartIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseCartIdQuery(baseOptions?: Apollo.QueryHookOptions<UseCartIdQuery, UseCartIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseCartIdQuery, UseCartIdQueryVariables>(UseCartIdDocument, options);
      }
export function useUseCartIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseCartIdQuery, UseCartIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseCartIdQuery, UseCartIdQueryVariables>(UseCartIdDocument, options);
        }
export function useUseCartIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseCartIdQuery, UseCartIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseCartIdQuery, UseCartIdQueryVariables>(UseCartIdDocument, options);
        }
export type UseCartIdQueryHookResult = ReturnType<typeof useUseCartIdQuery>;
export type UseCartIdLazyQueryHookResult = ReturnType<typeof useUseCartIdLazyQuery>;
export type UseCartIdSuspenseQueryHookResult = ReturnType<typeof useUseCartIdSuspenseQuery>;
export type UseCartIdQueryResult = Apollo.QueryResult<UseCartIdQuery, UseCartIdQueryVariables>;
export const AddToCartTrackingDocument = gql`
    query AddToCartTracking($reference: String!) {
  productByReference(reference: $reference) {
    name
    reference
    type
    parentReference
    price {
      exclTax
      tag
    }
    brand {
      name
      urlKey
    }
    nomenclatureFamily
    nomenclatureGroup
    promoPriceCode
    canAddToCart
    stock {
      availability
      isSellable
    }
    analytics {
      promotionStatus
    }
  }
  currentUser {
    id
    checkout {
      cart {
        id
        currency
        couponCode
      }
    }
  }
}
    `;

/**
 * __useAddToCartTrackingQuery__
 *
 * To run a query within a React component, call `useAddToCartTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToCartTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToCartTrackingQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAddToCartTrackingQuery(baseOptions: Apollo.QueryHookOptions<AddToCartTrackingQuery, AddToCartTrackingQueryVariables> & ({ variables: AddToCartTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>(AddToCartTrackingDocument, options);
      }
export function useAddToCartTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>(AddToCartTrackingDocument, options);
        }
export function useAddToCartTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>(AddToCartTrackingDocument, options);
        }
export type AddToCartTrackingQueryHookResult = ReturnType<typeof useAddToCartTrackingQuery>;
export type AddToCartTrackingLazyQueryHookResult = ReturnType<typeof useAddToCartTrackingLazyQuery>;
export type AddToCartTrackingSuspenseQueryHookResult = ReturnType<typeof useAddToCartTrackingSuspenseQuery>;
export type AddToCartTrackingQueryResult = Apollo.QueryResult<AddToCartTrackingQuery, AddToCartTrackingQueryVariables>;
export const CartItemTrackingMultipleDocument = gql`
    query CartItemTrackingMultiple($references: [String!]!) {
  productsByReferences(references: $references) {
    name
    reference
    parentReference
    type
    price {
      exclTax
      tag
    }
    brand {
      name
      urlKey
    }
    nomenclatureFamily
    nomenclatureGroup
    promoPriceCode
    canAddToCart
    stock {
      availability
      isSellable
    }
    analytics {
      promotionStatus
    }
  }
}
    `;

/**
 * __useCartItemTrackingMultipleQuery__
 *
 * To run a query within a React component, call `useCartItemTrackingMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemTrackingMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemTrackingMultipleQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useCartItemTrackingMultipleQuery(baseOptions: Apollo.QueryHookOptions<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables> & ({ variables: CartItemTrackingMultipleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>(CartItemTrackingMultipleDocument, options);
      }
export function useCartItemTrackingMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>(CartItemTrackingMultipleDocument, options);
        }
export function useCartItemTrackingMultipleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>(CartItemTrackingMultipleDocument, options);
        }
export type CartItemTrackingMultipleQueryHookResult = ReturnType<typeof useCartItemTrackingMultipleQuery>;
export type CartItemTrackingMultipleLazyQueryHookResult = ReturnType<typeof useCartItemTrackingMultipleLazyQuery>;
export type CartItemTrackingMultipleSuspenseQueryHookResult = ReturnType<typeof useCartItemTrackingMultipleSuspenseQuery>;
export type CartItemTrackingMultipleQueryResult = Apollo.QueryResult<CartItemTrackingMultipleQuery, CartItemTrackingMultipleQueryVariables>;
export const CartUserTrackingDocument = gql`
    query CartUserTracking {
  currentUser {
    id
    checkout {
      cart {
        id
        currency
        totalExclTax
        couponCode
      }
    }
  }
}
    `;

/**
 * __useCartUserTrackingQuery__
 *
 * To run a query within a React component, call `useCartUserTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartUserTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartUserTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartUserTrackingQuery(baseOptions?: Apollo.QueryHookOptions<CartUserTrackingQuery, CartUserTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartUserTrackingQuery, CartUserTrackingQueryVariables>(CartUserTrackingDocument, options);
      }
export function useCartUserTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartUserTrackingQuery, CartUserTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartUserTrackingQuery, CartUserTrackingQueryVariables>(CartUserTrackingDocument, options);
        }
export function useCartUserTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartUserTrackingQuery, CartUserTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartUserTrackingQuery, CartUserTrackingQueryVariables>(CartUserTrackingDocument, options);
        }
export type CartUserTrackingQueryHookResult = ReturnType<typeof useCartUserTrackingQuery>;
export type CartUserTrackingLazyQueryHookResult = ReturnType<typeof useCartUserTrackingLazyQuery>;
export type CartUserTrackingSuspenseQueryHookResult = ReturnType<typeof useCartUserTrackingSuspenseQuery>;
export type CartUserTrackingQueryResult = Apollo.QueryResult<CartUserTrackingQuery, CartUserTrackingQueryVariables>;
export const CartEmptyProbeDocument = gql`
    query CartEmptyProbe {
  currentUser {
    id
    checkout {
      cart {
        id
        totalQuantity
      }
    }
  }
}
    `;

/**
 * __useCartEmptyProbeQuery__
 *
 * To run a query within a React component, call `useCartEmptyProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartEmptyProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartEmptyProbeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartEmptyProbeQuery(baseOptions?: Apollo.QueryHookOptions<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>(CartEmptyProbeDocument, options);
      }
export function useCartEmptyProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>(CartEmptyProbeDocument, options);
        }
export function useCartEmptyProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>(CartEmptyProbeDocument, options);
        }
export type CartEmptyProbeQueryHookResult = ReturnType<typeof useCartEmptyProbeQuery>;
export type CartEmptyProbeLazyQueryHookResult = ReturnType<typeof useCartEmptyProbeLazyQuery>;
export type CartEmptyProbeSuspenseQueryHookResult = ReturnType<typeof useCartEmptyProbeSuspenseQuery>;
export type CartEmptyProbeQueryResult = Apollo.QueryResult<CartEmptyProbeQuery, CartEmptyProbeQueryVariables>;
export const PunchoutCartEmptyProbeDocument = gql`
    query PunchoutCartEmptyProbe {
  currentUser {
    id
    punchout {
      cart {
        id
        totalQuantity
      }
    }
  }
}
    `;

/**
 * __usePunchoutCartEmptyProbeQuery__
 *
 * To run a query within a React component, call `usePunchoutCartEmptyProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchoutCartEmptyProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchoutCartEmptyProbeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePunchoutCartEmptyProbeQuery(baseOptions?: Apollo.QueryHookOptions<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>(PunchoutCartEmptyProbeDocument, options);
      }
export function usePunchoutCartEmptyProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>(PunchoutCartEmptyProbeDocument, options);
        }
export function usePunchoutCartEmptyProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>(PunchoutCartEmptyProbeDocument, options);
        }
export type PunchoutCartEmptyProbeQueryHookResult = ReturnType<typeof usePunchoutCartEmptyProbeQuery>;
export type PunchoutCartEmptyProbeLazyQueryHookResult = ReturnType<typeof usePunchoutCartEmptyProbeLazyQuery>;
export type PunchoutCartEmptyProbeSuspenseQueryHookResult = ReturnType<typeof usePunchoutCartEmptyProbeSuspenseQuery>;
export type PunchoutCartEmptyProbeQueryResult = Apollo.QueryResult<PunchoutCartEmptyProbeQuery, PunchoutCartEmptyProbeQueryVariables>;
export const GetTenantBySlugDocument = gql`
    query GetTenantBySlug($slug: String!) {
  CMS_Tenants(where: {slug: {equals: $slug}}) {
    docs {
      id
    }
  }
}
    `;

/**
 * __useGetTenantBySlugQuery__
 *
 * To run a query within a React component, call `useGetTenantBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetTenantBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetTenantBySlugQuery, GetTenantBySlugQueryVariables> & ({ variables: GetTenantBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>(GetTenantBySlugDocument, options);
      }
export function useGetTenantBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>(GetTenantBySlugDocument, options);
        }
export function useGetTenantBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>(GetTenantBySlugDocument, options);
        }
export type GetTenantBySlugQueryHookResult = ReturnType<typeof useGetTenantBySlugQuery>;
export type GetTenantBySlugLazyQueryHookResult = ReturnType<typeof useGetTenantBySlugLazyQuery>;
export type GetTenantBySlugSuspenseQueryHookResult = ReturnType<typeof useGetTenantBySlugSuspenseQuery>;
export type GetTenantBySlugQueryResult = Apollo.QueryResult<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>;
export const IsCmsHeadlessPageExistsDocument = gql`
    query IsCmsHeadlessPageExists($slug: String!, $tenantId: JSON!, $draft: Boolean) {
  CMS_Pages(
    where: {path: {equals: $slug}, tenant: {equals: $tenantId}}
    limit: 1
    draft: $draft
  ) {
    docs {
      id
    }
  }
}
    `;

/**
 * __useIsCmsHeadlessPageExistsQuery__
 *
 * To run a query within a React component, call `useIsCmsHeadlessPageExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCmsHeadlessPageExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCmsHeadlessPageExistsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      tenantId: // value for 'tenantId'
 *      draft: // value for 'draft'
 *   },
 * });
 */
export function useIsCmsHeadlessPageExistsQuery(baseOptions: Apollo.QueryHookOptions<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables> & ({ variables: IsCmsHeadlessPageExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>(IsCmsHeadlessPageExistsDocument, options);
      }
export function useIsCmsHeadlessPageExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>(IsCmsHeadlessPageExistsDocument, options);
        }
export function useIsCmsHeadlessPageExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>(IsCmsHeadlessPageExistsDocument, options);
        }
export type IsCmsHeadlessPageExistsQueryHookResult = ReturnType<typeof useIsCmsHeadlessPageExistsQuery>;
export type IsCmsHeadlessPageExistsLazyQueryHookResult = ReturnType<typeof useIsCmsHeadlessPageExistsLazyQuery>;
export type IsCmsHeadlessPageExistsSuspenseQueryHookResult = ReturnType<typeof useIsCmsHeadlessPageExistsSuspenseQuery>;
export type IsCmsHeadlessPageExistsQueryResult = Apollo.QueryResult<IsCmsHeadlessPageExistsQuery, IsCmsHeadlessPageExistsQueryVariables>;
export const CmsPageDocument = gql`
    query CMSPage($code: String) {
  cmsPage(code: $code) {
    code
    metadata
    jsonContent
  }
}
    `;

/**
 * __useCmsPageQuery__
 *
 * To run a query within a React component, call `useCmsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsPageQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCmsPageQuery(baseOptions?: Apollo.QueryHookOptions<CmsPageQuery, CmsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageDocument, options);
      }
export function useCmsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsPageQuery, CmsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageDocument, options);
        }
export function useCmsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CmsPageQuery, CmsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageDocument, options);
        }
export type CmsPageQueryHookResult = ReturnType<typeof useCmsPageQuery>;
export type CmsPageLazyQueryHookResult = ReturnType<typeof useCmsPageLazyQuery>;
export type CmsPageSuspenseQueryHookResult = ReturnType<typeof useCmsPageSuspenseQuery>;
export type CmsPageQueryResult = Apollo.QueryResult<CmsPageQuery, CmsPageQueryVariables>;
export const GetCollaboratorsDocument = gql`
    query GetCollaborators($input: Browsing!) {
  currentUser {
    id
    company {
      id
      ...Collaborators_Company
    }
  }
}
    ${Collaborators_CompanyFragmentDoc}`;

/**
 * __useGetCollaboratorsQuery__
 *
 * To run a query within a React component, call `useGetCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollaboratorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollaboratorsQuery(baseOptions: Apollo.QueryHookOptions<GetCollaboratorsQuery, GetCollaboratorsQueryVariables> & ({ variables: GetCollaboratorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>(GetCollaboratorsDocument, options);
      }
export function useGetCollaboratorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>(GetCollaboratorsDocument, options);
        }
export function useGetCollaboratorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>(GetCollaboratorsDocument, options);
        }
export type GetCollaboratorsQueryHookResult = ReturnType<typeof useGetCollaboratorsQuery>;
export type GetCollaboratorsLazyQueryHookResult = ReturnType<typeof useGetCollaboratorsLazyQuery>;
export type GetCollaboratorsSuspenseQueryHookResult = ReturnType<typeof useGetCollaboratorsSuspenseQuery>;
export type GetCollaboratorsQueryResult = Apollo.QueryResult<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>;
export const GetAvailableUserRolesDocument = gql`
    query GetAvailableUserRoles {
  currentUser {
    id
    company {
      id
      availableUserRoles
    }
  }
}
    `;

/**
 * __useGetAvailableUserRolesQuery__
 *
 * To run a query within a React component, call `useGetAvailableUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>(GetAvailableUserRolesDocument, options);
      }
export function useGetAvailableUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>(GetAvailableUserRolesDocument, options);
        }
export function useGetAvailableUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>(GetAvailableUserRolesDocument, options);
        }
export type GetAvailableUserRolesQueryHookResult = ReturnType<typeof useGetAvailableUserRolesQuery>;
export type GetAvailableUserRolesLazyQueryHookResult = ReturnType<typeof useGetAvailableUserRolesLazyQuery>;
export type GetAvailableUserRolesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableUserRolesSuspenseQuery>;
export type GetAvailableUserRolesQueryResult = Apollo.QueryResult<GetAvailableUserRolesQuery, GetAvailableUserRolesQueryVariables>;
export const RoleInfoDrawerCurrentUserRolesDocument = gql`
    query RoleInfoDrawerCurrentUserRoles {
  currentUser {
    role
    company {
      availableUserRoles
    }
    permissions {
      allowedRolesToManage
    }
  }
}
    `;

/**
 * __useRoleInfoDrawerCurrentUserRolesQuery__
 *
 * To run a query within a React component, call `useRoleInfoDrawerCurrentUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleInfoDrawerCurrentUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleInfoDrawerCurrentUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleInfoDrawerCurrentUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>(RoleInfoDrawerCurrentUserRolesDocument, options);
      }
export function useRoleInfoDrawerCurrentUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>(RoleInfoDrawerCurrentUserRolesDocument, options);
        }
export function useRoleInfoDrawerCurrentUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>(RoleInfoDrawerCurrentUserRolesDocument, options);
        }
export type RoleInfoDrawerCurrentUserRolesQueryHookResult = ReturnType<typeof useRoleInfoDrawerCurrentUserRolesQuery>;
export type RoleInfoDrawerCurrentUserRolesLazyQueryHookResult = ReturnType<typeof useRoleInfoDrawerCurrentUserRolesLazyQuery>;
export type RoleInfoDrawerCurrentUserRolesSuspenseQueryHookResult = ReturnType<typeof useRoleInfoDrawerCurrentUserRolesSuspenseQuery>;
export type RoleInfoDrawerCurrentUserRolesQueryResult = Apollo.QueryResult<RoleInfoDrawerCurrentUserRolesQuery, RoleInfoDrawerCurrentUserRolesQueryVariables>;
export const UpdateCollaboratorDocument = gql`
    mutation updateCollaborator($input: UserUpdateInput!) {
  updateUser(input: $input)
}
    `;
export type UpdateCollaboratorMutationFn = Apollo.MutationFunction<UpdateCollaboratorMutation, UpdateCollaboratorMutationVariables>;

/**
 * __useUpdateCollaboratorMutation__
 *
 * To run a mutation, you first call `useUpdateCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollaboratorMutation, { data, loading, error }] = useUpdateCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollaboratorMutation, UpdateCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollaboratorMutation, UpdateCollaboratorMutationVariables>(UpdateCollaboratorDocument, options);
      }
export type UpdateCollaboratorMutationHookResult = ReturnType<typeof useUpdateCollaboratorMutation>;
export type UpdateCollaboratorMutationResult = Apollo.MutationResult<UpdateCollaboratorMutation>;
export type UpdateCollaboratorMutationOptions = Apollo.BaseMutationOptions<UpdateCollaboratorMutation, UpdateCollaboratorMutationVariables>;
export const CollaboratorPermissionsDocument = gql`
    query CollaboratorPermissions {
  currentUser {
    id
    ...CollaboratorPermissions
  }
}
    ${CollaboratorPermissionsFragmentDoc}`;

/**
 * __useCollaboratorPermissionsQuery__
 *
 * To run a query within a React component, call `useCollaboratorPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaboratorPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollaboratorPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>(CollaboratorPermissionsDocument, options);
      }
export function useCollaboratorPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>(CollaboratorPermissionsDocument, options);
        }
export function useCollaboratorPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>(CollaboratorPermissionsDocument, options);
        }
export type CollaboratorPermissionsQueryHookResult = ReturnType<typeof useCollaboratorPermissionsQuery>;
export type CollaboratorPermissionsLazyQueryHookResult = ReturnType<typeof useCollaboratorPermissionsLazyQuery>;
export type CollaboratorPermissionsSuspenseQueryHookResult = ReturnType<typeof useCollaboratorPermissionsSuspenseQuery>;
export type CollaboratorPermissionsQueryResult = Apollo.QueryResult<CollaboratorPermissionsQuery, CollaboratorPermissionsQueryVariables>;
export const GetApprovalFlowByUserDocument = gql`
    query GetApprovalFlowByUser($input: Browsing!) {
  currentUser {
    id
    company {
      id
      approvalFlows(input: $input) {
        items {
          ...ApprovalFlowByUser
        }
      }
    }
  }
}
    ${ApprovalFlowByUserFragmentDoc}`;

/**
 * __useGetApprovalFlowByUserQuery__
 *
 * To run a query within a React component, call `useGetApprovalFlowByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalFlowByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalFlowByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApprovalFlowByUserQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables> & ({ variables: GetApprovalFlowByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>(GetApprovalFlowByUserDocument, options);
      }
export function useGetApprovalFlowByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>(GetApprovalFlowByUserDocument, options);
        }
export function useGetApprovalFlowByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>(GetApprovalFlowByUserDocument, options);
        }
export type GetApprovalFlowByUserQueryHookResult = ReturnType<typeof useGetApprovalFlowByUserQuery>;
export type GetApprovalFlowByUserLazyQueryHookResult = ReturnType<typeof useGetApprovalFlowByUserLazyQuery>;
export type GetApprovalFlowByUserSuspenseQueryHookResult = ReturnType<typeof useGetApprovalFlowByUserSuspenseQuery>;
export type GetApprovalFlowByUserQueryResult = Apollo.QueryResult<GetApprovalFlowByUserQuery, GetApprovalFlowByUserQueryVariables>;
export const CreateCollaboratorDocument = gql`
    mutation createCollaborator($input: UserCreateInput!) {
  createUser(input: $input)
}
    `;
export type CreateCollaboratorMutationFn = Apollo.MutationFunction<CreateCollaboratorMutation, CreateCollaboratorMutationVariables>;

/**
 * __useCreateCollaboratorMutation__
 *
 * To run a mutation, you first call `useCreateCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollaboratorMutation, { data, loading, error }] = useCreateCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollaboratorMutation, CreateCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollaboratorMutation, CreateCollaboratorMutationVariables>(CreateCollaboratorDocument, options);
      }
export type CreateCollaboratorMutationHookResult = ReturnType<typeof useCreateCollaboratorMutation>;
export type CreateCollaboratorMutationResult = Apollo.MutationResult<CreateCollaboratorMutation>;
export type CreateCollaboratorMutationOptions = Apollo.BaseMutationOptions<CreateCollaboratorMutation, CreateCollaboratorMutationVariables>;
export const DeleteCollaboratorDocument = gql`
    mutation deleteCollaborator($userId: ID!) {
  deleteUser(userId: $userId)
}
    `;
export type DeleteCollaboratorMutationFn = Apollo.MutationFunction<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;

/**
 * __useDeleteCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollaboratorMutation, { data, loading, error }] = useDeleteCollaboratorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>(DeleteCollaboratorDocument, options);
      }
export type DeleteCollaboratorMutationHookResult = ReturnType<typeof useDeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationResult = Apollo.MutationResult<DeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationOptions = Apollo.BaseMutationOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;
export const __Private__UseSiteConfig__Document = gql`
    query __PRIVATE__UseSiteConfig__ {
  config {
    ...SiteConfig
  }
}
    ${SiteConfigFragmentDoc}`;

/**
 * __use__Private__UseSiteConfig__Query__
 *
 * To run a query within a React component, call `use__Private__UseSiteConfig__Query` and pass it any options that fit your needs.
 * When your component renders, `use__Private__UseSiteConfig__Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = use__Private__UseSiteConfig__Query({
 *   variables: {
 *   },
 * });
 */
export function use__Private__UseSiteConfig__Query(baseOptions?: Apollo.QueryHookOptions<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>(__Private__UseSiteConfig__Document, options);
      }
export function use__Private__UseSiteConfig__LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>(__Private__UseSiteConfig__Document, options);
        }
export function use__Private__UseSiteConfig__SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>(__Private__UseSiteConfig__Document, options);
        }
export type __Private__UseSiteConfig__QueryHookResult = ReturnType<typeof use__Private__UseSiteConfig__Query>;
export type __Private__UseSiteConfig__LazyQueryHookResult = ReturnType<typeof use__Private__UseSiteConfig__LazyQuery>;
export type __Private__UseSiteConfig__SuspenseQueryHookResult = ReturnType<typeof use__Private__UseSiteConfig__SuspenseQuery>;
export type __Private__UseSiteConfig__QueryResult = Apollo.QueryResult<__Private__UseSiteConfig__Query, __Private__UseSiteConfig__QueryVariables>;
export const OrderInfoTrackingDocument = gql`
    query OrderInfoTracking($webRef: String!) {
  currentUser {
    id
    checkout {
      cart {
        id
        currency
      }
    }
    orders(
      input: {filter: [{operator: EQUAL, field: "webRef", stringValue: $webRef, type: STRING}]}
    ) {
      items {
        ...OrderDetails
      }
    }
  }
}
    ${OrderDetailsFragmentDoc}`;

/**
 * __useOrderInfoTrackingQuery__
 *
 * To run a query within a React component, call `useOrderInfoTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderInfoTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderInfoTrackingQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useOrderInfoTrackingQuery(baseOptions: Apollo.QueryHookOptions<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables> & ({ variables: OrderInfoTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>(OrderInfoTrackingDocument, options);
      }
export function useOrderInfoTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>(OrderInfoTrackingDocument, options);
        }
export function useOrderInfoTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>(OrderInfoTrackingDocument, options);
        }
export type OrderInfoTrackingQueryHookResult = ReturnType<typeof useOrderInfoTrackingQuery>;
export type OrderInfoTrackingLazyQueryHookResult = ReturnType<typeof useOrderInfoTrackingLazyQuery>;
export type OrderInfoTrackingSuspenseQueryHookResult = ReturnType<typeof useOrderInfoTrackingSuspenseQuery>;
export type OrderInfoTrackingQueryResult = Apollo.QueryResult<OrderInfoTrackingQuery, OrderInfoTrackingQueryVariables>;
export const CheckoutConfirmationDocument = gql`
    query CheckoutConfirmation($webRef: String!, $marketingCardType: EventPageType) {
  config {
    ...ConfirmationClickAndCollectCardConfig
    ...OrderReferenceDisplay_Config
    catalog {
      isOrderMarketingThresholdEnabled
      orderMarketingThresholdAmount
    }
  }
  marketingCards(type: $marketingCardType) {
    ...MarketingEventCard_EventCard
    openInNewTab
  }
  currentUser {
    id
    email
    company {
      pointOfSale {
        ...ConfirmationContactCard_PointOfSale
      }
    }
    orders(
      input: {filter: [{operator: EQUAL, field: "webRef", stringValue: $webRef, type: STRING}]}
    ) {
      items {
        hasClickAndCollectItems
        hasOnlineDeliveryItems
        isPickUpShippingMethod
        ...ConfirmationSummaryCard_Order
        collectPointOfSale {
          ...ConfirmationStorePickupCard_PointOfSale
          ...ConfirmationClickAndCollectCard_PointOfSale
        }
      }
    }
  }
}
    ${ConfirmationClickAndCollectCardConfigFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}
${MarketingEventCard_EventCardFragmentDoc}
${ConfirmationContactCard_PointOfSaleFragmentDoc}
${ConfirmationSummaryCard_OrderFragmentDoc}
${ConfirmationStorePickupCard_PointOfSaleFragmentDoc}
${ConfirmationClickAndCollectCard_PointOfSaleFragmentDoc}`;

/**
 * __useCheckoutConfirmationQuery__
 *
 * To run a query within a React component, call `useCheckoutConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutConfirmationQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *      marketingCardType: // value for 'marketingCardType'
 *   },
 * });
 */
export function useCheckoutConfirmationQuery(baseOptions: Apollo.QueryHookOptions<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables> & ({ variables: CheckoutConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>(CheckoutConfirmationDocument, options);
      }
export function useCheckoutConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>(CheckoutConfirmationDocument, options);
        }
export function useCheckoutConfirmationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>(CheckoutConfirmationDocument, options);
        }
export type CheckoutConfirmationQueryHookResult = ReturnType<typeof useCheckoutConfirmationQuery>;
export type CheckoutConfirmationLazyQueryHookResult = ReturnType<typeof useCheckoutConfirmationLazyQuery>;
export type CheckoutConfirmationSuspenseQueryHookResult = ReturnType<typeof useCheckoutConfirmationSuspenseQuery>;
export type CheckoutConfirmationQueryResult = Apollo.QueryResult<CheckoutConfirmationQuery, CheckoutConfirmationQueryVariables>;
export const FaqConfigDocument = gql`
    query FaqConfig {
  config {
    support {
      enableFaq
    }
  }
}
    `;

/**
 * __useFaqConfigQuery__
 *
 * To run a query within a React component, call `useFaqConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaqConfigQuery(baseOptions?: Apollo.QueryHookOptions<FaqConfigQuery, FaqConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqConfigQuery, FaqConfigQueryVariables>(FaqConfigDocument, options);
      }
export function useFaqConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqConfigQuery, FaqConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqConfigQuery, FaqConfigQueryVariables>(FaqConfigDocument, options);
        }
export function useFaqConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaqConfigQuery, FaqConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaqConfigQuery, FaqConfigQueryVariables>(FaqConfigDocument, options);
        }
export type FaqConfigQueryHookResult = ReturnType<typeof useFaqConfigQuery>;
export type FaqConfigLazyQueryHookResult = ReturnType<typeof useFaqConfigLazyQuery>;
export type FaqConfigSuspenseQueryHookResult = ReturnType<typeof useFaqConfigSuspenseQuery>;
export type FaqConfigQueryResult = Apollo.QueryResult<FaqConfigQuery, FaqConfigQueryVariables>;
export const SubmitContactRequestDocument = gql`
    mutation submitContactRequest($input: ContactRequestInput!) {
  submitContactRequest(input: $input)
}
    `;
export type SubmitContactRequestMutationFn = Apollo.MutationFunction<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>;

/**
 * __useSubmitContactRequestMutation__
 *
 * To run a mutation, you first call `useSubmitContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContactRequestMutation, { data, loading, error }] = useSubmitContactRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>(SubmitContactRequestDocument, options);
      }
export type SubmitContactRequestMutationHookResult = ReturnType<typeof useSubmitContactRequestMutation>;
export type SubmitContactRequestMutationResult = Apollo.MutationResult<SubmitContactRequestMutation>;
export type SubmitContactRequestMutationOptions = Apollo.BaseMutationOptions<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>;
export const ContactTypeSelectDocument = gql`
    query contactTypeSelect {
  contactFormSubjects {
    id
    label
    subjects {
      code
      id
      name
    }
    type
  }
}
    `;

/**
 * __useContactTypeSelectQuery__
 *
 * To run a query within a React component, call `useContactTypeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactTypeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactTypeSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactTypeSelectQuery(baseOptions?: Apollo.QueryHookOptions<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>(ContactTypeSelectDocument, options);
      }
export function useContactTypeSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>(ContactTypeSelectDocument, options);
        }
export function useContactTypeSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>(ContactTypeSelectDocument, options);
        }
export type ContactTypeSelectQueryHookResult = ReturnType<typeof useContactTypeSelectQuery>;
export type ContactTypeSelectLazyQueryHookResult = ReturnType<typeof useContactTypeSelectLazyQuery>;
export type ContactTypeSelectSuspenseQueryHookResult = ReturnType<typeof useContactTypeSelectSuspenseQuery>;
export type ContactTypeSelectQueryResult = Apollo.QueryResult<ContactTypeSelectQuery, ContactTypeSelectQueryVariables>;
export const ContactPageDataDocument = gql`
    query ContactPageData {
  currentUser {
    id
    ...ContactForm_User
  }
}
    ${ContactForm_UserFragmentDoc}`;

/**
 * __useContactPageDataQuery__
 *
 * To run a query within a React component, call `useContactPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactPageDataQuery(baseOptions?: Apollo.QueryHookOptions<ContactPageDataQuery, ContactPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPageDataQuery, ContactPageDataQueryVariables>(ContactPageDataDocument, options);
      }
export function useContactPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPageDataQuery, ContactPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPageDataQuery, ContactPageDataQueryVariables>(ContactPageDataDocument, options);
        }
export function useContactPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactPageDataQuery, ContactPageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactPageDataQuery, ContactPageDataQueryVariables>(ContactPageDataDocument, options);
        }
export type ContactPageDataQueryHookResult = ReturnType<typeof useContactPageDataQuery>;
export type ContactPageDataLazyQueryHookResult = ReturnType<typeof useContactPageDataLazyQuery>;
export type ContactPageDataSuspenseQueryHookResult = ReturnType<typeof useContactPageDataSuspenseQuery>;
export type ContactPageDataQueryResult = Apollo.QueryResult<ContactPageDataQuery, ContactPageDataQueryVariables>;
export const ContactPointsOfSaleDocument = gql`
    query ContactPointsOfSale($input: Browsing) {
  pointsOfSale(input: $input) {
    items {
      ...ContactForm_PointsOfSale
    }
  }
}
    ${ContactForm_PointsOfSaleFragmentDoc}`;

/**
 * __useContactPointsOfSaleQuery__
 *
 * To run a query within a React component, call `useContactPointsOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPointsOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPointsOfSaleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactPointsOfSaleQuery(baseOptions?: Apollo.QueryHookOptions<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>(ContactPointsOfSaleDocument, options);
      }
export function useContactPointsOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>(ContactPointsOfSaleDocument, options);
        }
export function useContactPointsOfSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>(ContactPointsOfSaleDocument, options);
        }
export type ContactPointsOfSaleQueryHookResult = ReturnType<typeof useContactPointsOfSaleQuery>;
export type ContactPointsOfSaleLazyQueryHookResult = ReturnType<typeof useContactPointsOfSaleLazyQuery>;
export type ContactPointsOfSaleSuspenseQueryHookResult = ReturnType<typeof useContactPointsOfSaleSuspenseQuery>;
export type ContactPointsOfSaleQueryResult = Apollo.QueryResult<ContactPointsOfSaleQuery, ContactPointsOfSaleQueryVariables>;
export const SimplifiedContactPageConfigDocument = gql`
    query SimplifiedContactPageConfig {
  config {
    support {
      isGlobalClick2ChatEnabled
    }
  }
}
    `;

/**
 * __useSimplifiedContactPageConfigQuery__
 *
 * To run a query within a React component, call `useSimplifiedContactPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimplifiedContactPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimplifiedContactPageConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimplifiedContactPageConfigQuery(baseOptions?: Apollo.QueryHookOptions<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>(SimplifiedContactPageConfigDocument, options);
      }
export function useSimplifiedContactPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>(SimplifiedContactPageConfigDocument, options);
        }
export function useSimplifiedContactPageConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>(SimplifiedContactPageConfigDocument, options);
        }
export type SimplifiedContactPageConfigQueryHookResult = ReturnType<typeof useSimplifiedContactPageConfigQuery>;
export type SimplifiedContactPageConfigLazyQueryHookResult = ReturnType<typeof useSimplifiedContactPageConfigLazyQuery>;
export type SimplifiedContactPageConfigSuspenseQueryHookResult = ReturnType<typeof useSimplifiedContactPageConfigSuspenseQuery>;
export type SimplifiedContactPageConfigQueryResult = Apollo.QueryResult<SimplifiedContactPageConfigQuery, SimplifiedContactPageConfigQueryVariables>;
export const ApplyCouponToCartDocument = gql`
    mutation ApplyCouponToCart($cartId: String!, $couponCode: String!) {
  applyCouponToCart(cartId: $cartId, couponCode: $couponCode) {
    cart {
      ...ApplyCouponCodeForm_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${ApplyCouponCodeForm_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type ApplyCouponToCartMutationFn = Apollo.MutationFunction<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>;

/**
 * __useApplyCouponToCartMutation__
 *
 * To run a mutation, you first call `useApplyCouponToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponToCartMutation, { data, loading, error }] = useApplyCouponToCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplyCouponToCartMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>(ApplyCouponToCartDocument, options);
      }
export type ApplyCouponToCartMutationHookResult = ReturnType<typeof useApplyCouponToCartMutation>;
export type ApplyCouponToCartMutationResult = Apollo.MutationResult<ApplyCouponToCartMutation>;
export type ApplyCouponToCartMutationOptions = Apollo.BaseMutationOptions<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>;
export const RemoveCouponFromCartDocument = gql`
    mutation RemoveCouponFromCart($cartId: String!) {
  removeCouponFromCart(cartId: $cartId) {
    cart {
      ...ApplyCouponCodeForm_Cart
      ...CartItems_Cart
      ...CartSummary_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${ApplyCouponCodeForm_CartFragmentDoc}
${CartItems_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type RemoveCouponFromCartMutationFn = Apollo.MutationFunction<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;

/**
 * __useRemoveCouponFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveCouponFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponFromCartMutation, { data, loading, error }] = useRemoveCouponFromCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useRemoveCouponFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(RemoveCouponFromCartDocument, options);
      }
export type RemoveCouponFromCartMutationHookResult = ReturnType<typeof useRemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationResult = Apollo.MutationResult<RemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;
export const DashboardMenu_CurrentUserDocument = gql`
    query DashboardMenu_CurrentUser {
  currentUser {
    id
    ...CurrentUser_DashboardMenuHeaderCards
    ...AvailablePointsOfSale_DashboardMenuHeaderCards
  }
}
    ${CurrentUser_DashboardMenuHeaderCardsFragmentDoc}
${AvailablePointsOfSale_DashboardMenuHeaderCardsFragmentDoc}`;

/**
 * __useDashboardMenu_CurrentUserQuery__
 *
 * To run a query within a React component, call `useDashboardMenu_CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMenu_CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMenu_CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardMenu_CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>(DashboardMenu_CurrentUserDocument, options);
      }
export function useDashboardMenu_CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>(DashboardMenu_CurrentUserDocument, options);
        }
export function useDashboardMenu_CurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>(DashboardMenu_CurrentUserDocument, options);
        }
export type DashboardMenu_CurrentUserQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserQuery>;
export type DashboardMenu_CurrentUserLazyQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserLazyQuery>;
export type DashboardMenu_CurrentUserSuspenseQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserSuspenseQuery>;
export type DashboardMenu_CurrentUserQueryResult = Apollo.QueryResult<DashboardMenu_CurrentUserQuery, DashboardMenu_CurrentUserQueryVariables>;
export const DashboardMenu_CurrentUserAccountsDocument = gql`
    query DashboardMenu_CurrentUserAccounts($status: UserStatus) {
  currentUserAccounts(status: $status) {
    ...CurrentUserAccounts_DashboardMenuHeaderCards
  }
}
    ${CurrentUserAccounts_DashboardMenuHeaderCardsFragmentDoc}`;

/**
 * __useDashboardMenu_CurrentUserAccountsQuery__
 *
 * To run a query within a React component, call `useDashboardMenu_CurrentUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMenu_CurrentUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMenu_CurrentUserAccountsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useDashboardMenu_CurrentUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>(DashboardMenu_CurrentUserAccountsDocument, options);
      }
export function useDashboardMenu_CurrentUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>(DashboardMenu_CurrentUserAccountsDocument, options);
        }
export function useDashboardMenu_CurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>(DashboardMenu_CurrentUserAccountsDocument, options);
        }
export type DashboardMenu_CurrentUserAccountsQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserAccountsQuery>;
export type DashboardMenu_CurrentUserAccountsLazyQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserAccountsLazyQuery>;
export type DashboardMenu_CurrentUserAccountsSuspenseQueryHookResult = ReturnType<typeof useDashboardMenu_CurrentUserAccountsSuspenseQuery>;
export type DashboardMenu_CurrentUserAccountsQueryResult = Apollo.QueryResult<DashboardMenu_CurrentUserAccountsQuery, DashboardMenu_CurrentUserAccountsQueryVariables>;
export const DashboardMenu_ConfigDocument = gql`
    query DashboardMenu_Config {
  config {
    pointOfSale {
      isFavoritePointOfSaleEnabled
    }
  }
}
    `;

/**
 * __useDashboardMenu_ConfigQuery__
 *
 * To run a query within a React component, call `useDashboardMenu_ConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMenu_ConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMenu_ConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardMenu_ConfigQuery(baseOptions?: Apollo.QueryHookOptions<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>(DashboardMenu_ConfigDocument, options);
      }
export function useDashboardMenu_ConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>(DashboardMenu_ConfigDocument, options);
        }
export function useDashboardMenu_ConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>(DashboardMenu_ConfigDocument, options);
        }
export type DashboardMenu_ConfigQueryHookResult = ReturnType<typeof useDashboardMenu_ConfigQuery>;
export type DashboardMenu_ConfigLazyQueryHookResult = ReturnType<typeof useDashboardMenu_ConfigLazyQuery>;
export type DashboardMenu_ConfigSuspenseQueryHookResult = ReturnType<typeof useDashboardMenu_ConfigSuspenseQuery>;
export type DashboardMenu_ConfigQueryResult = Apollo.QueryResult<DashboardMenu_ConfigQuery, DashboardMenu_ConfigQueryVariables>;
export const DashboardWebshopConfigsDocument = gql`
    query DashboardWebshopConfigs {
  config {
    ...QuotesPage_Config
    ...LoyaltyConfig
    ...TopPurchaseConfig_Config
    ...OrderRequestConfig_Config
    ...QuickOrderConfig
    ...OrdersHistoryConfig
  }
}
    ${QuotesPage_ConfigFragmentDoc}
${LoyaltyConfigFragmentDoc}
${TopPurchaseConfig_ConfigFragmentDoc}
${OrderRequestConfig_ConfigFragmentDoc}
${QuickOrderConfigFragmentDoc}
${OrdersHistoryConfigFragmentDoc}`;

/**
 * __useDashboardWebshopConfigsQuery__
 *
 * To run a query within a React component, call `useDashboardWebshopConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardWebshopConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardWebshopConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardWebshopConfigsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>(DashboardWebshopConfigsDocument, options);
      }
export function useDashboardWebshopConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>(DashboardWebshopConfigsDocument, options);
        }
export function useDashboardWebshopConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>(DashboardWebshopConfigsDocument, options);
        }
export type DashboardWebshopConfigsQueryHookResult = ReturnType<typeof useDashboardWebshopConfigsQuery>;
export type DashboardWebshopConfigsLazyQueryHookResult = ReturnType<typeof useDashboardWebshopConfigsLazyQuery>;
export type DashboardWebshopConfigsSuspenseQueryHookResult = ReturnType<typeof useDashboardWebshopConfigsSuspenseQuery>;
export type DashboardWebshopConfigsQueryResult = Apollo.QueryResult<DashboardWebshopConfigsQuery, DashboardWebshopConfigsQueryVariables>;
export const DashboardUserQuoteConfigDocument = gql`
    query DashboardUserQuoteConfig {
  currentUser {
    id
    permissions {
      canManageQuote
    }
  }
}
    `;

/**
 * __useDashboardUserQuoteConfigQuery__
 *
 * To run a query within a React component, call `useDashboardUserQuoteConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUserQuoteConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUserQuoteConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardUserQuoteConfigQuery(baseOptions?: Apollo.QueryHookOptions<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>(DashboardUserQuoteConfigDocument, options);
      }
export function useDashboardUserQuoteConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>(DashboardUserQuoteConfigDocument, options);
        }
export function useDashboardUserQuoteConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>(DashboardUserQuoteConfigDocument, options);
        }
export type DashboardUserQuoteConfigQueryHookResult = ReturnType<typeof useDashboardUserQuoteConfigQuery>;
export type DashboardUserQuoteConfigLazyQueryHookResult = ReturnType<typeof useDashboardUserQuoteConfigLazyQuery>;
export type DashboardUserQuoteConfigSuspenseQueryHookResult = ReturnType<typeof useDashboardUserQuoteConfigSuspenseQuery>;
export type DashboardUserQuoteConfigQueryResult = Apollo.QueryResult<DashboardUserQuoteConfigQuery, DashboardUserQuoteConfigQueryVariables>;
export const DashboardMenuDocument = gql`
    query DashboardMenu {
  currentUser {
    id
    isSubjectToApprovalFlow
    hasProcessingQuotes
    permissions {
      ... on CollaboratorPermissions {
        canApproveOrderRequest
        canManageApprovalFlows
        hasAccessToStoreOrders
        hasAccessToWebOrders
        showOrderHistory
        showStoreOrderHistory
        showCompanyUsers
      }
    }
    orderRequests {
      items {
        webRef
      }
    }
    loyalty {
      status
    }
    permissions {
      hasAccessToOrderRequestToApprove
    }
  }
}
    `;

/**
 * __useDashboardMenuQuery__
 *
 * To run a query within a React component, call `useDashboardMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardMenuQuery(baseOptions?: Apollo.QueryHookOptions<DashboardMenuQuery, DashboardMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardMenuQuery, DashboardMenuQueryVariables>(DashboardMenuDocument, options);
      }
export function useDashboardMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardMenuQuery, DashboardMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardMenuQuery, DashboardMenuQueryVariables>(DashboardMenuDocument, options);
        }
export function useDashboardMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardMenuQuery, DashboardMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardMenuQuery, DashboardMenuQueryVariables>(DashboardMenuDocument, options);
        }
export type DashboardMenuQueryHookResult = ReturnType<typeof useDashboardMenuQuery>;
export type DashboardMenuLazyQueryHookResult = ReturnType<typeof useDashboardMenuLazyQuery>;
export type DashboardMenuSuspenseQueryHookResult = ReturnType<typeof useDashboardMenuSuspenseQuery>;
export type DashboardMenuQueryResult = Apollo.QueryResult<DashboardMenuQuery, DashboardMenuQueryVariables>;
export const DashboardApproverOrderRequestsDocument = gql`
    query DashboardApproverOrderRequests {
  currentUser {
    id
    orderRequests(
      input: {filter: {field: "approver", type: BOOLEAN, operator: EQUAL, booleanValue: true}}
    ) {
      items {
        webRef
      }
    }
  }
}
    `;

/**
 * __useDashboardApproverOrderRequestsQuery__
 *
 * To run a query within a React component, call `useDashboardApproverOrderRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardApproverOrderRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardApproverOrderRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardApproverOrderRequestsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>(DashboardApproverOrderRequestsDocument, options);
      }
export function useDashboardApproverOrderRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>(DashboardApproverOrderRequestsDocument, options);
        }
export function useDashboardApproverOrderRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>(DashboardApproverOrderRequestsDocument, options);
        }
export type DashboardApproverOrderRequestsQueryHookResult = ReturnType<typeof useDashboardApproverOrderRequestsQuery>;
export type DashboardApproverOrderRequestsLazyQueryHookResult = ReturnType<typeof useDashboardApproverOrderRequestsLazyQuery>;
export type DashboardApproverOrderRequestsSuspenseQueryHookResult = ReturnType<typeof useDashboardApproverOrderRequestsSuspenseQuery>;
export type DashboardApproverOrderRequestsQueryResult = Apollo.QueryResult<DashboardApproverOrderRequestsQuery, DashboardApproverOrderRequestsQueryVariables>;
export const GetUserFavoriteListsDocument = gql`
    query getUserFavoriteLists($input: Browsing!) {
  currentUser {
    id
    wishlists(input: $input) {
      items {
        ...AddProductToFavoritesList_List
      }
    }
  }
}
    ${AddProductToFavoritesList_ListFragmentDoc}`;

/**
 * __useGetUserFavoriteListsQuery__
 *
 * To run a query within a React component, call `useGetUserFavoriteListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoriteListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoriteListsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserFavoriteListsQuery(baseOptions: Apollo.QueryHookOptions<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables> & ({ variables: GetUserFavoriteListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>(GetUserFavoriteListsDocument, options);
      }
export function useGetUserFavoriteListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>(GetUserFavoriteListsDocument, options);
        }
export function useGetUserFavoriteListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>(GetUserFavoriteListsDocument, options);
        }
export type GetUserFavoriteListsQueryHookResult = ReturnType<typeof useGetUserFavoriteListsQuery>;
export type GetUserFavoriteListsLazyQueryHookResult = ReturnType<typeof useGetUserFavoriteListsLazyQuery>;
export type GetUserFavoriteListsSuspenseQueryHookResult = ReturnType<typeof useGetUserFavoriteListsSuspenseQuery>;
export type GetUserFavoriteListsQueryResult = Apollo.QueryResult<GetUserFavoriteListsQuery, GetUserFavoriteListsQueryVariables>;
export const AddProductReferenceDocument = gql`
    query AddProductReference($reference: String!) {
  productByReference(reference: $reference) {
    reference
  }
}
    `;

/**
 * __useAddProductReferenceQuery__
 *
 * To run a query within a React component, call `useAddProductReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductReferenceQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAddProductReferenceQuery(baseOptions: Apollo.QueryHookOptions<AddProductReferenceQuery, AddProductReferenceQueryVariables> & ({ variables: AddProductReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddProductReferenceQuery, AddProductReferenceQueryVariables>(AddProductReferenceDocument, options);
      }
export function useAddProductReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddProductReferenceQuery, AddProductReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddProductReferenceQuery, AddProductReferenceQueryVariables>(AddProductReferenceDocument, options);
        }
export function useAddProductReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddProductReferenceQuery, AddProductReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddProductReferenceQuery, AddProductReferenceQueryVariables>(AddProductReferenceDocument, options);
        }
export type AddProductReferenceQueryHookResult = ReturnType<typeof useAddProductReferenceQuery>;
export type AddProductReferenceLazyQueryHookResult = ReturnType<typeof useAddProductReferenceLazyQuery>;
export type AddProductReferenceSuspenseQueryHookResult = ReturnType<typeof useAddProductReferenceSuspenseQuery>;
export type AddProductReferenceQueryResult = Apollo.QueryResult<AddProductReferenceQuery, AddProductReferenceQueryVariables>;
export const AddProductToListDocument = gql`
    mutation AddProductToList($input: WishlistUpdateInput_V2!) {
  updateWishlist_V2(input: $input) {
    id
  }
}
    `;
export type AddProductToListMutationFn = Apollo.MutationFunction<AddProductToListMutation, AddProductToListMutationVariables>;

/**
 * __useAddProductToListMutation__
 *
 * To run a mutation, you first call `useAddProductToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToListMutation, { data, loading, error }] = useAddProductToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductToListMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToListMutation, AddProductToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToListMutation, AddProductToListMutationVariables>(AddProductToListDocument, options);
      }
export type AddProductToListMutationHookResult = ReturnType<typeof useAddProductToListMutation>;
export type AddProductToListMutationResult = Apollo.MutationResult<AddProductToListMutation>;
export type AddProductToListMutationOptions = Apollo.BaseMutationOptions<AddProductToListMutation, AddProductToListMutationVariables>;
export const DeleteFavoritesListDocument = gql`
    mutation deleteFavoritesList($id: Int!) {
  deleteWishlist(id: $id)
}
    `;
export type DeleteFavoritesListMutationFn = Apollo.MutationFunction<DeleteFavoritesListMutation, DeleteFavoritesListMutationVariables>;

/**
 * __useDeleteFavoritesListMutation__
 *
 * To run a mutation, you first call `useDeleteFavoritesListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoritesListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoritesListMutation, { data, loading, error }] = useDeleteFavoritesListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFavoritesListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoritesListMutation, DeleteFavoritesListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoritesListMutation, DeleteFavoritesListMutationVariables>(DeleteFavoritesListDocument, options);
      }
export type DeleteFavoritesListMutationHookResult = ReturnType<typeof useDeleteFavoritesListMutation>;
export type DeleteFavoritesListMutationResult = Apollo.MutationResult<DeleteFavoritesListMutation>;
export type DeleteFavoritesListMutationOptions = Apollo.BaseMutationOptions<DeleteFavoritesListMutation, DeleteFavoritesListMutationVariables>;
export const GetFavoritesListProductsDocument = gql`
    query GetFavoritesListProducts($input: Browsing!) {
  currentUser {
    id
    wishlists(input: $input) {
      items {
        ...FavoritesDetailsPage_Wishlist
      }
    }
  }
}
    ${FavoritesDetailsPage_WishlistFragmentDoc}`;

/**
 * __useGetFavoritesListProductsQuery__
 *
 * To run a query within a React component, call `useGetFavoritesListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesListProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFavoritesListProductsQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables> & ({ variables: GetFavoritesListProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>(GetFavoritesListProductsDocument, options);
      }
export function useGetFavoritesListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>(GetFavoritesListProductsDocument, options);
        }
export function useGetFavoritesListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>(GetFavoritesListProductsDocument, options);
        }
export type GetFavoritesListProductsQueryHookResult = ReturnType<typeof useGetFavoritesListProductsQuery>;
export type GetFavoritesListProductsLazyQueryHookResult = ReturnType<typeof useGetFavoritesListProductsLazyQuery>;
export type GetFavoritesListProductsSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesListProductsSuspenseQuery>;
export type GetFavoritesListProductsQueryResult = Apollo.QueryResult<GetFavoritesListProductsQuery, GetFavoritesListProductsQueryVariables>;
export const UpdateFavoritesListDocument = gql`
    mutation updateFavoritesList($input: WishlistUpdateInput_V2!) {
  updateWishlist_V2(input: $input) {
    id
  }
}
    `;
export type UpdateFavoritesListMutationFn = Apollo.MutationFunction<UpdateFavoritesListMutation, UpdateFavoritesListMutationVariables>;

/**
 * __useUpdateFavoritesListMutation__
 *
 * To run a mutation, you first call `useUpdateFavoritesListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoritesListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoritesListMutation, { data, loading, error }] = useUpdateFavoritesListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFavoritesListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoritesListMutation, UpdateFavoritesListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoritesListMutation, UpdateFavoritesListMutationVariables>(UpdateFavoritesListDocument, options);
      }
export type UpdateFavoritesListMutationHookResult = ReturnType<typeof useUpdateFavoritesListMutation>;
export type UpdateFavoritesListMutationResult = Apollo.MutationResult<UpdateFavoritesListMutation>;
export type UpdateFavoritesListMutationOptions = Apollo.BaseMutationOptions<UpdateFavoritesListMutation, UpdateFavoritesListMutationVariables>;
export const GetFavoritesTableDocument = gql`
    query GetFavoritesTable($input: Browsing!) {
  currentUser {
    id
    wishlists(input: $input) {
      items {
        ...FavoritesTable_Favorite
      }
      totalPages
    }
  }
}
    ${FavoritesTable_FavoriteFragmentDoc}`;

/**
 * __useGetFavoritesTableQuery__
 *
 * To run a query within a React component, call `useGetFavoritesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFavoritesTableQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritesTableQuery, GetFavoritesTableQueryVariables> & ({ variables: GetFavoritesTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>(GetFavoritesTableDocument, options);
      }
export function useGetFavoritesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>(GetFavoritesTableDocument, options);
        }
export function useGetFavoritesTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>(GetFavoritesTableDocument, options);
        }
export type GetFavoritesTableQueryHookResult = ReturnType<typeof useGetFavoritesTableQuery>;
export type GetFavoritesTableLazyQueryHookResult = ReturnType<typeof useGetFavoritesTableLazyQuery>;
export type GetFavoritesTableSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesTableSuspenseQuery>;
export type GetFavoritesTableQueryResult = Apollo.QueryResult<GetFavoritesTableQuery, GetFavoritesTableQueryVariables>;
export const ShareFavoritesListDrawerRecipientsDocument = gql`
    query ShareFavoritesListDrawerRecipients($type: SharingType!) {
  shareUserList(type: $type) {
    id
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useShareFavoritesListDrawerRecipientsQuery__
 *
 * To run a query within a React component, call `useShareFavoritesListDrawerRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareFavoritesListDrawerRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareFavoritesListDrawerRecipientsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShareFavoritesListDrawerRecipientsQuery(baseOptions: Apollo.QueryHookOptions<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables> & ({ variables: ShareFavoritesListDrawerRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>(ShareFavoritesListDrawerRecipientsDocument, options);
      }
export function useShareFavoritesListDrawerRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>(ShareFavoritesListDrawerRecipientsDocument, options);
        }
export function useShareFavoritesListDrawerRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>(ShareFavoritesListDrawerRecipientsDocument, options);
        }
export type ShareFavoritesListDrawerRecipientsQueryHookResult = ReturnType<typeof useShareFavoritesListDrawerRecipientsQuery>;
export type ShareFavoritesListDrawerRecipientsLazyQueryHookResult = ReturnType<typeof useShareFavoritesListDrawerRecipientsLazyQuery>;
export type ShareFavoritesListDrawerRecipientsSuspenseQueryHookResult = ReturnType<typeof useShareFavoritesListDrawerRecipientsSuspenseQuery>;
export type ShareFavoritesListDrawerRecipientsQueryResult = Apollo.QueryResult<ShareFavoritesListDrawerRecipientsQuery, ShareFavoritesListDrawerRecipientsQueryVariables>;
export const ShareFavoriteListDocument = gql`
    mutation ShareFavoriteList($input: WishlistSharingInput!) {
  shareWishlist(input: $input) {
    id
  }
}
    `;
export type ShareFavoriteListMutationFn = Apollo.MutationFunction<ShareFavoriteListMutation, ShareFavoriteListMutationVariables>;

/**
 * __useShareFavoriteListMutation__
 *
 * To run a mutation, you first call `useShareFavoriteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareFavoriteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareFavoriteListMutation, { data, loading, error }] = useShareFavoriteListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareFavoriteListMutation(baseOptions?: Apollo.MutationHookOptions<ShareFavoriteListMutation, ShareFavoriteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareFavoriteListMutation, ShareFavoriteListMutationVariables>(ShareFavoriteListDocument, options);
      }
export type ShareFavoriteListMutationHookResult = ReturnType<typeof useShareFavoriteListMutation>;
export type ShareFavoriteListMutationResult = Apollo.MutationResult<ShareFavoriteListMutation>;
export type ShareFavoriteListMutationOptions = Apollo.BaseMutationOptions<ShareFavoriteListMutation, ShareFavoriteListMutationVariables>;
export const CreateFavoritesListDocument = gql`
    mutation createFavoritesList($input: WishlistCreateInput_V2!) {
  createWishlist_V2(input: $input) {
    id
    name
  }
}
    `;
export type CreateFavoritesListMutationFn = Apollo.MutationFunction<CreateFavoritesListMutation, CreateFavoritesListMutationVariables>;

/**
 * __useCreateFavoritesListMutation__
 *
 * To run a mutation, you first call `useCreateFavoritesListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoritesListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoritesListMutation, { data, loading, error }] = useCreateFavoritesListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoritesListMutation(baseOptions?: Apollo.MutationHookOptions<CreateFavoritesListMutation, CreateFavoritesListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFavoritesListMutation, CreateFavoritesListMutationVariables>(CreateFavoritesListDocument, options);
      }
export type CreateFavoritesListMutationHookResult = ReturnType<typeof useCreateFavoritesListMutation>;
export type CreateFavoritesListMutationResult = Apollo.MutationResult<CreateFavoritesListMutation>;
export type CreateFavoritesListMutationOptions = Apollo.BaseMutationOptions<CreateFavoritesListMutation, CreateFavoritesListMutationVariables>;
export const GetFavoritesListCheckoutInformationDocument = gql`
    query GetFavoritesListCheckoutInformation {
  currentUser {
    id
    checkout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useGetFavoritesListCheckoutInformationQuery__
 *
 * To run a query within a React component, call `useGetFavoritesListCheckoutInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesListCheckoutInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesListCheckoutInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoritesListCheckoutInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>(GetFavoritesListCheckoutInformationDocument, options);
      }
export function useGetFavoritesListCheckoutInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>(GetFavoritesListCheckoutInformationDocument, options);
        }
export function useGetFavoritesListCheckoutInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>(GetFavoritesListCheckoutInformationDocument, options);
        }
export type GetFavoritesListCheckoutInformationQueryHookResult = ReturnType<typeof useGetFavoritesListCheckoutInformationQuery>;
export type GetFavoritesListCheckoutInformationLazyQueryHookResult = ReturnType<typeof useGetFavoritesListCheckoutInformationLazyQuery>;
export type GetFavoritesListCheckoutInformationSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesListCheckoutInformationSuspenseQuery>;
export type GetFavoritesListCheckoutInformationQueryResult = Apollo.QueryResult<GetFavoritesListCheckoutInformationQuery, GetFavoritesListCheckoutInformationQueryVariables>;
export const GetFavoritesListDetailDocument = gql`
    query GetFavoritesListDetail($input: Browsing!) {
  currentUser {
    id
    permissions {
      ...FavoritesActionsList_Permissions
    }
    wishlists(input: $input) {
      items {
        ...FavoritesTable_Favorite
        products {
          product {
            firstLevelCategory {
              ...ProductFirstLevelCategory
            }
          }
        }
      }
    }
  }
}
    ${FavoritesActionsList_PermissionsFragmentDoc}
${FavoritesTable_FavoriteFragmentDoc}
${ProductFirstLevelCategoryFragmentDoc}`;

/**
 * __useGetFavoritesListDetailQuery__
 *
 * To run a query within a React component, call `useGetFavoritesListDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesListDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesListDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFavoritesListDetailQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables> & ({ variables: GetFavoritesListDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>(GetFavoritesListDetailDocument, options);
      }
export function useGetFavoritesListDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>(GetFavoritesListDetailDocument, options);
        }
export function useGetFavoritesListDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>(GetFavoritesListDetailDocument, options);
        }
export type GetFavoritesListDetailQueryHookResult = ReturnType<typeof useGetFavoritesListDetailQuery>;
export type GetFavoritesListDetailLazyQueryHookResult = ReturnType<typeof useGetFavoritesListDetailLazyQuery>;
export type GetFavoritesListDetailSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesListDetailSuspenseQuery>;
export type GetFavoritesListDetailQueryResult = Apollo.QueryResult<GetFavoritesListDetailQuery, GetFavoritesListDetailQueryVariables>;
export const GetReassuranceCardsDocument = gql`
    query GetReassuranceCards($tenantId: JSON) {
  CMS_ReassuranceCards(
    where: {tenant: {equals: $tenantId}, AND: [{_status: {equals: published}}]}
  ) {
    docs {
      layout {
        ... on CMS_ReassuranceCardBlock {
          ...Footer_ReassuranceCards
        }
      }
    }
  }
}
    ${Footer_ReassuranceCardsFragmentDoc}`;

/**
 * __useGetReassuranceCardsQuery__
 *
 * To run a query within a React component, call `useGetReassuranceCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReassuranceCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReassuranceCardsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetReassuranceCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>(GetReassuranceCardsDocument, options);
      }
export function useGetReassuranceCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>(GetReassuranceCardsDocument, options);
        }
export function useGetReassuranceCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>(GetReassuranceCardsDocument, options);
        }
export type GetReassuranceCardsQueryHookResult = ReturnType<typeof useGetReassuranceCardsQuery>;
export type GetReassuranceCardsLazyQueryHookResult = ReturnType<typeof useGetReassuranceCardsLazyQuery>;
export type GetReassuranceCardsSuspenseQueryHookResult = ReturnType<typeof useGetReassuranceCardsSuspenseQuery>;
export type GetReassuranceCardsQueryResult = Apollo.QueryResult<GetReassuranceCardsQuery, GetReassuranceCardsQueryVariables>;
export const Header_NavigationDocument = gql`
    query Header_Navigation {
  menu {
    ...MenuEntry
  }
}
    ${MenuEntryFragmentDoc}`;

/**
 * __useHeader_NavigationQuery__
 *
 * To run a query within a React component, call `useHeader_NavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeader_NavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeader_NavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeader_NavigationQuery(baseOptions?: Apollo.QueryHookOptions<Header_NavigationQuery, Header_NavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Header_NavigationQuery, Header_NavigationQueryVariables>(Header_NavigationDocument, options);
      }
export function useHeader_NavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Header_NavigationQuery, Header_NavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Header_NavigationQuery, Header_NavigationQueryVariables>(Header_NavigationDocument, options);
        }
export function useHeader_NavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Header_NavigationQuery, Header_NavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Header_NavigationQuery, Header_NavigationQueryVariables>(Header_NavigationDocument, options);
        }
export type Header_NavigationQueryHookResult = ReturnType<typeof useHeader_NavigationQuery>;
export type Header_NavigationLazyQueryHookResult = ReturnType<typeof useHeader_NavigationLazyQuery>;
export type Header_NavigationSuspenseQueryHookResult = ReturnType<typeof useHeader_NavigationSuspenseQuery>;
export type Header_NavigationQueryResult = Apollo.QueryResult<Header_NavigationQuery, Header_NavigationQueryVariables>;
export const Header_PointOfSaleConfigDocument = gql`
    query Header_PointOfSaleConfig {
  config {
    ...HeaderButtonsV2_Config
  }
}
    ${HeaderButtonsV2_ConfigFragmentDoc}`;

/**
 * __useHeader_PointOfSaleConfigQuery__
 *
 * To run a query within a React component, call `useHeader_PointOfSaleConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeader_PointOfSaleConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeader_PointOfSaleConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeader_PointOfSaleConfigQuery(baseOptions?: Apollo.QueryHookOptions<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>(Header_PointOfSaleConfigDocument, options);
      }
export function useHeader_PointOfSaleConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>(Header_PointOfSaleConfigDocument, options);
        }
export function useHeader_PointOfSaleConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>(Header_PointOfSaleConfigDocument, options);
        }
export type Header_PointOfSaleConfigQueryHookResult = ReturnType<typeof useHeader_PointOfSaleConfigQuery>;
export type Header_PointOfSaleConfigLazyQueryHookResult = ReturnType<typeof useHeader_PointOfSaleConfigLazyQuery>;
export type Header_PointOfSaleConfigSuspenseQueryHookResult = ReturnType<typeof useHeader_PointOfSaleConfigSuspenseQuery>;
export type Header_PointOfSaleConfigQueryResult = Apollo.QueryResult<Header_PointOfSaleConfigQuery, Header_PointOfSaleConfigQueryVariables>;
export const Header_PickUpPointOfSaleDocument = gql`
    query Header_PickUpPointOfSale($pickupPointOfSaleId: String!) {
  currentUser {
    availablePointsOfSalePickup {
      id
    }
  }
  pickupPointOfSale: pointOfSale(pointOfSaleId: $pickupPointOfSaleId) {
    ...SignedInPointOfSaleButton_pickupPointOfSale
  }
}
    ${SignedInPointOfSaleButton_PickupPointOfSaleFragmentDoc}`;

/**
 * __useHeader_PickUpPointOfSaleQuery__
 *
 * To run a query within a React component, call `useHeader_PickUpPointOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeader_PickUpPointOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeader_PickUpPointOfSaleQuery({
 *   variables: {
 *      pickupPointOfSaleId: // value for 'pickupPointOfSaleId'
 *   },
 * });
 */
export function useHeader_PickUpPointOfSaleQuery(baseOptions: Apollo.QueryHookOptions<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables> & ({ variables: Header_PickUpPointOfSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>(Header_PickUpPointOfSaleDocument, options);
      }
export function useHeader_PickUpPointOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>(Header_PickUpPointOfSaleDocument, options);
        }
export function useHeader_PickUpPointOfSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>(Header_PickUpPointOfSaleDocument, options);
        }
export type Header_PickUpPointOfSaleQueryHookResult = ReturnType<typeof useHeader_PickUpPointOfSaleQuery>;
export type Header_PickUpPointOfSaleLazyQueryHookResult = ReturnType<typeof useHeader_PickUpPointOfSaleLazyQuery>;
export type Header_PickUpPointOfSaleSuspenseQueryHookResult = ReturnType<typeof useHeader_PickUpPointOfSaleSuspenseQuery>;
export type Header_PickUpPointOfSaleQueryResult = Apollo.QueryResult<Header_PickUpPointOfSaleQuery, Header_PickUpPointOfSaleQueryVariables>;
export const InternalClientPageDocument = gql`
    query InternalClientPage {
  currentInternalUser {
    email
    firstname
    lastname
  }
}
    `;

/**
 * __useInternalClientPageQuery__
 *
 * To run a query within a React component, call `useInternalClientPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalClientPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalClientPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalClientPageQuery(baseOptions?: Apollo.QueryHookOptions<InternalClientPageQuery, InternalClientPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalClientPageQuery, InternalClientPageQueryVariables>(InternalClientPageDocument, options);
      }
export function useInternalClientPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalClientPageQuery, InternalClientPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalClientPageQuery, InternalClientPageQueryVariables>(InternalClientPageDocument, options);
        }
export function useInternalClientPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalClientPageQuery, InternalClientPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalClientPageQuery, InternalClientPageQueryVariables>(InternalClientPageDocument, options);
        }
export type InternalClientPageQueryHookResult = ReturnType<typeof useInternalClientPageQuery>;
export type InternalClientPageLazyQueryHookResult = ReturnType<typeof useInternalClientPageLazyQuery>;
export type InternalClientPageSuspenseQueryHookResult = ReturnType<typeof useInternalClientPageSuspenseQuery>;
export type InternalClientPageQueryResult = Apollo.QueryResult<InternalClientPageQuery, InternalClientPageQueryVariables>;
export const SearchCompaniesDocument = gql`
    query SearchCompanies($input: Browsing!) {
  searchCompanies(input: $input) {
    items {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions: Apollo.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables> & ({ variables: SearchCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export function useSearchCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesSuspenseQuery>;
export type SearchCompaniesQueryResult = Apollo.QueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($input: Browsing!) {
  searchUsers(input: $input) {
    items {
      id
      firstname
      lastname
      email
      role
      company {
        id
        code
        name
        pointOfSale {
          id
          subsidiary {
            id
          }
        }
      }
      favoritePointOfSale {
        id
      }
    }
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables> & ({ variables: SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const GetUserLoyaltyDocument = gql`
    query GetUserLoyalty {
  currentUser {
    id
    loyalty {
      data {
        active
        authLink
        boosterMonth
        customerStatus
        isResponsable
        pointNumberExpiringThisYear
        pointsBalance
        responsableEmail
        state
      }
      status
    }
  }
}
    `;

/**
 * __useGetUserLoyaltyQuery__
 *
 * To run a query within a React component, call `useGetUserLoyaltyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLoyaltyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLoyaltyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLoyaltyQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>(GetUserLoyaltyDocument, options);
      }
export function useGetUserLoyaltyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>(GetUserLoyaltyDocument, options);
        }
export function useGetUserLoyaltySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>(GetUserLoyaltyDocument, options);
        }
export type GetUserLoyaltyQueryHookResult = ReturnType<typeof useGetUserLoyaltyQuery>;
export type GetUserLoyaltyLazyQueryHookResult = ReturnType<typeof useGetUserLoyaltyLazyQuery>;
export type GetUserLoyaltySuspenseQueryHookResult = ReturnType<typeof useGetUserLoyaltySuspenseQuery>;
export type GetUserLoyaltyQueryResult = Apollo.QueryResult<GetUserLoyaltyQuery, GetUserLoyaltyQueryVariables>;
export const GetLoyaltyOperationsDocument = gql`
    query GetLoyaltyOperations {
  currentUser {
    id
    loyalty {
      data {
        ...LoyaltyOperationsLoyaltyDataProps
      }
      status
    }
  }
}
    ${LoyaltyOperationsLoyaltyDataPropsFragmentDoc}`;

/**
 * __useGetLoyaltyOperationsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoyaltyOperationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>(GetLoyaltyOperationsDocument, options);
      }
export function useGetLoyaltyOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>(GetLoyaltyOperationsDocument, options);
        }
export function useGetLoyaltyOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>(GetLoyaltyOperationsDocument, options);
        }
export type GetLoyaltyOperationsQueryHookResult = ReturnType<typeof useGetLoyaltyOperationsQuery>;
export type GetLoyaltyOperationsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyOperationsLazyQuery>;
export type GetLoyaltyOperationsSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyOperationsSuspenseQuery>;
export type GetLoyaltyOperationsQueryResult = Apollo.QueryResult<GetLoyaltyOperationsQuery, GetLoyaltyOperationsQueryVariables>;
export const DashboardUserLoyaltyStatusDocument = gql`
    query DashboardUserLoyaltyStatus {
  currentUser {
    id
    loyalty {
      status
    }
  }
}
    `;

/**
 * __useDashboardUserLoyaltyStatusQuery__
 *
 * To run a query within a React component, call `useDashboardUserLoyaltyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUserLoyaltyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUserLoyaltyStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardUserLoyaltyStatusQuery(baseOptions?: Apollo.QueryHookOptions<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>(DashboardUserLoyaltyStatusDocument, options);
      }
export function useDashboardUserLoyaltyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>(DashboardUserLoyaltyStatusDocument, options);
        }
export function useDashboardUserLoyaltyStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>(DashboardUserLoyaltyStatusDocument, options);
        }
export type DashboardUserLoyaltyStatusQueryHookResult = ReturnType<typeof useDashboardUserLoyaltyStatusQuery>;
export type DashboardUserLoyaltyStatusLazyQueryHookResult = ReturnType<typeof useDashboardUserLoyaltyStatusLazyQuery>;
export type DashboardUserLoyaltyStatusSuspenseQueryHookResult = ReturnType<typeof useDashboardUserLoyaltyStatusSuspenseQuery>;
export type DashboardUserLoyaltyStatusQueryResult = Apollo.QueryResult<DashboardUserLoyaltyStatusQuery, DashboardUserLoyaltyStatusQueryVariables>;
export const GetDashboardConfigDocument = gql`
    query getDashboardConfig {
  config {
    ...LoyaltyConfig
    ...QuotesPage_Config
  }
}
    ${LoyaltyConfigFragmentDoc}
${QuotesPage_ConfigFragmentDoc}`;

/**
 * __useGetDashboardConfigQuery__
 *
 * To run a query within a React component, call `useGetDashboardConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>(GetDashboardConfigDocument, options);
      }
export function useGetDashboardConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>(GetDashboardConfigDocument, options);
        }
export function useGetDashboardConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>(GetDashboardConfigDocument, options);
        }
export type GetDashboardConfigQueryHookResult = ReturnType<typeof useGetDashboardConfigQuery>;
export type GetDashboardConfigLazyQueryHookResult = ReturnType<typeof useGetDashboardConfigLazyQuery>;
export type GetDashboardConfigSuspenseQueryHookResult = ReturnType<typeof useGetDashboardConfigSuspenseQuery>;
export type GetDashboardConfigQueryResult = Apollo.QueryResult<GetDashboardConfigQuery, GetDashboardConfigQueryVariables>;
export const RequestLoyaltyRegistrationDocument = gql`
    mutation RequestLoyaltyRegistration($isChecked: Boolean!, $legalStatus: LegalStatus!) {
  requestLoyaltyRegistration(
    input: {isChecked: $isChecked, legalStatus: $legalStatus}
  )
}
    `;
export type RequestLoyaltyRegistrationMutationFn = Apollo.MutationFunction<RequestLoyaltyRegistrationMutation, RequestLoyaltyRegistrationMutationVariables>;

/**
 * __useRequestLoyaltyRegistrationMutation__
 *
 * To run a mutation, you first call `useRequestLoyaltyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLoyaltyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLoyaltyRegistrationMutation, { data, loading, error }] = useRequestLoyaltyRegistrationMutation({
 *   variables: {
 *      isChecked: // value for 'isChecked'
 *      legalStatus: // value for 'legalStatus'
 *   },
 * });
 */
export function useRequestLoyaltyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RequestLoyaltyRegistrationMutation, RequestLoyaltyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLoyaltyRegistrationMutation, RequestLoyaltyRegistrationMutationVariables>(RequestLoyaltyRegistrationDocument, options);
      }
export type RequestLoyaltyRegistrationMutationHookResult = ReturnType<typeof useRequestLoyaltyRegistrationMutation>;
export type RequestLoyaltyRegistrationMutationResult = Apollo.MutationResult<RequestLoyaltyRegistrationMutation>;
export type RequestLoyaltyRegistrationMutationOptions = Apollo.BaseMutationOptions<RequestLoyaltyRegistrationMutation, RequestLoyaltyRegistrationMutationVariables>;
export const GetMarketingEventCardsDocument = gql`
    query GetMarketingEventCards($type: EventPageType) {
  marketingCards(type: $type) {
    ...MarketingEventSlide_EventCard
  }
}
    ${MarketingEventSlide_EventCardFragmentDoc}`;

/**
 * __useGetMarketingEventCardsQuery__
 *
 * To run a query within a React component, call `useGetMarketingEventCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingEventCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingEventCardsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMarketingEventCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>(GetMarketingEventCardsDocument, options);
      }
export function useGetMarketingEventCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>(GetMarketingEventCardsDocument, options);
        }
export function useGetMarketingEventCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>(GetMarketingEventCardsDocument, options);
        }
export type GetMarketingEventCardsQueryHookResult = ReturnType<typeof useGetMarketingEventCardsQuery>;
export type GetMarketingEventCardsLazyQueryHookResult = ReturnType<typeof useGetMarketingEventCardsLazyQuery>;
export type GetMarketingEventCardsSuspenseQueryHookResult = ReturnType<typeof useGetMarketingEventCardsSuspenseQuery>;
export type GetMarketingEventCardsQueryResult = Apollo.QueryResult<GetMarketingEventCardsQuery, GetMarketingEventCardsQueryVariables>;
export const GetSignedOutWelcomeConfigDocument = gql`
    query GetSignedOutWelcomeConfig {
  config {
    customer {
      isAccountCreationEnabled
    }
  }
}
    `;

/**
 * __useGetSignedOutWelcomeConfigQuery__
 *
 * To run a query within a React component, call `useGetSignedOutWelcomeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedOutWelcomeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedOutWelcomeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignedOutWelcomeConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>(GetSignedOutWelcomeConfigDocument, options);
      }
export function useGetSignedOutWelcomeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>(GetSignedOutWelcomeConfigDocument, options);
        }
export function useGetSignedOutWelcomeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>(GetSignedOutWelcomeConfigDocument, options);
        }
export type GetSignedOutWelcomeConfigQueryHookResult = ReturnType<typeof useGetSignedOutWelcomeConfigQuery>;
export type GetSignedOutWelcomeConfigLazyQueryHookResult = ReturnType<typeof useGetSignedOutWelcomeConfigLazyQuery>;
export type GetSignedOutWelcomeConfigSuspenseQueryHookResult = ReturnType<typeof useGetSignedOutWelcomeConfigSuspenseQuery>;
export type GetSignedOutWelcomeConfigQueryResult = Apollo.QueryResult<GetSignedOutWelcomeConfigQuery, GetSignedOutWelcomeConfigQueryVariables>;
export const GetBannerInfosDocument = gql`
    query GetBannerInfos {
  config {
    preheader {
      isEnabled
      textColor
      backgroundColor
      text
    }
  }
}
    `;

/**
 * __useGetBannerInfosQuery__
 *
 * To run a query within a React component, call `useGetBannerInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBannerInfosQuery(baseOptions?: Apollo.QueryHookOptions<GetBannerInfosQuery, GetBannerInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerInfosQuery, GetBannerInfosQueryVariables>(GetBannerInfosDocument, options);
      }
export function useGetBannerInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerInfosQuery, GetBannerInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerInfosQuery, GetBannerInfosQueryVariables>(GetBannerInfosDocument, options);
        }
export function useGetBannerInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannerInfosQuery, GetBannerInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannerInfosQuery, GetBannerInfosQueryVariables>(GetBannerInfosDocument, options);
        }
export type GetBannerInfosQueryHookResult = ReturnType<typeof useGetBannerInfosQuery>;
export type GetBannerInfosLazyQueryHookResult = ReturnType<typeof useGetBannerInfosLazyQuery>;
export type GetBannerInfosSuspenseQueryHookResult = ReturnType<typeof useGetBannerInfosSuspenseQuery>;
export type GetBannerInfosQueryResult = Apollo.QueryResult<GetBannerInfosQuery, GetBannerInfosQueryVariables>;
export const GetMarketingProductsDocument = gql`
    query GetMarketingProducts($type: EventCrossType, $categoryId: String) {
  marketingProducts(type: $type, categoryId: $categoryId) {
    ...MarketingProductFields
  }
}
    ${MarketingProductFieldsFragmentDoc}`;

/**
 * __useGetMarketingProductsQuery__
 *
 * To run a query within a React component, call `useGetMarketingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingProductsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetMarketingProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>(GetMarketingProductsDocument, options);
      }
export function useGetMarketingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>(GetMarketingProductsDocument, options);
        }
export function useGetMarketingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>(GetMarketingProductsDocument, options);
        }
export type GetMarketingProductsQueryHookResult = ReturnType<typeof useGetMarketingProductsQuery>;
export type GetMarketingProductsLazyQueryHookResult = ReturnType<typeof useGetMarketingProductsLazyQuery>;
export type GetMarketingProductsSuspenseQueryHookResult = ReturnType<typeof useGetMarketingProductsSuspenseQuery>;
export type GetMarketingProductsQueryResult = Apollo.QueryResult<GetMarketingProductsQuery, GetMarketingProductsQueryVariables>;
export const GetMarketingProductsPriceAndStockDocument = gql`
    query GetMarketingProductsPriceAndStock($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    ...ProductCard_ProductPriceAndStock
  }
}
    ${ProductCard_ProductPriceAndStockFragmentDoc}`;

/**
 * __useGetMarketingProductsPriceAndStockQuery__
 *
 * To run a query within a React component, call `useGetMarketingProductsPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingProductsPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingProductsPriceAndStockQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useGetMarketingProductsPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables> & ({ variables: GetMarketingProductsPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>(GetMarketingProductsPriceAndStockDocument, options);
      }
export function useGetMarketingProductsPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>(GetMarketingProductsPriceAndStockDocument, options);
        }
export function useGetMarketingProductsPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>(GetMarketingProductsPriceAndStockDocument, options);
        }
export type GetMarketingProductsPriceAndStockQueryHookResult = ReturnType<typeof useGetMarketingProductsPriceAndStockQuery>;
export type GetMarketingProductsPriceAndStockLazyQueryHookResult = ReturnType<typeof useGetMarketingProductsPriceAndStockLazyQuery>;
export type GetMarketingProductsPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useGetMarketingProductsPriceAndStockSuspenseQuery>;
export type GetMarketingProductsPriceAndStockQueryResult = Apollo.QueryResult<GetMarketingProductsPriceAndStockQuery, GetMarketingProductsPriceAndStockQueryVariables>;
export const MiniCartButtonDocument = gql`
    query MiniCartButton {
  currentUser {
    id
    checkout {
      cart(forceRefresh: false) {
        id
        ...MiniCartButton_Cart
      }
    }
  }
  config {
    checkout {
      isMiniCartEnabled
    }
  }
}
    ${MiniCartButton_CartFragmentDoc}`;

/**
 * __useMiniCartButtonQuery__
 *
 * To run a query within a React component, call `useMiniCartButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiniCartButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiniCartButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useMiniCartButtonQuery(baseOptions?: Apollo.QueryHookOptions<MiniCartButtonQuery, MiniCartButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiniCartButtonQuery, MiniCartButtonQueryVariables>(MiniCartButtonDocument, options);
      }
export function useMiniCartButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiniCartButtonQuery, MiniCartButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiniCartButtonQuery, MiniCartButtonQueryVariables>(MiniCartButtonDocument, options);
        }
export function useMiniCartButtonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MiniCartButtonQuery, MiniCartButtonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MiniCartButtonQuery, MiniCartButtonQueryVariables>(MiniCartButtonDocument, options);
        }
export type MiniCartButtonQueryHookResult = ReturnType<typeof useMiniCartButtonQuery>;
export type MiniCartButtonLazyQueryHookResult = ReturnType<typeof useMiniCartButtonLazyQuery>;
export type MiniCartButtonSuspenseQueryHookResult = ReturnType<typeof useMiniCartButtonSuspenseQuery>;
export type MiniCartButtonQueryResult = Apollo.QueryResult<MiniCartButtonQuery, MiniCartButtonQueryVariables>;
export const MiniCartButtonPunchoutDocument = gql`
    query MiniCartButtonPunchout {
  currentUser {
    id
    punchout {
      cart {
        id
        totalExclTax
      }
    }
  }
}
    `;

/**
 * __useMiniCartButtonPunchoutQuery__
 *
 * To run a query within a React component, call `useMiniCartButtonPunchoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiniCartButtonPunchoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiniCartButtonPunchoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useMiniCartButtonPunchoutQuery(baseOptions?: Apollo.QueryHookOptions<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>(MiniCartButtonPunchoutDocument, options);
      }
export function useMiniCartButtonPunchoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>(MiniCartButtonPunchoutDocument, options);
        }
export function useMiniCartButtonPunchoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>(MiniCartButtonPunchoutDocument, options);
        }
export type MiniCartButtonPunchoutQueryHookResult = ReturnType<typeof useMiniCartButtonPunchoutQuery>;
export type MiniCartButtonPunchoutLazyQueryHookResult = ReturnType<typeof useMiniCartButtonPunchoutLazyQuery>;
export type MiniCartButtonPunchoutSuspenseQueryHookResult = ReturnType<typeof useMiniCartButtonPunchoutSuspenseQuery>;
export type MiniCartButtonPunchoutQueryResult = Apollo.QueryResult<MiniCartButtonPunchoutQuery, MiniCartButtonPunchoutQueryVariables>;
export const GetMixedOrdersDocument = gql`
    query GetMixedOrders($input: Browsing!) {
  currentUser {
    id
    permissions {
      showOrderHistory
      showStoreOrderHistory
    }
    orders(input: $input) {
      totalPages
      items {
        ...MixedOrdersContainer_Item
      }
    }
  }
}
    ${MixedOrdersContainer_ItemFragmentDoc}`;

/**
 * __useGetMixedOrdersQuery__
 *
 * To run a query within a React component, call `useGetMixedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMixedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMixedOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMixedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetMixedOrdersQuery, GetMixedOrdersQueryVariables> & ({ variables: GetMixedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>(GetMixedOrdersDocument, options);
      }
export function useGetMixedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>(GetMixedOrdersDocument, options);
        }
export function useGetMixedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>(GetMixedOrdersDocument, options);
        }
export type GetMixedOrdersQueryHookResult = ReturnType<typeof useGetMixedOrdersQuery>;
export type GetMixedOrdersLazyQueryHookResult = ReturnType<typeof useGetMixedOrdersLazyQuery>;
export type GetMixedOrdersSuspenseQueryHookResult = ReturnType<typeof useGetMixedOrdersSuspenseQuery>;
export type GetMixedOrdersQueryResult = Apollo.QueryResult<GetMixedOrdersQuery, GetMixedOrdersQueryVariables>;
export const OrdersResumeConfigDocument = gql`
    query OrdersResumeConfig {
  config {
    ...OrdersHistoryConfig
  }
}
    ${OrdersHistoryConfigFragmentDoc}`;

/**
 * __useOrdersResumeConfigQuery__
 *
 * To run a query within a React component, call `useOrdersResumeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersResumeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersResumeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdersResumeConfigQuery(baseOptions?: Apollo.QueryHookOptions<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>(OrdersResumeConfigDocument, options);
      }
export function useOrdersResumeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>(OrdersResumeConfigDocument, options);
        }
export function useOrdersResumeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>(OrdersResumeConfigDocument, options);
        }
export type OrdersResumeConfigQueryHookResult = ReturnType<typeof useOrdersResumeConfigQuery>;
export type OrdersResumeConfigLazyQueryHookResult = ReturnType<typeof useOrdersResumeConfigLazyQuery>;
export type OrdersResumeConfigSuspenseQueryHookResult = ReturnType<typeof useOrdersResumeConfigSuspenseQuery>;
export type OrdersResumeConfigQueryResult = Apollo.QueryResult<OrdersResumeConfigQuery, OrdersResumeConfigQueryVariables>;
export const MixedOrdersResumeCurrentUserDocument = gql`
    query MixedOrdersResumeCurrentUser($input: Browsing!) {
  currentUser {
    id
    permissions {
      showOrderHistory
      showStoreOrderHistory
    }
    orders(input: $input) {
      totalPages
      items {
        ...MixedOrdersContainer_Item
      }
    }
    checkout {
      cart {
        id
      }
    }
  }
}
    ${MixedOrdersContainer_ItemFragmentDoc}`;

/**
 * __useMixedOrdersResumeCurrentUserQuery__
 *
 * To run a query within a React component, call `useMixedOrdersResumeCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixedOrdersResumeCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixedOrdersResumeCurrentUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMixedOrdersResumeCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables> & ({ variables: MixedOrdersResumeCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>(MixedOrdersResumeCurrentUserDocument, options);
      }
export function useMixedOrdersResumeCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>(MixedOrdersResumeCurrentUserDocument, options);
        }
export function useMixedOrdersResumeCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>(MixedOrdersResumeCurrentUserDocument, options);
        }
export type MixedOrdersResumeCurrentUserQueryHookResult = ReturnType<typeof useMixedOrdersResumeCurrentUserQuery>;
export type MixedOrdersResumeCurrentUserLazyQueryHookResult = ReturnType<typeof useMixedOrdersResumeCurrentUserLazyQuery>;
export type MixedOrdersResumeCurrentUserSuspenseQueryHookResult = ReturnType<typeof useMixedOrdersResumeCurrentUserSuspenseQuery>;
export type MixedOrdersResumeCurrentUserQueryResult = Apollo.QueryResult<MixedOrdersResumeCurrentUserQuery, MixedOrdersResumeCurrentUserQueryVariables>;
export const OrdersResumeCurrentUserDocument = gql`
    query OrdersResumeCurrentUser($input: Browsing!) {
  currentUser {
    id
    permissions {
      showOrderHistory
      hasAccessToWebOrders
    }
    orders(input: $input) {
      totalPages
      items {
        ...WebOrdersContainer_Item
      }
    }
    checkout {
      cart {
        id
      }
    }
  }
}
    ${WebOrdersContainer_ItemFragmentDoc}`;

/**
 * __useOrdersResumeCurrentUserQuery__
 *
 * To run a query within a React component, call `useOrdersResumeCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersResumeCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersResumeCurrentUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrdersResumeCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables> & ({ variables: OrdersResumeCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>(OrdersResumeCurrentUserDocument, options);
      }
export function useOrdersResumeCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>(OrdersResumeCurrentUserDocument, options);
        }
export function useOrdersResumeCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>(OrdersResumeCurrentUserDocument, options);
        }
export type OrdersResumeCurrentUserQueryHookResult = ReturnType<typeof useOrdersResumeCurrentUserQuery>;
export type OrdersResumeCurrentUserLazyQueryHookResult = ReturnType<typeof useOrdersResumeCurrentUserLazyQuery>;
export type OrdersResumeCurrentUserSuspenseQueryHookResult = ReturnType<typeof useOrdersResumeCurrentUserSuspenseQuery>;
export type OrdersResumeCurrentUserQueryResult = Apollo.QueryResult<OrdersResumeCurrentUserQuery, OrdersResumeCurrentUserQueryVariables>;
export const GetStoreOrdersDocument = gql`
    query GetStoreOrders($input: Browsing!) {
  currentUser {
    id
    permissions {
      showOrderHistory
      hasAccessToStoreOrders
    }
    orders(input: $input) {
      totalPages
      items {
        ...StoreOrdersContainer_Item
      }
    }
  }
}
    ${StoreOrdersContainer_ItemFragmentDoc}`;

/**
 * __useGetStoreOrdersQuery__
 *
 * To run a query within a React component, call `useGetStoreOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStoreOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetStoreOrdersQuery, GetStoreOrdersQueryVariables> & ({ variables: GetStoreOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>(GetStoreOrdersDocument, options);
      }
export function useGetStoreOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>(GetStoreOrdersDocument, options);
        }
export function useGetStoreOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>(GetStoreOrdersDocument, options);
        }
export type GetStoreOrdersQueryHookResult = ReturnType<typeof useGetStoreOrdersQuery>;
export type GetStoreOrdersLazyQueryHookResult = ReturnType<typeof useGetStoreOrdersLazyQuery>;
export type GetStoreOrdersSuspenseQueryHookResult = ReturnType<typeof useGetStoreOrdersSuspenseQuery>;
export type GetStoreOrdersQueryResult = Apollo.QueryResult<GetStoreOrdersQuery, GetStoreOrdersQueryVariables>;
export const GetWebOrdersDocument = gql`
    query GetWebOrders($input: Browsing!) {
  currentUser {
    id
    permissions {
      showOrderHistory
      hasAccessToWebOrders
    }
    orders(input: $input) {
      totalPages
      items {
        ...WebOrdersContainer_Item
      }
    }
  }
}
    ${WebOrdersContainer_ItemFragmentDoc}`;

/**
 * __useGetWebOrdersQuery__
 *
 * To run a query within a React component, call `useGetWebOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWebOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetWebOrdersQuery, GetWebOrdersQueryVariables> & ({ variables: GetWebOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebOrdersQuery, GetWebOrdersQueryVariables>(GetWebOrdersDocument, options);
      }
export function useGetWebOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebOrdersQuery, GetWebOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebOrdersQuery, GetWebOrdersQueryVariables>(GetWebOrdersDocument, options);
        }
export function useGetWebOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebOrdersQuery, GetWebOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebOrdersQuery, GetWebOrdersQueryVariables>(GetWebOrdersDocument, options);
        }
export type GetWebOrdersQueryHookResult = ReturnType<typeof useGetWebOrdersQuery>;
export type GetWebOrdersLazyQueryHookResult = ReturnType<typeof useGetWebOrdersLazyQuery>;
export type GetWebOrdersSuspenseQueryHookResult = ReturnType<typeof useGetWebOrdersSuspenseQuery>;
export type GetWebOrdersQueryResult = Apollo.QueryResult<GetWebOrdersQuery, GetWebOrdersQueryVariables>;
export const StoreOrderDetailsDocument = gql`
    query StoreOrderDetails($externalRef: String!) {
  currentUser {
    id
    orders(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $externalRef}, {type: STRING, field: "orderType", operator: EQUAL, stringValue: "STORE"}]}
    ) {
      items {
        internalRef
        orderDate
        status
        buyer {
          name
        }
        hasClickAndCollectItems
        hasOnlineDeliveryItems
        isPickUpShippingMethod
        delivery {
          addresses {
            ...OrderAddress
          }
        }
        collectPointOfSale {
          ...CollectPointOfSale
        }
        items {
          ...StoreOrderProductRow_OrderItem
        }
        ...StoreOrderSummaryCard_Order
      }
    }
  }
  config {
    ...OrdersHistoryConfig
    ...OrderReferenceDisplay_Config
  }
}
    ${OrderAddressFragmentDoc}
${CollectPointOfSaleFragmentDoc}
${StoreOrderProductRow_OrderItemFragmentDoc}
${StoreOrderSummaryCard_OrderFragmentDoc}
${OrdersHistoryConfigFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useStoreOrderDetailsQuery__
 *
 * To run a query within a React component, call `useStoreOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreOrderDetailsQuery({
 *   variables: {
 *      externalRef: // value for 'externalRef'
 *   },
 * });
 */
export function useStoreOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables> & ({ variables: StoreOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>(StoreOrderDetailsDocument, options);
      }
export function useStoreOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>(StoreOrderDetailsDocument, options);
        }
export function useStoreOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>(StoreOrderDetailsDocument, options);
        }
export type StoreOrderDetailsQueryHookResult = ReturnType<typeof useStoreOrderDetailsQuery>;
export type StoreOrderDetailsLazyQueryHookResult = ReturnType<typeof useStoreOrderDetailsLazyQuery>;
export type StoreOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useStoreOrderDetailsSuspenseQuery>;
export type StoreOrderDetailsQueryResult = Apollo.QueryResult<StoreOrderDetailsQuery, StoreOrderDetailsQueryVariables>;
export const StoreOrdersPermissionDocument = gql`
    query StoreOrdersPermission {
  currentUser {
    permissions {
      hasAccessToStoreOrders
    }
  }
}
    `;

/**
 * __useStoreOrdersPermissionQuery__
 *
 * To run a query within a React component, call `useStoreOrdersPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreOrdersPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreOrdersPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreOrdersPermissionQuery(baseOptions?: Apollo.QueryHookOptions<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>(StoreOrdersPermissionDocument, options);
      }
export function useStoreOrdersPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>(StoreOrdersPermissionDocument, options);
        }
export function useStoreOrdersPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>(StoreOrdersPermissionDocument, options);
        }
export type StoreOrdersPermissionQueryHookResult = ReturnType<typeof useStoreOrdersPermissionQuery>;
export type StoreOrdersPermissionLazyQueryHookResult = ReturnType<typeof useStoreOrdersPermissionLazyQuery>;
export type StoreOrdersPermissionSuspenseQueryHookResult = ReturnType<typeof useStoreOrdersPermissionSuspenseQuery>;
export type StoreOrdersPermissionQueryResult = Apollo.QueryResult<StoreOrdersPermissionQuery, StoreOrdersPermissionQueryVariables>;
export const WebOrderDetailsDocument = gql`
    query WebOrderDetails($webRef: String!) {
  currentUser {
    id
    orders(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $webRef}, {type: STRING, field: "orderType", operator: EQUAL, stringValue: "ECOMMERCE"}]}
    ) {
      items {
        hasClickAndCollectItems
        hasOnlineDeliveryItems
        isPickUpShippingMethod
        internalRef
        orderDate
        status
        approver {
          firstname
          lastname
        }
        buyer {
          name
        }
        delivery {
          addresses {
            ...WebOrderDetails_Address
          }
        }
        collectPointOfSale {
          ...CollectPointOfSale
        }
        wentThroughApproval
        itemsSplitByDeliveryDate {
          info {
            __typename
            ... on OrderItemsSectionInfoReal {
              date
            }
            ... on OrderItemsSectionInfoEstimated {
              delay
            }
            ... on OrderItemsSectionInfoClickAndCollect {
              noValue
            }
            ... on OrderItemsSectionInfoNoDeliveryTime {
              noDeliveryTime
            }
          }
          items {
            ...WebOrderProductRow_OrderItem
          }
        }
        ...WebOrderSummaryCard_Order
      }
    }
  }
  config {
    ...OrdersHistoryConfig
    ...OrderReferenceDisplay_Config
  }
}
    ${WebOrderDetails_AddressFragmentDoc}
${CollectPointOfSaleFragmentDoc}
${WebOrderProductRow_OrderItemFragmentDoc}
${WebOrderSummaryCard_OrderFragmentDoc}
${OrdersHistoryConfigFragmentDoc}
${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useWebOrderDetailsQuery__
 *
 * To run a query within a React component, call `useWebOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOrderDetailsQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useWebOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<WebOrderDetailsQuery, WebOrderDetailsQueryVariables> & ({ variables: WebOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>(WebOrderDetailsDocument, options);
      }
export function useWebOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>(WebOrderDetailsDocument, options);
        }
export function useWebOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>(WebOrderDetailsDocument, options);
        }
export type WebOrderDetailsQueryHookResult = ReturnType<typeof useWebOrderDetailsQuery>;
export type WebOrderDetailsLazyQueryHookResult = ReturnType<typeof useWebOrderDetailsLazyQuery>;
export type WebOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useWebOrderDetailsSuspenseQuery>;
export type WebOrderDetailsQueryResult = Apollo.QueryResult<WebOrderDetailsQuery, WebOrderDetailsQueryVariables>;
export const WebOrdersPermissionDocument = gql`
    query WebOrdersPermission {
  currentUser {
    permissions {
      hasAccessToWebOrders
    }
  }
}
    `;

/**
 * __useWebOrdersPermissionQuery__
 *
 * To run a query within a React component, call `useWebOrdersPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOrdersPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOrdersPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebOrdersPermissionQuery(baseOptions?: Apollo.QueryHookOptions<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>(WebOrdersPermissionDocument, options);
      }
export function useWebOrdersPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>(WebOrdersPermissionDocument, options);
        }
export function useWebOrdersPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>(WebOrdersPermissionDocument, options);
        }
export type WebOrdersPermissionQueryHookResult = ReturnType<typeof useWebOrdersPermissionQuery>;
export type WebOrdersPermissionLazyQueryHookResult = ReturnType<typeof useWebOrdersPermissionLazyQuery>;
export type WebOrdersPermissionSuspenseQueryHookResult = ReturnType<typeof useWebOrdersPermissionSuspenseQuery>;
export type WebOrdersPermissionQueryResult = Apollo.QueryResult<WebOrdersPermissionQuery, WebOrdersPermissionQueryVariables>;
export const OrderRequestsDocument = gql`
    query OrderRequests($since: String) {
  currentUser {
    id
    orderRequests(
      input: {filter: [{type: STRING, field: "since", operator: EQUAL, stringValue: $since}]}
    ) {
      items {
        ...OrderRequestBuyerTable_Item
      }
    }
  }
}
    ${OrderRequestBuyerTable_ItemFragmentDoc}`;

/**
 * __useOrderRequestsQuery__
 *
 * To run a query within a React component, call `useOrderRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestsQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useOrderRequestsQuery(baseOptions?: Apollo.QueryHookOptions<OrderRequestsQuery, OrderRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestsQuery, OrderRequestsQueryVariables>(OrderRequestsDocument, options);
      }
export function useOrderRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestsQuery, OrderRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestsQuery, OrderRequestsQueryVariables>(OrderRequestsDocument, options);
        }
export function useOrderRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRequestsQuery, OrderRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRequestsQuery, OrderRequestsQueryVariables>(OrderRequestsDocument, options);
        }
export type OrderRequestsQueryHookResult = ReturnType<typeof useOrderRequestsQuery>;
export type OrderRequestsLazyQueryHookResult = ReturnType<typeof useOrderRequestsLazyQuery>;
export type OrderRequestsSuspenseQueryHookResult = ReturnType<typeof useOrderRequestsSuspenseQuery>;
export type OrderRequestsQueryResult = Apollo.QueryResult<OrderRequestsQuery, OrderRequestsQueryVariables>;
export const SaveOrderRequestModificationsDocument = gql`
    mutation SaveOrderRequestModifications($webRef: String!, $orderRequestData: OrderRequestDataInput) {
  saveOrderRequestModifications(
    webRef: $webRef
    orderRequestData: $orderRequestData
  )
}
    `;
export type SaveOrderRequestModificationsMutationFn = Apollo.MutationFunction<SaveOrderRequestModificationsMutation, SaveOrderRequestModificationsMutationVariables>;

/**
 * __useSaveOrderRequestModificationsMutation__
 *
 * To run a mutation, you first call `useSaveOrderRequestModificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrderRequestModificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrderRequestModificationsMutation, { data, loading, error }] = useSaveOrderRequestModificationsMutation({
 *   variables: {
 *      webRef: // value for 'webRef'
 *      orderRequestData: // value for 'orderRequestData'
 *   },
 * });
 */
export function useSaveOrderRequestModificationsMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrderRequestModificationsMutation, SaveOrderRequestModificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrderRequestModificationsMutation, SaveOrderRequestModificationsMutationVariables>(SaveOrderRequestModificationsDocument, options);
      }
export type SaveOrderRequestModificationsMutationHookResult = ReturnType<typeof useSaveOrderRequestModificationsMutation>;
export type SaveOrderRequestModificationsMutationResult = Apollo.MutationResult<SaveOrderRequestModificationsMutation>;
export type SaveOrderRequestModificationsMutationOptions = Apollo.BaseMutationOptions<SaveOrderRequestModificationsMutation, SaveOrderRequestModificationsMutationVariables>;
export const SetOrderReferenceOnCartDocument = gql`
    mutation SetOrderReferenceOnCart($cartId: String!, $orderReference: String) {
  setOrderReferenceOnCart(cartId: $cartId, orderReference: $orderReference)
}
    `;
export type SetOrderReferenceOnCartMutationFn = Apollo.MutationFunction<SetOrderReferenceOnCartMutation, SetOrderReferenceOnCartMutationVariables>;

/**
 * __useSetOrderReferenceOnCartMutation__
 *
 * To run a mutation, you first call `useSetOrderReferenceOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderReferenceOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderReferenceOnCartMutation, { data, loading, error }] = useSetOrderReferenceOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      orderReference: // value for 'orderReference'
 *   },
 * });
 */
export function useSetOrderReferenceOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetOrderReferenceOnCartMutation, SetOrderReferenceOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrderReferenceOnCartMutation, SetOrderReferenceOnCartMutationVariables>(SetOrderReferenceOnCartDocument, options);
      }
export type SetOrderReferenceOnCartMutationHookResult = ReturnType<typeof useSetOrderReferenceOnCartMutation>;
export type SetOrderReferenceOnCartMutationResult = Apollo.MutationResult<SetOrderReferenceOnCartMutation>;
export type SetOrderReferenceOnCartMutationOptions = Apollo.BaseMutationOptions<SetOrderReferenceOnCartMutation, SetOrderReferenceOnCartMutationVariables>;
export const RefuseOrderRequestDocument = gql`
    mutation RefuseOrderRequest($webRef: String!, $comment: String) {
  refuseOrderRequest(webRef: $webRef, comment: $comment)
}
    `;
export type RefuseOrderRequestMutationFn = Apollo.MutationFunction<RefuseOrderRequestMutation, RefuseOrderRequestMutationVariables>;

/**
 * __useRefuseOrderRequestMutation__
 *
 * To run a mutation, you first call `useRefuseOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseOrderRequestMutation, { data, loading, error }] = useRefuseOrderRequestMutation({
 *   variables: {
 *      webRef: // value for 'webRef'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRefuseOrderRequestMutation(baseOptions?: Apollo.MutationHookOptions<RefuseOrderRequestMutation, RefuseOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseOrderRequestMutation, RefuseOrderRequestMutationVariables>(RefuseOrderRequestDocument, options);
      }
export type RefuseOrderRequestMutationHookResult = ReturnType<typeof useRefuseOrderRequestMutation>;
export type RefuseOrderRequestMutationResult = Apollo.MutationResult<RefuseOrderRequestMutation>;
export type RefuseOrderRequestMutationOptions = Apollo.BaseMutationOptions<RefuseOrderRequestMutation, RefuseOrderRequestMutationVariables>;
export const OrderRequestDeliveryDateDocument = gql`
    mutation OrderRequestDeliveryDate($cartId: String!, $date: String) {
  requestDeliveryDate(cartId: $cartId, date: $date) {
    cart {
      id
      requestedDeliveryDate
    }
  }
}
    `;
export type OrderRequestDeliveryDateMutationFn = Apollo.MutationFunction<OrderRequestDeliveryDateMutation, OrderRequestDeliveryDateMutationVariables>;

/**
 * __useOrderRequestDeliveryDateMutation__
 *
 * To run a mutation, you first call `useOrderRequestDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderRequestDeliveryDateMutation, { data, loading, error }] = useOrderRequestDeliveryDateMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOrderRequestDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<OrderRequestDeliveryDateMutation, OrderRequestDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderRequestDeliveryDateMutation, OrderRequestDeliveryDateMutationVariables>(OrderRequestDeliveryDateDocument, options);
      }
export type OrderRequestDeliveryDateMutationHookResult = ReturnType<typeof useOrderRequestDeliveryDateMutation>;
export type OrderRequestDeliveryDateMutationResult = Apollo.MutationResult<OrderRequestDeliveryDateMutation>;
export type OrderRequestDeliveryDateMutationOptions = Apollo.BaseMutationOptions<OrderRequestDeliveryDateMutation, OrderRequestDeliveryDateMutationVariables>;
export const ApproveOrderRequestDocument = gql`
    mutation ApproveOrderRequest($webRef: String!) {
  approveOrderRequest(webRef: $webRef)
}
    `;
export type ApproveOrderRequestMutationFn = Apollo.MutationFunction<ApproveOrderRequestMutation, ApproveOrderRequestMutationVariables>;

/**
 * __useApproveOrderRequestMutation__
 *
 * To run a mutation, you first call `useApproveOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrderRequestMutation, { data, loading, error }] = useApproveOrderRequestMutation({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useApproveOrderRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrderRequestMutation, ApproveOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrderRequestMutation, ApproveOrderRequestMutationVariables>(ApproveOrderRequestDocument, options);
      }
export type ApproveOrderRequestMutationHookResult = ReturnType<typeof useApproveOrderRequestMutation>;
export type ApproveOrderRequestMutationResult = Apollo.MutationResult<ApproveOrderRequestMutation>;
export type ApproveOrderRequestMutationOptions = Apollo.BaseMutationOptions<ApproveOrderRequestMutation, ApproveOrderRequestMutationVariables>;
export const OrderRequestsValidationDocument = gql`
    query OrderRequestsValidation($since: String, $sortField: String!, $sortDirection: Direction, $pageIndex: Int!, $pageSize: Int!) {
  currentUser {
    id
    orderRequests(
      input: {filter: [{type: BOOLEAN, field: "approver", operator: EQUAL, booleanValue: true}, {type: STRING, field: "since", operator: EQUAL, stringValue: $since}], pagination: {size: $pageSize, index: $pageIndex}, sort: {field: $sortField, direction: $sortDirection}}
    ) {
      items {
        ...OrderRequestValidationTable_Order
      }
      totalPages
      totalSize
    }
  }
}
    ${OrderRequestValidationTable_OrderFragmentDoc}`;

/**
 * __useOrderRequestsValidationQuery__
 *
 * To run a query within a React component, call `useOrderRequestsValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestsValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestsValidationQuery({
 *   variables: {
 *      since: // value for 'since'
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useOrderRequestsValidationQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables> & ({ variables: OrderRequestsValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>(OrderRequestsValidationDocument, options);
      }
export function useOrderRequestsValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>(OrderRequestsValidationDocument, options);
        }
export function useOrderRequestsValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>(OrderRequestsValidationDocument, options);
        }
export type OrderRequestsValidationQueryHookResult = ReturnType<typeof useOrderRequestsValidationQuery>;
export type OrderRequestsValidationLazyQueryHookResult = ReturnType<typeof useOrderRequestsValidationLazyQuery>;
export type OrderRequestsValidationSuspenseQueryHookResult = ReturnType<typeof useOrderRequestsValidationSuspenseQuery>;
export type OrderRequestsValidationQueryResult = Apollo.QueryResult<OrderRequestsValidationQuery, OrderRequestsValidationQueryVariables>;
export const OrderRequestResetDocument = gql`
    query OrderRequestReset($webRef: String!) {
  currentUser {
    id
    orderRequestToApprove(webRef: $webRef, resetData: true) {
      internalRef
      orderDate
      webRef
      approvee {
        firstname
        lastname
      }
      approver {
        firstname
        lastname
      }
      delivery {
        addresses {
          ...OrderAddress
        }
        fee {
          ... on ShippingFeeFree {
            isFranco
          }
          ... on ShippingFeeWithAmount {
            amount
          }
        }
      }
      payment {
        code
      }
      updatedState {
        id
        ...CartSummary_Cart
        requestedDeliveryDate
        messages {
          ...OrderRequestUnavailableProduct_CartMessage
        }
        itemsGroupedByEarliestDeliveryDate {
          items {
            totalExclTax
            id
            quantity
            deliveryDetails {
              ...OrderRequestSectionLabel_CartItemDeliveryStockDetails
            }
            unitPrice {
              exclTax
            }
            discount {
              catalogDiscountAmount
              oldPrice
              percentage
              webDiscount {
                amount
                hasCoupon
                label
              }
            }
            product {
              ...ExtendedProduct
              stock {
                packaging {
                  ...FullPackaging
                }
              }
              isEquivalentProductsLinkVisible
              urlKey
            }
            promotionTag {
              ...PromotionTagFields
            }
          }
        }
      }
    }
  }
}
    ${OrderAddressFragmentDoc}
${CartSummary_CartFragmentDoc}
${OrderRequestUnavailableProduct_CartMessageFragmentDoc}
${OrderRequestSectionLabel_CartItemDeliveryStockDetailsFragmentDoc}
${ExtendedProductFragmentDoc}
${FullPackagingFragmentDoc}
${PromotionTagFieldsFragmentDoc}`;

/**
 * __useOrderRequestResetQuery__
 *
 * To run a query within a React component, call `useOrderRequestResetQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestResetQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useOrderRequestResetQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestResetQuery, OrderRequestResetQueryVariables> & ({ variables: OrderRequestResetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestResetQuery, OrderRequestResetQueryVariables>(OrderRequestResetDocument, options);
      }
export function useOrderRequestResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestResetQuery, OrderRequestResetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestResetQuery, OrderRequestResetQueryVariables>(OrderRequestResetDocument, options);
        }
export function useOrderRequestResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRequestResetQuery, OrderRequestResetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRequestResetQuery, OrderRequestResetQueryVariables>(OrderRequestResetDocument, options);
        }
export type OrderRequestResetQueryHookResult = ReturnType<typeof useOrderRequestResetQuery>;
export type OrderRequestResetLazyQueryHookResult = ReturnType<typeof useOrderRequestResetLazyQuery>;
export type OrderRequestResetSuspenseQueryHookResult = ReturnType<typeof useOrderRequestResetSuspenseQuery>;
export type OrderRequestResetQueryResult = Apollo.QueryResult<OrderRequestResetQuery, OrderRequestResetQueryVariables>;
export const OrderReferenceDisplayDocument = gql`
    query OrderReferenceDisplay {
  config {
    ...OrderReferenceDisplay_Config
  }
}
    ${OrderReferenceDisplay_ConfigFragmentDoc}`;

/**
 * __useOrderReferenceDisplayQuery__
 *
 * To run a query within a React component, call `useOrderReferenceDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderReferenceDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderReferenceDisplayQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderReferenceDisplayQuery(baseOptions?: Apollo.QueryHookOptions<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>(OrderReferenceDisplayDocument, options);
      }
export function useOrderReferenceDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>(OrderReferenceDisplayDocument, options);
        }
export function useOrderReferenceDisplaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>(OrderReferenceDisplayDocument, options);
        }
export type OrderReferenceDisplayQueryHookResult = ReturnType<typeof useOrderReferenceDisplayQuery>;
export type OrderReferenceDisplayLazyQueryHookResult = ReturnType<typeof useOrderReferenceDisplayLazyQuery>;
export type OrderReferenceDisplaySuspenseQueryHookResult = ReturnType<typeof useOrderReferenceDisplaySuspenseQuery>;
export type OrderReferenceDisplayQueryResult = Apollo.QueryResult<OrderReferenceDisplayQuery, OrderReferenceDisplayQueryVariables>;
export const PaymentDocument = gql`
    query Payment {
  config {
    sales {
      isChorusDisplayEnabled
    }
  }
  currentUser {
    id
    ...PaymentForm_User
  }
}
    ${PaymentForm_UserFragmentDoc}`;

/**
 * __usePaymentQuery__
 *
 * To run a query within a React component, call `usePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentQuery(baseOptions?: Apollo.QueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options);
      }
export function usePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options);
        }
export function usePaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options);
        }
export type PaymentQueryHookResult = ReturnType<typeof usePaymentQuery>;
export type PaymentLazyQueryHookResult = ReturnType<typeof usePaymentLazyQuery>;
export type PaymentSuspenseQueryHookResult = ReturnType<typeof usePaymentSuspenseQuery>;
export type PaymentQueryResult = Apollo.QueryResult<PaymentQuery, PaymentQueryVariables>;
export const PayzenPublicKeyDocument = gql`
    query PayzenPublicKey {
  config {
    sales {
      payzen {
        currentSubsidiary {
          publicKey
        }
      }
    }
  }
}
    `;

/**
 * __usePayzenPublicKeyQuery__
 *
 * To run a query within a React component, call `usePayzenPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayzenPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayzenPublicKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayzenPublicKeyQuery(baseOptions?: Apollo.QueryHookOptions<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>(PayzenPublicKeyDocument, options);
      }
export function usePayzenPublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>(PayzenPublicKeyDocument, options);
        }
export function usePayzenPublicKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>(PayzenPublicKeyDocument, options);
        }
export type PayzenPublicKeyQueryHookResult = ReturnType<typeof usePayzenPublicKeyQuery>;
export type PayzenPublicKeyLazyQueryHookResult = ReturnType<typeof usePayzenPublicKeyLazyQuery>;
export type PayzenPublicKeySuspenseQueryHookResult = ReturnType<typeof usePayzenPublicKeySuspenseQuery>;
export type PayzenPublicKeyQueryResult = Apollo.QueryResult<PayzenPublicKeyQuery, PayzenPublicKeyQueryVariables>;
export const PayzenTokenDocument = gql`
    query PayzenToken {
  currentUser {
    id
    checkout {
      payment {
        availableMethods {
          card {
            token
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePayzenTokenQuery__
 *
 * To run a query within a React component, call `usePayzenTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayzenTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayzenTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayzenTokenQuery(baseOptions?: Apollo.QueryHookOptions<PayzenTokenQuery, PayzenTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayzenTokenQuery, PayzenTokenQueryVariables>(PayzenTokenDocument, options);
      }
export function usePayzenTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayzenTokenQuery, PayzenTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayzenTokenQuery, PayzenTokenQueryVariables>(PayzenTokenDocument, options);
        }
export function usePayzenTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayzenTokenQuery, PayzenTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayzenTokenQuery, PayzenTokenQueryVariables>(PayzenTokenDocument, options);
        }
export type PayzenTokenQueryHookResult = ReturnType<typeof usePayzenTokenQuery>;
export type PayzenTokenLazyQueryHookResult = ReturnType<typeof usePayzenTokenLazyQuery>;
export type PayzenTokenSuspenseQueryHookResult = ReturnType<typeof usePayzenTokenSuspenseQuery>;
export type PayzenTokenQueryResult = Apollo.QueryResult<PayzenTokenQuery, PayzenTokenQueryVariables>;
export const SetAdditionalOrderInfoOnCartDocument = gql`
    mutation SetAdditionalOrderInfoOnCart($cartId: String!, $additionalOrderInfo: SetAdditionalOrderInfoInput!) {
  setAdditionalOrderInfoOnCart(
    cartId: $cartId
    additionalOrderInfo: $additionalOrderInfo
  )
}
    `;
export type SetAdditionalOrderInfoOnCartMutationFn = Apollo.MutationFunction<SetAdditionalOrderInfoOnCartMutation, SetAdditionalOrderInfoOnCartMutationVariables>;

/**
 * __useSetAdditionalOrderInfoOnCartMutation__
 *
 * To run a mutation, you first call `useSetAdditionalOrderInfoOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdditionalOrderInfoOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdditionalOrderInfoOnCartMutation, { data, loading, error }] = useSetAdditionalOrderInfoOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      additionalOrderInfo: // value for 'additionalOrderInfo'
 *   },
 * });
 */
export function useSetAdditionalOrderInfoOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetAdditionalOrderInfoOnCartMutation, SetAdditionalOrderInfoOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdditionalOrderInfoOnCartMutation, SetAdditionalOrderInfoOnCartMutationVariables>(SetAdditionalOrderInfoOnCartDocument, options);
      }
export type SetAdditionalOrderInfoOnCartMutationHookResult = ReturnType<typeof useSetAdditionalOrderInfoOnCartMutation>;
export type SetAdditionalOrderInfoOnCartMutationResult = Apollo.MutationResult<SetAdditionalOrderInfoOnCartMutation>;
export type SetAdditionalOrderInfoOnCartMutationOptions = Apollo.BaseMutationOptions<SetAdditionalOrderInfoOnCartMutation, SetAdditionalOrderInfoOnCartMutationVariables>;
export const PlaceOrderWithPayzenDocument = gql`
    mutation PlaceOrderWithPayzen($cartId: String!, $payzenResponse: PayzenPaymentResponseInput!) {
  placeOrder(cartId: $cartId, payzenResponse: $payzenResponse)
}
    `;
export type PlaceOrderWithPayzenMutationFn = Apollo.MutationFunction<PlaceOrderWithPayzenMutation, PlaceOrderWithPayzenMutationVariables>;

/**
 * __usePlaceOrderWithPayzenMutation__
 *
 * To run a mutation, you first call `usePlaceOrderWithPayzenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderWithPayzenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderWithPayzenMutation, { data, loading, error }] = usePlaceOrderWithPayzenMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      payzenResponse: // value for 'payzenResponse'
 *   },
 * });
 */
export function usePlaceOrderWithPayzenMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderWithPayzenMutation, PlaceOrderWithPayzenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceOrderWithPayzenMutation, PlaceOrderWithPayzenMutationVariables>(PlaceOrderWithPayzenDocument, options);
      }
export type PlaceOrderWithPayzenMutationHookResult = ReturnType<typeof usePlaceOrderWithPayzenMutation>;
export type PlaceOrderWithPayzenMutationResult = Apollo.MutationResult<PlaceOrderWithPayzenMutation>;
export type PlaceOrderWithPayzenMutationOptions = Apollo.BaseMutationOptions<PlaceOrderWithPayzenMutation, PlaceOrderWithPayzenMutationVariables>;
export const PlaceOrderDocument = gql`
    mutation PlaceOrder($cartId: String!, $setAdditionalOrderInfoInput: SetAdditionalOrderInfoInput) {
  placeOrder(
    cartId: $cartId
    setAdditionalOrderInfoInput: $setAdditionalOrderInfoInput
  )
}
    `;
export type PlaceOrderMutationFn = Apollo.MutationFunction<PlaceOrderMutation, PlaceOrderMutationVariables>;

/**
 * __usePlaceOrderMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutation, { data, loading, error }] = usePlaceOrderMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      setAdditionalOrderInfoInput: // value for 'setAdditionalOrderInfoInput'
 *   },
 * });
 */
export function usePlaceOrderMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderMutation, PlaceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(PlaceOrderDocument, options);
      }
export type PlaceOrderMutationHookResult = ReturnType<typeof usePlaceOrderMutation>;
export type PlaceOrderMutationResult = Apollo.MutationResult<PlaceOrderMutation>;
export type PlaceOrderMutationOptions = Apollo.BaseMutationOptions<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const SetPaymentMethodOnCartDocument = gql`
    mutation SetPaymentMethodOnCart($cartId: String!, $paymentCode: String!) {
  setPaymentMethodOnCart(
    paymentMethodOnCartInput: {cartId: $cartId, paymentMethod: {code: $paymentCode}}
  ) {
    cart {
      id
    }
    payment {
      code
    }
  }
}
    `;
export type SetPaymentMethodOnCartMutationFn = Apollo.MutationFunction<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>;

/**
 * __useSetPaymentMethodOnCartMutation__
 *
 * To run a mutation, you first call `useSetPaymentMethodOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentMethodOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentMethodOnCartMutation, { data, loading, error }] = useSetPaymentMethodOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      paymentCode: // value for 'paymentCode'
 *   },
 * });
 */
export function useSetPaymentMethodOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>(SetPaymentMethodOnCartDocument, options);
      }
export type SetPaymentMethodOnCartMutationHookResult = ReturnType<typeof useSetPaymentMethodOnCartMutation>;
export type SetPaymentMethodOnCartMutationResult = Apollo.MutationResult<SetPaymentMethodOnCartMutation>;
export type SetPaymentMethodOnCartMutationOptions = Apollo.BaseMutationOptions<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>;
export const CartItemsAtPaymentTrackingDocument = gql`
    query CartItemsAtPaymentTracking {
  currentUser {
    id
    checkout {
      cart {
        id
        totalExclTax
        isClickAndCollectActivated
        currency
        couponCode
        itemsGroupedByEarliestDeliveryDate {
          items {
            id
            analyticsPromotionStatus
            availableClickAndCollect
            quantity
            totalExclTax
            unitPrice {
              exclTax
            }
            product {
              name
              reference
              type
              parentReference
              price {
                tag
              }
              brand {
                name
                urlKey
              }
              analytics {
                promotionStatus
              }
              nomenclatureFamily
              nomenclatureGroup
              canAddToCart
              stock {
                availability
                isSellable
              }
            }
            deliveryDetails {
              availability
              date
              realDeliveryDate
              quantity
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCartItemsAtPaymentTrackingQuery__
 *
 * To run a query within a React component, call `useCartItemsAtPaymentTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemsAtPaymentTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemsAtPaymentTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartItemsAtPaymentTrackingQuery(baseOptions?: Apollo.QueryHookOptions<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>(CartItemsAtPaymentTrackingDocument, options);
      }
export function useCartItemsAtPaymentTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>(CartItemsAtPaymentTrackingDocument, options);
        }
export function useCartItemsAtPaymentTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>(CartItemsAtPaymentTrackingDocument, options);
        }
export type CartItemsAtPaymentTrackingQueryHookResult = ReturnType<typeof useCartItemsAtPaymentTrackingQuery>;
export type CartItemsAtPaymentTrackingLazyQueryHookResult = ReturnType<typeof useCartItemsAtPaymentTrackingLazyQuery>;
export type CartItemsAtPaymentTrackingSuspenseQueryHookResult = ReturnType<typeof useCartItemsAtPaymentTrackingSuspenseQuery>;
export type CartItemsAtPaymentTrackingQueryResult = Apollo.QueryResult<CartItemsAtPaymentTrackingQuery, CartItemsAtPaymentTrackingQueryVariables>;
export const PointOfSaleDrawerDocument = gql`
    query PointOfSaleDrawer($id: String!) {
  pointOfSale(pointOfSaleId: $id) {
    ...DisplayPointOfSaleInfos_pointOfSale
  }
}
    ${DisplayPointOfSaleInfos_PointOfSaleFragmentDoc}`;

/**
 * __usePointOfSaleDrawerQuery__
 *
 * To run a query within a React component, call `usePointOfSaleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfSaleDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePointOfSaleDrawerQuery(baseOptions: Apollo.QueryHookOptions<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables> & ({ variables: PointOfSaleDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>(PointOfSaleDrawerDocument, options);
      }
export function usePointOfSaleDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>(PointOfSaleDrawerDocument, options);
        }
export function usePointOfSaleDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>(PointOfSaleDrawerDocument, options);
        }
export type PointOfSaleDrawerQueryHookResult = ReturnType<typeof usePointOfSaleDrawerQuery>;
export type PointOfSaleDrawerLazyQueryHookResult = ReturnType<typeof usePointOfSaleDrawerLazyQuery>;
export type PointOfSaleDrawerSuspenseQueryHookResult = ReturnType<typeof usePointOfSaleDrawerSuspenseQuery>;
export type PointOfSaleDrawerQueryResult = Apollo.QueryResult<PointOfSaleDrawerQuery, PointOfSaleDrawerQueryVariables>;
export const GetPointOfSaleDrawerConfigDocument = gql`
    query GetPointOfSaleDrawerConfig {
  config {
    pointOfSale {
      isFavoritePointOfSaleEnabled
      isPickupPointOfSaleEnabled
    }
  }
}
    `;

/**
 * __useGetPointOfSaleDrawerConfigQuery__
 *
 * To run a query within a React component, call `useGetPointOfSaleDrawerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSaleDrawerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSaleDrawerConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPointOfSaleDrawerConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>(GetPointOfSaleDrawerConfigDocument, options);
      }
export function useGetPointOfSaleDrawerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>(GetPointOfSaleDrawerConfigDocument, options);
        }
export function useGetPointOfSaleDrawerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>(GetPointOfSaleDrawerConfigDocument, options);
        }
export type GetPointOfSaleDrawerConfigQueryHookResult = ReturnType<typeof useGetPointOfSaleDrawerConfigQuery>;
export type GetPointOfSaleDrawerConfigLazyQueryHookResult = ReturnType<typeof useGetPointOfSaleDrawerConfigLazyQuery>;
export type GetPointOfSaleDrawerConfigSuspenseQueryHookResult = ReturnType<typeof useGetPointOfSaleDrawerConfigSuspenseQuery>;
export type GetPointOfSaleDrawerConfigQueryResult = Apollo.QueryResult<GetPointOfSaleDrawerConfigQuery, GetPointOfSaleDrawerConfigQueryVariables>;
export const SelectFavoritePointOfSaleDrawerDocument = gql`
    query SelectFavoritePointOfSaleDrawer($searchPostalCode: String) {
  currentUser {
    availablePointsOfSale(searchPostalCode: $searchPostalCode) {
      ...SelectablePointOfSaleCard_V2_pointOfSale
    }
  }
}
    ${SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc}`;

/**
 * __useSelectFavoritePointOfSaleDrawerQuery__
 *
 * To run a query within a React component, call `useSelectFavoritePointOfSaleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectFavoritePointOfSaleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectFavoritePointOfSaleDrawerQuery({
 *   variables: {
 *      searchPostalCode: // value for 'searchPostalCode'
 *   },
 * });
 */
export function useSelectFavoritePointOfSaleDrawerQuery(baseOptions?: Apollo.QueryHookOptions<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>(SelectFavoritePointOfSaleDrawerDocument, options);
      }
export function useSelectFavoritePointOfSaleDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>(SelectFavoritePointOfSaleDrawerDocument, options);
        }
export function useSelectFavoritePointOfSaleDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>(SelectFavoritePointOfSaleDrawerDocument, options);
        }
export type SelectFavoritePointOfSaleDrawerQueryHookResult = ReturnType<typeof useSelectFavoritePointOfSaleDrawerQuery>;
export type SelectFavoritePointOfSaleDrawerLazyQueryHookResult = ReturnType<typeof useSelectFavoritePointOfSaleDrawerLazyQuery>;
export type SelectFavoritePointOfSaleDrawerSuspenseQueryHookResult = ReturnType<typeof useSelectFavoritePointOfSaleDrawerSuspenseQuery>;
export type SelectFavoritePointOfSaleDrawerQueryResult = Apollo.QueryResult<SelectFavoritePointOfSaleDrawerQuery, SelectFavoritePointOfSaleDrawerQueryVariables>;
export const SelectPickupPointOfSaleDrawerDocument = gql`
    query SelectPickupPointOfSaleDrawer($searchPostalCode: String) {
  currentUser {
    availablePointsOfSalePickup(searchPostalCode: $searchPostalCode) {
      ...SelectablePointOfSaleCard_V2_pointOfSale
    }
  }
}
    ${SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc}`;

/**
 * __useSelectPickupPointOfSaleDrawerQuery__
 *
 * To run a query within a React component, call `useSelectPickupPointOfSaleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPickupPointOfSaleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPickupPointOfSaleDrawerQuery({
 *   variables: {
 *      searchPostalCode: // value for 'searchPostalCode'
 *   },
 * });
 */
export function useSelectPickupPointOfSaleDrawerQuery(baseOptions?: Apollo.QueryHookOptions<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>(SelectPickupPointOfSaleDrawerDocument, options);
      }
export function useSelectPickupPointOfSaleDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>(SelectPickupPointOfSaleDrawerDocument, options);
        }
export function useSelectPickupPointOfSaleDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>(SelectPickupPointOfSaleDrawerDocument, options);
        }
export type SelectPickupPointOfSaleDrawerQueryHookResult = ReturnType<typeof useSelectPickupPointOfSaleDrawerQuery>;
export type SelectPickupPointOfSaleDrawerLazyQueryHookResult = ReturnType<typeof useSelectPickupPointOfSaleDrawerLazyQuery>;
export type SelectPickupPointOfSaleDrawerSuspenseQueryHookResult = ReturnType<typeof useSelectPickupPointOfSaleDrawerSuspenseQuery>;
export type SelectPickupPointOfSaleDrawerQueryResult = Apollo.QueryResult<SelectPickupPointOfSaleDrawerQuery, SelectPickupPointOfSaleDrawerQueryVariables>;
export const SelectProductPickupPointOfSaleDrawerConfigDocument = gql`
    query SelectProductPickupPointOfSaleDrawerConfig {
  config {
    pointOfSale {
      isLocalStockByStoreEnabled
    }
  }
}
    `;

/**
 * __useSelectProductPickupPointOfSaleDrawerConfigQuery__
 *
 * To run a query within a React component, call `useSelectProductPickupPointOfSaleDrawerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductPickupPointOfSaleDrawerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductPickupPointOfSaleDrawerConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectProductPickupPointOfSaleDrawerConfigQuery(baseOptions?: Apollo.QueryHookOptions<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>(SelectProductPickupPointOfSaleDrawerConfigDocument, options);
      }
export function useSelectProductPickupPointOfSaleDrawerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>(SelectProductPickupPointOfSaleDrawerConfigDocument, options);
        }
export function useSelectProductPickupPointOfSaleDrawerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>(SelectProductPickupPointOfSaleDrawerConfigDocument, options);
        }
export type SelectProductPickupPointOfSaleDrawerConfigQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerConfigQuery>;
export type SelectProductPickupPointOfSaleDrawerConfigLazyQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerConfigLazyQuery>;
export type SelectProductPickupPointOfSaleDrawerConfigSuspenseQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerConfigSuspenseQuery>;
export type SelectProductPickupPointOfSaleDrawerConfigQueryResult = Apollo.QueryResult<SelectProductPickupPointOfSaleDrawerConfigQuery, SelectProductPickupPointOfSaleDrawerConfigQueryVariables>;
export const SelectProductPickupPointOfSaleDrawerDocument = gql`
    query SelectProductPickupPointOfSaleDrawer($reference: String!, $searchPostalCode: String) {
  availablePointsOfSaleInventory(
    reference: $reference
    searchPostalCode: $searchPostalCode
  ) {
    id
    pointOfSale {
      isSelectable
      ...SelectablePointOfSaleCard_V2_pointOfSale
    }
    product {
      reference
      ...ProductAvailabilityItem_Availability
    }
  }
}
    ${SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc}
${ProductAvailabilityItem_AvailabilityFragmentDoc}`;

/**
 * __useSelectProductPickupPointOfSaleDrawerQuery__
 *
 * To run a query within a React component, call `useSelectProductPickupPointOfSaleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductPickupPointOfSaleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductPickupPointOfSaleDrawerQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      searchPostalCode: // value for 'searchPostalCode'
 *   },
 * });
 */
export function useSelectProductPickupPointOfSaleDrawerQuery(baseOptions: Apollo.QueryHookOptions<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables> & ({ variables: SelectProductPickupPointOfSaleDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>(SelectProductPickupPointOfSaleDrawerDocument, options);
      }
export function useSelectProductPickupPointOfSaleDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>(SelectProductPickupPointOfSaleDrawerDocument, options);
        }
export function useSelectProductPickupPointOfSaleDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>(SelectProductPickupPointOfSaleDrawerDocument, options);
        }
export type SelectProductPickupPointOfSaleDrawerQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerQuery>;
export type SelectProductPickupPointOfSaleDrawerLazyQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerLazyQuery>;
export type SelectProductPickupPointOfSaleDrawerSuspenseQueryHookResult = ReturnType<typeof useSelectProductPickupPointOfSaleDrawerSuspenseQuery>;
export type SelectProductPickupPointOfSaleDrawerQueryResult = Apollo.QueryResult<SelectProductPickupPointOfSaleDrawerQuery, SelectProductPickupPointOfSaleDrawerQueryVariables>;
export const SelectShippingPickupPointOfSaleDrawerDocument = gql`
    query SelectShippingPickupPointOfSaleDrawer($forceStorePickup: Boolean = false) {
  currentUser {
    id
    checkout {
      shipping {
        methodCode
        availablePointsOfSale(forceStorePickup: $forceStorePickup) {
          ...SelectablePointOfSaleCard_V2_pointOfSale
        }
      }
    }
  }
}
    ${SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc}`;

/**
 * __useSelectShippingPickupPointOfSaleDrawerQuery__
 *
 * To run a query within a React component, call `useSelectShippingPickupPointOfSaleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectShippingPickupPointOfSaleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectShippingPickupPointOfSaleDrawerQuery({
 *   variables: {
 *      forceStorePickup: // value for 'forceStorePickup'
 *   },
 * });
 */
export function useSelectShippingPickupPointOfSaleDrawerQuery(baseOptions?: Apollo.QueryHookOptions<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>(SelectShippingPickupPointOfSaleDrawerDocument, options);
      }
export function useSelectShippingPickupPointOfSaleDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>(SelectShippingPickupPointOfSaleDrawerDocument, options);
        }
export function useSelectShippingPickupPointOfSaleDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>(SelectShippingPickupPointOfSaleDrawerDocument, options);
        }
export type SelectShippingPickupPointOfSaleDrawerQueryHookResult = ReturnType<typeof useSelectShippingPickupPointOfSaleDrawerQuery>;
export type SelectShippingPickupPointOfSaleDrawerLazyQueryHookResult = ReturnType<typeof useSelectShippingPickupPointOfSaleDrawerLazyQuery>;
export type SelectShippingPickupPointOfSaleDrawerSuspenseQueryHookResult = ReturnType<typeof useSelectShippingPickupPointOfSaleDrawerSuspenseQuery>;
export type SelectShippingPickupPointOfSaleDrawerQueryResult = Apollo.QueryResult<SelectShippingPickupPointOfSaleDrawerQuery, SelectShippingPickupPointOfSaleDrawerQueryVariables>;
export const GetDashboardPointOfSaleDrawerConfigDocument = gql`
    query GetDashboardPointOfSaleDrawerConfig {
  config {
    pointOfSale {
      ...PointOfSaleConfig
      dashboardFavoritePointOfSaleImage {
        ...FullPicture
      }
    }
  }
}
    ${PointOfSaleConfigFragmentDoc}
${FullPictureFragmentDoc}`;

/**
 * __useGetDashboardPointOfSaleDrawerConfigQuery__
 *
 * To run a query within a React component, call `useGetDashboardPointOfSaleDrawerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPointOfSaleDrawerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPointOfSaleDrawerConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardPointOfSaleDrawerConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>(GetDashboardPointOfSaleDrawerConfigDocument, options);
      }
export function useGetDashboardPointOfSaleDrawerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>(GetDashboardPointOfSaleDrawerConfigDocument, options);
        }
export function useGetDashboardPointOfSaleDrawerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>(GetDashboardPointOfSaleDrawerConfigDocument, options);
        }
export type GetDashboardPointOfSaleDrawerConfigQueryHookResult = ReturnType<typeof useGetDashboardPointOfSaleDrawerConfigQuery>;
export type GetDashboardPointOfSaleDrawerConfigLazyQueryHookResult = ReturnType<typeof useGetDashboardPointOfSaleDrawerConfigLazyQuery>;
export type GetDashboardPointOfSaleDrawerConfigSuspenseQueryHookResult = ReturnType<typeof useGetDashboardPointOfSaleDrawerConfigSuspenseQuery>;
export type GetDashboardPointOfSaleDrawerConfigQueryResult = Apollo.QueryResult<GetDashboardPointOfSaleDrawerConfigQuery, GetDashboardPointOfSaleDrawerConfigQueryVariables>;
export const GetAvailablePointOfSalesDocument = gql`
    query GetAvailablePointOfSales {
  currentUser {
    id
    ...AvailablePointOfSales
    ...FavoritePointOfSale
  }
}
    ${AvailablePointOfSalesFragmentDoc}
${FavoritePointOfSaleFragmentDoc}`;

/**
 * __useGetAvailablePointOfSalesQuery__
 *
 * To run a query within a React component, call `useGetAvailablePointOfSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePointOfSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePointOfSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePointOfSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>(GetAvailablePointOfSalesDocument, options);
      }
export function useGetAvailablePointOfSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>(GetAvailablePointOfSalesDocument, options);
        }
export function useGetAvailablePointOfSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>(GetAvailablePointOfSalesDocument, options);
        }
export type GetAvailablePointOfSalesQueryHookResult = ReturnType<typeof useGetAvailablePointOfSalesQuery>;
export type GetAvailablePointOfSalesLazyQueryHookResult = ReturnType<typeof useGetAvailablePointOfSalesLazyQuery>;
export type GetAvailablePointOfSalesSuspenseQueryHookResult = ReturnType<typeof useGetAvailablePointOfSalesSuspenseQuery>;
export type GetAvailablePointOfSalesQueryResult = Apollo.QueryResult<GetAvailablePointOfSalesQuery, GetAvailablePointOfSalesQueryVariables>;
export const CurrentUserPickupPointOfSaleInfoDocument = gql`
    query CurrentUserPickupPointOfSaleInfo {
  currentUser {
    id
    availablePointsOfSalePickup {
      ...PointOfSaleStatusCard_PointOfSale
    }
    favoritePointOfSale {
      ...PointOfSaleStatusCard_PointOfSale
    }
  }
}
    ${PointOfSaleStatusCard_PointOfSaleFragmentDoc}`;

/**
 * __useCurrentUserPickupPointOfSaleInfoQuery__
 *
 * To run a query within a React component, call `useCurrentUserPickupPointOfSaleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPickupPointOfSaleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPickupPointOfSaleInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPickupPointOfSaleInfoQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>(CurrentUserPickupPointOfSaleInfoDocument, options);
      }
export function useCurrentUserPickupPointOfSaleInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>(CurrentUserPickupPointOfSaleInfoDocument, options);
        }
export function useCurrentUserPickupPointOfSaleInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>(CurrentUserPickupPointOfSaleInfoDocument, options);
        }
export type CurrentUserPickupPointOfSaleInfoQueryHookResult = ReturnType<typeof useCurrentUserPickupPointOfSaleInfoQuery>;
export type CurrentUserPickupPointOfSaleInfoLazyQueryHookResult = ReturnType<typeof useCurrentUserPickupPointOfSaleInfoLazyQuery>;
export type CurrentUserPickupPointOfSaleInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPickupPointOfSaleInfoSuspenseQuery>;
export type CurrentUserPickupPointOfSaleInfoQueryResult = Apollo.QueryResult<CurrentUserPickupPointOfSaleInfoQuery, CurrentUserPickupPointOfSaleInfoQueryVariables>;
export const GetPointOfSaleStatusCardImageDocument = gql`
    query GetPointOfSaleStatusCardImage {
  config {
    pointOfSale {
      dashboardFavoritePointOfSaleImage {
        ...FullPicture
      }
    }
  }
}
    ${FullPictureFragmentDoc}`;

/**
 * __useGetPointOfSaleStatusCardImageQuery__
 *
 * To run a query within a React component, call `useGetPointOfSaleStatusCardImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSaleStatusCardImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSaleStatusCardImageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPointOfSaleStatusCardImageQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>(GetPointOfSaleStatusCardImageDocument, options);
      }
export function useGetPointOfSaleStatusCardImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>(GetPointOfSaleStatusCardImageDocument, options);
        }
export function useGetPointOfSaleStatusCardImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>(GetPointOfSaleStatusCardImageDocument, options);
        }
export type GetPointOfSaleStatusCardImageQueryHookResult = ReturnType<typeof useGetPointOfSaleStatusCardImageQuery>;
export type GetPointOfSaleStatusCardImageLazyQueryHookResult = ReturnType<typeof useGetPointOfSaleStatusCardImageLazyQuery>;
export type GetPointOfSaleStatusCardImageSuspenseQueryHookResult = ReturnType<typeof useGetPointOfSaleStatusCardImageSuspenseQuery>;
export type GetPointOfSaleStatusCardImageQueryResult = Apollo.QueryResult<GetPointOfSaleStatusCardImageQuery, GetPointOfSaleStatusCardImageQueryVariables>;
export const CurrentUserPointOfSalePageDocument = gql`
    query CurrentUserPointOfSalePage($searchPostalCode: String) {
  currentUser {
    favoritePointOfSaleId
    availablePointsOfSale(searchPostalCode: $searchPostalCode) {
      ...SelectablePointOfSaleCard_V2_pointOfSale
    }
  }
}
    ${SelectablePointOfSaleCard_V2_PointOfSaleFragmentDoc}`;

/**
 * __useCurrentUserPointOfSalePageQuery__
 *
 * To run a query within a React component, call `useCurrentUserPointOfSalePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPointOfSalePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPointOfSalePageQuery({
 *   variables: {
 *      searchPostalCode: // value for 'searchPostalCode'
 *   },
 * });
 */
export function useCurrentUserPointOfSalePageQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>(CurrentUserPointOfSalePageDocument, options);
      }
export function useCurrentUserPointOfSalePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>(CurrentUserPointOfSalePageDocument, options);
        }
export function useCurrentUserPointOfSalePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>(CurrentUserPointOfSalePageDocument, options);
        }
export type CurrentUserPointOfSalePageQueryHookResult = ReturnType<typeof useCurrentUserPointOfSalePageQuery>;
export type CurrentUserPointOfSalePageLazyQueryHookResult = ReturnType<typeof useCurrentUserPointOfSalePageLazyQuery>;
export type CurrentUserPointOfSalePageSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPointOfSalePageSuspenseQuery>;
export type CurrentUserPointOfSalePageQueryResult = Apollo.QueryResult<CurrentUserPointOfSalePageQuery, CurrentUserPointOfSalePageQueryVariables>;
export const SwitchFavoritePointOfSaleDocument = gql`
    mutation SwitchFavoritePointOfSale($posId: String!) {
  switchFavoritePointOfSale(posId: $posId) {
    ...UsePointOfSale_PointOfSale
  }
}
    ${UsePointOfSale_PointOfSaleFragmentDoc}`;
export type SwitchFavoritePointOfSaleMutationFn = Apollo.MutationFunction<SwitchFavoritePointOfSaleMutation, SwitchFavoritePointOfSaleMutationVariables>;

/**
 * __useSwitchFavoritePointOfSaleMutation__
 *
 * To run a mutation, you first call `useSwitchFavoritePointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchFavoritePointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchFavoritePointOfSaleMutation, { data, loading, error }] = useSwitchFavoritePointOfSaleMutation({
 *   variables: {
 *      posId: // value for 'posId'
 *   },
 * });
 */
export function useSwitchFavoritePointOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<SwitchFavoritePointOfSaleMutation, SwitchFavoritePointOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchFavoritePointOfSaleMutation, SwitchFavoritePointOfSaleMutationVariables>(SwitchFavoritePointOfSaleDocument, options);
      }
export type SwitchFavoritePointOfSaleMutationHookResult = ReturnType<typeof useSwitchFavoritePointOfSaleMutation>;
export type SwitchFavoritePointOfSaleMutationResult = Apollo.MutationResult<SwitchFavoritePointOfSaleMutation>;
export type SwitchFavoritePointOfSaleMutationOptions = Apollo.BaseMutationOptions<SwitchFavoritePointOfSaleMutation, SwitchFavoritePointOfSaleMutationVariables>;
export const ProductListPriceAndStockDocument = gql`
    query ProductListPriceAndStock($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    ...ProductCard_ProductPriceAndStock
  }
}
    ${ProductCard_ProductPriceAndStockFragmentDoc}`;

/**
 * __useProductListPriceAndStockQuery__
 *
 * To run a query within a React component, call `useProductListPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListPriceAndStockQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useProductListPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables> & ({ variables: ProductListPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>(ProductListPriceAndStockDocument, options);
      }
export function useProductListPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>(ProductListPriceAndStockDocument, options);
        }
export function useProductListPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>(ProductListPriceAndStockDocument, options);
        }
export type ProductListPriceAndStockQueryHookResult = ReturnType<typeof useProductListPriceAndStockQuery>;
export type ProductListPriceAndStockLazyQueryHookResult = ReturnType<typeof useProductListPriceAndStockLazyQuery>;
export type ProductListPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useProductListPriceAndStockSuspenseQuery>;
export type ProductListPriceAndStockQueryResult = Apollo.QueryResult<ProductListPriceAndStockQuery, ProductListPriceAndStockQueryVariables>;
export const ProductListCategoryFiltersDocument = gql`
    query ProductListCategoryFilters($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  categories(urlKey: $urlKey) {
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListFilters_Data
    }
  }
}
    ${ProductListFilters_DataFragmentDoc}`;

/**
 * __useProductListCategoryFiltersQuery__
 *
 * To run a query within a React component, call `useProductListCategoryFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListCategoryFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListCategoryFiltersQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListCategoryFiltersQuery(baseOptions: Apollo.QueryHookOptions<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables> & ({ variables: ProductListCategoryFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>(ProductListCategoryFiltersDocument, options);
      }
export function useProductListCategoryFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>(ProductListCategoryFiltersDocument, options);
        }
export function useProductListCategoryFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>(ProductListCategoryFiltersDocument, options);
        }
export type ProductListCategoryFiltersQueryHookResult = ReturnType<typeof useProductListCategoryFiltersQuery>;
export type ProductListCategoryFiltersLazyQueryHookResult = ReturnType<typeof useProductListCategoryFiltersLazyQuery>;
export type ProductListCategoryFiltersSuspenseQueryHookResult = ReturnType<typeof useProductListCategoryFiltersSuspenseQuery>;
export type ProductListCategoryFiltersQueryResult = Apollo.QueryResult<ProductListCategoryFiltersQuery, ProductListCategoryFiltersQueryVariables>;
export const ProductListCategoryProductsDocument = gql`
    query ProductListCategoryProducts($urlKey: String!, $pageIndex: Int!, $requestFilter: String, $pageSize: Int!) {
  categories(urlKey: $urlKey) {
    marketingBanner {
      ...ProductListEventBanner_Banner
    }
    productList(pageIndex: $pageIndex, request: $requestFilter, pageSize: $pageSize) {
      ...ProductListTemplate_ProductList
    }
  }
}
    ${ProductListEventBanner_BannerFragmentDoc}
${ProductListTemplate_ProductListFragmentDoc}`;

/**
 * __useProductListCategoryProductsQuery__
 *
 * To run a query within a React component, call `useProductListCategoryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListCategoryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListCategoryProductsQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      pageIndex: // value for 'pageIndex'
 *      requestFilter: // value for 'requestFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useProductListCategoryProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables> & ({ variables: ProductListCategoryProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>(ProductListCategoryProductsDocument, options);
      }
export function useProductListCategoryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>(ProductListCategoryProductsDocument, options);
        }
export function useProductListCategoryProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>(ProductListCategoryProductsDocument, options);
        }
export type ProductListCategoryProductsQueryHookResult = ReturnType<typeof useProductListCategoryProductsQuery>;
export type ProductListCategoryProductsLazyQueryHookResult = ReturnType<typeof useProductListCategoryProductsLazyQuery>;
export type ProductListCategoryProductsSuspenseQueryHookResult = ReturnType<typeof useProductListCategoryProductsSuspenseQuery>;
export type ProductListCategoryProductsQueryResult = Apollo.QueryResult<ProductListCategoryProductsQuery, ProductListCategoryProductsQueryVariables>;
export const GetAlsoBoughtSliderDocument = gql`
    query GetAlsoBoughtSlider($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    recommendedProducts {
      ...ProductCard
    }
  }
}
    ${ProductCardFragmentDoc}`;

/**
 * __useGetAlsoBoughtSliderQuery__
 *
 * To run a query within a React component, call `useGetAlsoBoughtSliderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlsoBoughtSliderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlsoBoughtSliderQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetAlsoBoughtSliderQuery(baseOptions: Apollo.QueryHookOptions<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables> & ({ variables: GetAlsoBoughtSliderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>(GetAlsoBoughtSliderDocument, options);
      }
export function useGetAlsoBoughtSliderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>(GetAlsoBoughtSliderDocument, options);
        }
export function useGetAlsoBoughtSliderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>(GetAlsoBoughtSliderDocument, options);
        }
export type GetAlsoBoughtSliderQueryHookResult = ReturnType<typeof useGetAlsoBoughtSliderQuery>;
export type GetAlsoBoughtSliderLazyQueryHookResult = ReturnType<typeof useGetAlsoBoughtSliderLazyQuery>;
export type GetAlsoBoughtSliderSuspenseQueryHookResult = ReturnType<typeof useGetAlsoBoughtSliderSuspenseQuery>;
export type GetAlsoBoughtSliderQueryResult = Apollo.QueryResult<GetAlsoBoughtSliderQuery, GetAlsoBoughtSliderQueryVariables>;
export const GetOurProductsCategoryDocument = gql`
    query GetOurProductsCategory($urlKey: String) {
  categories(urlKey: $urlKey, filterSubCats: true) {
    name
    categories {
      ...CategoryCard_Category
    }
  }
}
    ${CategoryCard_CategoryFragmentDoc}`;

/**
 * __useGetOurProductsCategoryQuery__
 *
 * To run a query within a React component, call `useGetOurProductsCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOurProductsCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOurProductsCategoryQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetOurProductsCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>(GetOurProductsCategoryDocument, options);
      }
export function useGetOurProductsCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>(GetOurProductsCategoryDocument, options);
        }
export function useGetOurProductsCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>(GetOurProductsCategoryDocument, options);
        }
export type GetOurProductsCategoryQueryHookResult = ReturnType<typeof useGetOurProductsCategoryQuery>;
export type GetOurProductsCategoryLazyQueryHookResult = ReturnType<typeof useGetOurProductsCategoryLazyQuery>;
export type GetOurProductsCategorySuspenseQueryHookResult = ReturnType<typeof useGetOurProductsCategorySuspenseQuery>;
export type GetOurProductsCategoryQueryResult = Apollo.QueryResult<GetOurProductsCategoryQuery, GetOurProductsCategoryQueryVariables>;
export const EquivalentProductsDrawerDocument = gql`
    query EquivalentProductsDrawer($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    equivalentProducts {
      ...ProductCard
    }
  }
}
    ${ProductCardFragmentDoc}`;

/**
 * __useEquivalentProductsDrawerQuery__
 *
 * To run a query within a React component, call `useEquivalentProductsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquivalentProductsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquivalentProductsDrawerQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useEquivalentProductsDrawerQuery(baseOptions: Apollo.QueryHookOptions<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables> & ({ variables: EquivalentProductsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>(EquivalentProductsDrawerDocument, options);
      }
export function useEquivalentProductsDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>(EquivalentProductsDrawerDocument, options);
        }
export function useEquivalentProductsDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>(EquivalentProductsDrawerDocument, options);
        }
export type EquivalentProductsDrawerQueryHookResult = ReturnType<typeof useEquivalentProductsDrawerQuery>;
export type EquivalentProductsDrawerLazyQueryHookResult = ReturnType<typeof useEquivalentProductsDrawerLazyQuery>;
export type EquivalentProductsDrawerSuspenseQueryHookResult = ReturnType<typeof useEquivalentProductsDrawerSuspenseQuery>;
export type EquivalentProductsDrawerQueryResult = Apollo.QueryResult<EquivalentProductsDrawerQuery, EquivalentProductsDrawerQueryVariables>;
export const GetLinkedProductsSliderDocument = gql`
    query GetLinkedProductsSlider($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    type
    linkedProducts {
      ...ProductCard
    }
  }
}
    ${ProductCardFragmentDoc}`;

/**
 * __useGetLinkedProductsSliderQuery__
 *
 * To run a query within a React component, call `useGetLinkedProductsSliderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedProductsSliderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedProductsSliderQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetLinkedProductsSliderQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables> & ({ variables: GetLinkedProductsSliderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>(GetLinkedProductsSliderDocument, options);
      }
export function useGetLinkedProductsSliderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>(GetLinkedProductsSliderDocument, options);
        }
export function useGetLinkedProductsSliderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>(GetLinkedProductsSliderDocument, options);
        }
export type GetLinkedProductsSliderQueryHookResult = ReturnType<typeof useGetLinkedProductsSliderQuery>;
export type GetLinkedProductsSliderLazyQueryHookResult = ReturnType<typeof useGetLinkedProductsSliderLazyQuery>;
export type GetLinkedProductsSliderSuspenseQueryHookResult = ReturnType<typeof useGetLinkedProductsSliderSuspenseQuery>;
export type GetLinkedProductsSliderQueryResult = Apollo.QueryResult<GetLinkedProductsSliderQuery, GetLinkedProductsSliderQueryVariables>;
export const GetProductAnomaliesDocument = gql`
    query GetProductAnomalies {
  productAnomalies {
    name
    value
    categories {
      name
      value
    }
  }
}
    `;

/**
 * __useGetProductAnomaliesQuery__
 *
 * To run a query within a React component, call `useGetProductAnomaliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAnomaliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAnomaliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductAnomaliesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>(GetProductAnomaliesDocument, options);
      }
export function useGetProductAnomaliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>(GetProductAnomaliesDocument, options);
        }
export function useGetProductAnomaliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>(GetProductAnomaliesDocument, options);
        }
export type GetProductAnomaliesQueryHookResult = ReturnType<typeof useGetProductAnomaliesQuery>;
export type GetProductAnomaliesLazyQueryHookResult = ReturnType<typeof useGetProductAnomaliesLazyQuery>;
export type GetProductAnomaliesSuspenseQueryHookResult = ReturnType<typeof useGetProductAnomaliesSuspenseQuery>;
export type GetProductAnomaliesQueryResult = Apollo.QueryResult<GetProductAnomaliesQuery, GetProductAnomaliesQueryVariables>;
export const ProductBob_CurrentUserPermissionsShowbobDocument = gql`
    query ProductBob_CurrentUserPermissionsShowbob {
  currentUser {
    id
    permissions {
      showBob
    }
  }
}
    `;

/**
 * __useProductBob_CurrentUserPermissionsShowbobQuery__
 *
 * To run a query within a React component, call `useProductBob_CurrentUserPermissionsShowbobQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBob_CurrentUserPermissionsShowbobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBob_CurrentUserPermissionsShowbobQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBob_CurrentUserPermissionsShowbobQuery(baseOptions?: Apollo.QueryHookOptions<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>(ProductBob_CurrentUserPermissionsShowbobDocument, options);
      }
export function useProductBob_CurrentUserPermissionsShowbobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>(ProductBob_CurrentUserPermissionsShowbobDocument, options);
        }
export function useProductBob_CurrentUserPermissionsShowbobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>(ProductBob_CurrentUserPermissionsShowbobDocument, options);
        }
export type ProductBob_CurrentUserPermissionsShowbobQueryHookResult = ReturnType<typeof useProductBob_CurrentUserPermissionsShowbobQuery>;
export type ProductBob_CurrentUserPermissionsShowbobLazyQueryHookResult = ReturnType<typeof useProductBob_CurrentUserPermissionsShowbobLazyQuery>;
export type ProductBob_CurrentUserPermissionsShowbobSuspenseQueryHookResult = ReturnType<typeof useProductBob_CurrentUserPermissionsShowbobSuspenseQuery>;
export type ProductBob_CurrentUserPermissionsShowbobQueryResult = Apollo.QueryResult<ProductBob_CurrentUserPermissionsShowbobQuery, ProductBob_CurrentUserPermissionsShowbobQueryVariables>;
export const ProductBuyBoxPriceAndStockDocument = gql`
    query ProductBuyBoxPriceAndStock($reference: String!) {
  productByReference(reference: $reference) {
    ...ProductBuyBox_ProductPriceAndStock
    reference
    parentReference
    analytics {
      promotionStatus
      profileCase
    }
  }
}
    ${ProductBuyBox_ProductPriceAndStockFragmentDoc}`;

/**
 * __useProductBuyBoxPriceAndStockQuery__
 *
 * To run a query within a React component, call `useProductBuyBoxPriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBuyBoxPriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBuyBoxPriceAndStockQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductBuyBoxPriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables> & ({ variables: ProductBuyBoxPriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>(ProductBuyBoxPriceAndStockDocument, options);
      }
export function useProductBuyBoxPriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>(ProductBuyBoxPriceAndStockDocument, options);
        }
export function useProductBuyBoxPriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>(ProductBuyBoxPriceAndStockDocument, options);
        }
export type ProductBuyBoxPriceAndStockQueryHookResult = ReturnType<typeof useProductBuyBoxPriceAndStockQuery>;
export type ProductBuyBoxPriceAndStockLazyQueryHookResult = ReturnType<typeof useProductBuyBoxPriceAndStockLazyQuery>;
export type ProductBuyBoxPriceAndStockSuspenseQueryHookResult = ReturnType<typeof useProductBuyBoxPriceAndStockSuspenseQuery>;
export type ProductBuyBoxPriceAndStockQueryResult = Apollo.QueryResult<ProductBuyBoxPriceAndStockQuery, ProductBuyBoxPriceAndStockQueryVariables>;
export const ProductRichDescriptionDocument = gql`
    query ProductRichDescription($urlKey: String!) {
  product(urlKey: $urlKey) {
    ...ProductRichDescription_Product
  }
}
    ${ProductRichDescription_ProductFragmentDoc}`;

/**
 * __useProductRichDescriptionQuery__
 *
 * To run a query within a React component, call `useProductRichDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRichDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRichDescriptionQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductRichDescriptionQuery(baseOptions: Apollo.QueryHookOptions<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables> & ({ variables: ProductRichDescriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>(ProductRichDescriptionDocument, options);
      }
export function useProductRichDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>(ProductRichDescriptionDocument, options);
        }
export function useProductRichDescriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>(ProductRichDescriptionDocument, options);
        }
export type ProductRichDescriptionQueryHookResult = ReturnType<typeof useProductRichDescriptionQuery>;
export type ProductRichDescriptionLazyQueryHookResult = ReturnType<typeof useProductRichDescriptionLazyQuery>;
export type ProductRichDescriptionSuspenseQueryHookResult = ReturnType<typeof useProductRichDescriptionSuspenseQuery>;
export type ProductRichDescriptionQueryResult = Apollo.QueryResult<ProductRichDescriptionQuery, ProductRichDescriptionQueryVariables>;
export const ProductRowLinkedProductsDocument = gql`
    query ProductRowLinkedProducts($reference: String!) {
  productByReference(reference: $reference) {
    ...ProductRowLinkedProducts_Product
  }
}
    ${ProductRowLinkedProducts_ProductFragmentDoc}`;

/**
 * __useProductRowLinkedProductsQuery__
 *
 * To run a query within a React component, call `useProductRowLinkedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRowLinkedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRowLinkedProductsQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductRowLinkedProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables> & ({ variables: ProductRowLinkedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>(ProductRowLinkedProductsDocument, options);
      }
export function useProductRowLinkedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>(ProductRowLinkedProductsDocument, options);
        }
export function useProductRowLinkedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>(ProductRowLinkedProductsDocument, options);
        }
export type ProductRowLinkedProductsQueryHookResult = ReturnType<typeof useProductRowLinkedProductsQuery>;
export type ProductRowLinkedProductsLazyQueryHookResult = ReturnType<typeof useProductRowLinkedProductsLazyQuery>;
export type ProductRowLinkedProductsSuspenseQueryHookResult = ReturnType<typeof useProductRowLinkedProductsSuspenseQuery>;
export type ProductRowLinkedProductsQueryResult = Apollo.QueryResult<ProductRowLinkedProductsQuery, ProductRowLinkedProductsQueryVariables>;
export const GetLinkedProductsConfigDocument = gql`
    query getLinkedProductsConfig {
  config {
    catalog {
      isLinkedProductEnabled
      g9LowStockThreshold
    }
  }
}
    `;

/**
 * __useGetLinkedProductsConfigQuery__
 *
 * To run a query within a React component, call `useGetLinkedProductsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedProductsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedProductsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkedProductsConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>(GetLinkedProductsConfigDocument, options);
      }
export function useGetLinkedProductsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>(GetLinkedProductsConfigDocument, options);
        }
export function useGetLinkedProductsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>(GetLinkedProductsConfigDocument, options);
        }
export type GetLinkedProductsConfigQueryHookResult = ReturnType<typeof useGetLinkedProductsConfigQuery>;
export type GetLinkedProductsConfigLazyQueryHookResult = ReturnType<typeof useGetLinkedProductsConfigLazyQuery>;
export type GetLinkedProductsConfigSuspenseQueryHookResult = ReturnType<typeof useGetLinkedProductsConfigSuspenseQuery>;
export type GetLinkedProductsConfigQueryResult = Apollo.QueryResult<GetLinkedProductsConfigQuery, GetLinkedProductsConfigQueryVariables>;
export const ProductTechnicalSpecsFullDocument = gql`
    query ProductTechnicalSpecsFull($urlKey: String!) {
  product(urlKey: $urlKey) {
    ...ProductTechnicalSpecsFull_Product
  }
}
    ${ProductTechnicalSpecsFull_ProductFragmentDoc}`;

/**
 * __useProductTechnicalSpecsFullQuery__
 *
 * To run a query within a React component, call `useProductTechnicalSpecsFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTechnicalSpecsFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTechnicalSpecsFullQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductTechnicalSpecsFullQuery(baseOptions: Apollo.QueryHookOptions<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables> & ({ variables: ProductTechnicalSpecsFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>(ProductTechnicalSpecsFullDocument, options);
      }
export function useProductTechnicalSpecsFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>(ProductTechnicalSpecsFullDocument, options);
        }
export function useProductTechnicalSpecsFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>(ProductTechnicalSpecsFullDocument, options);
        }
export type ProductTechnicalSpecsFullQueryHookResult = ReturnType<typeof useProductTechnicalSpecsFullQuery>;
export type ProductTechnicalSpecsFullLazyQueryHookResult = ReturnType<typeof useProductTechnicalSpecsFullLazyQuery>;
export type ProductTechnicalSpecsFullSuspenseQueryHookResult = ReturnType<typeof useProductTechnicalSpecsFullSuspenseQuery>;
export type ProductTechnicalSpecsFullQueryResult = Apollo.QueryResult<ProductTechnicalSpecsFullQuery, ProductTechnicalSpecsFullQueryVariables>;
export const GetReferencesProductArticlesDocument = gql`
    query GetReferencesProductArticles($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    nbArticles
    articles {
      ...ReferencesProductTable_Article
      ...ProductArticleDetails_Article
    }
  }
}
    ${ReferencesProductTable_ArticleFragmentDoc}
${ProductArticleDetails_ArticleFragmentDoc}`;

/**
 * __useGetReferencesProductArticlesQuery__
 *
 * To run a query within a React component, call `useGetReferencesProductArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencesProductArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencesProductArticlesQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetReferencesProductArticlesQuery(baseOptions: Apollo.QueryHookOptions<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables> & ({ variables: GetReferencesProductArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>(GetReferencesProductArticlesDocument, options);
      }
export function useGetReferencesProductArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>(GetReferencesProductArticlesDocument, options);
        }
export function useGetReferencesProductArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>(GetReferencesProductArticlesDocument, options);
        }
export type GetReferencesProductArticlesQueryHookResult = ReturnType<typeof useGetReferencesProductArticlesQuery>;
export type GetReferencesProductArticlesLazyQueryHookResult = ReturnType<typeof useGetReferencesProductArticlesLazyQuery>;
export type GetReferencesProductArticlesSuspenseQueryHookResult = ReturnType<typeof useGetReferencesProductArticlesSuspenseQuery>;
export type GetReferencesProductArticlesQueryResult = Apollo.QueryResult<GetReferencesProductArticlesQuery, GetReferencesProductArticlesQueryVariables>;
export const GetReferencesProductFiltersDocument = gql`
    query GetReferencesProductFilters($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    filters {
      ...ReferencesProductFilters_Filters
    }
  }
}
    ${ReferencesProductFilters_FiltersFragmentDoc}`;

/**
 * __useGetReferencesProductFiltersQuery__
 *
 * To run a query within a React component, call `useGetReferencesProductFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencesProductFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencesProductFiltersQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetReferencesProductFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables> & ({ variables: GetReferencesProductFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>(GetReferencesProductFiltersDocument, options);
      }
export function useGetReferencesProductFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>(GetReferencesProductFiltersDocument, options);
        }
export function useGetReferencesProductFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>(GetReferencesProductFiltersDocument, options);
        }
export type GetReferencesProductFiltersQueryHookResult = ReturnType<typeof useGetReferencesProductFiltersQuery>;
export type GetReferencesProductFiltersLazyQueryHookResult = ReturnType<typeof useGetReferencesProductFiltersLazyQuery>;
export type GetReferencesProductFiltersSuspenseQueryHookResult = ReturnType<typeof useGetReferencesProductFiltersSuspenseQuery>;
export type GetReferencesProductFiltersQueryResult = Apollo.QueryResult<GetReferencesProductFiltersQuery, GetReferencesProductFiltersQueryVariables>;
export const ReferencesProduct_CurrentUserDocument = gql`
    query ReferencesProduct_CurrentUser {
  currentUser {
    id
    checkout {
      cart {
        ...ProductBuyBox_Cart
      }
    }
  }
}
    ${ProductBuyBox_CartFragmentDoc}`;

/**
 * __useReferencesProduct_CurrentUserQuery__
 *
 * To run a query within a React component, call `useReferencesProduct_CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencesProduct_CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencesProduct_CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencesProduct_CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>(ReferencesProduct_CurrentUserDocument, options);
      }
export function useReferencesProduct_CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>(ReferencesProduct_CurrentUserDocument, options);
        }
export function useReferencesProduct_CurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>(ReferencesProduct_CurrentUserDocument, options);
        }
export type ReferencesProduct_CurrentUserQueryHookResult = ReturnType<typeof useReferencesProduct_CurrentUserQuery>;
export type ReferencesProduct_CurrentUserLazyQueryHookResult = ReturnType<typeof useReferencesProduct_CurrentUserLazyQuery>;
export type ReferencesProduct_CurrentUserSuspenseQueryHookResult = ReturnType<typeof useReferencesProduct_CurrentUserSuspenseQuery>;
export type ReferencesProduct_CurrentUserQueryResult = Apollo.QueryResult<ReferencesProduct_CurrentUserQuery, ReferencesProduct_CurrentUserQueryVariables>;
export const ReferencesProduct_PickupPointOfSaleDocument = gql`
    query ReferencesProduct_PickupPointOfSale($pickupPointOfSaleId: String!) {
  pickupPointOfSale: pointOfSale(pointOfSaleId: $pickupPointOfSaleId) {
    ...ProductAvailabilities_PickupPointOfSale
  }
}
    ${ProductAvailabilities_PickupPointOfSaleFragmentDoc}`;

/**
 * __useReferencesProduct_PickupPointOfSaleQuery__
 *
 * To run a query within a React component, call `useReferencesProduct_PickupPointOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencesProduct_PickupPointOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencesProduct_PickupPointOfSaleQuery({
 *   variables: {
 *      pickupPointOfSaleId: // value for 'pickupPointOfSaleId'
 *   },
 * });
 */
export function useReferencesProduct_PickupPointOfSaleQuery(baseOptions: Apollo.QueryHookOptions<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables> & ({ variables: ReferencesProduct_PickupPointOfSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>(ReferencesProduct_PickupPointOfSaleDocument, options);
      }
export function useReferencesProduct_PickupPointOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>(ReferencesProduct_PickupPointOfSaleDocument, options);
        }
export function useReferencesProduct_PickupPointOfSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>(ReferencesProduct_PickupPointOfSaleDocument, options);
        }
export type ReferencesProduct_PickupPointOfSaleQueryHookResult = ReturnType<typeof useReferencesProduct_PickupPointOfSaleQuery>;
export type ReferencesProduct_PickupPointOfSaleLazyQueryHookResult = ReturnType<typeof useReferencesProduct_PickupPointOfSaleLazyQuery>;
export type ReferencesProduct_PickupPointOfSaleSuspenseQueryHookResult = ReturnType<typeof useReferencesProduct_PickupPointOfSaleSuspenseQuery>;
export type ReferencesProduct_PickupPointOfSaleQueryResult = Apollo.QueryResult<ReferencesProduct_PickupPointOfSaleQuery, ReferencesProduct_PickupPointOfSaleQueryVariables>;
export const ReferencesProductTableRows_PriceAndStockDocument = gql`
    query ReferencesProductTableRows_PriceAndStock($references: [String!]!) {
  productsByReferences(references: $references) {
    ...ReferencesProductTableRows_PriceAndStock
  }
}
    ${ReferencesProductTableRows_PriceAndStockFragmentDoc}`;

/**
 * __useReferencesProductTableRows_PriceAndStockQuery__
 *
 * To run a query within a React component, call `useReferencesProductTableRows_PriceAndStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencesProductTableRows_PriceAndStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencesProductTableRows_PriceAndStockQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useReferencesProductTableRows_PriceAndStockQuery(baseOptions: Apollo.QueryHookOptions<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables> & ({ variables: ReferencesProductTableRows_PriceAndStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>(ReferencesProductTableRows_PriceAndStockDocument, options);
      }
export function useReferencesProductTableRows_PriceAndStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>(ReferencesProductTableRows_PriceAndStockDocument, options);
        }
export function useReferencesProductTableRows_PriceAndStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>(ReferencesProductTableRows_PriceAndStockDocument, options);
        }
export type ReferencesProductTableRows_PriceAndStockQueryHookResult = ReturnType<typeof useReferencesProductTableRows_PriceAndStockQuery>;
export type ReferencesProductTableRows_PriceAndStockLazyQueryHookResult = ReturnType<typeof useReferencesProductTableRows_PriceAndStockLazyQuery>;
export type ReferencesProductTableRows_PriceAndStockSuspenseQueryHookResult = ReturnType<typeof useReferencesProductTableRows_PriceAndStockSuspenseQuery>;
export type ReferencesProductTableRows_PriceAndStockQueryResult = Apollo.QueryResult<ReferencesProductTableRows_PriceAndStockQuery, ReferencesProductTableRows_PriceAndStockQueryVariables>;
export const AddProductToCartDocument = gql`
    mutation AddProductToCart($reference: String!, $quantity: Int!, $cartId: String!) {
  addProductToCart(reference: $reference, quantity: $quantity, cartId: $cartId) {
    cart {
      id
      hasClickAndCollectOnlyItems
      sumItemsQuantity
      availableClickAndCollectQuantity
      items {
        ...ProductRowReadOnly_CartItem
      }
      ...MiniCart_Cart
      ...MiniCartButton_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${ProductRowReadOnly_CartItemFragmentDoc}
${MiniCart_CartFragmentDoc}
${MiniCartButton_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type AddProductToCartMutationFn = Apollo.MutationFunction<AddProductToCartMutation, AddProductToCartMutationVariables>;

/**
 * __useAddProductToCartMutation__
 *
 * To run a mutation, you first call `useAddProductToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToCartMutation, { data, loading, error }] = useAddProductToCartMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *      quantity: // value for 'quantity'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAddProductToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToCartMutation, AddProductToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToCartMutation, AddProductToCartMutationVariables>(AddProductToCartDocument, options);
      }
export type AddProductToCartMutationHookResult = ReturnType<typeof useAddProductToCartMutation>;
export type AddProductToCartMutationResult = Apollo.MutationResult<AddProductToCartMutation>;
export type AddProductToCartMutationOptions = Apollo.BaseMutationOptions<AddProductToCartMutation, AddProductToCartMutationVariables>;
export const AddProductToPunchoutCartFromProductDocument = gql`
    mutation AddProductToPunchoutCartFromProduct($punchoutCartId: Int!, $reference: String!, $quantity: Int!) {
  addProductToPunchoutCart(
    punchoutCartId: $punchoutCartId
    reference: $reference
    quantity: $quantity
  ) {
    id
    totalQuantity
    totalExclTax
    items {
      id
      quantity
      rowTotalExclTax
      conditioningUnitPriceExclTax
      catalogDiscountAmount
      product {
        reference
        ...ProductRowReadOnly_Product
      }
    }
  }
}
    ${ProductRowReadOnly_ProductFragmentDoc}`;
export type AddProductToPunchoutCartFromProductMutationFn = Apollo.MutationFunction<AddProductToPunchoutCartFromProductMutation, AddProductToPunchoutCartFromProductMutationVariables>;

/**
 * __useAddProductToPunchoutCartFromProductMutation__
 *
 * To run a mutation, you first call `useAddProductToPunchoutCartFromProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToPunchoutCartFromProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToPunchoutCartFromProductMutation, { data, loading, error }] = useAddProductToPunchoutCartFromProductMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *      reference: // value for 'reference'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProductToPunchoutCartFromProductMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToPunchoutCartFromProductMutation, AddProductToPunchoutCartFromProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToPunchoutCartFromProductMutation, AddProductToPunchoutCartFromProductMutationVariables>(AddProductToPunchoutCartFromProductDocument, options);
      }
export type AddProductToPunchoutCartFromProductMutationHookResult = ReturnType<typeof useAddProductToPunchoutCartFromProductMutation>;
export type AddProductToPunchoutCartFromProductMutationResult = Apollo.MutationResult<AddProductToPunchoutCartFromProductMutation>;
export type AddProductToPunchoutCartFromProductMutationOptions = Apollo.BaseMutationOptions<AddProductToPunchoutCartFromProductMutation, AddProductToPunchoutCartFromProductMutationVariables>;
export const UpdateFavoritesListForProductDocument = gql`
    mutation updateFavoritesListForProduct($input: WishlistUpdateInput_V2!) {
  updateWishlist_V2(input: $input) {
    id
  }
}
    `;
export type UpdateFavoritesListForProductMutationFn = Apollo.MutationFunction<UpdateFavoritesListForProductMutation, UpdateFavoritesListForProductMutationVariables>;

/**
 * __useUpdateFavoritesListForProductMutation__
 *
 * To run a mutation, you first call `useUpdateFavoritesListForProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoritesListForProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoritesListForProductMutation, { data, loading, error }] = useUpdateFavoritesListForProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFavoritesListForProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoritesListForProductMutation, UpdateFavoritesListForProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoritesListForProductMutation, UpdateFavoritesListForProductMutationVariables>(UpdateFavoritesListForProductDocument, options);
      }
export type UpdateFavoritesListForProductMutationHookResult = ReturnType<typeof useUpdateFavoritesListForProductMutation>;
export type UpdateFavoritesListForProductMutationResult = Apollo.MutationResult<UpdateFavoritesListForProductMutation>;
export type UpdateFavoritesListForProductMutationOptions = Apollo.BaseMutationOptions<UpdateFavoritesListForProductMutation, UpdateFavoritesListForProductMutationVariables>;
export const CreateFavoritesListForProductDocument = gql`
    mutation createFavoritesListForProduct($input: WishlistCreateInput_V2!) {
  createWishlist_V2(input: $input) {
    id
    name
  }
}
    `;
export type CreateFavoritesListForProductMutationFn = Apollo.MutationFunction<CreateFavoritesListForProductMutation, CreateFavoritesListForProductMutationVariables>;

/**
 * __useCreateFavoritesListForProductMutation__
 *
 * To run a mutation, you first call `useCreateFavoritesListForProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoritesListForProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoritesListForProductMutation, { data, loading, error }] = useCreateFavoritesListForProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoritesListForProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateFavoritesListForProductMutation, CreateFavoritesListForProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFavoritesListForProductMutation, CreateFavoritesListForProductMutationVariables>(CreateFavoritesListForProductDocument, options);
      }
export type CreateFavoritesListForProductMutationHookResult = ReturnType<typeof useCreateFavoritesListForProductMutation>;
export type CreateFavoritesListForProductMutationResult = Apollo.MutationResult<CreateFavoritesListForProductMutation>;
export type CreateFavoritesListForProductMutationOptions = Apollo.BaseMutationOptions<CreateFavoritesListForProductMutation, CreateFavoritesListForProductMutationVariables>;
export const ProductAnalyticsDataDocument = gql`
    query ProductAnalyticsData($reference: String!) {
  productByReference(reference: $reference) {
    reference
    breadcrumbs {
      name
      urlKey
    }
    analytics {
      promotionStatus
      profileCase
    }
    parentReference
    nomenclatureFamily
    nomenclatureGroup
  }
}
    `;

/**
 * __useProductAnalyticsDataQuery__
 *
 * To run a query within a React component, call `useProductAnalyticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAnalyticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAnalyticsDataQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductAnalyticsDataQuery(baseOptions: Apollo.QueryHookOptions<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables> & ({ variables: ProductAnalyticsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>(ProductAnalyticsDataDocument, options);
      }
export function useProductAnalyticsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>(ProductAnalyticsDataDocument, options);
        }
export function useProductAnalyticsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>(ProductAnalyticsDataDocument, options);
        }
export type ProductAnalyticsDataQueryHookResult = ReturnType<typeof useProductAnalyticsDataQuery>;
export type ProductAnalyticsDataLazyQueryHookResult = ReturnType<typeof useProductAnalyticsDataLazyQuery>;
export type ProductAnalyticsDataSuspenseQueryHookResult = ReturnType<typeof useProductAnalyticsDataSuspenseQuery>;
export type ProductAnalyticsDataQueryResult = Apollo.QueryResult<ProductAnalyticsDataQuery, ProductAnalyticsDataQueryVariables>;
export const ProductFavoriteStatusDocument = gql`
    query productFavoriteStatus($reference: String!) {
  productByReference(reference: $reference) {
    reference
    isFavorite
  }
}
    `;

/**
 * __useProductFavoriteStatusQuery__
 *
 * To run a query within a React component, call `useProductFavoriteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFavoriteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFavoriteStatusQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useProductFavoriteStatusQuery(baseOptions: Apollo.QueryHookOptions<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables> & ({ variables: ProductFavoriteStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>(ProductFavoriteStatusDocument, options);
      }
export function useProductFavoriteStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>(ProductFavoriteStatusDocument, options);
        }
export function useProductFavoriteStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>(ProductFavoriteStatusDocument, options);
        }
export type ProductFavoriteStatusQueryHookResult = ReturnType<typeof useProductFavoriteStatusQuery>;
export type ProductFavoriteStatusLazyQueryHookResult = ReturnType<typeof useProductFavoriteStatusLazyQuery>;
export type ProductFavoriteStatusSuspenseQueryHookResult = ReturnType<typeof useProductFavoriteStatusSuspenseQuery>;
export type ProductFavoriteStatusQueryResult = Apollo.QueryResult<ProductFavoriteStatusQuery, ProductFavoriteStatusQueryVariables>;
export const ProductListFavoriteStatusDocument = gql`
    query productListFavoriteStatus($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    isFavorite
  }
}
    `;

/**
 * __useProductListFavoriteStatusQuery__
 *
 * To run a query within a React component, call `useProductListFavoriteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListFavoriteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListFavoriteStatusQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useProductListFavoriteStatusQuery(baseOptions: Apollo.QueryHookOptions<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables> & ({ variables: ProductListFavoriteStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>(ProductListFavoriteStatusDocument, options);
      }
export function useProductListFavoriteStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>(ProductListFavoriteStatusDocument, options);
        }
export function useProductListFavoriteStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>(ProductListFavoriteStatusDocument, options);
        }
export type ProductListFavoriteStatusQueryHookResult = ReturnType<typeof useProductListFavoriteStatusQuery>;
export type ProductListFavoriteStatusLazyQueryHookResult = ReturnType<typeof useProductListFavoriteStatusLazyQuery>;
export type ProductListFavoriteStatusSuspenseQueryHookResult = ReturnType<typeof useProductListFavoriteStatusSuspenseQuery>;
export type ProductListFavoriteStatusQueryResult = Apollo.QueryResult<ProductListFavoriteStatusQuery, ProductListFavoriteStatusQueryVariables>;
export const VisibleCardsAnalyticsByReferencesDocument = gql`
    query VisibleCardsAnalyticsByReferences($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    parentReference
    name
    type
    brand {
      name
      urlKey
    }
    analytics {
      promotionStatus
    }
    breadcrumbs {
      name
    }
    nomenclatureFamily
    nomenclatureGroup
  }
}
    `;

/**
 * __useVisibleCardsAnalyticsByReferencesQuery__
 *
 * To run a query within a React component, call `useVisibleCardsAnalyticsByReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleCardsAnalyticsByReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleCardsAnalyticsByReferencesQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useVisibleCardsAnalyticsByReferencesQuery(baseOptions: Apollo.QueryHookOptions<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables> & ({ variables: VisibleCardsAnalyticsByReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>(VisibleCardsAnalyticsByReferencesDocument, options);
      }
export function useVisibleCardsAnalyticsByReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>(VisibleCardsAnalyticsByReferencesDocument, options);
        }
export function useVisibleCardsAnalyticsByReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>(VisibleCardsAnalyticsByReferencesDocument, options);
        }
export type VisibleCardsAnalyticsByReferencesQueryHookResult = ReturnType<typeof useVisibleCardsAnalyticsByReferencesQuery>;
export type VisibleCardsAnalyticsByReferencesLazyQueryHookResult = ReturnType<typeof useVisibleCardsAnalyticsByReferencesLazyQuery>;
export type VisibleCardsAnalyticsByReferencesSuspenseQueryHookResult = ReturnType<typeof useVisibleCardsAnalyticsByReferencesSuspenseQuery>;
export type VisibleCardsAnalyticsByReferencesQueryResult = Apollo.QueryResult<VisibleCardsAnalyticsByReferencesQuery, VisibleCardsAnalyticsByReferencesQueryVariables>;
export const VisibleCardsPriceAndStockByReferencesDocument = gql`
    query VisibleCardsPriceAndStockByReferences($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    ...ProductCard_ProductPriceAndStock
  }
}
    ${ProductCard_ProductPriceAndStockFragmentDoc}`;

/**
 * __useVisibleCardsPriceAndStockByReferencesQuery__
 *
 * To run a query within a React component, call `useVisibleCardsPriceAndStockByReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleCardsPriceAndStockByReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleCardsPriceAndStockByReferencesQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useVisibleCardsPriceAndStockByReferencesQuery(baseOptions: Apollo.QueryHookOptions<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables> & ({ variables: VisibleCardsPriceAndStockByReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>(VisibleCardsPriceAndStockByReferencesDocument, options);
      }
export function useVisibleCardsPriceAndStockByReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>(VisibleCardsPriceAndStockByReferencesDocument, options);
        }
export function useVisibleCardsPriceAndStockByReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>(VisibleCardsPriceAndStockByReferencesDocument, options);
        }
export type VisibleCardsPriceAndStockByReferencesQueryHookResult = ReturnType<typeof useVisibleCardsPriceAndStockByReferencesQuery>;
export type VisibleCardsPriceAndStockByReferencesLazyQueryHookResult = ReturnType<typeof useVisibleCardsPriceAndStockByReferencesLazyQuery>;
export type VisibleCardsPriceAndStockByReferencesSuspenseQueryHookResult = ReturnType<typeof useVisibleCardsPriceAndStockByReferencesSuspenseQuery>;
export type VisibleCardsPriceAndStockByReferencesQueryResult = Apollo.QueryResult<VisibleCardsPriceAndStockByReferencesQuery, VisibleCardsPriceAndStockByReferencesQueryVariables>;
export const ProductPageProductDocument = gql`
    query ProductPageProduct($urlKey: String!) {
  product(urlKey: $urlKey) {
    reference
    type
    parentUrlKey
    filters {
      ...FiltersFields
    }
  }
}
    ${FiltersFieldsFragmentDoc}`;

/**
 * __useProductPageProductQuery__
 *
 * To run a query within a React component, call `useProductPageProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageProductQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useProductPageProductQuery(baseOptions: Apollo.QueryHookOptions<ProductPageProductQuery, ProductPageProductQueryVariables> & ({ variables: ProductPageProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageProductQuery, ProductPageProductQueryVariables>(ProductPageProductDocument, options);
      }
export function useProductPageProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageProductQuery, ProductPageProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageProductQuery, ProductPageProductQueryVariables>(ProductPageProductDocument, options);
        }
export function useProductPageProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageProductQuery, ProductPageProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageProductQuery, ProductPageProductQueryVariables>(ProductPageProductDocument, options);
        }
export type ProductPageProductQueryHookResult = ReturnType<typeof useProductPageProductQuery>;
export type ProductPageProductLazyQueryHookResult = ReturnType<typeof useProductPageProductLazyQuery>;
export type ProductPageProductSuspenseQueryHookResult = ReturnType<typeof useProductPageProductSuspenseQuery>;
export type ProductPageProductQueryResult = Apollo.QueryResult<ProductPageProductQuery, ProductPageProductQueryVariables>;
export const ReportProductAnomalyDocument = gql`
    mutation reportProductAnomaly($reference: String!, $type: String!, $subType: String!, $url: String!, $message: String) {
  reportProductAnomaly(
    reference: $reference
    type: $type
    subType: $subType
    url: $url
    message: $message
  )
}
    `;
export type ReportProductAnomalyMutationFn = Apollo.MutationFunction<ReportProductAnomalyMutation, ReportProductAnomalyMutationVariables>;

/**
 * __useReportProductAnomalyMutation__
 *
 * To run a mutation, you first call `useReportProductAnomalyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportProductAnomalyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportProductAnomalyMutation, { data, loading, error }] = useReportProductAnomalyMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      url: // value for 'url'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useReportProductAnomalyMutation(baseOptions?: Apollo.MutationHookOptions<ReportProductAnomalyMutation, ReportProductAnomalyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportProductAnomalyMutation, ReportProductAnomalyMutationVariables>(ReportProductAnomalyDocument, options);
      }
export type ReportProductAnomalyMutationHookResult = ReturnType<typeof useReportProductAnomalyMutation>;
export type ReportProductAnomalyMutationResult = Apollo.MutationResult<ReportProductAnomalyMutation>;
export type ReportProductAnomalyMutationOptions = Apollo.BaseMutationOptions<ReportProductAnomalyMutation, ReportProductAnomalyMutationVariables>;
export const ClearPunchoutCartItemsDocument = gql`
    mutation ClearPunchoutCartItems($punchoutCartId: Int!) {
  clearPunchoutCartItems(punchoutCartId: $punchoutCartId) {
    ...PunchoutCart_Cart
  }
}
    ${PunchoutCart_CartFragmentDoc}`;
export type ClearPunchoutCartItemsMutationFn = Apollo.MutationFunction<ClearPunchoutCartItemsMutation, ClearPunchoutCartItemsMutationVariables>;

/**
 * __useClearPunchoutCartItemsMutation__
 *
 * To run a mutation, you first call `useClearPunchoutCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPunchoutCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPunchoutCartItemsMutation, { data, loading, error }] = useClearPunchoutCartItemsMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *   },
 * });
 */
export function useClearPunchoutCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<ClearPunchoutCartItemsMutation, ClearPunchoutCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPunchoutCartItemsMutation, ClearPunchoutCartItemsMutationVariables>(ClearPunchoutCartItemsDocument, options);
      }
export type ClearPunchoutCartItemsMutationHookResult = ReturnType<typeof useClearPunchoutCartItemsMutation>;
export type ClearPunchoutCartItemsMutationResult = Apollo.MutationResult<ClearPunchoutCartItemsMutation>;
export type ClearPunchoutCartItemsMutationOptions = Apollo.BaseMutationOptions<ClearPunchoutCartItemsMutation, ClearPunchoutCartItemsMutationVariables>;
export const SendPunchoutCartToErpDocument = gql`
    mutation SendPunchoutCartToErp($cartId: Int!) {
  punchoutCart(cartId: $cartId) {
    url
    formData
  }
}
    `;
export type SendPunchoutCartToErpMutationFn = Apollo.MutationFunction<SendPunchoutCartToErpMutation, SendPunchoutCartToErpMutationVariables>;

/**
 * __useSendPunchoutCartToErpMutation__
 *
 * To run a mutation, you first call `useSendPunchoutCartToErpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPunchoutCartToErpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPunchoutCartToErpMutation, { data, loading, error }] = useSendPunchoutCartToErpMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSendPunchoutCartToErpMutation(baseOptions?: Apollo.MutationHookOptions<SendPunchoutCartToErpMutation, SendPunchoutCartToErpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPunchoutCartToErpMutation, SendPunchoutCartToErpMutationVariables>(SendPunchoutCartToErpDocument, options);
      }
export type SendPunchoutCartToErpMutationHookResult = ReturnType<typeof useSendPunchoutCartToErpMutation>;
export type SendPunchoutCartToErpMutationResult = Apollo.MutationResult<SendPunchoutCartToErpMutation>;
export type SendPunchoutCartToErpMutationOptions = Apollo.BaseMutationOptions<SendPunchoutCartToErpMutation, SendPunchoutCartToErpMutationVariables>;
export const AddProductToPunchoutCartDocument = gql`
    mutation AddProductToPunchoutCart($punchoutCartId: Int!, $reference: String!, $quantity: Int!) {
  addProductToPunchoutCart(
    punchoutCartId: $punchoutCartId
    reference: $reference
    quantity: $quantity
  ) {
    ...PunchoutCart_Cart
  }
}
    ${PunchoutCart_CartFragmentDoc}`;
export type AddProductToPunchoutCartMutationFn = Apollo.MutationFunction<AddProductToPunchoutCartMutation, AddProductToPunchoutCartMutationVariables>;

/**
 * __useAddProductToPunchoutCartMutation__
 *
 * To run a mutation, you first call `useAddProductToPunchoutCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToPunchoutCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToPunchoutCartMutation, { data, loading, error }] = useAddProductToPunchoutCartMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *      reference: // value for 'reference'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProductToPunchoutCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToPunchoutCartMutation, AddProductToPunchoutCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToPunchoutCartMutation, AddProductToPunchoutCartMutationVariables>(AddProductToPunchoutCartDocument, options);
      }
export type AddProductToPunchoutCartMutationHookResult = ReturnType<typeof useAddProductToPunchoutCartMutation>;
export type AddProductToPunchoutCartMutationResult = Apollo.MutationResult<AddProductToPunchoutCartMutation>;
export type AddProductToPunchoutCartMutationOptions = Apollo.BaseMutationOptions<AddProductToPunchoutCartMutation, AddProductToPunchoutCartMutationVariables>;
export const AddProductsToPunchoutCartDocument = gql`
    mutation AddProductsToPunchoutCart($punchoutCartId: Int!, $items: [ProductToCartInput!]!) {
  addProductsToPunchoutCart(punchoutCartId: $punchoutCartId, items: $items) {
    ...PunchoutCart_Cart
  }
}
    ${PunchoutCart_CartFragmentDoc}`;
export type AddProductsToPunchoutCartMutationFn = Apollo.MutationFunction<AddProductsToPunchoutCartMutation, AddProductsToPunchoutCartMutationVariables>;

/**
 * __useAddProductsToPunchoutCartMutation__
 *
 * To run a mutation, you first call `useAddProductsToPunchoutCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToPunchoutCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToPunchoutCartMutation, { data, loading, error }] = useAddProductsToPunchoutCartMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useAddProductsToPunchoutCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToPunchoutCartMutation, AddProductsToPunchoutCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToPunchoutCartMutation, AddProductsToPunchoutCartMutationVariables>(AddProductsToPunchoutCartDocument, options);
      }
export type AddProductsToPunchoutCartMutationHookResult = ReturnType<typeof useAddProductsToPunchoutCartMutation>;
export type AddProductsToPunchoutCartMutationResult = Apollo.MutationResult<AddProductsToPunchoutCartMutation>;
export type AddProductsToPunchoutCartMutationOptions = Apollo.BaseMutationOptions<AddProductsToPunchoutCartMutation, AddProductsToPunchoutCartMutationVariables>;
export const PunchoutCartDocument = gql`
    query PunchoutCart {
  currentUser {
    id
    ...SendPunchoutCartToErpButton_User
    punchout {
      cart {
        ...PunchoutCart_Cart
      }
    }
  }
}
    ${SendPunchoutCartToErpButton_UserFragmentDoc}
${PunchoutCart_CartFragmentDoc}`;

/**
 * __usePunchoutCartQuery__
 *
 * To run a query within a React component, call `usePunchoutCartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchoutCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchoutCartQuery({
 *   variables: {
 *   },
 * });
 */
export function usePunchoutCartQuery(baseOptions?: Apollo.QueryHookOptions<PunchoutCartQuery, PunchoutCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchoutCartQuery, PunchoutCartQueryVariables>(PunchoutCartDocument, options);
      }
export function usePunchoutCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchoutCartQuery, PunchoutCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchoutCartQuery, PunchoutCartQueryVariables>(PunchoutCartDocument, options);
        }
export function usePunchoutCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PunchoutCartQuery, PunchoutCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PunchoutCartQuery, PunchoutCartQueryVariables>(PunchoutCartDocument, options);
        }
export type PunchoutCartQueryHookResult = ReturnType<typeof usePunchoutCartQuery>;
export type PunchoutCartLazyQueryHookResult = ReturnType<typeof usePunchoutCartLazyQuery>;
export type PunchoutCartSuspenseQueryHookResult = ReturnType<typeof usePunchoutCartSuspenseQuery>;
export type PunchoutCartQueryResult = Apollo.QueryResult<PunchoutCartQuery, PunchoutCartQueryVariables>;
export const UsePunchoutCartIdDocument = gql`
    query UsePunchoutCartId {
  currentUser {
    id
    punchout {
      cart {
        id
      }
    }
  }
}
    `;

/**
 * __useUsePunchoutCartIdQuery__
 *
 * To run a query within a React component, call `useUsePunchoutCartIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsePunchoutCartIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsePunchoutCartIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsePunchoutCartIdQuery(baseOptions?: Apollo.QueryHookOptions<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>(UsePunchoutCartIdDocument, options);
      }
export function useUsePunchoutCartIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>(UsePunchoutCartIdDocument, options);
        }
export function useUsePunchoutCartIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>(UsePunchoutCartIdDocument, options);
        }
export type UsePunchoutCartIdQueryHookResult = ReturnType<typeof useUsePunchoutCartIdQuery>;
export type UsePunchoutCartIdLazyQueryHookResult = ReturnType<typeof useUsePunchoutCartIdLazyQuery>;
export type UsePunchoutCartIdSuspenseQueryHookResult = ReturnType<typeof useUsePunchoutCartIdSuspenseQuery>;
export type UsePunchoutCartIdQueryResult = Apollo.QueryResult<UsePunchoutCartIdQuery, UsePunchoutCartIdQueryVariables>;
export const UpdatePunchoutCartItemQuantityDocument = gql`
    mutation UpdatePunchoutCartItemQuantity($punchoutCartId: Int!, $cartItemId: Int!, $quantity: Int!) {
  updatePunchoutCartItemQuantity(
    punchoutCartId: $punchoutCartId
    cartItemId: $cartItemId
    quantity: $quantity
  ) {
    ...PunchoutCart_Cart
  }
}
    ${PunchoutCart_CartFragmentDoc}`;
export type UpdatePunchoutCartItemQuantityMutationFn = Apollo.MutationFunction<UpdatePunchoutCartItemQuantityMutation, UpdatePunchoutCartItemQuantityMutationVariables>;

/**
 * __useUpdatePunchoutCartItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdatePunchoutCartItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePunchoutCartItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePunchoutCartItemQuantityMutation, { data, loading, error }] = useUpdatePunchoutCartItemQuantityMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *      cartItemId: // value for 'cartItemId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdatePunchoutCartItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePunchoutCartItemQuantityMutation, UpdatePunchoutCartItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePunchoutCartItemQuantityMutation, UpdatePunchoutCartItemQuantityMutationVariables>(UpdatePunchoutCartItemQuantityDocument, options);
      }
export type UpdatePunchoutCartItemQuantityMutationHookResult = ReturnType<typeof useUpdatePunchoutCartItemQuantityMutation>;
export type UpdatePunchoutCartItemQuantityMutationResult = Apollo.MutationResult<UpdatePunchoutCartItemQuantityMutation>;
export type UpdatePunchoutCartItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdatePunchoutCartItemQuantityMutation, UpdatePunchoutCartItemQuantityMutationVariables>;
export const RemovePunchoutCartItemDocument = gql`
    mutation RemovePunchoutCartItem($punchoutCartId: Int!, $cartItemId: Int!) {
  removePunchoutCartItem(punchoutCartId: $punchoutCartId, cartItemId: $cartItemId) {
    ...PunchoutCart_Cart
  }
}
    ${PunchoutCart_CartFragmentDoc}`;
export type RemovePunchoutCartItemMutationFn = Apollo.MutationFunction<RemovePunchoutCartItemMutation, RemovePunchoutCartItemMutationVariables>;

/**
 * __useRemovePunchoutCartItemMutation__
 *
 * To run a mutation, you first call `useRemovePunchoutCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePunchoutCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePunchoutCartItemMutation, { data, loading, error }] = useRemovePunchoutCartItemMutation({
 *   variables: {
 *      punchoutCartId: // value for 'punchoutCartId'
 *      cartItemId: // value for 'cartItemId'
 *   },
 * });
 */
export function useRemovePunchoutCartItemMutation(baseOptions?: Apollo.MutationHookOptions<RemovePunchoutCartItemMutation, RemovePunchoutCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePunchoutCartItemMutation, RemovePunchoutCartItemMutationVariables>(RemovePunchoutCartItemDocument, options);
      }
export type RemovePunchoutCartItemMutationHookResult = ReturnType<typeof useRemovePunchoutCartItemMutation>;
export type RemovePunchoutCartItemMutationResult = Apollo.MutationResult<RemovePunchoutCartItemMutation>;
export type RemovePunchoutCartItemMutationOptions = Apollo.BaseMutationOptions<RemovePunchoutCartItemMutation, RemovePunchoutCartItemMutationVariables>;
export const UpdateQuickOrderListDocument = gql`
    mutation updateQuickOrderList($input: QuickOrderInput_V2!) {
  updateQuickOrder_V2(input: $input) {
    id
  }
}
    `;
export type UpdateQuickOrderListMutationFn = Apollo.MutationFunction<UpdateQuickOrderListMutation, UpdateQuickOrderListMutationVariables>;

/**
 * __useUpdateQuickOrderListMutation__
 *
 * To run a mutation, you first call `useUpdateQuickOrderListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickOrderListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickOrderListMutation, { data, loading, error }] = useUpdateQuickOrderListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickOrderListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuickOrderListMutation, UpdateQuickOrderListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuickOrderListMutation, UpdateQuickOrderListMutationVariables>(UpdateQuickOrderListDocument, options);
      }
export type UpdateQuickOrderListMutationHookResult = ReturnType<typeof useUpdateQuickOrderListMutation>;
export type UpdateQuickOrderListMutationResult = Apollo.MutationResult<UpdateQuickOrderListMutation>;
export type UpdateQuickOrderListMutationOptions = Apollo.BaseMutationOptions<UpdateQuickOrderListMutation, UpdateQuickOrderListMutationVariables>;
export const GetQuickOrderListFilteredCartAmountDocument = gql`
    query GetQuickOrderListFilteredCartAmount($category: String) {
  currentUser {
    id
    quickOrderList(firstLevelCategoryCode: $category) {
      id
      totalExclTax
      products {
        id
        quantity
        product {
          reference
          stock {
            availability
          }
          canAddToCart
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuickOrderListFilteredCartAmountQuery__
 *
 * To run a query within a React component, call `useGetQuickOrderListFilteredCartAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickOrderListFilteredCartAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickOrderListFilteredCartAmountQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetQuickOrderListFilteredCartAmountQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>(GetQuickOrderListFilteredCartAmountDocument, options);
      }
export function useGetQuickOrderListFilteredCartAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>(GetQuickOrderListFilteredCartAmountDocument, options);
        }
export function useGetQuickOrderListFilteredCartAmountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>(GetQuickOrderListFilteredCartAmountDocument, options);
        }
export type GetQuickOrderListFilteredCartAmountQueryHookResult = ReturnType<typeof useGetQuickOrderListFilteredCartAmountQuery>;
export type GetQuickOrderListFilteredCartAmountLazyQueryHookResult = ReturnType<typeof useGetQuickOrderListFilteredCartAmountLazyQuery>;
export type GetQuickOrderListFilteredCartAmountSuspenseQueryHookResult = ReturnType<typeof useGetQuickOrderListFilteredCartAmountSuspenseQuery>;
export type GetQuickOrderListFilteredCartAmountQueryResult = Apollo.QueryResult<GetQuickOrderListFilteredCartAmountQuery, GetQuickOrderListFilteredCartAmountQueryVariables>;
export const ClearQuickOrderDocument = gql`
    mutation clearQuickOrder($category: String) {
  clearQuickOrder(firstLevelCategoryCode: $category)
}
    `;
export type ClearQuickOrderMutationFn = Apollo.MutationFunction<ClearQuickOrderMutation, ClearQuickOrderMutationVariables>;

/**
 * __useClearQuickOrderMutation__
 *
 * To run a mutation, you first call `useClearQuickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearQuickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearQuickOrderMutation, { data, loading, error }] = useClearQuickOrderMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useClearQuickOrderMutation(baseOptions?: Apollo.MutationHookOptions<ClearQuickOrderMutation, ClearQuickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearQuickOrderMutation, ClearQuickOrderMutationVariables>(ClearQuickOrderDocument, options);
      }
export type ClearQuickOrderMutationHookResult = ReturnType<typeof useClearQuickOrderMutation>;
export type ClearQuickOrderMutationResult = Apollo.MutationResult<ClearQuickOrderMutation>;
export type ClearQuickOrderMutationOptions = Apollo.BaseMutationOptions<ClearQuickOrderMutation, ClearQuickOrderMutationVariables>;
export const GetQuickOrderListProductsDocument = gql`
    query GetQuickOrderListProducts($category: String) {
  currentUser {
    id
    quickOrderList(firstLevelCategoryCode: $category) {
      ...QuickOrderProductList_Products
    }
  }
}
    ${QuickOrderProductList_ProductsFragmentDoc}`;

/**
 * __useGetQuickOrderListProductsQuery__
 *
 * To run a query within a React component, call `useGetQuickOrderListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickOrderListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickOrderListProductsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetQuickOrderListProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>(GetQuickOrderListProductsDocument, options);
      }
export function useGetQuickOrderListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>(GetQuickOrderListProductsDocument, options);
        }
export function useGetQuickOrderListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>(GetQuickOrderListProductsDocument, options);
        }
export type GetQuickOrderListProductsQueryHookResult = ReturnType<typeof useGetQuickOrderListProductsQuery>;
export type GetQuickOrderListProductsLazyQueryHookResult = ReturnType<typeof useGetQuickOrderListProductsLazyQuery>;
export type GetQuickOrderListProductsSuspenseQueryHookResult = ReturnType<typeof useGetQuickOrderListProductsSuspenseQuery>;
export type GetQuickOrderListProductsQueryResult = Apollo.QueryResult<GetQuickOrderListProductsQuery, GetQuickOrderListProductsQueryVariables>;
export const UpdateCurrentQuoteDocument = gql`
    mutation updateCurrentQuote($input: QuoteUpdateInput_V2!) {
  updateCurrentQuote_V2(input: $input) {
    id
  }
}
    `;
export type UpdateCurrentQuoteMutationFn = Apollo.MutationFunction<UpdateCurrentQuoteMutation, UpdateCurrentQuoteMutationVariables>;

/**
 * __useUpdateCurrentQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentQuoteMutation, { data, loading, error }] = useUpdateCurrentQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentQuoteMutation, UpdateCurrentQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentQuoteMutation, UpdateCurrentQuoteMutationVariables>(UpdateCurrentQuoteDocument, options);
      }
export type UpdateCurrentQuoteMutationHookResult = ReturnType<typeof useUpdateCurrentQuoteMutation>;
export type UpdateCurrentQuoteMutationResult = Apollo.MutationResult<UpdateCurrentQuoteMutation>;
export type UpdateCurrentQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentQuoteMutation, UpdateCurrentQuoteMutationVariables>;
export const CompanyChorusDataDocument = gql`
    query CompanyChorusData {
  currentUser {
    id
    company {
      id
      chorusData {
        ...Company_ChorusData
      }
    }
  }
}
    ${Company_ChorusDataFragmentDoc}`;

/**
 * __useCompanyChorusDataQuery__
 *
 * To run a query within a React component, call `useCompanyChorusDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyChorusDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyChorusDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyChorusDataQuery(baseOptions?: Apollo.QueryHookOptions<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>(CompanyChorusDataDocument, options);
      }
export function useCompanyChorusDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>(CompanyChorusDataDocument, options);
        }
export function useCompanyChorusDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>(CompanyChorusDataDocument, options);
        }
export type CompanyChorusDataQueryHookResult = ReturnType<typeof useCompanyChorusDataQuery>;
export type CompanyChorusDataLazyQueryHookResult = ReturnType<typeof useCompanyChorusDataLazyQuery>;
export type CompanyChorusDataSuspenseQueryHookResult = ReturnType<typeof useCompanyChorusDataSuspenseQuery>;
export type CompanyChorusDataQueryResult = Apollo.QueryResult<CompanyChorusDataQuery, CompanyChorusDataQueryVariables>;
export const ApproveChorusQuoteDocument = gql`
    mutation ApproveChorusQuote($quoteId: String!, $posId: String!, $legalCommitment: String!, $serviceCode: String!) {
  approveQuote(
    input: {id: {id: $quoteId, pointOfSaleId: $posId}, chorusData: {legalCommitment: $legalCommitment, serviceCode: $serviceCode}}
  ) {
    id
  }
}
    `;
export type ApproveChorusQuoteMutationFn = Apollo.MutationFunction<ApproveChorusQuoteMutation, ApproveChorusQuoteMutationVariables>;

/**
 * __useApproveChorusQuoteMutation__
 *
 * To run a mutation, you first call `useApproveChorusQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveChorusQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveChorusQuoteMutation, { data, loading, error }] = useApproveChorusQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      posId: // value for 'posId'
 *      legalCommitment: // value for 'legalCommitment'
 *      serviceCode: // value for 'serviceCode'
 *   },
 * });
 */
export function useApproveChorusQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ApproveChorusQuoteMutation, ApproveChorusQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveChorusQuoteMutation, ApproveChorusQuoteMutationVariables>(ApproveChorusQuoteDocument, options);
      }
export type ApproveChorusQuoteMutationHookResult = ReturnType<typeof useApproveChorusQuoteMutation>;
export type ApproveChorusQuoteMutationResult = Apollo.MutationResult<ApproveChorusQuoteMutation>;
export type ApproveChorusQuoteMutationOptions = Apollo.BaseMutationOptions<ApproveChorusQuoteMutation, ApproveChorusQuoteMutationVariables>;
export const ApproveQuoteDocument = gql`
    mutation ApproveQuote($quoteId: String!, $posId: String!) {
  approveQuote(input: {id: {id: $quoteId, pointOfSaleId: $posId}}) {
    id
  }
}
    `;
export type ApproveQuoteMutationFn = Apollo.MutationFunction<ApproveQuoteMutation, ApproveQuoteMutationVariables>;

/**
 * __useApproveQuoteMutation__
 *
 * To run a mutation, you first call `useApproveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveQuoteMutation, { data, loading, error }] = useApproveQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      posId: // value for 'posId'
 *   },
 * });
 */
export function useApproveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ApproveQuoteMutation, ApproveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveQuoteMutation, ApproveQuoteMutationVariables>(ApproveQuoteDocument, options);
      }
export type ApproveQuoteMutationHookResult = ReturnType<typeof useApproveQuoteMutation>;
export type ApproveQuoteMutationResult = Apollo.MutationResult<ApproveQuoteMutation>;
export type ApproveQuoteMutationOptions = Apollo.BaseMutationOptions<ApproveQuoteMutation, ApproveQuoteMutationVariables>;
export const ClearCurrentQuoteDocument = gql`
    mutation clearCurrentQuote {
  clearCurrentQuote
}
    `;
export type ClearCurrentQuoteMutationFn = Apollo.MutationFunction<ClearCurrentQuoteMutation, ClearCurrentQuoteMutationVariables>;

/**
 * __useClearCurrentQuoteMutation__
 *
 * To run a mutation, you first call `useClearCurrentQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCurrentQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCurrentQuoteMutation, { data, loading, error }] = useClearCurrentQuoteMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearCurrentQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ClearCurrentQuoteMutation, ClearCurrentQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCurrentQuoteMutation, ClearCurrentQuoteMutationVariables>(ClearCurrentQuoteDocument, options);
      }
export type ClearCurrentQuoteMutationHookResult = ReturnType<typeof useClearCurrentQuoteMutation>;
export type ClearCurrentQuoteMutationResult = Apollo.MutationResult<ClearCurrentQuoteMutation>;
export type ClearCurrentQuoteMutationOptions = Apollo.BaseMutationOptions<ClearCurrentQuoteMutation, ClearCurrentQuoteMutationVariables>;
export const DeclineQuoteDocument = gql`
    mutation DeclineQuote($quoteId: String!, $posId: String!, $reason: QuoteDeclineReason!, $comment: String) {
  declineQuote(
    input: {id: {id: $quoteId, pointOfSaleId: $posId}, declineReason: {reason: $reason, comment: $comment}}
  )
}
    `;
export type DeclineQuoteMutationFn = Apollo.MutationFunction<DeclineQuoteMutation, DeclineQuoteMutationVariables>;

/**
 * __useDeclineQuoteMutation__
 *
 * To run a mutation, you first call `useDeclineQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineQuoteMutation, { data, loading, error }] = useDeclineQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      posId: // value for 'posId'
 *      reason: // value for 'reason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useDeclineQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineQuoteMutation, DeclineQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineQuoteMutation, DeclineQuoteMutationVariables>(DeclineQuoteDocument, options);
      }
export type DeclineQuoteMutationHookResult = ReturnType<typeof useDeclineQuoteMutation>;
export type DeclineQuoteMutationResult = Apollo.MutationResult<DeclineQuoteMutation>;
export type DeclineQuoteMutationOptions = Apollo.BaseMutationOptions<DeclineQuoteMutation, DeclineQuoteMutationVariables>;
export const IsPublicAdministrationDocument = gql`
    query isPublicAdministration {
  config {
    sales {
      isChorusDisplayEnabled
    }
  }
  currentUser {
    id
    company {
      id
      chorusData {
        isChorus
      }
    }
  }
}
    `;

/**
 * __useIsPublicAdministrationQuery__
 *
 * To run a query within a React component, call `useIsPublicAdministrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPublicAdministrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPublicAdministrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsPublicAdministrationQuery(baseOptions?: Apollo.QueryHookOptions<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>(IsPublicAdministrationDocument, options);
      }
export function useIsPublicAdministrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>(IsPublicAdministrationDocument, options);
        }
export function useIsPublicAdministrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>(IsPublicAdministrationDocument, options);
        }
export type IsPublicAdministrationQueryHookResult = ReturnType<typeof useIsPublicAdministrationQuery>;
export type IsPublicAdministrationLazyQueryHookResult = ReturnType<typeof useIsPublicAdministrationLazyQuery>;
export type IsPublicAdministrationSuspenseQueryHookResult = ReturnType<typeof useIsPublicAdministrationSuspenseQuery>;
export type IsPublicAdministrationQueryResult = Apollo.QueryResult<IsPublicAdministrationQuery, IsPublicAdministrationQueryVariables>;
export const QuotesResumeCurrentUserDocument = gql`
    query QuotesResumeCurrentUser {
  currentUser {
    id
    company {
      id
      isProspect
    }
    permissions {
      showOrderHistory
      canManageQuote
    }
  }
}
    `;

/**
 * __useQuotesResumeCurrentUserQuery__
 *
 * To run a query within a React component, call `useQuotesResumeCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesResumeCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesResumeCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuotesResumeCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>(QuotesResumeCurrentUserDocument, options);
      }
export function useQuotesResumeCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>(QuotesResumeCurrentUserDocument, options);
        }
export function useQuotesResumeCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>(QuotesResumeCurrentUserDocument, options);
        }
export type QuotesResumeCurrentUserQueryHookResult = ReturnType<typeof useQuotesResumeCurrentUserQuery>;
export type QuotesResumeCurrentUserLazyQueryHookResult = ReturnType<typeof useQuotesResumeCurrentUserLazyQuery>;
export type QuotesResumeCurrentUserSuspenseQueryHookResult = ReturnType<typeof useQuotesResumeCurrentUserSuspenseQuery>;
export type QuotesResumeCurrentUserQueryResult = Apollo.QueryResult<QuotesResumeCurrentUserQuery, QuotesResumeCurrentUserQueryVariables>;
export const GetQuotesResumeConfigDocument = gql`
    query getQuotesResumeConfig {
  config {
    ...LoyaltyConfig
    ...QuotesPage_Config
  }
}
    ${LoyaltyConfigFragmentDoc}
${QuotesPage_ConfigFragmentDoc}`;

/**
 * __useGetQuotesResumeConfigQuery__
 *
 * To run a query within a React component, call `useGetQuotesResumeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesResumeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesResumeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuotesResumeConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>(GetQuotesResumeConfigDocument, options);
      }
export function useGetQuotesResumeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>(GetQuotesResumeConfigDocument, options);
        }
export function useGetQuotesResumeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>(GetQuotesResumeConfigDocument, options);
        }
export type GetQuotesResumeConfigQueryHookResult = ReturnType<typeof useGetQuotesResumeConfigQuery>;
export type GetQuotesResumeConfigLazyQueryHookResult = ReturnType<typeof useGetQuotesResumeConfigLazyQuery>;
export type GetQuotesResumeConfigSuspenseQueryHookResult = ReturnType<typeof useGetQuotesResumeConfigSuspenseQuery>;
export type GetQuotesResumeConfigQueryResult = Apollo.QueryResult<GetQuotesResumeConfigQuery, GetQuotesResumeConfigQueryVariables>;
export const GetQuotesDocument = gql`
    query getQuotes($input: Browsing) {
  currentUser {
    id
    company {
      id
      quotes(input: $input) {
        totalPages
        totalSize
        items {
          ...QuotesTable_Quote
        }
      }
    }
  }
}
    ${QuotesTable_QuoteFragmentDoc}`;

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
      }
export function useGetQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export function useGetQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesSuspenseQueryHookResult = ReturnType<typeof useGetQuotesSuspenseQuery>;
export type GetQuotesQueryResult = Apollo.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export const RenewQuoteDocument = gql`
    mutation RenewQuote($quoteId: String!, $pointOfSaleId: String!) {
  renewQuote(input: {id: $quoteId, pointOfSaleId: $pointOfSaleId})
}
    `;
export type RenewQuoteMutationFn = Apollo.MutationFunction<RenewQuoteMutation, RenewQuoteMutationVariables>;

/**
 * __useRenewQuoteMutation__
 *
 * To run a mutation, you first call `useRenewQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewQuoteMutation, { data, loading, error }] = useRenewQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *   },
 * });
 */
export function useRenewQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RenewQuoteMutation, RenewQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewQuoteMutation, RenewQuoteMutationVariables>(RenewQuoteDocument, options);
      }
export type RenewQuoteMutationHookResult = ReturnType<typeof useRenewQuoteMutation>;
export type RenewQuoteMutationResult = Apollo.MutationResult<RenewQuoteMutation>;
export type RenewQuoteMutationOptions = Apollo.BaseMutationOptions<RenewQuoteMutation, RenewQuoteMutationVariables>;
export const GetIsCurrentUserSignedInDocument = gql`
    query GetIsCurrentUserSignedIn {
  currentUser {
    id
    email
  }
}
    `;

/**
 * __useGetIsCurrentUserSignedInQuery__
 *
 * To run a query within a React component, call `useGetIsCurrentUserSignedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsCurrentUserSignedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsCurrentUserSignedInQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsCurrentUserSignedInQuery(baseOptions?: Apollo.QueryHookOptions<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>(GetIsCurrentUserSignedInDocument, options);
      }
export function useGetIsCurrentUserSignedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>(GetIsCurrentUserSignedInDocument, options);
        }
export function useGetIsCurrentUserSignedInSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>(GetIsCurrentUserSignedInDocument, options);
        }
export type GetIsCurrentUserSignedInQueryHookResult = ReturnType<typeof useGetIsCurrentUserSignedInQuery>;
export type GetIsCurrentUserSignedInLazyQueryHookResult = ReturnType<typeof useGetIsCurrentUserSignedInLazyQuery>;
export type GetIsCurrentUserSignedInSuspenseQueryHookResult = ReturnType<typeof useGetIsCurrentUserSignedInSuspenseQuery>;
export type GetIsCurrentUserSignedInQueryResult = Apollo.QueryResult<GetIsCurrentUserSignedInQuery, GetIsCurrentUserSignedInQueryVariables>;
export const ShareQuoteDrawerDocument = gql`
    query ShareQuoteDrawer($type: SharingType!) {
  shareUserList(type: $type) {
    id
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useShareQuoteDrawerQuery__
 *
 * To run a query within a React component, call `useShareQuoteDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareQuoteDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareQuoteDrawerQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShareQuoteDrawerQuery(baseOptions: Apollo.QueryHookOptions<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables> & ({ variables: ShareQuoteDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>(ShareQuoteDrawerDocument, options);
      }
export function useShareQuoteDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>(ShareQuoteDrawerDocument, options);
        }
export function useShareQuoteDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>(ShareQuoteDrawerDocument, options);
        }
export type ShareQuoteDrawerQueryHookResult = ReturnType<typeof useShareQuoteDrawerQuery>;
export type ShareQuoteDrawerLazyQueryHookResult = ReturnType<typeof useShareQuoteDrawerLazyQuery>;
export type ShareQuoteDrawerSuspenseQueryHookResult = ReturnType<typeof useShareQuoteDrawerSuspenseQuery>;
export type ShareQuoteDrawerQueryResult = Apollo.QueryResult<ShareQuoteDrawerQuery, ShareQuoteDrawerQueryVariables>;
export const ShareQuoteDocument = gql`
    mutation ShareQuote($input: QuoteShareInput!) {
  shareQuote(input: $input)
}
    `;
export type ShareQuoteMutationFn = Apollo.MutationFunction<ShareQuoteMutation, ShareQuoteMutationVariables>;

/**
 * __useShareQuoteMutation__
 *
 * To run a mutation, you first call `useShareQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareQuoteMutation, { data, loading, error }] = useShareQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ShareQuoteMutation, ShareQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareQuoteMutation, ShareQuoteMutationVariables>(ShareQuoteDocument, options);
      }
export type ShareQuoteMutationHookResult = ReturnType<typeof useShareQuoteMutation>;
export type ShareQuoteMutationResult = Apollo.MutationResult<ShareQuoteMutation>;
export type ShareQuoteMutationOptions = Apollo.BaseMutationOptions<ShareQuoteMutation, ShareQuoteMutationVariables>;
export const SubmitCurrentQuoteDocument = gql`
    mutation SubmitCurrentQuote {
  submitCurrentQuote
}
    `;
export type SubmitCurrentQuoteMutationFn = Apollo.MutationFunction<SubmitCurrentQuoteMutation, SubmitCurrentQuoteMutationVariables>;

/**
 * __useSubmitCurrentQuoteMutation__
 *
 * To run a mutation, you first call `useSubmitCurrentQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCurrentQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCurrentQuoteMutation, { data, loading, error }] = useSubmitCurrentQuoteMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitCurrentQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCurrentQuoteMutation, SubmitCurrentQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCurrentQuoteMutation, SubmitCurrentQuoteMutationVariables>(SubmitCurrentQuoteDocument, options);
      }
export type SubmitCurrentQuoteMutationHookResult = ReturnType<typeof useSubmitCurrentQuoteMutation>;
export type SubmitCurrentQuoteMutationResult = Apollo.MutationResult<SubmitCurrentQuoteMutation>;
export type SubmitCurrentQuoteMutationOptions = Apollo.BaseMutationOptions<SubmitCurrentQuoteMutation, SubmitCurrentQuoteMutationVariables>;
export const CreateQuoteDocument = gql`
    mutation CreateQuote($name: String!) {
  createQuote(name: $name) {
    name
  }
}
    `;
export type CreateQuoteMutationFn = Apollo.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = Apollo.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const DirectReOrderDocument = gql`
    mutation DirectReOrder($orderId: String!, $cartId: String!) {
  directReOrder(webRef: $orderId, cartId: $cartId) {
    addedProducts {
      productReference
      quantity
    }
    unavailableProducts {
      productReference
    }
  }
}
    `;
export type DirectReOrderMutationFn = Apollo.MutationFunction<DirectReOrderMutation, DirectReOrderMutationVariables>;

/**
 * __useDirectReOrderMutation__
 *
 * To run a mutation, you first call `useDirectReOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectReOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directReOrderMutation, { data, loading, error }] = useDirectReOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useDirectReOrderMutation(baseOptions?: Apollo.MutationHookOptions<DirectReOrderMutation, DirectReOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectReOrderMutation, DirectReOrderMutationVariables>(DirectReOrderDocument, options);
      }
export type DirectReOrderMutationHookResult = ReturnType<typeof useDirectReOrderMutation>;
export type DirectReOrderMutationResult = Apollo.MutationResult<DirectReOrderMutation>;
export type DirectReOrderMutationOptions = Apollo.BaseMutationOptions<DirectReOrderMutation, DirectReOrderMutationVariables>;
export const ReOrderButton_OrderItemsDocument = gql`
    query ReOrderButton_OrderItems($webRef: String!) {
  currentUser {
    id
    orders(
      input: {filter: [{type: STRING, field: "webRef", operator: EQUAL, stringValue: $webRef}, {type: STRING, field: "orderType", operator: EQUAL, stringValue: "ECOMMERCE"}]}
    ) {
      items {
        webRef
        items {
          reference
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useReOrderButton_OrderItemsQuery__
 *
 * To run a query within a React component, call `useReOrderButton_OrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReOrderButton_OrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReOrderButton_OrderItemsQuery({
 *   variables: {
 *      webRef: // value for 'webRef'
 *   },
 * });
 */
export function useReOrderButton_OrderItemsQuery(baseOptions: Apollo.QueryHookOptions<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables> & ({ variables: ReOrderButton_OrderItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>(ReOrderButton_OrderItemsDocument, options);
      }
export function useReOrderButton_OrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>(ReOrderButton_OrderItemsDocument, options);
        }
export function useReOrderButton_OrderItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>(ReOrderButton_OrderItemsDocument, options);
        }
export type ReOrderButton_OrderItemsQueryHookResult = ReturnType<typeof useReOrderButton_OrderItemsQuery>;
export type ReOrderButton_OrderItemsLazyQueryHookResult = ReturnType<typeof useReOrderButton_OrderItemsLazyQuery>;
export type ReOrderButton_OrderItemsSuspenseQueryHookResult = ReturnType<typeof useReOrderButton_OrderItemsSuspenseQuery>;
export type ReOrderButton_OrderItemsQueryResult = Apollo.QueryResult<ReOrderButton_OrderItemsQuery, ReOrderButton_OrderItemsQueryVariables>;
export const CmsSeoCategoryDocument = gql`
    query CMSSeoCategory($categoryCode: String!, $tenantId: JSON!) {
  CMS_SeoCategories(
    where: {AND: [{categoryCode: {equals: $categoryCode}}, {tenant: {equals: $tenantId}}]}
  ) {
    docs {
      seoContent
    }
  }
}
    `;

/**
 * __useCmsSeoCategoryQuery__
 *
 * To run a query within a React component, call `useCmsSeoCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsSeoCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsSeoCategoryQuery({
 *   variables: {
 *      categoryCode: // value for 'categoryCode'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCmsSeoCategoryQuery(baseOptions: Apollo.QueryHookOptions<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables> & ({ variables: CmsSeoCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>(CmsSeoCategoryDocument, options);
      }
export function useCmsSeoCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>(CmsSeoCategoryDocument, options);
        }
export function useCmsSeoCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>(CmsSeoCategoryDocument, options);
        }
export type CmsSeoCategoryQueryHookResult = ReturnType<typeof useCmsSeoCategoryQuery>;
export type CmsSeoCategoryLazyQueryHookResult = ReturnType<typeof useCmsSeoCategoryLazyQuery>;
export type CmsSeoCategorySuspenseQueryHookResult = ReturnType<typeof useCmsSeoCategorySuspenseQuery>;
export type CmsSeoCategoryQueryResult = Apollo.QueryResult<CmsSeoCategoryQuery, CmsSeoCategoryQueryVariables>;
export const SetShippingDeliveryContactInfoOnCartDocument = gql`
    mutation SetShippingDeliveryContactInfoOnCart($cartId: String!, $input: SetShippingDeliveryContactInfoInput!) {
  setShippingDeliveryContactInfoOnCart(cartId: $cartId, input: $input) {
    shipping {
      delivery {
        recipientName
        recipientPhone
      }
    }
  }
}
    `;
export type SetShippingDeliveryContactInfoOnCartMutationFn = Apollo.MutationFunction<SetShippingDeliveryContactInfoOnCartMutation, SetShippingDeliveryContactInfoOnCartMutationVariables>;

/**
 * __useSetShippingDeliveryContactInfoOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingDeliveryContactInfoOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingDeliveryContactInfoOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingDeliveryContactInfoOnCartMutation, { data, loading, error }] = useSetShippingDeliveryContactInfoOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShippingDeliveryContactInfoOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingDeliveryContactInfoOnCartMutation, SetShippingDeliveryContactInfoOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingDeliveryContactInfoOnCartMutation, SetShippingDeliveryContactInfoOnCartMutationVariables>(SetShippingDeliveryContactInfoOnCartDocument, options);
      }
export type SetShippingDeliveryContactInfoOnCartMutationHookResult = ReturnType<typeof useSetShippingDeliveryContactInfoOnCartMutation>;
export type SetShippingDeliveryContactInfoOnCartMutationResult = Apollo.MutationResult<SetShippingDeliveryContactInfoOnCartMutation>;
export type SetShippingDeliveryContactInfoOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingDeliveryContactInfoOnCartMutation, SetShippingDeliveryContactInfoOnCartMutationVariables>;
export const SetShippingDeliveryInstructionsOnCartDocument = gql`
    mutation SetShippingDeliveryInstructionsOnCart($cartId: String!, $input: SetShippingDeliveryInstructionsInput!) {
  setShippingDeliveryInstructionsOnCart(cartId: $cartId, input: $input) {
    shipping {
      delivery {
        comment
      }
    }
  }
}
    `;
export type SetShippingDeliveryInstructionsOnCartMutationFn = Apollo.MutationFunction<SetShippingDeliveryInstructionsOnCartMutation, SetShippingDeliveryInstructionsOnCartMutationVariables>;

/**
 * __useSetShippingDeliveryInstructionsOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingDeliveryInstructionsOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingDeliveryInstructionsOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingDeliveryInstructionsOnCartMutation, { data, loading, error }] = useSetShippingDeliveryInstructionsOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShippingDeliveryInstructionsOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingDeliveryInstructionsOnCartMutation, SetShippingDeliveryInstructionsOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingDeliveryInstructionsOnCartMutation, SetShippingDeliveryInstructionsOnCartMutationVariables>(SetShippingDeliveryInstructionsOnCartDocument, options);
      }
export type SetShippingDeliveryInstructionsOnCartMutationHookResult = ReturnType<typeof useSetShippingDeliveryInstructionsOnCartMutation>;
export type SetShippingDeliveryInstructionsOnCartMutationResult = Apollo.MutationResult<SetShippingDeliveryInstructionsOnCartMutation>;
export type SetShippingDeliveryInstructionsOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingDeliveryInstructionsOnCartMutation, SetShippingDeliveryInstructionsOnCartMutationVariables>;
export const RequestCartShippingDeliveryDateDocument = gql`
    mutation RequestCartShippingDeliveryDate($cartId: String!, $date: String) {
  requestDeliveryDate(cartId: $cartId, date: $date) {
    cart {
      id
      requestedDeliveryDate
      itemsSplitByDeliveryDate {
        ...CartItemsSummaryAccordionCard_Sections
        info {
          ...DeliveryDatePicker_Info
        }
      }
      ...ChooseDeliveryDate_Cart
    }
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItemsSummaryAccordionCard_SectionsFragmentDoc}
${DeliveryDatePicker_InfoFragmentDoc}
${ChooseDeliveryDate_CartFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type RequestCartShippingDeliveryDateMutationFn = Apollo.MutationFunction<RequestCartShippingDeliveryDateMutation, RequestCartShippingDeliveryDateMutationVariables>;

/**
 * __useRequestCartShippingDeliveryDateMutation__
 *
 * To run a mutation, you first call `useRequestCartShippingDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCartShippingDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCartShippingDeliveryDateMutation, { data, loading, error }] = useRequestCartShippingDeliveryDateMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useRequestCartShippingDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<RequestCartShippingDeliveryDateMutation, RequestCartShippingDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCartShippingDeliveryDateMutation, RequestCartShippingDeliveryDateMutationVariables>(RequestCartShippingDeliveryDateDocument, options);
      }
export type RequestCartShippingDeliveryDateMutationHookResult = ReturnType<typeof useRequestCartShippingDeliveryDateMutation>;
export type RequestCartShippingDeliveryDateMutationResult = Apollo.MutationResult<RequestCartShippingDeliveryDateMutation>;
export type RequestCartShippingDeliveryDateMutationOptions = Apollo.BaseMutationOptions<RequestCartShippingDeliveryDateMutation, RequestCartShippingDeliveryDateMutationVariables>;
export const SetShippingMethodOnCartDocument = gql`
    mutation SetShippingMethodOnCart($shippingMethodOnCartInput: SetShippingMethodOnCartInput!) {
  setShippingMethodOnCart(shippingMethodOnCartInput: $shippingMethodOnCartInput) {
    cart {
      id
      requestedDeliveryDate
      isClickAndCollectActivated
      itemsSplitByDeliveryDate {
        ...CartItemsSummaryAccordionCard_Sections
      }
      ...ShippingTracking_Cart
      ...ShippingForm_Cart
      ...ChooseDeliveryDate_Cart
      ...CartSummary_Cart
    }
    shipping {
      delivery {
        comment
        recipientName
        recipientPhone
      }
      ...ShippingForm_Shipping
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${CartItemsSummaryAccordionCard_SectionsFragmentDoc}
${ShippingTracking_CartFragmentDoc}
${ShippingForm_CartFragmentDoc}
${ChooseDeliveryDate_CartFragmentDoc}
${CartSummary_CartFragmentDoc}
${ShippingForm_ShippingFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type SetShippingMethodOnCartMutationFn = Apollo.MutationFunction<SetShippingMethodOnCartMutation, SetShippingMethodOnCartMutationVariables>;

/**
 * __useSetShippingMethodOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingMethodOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingMethodOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingMethodOnCartMutation, { data, loading, error }] = useSetShippingMethodOnCartMutation({
 *   variables: {
 *      shippingMethodOnCartInput: // value for 'shippingMethodOnCartInput'
 *   },
 * });
 */
export function useSetShippingMethodOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingMethodOnCartMutation, SetShippingMethodOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingMethodOnCartMutation, SetShippingMethodOnCartMutationVariables>(SetShippingMethodOnCartDocument, options);
      }
export type SetShippingMethodOnCartMutationHookResult = ReturnType<typeof useSetShippingMethodOnCartMutation>;
export type SetShippingMethodOnCartMutationResult = Apollo.MutationResult<SetShippingMethodOnCartMutation>;
export type SetShippingMethodOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingMethodOnCartMutation, SetShippingMethodOnCartMutationVariables>;
export const ShippingDocument = gql`
    query Shipping {
  currentUser {
    id
    role
    checkout {
      ...Shipping_Checkout
    }
  }
}
    ${Shipping_CheckoutFragmentDoc}`;

/**
 * __useShippingQuery__
 *
 * To run a query within a React component, call `useShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingQuery(baseOptions?: Apollo.QueryHookOptions<ShippingQuery, ShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingQuery, ShippingQueryVariables>(ShippingDocument, options);
      }
export function useShippingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingQuery, ShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingQuery, ShippingQueryVariables>(ShippingDocument, options);
        }
export function useShippingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShippingQuery, ShippingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingQuery, ShippingQueryVariables>(ShippingDocument, options);
        }
export type ShippingQueryHookResult = ReturnType<typeof useShippingQuery>;
export type ShippingLazyQueryHookResult = ReturnType<typeof useShippingLazyQuery>;
export type ShippingSuspenseQueryHookResult = ReturnType<typeof useShippingSuspenseQuery>;
export type ShippingQueryResult = Apollo.QueryResult<ShippingQuery, ShippingQueryVariables>;
export const SetShippingAddressOnCartDocument = gql`
    mutation SetShippingAddressOnCart($shippingAddressOnCartInput: SetShippingAddressesOnCartInput!) {
  setShippingAddressOnCart(
    shippingAddressOnCartInput: $shippingAddressOnCartInput
  ) {
    ...Shipping_Checkout
    shipping {
      fee {
        ...ShippingFeeTag_Fee
      }
    }
  }
}
    ${Shipping_CheckoutFragmentDoc}
${ShippingFeeTag_FeeFragmentDoc}`;
export type SetShippingAddressOnCartMutationFn = Apollo.MutationFunction<SetShippingAddressOnCartMutation, SetShippingAddressOnCartMutationVariables>;

/**
 * __useSetShippingAddressOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingAddressOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingAddressOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingAddressOnCartMutation, { data, loading, error }] = useSetShippingAddressOnCartMutation({
 *   variables: {
 *      shippingAddressOnCartInput: // value for 'shippingAddressOnCartInput'
 *   },
 * });
 */
export function useSetShippingAddressOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingAddressOnCartMutation, SetShippingAddressOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingAddressOnCartMutation, SetShippingAddressOnCartMutationVariables>(SetShippingAddressOnCartDocument, options);
      }
export type SetShippingAddressOnCartMutationHookResult = ReturnType<typeof useSetShippingAddressOnCartMutation>;
export type SetShippingAddressOnCartMutationResult = Apollo.MutationResult<SetShippingAddressOnCartMutation>;
export type SetShippingAddressOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingAddressOnCartMutation, SetShippingAddressOnCartMutationVariables>;
export const ShippingItemsSplitByDeliveryDateDocument = gql`
    query ShippingItemsSplitByDeliveryDate {
  currentUser {
    id
    checkout {
      cart {
        id
        itemsSplitByDeliveryDate {
          ...CartItemsSummaryAccordionCard_Sections
        }
        ...ChooseDeliveryDate_Cart
      }
    }
  }
}
    ${CartItemsSummaryAccordionCard_SectionsFragmentDoc}
${ChooseDeliveryDate_CartFragmentDoc}`;

/**
 * __useShippingItemsSplitByDeliveryDateQuery__
 *
 * To run a query within a React component, call `useShippingItemsSplitByDeliveryDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingItemsSplitByDeliveryDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingItemsSplitByDeliveryDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingItemsSplitByDeliveryDateQuery(baseOptions?: Apollo.QueryHookOptions<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>(ShippingItemsSplitByDeliveryDateDocument, options);
      }
export function useShippingItemsSplitByDeliveryDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>(ShippingItemsSplitByDeliveryDateDocument, options);
        }
export function useShippingItemsSplitByDeliveryDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>(ShippingItemsSplitByDeliveryDateDocument, options);
        }
export type ShippingItemsSplitByDeliveryDateQueryHookResult = ReturnType<typeof useShippingItemsSplitByDeliveryDateQuery>;
export type ShippingItemsSplitByDeliveryDateLazyQueryHookResult = ReturnType<typeof useShippingItemsSplitByDeliveryDateLazyQuery>;
export type ShippingItemsSplitByDeliveryDateSuspenseQueryHookResult = ReturnType<typeof useShippingItemsSplitByDeliveryDateSuspenseQuery>;
export type ShippingItemsSplitByDeliveryDateQueryResult = Apollo.QueryResult<ShippingItemsSplitByDeliveryDateQuery, ShippingItemsSplitByDeliveryDateQueryVariables>;
export const CartShippingTrackingDocument = gql`
    query CartShippingTracking($references: [String!]!) {
  productsByReferences(references: $references) {
    reference
    parentReference
    name
    type
    price {
      exclTax
      tag
    }
    brand {
      name
      urlKey
    }
    analytics {
      promotionStatus
    }
    nomenclatureFamily
    nomenclatureGroup
    canAddToCart
    stock {
      availability
      isSellable
    }
  }
  currentUser {
    id
    checkout {
      cart {
        id
        currency
        totalExclTax
        couponCode
      }
    }
  }
}
    `;

/**
 * __useCartShippingTrackingQuery__
 *
 * To run a query within a React component, call `useCartShippingTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartShippingTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartShippingTrackingQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useCartShippingTrackingQuery(baseOptions: Apollo.QueryHookOptions<CartShippingTrackingQuery, CartShippingTrackingQueryVariables> & ({ variables: CartShippingTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>(CartShippingTrackingDocument, options);
      }
export function useCartShippingTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>(CartShippingTrackingDocument, options);
        }
export function useCartShippingTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>(CartShippingTrackingDocument, options);
        }
export type CartShippingTrackingQueryHookResult = ReturnType<typeof useCartShippingTrackingQuery>;
export type CartShippingTrackingLazyQueryHookResult = ReturnType<typeof useCartShippingTrackingLazyQuery>;
export type CartShippingTrackingSuspenseQueryHookResult = ReturnType<typeof useCartShippingTrackingSuspenseQuery>;
export type CartShippingTrackingQueryResult = Apollo.QueryResult<CartShippingTrackingQuery, CartShippingTrackingQueryVariables>;
export const StoreLocatorConfigDocument = gql`
    query StoreLocatorConfig {
  config {
    pointOfSale {
      storeLocatorUrl
    }
  }
}
    `;

/**
 * __useStoreLocatorConfigQuery__
 *
 * To run a query within a React component, call `useStoreLocatorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLocatorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLocatorConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreLocatorConfigQuery(baseOptions?: Apollo.QueryHookOptions<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>(StoreLocatorConfigDocument, options);
      }
export function useStoreLocatorConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>(StoreLocatorConfigDocument, options);
        }
export function useStoreLocatorConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>(StoreLocatorConfigDocument, options);
        }
export type StoreLocatorConfigQueryHookResult = ReturnType<typeof useStoreLocatorConfigQuery>;
export type StoreLocatorConfigLazyQueryHookResult = ReturnType<typeof useStoreLocatorConfigLazyQuery>;
export type StoreLocatorConfigSuspenseQueryHookResult = ReturnType<typeof useStoreLocatorConfigSuspenseQuery>;
export type StoreLocatorConfigQueryResult = Apollo.QueryResult<StoreLocatorConfigQuery, StoreLocatorConfigQueryVariables>;
export const TrackFirstSignInDocument = gql`
    query TrackFirstSignIn {
  currentUser {
    id
    firstLoginManagerOrigin
  }
}
    `;

/**
 * __useTrackFirstSignInQuery__
 *
 * To run a query within a React component, call `useTrackFirstSignInQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackFirstSignInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackFirstSignInQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackFirstSignInQuery(baseOptions?: Apollo.QueryHookOptions<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>(TrackFirstSignInDocument, options);
      }
export function useTrackFirstSignInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>(TrackFirstSignInDocument, options);
        }
export function useTrackFirstSignInSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>(TrackFirstSignInDocument, options);
        }
export type TrackFirstSignInQueryHookResult = ReturnType<typeof useTrackFirstSignInQuery>;
export type TrackFirstSignInLazyQueryHookResult = ReturnType<typeof useTrackFirstSignInLazyQuery>;
export type TrackFirstSignInSuspenseQueryHookResult = ReturnType<typeof useTrackFirstSignInSuspenseQuery>;
export type TrackFirstSignInQueryResult = Apollo.QueryResult<TrackFirstSignInQuery, TrackFirstSignInQueryVariables>;
export const GetAllUniversesDocument = gql`
    query GetAllUniverses($urlKey: String) {
  categories(urlKey: $urlKey) {
    categories {
      ...CategoriesSlider_Categories
    }
  }
}
    ${CategoriesSlider_CategoriesFragmentDoc}`;

/**
 * __useGetAllUniversesQuery__
 *
 * To run a query within a React component, call `useGetAllUniversesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUniversesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUniversesQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetAllUniversesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUniversesQuery, GetAllUniversesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUniversesQuery, GetAllUniversesQueryVariables>(GetAllUniversesDocument, options);
      }
export function useGetAllUniversesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUniversesQuery, GetAllUniversesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUniversesQuery, GetAllUniversesQueryVariables>(GetAllUniversesDocument, options);
        }
export function useGetAllUniversesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUniversesQuery, GetAllUniversesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUniversesQuery, GetAllUniversesQueryVariables>(GetAllUniversesDocument, options);
        }
export type GetAllUniversesQueryHookResult = ReturnType<typeof useGetAllUniversesQuery>;
export type GetAllUniversesLazyQueryHookResult = ReturnType<typeof useGetAllUniversesLazyQuery>;
export type GetAllUniversesSuspenseQueryHookResult = ReturnType<typeof useGetAllUniversesSuspenseQuery>;
export type GetAllUniversesQueryResult = Apollo.QueryResult<GetAllUniversesQuery, GetAllUniversesQueryVariables>;
export const GetUniverseDocument = gql`
    query GetUniverse($urlKey: String, $filterSubCats: Boolean) {
  categories(urlKey: $urlKey, filterSubCats: $filterSubCats) {
    ...MainCategory
    categories {
      ...SubCategory
    }
  }
}
    ${MainCategoryFragmentDoc}
${SubCategoryFragmentDoc}`;

/**
 * __useGetUniverseQuery__
 *
 * To run a query within a React component, call `useGetUniverseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniverseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniverseQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      filterSubCats: // value for 'filterSubCats'
 *   },
 * });
 */
export function useGetUniverseQuery(baseOptions?: Apollo.QueryHookOptions<GetUniverseQuery, GetUniverseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniverseQuery, GetUniverseQueryVariables>(GetUniverseDocument, options);
      }
export function useGetUniverseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniverseQuery, GetUniverseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniverseQuery, GetUniverseQueryVariables>(GetUniverseDocument, options);
        }
export function useGetUniverseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniverseQuery, GetUniverseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniverseQuery, GetUniverseQueryVariables>(GetUniverseDocument, options);
        }
export type GetUniverseQueryHookResult = ReturnType<typeof useGetUniverseQuery>;
export type GetUniverseLazyQueryHookResult = ReturnType<typeof useGetUniverseLazyQuery>;
export type GetUniverseSuspenseQueryHookResult = ReturnType<typeof useGetUniverseSuspenseQuery>;
export type GetUniverseQueryResult = Apollo.QueryResult<GetUniverseQuery, GetUniverseQueryVariables>;
export const CategoryUrlKeyDocument = gql`
    query CategoryUrlKey($code: String!) {
  urlKey(entity: CATEGORY, code: $code)
}
    `;

/**
 * __useCategoryUrlKeyQuery__
 *
 * To run a query within a React component, call `useCategoryUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryUrlKeyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCategoryUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables> & ({ variables: CategoryUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>(CategoryUrlKeyDocument, options);
      }
export function useCategoryUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>(CategoryUrlKeyDocument, options);
        }
export function useCategoryUrlKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>(CategoryUrlKeyDocument, options);
        }
export type CategoryUrlKeyQueryHookResult = ReturnType<typeof useCategoryUrlKeyQuery>;
export type CategoryUrlKeyLazyQueryHookResult = ReturnType<typeof useCategoryUrlKeyLazyQuery>;
export type CategoryUrlKeySuspenseQueryHookResult = ReturnType<typeof useCategoryUrlKeySuspenseQuery>;
export type CategoryUrlKeyQueryResult = Apollo.QueryResult<CategoryUrlKeyQuery, CategoryUrlKeyQueryVariables>;
export const GetFavoritesListFilteredCartAmountDocument = gql`
    query GetFavoritesListFilteredCartAmount($input: Browsing!) {
  currentUser {
    id
    wishlists(input: $input) {
      items {
        id
        totalExclTax
        products {
          quantity
          product {
            reference
            availability
            canAddToCart
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFavoritesListFilteredCartAmountQuery__
 *
 * To run a query within a React component, call `useGetFavoritesListFilteredCartAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesListFilteredCartAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesListFilteredCartAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFavoritesListFilteredCartAmountQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables> & ({ variables: GetFavoritesListFilteredCartAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>(GetFavoritesListFilteredCartAmountDocument, options);
      }
export function useGetFavoritesListFilteredCartAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>(GetFavoritesListFilteredCartAmountDocument, options);
        }
export function useGetFavoritesListFilteredCartAmountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>(GetFavoritesListFilteredCartAmountDocument, options);
        }
export type GetFavoritesListFilteredCartAmountQueryHookResult = ReturnType<typeof useGetFavoritesListFilteredCartAmountQuery>;
export type GetFavoritesListFilteredCartAmountLazyQueryHookResult = ReturnType<typeof useGetFavoritesListFilteredCartAmountLazyQuery>;
export type GetFavoritesListFilteredCartAmountSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesListFilteredCartAmountSuspenseQuery>;
export type GetFavoritesListFilteredCartAmountQueryResult = Apollo.QueryResult<GetFavoritesListFilteredCartAmountQuery, GetFavoritesListFilteredCartAmountQueryVariables>;
export const AddProductsToCartDocument = gql`
    mutation AddProductsToCart($cartId: String!, $items: [ProductToCartInput!]!) {
  addProductsToCart(cartId: $cartId, items: $items) {
    addedReferences
    cart {
      id
      ...MiniCart_Cart
      ...MiniCartButton_Cart
      ...CartSummary_Cart
    }
  }
}
    ${MiniCart_CartFragmentDoc}
${MiniCartButton_CartFragmentDoc}
${CartSummary_CartFragmentDoc}`;
export type AddProductsToCartMutationFn = Apollo.MutationFunction<AddProductsToCartMutation, AddProductsToCartMutationVariables>;

/**
 * __useAddProductsToCartMutation__
 *
 * To run a mutation, you first call `useAddProductsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToCartMutation, { data, loading, error }] = useAddProductsToCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useAddProductsToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToCartMutation, AddProductsToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToCartMutation, AddProductsToCartMutationVariables>(AddProductsToCartDocument, options);
      }
export type AddProductsToCartMutationHookResult = ReturnType<typeof useAddProductsToCartMutation>;
export type AddProductsToCartMutationResult = Apollo.MutationResult<AddProductsToCartMutation>;
export type AddProductsToCartMutationOptions = Apollo.BaseMutationOptions<AddProductsToCartMutation, AddProductsToCartMutationVariables>;
export const WishlistProductsAvailabilityDocument = gql`
    query WishlistProductsAvailability($references: [String!]!) {
  productsByReferences(references: $references) {
    ...WishlistPriceAndStocks_Product
  }
}
    ${WishlistPriceAndStocks_ProductFragmentDoc}`;

/**
 * __useWishlistProductsAvailabilityQuery__
 *
 * To run a query within a React component, call `useWishlistProductsAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistProductsAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistProductsAvailabilityQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useWishlistProductsAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables> & ({ variables: WishlistProductsAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>(WishlistProductsAvailabilityDocument, options);
      }
export function useWishlistProductsAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>(WishlistProductsAvailabilityDocument, options);
        }
export function useWishlistProductsAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>(WishlistProductsAvailabilityDocument, options);
        }
export type WishlistProductsAvailabilityQueryHookResult = ReturnType<typeof useWishlistProductsAvailabilityQuery>;
export type WishlistProductsAvailabilityLazyQueryHookResult = ReturnType<typeof useWishlistProductsAvailabilityLazyQuery>;
export type WishlistProductsAvailabilitySuspenseQueryHookResult = ReturnType<typeof useWishlistProductsAvailabilitySuspenseQuery>;
export type WishlistProductsAvailabilityQueryResult = Apollo.QueryResult<WishlistProductsAvailabilityQuery, WishlistProductsAvailabilityQueryVariables>;
export const ValidArticlesReferencesDocument = gql`
    query ValidArticlesReferences($references: [String!]!) {
  articlesByReferences(references: $references) {
    reference
  }
}
    `;

/**
 * __useValidArticlesReferencesQuery__
 *
 * To run a query within a React component, call `useValidArticlesReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidArticlesReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidArticlesReferencesQuery({
 *   variables: {
 *      references: // value for 'references'
 *   },
 * });
 */
export function useValidArticlesReferencesQuery(baseOptions: Apollo.QueryHookOptions<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables> & ({ variables: ValidArticlesReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>(ValidArticlesReferencesDocument, options);
      }
export function useValidArticlesReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>(ValidArticlesReferencesDocument, options);
        }
export function useValidArticlesReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>(ValidArticlesReferencesDocument, options);
        }
export type ValidArticlesReferencesQueryHookResult = ReturnType<typeof useValidArticlesReferencesQuery>;
export type ValidArticlesReferencesLazyQueryHookResult = ReturnType<typeof useValidArticlesReferencesLazyQuery>;
export type ValidArticlesReferencesSuspenseQueryHookResult = ReturnType<typeof useValidArticlesReferencesSuspenseQuery>;
export type ValidArticlesReferencesQueryResult = Apollo.QueryResult<ValidArticlesReferencesQuery, ValidArticlesReferencesQueryVariables>;
export const GenerateRefreshTokenDocument = gql`
    mutation GenerateRefreshToken($code: String!, $codeVerifier: String!) {
  generateRefreshToken(code: $code, encCodeVerifier: $codeVerifier) {
    type
    value
  }
}
    `;
export type GenerateRefreshTokenMutationFn = Apollo.MutationFunction<GenerateRefreshTokenMutation, GenerateRefreshTokenMutationVariables>;

/**
 * __useGenerateRefreshTokenMutation__
 *
 * To run a mutation, you first call `useGenerateRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRefreshTokenMutation, { data, loading, error }] = useGenerateRefreshTokenMutation({
 *   variables: {
 *      code: // value for 'code'
 *      codeVerifier: // value for 'codeVerifier'
 *   },
 * });
 */
export function useGenerateRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRefreshTokenMutation, GenerateRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRefreshTokenMutation, GenerateRefreshTokenMutationVariables>(GenerateRefreshTokenDocument, options);
      }
export type GenerateRefreshTokenMutationHookResult = ReturnType<typeof useGenerateRefreshTokenMutation>;
export type GenerateRefreshTokenMutationResult = Apollo.MutationResult<GenerateRefreshTokenMutation>;
export type GenerateRefreshTokenMutationOptions = Apollo.BaseMutationOptions<GenerateRefreshTokenMutation, GenerateRefreshTokenMutationVariables>;
export const ProductUrlKeyDocument = gql`
    query ProductUrlKey($code: String!) {
  urlKey(entity: PRODUCT, code: $code)
}
    `;

/**
 * __useProductUrlKeyQuery__
 *
 * To run a query within a React component, call `useProductUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUrlKeyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useProductUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<ProductUrlKeyQuery, ProductUrlKeyQueryVariables> & ({ variables: ProductUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>(ProductUrlKeyDocument, options);
      }
export function useProductUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>(ProductUrlKeyDocument, options);
        }
export function useProductUrlKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>(ProductUrlKeyDocument, options);
        }
export type ProductUrlKeyQueryHookResult = ReturnType<typeof useProductUrlKeyQuery>;
export type ProductUrlKeyLazyQueryHookResult = ReturnType<typeof useProductUrlKeyLazyQuery>;
export type ProductUrlKeySuspenseQueryHookResult = ReturnType<typeof useProductUrlKeySuspenseQuery>;
export type ProductUrlKeyQueryResult = Apollo.QueryResult<ProductUrlKeyQuery, ProductUrlKeyQueryVariables>;
export const RobotsTxtConfigDocument = gql`
    query RobotsTxtConfig {
  config {
    site {
      robotsContent
      robotsMeta
    }
  }
}
    `;

/**
 * __useRobotsTxtConfigQuery__
 *
 * To run a query within a React component, call `useRobotsTxtConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRobotsTxtConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRobotsTxtConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useRobotsTxtConfigQuery(baseOptions?: Apollo.QueryHookOptions<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>(RobotsTxtConfigDocument, options);
      }
export function useRobotsTxtConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>(RobotsTxtConfigDocument, options);
        }
export function useRobotsTxtConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>(RobotsTxtConfigDocument, options);
        }
export type RobotsTxtConfigQueryHookResult = ReturnType<typeof useRobotsTxtConfigQuery>;
export type RobotsTxtConfigLazyQueryHookResult = ReturnType<typeof useRobotsTxtConfigLazyQuery>;
export type RobotsTxtConfigSuspenseQueryHookResult = ReturnType<typeof useRobotsTxtConfigSuspenseQuery>;
export type RobotsTxtConfigQueryResult = Apollo.QueryResult<RobotsTxtConfigQuery, RobotsTxtConfigQueryVariables>;
export const UserTrackingDocument = gql`
    query UserTracking {
  currentUserAccounts {
    id
  }
  currentUser {
    id
    role
    company {
      id
      type
      code
      professionCode
      pointOfSale {
        id
        parentId
        name
        subsidiary {
          id
          name
        }
      }
    }
    favoritePointOfSale {
      id
      parentId
    }
    checkout {
      cart {
        id
      }
    }
    loyalty {
      status
      data {
        active
      }
    }
  }
}
    `;

/**
 * __useUserTrackingQuery__
 *
 * To run a query within a React component, call `useUserTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTrackingQuery(baseOptions?: Apollo.QueryHookOptions<UserTrackingQuery, UserTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTrackingQuery, UserTrackingQueryVariables>(UserTrackingDocument, options);
      }
export function useUserTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTrackingQuery, UserTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTrackingQuery, UserTrackingQueryVariables>(UserTrackingDocument, options);
        }
export function useUserTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTrackingQuery, UserTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTrackingQuery, UserTrackingQueryVariables>(UserTrackingDocument, options);
        }
export type UserTrackingQueryHookResult = ReturnType<typeof useUserTrackingQuery>;
export type UserTrackingLazyQueryHookResult = ReturnType<typeof useUserTrackingLazyQuery>;
export type UserTrackingSuspenseQueryHookResult = ReturnType<typeof useUserTrackingSuspenseQuery>;
export type UserTrackingQueryResult = Apollo.QueryResult<UserTrackingQuery, UserTrackingQueryVariables>;
export const ZendeskScriptDocument = gql`
    query ZendeskScript {
  config {
    support {
      isGlobalClick2ChatEnabled
      isLoginClick2ChatEnabled
      scriptKey
    }
  }
}
    `;

/**
 * __useZendeskScriptQuery__
 *
 * To run a query within a React component, call `useZendeskScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useZendeskScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZendeskScriptQuery({
 *   variables: {
 *   },
 * });
 */
export function useZendeskScriptQuery(baseOptions?: Apollo.QueryHookOptions<ZendeskScriptQuery, ZendeskScriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZendeskScriptQuery, ZendeskScriptQueryVariables>(ZendeskScriptDocument, options);
      }
export function useZendeskScriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZendeskScriptQuery, ZendeskScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZendeskScriptQuery, ZendeskScriptQueryVariables>(ZendeskScriptDocument, options);
        }
export function useZendeskScriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZendeskScriptQuery, ZendeskScriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZendeskScriptQuery, ZendeskScriptQueryVariables>(ZendeskScriptDocument, options);
        }
export type ZendeskScriptQueryHookResult = ReturnType<typeof useZendeskScriptQuery>;
export type ZendeskScriptLazyQueryHookResult = ReturnType<typeof useZendeskScriptLazyQuery>;
export type ZendeskScriptSuspenseQueryHookResult = ReturnType<typeof useZendeskScriptSuspenseQuery>;
export type ZendeskScriptQueryResult = Apollo.QueryResult<ZendeskScriptQuery, ZendeskScriptQueryVariables>;
export const ForbiddenPhoneTypesDocument = gql`
    query ForbiddenPhoneTypes {
  config {
    customer {
      forbiddenPhoneTypes
    }
  }
}
    `;

/**
 * __useForbiddenPhoneTypesQuery__
 *
 * To run a query within a React component, call `useForbiddenPhoneTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useForbiddenPhoneTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForbiddenPhoneTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useForbiddenPhoneTypesQuery(baseOptions?: Apollo.QueryHookOptions<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>(ForbiddenPhoneTypesDocument, options);
      }
export function useForbiddenPhoneTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>(ForbiddenPhoneTypesDocument, options);
        }
export function useForbiddenPhoneTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>(ForbiddenPhoneTypesDocument, options);
        }
export type ForbiddenPhoneTypesQueryHookResult = ReturnType<typeof useForbiddenPhoneTypesQuery>;
export type ForbiddenPhoneTypesLazyQueryHookResult = ReturnType<typeof useForbiddenPhoneTypesLazyQuery>;
export type ForbiddenPhoneTypesSuspenseQueryHookResult = ReturnType<typeof useForbiddenPhoneTypesSuspenseQuery>;
export type ForbiddenPhoneTypesQueryResult = Apollo.QueryResult<ForbiddenPhoneTypesQuery, ForbiddenPhoneTypesQueryVariables>;